export function getAirports() {
  return [{
     "name": "Anaa Airport",
     "countryCode": "PF",
     "iata": "AAA",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Anaa"
  }, {
     "name": "Scandinavian Mountains Airport",
     "countryCode": "SE",
     "iata": "SCR",
     "eucustoms": true,
     "countryDK": "Sverige",
     "cityDK": "Sälen"
  }, {
     "name": "Arrabury Airport",
     "countryCode": "AU",
     "iata": "AAB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Arrabury"
  }, {
     "name": "El Arish International Airport",
     "countryCode": "EG",
     "iata": "AAC",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "El Arish"
  }, {
     "name": "Rabah Bitat Airport",
     "countryCode": "DZ",
     "iata": "AAE",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Annaba"
  }, {
     "name": "Apalachicola Municipal Airport",
     "countryCode": "US",
     "iata": "AAF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Apalachicola"
  }, {
     "name": "Aachen/Merzbruck Airport",
     "countryCode": "DE",
     "iata": "AAH",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Aachen"
  }, {
     "name": "Arraias Airport",
     "countryCode": "BR",
     "iata": "AAI",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Arraias"
  }, {
     "name": "Aalborg Airport",
     "countryCode": "DK",
     "iata": "AAL",
     "eucustoms": true,
     "countryDK": "Danmark",
     "cityDK": "Aalborg"
  }, {
     "name": "Mala Mala Airport",
     "countryCode": "ZA",
     "iata": "AAM",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Mala Mala"
  }, {
     "name": "Al Ain Airport",
     "countryCode": "AE",
     "iata": "AAN",
     "eucustoms": false,
     "countryDK": "Forenede Arabiske Emirater",
     "cityDK": "Al Ain"
  }, {
     "name": "Anaco Airport",
     "countryCode": "VE",
     "iata": "AAO",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Anaco"
  }, {
     "name": "Anapa Airport",
     "countryCode": "RU",
     "iata": "AAQ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Anapa"
  }, {
     "name": "Aarhus Airport",
     "countryCode": "DK",
     "iata": "AAR",
     "eucustoms": false,
     "countryDK": "Danmark",
     "cityDK": "Århus"
  }, {
     "name": "Altay Airport",
     "countryCode": "CN",
     "iata": "AAT",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Altay"
  }, {
     "name": "Allah Valley Airport",
     "countryCode": "PH",
     "iata": "AAV",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Surallah"
  }, {
     "name": "Araxa Airport",
     "countryCode": "BR",
     "iata": "AAX",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Araxa"
  }, {
     "name": "Al Ghaydah Airport",
     "countryCode": "YE",
     "iata": "AAY",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Al Ghaydah"
  }, {
     "name": "Abakan Airport",
     "countryCode": "RU",
     "iata": "ABA",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Abakan"
  }, {
     "name": "Asaba International Airport",
     "countryCode": "NG",
     "iata": "ABB",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Asaba"
  }, {
     "name": "Albacete Airport",
     "countryCode": "ES",
     "iata": "ABC",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Albacete"
  }, {
     "name": "Abadan Airport",
     "countryCode": "IR",
     "iata": "ABD",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Abadan"
  }, {
     "name": "Lehigh Valley International Airport",
     "countryCode": "US",
     "iata": "ABE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Allentown"
  }, {
     "name": "Alpha Airport",
     "countryCode": "AU",
     "iata": "ABH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Alpha"
  }, {
     "name": "Abilene Regional Airport",
     "countryCode": "US",
     "iata": "ABI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Abilene"
  }, {
     "name": "Felix Houphouet Boigny Airport",
     "countryCode": "CI",
     "iata": "ABJ",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Abidjan"
  }, {
     "name": "Kabri Dar Airport",
     "countryCode": "ET",
     "iata": "ABK",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Kabri Dar"
  }, {
     "name": "Ambler Airport",
     "countryCode": "US",
     "iata": "ABL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ambler"
  }, {
     "name": "Northern Peninsula Airport",
     "countryCode": "AU",
     "iata": "ABM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Bamaga"
  }, {
     "name": "Aboisso Airport",
     "countryCode": "CI",
     "iata": "ABO",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Aboisso"
  }, {
     "name": "Albuquerque International Sunport",
     "countryCode": "US",
     "iata": "ABQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Albuquerque"
  }, {
     "name": "Aberdeen Regional Airport",
     "countryCode": "US",
     "iata": "ABR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Aberdeen"
  }, {
     "name": "Abu Simbel Airport",
     "countryCode": "EG",
     "iata": "ABS",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Abu Simbel"
  }, {
     "name": "Al-Aqiq Airport",
     "countryCode": "SA",
     "iata": "ABT",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Al-Baha"
  }, {
     "name": "Haliwen Airport",
     "countryCode": "ID",
     "iata": "ABU",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Atambua"
  }, {
     "name": "Nnamdi Azikiwe International Airport",
     "countryCode": "NG",
     "iata": "ABV",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Abuja"
  }, {
     "name": "Albury Airport",
     "countryCode": "AU",
     "iata": "ABX",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Albury"
  }, {
     "name": "Southwest Georgia Regional Airport",
     "countryCode": "US",
     "iata": "ABY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Albany"
  }, {
     "name": "Aberdeen International Airport",
     "countryCode": "GB",
     "iata": "ABZ",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Aberdeen"
  }, {
     "name": "Acapulco International Airport",
     "countryCode": "MX",
     "iata": "ACA",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Acapulco"
  }, {
     "name": "Antrim County Airport",
     "countryCode": "US",
     "iata": "ACB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bellaire"
  }, {
     "name": "Kotoka International Airport",
     "countryCode": "GH",
     "iata": "ACC",
     "eucustoms": false,
     "countryDK": "Ghana",
     "cityDK": "Accra"
  }, {
     "name": "Alcides Fernandez Airport",
     "countryCode": "CO",
     "iata": "ACD",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Acandi"
  }, {
     "name": "Lanzarote Airport",
     "countryCode": "ES",
     "iata": "ACE",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Lanzarote"
  }, {
     "name": "Altenrhein Airport",
     "countryCode": "CH",
     "iata": "ACH",
     "eucustoms": false,
     "countryDK": "Schweiz",
     "cityDK": "Altenrhein"
  }, {
     "name": "Alderney Airport",
     "countryCode": "GB",
     "iata": "ACI",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Alderney"
  }, {
     "name": "Nantucket Memorial Airport",
     "countryCode": "US",
     "iata": "ACK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Nantucket"
  }, {
     "name": "Ciudad Acuna International Airport",
     "countryCode": "MX",
     "iata": "ACN",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Ciudad Acuna"
  }, {
     "name": "Araracuara Airport",
     "countryCode": "CO",
     "iata": "ACR",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Araracuara"
  }, {
     "name": "Waco Municipal Airport",
     "countryCode": "US",
     "iata": "ACT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Waco"
  }, {
     "name": "Arcata-Eureka Airport",
     "countryCode": "US",
     "iata": "ACV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Arcata"
  }, {
     "name": "Atlantic City International Airport",
     "countryCode": "US",
     "iata": "ACY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Atlantic City"
  }, {
     "name": "Zabol Airport",
     "countryCode": "IR",
     "iata": "ACZ",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Zabol"
  }, {
     "name": "Adana Sakirpasa Airport",
     "countryCode": "TR",
     "iata": "ADA",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Adana"
  }, {
     "name": "Izmir Adnan Menderes Airport",
     "countryCode": "TR",
     "iata": "ADB",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Izmir"
  }, {
     "name": "Addis Ababa Bole International Airport",
     "countryCode": "ET",
     "iata": "ADD",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Addis Abeba"
  }, {
     "name": "Aden International Airport",
     "countryCode": "YE",
     "iata": "ADE",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Aden"
  }, {
     "name": "Adiyaman Airport",
     "countryCode": "TR",
     "iata": "ADF",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Adiyaman"
  }, {
     "name": "Lenawee County Airport",
     "countryCode": "US",
     "iata": "ADG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Adrian"
  }, {
     "name": "Arandis Airport",
     "countryCode": "NA",
     "iata": "ADI",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Arandis"
  }, {
     "name": "Marka International Airport",
     "countryCode": "JO",
     "iata": "ADJ",
     "eucustoms": false,
     "countryDK": "Jordan",
     "cityDK": "Amman"
  }, {
     "name": "Adak Island Naval Station",
     "countryCode": "US",
     "iata": "ADK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Adak Island"
  }, {
     "name": "Adelaide Airport",
     "countryCode": "AU",
     "iata": "ADL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Adelaide"
  }, {
     "name": "Ardmore Municipal Airport",
     "countryCode": "US",
     "iata": "ADM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ardmore"
  }, {
     "name": "Andamooka Airport",
     "countryCode": "AU",
     "iata": "ADO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Andamooka"
  }, {
     "name": "Ampara Airport",
     "countryCode": "LK",
     "iata": "ADP",
     "eucustoms": false,
     "countryDK": "Sri Lanka",
     "cityDK": "Gal Oya"
  }, {
     "name": "Kodiak Benny Benson State Airport",
     "countryCode": "US",
     "iata": "ADQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kodiak"
  }, {
     "name": "Andrews Airport",
     "countryCode": "US",
     "iata": "ADR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Andrews"
  }, {
     "name": "Addison Airport",
     "countryCode": "US",
     "iata": "ADS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dallas"
  }, {
     "name": "Ada Airport",
     "countryCode": "US",
     "iata": "ADT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ada"
  }, {
     "name": "Ardabil Airport",
     "countryCode": "IR",
     "iata": "ADU",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Ardabil"
  }, {
     "name": "Andrews Air Force Base",
     "countryCode": "US",
     "iata": "ADW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Camp Springs"
  }, {
     "name": "Leuchars Airport",
     "countryCode": "GB",
     "iata": "ADX",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Saint Andrews"
  }, {
     "name": "Gustavo Rojas Pinilla Airport",
     "countryCode": "CO",
     "iata": "ADZ",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "San Andres Island"
  }, {
     "name": "Baise Bama Airport",
     "countryCode": "CN",
     "iata": "AEB",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Baise"
  }, {
     "name": "Aek Godang Airport",
     "countryCode": "ID",
     "iata": "AEG",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "South Tapanuli Regency"
  }, {
     "name": "Abecher Airport",
     "countryCode": "TD",
     "iata": "AEH",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Abecher"
  }, {
     "name": "Albert Lea Airport",
     "countryCode": "US",
     "iata": "AEL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Albert Lea"
  }, {
     "name": "Aioun El Atrouss Airport",
     "countryCode": "MR",
     "iata": "AEO",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Aioun El Atrouss"
  }, {
     "name": "Jorge Newbery Airport",
     "countryCode": "AR",
     "iata": "AEP",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Buenos Aires"
  }, {
     "name": "Sochi International Airport",
     "countryCode": "RU",
     "iata": "AER",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Adler / Sochi"
  }, {
     "name": "Vigra Alesund Airport",
     "countryCode": "NO",
     "iata": "AES",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Aalesund"
  }, {
     "name": "Abu Musa Airport",
     "countryCode": "IR",
     "iata": "AEU",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Abu Musa"
  }, {
     "name": "Alexandria International Airport",
     "countryCode": "US",
     "iata": "AEX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Alexandria"
  }, {
     "name": "Akureyri Airport",
     "countryCode": "IS",
     "iata": "AEY",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Akureyri"
  }, {
     "name": "San Rafael Airport",
     "countryCode": "AR",
     "iata": "AFA",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "San Rafael"
  }, {
     "name": "Port Alfred Airport",
     "countryCode": "ZA",
     "iata": "AFD",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Port Alfred"
  }, {
     "name": "United States Air Force Academy Airport",
     "countryCode": "US",
     "iata": "AFF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Colorado Springs"
  }, {
     "name": "Alta Floresta Airport",
     "countryCode": "BR",
     "iata": "AFL",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Alta Floresta"
  }, {
     "name": "Jaffrey Municipal Airport",
     "countryCode": "US",
     "iata": "AFN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jaffrey"
  }, {
     "name": "Afton Municipal Airport",
     "countryCode": "US",
     "iata": "AFO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Afton"
  }, {
     "name": "Fort Worth Alliance Airport",
     "countryCode": "US",
     "iata": "AFW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Worth"
  }, {
     "name": "Afyon Airport",
     "countryCode": "TR",
     "iata": "AFY",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Afyon"
  }, {
     "name": "Agadir Al Massira Airport",
     "countryCode": "MA",
     "iata": "AGA",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Agadir"
  }, {
     "name": "Augsburg Airport",
     "countryCode": "DE",
     "iata": "AGB",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Augsburg"
  }, {
     "name": "Allegheny County Airport",
     "countryCode": "US",
     "iata": "AGC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pittsburgh"
  }, {
     "name": "Flugplatz Airport",
     "countryCode": "DE",
     "iata": "AGE",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Wangerooge"
  }, {
     "name": "La Garenne Airport",
     "countryCode": "FR",
     "iata": "AGF",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Agen"
  }, {
     "name": "Angelholm Helsingborg Airport",
     "countryCode": "SE",
     "iata": "AGH",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Angelholm / Helsingborg"
  }, {
     "name": "Aguni Airport",
     "countryCode": "JP",
     "iata": "AGJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Aguni"
  }, {
     "name": "Ammassalik Heliport",
     "countryCode": "GL",
     "iata": "AGM",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Tasiilaq"
  }, {
     "name": "Magnolia Municipal Airport",
     "countryCode": "US",
     "iata": "AGO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Magnolia"
  }, {
     "name": "Malaga Airport",
     "countryCode": "ES",
     "iata": "AGP",
     "eucustoms": true,
     "countryDK": "Spanien",
     "cityDK": "Malaga"
  }, {
     "name": "Agrinion Airport",
     "countryCode": "GR",
     "iata": "AGQ",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Agrinion"
  }, {
     "name": "Kheria Airport",
     "countryCode": "IN",
     "iata": "AGR",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Agra"
  }, {
     "name": "Augusta Regional Airport",
     "countryCode": "US",
     "iata": "AGS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Augusta"
  }, {
     "name": "Guarani International Airport",
     "countryCode": "PY",
     "iata": "AGT",
     "eucustoms": false,
     "countryDK": "Paraguay",
     "cityDK": "Ciudad del Este"
  }, {
     "name": "Jesus Teran Peredo International Airport",
     "countryCode": "MX",
     "iata": "AGU",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Aguascalientes"
  }, {
     "name": "Acarigua Airport",
     "countryCode": "VE",
     "iata": "AGV",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Acarigua"
  }, {
     "name": "Agatti Island Airport",
     "countryCode": "IN",
     "iata": "AGX",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Agatti Island"
  }, {
     "name": "Abha Regional Airport",
     "countryCode": "SA",
     "iata": "AHB",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Abha"
  }, {
     "name": "Amedee Army Air Field",
     "countryCode": "US",
     "iata": "AHC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Herlong"
  }, {
     "name": "Amery Municipal Airport",
     "countryCode": "US",
     "iata": "AHH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Amery"
  }, {
     "name": "Aishalton Airport",
     "countryCode": "GY",
     "iata": "AHL",
     "eucustoms": false,
     "countryDK": "Guyana",
     "cityDK": "Aishalton"
  }, {
     "name": "Athens-Ben Epps Airport",
     "countryCode": "US",
     "iata": "AHN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Athen"
  }, {
     "name": "Alghero-Fertilia Airport",
     "countryCode": "IT",
     "iata": "AHO",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Alghero"
  }, {
     "name": "Charif Al Idrissi Airport",
     "countryCode": "MA",
     "iata": "AHU",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Al Hoceima"
  }, {
     "name": "Alliance Airport",
     "countryCode": "US",
     "iata": "AIA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Alliance"
  }, {
     "name": "Anderson Municipal Airport",
     "countryCode": "US",
     "iata": "AID",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Anderson"
  }, {
     "name": "Assis Airport",
     "countryCode": "BR",
     "iata": "AIF",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Assis"
  }, {
     "name": "Yalinga Airport",
     "countryCode": "CF",
     "iata": "AIG",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "Yalinga"
  }, {
     "name": "Aiken Municipal Airport",
     "countryCode": "US",
     "iata": "AIK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Aiken"
  }, {
     "name": "Wainwright Airport",
     "countryCode": "US",
     "iata": "AIN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wainwright"
  }, {
     "name": "Atlantic Municipal Airport",
     "countryCode": "US",
     "iata": "AIO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Atlantic"
  }, {
     "name": "Aitutaki Airport",
     "countryCode": "CK",
     "iata": "AIT",
     "eucustoms": false,
     "countryDK": "Cookøerne",
     "cityDK": "Aitutaki"
  }, {
     "name": "Atiu Island Airport",
     "countryCode": "CK",
     "iata": "AIU",
     "eucustoms": false,
     "countryDK": "Cookøerne",
     "cityDK": "Atiu Island"
  }, {
     "name": "George Downer Airport",
     "countryCode": "US",
     "iata": "AIV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Aliceville"
  }, {
     "name": "Bader Field",
     "countryCode": "US",
     "iata": "AIY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Atlantic City"
  }, {
     "name": "Lee C Fine Memorial Airport",
     "countryCode": "US",
     "iata": "AIZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kaiser / Lake Ozark"
  }, {
     "name": "Ajaccio Napoleon Bonaparte Airport",
     "countryCode": "FR",
     "iata": "AJA",
     "eucustoms": true,
     "countryDK": "Frankrig",
     "cityDK": "Ajaccio"
  }, {
     "name": "Jouf Airport",
     "countryCode": "SA",
     "iata": "AJF",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Jouf"
  }, {
     "name": "Agri Airport",
     "countryCode": "TR",
     "iata": "AJI",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Agri"
  }, {
     "name": "Akjoujt Airport",
     "countryCode": "MR",
     "iata": "AJJ",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Akjoujt"
  }, {
     "name": "Arak Airport",
     "countryCode": "IR",
     "iata": "AJK",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Arak"
  }, {
     "name": "Aizawl Airport",
     "countryCode": "IN",
     "iata": "AJL",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Aizawl"
  }, {
     "name": "Ouani Airport",
     "countryCode": "KM",
     "iata": "AJN",
     "eucustoms": false,
     "countryDK": "Comorerne",
     "cityDK": "Anjouan"
  }, {
     "name": "Arvidsjaur Airport",
     "countryCode": "SE",
     "iata": "AJR",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Arvidsjaur"
  }, {
     "name": "Aracaju Airport",
     "countryCode": "BR",
     "iata": "AJU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Aracaju"
  }, {
     "name": "Manu Dayak International Airport",
     "countryCode": "NE",
     "iata": "AJY",
     "eucustoms": false,
     "countryDK": "Niger",
     "cityDK": "Agades"
  }, {
     "name": "Akron Fulton International Airport",
     "countryCode": "US",
     "iata": "AKC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Akron"
  }, {
     "name": "Akola Airport",
     "countryCode": "IN",
     "iata": "AKD",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Akola"
  }, {
     "name": "Kufra Airport",
     "countryCode": "LY",
     "iata": "AKF",
     "eucustoms": false,
     "countryDK": "Libyen",
     "cityDK": "Kufra"
  }, {
     "name": "Prince Sultan Air Base",
     "countryCode": "SA",
     "iata": "AKH",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Al Kharj"
  }, {
     "name": "Asahikawa Airport",
     "countryCode": "JP",
     "iata": "AKJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Asahikawa"
  }, {
     "name": "Auckland Airport",
     "countryCode": "NZ",
     "iata": "AKL",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Auckland"
  }, {
     "name": "King Salmon Airport",
     "countryCode": "US",
     "iata": "AKN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kongelaks"
  }, {
     "name": "Washington County Airport",
     "countryCode": "US",
     "iata": "AKO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Akron"
  }, {
     "name": "Anaktuvuk Airport",
     "countryCode": "US",
     "iata": "AKP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Anaktuvuk"
  }, {
     "name": "Akure Airport",
     "countryCode": "NG",
     "iata": "AKR",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Akure"
  }, {
     "name": "Gwaunaru'u Airport",
     "countryCode": "SB",
     "iata": "AKS",
     "eucustoms": false,
     "countryDK": "Salomonøerne",
     "cityDK": "Auki"
  }, {
     "name": "Akrotiri RAF Station",
     "countryCode": "CY",
     "iata": "AKT",
     "eucustoms": false,
     "countryDK": "Cypern",
     "cityDK": "Akrotiri"
  }, {
     "name": "Aksu Airport",
     "countryCode": "CN",
     "iata": "AKU",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Aksu"
  }, {
     "name": "Akulivik Airport",
     "countryCode": "CA",
     "iata": "AKV",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Akulivik"
  }, {
     "name": "Aghajari Airport",
     "countryCode": "IR",
     "iata": "AKW",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Aghajari"
  }, {
     "name": "Aktyubinsk Airport",
     "countryCode": "KZ",
     "iata": "AKX",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Aktyubinsk"
  }, {
     "name": "Civil Airport",
     "countryCode": "MM",
     "iata": "AKY",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Sittwe"
  }, {
     "name": "Almaty Airport",
     "countryCode": "KZ",
     "iata": "ALA",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Almaty"
  }, {
     "name": "Albany International Airport",
     "countryCode": "US",
     "iata": "ALB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Albany"
  }, {
     "name": "Alicante-Elche Airport",
     "countryCode": "ES",
     "iata": "ALC",
     "eucustoms": true,
     "countryDK": "Spanien",
     "cityDK": "Alicante"
  }, {
     "name": "Alerta Airport",
     "countryCode": "PE",
     "iata": "ALD",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Alerta"
  }, {
     "name": "Alta Airport",
     "countryCode": "NO",
     "iata": "ALF",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Alta"
  }, {
     "name": "Houari Boumediene Airport",
     "countryCode": "DZ",
     "iata": "ALG",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Algier"
  }, {
     "name": "Albany Airport",
     "countryCode": "AU",
     "iata": "ALH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Albany"
  }, {
     "name": "Alice International Airport",
     "countryCode": "US",
     "iata": "ALI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Alice"
  }, {
     "name": "Alexander Bay Airport",
     "countryCode": "ZA",
     "iata": "ALJ",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Alexander Bay"
  }, {
     "name": "Albenga Airport",
     "countryCode": "IT",
     "iata": "ALL",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Albenga"
  }, {
     "name": "Alamogordo Municipal Airport",
     "countryCode": "US",
     "iata": "ALM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Alamogordo"
  }, {
     "name": "St. Louis Regional Airport",
     "countryCode": "US",
     "iata": "ALN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Alton"
  }, {
     "name": "Waterloo Airport",
     "countryCode": "US",
     "iata": "ALO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Waterloo"
  }, {
     "name": "Aleppo International Airport",
     "countryCode": "SY",
     "iata": "ALP",
     "eucustoms": false,
     "countryDK": "Syrien",
     "cityDK": "Aleppo"
  }, {
     "name": "Federal Airport",
     "countryCode": "BR",
     "iata": "ALQ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Alegrete"
  }, {
     "name": "Alexandra Airport",
     "countryCode": "NZ",
     "iata": "ALR",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Alexandra"
  }, {
     "name": "Alamosa Municipal Airport",
     "countryCode": "US",
     "iata": "ALS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Alamosa"
  }, {
     "name": "Alula Airport",
     "countryCode": "SO",
     "iata": "ALU",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Alula"
  }, {
     "name": "Walla Walla Airport",
     "countryCode": "US",
     "iata": "ALW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Walla walla"
  }, {
     "name": "Thomas C Russell Field",
     "countryCode": "US",
     "iata": "ALX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Alexander City"
  }, {
     "name": "El Nohza Airport",
     "countryCode": "EG",
     "iata": "ALY",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Alexandria"
  }, {
     "name": "Rick Husband Amarillo International Airport",
     "countryCode": "US",
     "iata": "AMA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Amarillo"
  }, {
     "name": "Ambilobe Airport",
     "countryCode": "MG",
     "iata": "AMB",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Ambilobe"
  }, {
     "name": "Am Timan Airport",
     "countryCode": "TD",
     "iata": "AMC",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Am Timan"
  }, {
     "name": "Ahmedabad Airport",
     "countryCode": "IN",
     "iata": "AMD",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Ahmedabad"
  }, {
     "name": "Arba Mintch Airport",
     "countryCode": "ET",
     "iata": "AMH",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Arba Mintch"
  }, {
     "name": "Selaparang Airport",
     "countryCode": "ID",
     "iata": "AMI",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Mataram"
  }, {
     "name": "Almenara Airport",
     "countryCode": "BR",
     "iata": "AMJ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Almenara"
  }, {
     "name": "Queen Alia International Airport",
     "countryCode": "JO",
     "iata": "AMM",
     "eucustoms": false,
     "countryDK": "Jordan",
     "cityDK": "Amman"
  }, {
     "name": "Gratiot Community Airport",
     "countryCode": "US",
     "iata": "AMN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Alma"
  }, {
     "name": "Mao Airport",
     "countryCode": "TD",
     "iata": "AMO",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Mao"
  }, {
     "name": "Ampanihy Airport",
     "countryCode": "MG",
     "iata": "AMP",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Ampanihy"
  }, {
     "name": "Pattimura Airport",
     "countryCode": "ID",
     "iata": "AMQ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Ambon"
  }, {
     "name": "Amsterdam Airport Schiphol",
     "countryCode": "NL",
     "iata": "AMS",
     "eucustoms": true,
     "countryDK": "Holland",
     "cityDK": "Amsterdam"
  }, {
     "name": "Amderma Airport",
     "countryCode": "RU",
     "iata": "AMV",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Amderma"
  }, {
     "name": "Ames Airport",
     "countryCode": "US",
     "iata": "AMW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ames"
  }, {
     "name": "Ardmore Airport",
     "countryCode": "NZ",
     "iata": "AMZ",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Ardmore"
  }, {
     "name": "Anniston Regional Airport",
     "countryCode": "US",
     "iata": "ANB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Anniston"
  }, {
     "name": "Ted Stevens Anchorage International Airport",
     "countryCode": "US",
     "iata": "ANC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Anchorage"
  }, {
     "name": "Anderson Airport",
     "countryCode": "US",
     "iata": "AND",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Anderson"
  }, {
     "name": "Angers-Marce Airport",
     "countryCode": "FR",
     "iata": "ANE",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Angers"
  }, {
     "name": "Cerro Moreno International Airport",
     "countryCode": "CL",
     "iata": "ANF",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Antofagasta"
  }, {
     "name": "Brie-Champniers Airport",
     "countryCode": "FR",
     "iata": "ANG",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Angouleme"
  }, {
     "name": "Aniak Airport",
     "countryCode": "US",
     "iata": "ANI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Aniak"
  }, {
     "name": "Zanaga Airport",
     "countryCode": "CG",
     "iata": "ANJ",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Zanaga"
  }, {
     "name": "Etimesgut Airport",
     "countryCode": "TR",
     "iata": "ANK",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Ankara"
  }, {
     "name": "Antsirabato Airport",
     "countryCode": "MG",
     "iata": "ANM",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Antalaha"
  }, {
     "name": "Angoche Airport",
     "countryCode": "MZ",
     "iata": "ANO",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Angoche"
  }, {
     "name": "Lee Airport",
     "countryCode": "US",
     "iata": "ANP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Annapolis"
  }, {
     "name": "Tri-State Steuben County Airport",
     "countryCode": "US",
     "iata": "ANQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Angola"
  }, {
     "name": "Antwerp International Airport",
     "countryCode": "BE",
     "iata": "ANR",
     "eucustoms": false,
     "countryDK": "Belgien",
     "cityDK": "Antwerpen"
  }, {
     "name": "Andahuaylas Airport",
     "countryCode": "PE",
     "iata": "ANS",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Andahuaylas"
  }, {
     "name": "V.C. Bird International Airport",
     "countryCode": "AG",
     "iata": "ANU",
     "eucustoms": false,
     "countryDK": "Antigua og Barbuda",
     "cityDK": "Antigua"
  }, {
     "name": "Anvik Airport",
     "countryCode": "US",
     "iata": "ANV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Anvik"
  }, {
     "name": "Ainsworth Airport",
     "countryCode": "US",
     "iata": "ANW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ainsworth"
  }, {
     "name": "Andoya Airport",
     "countryCode": "NO",
     "iata": "ANX",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Andenes"
  }, {
     "name": "Anthony Airport",
     "countryCode": "US",
     "iata": "ANY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Anthony"
  }, {
     "name": "Altenburg Nobitz Airport",
     "countryCode": "DE",
     "iata": "AOC",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Altenburg"
  }, {
     "name": "Anadolu Airport",
     "countryCode": "TR",
     "iata": "AOE",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Eskisehir"
  }, {
     "name": "Anshan Teng'ao Airport",
     "countryCode": "CN",
     "iata": "AOG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Anshan"
  }, {
     "name": "Allen County Airport",
     "countryCode": "US",
     "iata": "AOH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lima"
  }, {
     "name": "Ancona Falconara Airport",
     "countryCode": "IT",
     "iata": "AOI",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Ancona"
  }, {
     "name": "Aomori Airport",
     "countryCode": "JP",
     "iata": "AOJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Aomori"
  }, {
     "name": "Karpathos Airport",
     "countryCode": "GR",
     "iata": "AOK",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Karpathos"
  }, {
     "name": "Paso de los Libres Airport",
     "countryCode": "AR",
     "iata": "AOL",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Paso de los Libres"
  }, {
     "name": "Altoona Airport",
     "countryCode": "US",
     "iata": "AOO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Altoona"
  }, {
     "name": "Alfredo V. Sara Bauer Airport",
     "countryCode": "PE",
     "iata": "AOP",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Andoas"
  }, {
     "name": "Aappilattoq-Upernanik Heliport",
     "countryCode": "GL",
     "iata": "AOQ",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Aappilattoq"
  }, {
     "name": "Sultan Abdul Halim Airport",
     "countryCode": "MY",
     "iata": "AOR",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Alor Setar"
  }, {
     "name": "Corrado Gex Airport",
     "countryCode": "IT",
     "iata": "AOT",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Aosta"
  }, {
     "name": "Attopeu Airport",
     "countryCode": "LA",
     "iata": "AOU",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Attopeu"
  }, {
     "name": "Centennial Airport",
     "countryCode": "US",
     "iata": "APA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Denver"
  }, {
     "name": "Apolo Airport",
     "countryCode": "BO",
     "iata": "APB",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Apolo"
  }, {
     "name": "Napa County Airport",
     "countryCode": "US",
     "iata": "APC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Napa"
  }, {
     "name": "Naples Municipal Airport",
     "countryCode": "US",
     "iata": "APF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Napoli"
  }, {
     "name": "Phillips Army Air Field",
     "countryCode": "US",
     "iata": "APG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Aberdeen"
  }, {
     "name": "Apataki Airport",
     "countryCode": "PF",
     "iata": "APK",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Apataki"
  }, {
     "name": "Nampula Airport",
     "countryCode": "MZ",
     "iata": "APL",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Nampula"
  }, {
     "name": "Alpena County Regional Airport",
     "countryCode": "US",
     "iata": "APN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Alpena"
  }, {
     "name": "Apartado Airport",
     "countryCode": "CO",
     "iata": "APO",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Apartado"
  }, {
     "name": "Arapiraca Airport",
     "countryCode": "BR",
     "iata": "APQ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Arapiraca"
  }, {
     "name": "Anapolis Airport",
     "countryCode": "BR",
     "iata": "APS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Anapolis"
  }, {
     "name": "Marion County Airport",
     "countryCode": "US",
     "iata": "APT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "jaspis"
  }, {
     "name": "Apucarana Airport",
     "countryCode": "BR",
     "iata": "APU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Apucarana"
  }, {
     "name": "Apple Valley Airport",
     "countryCode": "US",
     "iata": "APV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Apple Valley"
  }, {
     "name": "Faleolo Airport",
     "countryCode": "WS",
     "iata": "APW",
     "eucustoms": false,
     "countryDK": "Samoa",
     "cityDK": "Apia"
  }, {
     "name": "Arapongas Airport",
     "countryCode": "BR",
     "iata": "APX",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Arapongas"
  }, {
     "name": "Alto Parnaiba Airport",
     "countryCode": "BR",
     "iata": "APY",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Alto Parnaiba"
  }, {
     "name": "Araraquara Airport",
     "countryCode": "BR",
     "iata": "AQA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Araraquara"
  }, {
     "name": "Anqing Tianzhushan Airport",
     "countryCode": "CN",
     "iata": "AQG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Anqing"
  }, {
     "name": "Qaisumah Airport",
     "countryCode": "SA",
     "iata": "AQI",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Qaisumah"
  }, {
     "name": "King Hussein International Airport",
     "countryCode": "JO",
     "iata": "AQJ",
     "eucustoms": false,
     "countryDK": "Jordan",
     "cityDK": "Aqaba"
  }, {
     "name": "Ariquemes Airport",
     "countryCode": "BR",
     "iata": "AQM",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Ariquemes"
  }, {
     "name": "Rodriguez Ballon International Airport",
     "countryCode": "PE",
     "iata": "AQP",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Arequipa"
  }, {
     "name": "Acadiana Regional Airport",
     "countryCode": "US",
     "iata": "ARA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ny Iberia"
  }, {
     "name": "Ann Arbor Municipal Airport",
     "countryCode": "US",
     "iata": "ARB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ann Arbor"
  }, {
     "name": "Arctic Village Airport",
     "countryCode": "US",
     "iata": "ARC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Arctic Village"
  }, {
     "name": "Alor Island Airport",
     "countryCode": "ID",
     "iata": "ARD",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Alor Island"
  }, {
     "name": "Walnut Ridge Airport",
     "countryCode": "US",
     "iata": "ARG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Walnut Ridge"
  }, {
     "name": "Talagi Airport",
     "countryCode": "RU",
     "iata": "ARH",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Arkhangelsk"
  }, {
     "name": "Chacalluta Airport",
     "countryCode": "CL",
     "iata": "ARI",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Arica"
  }, {
     "name": "Arusha Airport",
     "countryCode": "TZ",
     "iata": "ARK",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Arusha"
  }, {
     "name": "Arly Airport",
     "countryCode": "BF",
     "iata": "ARL",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Arly"
  }, {
     "name": "Armidale Airport",
     "countryCode": "AU",
     "iata": "ARM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Armidale"
  }, {
     "name": "Stockholm Arlanda Airport",
     "countryCode": "SE",
     "iata": "ARN",
     "eucustoms": true,
     "countryDK": "Sverige",
     "cityDK": "Stockholm"
  }, {
     "name": "Alto Rio Senguerr Airport",
     "countryCode": "AR",
     "iata": "ARR",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Alto Rio Senguerr"
  }, {
     "name": "Aragarcas Airport",
     "countryCode": "BR",
     "iata": "ARS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Aragarcas"
  }, {
     "name": "Watertown Airport",
     "countryCode": "US",
     "iata": "ART",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Watertown"
  }, {
     "name": "Aracatuba Airport",
     "countryCode": "BR",
     "iata": "ARU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Aracatuba"
  }, {
     "name": "Noble F. Lee Airport",
     "countryCode": "US",
     "iata": "ARV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Minocqua"
  }, {
     "name": "Arad International Airport",
     "countryCode": "RO",
     "iata": "ARW",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Arad"
  }, {
     "name": "Ararat Airport",
     "countryCode": "AU",
     "iata": "ARY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ararat"
  }, {
     "name": "N'Zeto Airport",
     "countryCode": "AO",
     "iata": "ARZ",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "N'Zeto"
  }, {
     "name": "Assab Airport",
     "countryCode": "ER",
     "iata": "ASA",
     "eucustoms": false,
     "countryDK": "Eritrea",
     "cityDK": "Assab"
  }, {
     "name": "Ashgabat Airport",
     "countryCode": "TM",
     "iata": "ASB",
     "eucustoms": false,
     "countryDK": "Turkmenistan",
     "cityDK": "Ashgabat"
  }, {
     "name": "Andros Town Airport",
     "countryCode": "BS",
     "iata": "ASD",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Andros Town"
  }, {
     "name": "Aspen Airport",
     "countryCode": "US",
     "iata": "ASE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Aspen"
  }, {
     "name": "Astrakhan Airport",
     "countryCode": "RU",
     "iata": "ASF",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Astrakhan"
  }, {
     "name": "Ashburton Airport",
     "countryCode": "NZ",
     "iata": "ASG",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Ashburton"
  }, {
     "name": "Boire Field",
     "countryCode": "US",
     "iata": "ASH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Nashua"
  }, {
     "name": "Ascension Island RAF Station",
     "countryCode": "SH",
     "iata": "ASI",
     "eucustoms": false,
     "countryDK": "St. Helena",
     "cityDK": "Ascension Island"
  }, {
     "name": "Amami Airport",
     "countryCode": "JP",
     "iata": "ASJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Amami O Shima"
  }, {
     "name": "Yamoussoukro Airport",
     "countryCode": "CI",
     "iata": "ASK",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Yamoussoukro"
  }, {
     "name": "Harrison County Airport",
     "countryCode": "US",
     "iata": "ASL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marshall"
  }, {
     "name": "Asmara International Airport",
     "countryCode": "ER",
     "iata": "ASM",
     "eucustoms": false,
     "countryDK": "Eritrea",
     "cityDK": "Asmara"
  }, {
     "name": "Talladega Municipal Airport",
     "countryCode": "US",
     "iata": "ASN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Talladega"
  }, {
     "name": "Asosa Airport",
     "countryCode": "ET",
     "iata": "ASO",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Asosa"
  }, {
     "name": "Alice Springs Airport",
     "countryCode": "AU",
     "iata": "ASP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Alice Springs"
  }, {
     "name": "Kayseri Airport",
     "countryCode": "TR",
     "iata": "ASR",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Kayseri"
  }, {
     "name": "Arathusa Safari Lodge Airport",
     "countryCode": "ZA",
     "iata": "ASS",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Chitwa Chitwa"
  }, {
     "name": "Astoria Regional Airport",
     "countryCode": "US",
     "iata": "AST",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Astoria"
  }, {
     "name": "Silvio Pettirossi International Airport",
     "countryCode": "PY",
     "iata": "ASU",
     "eucustoms": false,
     "countryDK": "Paraguay",
     "cityDK": "Asuncion"
  }, {
     "name": "Amboseli Airport",
     "countryCode": "KE",
     "iata": "ASV",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Amboseli"
  }, {
     "name": "Aswan International Airport",
     "countryCode": "EG",
     "iata": "ASW",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Aswan"
  }, {
     "name": "Ashland Airport",
     "countryCode": "US",
     "iata": "ASX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ashland"
  }, {
     "name": "Ashley Airport",
     "countryCode": "US",
     "iata": "ASY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ashley"
  }, {
     "name": "Comandante FAP German Arias Graziani Airport",
     "countryCode": "PE",
     "iata": "ATA",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Anta"
  }, {
     "name": "Atbara Airport",
     "countryCode": "SD",
     "iata": "ATB",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Atbara"
  }, {
     "name": "Arthur's Town Airport",
     "countryCode": "BS",
     "iata": "ATC",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Arthur Town"
  }, {
     "name": "Chachoan Airport",
     "countryCode": "EC",
     "iata": "ATF",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Ambato"
  }, {
     "name": "Athen International Airport",
     "countryCode": "GR",
     "iata": "ATH",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Athen"
  }, {
     "name": "Artigas Airport",
     "countryCode": "UY",
     "iata": "ATI",
     "eucustoms": false,
     "countryDK": "Uruguay",
     "cityDK": "Artigas"
  }, {
     "name": "Antsirabe Airport",
     "countryCode": "MG",
     "iata": "ATJ",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Antsirabe"
  }, {
     "name": "Atqasuk Airport",
     "countryCode": "US",
     "iata": "ATK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Atqasuk"
  }, {
     "name": "Hartsfield-Jackson Atlanta International Airport",
     "countryCode": "US",
     "iata": "ATL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Atlanta"
  }, {
     "name": "Altamira Airport",
     "countryCode": "BR",
     "iata": "ATM",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Altamira"
  }, {
     "name": "Ohio University Airport",
     "countryCode": "US",
     "iata": "ATO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Athen"
  }, {
     "name": "Sri Guru Ram Dass Jee International Airport",
     "countryCode": "IN",
     "iata": "ATQ",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Amritsar"
  }, {
     "name": "Atar International Airport",
     "countryCode": "MR",
     "iata": "ATR",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Atar"
  }, {
     "name": "Artesia Airport",
     "countryCode": "US",
     "iata": "ATS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Artesia"
  }, {
     "name": "Ati Airport",
     "countryCode": "TD",
     "iata": "ATV",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Ati"
  }, {
     "name": "Appleton International Airport",
     "countryCode": "US",
     "iata": "ATW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Appleton"
  }, {
     "name": "Watertown Airport",
     "countryCode": "US",
     "iata": "ATY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Watertown"
  }, {
     "name": "Assiut Airport",
     "countryCode": "EG",
     "iata": "ATZ",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Assiut"
  }, {
     "name": "Reina Beatrix International Airport",
     "countryCode": "AW",
     "iata": "AUA",
     "eucustoms": false,
     "countryDK": "Aruba",
     "cityDK": "Aruba"
  }, {
     "name": "Arauca Airport",
     "countryCode": "CO",
     "iata": "AUC",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Arauca"
  }, {
     "name": "Augustus Downs Airport",
     "countryCode": "AU",
     "iata": "AUD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Augustus Downs"
  }, {
     "name": "Aeroport Auxerre Branches",
     "countryCode": "FR",
     "iata": "AUF",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Auxerre"
  }, {
     "name": "Augusta Airport",
     "countryCode": "US",
     "iata": "AUG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Augusta"
  }, {
     "name": "Abu Dhabi International Airport",
     "countryCode": "AE",
     "iata": "AUH",
     "eucustoms": false,
     "countryDK": "Forenede Arabiske Emirater",
     "cityDK": "Abu Dhabi"
  }, {
     "name": "Austin Airport",
     "countryCode": "US",
     "iata": "AUM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Austin"
  }, {
     "name": "Auburn Airport",
     "countryCode": "US",
     "iata": "AUN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Auburn"
  }, {
     "name": "Auburn University Regional Airport",
     "countryCode": "US",
     "iata": "AUO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Auburn"
  }, {
     "name": "Hiva Oa Airport",
     "countryCode": "PF",
     "iata": "AUQ",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Atuona"
  }, {
     "name": "Aurillac Airport",
     "countryCode": "FR",
     "iata": "AUR",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Aurillac"
  }, {
     "name": "Austin-Bergstrom International Airport",
     "countryCode": "US",
     "iata": "AUS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Austin"
  }, {
     "name": "Aurukun Airport",
     "countryCode": "AU",
     "iata": "AUU",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Aurukun"
  }, {
     "name": "Wausau Downtown Airport",
     "countryCode": "US",
     "iata": "AUW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wausau"
  }, {
     "name": "Araguaina Airport",
     "countryCode": "BR",
     "iata": "AUX",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Araguaina"
  }, {
     "name": "Aurora Municipal Airport",
     "countryCode": "US",
     "iata": "AUZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Aurora"
  }, {
     "name": "Aviano Air Base",
     "countryCode": "IT",
     "iata": "AVB",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Aviano"
  }, {
     "name": "Maximo Gomez Airport",
     "countryCode": "CU",
     "iata": "AVI",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Ciego De Avila"
  }, {
     "name": "Arvaikheer Airport",
     "countryCode": "MN",
     "iata": "AVK",
     "eucustoms": false,
     "countryDK": "Mongoliet",
     "cityDK": "Arvaikheer"
  }, {
     "name": "Asheville Regional Airport",
     "countryCode": "US",
     "iata": "AVL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Asheville"
  }, {
     "name": "Caumont Airport",
     "countryCode": "FR",
     "iata": "AVN",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Avignon"
  }, {
     "name": "Avon Park Municipal Airport",
     "countryCode": "US",
     "iata": "AVO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Avon Park"
  }, {
     "name": "Wilkes-Barre/Scranton International Airport",
     "countryCode": "US",
     "iata": "AVP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wilkes-Barre"
  }, {
     "name": "Avalon Airport",
     "countryCode": "AU",
     "iata": "AVV",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Avalon"
  }, {
     "name": "Marana Regional Airport",
     "countryCode": "US",
     "iata": "AVW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tucson"
  }, {
     "name": "Catalina Airport",
     "countryCode": "US",
     "iata": "AVX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Avalon"
  }, {
     "name": "Awasa Airport",
     "countryCode": "ET",
     "iata": "AWA",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Awasa"
  }, {
     "name": "Aniwa Airport",
     "countryCode": "VU",
     "iata": "AWD",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Aniwa"
  }, {
     "name": "Mariehamn Airport",
     "countryCode": "AX",
     "iata": "MHQ",
     "eucustoms": false,
     "countryDK": "Åland",
     "cityDK": "Mariehamn"
  }, {
     "name": "West Memphis Municipal Airport",
     "countryCode": "US",
     "iata": "AWM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "West Memphis"
  }, {
     "name": "Awantipur Air Force Station",
     "countryCode": "IN",
     "iata": "AWT",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Awantipur"
  }, {
     "name": "Ahwaz Airport",
     "countryCode": "IR",
     "iata": "AWZ",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Ahwaz"
  }, {
     "name": "Clayton J. Lloyd International Airport",
     "countryCode": "AI",
     "iata": "AXA",
     "eucustoms": false,
     "countryDK": "Anguilla",
     "cityDK": "Anguilla"
  }, {
     "name": "Aramac Airport",
     "countryCode": "AU",
     "iata": "AXC",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Aramac"
  }, {
     "name": "Demokritos Airport",
     "countryCode": "GR",
     "iata": "AXD",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Alexandroupolis"
  }, {
     "name": "Algona Airport",
     "countryCode": "US",
     "iata": "AXG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Algona"
  }, {
     "name": "Amakusa Airport",
     "countryCode": "JP",
     "iata": "AXJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Amakusa"
  }, {
     "name": "Ataq Airport",
     "countryCode": "YE",
     "iata": "AXK",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Ataq"
  }, {
     "name": "El Eden Airport",
     "countryCode": "CO",
     "iata": "AXM",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Armenien"
  }, {
     "name": "Chandler Field",
     "countryCode": "US",
     "iata": "AXN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Alexandria"
  }, {
     "name": "Springpoint Airport",
     "countryCode": "BS",
     "iata": "AXP",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Spring Point"
  }, {
     "name": "Arutua Airport",
     "countryCode": "PF",
     "iata": "AXR",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Arutua"
  }, {
     "name": "Altus Municipal Airport",
     "countryCode": "US",
     "iata": "AXS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Altus"
  }, {
     "name": "Akita Airport",
     "countryCode": "JP",
     "iata": "AXT",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Akita"
  }, {
     "name": "Axum Airport",
     "countryCode": "ET",
     "iata": "AXU",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Axum"
  }, {
     "name": "Neil Armstrong Airport",
     "countryCode": "US",
     "iata": "AXV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wapakoneta"
  }, {
     "name": "Angel Fire Airport",
     "countryCode": "US",
     "iata": "AXX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Angel Fire"
  }, {
     "name": "Yanamilla Airport",
     "countryCode": "PE",
     "iata": "AYP",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Ayacucho"
  }, {
     "name": "Connellan Airport",
     "countryCode": "AU",
     "iata": "AYQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ayers Rock"
  }, {
     "name": "Ayr Airport",
     "countryCode": "AU",
     "iata": "AYR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ayr"
  }, {
     "name": "Ware County Airport",
     "countryCode": "US",
     "iata": "AYS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Waycross"
  }, {
     "name": "Antalya Airport",
     "countryCode": "TR",
     "iata": "AYT",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Antalya"
  }, {
     "name": "Arnold Afb",
     "countryCode": "US",
     "iata": "AYX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tullahoma"
  }, {
     "name": "Phoenix-Mesa Gateway Airport",
     "countryCode": "US",
     "iata": "AZA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mesa"
  }, {
     "name": "Yazd Airport",
     "countryCode": "IR",
     "iata": "AZD",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Yazd"
  }, {
     "name": "Bateen Airport",
     "countryCode": "AE",
     "iata": "AZI",
     "eucustoms": false,
     "countryDK": "Forenede Arabiske Emirater",
     "cityDK": "Abu Dhabi"
  }, {
     "name": "Kalamazoo/Battle Creek International Airport",
     "countryCode": "US",
     "iata": "AZO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kalamazoo"
  }, {
     "name": "Adrar Airport",
     "countryCode": "DZ",
     "iata": "AZR",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Adrar"
  }, {
     "name": "Samana El Catey Airport",
     "countryCode": "DO",
     "iata": "AZS",
     "eucustoms": false,
     "countryDK": "Dominikanske Republik",
     "cityDK": "El Catey / Samana"
  }, {
     "name": "Ambriz Airport",
     "countryCode": "AO",
     "iata": "AZZ",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Ambriz"
  }, {
     "name": "Beale Air Force Base",
     "countryCode": "US",
     "iata": "BAB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marysville"
  }, {
     "name": "Barksdale Air Force Base",
     "countryCode": "US",
     "iata": "BAD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Shreveport"
  }, {
     "name": "St-Pons Airport",
     "countryCode": "FR",
     "iata": "BAE",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Barcelonnette"
  }, {
     "name": "Westfield-Barnes Regional Airport",
     "countryCode": "US",
     "iata": "BAF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Springfield"
  }, {
     "name": "Loakan Airport",
     "countryCode": "PH",
     "iata": "BAG",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Baguio"
  }, {
     "name": "Bahrain International Airport",
     "countryCode": "BH",
     "iata": "BAH",
     "eucustoms": false,
     "countryDK": "Bahrain",
     "cityDK": "Bahrain"
  }, {
     "name": "Buenos Aires Airport",
     "countryCode": "CR",
     "iata": "BAI",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Buenos Aires"
  }, {
     "name": "Batman Airport",
     "countryCode": "TR",
     "iata": "BAL",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Batman"
  }, {
     "name": "Lander County Airport",
     "countryCode": "US",
     "iata": "BAM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Battle Mountain"
  }, {
     "name": "Basongo Airport",
     "countryCode": "CD",
     "iata": "BAN",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Basongo"
  }, {
     "name": "Ernesto Cortissoz International Airport",
     "countryCode": "CO",
     "iata": "BAQ",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Barranquilla"
  }, {
     "name": "Balalae Airport",
     "countryCode": "SB",
     "iata": "BAS",
     "eucustoms": false,
     "countryDK": "Salomonøerne",
     "cityDK": "Balalae"
  }, {
     "name": "Barretos Airport",
     "countryCode": "BR",
     "iata": "BAT",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Barretos"
  }, {
     "name": "Baotou Airport",
     "countryCode": "CN",
     "iata": "BAV",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Baotou"
  }, {
     "name": "Barnaul Airport",
     "countryCode": "RU",
     "iata": "BAX",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Barnaul"
  }, {
     "name": "Baia Mare Airport",
     "countryCode": "RO",
     "iata": "BAY",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Baia Mare"
  }, {
     "name": "Barbelos Airport",
     "countryCode": "BR",
     "iata": "BAZ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Barbelos"
  }, {
     "name": "Teniente Vidal Airport",
     "countryCode": "CL",
     "iata": "BBA",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Balmaceda"
  }, {
     "name": "Benson Municipal Airport",
     "countryCode": "US",
     "iata": "BBB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Benson"
  }, {
     "name": "Bay City Airport",
     "countryCode": "US",
     "iata": "BBC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bay City"
  }, {
     "name": "Curtis Field",
     "countryCode": "US",
     "iata": "BBD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Brady"
  }, {
     "name": "Butaritari Airport",
     "countryCode": "KI",
     "iata": "BBG",
     "eucustoms": false,
     "countryDK": "Kiribati",
     "cityDK": "Butaritari"
  }, {
     "name": "Barth Airport",
     "countryCode": "DE",
     "iata": "BBH",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Barth"
  }, {
     "name": "Biju Patnaik International Airport",
     "countryCode": "IN",
     "iata": "BBI",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Bhubaneswar"
  }, {
     "name": "Kasane Airport",
     "countryCode": "BW",
     "iata": "BBK",
     "eucustoms": false,
     "countryDK": "Botswana",
     "cityDK": "Kasane"
  }, {
     "name": "Battambang Airport",
     "countryCode": "KH",
     "iata": "BBM",
     "eucustoms": false,
     "countryDK": "Cambodja",
     "cityDK": "Battambang"
  }, {
     "name": "Bario Airport",
     "countryCode": "MY",
     "iata": "BBN",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Bario"
  }, {
     "name": "Berbera Airport",
     "countryCode": "SO",
     "iata": "BBO",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Berbera"
  }, {
     "name": "Bembridge Airport",
     "countryCode": "GB",
     "iata": "BBP",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Bembridge"
  }, {
     "name": "Barbuda Codrington Airport",
     "countryCode": "AG",
     "iata": "BBQ",
     "eucustoms": false,
     "countryDK": "Antigua og Barbuda",
     "cityDK": "Barbuda"
  }, {
     "name": "Baillif Airport",
     "countryCode": "GP",
     "iata": "BBR",
     "eucustoms": false,
     "countryDK": "Guadeloupe",
     "cityDK": "Basse Terre"
  }, {
     "name": "Blackbush Airport",
     "countryCode": "GB",
     "iata": "BBS",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Blackbush"
  }, {
     "name": "Berberati Airport",
     "countryCode": "CF",
     "iata": "BBT",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "Berberati"
  }, {
     "name": "Baneasa Airport",
     "countryCode": "RO",
     "iata": "BBU",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Bukarest"
  }, {
     "name": "Bereby Airport",
     "countryCode": "CI",
     "iata": "BBV",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Bereby"
  }, {
     "name": "Broken Bow Municipal Airport",
     "countryCode": "US",
     "iata": "BBW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Broken Bow"
  }, {
     "name": "Bambari Airport",
     "countryCode": "CF",
     "iata": "BBY",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "Bambari"
  }, {
     "name": "Zambezi Airport",
     "countryCode": "ZM",
     "iata": "BBZ",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Zambezi"
  }, {
     "name": "Baracoa Airport",
     "countryCode": "CU",
     "iata": "BCA",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Baracoa"
  }, {
     "name": "Virginia Tech Airport",
     "countryCode": "US",
     "iata": "BCB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Blacksburg"
  }, {
     "name": "Silay International Airport",
     "countryCode": "PH",
     "iata": "BCD",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Bacolod"
  }, {
     "name": "Bryce Airport",
     "countryCode": "US",
     "iata": "BCE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bryce"
  }, {
     "name": "Baucau Airport",
     "countryCode": "ID",
     "iata": "BCH",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Baucau"
  }, {
     "name": "Barcaldine Airport",
     "countryCode": "AU",
     "iata": "BCI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Barcaldine"
  }, {
     "name": "Barra del Colorado Airport",
     "countryCode": "CR",
     "iata": "BCL",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Barra del Colorado"
  }, {
     "name": "Bacau Airport",
     "countryCode": "RO",
     "iata": "BCM",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Bacau"
  }, {
     "name": "Barcelona-El Prat Airport",
     "countryCode": "ES",
     "iata": "BCN",
     "eucustoms": true,
     "countryDK": "Spanien",
     "cityDK": "Barcelona"
  }, {
     "name": "Bako Airport",
     "countryCode": "ET",
     "iata": "BCO",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Jinka"
  }, {
     "name": "Boca Raton Airport",
     "countryCode": "US",
     "iata": "BCT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Boca Raton"
  }, {
     "name": "Bauchi Airport",
     "countryCode": "NG",
     "iata": "BCU",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Bauchi"
  }, {
     "name": "L.F. Wade International Airport",
     "countryCode": "BM",
     "iata": "BDA",
     "eucustoms": false,
     "countryDK": "Bermuda",
     "cityDK": "Bermuda"
  }, {
     "name": "Bundaberg Airport",
     "countryCode": "AU",
     "iata": "BDB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Bundaberg"
  }, {
     "name": "Barra Do Corda Airport",
     "countryCode": "BR",
     "iata": "BDC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Barra Do Corda"
  }, {
     "name": "Badu Island Airport",
     "countryCode": "AU",
     "iata": "BDD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Badu Island"
  }, {
     "name": "Baudette Airport",
     "countryCode": "US",
     "iata": "BDE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Baudette"
  }, {
     "name": "Blanding Airport",
     "countryCode": "US",
     "iata": "BDG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Blanding"
  }, {
     "name": "Bandar Lengeh Airport",
     "countryCode": "IR",
     "iata": "BDH",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Bandar Lengeh"
  }, {
     "name": "Bird Island Airport",
     "countryCode": "SC",
     "iata": "BDI",
     "eucustoms": false,
     "countryDK": "Seychellerne",
     "cityDK": "Bird Island"
  }, {
     "name": "Syamsudin Noor International Airport",
     "countryCode": "ID",
     "iata": "BDJ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Banjarmasin"
  }, {
     "name": "Bondoukou Airport",
     "countryCode": "CI",
     "iata": "BDK",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Bondoukou"
  }, {
     "name": "Bradley International Airport",
     "countryCode": "US",
     "iata": "BDL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hartford"
  }, {
     "name": "Bandirma Airport",
     "countryCode": "TR",
     "iata": "BDM",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Bandirma"
  }, {
     "name": "Husein Sastranegara Airport",
     "countryCode": "ID",
     "iata": "BDO",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Bandung"
  }, {
     "name": "Vadodara Airport",
     "countryCode": "IN",
     "iata": "BDQ",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Vadodara"
  }, {
     "name": "Igor I. Sikorsky Memorial Airport",
     "countryCode": "US",
     "iata": "BDR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bridgeport"
  }, {
     "name": "Brindisi - Salento Airport",
     "countryCode": "IT",
     "iata": "BDS",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Brindisi"
  }, {
     "name": "Gbadolite Airport",
     "countryCode": "CD",
     "iata": "BDT",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Gbadolite"
  }, {
     "name": "Bardufoss Airport",
     "countryCode": "NO",
     "iata": "BDU",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Bardufoss"
  }, {
     "name": "Moba Airport",
     "countryCode": "CD",
     "iata": "BDV",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Moba"
  }, {
     "name": "Broadus Airport",
     "countryCode": "US",
     "iata": "BDX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Broadus"
  }, {
     "name": "Benbecula Airport",
     "countryCode": "GB",
     "iata": "BEB",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Benbecula"
  }, {
     "name": "Beech Airport",
     "countryCode": "US",
     "iata": "BEC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wichita"
  }, {
     "name": "Laurence G. Hanscom Field",
     "countryCode": "US",
     "iata": "BED",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bedford / Hanscom"
  }, {
     "name": "Bluefields Airport",
     "countryCode": "NI",
     "iata": "BEF",
     "eucustoms": false,
     "countryDK": "Nicaragua",
     "cityDK": "Bluefields"
  }, {
     "name": "Belgrad Nikola Tesla Airport",
     "countryCode": "RS",
     "iata": "BEG",
     "eucustoms": false,
     "countryDK": "Serbien",
     "cityDK": "Beograd"
  }, {
     "name": "Southwest Michigan Regional Airport",
     "countryCode": "US",
     "iata": "BEH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Benton Harbor"
  }, {
     "name": "Beica Airport",
     "countryCode": "ET",
     "iata": "BEI",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Beica"
  }, {
     "name": "Kalimarau Airport",
     "countryCode": "ID",
     "iata": "BEJ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Berau"
  }, {
     "name": "Val De Cans International Airport",
     "countryCode": "BR",
     "iata": "BEL",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Belem"
  }, {
     "name": "Beni Mellal National Airport",
     "countryCode": "MA",
     "iata": "BEM",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Beni Mellal"
  }, {
     "name": "Benina International Airport",
     "countryCode": "LY",
     "iata": "BEN",
     "eucustoms": false,
     "countryDK": "Libyen",
     "cityDK": "Benghazi"
  }, {
     "name": "Brest Bretagne Airport",
     "countryCode": "FR",
     "iata": "BES",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Brest"
  }, {
     "name": "Bethel Airport",
     "countryCode": "US",
     "iata": "BET",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bethel"
  }, {
     "name": "Bedourie Airport",
     "countryCode": "AU",
     "iata": "BEU",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Bedourie"
  }, {
     "name": "Beer Sheba Airport",
     "countryCode": "IL",
     "iata": "BEV",
     "eucustoms": false,
     "countryDK": "Israel",
     "cityDK": "Øl Sheba"
  }, {
     "name": "Beira Airport",
     "countryCode": "MZ",
     "iata": "BEW",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Beira"
  }, {
     "name": "Benson RAF Station",
     "countryCode": "GB",
     "iata": "BEX",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Benson"
  }, {
     "name": "Beirut-Rafic Hariri International Airport",
     "countryCode": "LB",
     "iata": "BEY",
     "eucustoms": false,
     "countryDK": "Libanon",
     "cityDK": "Beirut"
  }, {
     "name": "Bradford Airport",
     "countryCode": "US",
     "iata": "BFD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bradford"
  }, {
     "name": "Bielefeld Airport",
     "countryCode": "DE",
     "iata": "BFE",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Bielefeld"
  }, {
     "name": "Western Nebraska Regional Airport",
     "countryCode": "US",
     "iata": "BFF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Scottsbluff"
  }, {
     "name": "Bacacheri Airport",
     "countryCode": "BR",
     "iata": "BFH",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Curitiba"
  }, {
     "name": "Boeing Field International Airport",
     "countryCode": "US",
     "iata": "BFI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Seattle"
  }, {
     "name": "Buckley Air National Guard Base",
     "countryCode": "US",
     "iata": "BFK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Denver"
  }, {
     "name": "Meadows Field Airport",
     "countryCode": "US",
     "iata": "BFL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bakersfield"
  }, {
     "name": "Mobile Downtown Airport",
     "countryCode": "US",
     "iata": "BFM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mobil"
  }, {
     "name": "Bram Fischer International Airport",
     "countryCode": "ZA",
     "iata": "BFN",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Bloemfontein"
  }, {
     "name": "Buffalo Range Airport",
     "countryCode": "ZW",
     "iata": "BFO",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Buffalo Range"
  }, {
     "name": "Beaver Falls Airport",
     "countryCode": "US",
     "iata": "BFP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Beaver Falls"
  }, {
     "name": "Virgil I Grissom Municipal Airport",
     "countryCode": "US",
     "iata": "BFR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bedford"
  }, {
     "name": "Belfast International Airport",
     "countryCode": "GB",
     "iata": "BFS",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Belfast"
  }, {
     "name": "Beaufort County Airport",
     "countryCode": "US",
     "iata": "BFT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Beaufort"
  }, {
     "name": "Bengbu Airport",
     "countryCode": "CN",
     "iata": "BFU",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Bengbu"
  }, {
     "name": "Bafoussam Airport",
     "countryCode": "CM",
     "iata": "BFX",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Bafoussam"
  }, {
     "name": "Palonegro International Airport",
     "countryCode": "CO",
     "iata": "BGA",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Bucaramanga"
  }, {
     "name": "Booue Airport",
     "countryCode": "GA",
     "iata": "BGB",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Booue"
  }, {
     "name": "Braganca Airport",
     "countryCode": "PT",
     "iata": "BGC",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Braganca"
  }, {
     "name": "Borger Airport",
     "countryCode": "US",
     "iata": "BGD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Borger"
  }, {
     "name": "Decatur County Airport",
     "countryCode": "US",
     "iata": "BGE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bainbridge"
  }, {
     "name": "M'poko International Airport",
     "countryCode": "CF",
     "iata": "BGF",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "Bangui"
  }, {
     "name": "Abbaye Airport",
     "countryCode": "MR",
     "iata": "BGH",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Boghe"
  }, {
     "name": "Grantley Adams International Airport",
     "countryCode": "BB",
     "iata": "BGI",
     "eucustoms": false,
     "countryDK": "Barbados",
     "cityDK": "Bridgetown"
  }, {
     "name": "Baglung Airport",
     "countryCode": "NP",
     "iata": "BGL",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Baglung"
  }, {
     "name": "Greater Binghamton Airport",
     "countryCode": "US",
     "iata": "BGM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Binghamton"
  }, {
     "name": "Belaya Gora Airport",
     "countryCode": "RU",
     "iata": "BGN",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Belaya Gora"
  }, {
     "name": "Bergen Airport",
     "countryCode": "NO",
     "iata": "BGO",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Bergen"
  }, {
     "name": "Bangor International Airport",
     "countryCode": "US",
     "iata": "BGR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bangor"
  }, {
     "name": "Bangassou Airport",
     "countryCode": "CF",
     "iata": "BGU",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "Bangassou"
  }, {
     "name": "Bage Airport",
     "countryCode": "BR",
     "iata": "BGX",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Bage"
  }, {
     "name": "Orio al Serio International Airport",
     "countryCode": "IT",
     "iata": "BGY",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Milano"
  }, {
     "name": "Braga Airport",
     "countryCode": "PT",
     "iata": "BGZ",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Braga"
  }, {
     "name": "Bahia De Caraquez Airport",
     "countryCode": "EC",
     "iata": "BHA",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Bahia De Caraquez"
  }, {
     "name": "Bar Harbor Airport",
     "countryCode": "US",
     "iata": "BHB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bar Harbor"
  }, {
     "name": "George Best Belfast City Airport",
     "countryCode": "GB",
     "iata": "BHD",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Belfast"
  }, {
     "name": "Woodbourne Airport",
     "countryCode": "NZ",
     "iata": "BHE",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Blenheim"
  }, {
     "name": "Bisha Airport",
     "countryCode": "SA",
     "iata": "BHH",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Bisha"
  }, {
     "name": "Comandante Airport",
     "countryCode": "AR",
     "iata": "BHI",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Bahia Blanca"
  }, {
     "name": "Rudra Mata Airport",
     "countryCode": "IN",
     "iata": "BHJ",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Bhuj"
  }, {
     "name": "Bukhara Airport",
     "countryCode": "UZ",
     "iata": "BHK",
     "eucustoms": false,
     "countryDK": "Usbekistan",
     "cityDK": "Bukhara"
  }, {
     "name": "Birmingham-Shuttlesworth International Airport",
     "countryCode": "US",
     "iata": "BHM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Birmingham"
  }, {
     "name": "Beihan Airport",
     "countryCode": "YE",
     "iata": "BHN",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Beihan"
  }, {
     "name": "Raja Bhoj Airport",
     "countryCode": "IN",
     "iata": "BHO",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Bhopal"
  }, {
     "name": "Bhojpur Airport",
     "countryCode": "NP",
     "iata": "BHP",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Bhojpur"
  }, {
     "name": "Broken Hill Airport",
     "countryCode": "AU",
     "iata": "BHQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Broken Hill"
  }, {
     "name": "Bharatpur Airport",
     "countryCode": "NP",
     "iata": "BHR",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Bharatpur"
  }, {
     "name": "Raglan Airport",
     "countryCode": "AU",
     "iata": "BHS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Bathurst"
  }, {
     "name": "Bhavnagar Airport",
     "countryCode": "IN",
     "iata": "BHU",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Bhavnagar"
  }, {
     "name": "Bahawalpur Airport",
     "countryCode": "PK",
     "iata": "BHV",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Bahawalpur"
  }, {
     "name": "Birmingham International Airport",
     "countryCode": "GB",
     "iata": "BHX",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Birmingham"
  }, {
     "name": "Beihai Fucheng Airport",
     "countryCode": "CN",
     "iata": "BHY",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Beihai"
  }, {
     "name": "Bastia Poretta Airport",
     "countryCode": "FR",
     "iata": "BIA",
     "eucustoms": true,
     "countryDK": "Frankrig",
     "cityDK": "Bastia"
  }, {
     "name": "Baidoa Airport",
     "countryCode": "SO",
     "iata": "BIB",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Baidoa"
  }, {
     "name": "Block Island Airport",
     "countryCode": "US",
     "iata": "BID",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Block Island"
  }, {
     "name": "Beatrice Municipal Airport",
     "countryCode": "US",
     "iata": "BIE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Beatrice"
  }, {
     "name": "Biggs Army Air Field",
     "countryCode": "US",
     "iata": "BIF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "El Paso"
  }, {
     "name": "Eastern Sierra Regional Airport",
     "countryCode": "US",
     "iata": "BIH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Biskop"
  }, {
     "name": "Frans Kaisiepo Airport",
     "countryCode": "ID",
     "iata": "BIK",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Biak"
  }, {
     "name": "Billings Logan International Airport",
     "countryCode": "US",
     "iata": "BIL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Billings"
  }, {
     "name": "Bimini International Airport",
     "countryCode": "BS",
     "iata": "BIM",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Bimini"
  }, {
     "name": "Bamiyan Airport",
     "countryCode": "AF",
     "iata": "BIN",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Bamiyan"
  }, {
     "name": "Bilbao Airport",
     "countryCode": "ES",
     "iata": "BIO",
     "eucustoms": true,
     "countryDK": "Spanien",
     "cityDK": "Bilbao"
  }, {
     "name": "Biarritz Pays Basque Airport",
     "countryCode": "FR",
     "iata": "BIQ",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Biarritz"
  }, {
     "name": "Biratnagar Airport",
     "countryCode": "NP",
     "iata": "BIR",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Biratnagar"
  }, {
     "name": "Bismarck Airport",
     "countryCode": "US",
     "iata": "BIS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bismarck"
  }, {
     "name": "Patan Airport",
     "countryCode": "NP",
     "iata": "BIT",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Baitadi"
  }, {
     "name": "Bria Airport",
     "countryCode": "CF",
     "iata": "BIV",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "Bria"
  }, {
     "name": "Keesler Air Force Base",
     "countryCode": "US",
     "iata": "BIX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Biloxi"
  }, {
     "name": "Bisho Airport",
     "countryCode": "ZA",
     "iata": "BIY",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Bisho"
  }, {
     "name": "Bejaia Airport",
     "countryCode": "DZ",
     "iata": "BJA",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Bejaia"
  }, {
     "name": "Bojnord Airport",
     "countryCode": "IR",
     "iata": "BJB",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Bojnord"
  }, {
     "name": "Rocky Mountain Metropolitan Airport",
     "countryCode": "US",
     "iata": "BJC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Broomfield"
  }, {
     "name": "Batsfjord Airport",
     "countryCode": "NO",
     "iata": "BJF",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Batsfjord"
  }, {
     "name": "Bajhang Airport",
     "countryCode": "NP",
     "iata": "BJH",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Bajhang"
  }, {
     "name": "Bemidji Airport",
     "countryCode": "US",
     "iata": "BJI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bemidji"
  }, {
     "name": "Wayne County Airport",
     "countryCode": "US",
     "iata": "BJJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wooster"
  }, {
     "name": "Banjul International Airport",
     "countryCode": "GM",
     "iata": "BJL",
     "eucustoms": false,
     "countryDK": "Gambia",
     "cityDK": "Banjul"
  }, {
     "name": "Bujumbura International Airport",
     "countryCode": "BI",
     "iata": "BJM",
     "eucustoms": false,
     "countryDK": "Burundi",
     "cityDK": "Bujumbura"
  }, {
     "name": "Bermejo Airport",
     "countryCode": "BO",
     "iata": "BJO",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Bermejo"
  }, {
     "name": "Arthur Siqueira State Airport",
     "countryCode": "BR",
     "iata": "BJP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Braganca Paulista"
  }, {
     "name": "Bahar Dar Airport",
     "countryCode": "ET",
     "iata": "BJR",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Bahar Dar"
  }, {
     "name": "Bajura Airport",
     "countryCode": "NP",
     "iata": "BJU",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Bajura"
  }, {
     "name": "Milas-Bodrum Airport",
     "countryCode": "TR",
     "iata": "BJV",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Bodrum"
  }, {
     "name": "Del Bajio International Airport",
     "countryCode": "MX",
     "iata": "BJX",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Leon / Guanajuato"
  }, {
     "name": "Batajnica Airbase",
     "countryCode": "RS",
     "iata": "BJY",
     "eucustoms": false,
     "countryDK": "Serbien",
     "cityDK": "Beograd"
  }, {
     "name": "Badajoz Airport",
     "countryCode": "ES",
     "iata": "BJZ",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Badajoz"
  }, {
     "name": "Buckland Airport",
     "countryCode": "US",
     "iata": "BKC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Buckland"
  }, {
     "name": "Stephens County Airport",
     "countryCode": "US",
     "iata": "BKD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Breckenridge"
  }, {
     "name": "Baker Airport",
     "countryCode": "US",
     "iata": "BKE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bager"
  }, {
     "name": "Branson Airport",
     "countryCode": "US",
     "iata": "BKG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hollister"
  }, {
     "name": "Barking Sands Airport",
     "countryCode": "US",
     "iata": "BKH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kekaha"
  }, {
     "name": "Kota Kinabalu International Airport",
     "countryCode": "MY",
     "iata": "BKI",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Kota Kinabalu"
  }, {
     "name": "Baralande Airport",
     "countryCode": "GN",
     "iata": "BKJ",
     "eucustoms": false,
     "countryDK": "Guinea",
     "cityDK": "Boke"
  }, {
     "name": "Suvarnabhumi Airport",
     "countryCode": "TH",
     "iata": "BKK",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Bangkok"
  }, {
     "name": "Burke Lakefront Airport",
     "countryCode": "US",
     "iata": "BKL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cleveland"
  }, {
     "name": "Bamako-Senou International Airport",
     "countryCode": "ML",
     "iata": "BKO",
     "eucustoms": false,
     "countryDK": "Mali",
     "cityDK": "Bamako"
  }, {
     "name": "Blackall Airport",
     "countryCode": "AU",
     "iata": "BKQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Blackall"
  }, {
     "name": "Bokoro Airport",
     "countryCode": "TD",
     "iata": "BKR",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Bokoro"
  }, {
     "name": "Fatmawati Soekarno Airport",
     "countryCode": "ID",
     "iata": "BKS",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Bengkulu"
  }, {
     "name": "Blackstone Army Air Field",
     "countryCode": "US",
     "iata": "BKT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sort sten"
  }, {
     "name": "Raleigh County Memorial Airport",
     "countryCode": "US",
     "iata": "BKW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Beckley"
  }, {
     "name": "Brookings Airport",
     "countryCode": "US",
     "iata": "BKX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Brookings"
  }, {
     "name": "Kavumu Airport",
     "countryCode": "CD",
     "iata": "BKY",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Bukavu"
  }, {
     "name": "Bukoba Airport",
     "countryCode": "TZ",
     "iata": "BKZ",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Bukoba"
  }, {
     "name": "General Jose Antonio Anzoategui International Airport",
     "countryCode": "VE",
     "iata": "BLA",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Barcelona"
  }, {
     "name": "Panama Pacifico Airport",
     "countryCode": "PA",
     "iata": "BLB",
     "eucustoms": false,
     "countryDK": "Panama",
     "cityDK": "Balboa"
  }, {
     "name": "Dala Airport",
     "countryCode": "SE",
     "iata": "BLE",
     "eucustoms": true,
     "countryDK": "Sverige",
     "cityDK": "Borlange / Falun"
  }, {
     "name": "Mercer County Airport",
     "countryCode": "US",
     "iata": "BLF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bluefield"
  }, {
     "name": "Blythe Airport",
     "countryCode": "US",
     "iata": "BLH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Blythe"
  }, {
     "name": "Bellingham International Airport",
     "countryCode": "US",
     "iata": "BLI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bellingham"
  }, {
     "name": "Mostepha Ben Boulaid Airport",
     "countryCode": "DZ",
     "iata": "BLJ",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Batna"
  }, {
     "name": "Blackpool Airport",
     "countryCode": "GB",
     "iata": "BLK",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Blackpool"
  }, {
     "name": "Billund Airport",
     "countryCode": "DK",
     "iata": "BLL",
     "eucustoms": true,
     "countryDK": "Danmark",
     "cityDK": "Billund"
  }, {
     "name": "Monmouth Executive Airport",
     "countryCode": "US",
     "iata": "BLM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Belmar"
  }, {
     "name": "Benalla Airport",
     "countryCode": "AU",
     "iata": "BLN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Benalla"
  }, {
     "name": "Blonduos Airport",
     "countryCode": "IS",
     "iata": "BLO",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Blonduos"
  }, {
     "name": "Bellavista Airport",
     "countryCode": "PE",
     "iata": "BLP",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Bellavista"
  }, {
     "name": "Guglielmo Marconi Airport",
     "countryCode": "IT",
     "iata": "BLQ",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Bologna"
  }, {
     "name": "Kempegowda International Airport",
     "countryCode": "IN",
     "iata": "BLR",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Bengaluru"
  }, {
     "name": "Bollon Airport",
     "countryCode": "AU",
     "iata": "BLS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Bollon"
  }, {
     "name": "Blackwater Airport",
     "countryCode": "AU",
     "iata": "BLT",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Sort vand"
  }, {
     "name": "Blue Canyon Airport",
     "countryCode": "US",
     "iata": "BLU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Blue Canyon"
  }, {
     "name": "MidAmerica St. Louis Airport / Scott AFB",
     "countryCode": "US",
     "iata": "BLV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Belleville"
  }, {
     "name": "Beletwene Airport",
     "countryCode": "SO",
     "iata": "BLW",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Beletwene"
  }, {
     "name": "Belluno Airport",
     "countryCode": "IT",
     "iata": "BLX",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Belluno"
  }, {
     "name": "Belmullet Airport",
     "countryCode": "IE",
     "iata": "BLY",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Belmullet"
  }, {
     "name": "Chileka Airport",
     "countryCode": "MW",
     "iata": "BLZ",
     "eucustoms": false,
     "countryDK": "Malawi",
     "cityDK": "Blantyre"
  }, {
     "name": "Bromma Airport",
     "countryCode": "SE",
     "iata": "BMA",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Stockholm"
  }, {
     "name": "Bumba Airport",
     "countryCode": "CD",
     "iata": "BMB",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Bumba"
  }, {
     "name": "Brigham City Airport",
     "countryCode": "US",
     "iata": "BMC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Brigham City"
  }, {
     "name": "Belo sur Tsiribihina Airport",
     "countryCode": "MG",
     "iata": "BMD",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Belo sur Tsiribihina"
  }, {
     "name": "Broome Airport",
     "countryCode": "AU",
     "iata": "BME",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Broome"
  }, {
     "name": "Monroe County Airport",
     "countryCode": "US",
     "iata": "BMG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bloomington"
  }, {
     "name": "Central Illinois Regional Airport",
     "countryCode": "US",
     "iata": "BMI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bloomington"
  }, {
     "name": "Borkum Airport",
     "countryCode": "DE",
     "iata": "BMK",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Borkum"
  },  {
     "name": "Berlin Brandenburg Airport",
     "countryCode": "DE",
     "iata": "BER",
     "eucustoms": true,
     "countryDK": "Tyskland",
     "cityDK": "Berlin"
  }, {
     "name": "Berlin Airpor USAt",
     "countryCode": "US",
     "iata": "BML",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Berlin"
  }, {
     "name": "Bitam Airport",
     "countryCode": "GA",
     "iata": "BMM",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Bitam"
  }, {
     "name": "Banmaw Airport",
     "countryCode": "MM",
     "iata": "BMO",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Bhamo"
  }, {
     "name": "Brampton Island Airport",
     "countryCode": "AU",
     "iata": "BMP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Brampton Island"
  }, {
     "name": "Baltrum Airport",
     "countryCode": "DE",
     "iata": "BMR",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Baltrum"
  }, {
     "name": "Beaumont Municipal Airport",
     "countryCode": "US",
     "iata": "BMT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Beaumont"
  }, {
     "name": "Sultan Muhammad Salahuddin Airport",
     "countryCode": "ID",
     "iata": "BMU",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Bima"
  }, {
     "name": "Phung-Duc Airport",
     "countryCode": "VN",
     "iata": "BMV",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Banmethuot"
  }, {
     "name": "Bordj Badji Mokhtar Airport",
     "countryCode": "DZ",
     "iata": "BMW",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Bordj Badji Mokhtar"
  }, {
     "name": "Belep Island Airport",
     "countryCode": "NC",
     "iata": "BMY",
     "eucustoms": false,
     "countryDK": "Ny Kaledonien",
     "cityDK": "Belep Island"
  }, {
     "name": "Nashville International Airport",
     "countryCode": "US",
     "iata": "BNA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Nashville"
  }, {
     "name": "Boende Airport",
     "countryCode": "CD",
     "iata": "BNB",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Boende"
  }, {
     "name": "Beni Airport",
     "countryCode": "CD",
     "iata": "BNC",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Beni"
  }, {
     "name": "Bandar Abbas International Airport",
     "countryCode": "IR",
     "iata": "BND",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Bandar Abbas"
  }, {
     "name": "Brisbane Airport",
     "countryCode": "AU",
     "iata": "BNE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Brisbane"
  }, {
     "name": "Banning Airport",
     "countryCode": "US",
     "iata": "BNG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Banning"
  }, {
     "name": "Benin City Airport",
     "countryCode": "NG",
     "iata": "BNI",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Benin City"
  }, {
     "name": "Ballina Byron Airport",
     "countryCode": "AU",
     "iata": "BNK",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ballina"
  }, {
     "name": "Barnwell County Airport",
     "countryCode": "US",
     "iata": "BNL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Barnwell"
  }, {
     "name": "Bronnoysund Airport, Bronnoy",
     "countryCode": "NO",
     "iata": "BNN",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Brønnøysund"
  }, {
     "name": "Burns Municipal Airport",
     "countryCode": "US",
     "iata": "BNO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Burns"
  }, {
     "name": "Bannu Airport",
     "countryCode": "PK",
     "iata": "BNP",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Bannu"
  }, {
     "name": "Banfora Airport",
     "countryCode": "BF",
     "iata": "BNR",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Banfora"
  }, {
     "name": "Barinas Airport",
     "countryCode": "VE",
     "iata": "BNS",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Barinas"
  }, {
     "name": "Blumenau Airport",
     "countryCode": "BR",
     "iata": "BNU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Blumenau"
  }, {
     "name": "Boone Airport",
     "countryCode": "US",
     "iata": "BNW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Boone"
  }, {
     "name": "Banja Luka Airport",
     "countryCode": "BA",
     "iata": "BNX",
     "eucustoms": false,
     "countryDK": "Bosnien-Hercegovina",
     "cityDK": "Banja Luka"
  }, {
     "name": "Boma Airport",
     "countryCode": "CD",
     "iata": "BOA",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Boma"
  }, {
     "name": "Motu Mute Airport",
     "countryCode": "PF",
     "iata": "BOB",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Bora bora"
  }, {
     "name": "Bocas Del Toro Airport",
     "countryCode": "PA",
     "iata": "BOC",
     "eucustoms": false,
     "countryDK": "Panama",
     "cityDK": "Bocas Del Toro"
  }, {
     "name": "Bordeaux Airport",
     "countryCode": "FR",
     "iata": "BOD",
     "eucustoms": true,
     "countryDK": "Frankrig",
     "cityDK": "Bordeaux"
  }, {
     "name": "Boundji Airport",
     "countryCode": "CG",
     "iata": "BOE",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Boundji"
  }, {
     "name": "El Dorado International Airport",
     "countryCode": "CO",
     "iata": "BOG",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Bogota"
  }, {
     "name": "Bournemouth Airport",
     "countryCode": "GB",
     "iata": "BOH",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Bournemouth"
  }, {
     "name": "Boise Air Terminal (Gowen Field)",
     "countryCode": "US",
     "iata": "BOI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Boise"
  }, {
     "name": "Bourgas Airport",
     "countryCode": "BG",
     "iata": "BOJ",
     "eucustoms": true,
     "countryDK": "Bulgarien",
     "cityDK": "Bourgas"
  }, {
     "name": "Brookings State Airport",
     "countryCode": "US",
     "iata": "BOK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Brookings"
  }, {
     "name": "Chhatrapati Shivaji International Airport",
     "countryCode": "IN",
     "iata": "BOM",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Mumbai"
  }, {
     "name": "Flamingo International Airport",
     "countryCode": "BQ",
     "iata": "BON",
     "eucustoms": false,
     "countryDK": "Caribien Holland",
     "cityDK": "Bonaire"
  }, {
     "name": "Bodo Airport",
     "countryCode": "NO",
     "iata": "BOO",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Bodø"
  }, {
     "name": "Bouar Airport",
     "countryCode": "CF",
     "iata": "BOP",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "Bouar"
  }, {
     "name": "Logan International Airport",
     "countryCode": "US",
     "iata": "BOS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Boston"
  }, {
     "name": "Bourges Airport",
     "countryCode": "FR",
     "iata": "BOU",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Bourges"
  }, {
     "name": "Bartow Airport",
     "countryCode": "US",
     "iata": "BOW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bartow"
  }, {
     "name": "Borroloola Airport",
     "countryCode": "AU",
     "iata": "BOX",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Borroloola"
  }, {
     "name": "Borgo Airport",
     "countryCode": "BF",
     "iata": "BOY",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Bobo Dioulasso"
  }, {
     "name": "Bozoum Airport",
     "countryCode": "CF",
     "iata": "BOZ",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "Bozoum"
  }, {
     "name": "Bamenda Airport",
     "countryCode": "CM",
     "iata": "BPC",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Bamenda"
  }, {
     "name": "Barra Do Garcas Airport",
     "countryCode": "BR",
     "iata": "BPG",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Barra Do Garcas"
  }, {
     "name": "Bislig Airport",
     "countryCode": "PH",
     "iata": "BPH",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Bislig"
  }, {
     "name": "Miley Memorial Field",
     "countryCode": "US",
     "iata": "BPI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Big Piney"
  }, {
     "name": "Sultan Aji Muhamad Sulaiman Airport",
     "countryCode": "ID",
     "iata": "BPN",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Balikpapan"
  }, {
     "name": "Porto Seguro Airport",
     "countryCode": "BR",
     "iata": "BPS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Porto Seguro"
  }, {
     "name": "Jefferson County Airport",
     "countryCode": "US",
     "iata": "BPT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Beaumont"
  }, {
     "name": "Besalampy Airport",
     "countryCode": "MG",
     "iata": "BPY",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Besalampy"
  }, {
     "name": "Dr. Juan C. Angara Airport",
     "countryCode": "PH",
     "iata": "BQA",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Baler"
  }, {
     "name": "Busselton Airport",
     "countryCode": "AU",
     "iata": "BQB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Busselton"
  }, {
     "name": "Bogorodskoye Airport",
     "countryCode": "RU",
     "iata": "BQG",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Bogorodskoye"
  }, {
     "name": "Biggin Hill Airport",
     "countryCode": "GB",
     "iata": "BQH",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "London"
  }, {
     "name": "Batagay Airport",
     "countryCode": "RU",
     "iata": "BQJ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Batagay"
  }, {
     "name": "Glynco Jetport",
     "countryCode": "US",
     "iata": "BQK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Brunswick"
  }, {
     "name": "Boulia Airport",
     "countryCode": "AU",
     "iata": "BQL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Boulia"
  }, {
     "name": "Rafael Hernandez Airport",
     "countryCode": "PR",
     "iata": "BQN",
     "eucustoms": false,
     "countryDK": "Puerto Rico",
     "cityDK": "Aguadilla"
  }, {
     "name": "Bouna Airport",
     "countryCode": "CI",
     "iata": "BQO",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Bouna"
  }, {
     "name": "Barra Airport",
     "countryCode": "BR",
     "iata": "BQQ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Barra"
  }, {
     "name": "Blagoveschensk Airport",
     "countryCode": "RU",
     "iata": "BQS",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Blagoveschensk"
  }, {
     "name": "Brest Airport",
     "countryCode": "BY",
     "iata": "BQT",
     "eucustoms": false,
     "countryDK": "Hviderusland",
     "cityDK": "Brest"
  }, {
     "name": "Balgo Hills Airport",
     "countryCode": "AU",
     "iata": "BQW",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Balgo Hills"
  }, {
     "name": "Barreiras Airport",
     "countryCode": "BR",
     "iata": "BRA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Barreiras"
  }, {
     "name": "Barreirinhas Airport",
     "countryCode": "BR",
     "iata": "BRB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Barreirinhas"
  }, {
     "name": "San Carlos de Bariloche International Airport",
     "countryCode": "AR",
     "iata": "BRC",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "San Carlos de Bariloche"
  }, {
     "name": "Crow Wing County Airport",
     "countryCode": "US",
     "iata": "BRD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Brainerd"
  }, {
     "name": "Bremen Airport",
     "countryCode": "DE",
     "iata": "BRE",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Bremen"
  }, {
     "name": "Palese Airport",
     "countryCode": "IT",
     "iata": "BRI",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Bari"
  }, {
     "name": "Bourke Airport",
     "countryCode": "AU",
     "iata": "BRK",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Bourke"
  }, {
     "name": "Burlington Airport",
     "countryCode": "US",
     "iata": "BRL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Burlington"
  }, {
     "name": "Barquisimeto Airport",
     "countryCode": "VE",
     "iata": "BRM",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Barquisimeto"
  }, {
     "name": "Bern Airport",
     "countryCode": "CH",
     "iata": "BRN",
     "eucustoms": false,
     "countryDK": "Schweiz",
     "cityDK": "Berne"
  }, {
     "name": "South Padre Island International Airport",
     "countryCode": "US",
     "iata": "BRO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Brownsville"
  }, {
     "name": "Turany Airport",
     "countryCode": "CZ",
     "iata": "BRQ",
     "eucustoms": false,
     "countryDK": "Tjekkiet",
     "cityDK": "Brno"
  }, {
     "name": "North Bay Airport",
     "countryCode": "GB",
     "iata": "BRR",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Barra"
  }, {
     "name": "Bristol Airport",
     "countryCode": "GB",
     "iata": "BRS",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Bristol"
  }, {
     "name": "Bathurst Island Airport",
     "countryCode": "AU",
     "iata": "BRT",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Bathurst Island"
  }, {
     "name": "Brussels Airport",
     "countryCode": "BE",
     "iata": "BRU",
     "eucustoms": true,
     "countryDK": "Belgien",
     "cityDK": "Bruxelles"
  }, {
     "name": "Bremerhaven Airport",
     "countryCode": "DE",
     "iata": "BRV",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Bremerhaven"
  }, {
     "name": "Wiley Post-Will Rogers Memorial Airport",
     "countryCode": "US",
     "iata": "BRW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Barrow"
  }, {
     "name": "Barahona Airport",
     "countryCode": "DO",
     "iata": "BRX",
     "eucustoms": false,
     "countryDK": "Dominikanske Republik",
     "cityDK": "Barahona"
  }, {
     "name": "Samuels Field",
     "countryCode": "US",
     "iata": "BRY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bardstown"
  }, {
     "name": "Bossaso Airport",
     "countryCode": "SO",
     "iata": "BSA",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Bossaso"
  }, {
     "name": "Brasilia International Airport",
     "countryCode": "BR",
     "iata": "BSB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Brasilia"
  }, {
     "name": "Bahia Solano Airport",
     "countryCode": "CO",
     "iata": "BSC",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Bahia Solano"
  }, {
     "name": "Baoshan Airport",
     "countryCode": "CN",
     "iata": "BSD",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Baoshan"
  }, {
     "name": "Bradshaw Army Air Field",
     "countryCode": "US",
     "iata": "BSF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pohakuloa"
  }, {
     "name": "Bata Airport",
     "countryCode": "GQ",
     "iata": "BSG",
     "eucustoms": false,
     "countryDK": "Ækvatorialguinea",
     "cityDK": "Bata"
  }, {
     "name": "Bairnsdale Airport",
     "countryCode": "AU",
     "iata": "BSJ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Bairnsdale"
  }, {
     "name": "Mohamed Khider Airport",
     "countryCode": "DZ",
     "iata": "BSK",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Biskra"
  }, {
     "name": "Bishe Kola Air Base",
     "countryCode": "IR",
     "iata": "BSM",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Amol"
  }, {
     "name": "Bossangoa Airport",
     "countryCode": "CF",
     "iata": "BSN",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "Bossangoa"
  }, {
     "name": "Basco Airport",
     "countryCode": "PH",
     "iata": "BSO",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Basco"
  }, {
     "name": "Basra International Airport",
     "countryCode": "IQ",
     "iata": "BSR",
     "eucustoms": false,
     "countryDK": "Irak",
     "cityDK": "Basra"
  }, {
     "name": "Balsas Airport",
     "countryCode": "BR",
     "iata": "BSS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Balsas"
  }, {
     "name": "Bost Airport",
     "countryCode": "AF",
     "iata": "BST",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Bost"
  }, {
     "name": "Basankusu Airport",
     "countryCode": "CD",
     "iata": "BSU",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Basankusu"
  }, {
     "name": "Pathein Airport",
     "countryCode": "MM",
     "iata": "BSX",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Pathein"
  }, {
     "name": "Bertoua Airport",
     "countryCode": "CM",
     "iata": "BTA",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Bertoua"
  }, {
     "name": "Betou Airport",
     "countryCode": "CG",
     "iata": "BTB",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Bétou"
  }, {
     "name": "Batticaloa Airport",
     "countryCode": "LK",
     "iata": "BTC",
     "eucustoms": false,
     "countryDK": "Sri Lanka",
     "cityDK": "Batticaloa"
  }, {
     "name": "Bonthe Airport",
     "countryCode": "SL",
     "iata": "BTE",
     "eucustoms": false,
     "countryDK": "Sierra Leone",
     "cityDK": "Bonthe"
  }, {
     "name": "Bountiful Skypark",
     "countryCode": "US",
     "iata": "BTF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bountiful"
  }, {
     "name": "Hang Nadim International Airport",
     "countryCode": "ID",
     "iata": "BTH",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Batam"
  }, {
     "name": "Barter Island Airport",
     "countryCode": "US",
     "iata": "BTI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Barter Island"
  }, {
     "name": "Sultan Iskandar Muda International Airport",
     "countryCode": "ID",
     "iata": "BTJ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Banda Aceh"
  }, {
     "name": "Bratsk Airport",
     "countryCode": "RU",
     "iata": "BTK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Bratsk"
  }, {
     "name": "WK Kellogg Regional Airport",
     "countryCode": "US",
     "iata": "BTL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Battle Creek"
  }, {
     "name": "Butte Airport",
     "countryCode": "US",
     "iata": "BTM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Butte"
  }, {
     "name": "Bennettsville Airport",
     "countryCode": "US",
     "iata": "BTN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bennettsville"
  }, {
     "name": "Graham Field",
     "countryCode": "US",
     "iata": "BTP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Butler"
  }, {
     "name": "Butare Airport",
     "countryCode": "RW",
     "iata": "BTQ",
     "eucustoms": false,
     "countryDK": "Rwanda",
     "cityDK": "Butare"
  }, {
     "name": "Baton Rouge Metropolitan Airport",
     "countryCode": "US",
     "iata": "BTR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Baton Rouge"
  }, {
     "name": "M.R. Stefanik Airport",
     "countryCode": "SK",
     "iata": "BTS",
     "eucustoms": false,
     "countryDK": "Slovakiet",
     "cityDK": "Bratislava"
  }, {
     "name": "Bettles Airport",
     "countryCode": "US",
     "iata": "BTT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bettles"
  }, {
     "name": "Bintulu Airport",
     "countryCode": "MY",
     "iata": "BTU",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Bintulu"
  }, {
     "name": "Burlington International Airport",
     "countryCode": "US",
     "iata": "BTV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Burlington"
  }, {
     "name": "Betoota Airport",
     "countryCode": "AU",
     "iata": "BTX",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Betoota"
  }, {
     "name": "Beatty Airport",
     "countryCode": "US",
     "iata": "BTY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Beatty"
  }, {
     "name": "Cram Field",
     "countryCode": "US",
     "iata": "BUB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Burwell"
  }, {
     "name": "Burketown Airport",
     "countryCode": "AU",
     "iata": "BUC",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Burketown"
  }, {
     "name": "Budapest Ferenc Liszt International Airport",
     "countryCode": "HU",
     "iata": "BUD",
     "eucustoms": false,
     "countryDK": "Ungarn",
     "cityDK": "Budapest"
  }, {
     "name": "Buffalo Niagara International Airport",
     "countryCode": "US",
     "iata": "BUF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bøffel"
  }, {
     "name": "17 de Setembro Airport",
     "countryCode": "AO",
     "iata": "BUG",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Benguela"
  }, {
     "name": "Ain Eddis Airport",
     "countryCode": "DZ",
     "iata": "BUJ",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Boussaada"
  }, {
     "name": "Albuq Airport",
     "countryCode": "YE",
     "iata": "BUK",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Albuq"
  }, {
     "name": "Butler Airport",
     "countryCode": "US",
     "iata": "BUM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Butler"
  }, {
     "name": "Buenaventura Airport",
     "countryCode": "CO",
     "iata": "BUN",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Buenaventura"
  }, {
     "name": "Burao Airport",
     "countryCode": "SO",
     "iata": "BUO",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Burco"
  }, {
     "name": "Bathinda Airport",
     "countryCode": "IN",
     "iata": "BUP",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Bathinda"
  }, {
     "name": "Bulawayo Airport",
     "countryCode": "ZW",
     "iata": "BUQ",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Bulawayo"
  }, {
     "name": "Bob Hope Airport",
     "countryCode": "US",
     "iata": "BUR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Burbank"
  }, {
     "name": "Bunia Airport",
     "countryCode": "CD",
     "iata": "BUX",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Bunia"
  }, {
     "name": "Bunbury Airport",
     "countryCode": "AU",
     "iata": "BUY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Bunbury"
  }, {
     "name": "Bushehr Airport",
     "countryCode": "IR",
     "iata": "BUZ",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Bushehr"
  }, {
     "name": "Beauvais-Tille Airport",
     "countryCode": "FR",
     "iata": "BVA",
     "eucustoms": true,
     "countryDK": "Frankrig",
     "cityDK": "Paris"
  }, {
     "name": "Boa Vista Airport",
     "countryCode": "BR",
     "iata": "BVB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Boa Vista"
  }, {
     "name": "Rabil Airport",
     "countryCode": "CV",
     "iata": "BVC",
     "eucustoms": false,
     "countryDK": "Kap Verde",
     "cityDK": "Boa Vista"
  }, {
     "name": "Laroche Airport",
     "countryCode": "FR",
     "iata": "BVE",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Brive-la-Gaillarde"
  }, {
     "name": "Berlevag Airport",
     "countryCode": "NO",
     "iata": "BVG",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Berlevag"
  }, {
     "name": "Vilhena Airport",
     "countryCode": "BR",
     "iata": "BVH",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Vilhena"
  }, {
     "name": "Birdsville Airport",
     "countryCode": "AU",
     "iata": "BVI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Birdsville"
  }, {
     "name": "Belmonte Airport",
     "countryCode": "BR",
     "iata": "BVM",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Belmonte"
  }, {
     "name": "Bartlesville Municipal Airport",
     "countryCode": "US",
     "iata": "BVO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bartlesville"
  }, {
     "name": "Breves Airport",
     "countryCode": "BR",
     "iata": "BVS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Breves"
  }, {
     "name": "Beluga Airport",
     "countryCode": "US",
     "iata": "BVU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Beluga"
  }, {
     "name": "Burevestnik Airport",
     "countryCode": "RU",
     "iata": "BVV",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Burevestnik"
  }, {
     "name": "Batesville Regional Airport",
     "countryCode": "US",
     "iata": "BVX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Batesville"
  }, {
     "name": "Beverly Municipal Airport",
     "countryCode": "US",
     "iata": "BVY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Beverly"
  }, {
     "name": "Bhairawa Airport",
     "countryCode": "NP",
     "iata": "BWA",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Bhairawa"
  }, {
     "name": "Barrow Island Airport",
     "countryCode": "AU",
     "iata": "BWB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Barrow Island"
  }, {
     "name": "Brawley Municipal Airport",
     "countryCode": "US",
     "iata": "BWC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Brawley"
  }, {
     "name": "Brownwood Regional Airport",
     "countryCode": "US",
     "iata": "BWD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Brownwood"
  }, {
     "name": "Braunschweig-Wolfsburg Airport",
     "countryCode": "DE",
     "iata": "BWE",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Braunschweig"
  }, {
     "name": "Walney Island Airport",
     "countryCode": "GB",
     "iata": "BWF",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Barrow-In-Furness"
  }, {
     "name": "Warren County Airport",
     "countryCode": "US",
     "iata": "BWG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bowling Green"
  }, {
     "name": "Butterworth Airport",
     "countryCode": "MY",
     "iata": "BWH",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Butterworth"
  }, {
     "name": "Baltimore/Wash International Thurgood Marshall Airport",
     "countryCode": "US",
     "iata": "BWI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Baltimore"
  }, {
     "name": "Bowman Airport",
     "countryCode": "US",
     "iata": "BWM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bowman"
  }, {
     "name": "Brunei International Airport",
     "countryCode": "BN",
     "iata": "BWN",
     "eucustoms": false,
     "countryDK": "Brunei Darussalam",
     "cityDK": "Bandar Seri Begawan"
  }, {
     "name": "Brewarrina Airport",
     "countryCode": "AU",
     "iata": "BWQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Brewarrina"
  }, {
     "name": "Burnie Wynyard Airport",
     "countryCode": "AU",
     "iata": "BWT",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Burnie"
  }, {
     "name": "George R. Carr Airport",
     "countryCode": "US",
     "iata": "BXA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bogalusa"
  }, {
     "name": "Babo Airport",
     "countryCode": "ID",
     "iata": "BXB",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Babo"
  }, {
     "name": "Bakel Airport",
     "countryCode": "SN",
     "iata": "BXE",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Bakel"
  }, {
     "name": "Bendigo Airport",
     "countryCode": "AU",
     "iata": "BXG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Bendigo"
  }, {
     "name": "Balhash Airport",
     "countryCode": "KZ",
     "iata": "BXH",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Balhash"
  }, {
     "name": "Boundiali Airport",
     "countryCode": "CI",
     "iata": "BXI",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Boundiali"
  }, {
     "name": "Buckeye Airport",
     "countryCode": "US",
     "iata": "BXK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Buckeye"
  }, {
     "name": "Imsik Airport",
     "countryCode": "TR",
     "iata": "BXN",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Bodrum"
  }, {
     "name": "Bam Airport",
     "countryCode": "IR",
     "iata": "BXR",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Bam"
  }, {
     "name": "Butuan Airport",
     "countryCode": "PH",
     "iata": "BXU",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Butuan"
  }, {
     "name": "Yacuiba Airport",
     "countryCode": "BO",
     "iata": "BYC",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Yacuiba"
  }, {
     "name": "Buffalo Municipal Airport",
     "countryCode": "US",
     "iata": "BYG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bøffel"
  }, {
     "name": "Arkansas International Airport",
     "countryCode": "US",
     "iata": "BYH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Blytheville"
  }, {
     "name": "Burley Municipal Airport",
     "countryCode": "US",
     "iata": "BYI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Burley"
  }, {
     "name": "Bouake Airport",
     "countryCode": "CI",
     "iata": "BYK",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Bouaké"
  }, {
     "name": "C.M. de Cespedes Airport",
     "countryCode": "CU",
     "iata": "BYM",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Bayamo"
  }, {
     "name": "Bayankhongor Airport",
     "countryCode": "MN",
     "iata": "BYN",
     "eucustoms": false,
     "countryDK": "Mongoliet",
     "cityDK": "Bayankhongor"
  }, {
     "name": "Barimunya Airport",
     "countryCode": "AU",
     "iata": "BYP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Barimunya"
  }, {
     "name": "Laeso Airport",
     "countryCode": "DK",
     "iata": "BYR",
     "eucustoms": false,
     "countryDK": "Danmark",
     "cityDK": "Laeso Island"
  }, {
     "name": "Bantry Airport",
     "countryCode": "IE",
     "iata": "BYT",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Bantry"
  }, {
     "name": "Bindlacher-Berg Airport",
     "countryCode": "DE",
     "iata": "BYU",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Bayreuth"
  }, {
     "name": "Balranald Airport",
     "countryCode": "AU",
     "iata": "BZD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Balranald"
  }, {
     "name": "Philip S.W. Goldson International Airport",
     "countryCode": "BZ",
     "iata": "BZE",
     "eucustoms": false,
     "countryDK": "Belize",
     "cityDK": "Belize City"
  }, {
     "name": "Ignacy Jan Paderewski Airport",
     "countryCode": "PL",
     "iata": "BZG",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Bydgoszcz"
  }, {
     "name": "Bumi Hills Airport",
     "countryCode": "ZW",
     "iata": "BZH",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Bumi Hills"
  }, {
     "name": "Balikesir Airport",
     "countryCode": "TR",
     "iata": "BZI",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Balikesir"
  }, {
     "name": "Bryansk International Airport",
     "countryCode": "RU",
     "iata": "BZK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Bryansk"
  }, {
     "name": "Barisal Airport",
     "countryCode": "BD",
     "iata": "BZL",
     "eucustoms": false,
     "countryDK": "Bangladesh",
     "cityDK": "Barisal"
  }, {
     "name": "Bozeman Yellowstone International Airport",
     "countryCode": "US",
     "iata": "BZN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Beograd"
  }, {
     "name": "Bolzano Airport",
     "countryCode": "IT",
     "iata": "BZO",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Bolzano"
  }, {
     "name": "Beziers Vias Airport",
     "countryCode": "FR",
     "iata": "BZR",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Beziers"
  }, {
     "name": "Buta Airport",
     "countryCode": "CD",
     "iata": "BZU",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "buta"
  }, {
     "name": "Maya Maya Airport",
     "countryCode": "CG",
     "iata": "BZV",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Brazzaville"
  }, {
     "name": "Balti International Airport",
     "countryCode": "MD",
     "iata": "BZY",
     "eucustoms": false,
     "countryDK": "Moldova",
     "cityDK": "Balti"
  }, {
     "name": "RAF Brize Norton",
     "countryCode": "GB",
     "iata": "BZZ",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Brize Norton"
  }, {
     "name": "Catacamas Airport",
     "countryCode": "HN",
     "iata": "CAA",
     "eucustoms": false,
     "countryDK": "Honduras",
     "cityDK": "Catacamas"
  }, {
     "name": "Cabinda Airport",
     "countryCode": "AO",
     "iata": "CAB",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Cabinda"
  }, {
     "name": "Cascavel Airport",
     "countryCode": "BR",
     "iata": "CAC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Cascavel"
  }, {
     "name": "Wexford County Airport",
     "countryCode": "US",
     "iata": "CAD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cadillac"
  }, {
     "name": "Columbia Metropolitan Airport",
     "countryCode": "US",
     "iata": "CAE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbia"
  }, {
     "name": "Carauari Airport",
     "countryCode": "BR",
     "iata": "CAF",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Carauari"
  }, {
     "name": "Cagliari Elmas Airport",
     "countryCode": "IT",
     "iata": "CAG",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Cagliari"
  }, {
     "name": "Cairo International Airport",
     "countryCode": "EG",
     "iata": "CAI",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Kairo"
  }, {
     "name": "Canaima Airport",
     "countryCode": "VE",
     "iata": "CAJ",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Canaima"
  }, {
     "name": "Akron-Canton Airport",
     "countryCode": "US",
     "iata": "CAK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Akron"
  }, {
     "name": "Machrihanish Airport",
     "countryCode": "GB",
     "iata": "CAL",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Campbeltown"
  }, {
     "name": "Camiri Airport",
     "countryCode": "BO",
     "iata": "CAM",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Camiri"
  }, {
     "name": "Guangzhou Baiyun International Airport",
     "countryCode": "CN",
     "iata": "CAN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Guangzhou"
  }, {
     "name": "Clayton Municipal Airpark",
     "countryCode": "US",
     "iata": "CAO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clayton"
  }, {
     "name": "Hugo Chavez International Airport",
     "countryCode": "HT",
     "iata": "CAP",
     "eucustoms": false,
     "countryDK": "Haiti",
     "cityDK": "Cap Haitien"
  }, {
     "name": "Juan H. White Airport",
     "countryCode": "CO",
     "iata": "CAQ",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Kaukasien"
  }, {
     "name": "Caribou Municipal Airport",
     "countryCode": "US",
     "iata": "CAR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Caribou"
  }, {
     "name": "Anfa Airport",
     "countryCode": "MA",
     "iata": "CAS",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Casablanca"
  }, {
     "name": "Cascais Municipal Aerodrome",
     "countryCode": "PT",
     "iata": "CAT",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Tires"
  }, {
     "name": "Caruaru Airport",
     "countryCode": "BR",
     "iata": "CAU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Caruaru"
  }, {
     "name": "Bartolomeu Lisandro Airport",
     "countryCode": "BR",
     "iata": "CAW",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Campos"
  }, {
     "name": "Carlisle Airport",
     "countryCode": "GB",
     "iata": "CAX",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Carlisle"
  }, {
     "name": "Felix Eboue Airport",
     "countryCode": "GF",
     "iata": "CAY",
     "eucustoms": false,
     "countryDK": "Fransk guyana",
     "cityDK": "Cayenne"
  }, {
     "name": "Cobar Airport",
     "countryCode": "AU",
     "iata": "CAZ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cobar"
  }, {
     "name": "J Wilsterman Airport",
     "countryCode": "BO",
     "iata": "CBB",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Cochabamba"
  }, {
     "name": "Car Nicobar Air Force Base",
     "countryCode": "IN",
     "iata": "CBD",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Bil Nicobar"
  }, {
     "name": "Wiley Ford Airport",
     "countryCode": "US",
     "iata": "CBE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cumberland"
  }, {
     "name": "Council Bluffs Municipal Airport",
     "countryCode": "US",
     "iata": "CBF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Council Bluffs"
  }, {
     "name": "Cambridge Airport",
     "countryCode": "GB",
     "iata": "CBG",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Cambridge"
  }, {
     "name": "Leger Airport",
     "countryCode": "DZ",
     "iata": "CBH",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Bechar"
  }, {
     "name": "Cabo Rojo Airport",
     "countryCode": "DO",
     "iata": "CBJ",
     "eucustoms": false,
     "countryDK": "Dominikanske Republik",
     "cityDK": "Cabo Rojo"
  }, {
     "name": "Colby Municipal Airport",
     "countryCode": "US",
     "iata": "CBK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Colby"
  }, {
     "name": "Tomas de Heres Airport",
     "countryCode": "VE",
     "iata": "CBL",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Ciudad Bolivar"
  }, {
     "name": "Columbus Air Force Base",
     "countryCode": "US",
     "iata": "CBM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbus"
  }, {
     "name": "Awang Airport",
     "countryCode": "PH",
     "iata": "CBO",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Cotabato"
  }, {
     "name": "Coimbra Airport",
     "countryCode": "PT",
     "iata": "CBP",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Coimbra"
  }, {
     "name": "Calabar Airport",
     "countryCode": "NG",
     "iata": "CBQ",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Calabar"
  }, {
     "name": "Canberra Airport",
     "countryCode": "AU",
     "iata": "CBR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Canberra"
  }, {
     "name": "Catumbela Airport",
     "countryCode": "AO",
     "iata": "CBT",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Catumbela"
  }, {
     "name": "Cottbus Airport",
     "countryCode": "DE",
     "iata": "CBU",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Cottbus"
  }, {
     "name": "Condobolin Airport",
     "countryCode": "AU",
     "iata": "CBX",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Condobolin"
  }, {
     "name": "Cable Airport",
     "countryCode": "US",
     "iata": "CCB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Upland"
  }, {
     "name": "Jardines del Rey Airport",
     "countryCode": "CU",
     "iata": "CCC",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Cayo Coco"
  }, {
     "name": "Carcassonne Airport",
     "countryCode": "FR",
     "iata": "CCF",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Carcassonne"
  }, {
     "name": "Chile Chico Airport",
     "countryCode": "CL",
     "iata": "CCH",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Chile Chico"
  }, {
     "name": "Concordia Airport",
     "countryCode": "BR",
     "iata": "CCI",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Concordia"
  }, {
     "name": "Calicut International Airport",
     "countryCode": "IN",
     "iata": "CCJ",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Kozhikode"
  }, {
     "name": "Cocos Islands Airport",
     "countryCode": "CC",
     "iata": "CCK",
     "eucustoms": false,
     "countryDK": "Cocosøerne",
     "cityDK": "Cocosøerne"
  }, {
     "name": "Chinchilla Airport",
     "countryCode": "AU",
     "iata": "CCL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Chinchilla"
  }, {
     "name": "Criciuma Airport",
     "countryCode": "BR",
     "iata": "CCM",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Criciuma"
  }, {
     "name": "Chaghcharan Airport",
     "countryCode": "AF",
     "iata": "CCN",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Chaghcharan"
  }, {
     "name": "Carriel Sur Airport",
     "countryCode": "CL",
     "iata": "CCP",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Concepcion"
  }, {
     "name": "Buchanan Field",
     "countryCode": "US",
     "iata": "CCR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Concord"
  }, {
     "name": "Simon Bolivar International Airport",
     "countryCode": "VE",
     "iata": "CCS",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Caracas"
  }, {
     "name": "Netaji Subhas Chandra Bose Airport",
     "countryCode": "IN",
     "iata": "CCU",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Kolkata"
  }, {
     "name": "Craig Cove Airport",
     "countryCode": "VU",
     "iata": "CCV",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Craig Cove"
  }, {
     "name": "Cowell Airport",
     "countryCode": "AU",
     "iata": "CCW",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cowell"
  }, {
     "name": "Caceres Airport",
     "countryCode": "BR",
     "iata": "CCX",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Caceres"
  }, {
     "name": "Charles City Municipal Airport",
     "countryCode": "US",
     "iata": "CCY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Charles City"
  }, {
     "name": "Chub Cay Airport",
     "countryCode": "BS",
     "iata": "CCZ",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Chub Cay"
  }, {
     "name": "Cooinda Airport",
     "countryCode": "AU",
     "iata": "CDA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cooinda"
  }, {
     "name": "Cold Bay Airport",
     "countryCode": "US",
     "iata": "CDB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cold Bay"
  }, {
     "name": "Cedar City Airport",
     "countryCode": "US",
     "iata": "CDC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cedar City"
  }, {
     "name": "Charles de Gaulle Airport",
     "countryCode": "FR",
     "iata": "CDG",
     "eucustoms": true,
     "countryDK": "Frankrig",
     "cityDK": "Paris"
  }, {
     "name": "Harrell Field",
     "countryCode": "US",
     "iata": "CDH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Camden"
  }, {
     "name": "Conceicao Do Araguaia Airport",
     "countryCode": "BR",
     "iata": "CDJ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Conceicao Do Araguaia"
  }, {
     "name": "Lewis Airport",
     "countryCode": "US",
     "iata": "CDK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cedar Key"
  }, {
     "name": "Woodward Field",
     "countryCode": "US",
     "iata": "CDN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Camden"
  }, {
     "name": "Kadapa Airport",
     "countryCode": "IN",
     "iata": "CDP",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Kadapa"
  }, {
     "name": "Croydon Airport",
     "countryCode": "AU",
     "iata": "CDQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Croydon"
  }, {
     "name": "Chadron Airport",
     "countryCode": "US",
     "iata": "CDR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chadron"
  }, {
     "name": "Childress Airport",
     "countryCode": "US",
     "iata": "CDS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Childress"
  }, {
     "name": "Castellon-Costa Azahar Airport",
     "countryCode": "ES",
     "iata": "CDT",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Benlloch"
  }, {
     "name": "Camden Airport",
     "countryCode": "AU",
     "iata": "CDU",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Camden"
  }, {
     "name": "Mudhole Smith Airport",
     "countryCode": "US",
     "iata": "CDV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cordova"
  }, {
     "name": "Essex County Airport",
     "countryCode": "US",
     "iata": "CDW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Caldwell"
  }, {
     "name": "Cagayan De Sulu Airport",
     "countryCode": "PH",
     "iata": "CDY",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Mapun"
  }, {
     "name": "Cessna Aircraft Field",
     "countryCode": "US",
     "iata": "CEA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wichita"
  }, {
     "name": "Mactan-Cebu International Airport",
     "countryCode": "PH",
     "iata": "CEB",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Cebu City"
  }, {
     "name": "Del Norte County Regional Airport",
     "countryCode": "US",
     "iata": "CEC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Crescent City"
  }, {
     "name": "Ceduna Airport",
     "countryCode": "AU",
     "iata": "CED",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ceduna"
  }, {
     "name": "Westover Metropolitan Airport",
     "countryCode": "US",
     "iata": "CEF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Springfield"
  }, {
     "name": "Hawarden Airport",
     "countryCode": "GB",
     "iata": "CEG",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Chester"
  }, {
     "name": "Chelinda Airport",
     "countryCode": "MW",
     "iata": "CEH",
     "eucustoms": false,
     "countryDK": "Malawi",
     "cityDK": "Chelinda"
  }, {
     "name": "Chiang Rai International Airport",
     "countryCode": "TH",
     "iata": "CEI",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Chiang Rai"
  }, {
     "name": "Chelyabinsk International Airport",
     "countryCode": "RU",
     "iata": "CEK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Chelyabinsk"
  }, {
     "name": "Ciudad Obregon Airport",
     "countryCode": "MX",
     "iata": "CEN",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Ciudad Obregon"
  }, {
     "name": "Wako Kungo Airport",
     "countryCode": "AO",
     "iata": "CEO",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Wako Kungo"
  }, {
     "name": "Concepcion Airport",
     "countryCode": "BO",
     "iata": "CEP",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Concepcion"
  }, {
     "name": "Mandelieu Airport",
     "countryCode": "FR",
     "iata": "CEQ",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Cannes"
  }, {
     "name": "Cherbourg-Maupertus Airport",
     "countryCode": "FR",
     "iata": "CER",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Cherbourg"
  }, {
     "name": "Cessnock Airport",
     "countryCode": "AU",
     "iata": "CES",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cessnock"
  }, {
     "name": "Le Pontreau Airport",
     "countryCode": "FR",
     "iata": "CET",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Cholet"
  }, {
     "name": "Conklin (Leismer) Airport",
     "countryCode": "CA",
     "iata": "CFM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Conklin"
  }, {
     "name": "Oconee County Regional Airport",
     "countryCode": "US",
     "iata": "CEU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clemson"
  }, {
     "name": "Mettle Field",
     "countryCode": "US",
     "iata": "CEV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Connersville"
  }, {
     "name": "Bob Sikes Airport",
     "countryCode": "US",
     "iata": "CEW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Crestview"
  }, {
     "name": "Calloway County Airport",
     "countryCode": "US",
     "iata": "CEY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Murray"
  }, {
     "name": "Montezuma County Airport",
     "countryCode": "US",
     "iata": "CEZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cortez"
  }, {
     "name": "Cabo Frio International Airport",
     "countryCode": "BR",
     "iata": "CFB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Cabo Frio"
  }, {
     "name": "Coulter Field",
     "countryCode": "US",
     "iata": "CFD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bryan"
  }, {
     "name": "Auvergne Airport",
     "countryCode": "FR",
     "iata": "CFE",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Clermont-Ferrand"
  }, {
     "name": "Jaime Gonzalez Airport",
     "countryCode": "CU",
     "iata": "CFG",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Cienfuegos"
  }, {
     "name": "Aboubakr Belkaid Airport",
     "countryCode": "DZ",
     "iata": "CFK",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Chlef"
  }, {
     "name": "Donegal Airport",
     "countryCode": "IE",
     "iata": "CFN",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Donegal"
  }, {
     "name": "Creston Airport",
     "countryCode": "CA",
     "iata": "CFQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Creston"
  }, {
     "name": "Carpiquet Airport",
     "countryCode": "FR",
     "iata": "CFR",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Caen"
  }, {
     "name": "Coffs Harbour Airport",
     "countryCode": "AU",
     "iata": "CFS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Coffs Harbour"
  }, {
     "name": "Morenci Airport",
     "countryCode": "US",
     "iata": "CFT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clifton"
  }, {
     "name": "Ioannis Kapodistrias Airport",
     "countryCode": "GR",
     "iata": "CFU",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Kerkyra"
  }, {
     "name": "Coffeyville Municipal Airport",
     "countryCode": "US",
     "iata": "CFV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Coffeyville"
  }, {
     "name": "Marechal Rondon International Airport",
     "countryCode": "BR",
     "iata": "CGB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Cuiaba"
  }, {
     "name": "Changde Airport",
     "countryCode": "CN",
     "iata": "CGD",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Changde"
  }, {
     "name": "Cambridge Airport",
     "countryCode": "US",
     "iata": "CGE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cambridge"
  }, {
     "name": "Cuyahoga County Airport",
     "countryCode": "US",
     "iata": "CGF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cleveland"
  }, {
     "name": "Sao Paulo/Congonhas Airport",
     "countryCode": "BR",
     "iata": "CGH",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Paulo"
  }, {
     "name": "Cape Girardeau Airport",
     "countryCode": "US",
     "iata": "CGI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cape Girardeau"
  }, {
     "name": "Soekarno-Hatta International Airport",
     "countryCode": "ID",
     "iata": "CGK",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Jakarta"
  }, {
     "name": "Camiguin Airport",
     "countryCode": "PH",
     "iata": "CGM",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Mambajao"
  }, {
     "name": "Cologne Bonn Airport",
     "countryCode": "DE",
     "iata": "CGN",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Köln"
  }, {
     "name": "Zhengzhou Xinzheng Airport",
     "countryCode": "CN",
     "iata": "CGO",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Zhengzhou"
  }, {
     "name": "Shah Amanat International Airport",
     "countryCode": "BD",
     "iata": "CGP",
     "eucustoms": false,
     "countryDK": "Bangladesh",
     "cityDK": "Chittagong"
  }, {
     "name": "Changchun Longjia International Airport",
     "countryCode": "CN",
     "iata": "CGQ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Changchun"
  }, {
     "name": "Campo Grande International Airport",
     "countryCode": "BR",
     "iata": "CGR",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Campo Grande"
  }, {
     "name": "College Park Airport",
     "countryCode": "US",
     "iata": "CGS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "College Park"
  }, {
     "name": "Casa Grande Municipal Airport",
     "countryCode": "US",
     "iata": "CGZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Casa Grande"
  }, {
     "name": "Chattanooga Airport",
     "countryCode": "US",
     "iata": "CHA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chattanooga"
  }, {
     "name": "Christchurch International Airport",
     "countryCode": "NZ",
     "iata": "CHC",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Christchurch"
  }, {
     "name": "Jinhae Airport",
     "countryCode": "KR",
     "iata": "CHF",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Jinhae"
  }, {
     "name": "Chachapoyas Airport",
     "countryCode": "PE",
     "iata": "CHH",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Chachapoyas"
  }, {
     "name": "Chipinge Airport",
     "countryCode": "ZW",
     "iata": "CHJ",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Chipinge"
  }, {
     "name": "Chickasha Municipal Airport",
     "countryCode": "US",
     "iata": "CHK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chickasha"
  }, {
     "name": "Challis Airport",
     "countryCode": "US",
     "iata": "CHL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Challis"
  }, {
     "name": "Chimbote Airport",
     "countryCode": "PE",
     "iata": "CHM",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Chimbote"
  }, {
     "name": "Charlottesville Albemarle Airport",
     "countryCode": "US",
     "iata": "CHO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Charlottesville"
  }, {
     "name": "Chania International Airport",
     "countryCode": "GR",
     "iata": "CHQ",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Chania"
  }, {
     "name": "Deols Airport",
     "countryCode": "FR",
     "iata": "CHR",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Chateauroux"
  }, {
     "name": "Charleston International Airport",
     "countryCode": "US",
     "iata": "CHS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Charleston"
  }, {
     "name": "Karewa Airport",
     "countryCode": "NZ",
     "iata": "CHT",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Chatham Island"
  }, {
     "name": "Chaves Airport",
     "countryCode": "PT",
     "iata": "CHV",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Chaves"
  }, {
     "name": "Changuinola Airport",
     "countryCode": "PA",
     "iata": "CHX",
     "eucustoms": false,
     "countryDK": "Panama",
     "cityDK": "Changuinola"
  }, {
     "name": "Ciampino-G. B. Pastine International Airport",
     "countryCode": "IT",
     "iata": "CIA",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Rom"
  }, {
     "name": "Chico Municipal Airport",
     "countryCode": "US",
     "iata": "CIC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chico"
  }, {
     "name": "The Eastern Iowa Airport",
     "countryCode": "US",
     "iata": "CID",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cedar Rapids"
  }, {
     "name": "Chifeng Airport",
     "countryCode": "CN",
     "iata": "CIF",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Chifeng"
  }, {
     "name": "Craig-Moffat Airport",
     "countryCode": "US",
     "iata": "CIG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Craig"
  }, {
     "name": "E. Beltram Airport",
     "countryCode": "BO",
     "iata": "CIJ",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Cobija"
  }, {
     "name": "Cimitarra Airport",
     "countryCode": "CO",
     "iata": "CIM",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Cimitarra"
  }, {
     "name": "Carroll Airport",
     "countryCode": "US",
     "iata": "CIN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Carroll"
  }, {
     "name": "Chipata Airport",
     "countryCode": "ZM",
     "iata": "CIP",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Chipata"
  }, {
     "name": "Cairo Airport",
     "countryCode": "US",
     "iata": "CIR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kairo"
  }, {
     "name": "Canton Island Airport",
     "countryCode": "KI",
     "iata": "CIS",
     "eucustoms": false,
     "countryDK": "Kiribati",
     "cityDK": "Canton Island"
  }, {
     "name": "Shymkent Airport",
     "countryCode": "KZ",
     "iata": "CIT",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Shymkent"
  }, {
     "name": "Chippewa County Airport",
     "countryCode": "US",
     "iata": "CIU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sault Ste. Marie"
  }, {
     "name": "Canouan Island Airport",
     "countryCode": "VC",
     "iata": "CIW",
     "eucustoms": false,
     "countryDK": "Saint Vincent og Grenadinerne",
     "cityDK": "Canouan Island"
  }, {
     "name": "Cornel Ruiz Airport",
     "countryCode": "PE",
     "iata": "CIX",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Chiclayo"
  }, {
     "name": "Comiso Airport",
     "countryCode": "IT",
     "iata": "CIY",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Comiso"
  }, {
     "name": "Coari Airport",
     "countryCode": "BR",
     "iata": "CIZ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Coari"
  }, {
     "name": "Cajamarca Airport",
     "countryCode": "PE",
     "iata": "CJA",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Cajamarca"
  }, {
     "name": "Coimbatore International Airport",
     "countryCode": "IN",
     "iata": "CJB",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Coimbatore"
  }, {
     "name": "El Loa Airport",
     "countryCode": "CL",
     "iata": "CJC",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Calama"
  }, {
     "name": "Coondewanna Airport",
     "countryCode": "AU",
     "iata": "CJF",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Coondewanna"
  }, {
     "name": "Cheongju Airport",
     "countryCode": "KR",
     "iata": "CJJ",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Cheongju"
  }, {
     "name": "Chitral Airport",
     "countryCode": "PK",
     "iata": "CJL",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Chitral"
  }, {
     "name": "Chumphon Airport",
     "countryCode": "TH",
     "iata": "CJM",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Chumphon"
  }, {
     "name": "Abraham Gonzalez International Airport",
     "countryCode": "MX",
     "iata": "CJS",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Ciudad Juarez"
  }, {
     "name": "Jeju International Airport",
     "countryCode": "KR",
     "iata": "CJU",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Jeju"
  }, {
     "name": "Kegelman Air Field",
     "countryCode": "US",
     "iata": "CKA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cherokee"
  }, {
     "name": "Benedum Airport",
     "countryCode": "US",
     "iata": "CKB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clarksburg"
  }, {
     "name": "Cherkassy Airport",
     "countryCode": "UA",
     "iata": "CKC",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Cherkassy"
  }, {
     "name": "Chongqing Jiangbei International Airport",
     "countryCode": "CN",
     "iata": "CKG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Chongqing"
  }, {
     "name": "Croker Island Airport",
     "countryCode": "AU",
     "iata": "CKI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Croker Island"
  }, {
     "name": "Fletcher Field",
     "countryCode": "US",
     "iata": "CKM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clarksdale"
  }, {
     "name": "Crookston Municipal Airport",
     "countryCode": "US",
     "iata": "CKN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Crookston"
  }, {
     "name": "Cornelio Procopio Airport",
     "countryCode": "BR",
     "iata": "CKO",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Cornelio Procopio"
  }, {
     "name": "Carajas Airport",
     "countryCode": "BR",
     "iata": "CKS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Carajas"
  }, {
     "name": "Outlaw Field",
     "countryCode": "US",
     "iata": "CKV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clarksville"
  }, {
     "name": "Conakry Airport",
     "countryCode": "GN",
     "iata": "CKY",
     "eucustoms": false,
     "countryDK": "Guinea",
     "cityDK": "Conakry"
  }, {
     "name": "Canakkale Airport",
     "countryCode": "TR",
     "iata": "CKZ",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Canakkale"
  }, {
     "name": "Comilla Airport",
     "countryCode": "BD",
     "iata": "CLA",
     "eucustoms": false,
     "countryDK": "Bangladesh",
     "cityDK": "Comilla"
  }, {
     "name": "McClellan-Palomar Airport",
     "countryCode": "US",
     "iata": "CLD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Carlsbad"
  }, {
     "name": "Cleveland Hopkins International Airport",
     "countryCode": "US",
     "iata": "CLE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cleveland"
  }, {
     "name": "Coolah Airport",
     "countryCode": "AU",
     "iata": "CLH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Coolah"
  }, {
     "name": "Clintonville Airport",
     "countryCode": "US",
     "iata": "CLI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clintonville"
  }, {
     "name": "Cluj-Napoca International Airport",
     "countryCode": "RO",
     "iata": "CLJ",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Cluj-Napoca"
  }, {
     "name": "Clinton Regional Airport",
     "countryCode": "US",
     "iata": "CLK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clinton"
  }, {
     "name": "Easterwood Airport",
     "countryCode": "US",
     "iata": "CLL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "College Station"
  }, {
     "name": "William R. Fairchild International Airport",
     "countryCode": "US",
     "iata": "CLM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Port Angeles"
  }, {
     "name": "Carolina Airport",
     "countryCode": "BR",
     "iata": "CLN",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Carolina"
  }, {
     "name": "Alfonso B. Aragon Airport",
     "countryCode": "CO",
     "iata": "CLO",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Cali"
  }, {
     "name": "Miguel de la Madrid Airport",
     "countryCode": "MX",
     "iata": "CLQ",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Colima"
  }, {
     "name": "Cliff Hatfield Memorial Airport",
     "countryCode": "US",
     "iata": "CLR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Calipatria"
  }, {
     "name": "Centralia Airport",
     "countryCode": "US",
     "iata": "CLS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chehalis"
  }, {
     "name": "Charlotte Douglas International Airport",
     "countryCode": "US",
     "iata": "CLT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Charlotte"
  }, {
     "name": "Columbus Municipal Airport",
     "countryCode": "US",
     "iata": "CLU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbus"
  }, {
     "name": "Nelson R. Guimaraes Airport",
     "countryCode": "BR",
     "iata": "CLV",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Caldas Novas"
  }, {
     "name": "Clearwater Air Park",
     "countryCode": "US",
     "iata": "CLW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tampa"
  }, {
     "name": "Clorinda Airport",
     "countryCode": "AR",
     "iata": "CLX",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Clorinda"
  }, {
     "name": "Sainte Catherine Airport",
     "countryCode": "FR",
     "iata": "CLY",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Calvi"
  }, {
     "name": "Calabozo Airport",
     "countryCode": "VE",
     "iata": "CLZ",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Calabozo"
  }, {
     "name": "Cunnamulla Airport",
     "countryCode": "AU",
     "iata": "CMA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cunnamulla"
  }, {
     "name": "Bandaranaike International Airport",
     "countryCode": "LK",
     "iata": "CMB",
     "eucustoms": false,
     "countryDK": "Sri Lanka",
     "cityDK": "Colombo"
  }, {
     "name": "Cootamundra Airport",
     "countryCode": "AU",
     "iata": "CMD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cootamundra"
  }, {
     "name": "Ciudad Del Carmen Airport",
     "countryCode": "MX",
     "iata": "CME",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Ciudad Del Carmen"
  }, {
     "name": "Chambery Airport",
     "countryCode": "FR",
     "iata": "CMF",
     "eucustoms": true,
     "countryDK": "Frankrig",
     "cityDK": "Chambery"
  }, {
     "name": "Corumba Internacional Airport",
     "countryCode": "BR",
     "iata": "CMG",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Corumba"
  }, {
     "name": "John Glenn Columbus International Airport",
     "countryCode": "US",
     "iata": "CMH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbus"
  }, {
     "name": "University of Illinois Willard Airport",
     "countryCode": "US",
     "iata": "CMI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Champaign"
  }, {
     "name": "Club Makokola Airport",
     "countryCode": "MW",
     "iata": "CMK",
     "eucustoms": false,
     "countryDK": "Malawi",
     "cityDK": "Club Makokola"
  }, {
     "name": "Mohamed V International Airport",
     "countryCode": "MA",
     "iata": "CMN",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Casablanca"
  }, {
     "name": "Obbia Airport",
     "countryCode": "SO",
     "iata": "CMO",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Obbia"
  }, {
     "name": "Santana do Araguaia Airport",
     "countryCode": "BR",
     "iata": "CMP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Santana do Araguaia"
  }, {
     "name": "Clermont Airport",
     "countryCode": "AU",
     "iata": "CMQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Clermont"
  }, {
     "name": "Colmar-Houssen Airport",
     "countryCode": "FR",
     "iata": "CMR",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Colmar"
  }, {
     "name": "Scusciuban Airport",
     "countryCode": "SO",
     "iata": "CMS",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Scusciuban"
  }, {
     "name": "Coromandel Airport",
     "countryCode": "NZ",
     "iata": "CMV",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Coromandel"
  }, {
     "name": "Ign Agramonte International Airport",
     "countryCode": "CU",
     "iata": "CMW",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Camaguey"
  }, {
     "name": "Houghton County Airport",
     "countryCode": "US",
     "iata": "CMX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hancock"
  }, {
     "name": "Fort McCoy Army Air Field",
     "countryCode": "US",
     "iata": "CMY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sparta"
  }, {
     "name": "Cananea Airport",
     "countryCode": "MX",
     "iata": "CNA",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Cananea"
  }, {
     "name": "Coonamble Airport",
     "countryCode": "AU",
     "iata": "CNB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Coonamble"
  }, {
     "name": "Coconut Island Airport",
     "countryCode": "AU",
     "iata": "CNC",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Coconut Island"
  }, {
     "name": "Kogalniceanu Airport",
     "countryCode": "RO",
     "iata": "CND",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Constanta"
  }, {
     "name": "Tancredo Neves International Airport",
     "countryCode": "BR",
     "iata": "CNF",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Belo Horizonte"
  }, {
     "name": "Chateaubernard Airport",
     "countryCode": "FR",
     "iata": "CNG",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "cognac"
  }, {
     "name": "Claremont Municipal Airport",
     "countryCode": "US",
     "iata": "CNH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Claremont"
  }, {
     "name": "Cloncurry Airport",
     "countryCode": "AU",
     "iata": "CNJ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cloncurry"
  }, {
     "name": "Blosser Municipal Airport",
     "countryCode": "US",
     "iata": "CNK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Concordia"
  }, {
     "name": "Sindal Airport",
     "countryCode": "DK",
     "iata": "CNL",
     "eucustoms": false,
     "countryDK": "Danmark",
     "cityDK": "Sindal"
  }, {
     "name": "Cavern City Air Terminal",
     "countryCode": "US",
     "iata": "CNM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Carlsbad"
  }, {
     "name": "Chino Airport",
     "countryCode": "US",
     "iata": "CNO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chino"
  }, {
     "name": "Neerlerit Inaat Airport",
     "countryCode": "GL",
     "iata": "CNP",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Neerlerit Inaat"
  }, {
     "name": "Camba Punta Airport",
     "countryCode": "AR",
     "iata": "CNQ",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Corrientes"
  }, {
     "name": "Chanaral Airport",
     "countryCode": "CL",
     "iata": "CNR",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Chanaral"
  }, {
     "name": "Cairns Airport",
     "countryCode": "AU",
     "iata": "CNS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cairns"
  }, {
     "name": "Martin Johnson Airport",
     "countryCode": "US",
     "iata": "CNU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chanute"
  }, {
     "name": "TSTC Waco Airport",
     "countryCode": "US",
     "iata": "CNW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Waco"
  }, {
     "name": "Chiang Mai International Airport",
     "countryCode": "TH",
     "iata": "CNX",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Chiang Mai"
  }, {
     "name": "Canyonlands Field",
     "countryCode": "US",
     "iata": "CNY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Moab"
  }, {
     "name": "Comodoro Pierrestegui Airport",
     "countryCode": "AR",
     "iata": "COC",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Concordia"
  }, {
     "name": "Yellowstone Regional Airport",
     "countryCode": "US",
     "iata": "COD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cody"
  }, {
     "name": "Pappy Boyington Field",
     "countryCode": "US",
     "iata": "COE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Coeur D'Alene"
  }, {
     "name": "Patrick Air Force Base",
     "countryCode": "US",
     "iata": "COF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kakao"
  }, {
     "name": "Mandinga Airport",
     "countryCode": "CO",
     "iata": "COG",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Condoto"
  }, {
     "name": "Cooch Behar Airport",
     "countryCode": "IN",
     "iata": "COH",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Cooch Behar"
  }, {
     "name": "Merritt Island Airport",
     "countryCode": "US",
     "iata": "COI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kakao"
  }, {
     "name": "Coonabarabran Airport",
     "countryCode": "AU",
     "iata": "COJ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Coonabarabran"
  }, {
     "name": "Cochin International Airport",
     "countryCode": "IN",
     "iata": "COK",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Kochi"
  }, {
     "name": "Coleman Airport",
     "countryCode": "US",
     "iata": "COM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Coleman"
  }, {
     "name": "Concord Municipal Airport",
     "countryCode": "US",
     "iata": "CON",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Concord"
  }, {
     "name": "Cotonou Airport",
     "countryCode": "BJ",
     "iata": "COO",
     "eucustoms": false,
     "countryDK": "Benin",
     "cityDK": "Cotonou"
  }, {
     "name": "Choibalsan Airport",
     "countryCode": "MN",
     "iata": "COQ",
     "eucustoms": false,
     "countryDK": "Mongoliet",
     "cityDK": "Choibalsan"
  }, {
     "name": "Ingeniero Aeronautico Ambrosio L.V. Taravella International Airport",
     "countryCode": "AR",
     "iata": "COR",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Cordoba"
  }, {
     "name": "Colorado Springs Municipal Airport",
     "countryCode": "US",
     "iata": "COS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Colorado Springs"
  }, {
     "name": "Cotulla Airport",
     "countryCode": "US",
     "iata": "COT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cotulla"
  }, {
     "name": "Columbia Regional Airport",
     "countryCode": "US",
     "iata": "COU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbia"
  }, {
     "name": "Covilha Airport",
     "countryCode": "PT",
     "iata": "COV",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Covilha"
  }, {
     "name": "Constanza Airport",
     "countryCode": "DO",
     "iata": "COZ",
     "eucustoms": false,
     "countryDK": "Dominikanske Republik",
     "cityDK": "Constanza"
  }, {
     "name": "A. Tubman Airport",
     "countryCode": "LR",
     "iata": "CPA",
     "eucustoms": false,
     "countryDK": "Liberia",
     "cityDK": "Cape Palmas"
  }, {
     "name": "Aviador Carlos Campos Airport",
     "countryCode": "AR",
     "iata": "CPC",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "San Martin De Los Andes"
  }, {
     "name": "Coober Pedy Airport",
     "countryCode": "AU",
     "iata": "CPD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Coober Pedy"
  }, {
     "name": "Campeche International Airport",
     "countryCode": "MX",
     "iata": "CPE",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Campeche"
  }, /* {
     "name": "Copenhagen Airport",
     "countryCode": "DK",
     "iata": "CPH",
     "eucustoms": true,
     "countryDK": "Danmark",
     "cityDK": "København"
  },*/ {
     "name": "Chaparral Airport",
     "countryCode": "CO",
     "iata": "CPL",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Chaparral"
  }, {
     "name": "Compton Airport",
     "countryCode": "US",
     "iata": "CPM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Compton"
  }, {
     "name": "Chamonate Airport",
     "countryCode": "CL",
     "iata": "CPO",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Copiapo"
  }, {
     "name": "Amarais Airport",
     "countryCode": "BR",
     "iata": "CPQ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Campinas"
  }, {
     "name": "Casper/Natrona County International Airport",
     "countryCode": "US",
     "iata": "CPR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Casper"
  }, {
     "name": "St. Louis Downtown Airport",
     "countryCode": "US",
     "iata": "CPS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saint Louis"
  }, {
     "name": "Cape Town International Airport",
     "countryCode": "ZA",
     "iata": "CPT",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Cape Town"
  }, {
     "name": "Joao Suassuna Airport",
     "countryCode": "BR",
     "iata": "CPV",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Campina Grande"
  }, {
     "name": "Benjamin Rivera Noriega Airport",
     "countryCode": "PR",
     "iata": "CPX",
     "eucustoms": false,
     "countryDK": "Puerto Rico",
     "cityDK": "Culebra"
  }, {
     "name": "Canarana Airport",
     "countryCode": "BR",
     "iata": "CQA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Canarana"
  }, {
     "name": "Calais Airport",
     "countryCode": "FR",
     "iata": "CQF",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Calais"
  }, {
     "name": "Costa Marques Airport",
     "countryCode": "BR",
     "iata": "CQS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Costa Marques"
  }, {
     "name": "Craiova Airport",
     "countryCode": "RO",
     "iata": "CRA",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Craiova"
  }, {
     "name": "Collarenebri Airport",
     "countryCode": "AU",
     "iata": "CRB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Collarenebri"
  }, {
     "name": "Santa Ana Airport",
     "countryCode": "CO",
     "iata": "CRC",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Cartago"
  }, {
     "name": "General E. Mosconi International Airport",
     "countryCode": "AR",
     "iata": "CRD",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Comodoro Rivadavia"
  }, {
     "name": "Grand Strand Airport",
     "countryCode": "US",
     "iata": "CRE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Myrtle Beach"
  }, {
     "name": "Jacksonville Executive at Craig Airport",
     "countryCode": "US",
     "iata": "CRG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jacksonville"
  }, {
     "name": "Crooked Island Airport",
     "countryCode": "BS",
     "iata": "CRI",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Crooked Island"
  }, {
     "name": "Clark International Airport",
     "countryCode": "PH",
     "iata": "CRK",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Angeles"
  }, {
     "name": "Brussels S. Charleroi Airport",
     "countryCode": "BE",
     "iata": "CRL",
     "eucustoms": false,
     "countryDK": "Belgien",
     "cityDK": "Bruxelles"
  }, {
     "name": "Catarman National Airport",
     "countryCode": "PH",
     "iata": "CRM",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Catarman"
  }, {
     "name": "Corcoran Airport",
     "countryCode": "US",
     "iata": "CRO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Corcoran"
  }, {
     "name": "Corpus Christi International Airport",
     "countryCode": "US",
     "iata": "CRP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jesu legeme"
  }, {
     "name": "Caravelas Airport",
     "countryCode": "BR",
     "iata": "CRQ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Caravelas"
  }, {
     "name": "Ceres Airport",
     "countryCode": "AR",
     "iata": "CRR",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Ceres"
  }, {
     "name": "C. David Campbell Field",
     "countryCode": "US",
     "iata": "CRS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Corsicana"
  }, {
     "name": "Z.M. Jack Stell Field",
     "countryCode": "US",
     "iata": "CRT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Crossett"
  }, {
     "name": "Crotone Airport",
     "countryCode": "IT",
     "iata": "CRV",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Crotone"
  }, {
     "name": "Yeager Airport",
     "countryCode": "US",
     "iata": "CRW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Charleston"
  }, {
     "name": "Roscoe Turner Airport",
     "countryCode": "US",
     "iata": "CRX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Korinth"
  }, {
     "name": "Turkmenabat Airport",
     "countryCode": "TM",
     "iata": "CRZ",
     "eucustoms": false,
     "countryDK": "Turkmenistan",
     "cityDK": "Chardzhev"
  }, {
     "name": "Caransebes Airport",
     "countryCode": "RO",
     "iata": "CSB",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "caransebes"
  }, {
     "name": "Creil Airport",
     "countryCode": "FR",
     "iata": "CSF",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Creil"
  }, {
     "name": "Columbus Airport",
     "countryCode": "US",
     "iata": "CSG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbus"
  }, {
     "name": "Solovky Airport",
     "countryCode": "RU",
     "iata": "CSH",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Solovetsky"
  }, {
     "name": "Casino Airport",
     "countryCode": "AU",
     "iata": "CSI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kasino"
  }, {
     "name": "Cap Skirring Airport",
     "countryCode": "SN",
     "iata": "CSK",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Cap Skirring"
  }, {
     "name": "Cabo San Lucas International Airport",
     "countryCode": "MX",
     "iata": "CSL",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Cabo San Lucas"
  }, {
     "name": "Sherman Airport",
     "countryCode": "US",
     "iata": "CSM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clinton"
  }, {
     "name": "Carson City Airport",
     "countryCode": "US",
     "iata": "CSN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Carson City"
  }, {
     "name": "Creston Municipal Airport",
     "countryCode": "US",
     "iata": "CSQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Creston"
  }, {
     "name": "Castaway Island Sea Plane Base",
     "countryCode": "FJ",
     "iata": "CST",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Castaway"
  }, {
     "name": "Santa Cruz Do Sul Airport",
     "countryCode": "BR",
     "iata": "CSU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Santa Cruz Do Sul"
  }, {
     "name": "Memorial-Whitson Field",
     "countryCode": "US",
     "iata": "CSV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Crossville"
  }, {
     "name": "Changsha Huanghua Airport",
     "countryCode": "CN",
     "iata": "CSX",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Changsha"
  }, {
     "name": "Cheboksary Airport",
     "countryCode": "RU",
     "iata": "CSY",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Cheboksary"
  }, {
     "name": "Brigadier Hector Ruiz",
     "countryCode": "AR",
     "iata": "CSZ",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Coronel Suarez"
  }, {
     "name": "Catania-Fontanarossa Airport",
     "countryCode": "IT",
     "iata": "CTA",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Catania"
  }, {
     "name": "Cut Bank Municipal Airport",
     "countryCode": "US",
     "iata": "CTB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cut Bank"
  }, {
     "name": "Catamarca Airport",
     "countryCode": "AR",
     "iata": "CTC",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Catamarca"
  }, {
     "name": "Chitre Alonso Valderrama Airport",
     "countryCode": "PA",
     "iata": "CTD",
     "eucustoms": false,
     "countryDK": "Panama",
     "cityDK": "Chitre"
  }, {
     "name": "Rafael Nunez International Airport",
     "countryCode": "CO",
     "iata": "CTG",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Cartagena"
  }, {
     "name": "Chester County  G. O. Carlson Airport",
     "countryCode": "US",
     "iata": "CTH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Coatesville"
  }, {
     "name": "Charleville Airport",
     "countryCode": "AU",
     "iata": "CTL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Charleville"
  }, {
     "name": "Chetumal Airport",
     "countryCode": "MX",
     "iata": "CTM",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Chetumal"
  }, {
     "name": "Cooktown Airport",
     "countryCode": "AU",
     "iata": "CTN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cooktown"
  }, {
     "name": "Carutapera Airport",
     "countryCode": "BR",
     "iata": "CTP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Carutapera"
  }, {
     "name": "New Chitose Airport",
     "countryCode": "JP",
     "iata": "CTS",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Sapporo"
  }, {
     "name": "Le Castellet Airport",
     "countryCode": "FR",
     "iata": "CTT",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Le Castellet"
  }, {
     "name": "Chengdu Shuangliu International Airport",
     "countryCode": "CN",
     "iata": "CTU",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Chengdu"
  }, {
     "name": "Cross City Airport",
     "countryCode": "US",
     "iata": "CTY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cross City"
  }, {
     "name": "Sampson County Airport",
     "countryCode": "US",
     "iata": "CTZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clinton"
  }, {
     "name": "Ciudad Constitucion Airport",
     "countryCode": "MX",
     "iata": "CUA",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Ciudad Constitucion"
  }, {
     "name": "J. Hamilton-L.B. Owens Airport",
     "countryCode": "US",
     "iata": "CUB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbia"
  }, {
     "name": "Camilo Daza International Airport",
     "countryCode": "CO",
     "iata": "CUC",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Cucuta"
  }, {
     "name": "Caloundra Airport",
     "countryCode": "AU",
     "iata": "CUD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Caloundra"
  }, {
     "name": "Mariscal Lamar International Airport",
     "countryCode": "EC",
     "iata": "CUE",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Cuenca"
  }, {
     "name": "Levaldigi Airport",
     "countryCode": "IT",
     "iata": "CUF",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Cuneo"
  }, {
     "name": "Cushing Municipal Airport",
     "countryCode": "US",
     "iata": "CUH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cushing"
  }, {
     "name": "Culiacan International Airport",
     "countryCode": "MX",
     "iata": "CUL",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Culiacan"
  }, {
     "name": "Antonio Jose de Sucre Airport",
     "countryCode": "VE",
     "iata": "CUM",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Cumana"
  }, {
     "name": "Cancun International Airport",
     "countryCode": "MX",
     "iata": "CUN",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Cancun"
  }, {
     "name": "Caruru Airport",
     "countryCode": "CO",
     "iata": "CUO",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Caruru"
  }, {
     "name": "Carupano Airport",
     "countryCode": "VE",
     "iata": "CUP",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Carupano"
  }, {
     "name": "Coen Airport",
     "countryCode": "AU",
     "iata": "CUQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Coen"
  }, {
     "name": "Hato International Airport",
     "countryCode": "CW",
     "iata": "CUR",
     "eucustoms": false,
     "countryDK": "Curaçao",
     "cityDK": "Curacao"
  }, {
     "name": "Cutral Airport",
     "countryCode": "AR",
     "iata": "CUT",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "cutral"
  }, {
     "name": "Gen Fierro Villalobos Airport",
     "countryCode": "MX",
     "iata": "CUU",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Chihuahua"
  }, {
     "name": "Cue Airport",
     "countryCode": "AU",
     "iata": "CUY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cue"
  }, {
     "name": "Alejandro Velasco Astete International Airport",
     "countryCode": "PE",
     "iata": "CUZ",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Cuzco"
  }, {
     "name": "Cleve Airport",
     "countryCode": "AU",
     "iata": "CVC",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cleve"
  }, {
     "name": "Covenas Airport",
     "countryCode": "CO",
     "iata": "CVE",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Covenas"
  }, {
     "name": "Courchevel Airport",
     "countryCode": "FR",
     "iata": "CVF",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Courchevel"
  }, {
     "name": "Cincinnati/Northern Kentucky Airport",
     "countryCode": "US",
     "iata": "CVG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cincinnati"
  }, {
     "name": "General Mariano Matamoros Airport",
     "countryCode": "MX",
     "iata": "CVJ",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Cuernavaca"
  }, {
     "name": "Ciudad Victoria Airport",
     "countryCode": "MX",
     "iata": "CVM",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Ciudad Victoria"
  }, {
     "name": "Clovis Municipal Airport",
     "countryCode": "US",
     "iata": "CVN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clovis"
  }, {
     "name": "Corvallis Municipal Airport",
     "countryCode": "US",
     "iata": "CVO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Corvallis"
  }, {
     "name": "Carnarvon Airport",
     "countryCode": "AU",
     "iata": "CVQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Carnarvon"
  }, {
     "name": "Cannon Air Force Base",
     "countryCode": "US",
     "iata": "CVS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clovis"
  }, {
     "name": "Coventry Airport",
     "countryCode": "GB",
     "iata": "CVT",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Coventry"
  }, {
     "name": "Corvo Island (Azores) Airport",
     "countryCode": "PT",
     "iata": "CVU",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Corvo Island (Azorerne)"
  }, {
     "name": "Central Wisconsin Airport",
     "countryCode": "US",
     "iata": "CWA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wausau"
  }, {
     "name": "Afonso Pena International Airport",
     "countryCode": "BR",
     "iata": "CWB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Curitiba"
  }, {
     "name": "Chernivtsi International Airport",
     "countryCode": "UA",
     "iata": "CWC",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Chernivtsi"
  }, {
     "name": "Clinton Airport",
     "countryCode": "US",
     "iata": "CWI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clinton"
  }, {
     "name": "Cardiff Airport",
     "countryCode": "GB",
     "iata": "CWL",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Cardiff"
  }, {
     "name": "Cowra Airport",
     "countryCode": "AU",
     "iata": "CWT",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cowra"
  }, {
     "name": "Corowa Airport",
     "countryCode": "AU",
     "iata": "CWW",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Corowa"
  }, {
     "name": "Coxs Bazar Airport",
     "countryCode": "BD",
     "iata": "CXB",
     "eucustoms": false,
     "countryDK": "Bangladesh",
     "cityDK": "Coxs Bazar"
  }, {
     "name": "Vancouver Harbour Sea Plane Base",
     "countryCode": "CA",
     "iata": "CXH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Vancouver"
  }, {
     "name": "Christmas Island Airport",
     "countryCode": "KI",
     "iata": "CXI",
     "eucustoms": false,
     "countryDK": "Kiribati",
     "cityDK": "Juleøen"
  }, {
     "name": "Hugo Cantergiani Regional Airport",
     "countryCode": "BR",
     "iata": "CXJ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Caxias do Sul"
  }, {
     "name": "Calexico International Airport",
     "countryCode": "US",
     "iata": "CXL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Calexico"
  }, {
     "name": "Candala Airport",
     "countryCode": "SO",
     "iata": "CXN",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Candala"
  }, {
     "name": "Lone Star Executive Airport",
     "countryCode": "US",
     "iata": "CXO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Conroe"
  }, {
     "name": "Tunggul Wulung Airport",
     "countryCode": "ID",
     "iata": "CXP",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Cilacap"
  }, {
     "name": "Cam Ranh International Airport",
     "countryCode": "VN",
     "iata": "CXR",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Nha Trang"
  }, {
     "name": "Charters Towers Airport",
     "countryCode": "AU",
     "iata": "CXT",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Charters Towers"
  }, {
     "name": "Charles Kirkconnel International Airport",
     "countryCode": "KY",
     "iata": "CYB",
     "eucustoms": false,
     "countryDK": "Caymanøerne",
     "cityDK": "Cayman Brac Island"
  }, {
     "name": "Chefornak Sea Plane Base",
     "countryCode": "US",
     "iata": "CYF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chefornak"
  }, {
     "name": "Corryong Airport",
     "countryCode": "AU",
     "iata": "CYG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Corryong"
  }, {
     "name": "Chiayi Airport",
     "countryCode": "TW",
     "iata": "CYI",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Chiayi"
  }, {
     "name": "Cayo Largo Del Sur Airport",
     "countryCode": "CU",
     "iata": "CYO",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Cayo Largo Del Sur"
  }, {
     "name": "Calbayog Airport",
     "countryCode": "PH",
     "iata": "CYP",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Calbayog"
  }, {
     "name": "Laguna de los Patos International Airport",
     "countryCode": "UY",
     "iata": "CYR",
     "eucustoms": false,
     "countryDK": "Uruguay",
     "cityDK": "Colonia del Sacramento"
  }, {
     "name": "Cheyenne Regional Airport",
     "countryCode": "US",
     "iata": "CYS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cheyenne"
  }, {
     "name": "Yakataga Intermediate Airport",
     "countryCode": "US",
     "iata": "CYT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Yakataga"
  }, {
     "name": "Cauayan Airport",
     "countryCode": "PH",
     "iata": "CYZ",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Cauayan"
  }, {
     "name": "Coro Airport",
     "countryCode": "VE",
     "iata": "CZE",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Coro"
  }, {
     "name": "Cape Romanzof Airport",
     "countryCode": "US",
     "iata": "CZF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kap Romanzof"
  }, {
     "name": "Cascade Locks State Airport",
     "countryCode": "US",
     "iata": "CZK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cascade Locks"
  }, {
     "name": "Ain El Bey Airport",
     "countryCode": "DZ",
     "iata": "CZL",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Konstantin"
  }, {
     "name": "Cozumel Airport",
     "countryCode": "MX",
     "iata": "CZM",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Cozumel"
  }, {
     "name": "Campo Internacional Airport",
     "countryCode": "BR",
     "iata": "CZS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Cruzeiro Do Sul"
  }, {
     "name": "Carrizo Springs Airport",
     "countryCode": "US",
     "iata": "CZT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Carrizo Springs"
  }, {
     "name": "Corozal Airport",
     "countryCode": "CO",
     "iata": "CZU",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Corozal"
  }, {
     "name": "Changzhou Airport",
     "countryCode": "CN",
     "iata": "CZX",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Changzhou"
  }, {
     "name": "Davison Army Air Field",
     "countryCode": "US",
     "iata": "DAA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Belvoir"
  }, {
     "name": "Daytona Beach International Airport",
     "countryCode": "US",
     "iata": "DAB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Daytona Beach"
  }, {
     "name": "Hazrat Shahjalal International Airport",
     "countryCode": "BD",
     "iata": "DAC",
     "eucustoms": false,
     "countryDK": "Bangladesh",
     "cityDK": "Dhaka"
  }, {
     "name": "Da Nang International Airport",
     "countryCode": "VN",
     "iata": "DAD",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Da Nang"
  }, {
     "name": "Barstow-Daggett Airport",
     "countryCode": "US",
     "iata": "DAG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Daggett"
  }, {
     "name": "Dakhla Oasis Airport",
     "countryCode": "EG",
     "iata": "DAK",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Dakhla Oasis"
  }, {
     "name": "Dallas Love Field",
     "countryCode": "US",
     "iata": "DAL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dallas"
  }, {
     "name": "Damascus International Airport",
     "countryCode": "SY",
     "iata": "DAM",
     "eucustoms": false,
     "countryDK": "Syrien",
     "cityDK": "Damaskus"
  }, {
     "name": "Danville Regional Airport",
     "countryCode": "US",
     "iata": "DAN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Danville"
  }, {
     "name": "Darchula Airport",
     "countryCode": "NP",
     "iata": "DAP",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Darchula"
  }, {
     "name": "Julius Nyerere International Airport",
     "countryCode": "TZ",
     "iata": "DAR",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Dar Es Salaam"
  }, {
     "name": "Datong Airport",
     "countryCode": "CN",
     "iata": "DAT",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Datong"
  }, {
     "name": "Enrique Malek Airport",
     "countryCode": "PA",
     "iata": "DAV",
     "eucustoms": false,
     "countryDK": "Panama",
     "cityDK": "David"
  }, {
     "name": "Dazhou Heshi Airport",
     "countryCode": "CN",
     "iata": "DAX",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Dazhou"
  }, {
     "name": "James M. Cox Dayton International Airport",
     "countryCode": "US",
     "iata": "DAY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dayton"
  }, {
     "name": "Darwaz Airport",
     "countryCode": "AF",
     "iata": "DAZ",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Darwaz"
  }, {
     "name": "Dalbandin Airport",
     "countryCode": "PK",
     "iata": "DBA",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Dalbandin"
  }, {
     "name": "Al Alamain International Airport",
     "countryCode": "EG",
     "iata": "DBB",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Dabaa"
  }, {
     "name": "Debra Marcos Airport",
     "countryCode": "ET",
     "iata": "DBM",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Debra Marcos"
  }, {
     "name": "Dublin Municipal Airport",
     "countryCode": "US",
     "iata": "DBN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dublin"
  }, {
     "name": "Dubbo City Regional Airport",
     "countryCode": "AU",
     "iata": "DBO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Dubbo"
  }, {
     "name": "Dubuque Municipal Airport",
     "countryCode": "US",
     "iata": "DBQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dubuque"
  }, {
     "name": "Debra Tabor Airport",
     "countryCode": "ET",
     "iata": "DBT",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Debra Tabor"
  }, {
     "name": "Dubrovnik Airport",
     "countryCode": "HR",
     "iata": "DBV",
     "eucustoms": true,
     "countryDK": "Kroatien",
     "cityDK": "Dubrovnik"
  }, {
     "name": "Dalby Airport",
     "countryCode": "AU",
     "iata": "DBY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Dalby"
  }, {
     "name": "Ronald Reagan National Airport",
     "countryCode": "US",
     "iata": "DCA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Washington"
  }, {
     "name": "Canefield Airport",
     "countryCode": "DM",
     "iata": "DCF",
     "eucustoms": false,
     "countryDK": "Dominica",
     "cityDK": "Dominica"
  }, {
     "name": "Decimomannu Air Base",
     "countryCode": "IT",
     "iata": "DCI",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Decimomannu"
  }, {
     "name": "Mazamet Airport",
     "countryCode": "FR",
     "iata": "DCM",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Castres"
  }, {
     "name": "Decatur Hi-Way Airport",
     "countryCode": "US",
     "iata": "DCR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Decatur"
  }, {
     "name": "Pyor Airport",
     "countryCode": "US",
     "iata": "DCU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Decatur"
  }, {
     "name": "Daocheng Yading Airport",
     "countryCode": "CN",
     "iata": "DCY",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Daocheng"
  }, {
     "name": "Dodge City Regional Airport",
     "countryCode": "US",
     "iata": "DDC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dodge City"
  }, {
     "name": "Langtou Airport",
     "countryCode": "CN",
     "iata": "DDG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Dandong"
  }, {
     "name": "Daydream Island Airport",
     "countryCode": "AU",
     "iata": "DDI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Daydream Island"
  }, {
     "name": "Delta Downs Airport",
     "countryCode": "AU",
     "iata": "DDN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Delta Downs"
  }, {
     "name": "Dera Ghazi Khan Airport",
     "countryCode": "PK",
     "iata": "DEA",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Dera Ghazi Khan"
  }, {
     "name": "Debrecen Airport",
     "countryCode": "HU",
     "iata": "DEB",
     "eucustoms": false,
     "countryDK": "Ungarn",
     "cityDK": "Debrecen"
  }, {
     "name": "Decatur Airport",
     "countryCode": "US",
     "iata": "DEC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Decatur"
  }, {
     "name": "Dehra Dun Airport",
     "countryCode": "IN",
     "iata": "DED",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Dehra Dun"
  }, {
     "name": "Mendeleyevo Airport",
     "countryCode": "RU",
     "iata": "DEE",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Kunashir Island"
  }, {
     "name": "Dezful Airport",
     "countryCode": "IR",
     "iata": "DEF",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Dezful"
  }, {
     "name": "Decorah Municipal Airport",
     "countryCode": "US",
     "iata": "DEH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Decorah"
  }, {
     "name": "Denis Island Airport",
     "countryCode": "SC",
     "iata": "DEI",
     "eucustoms": false,
     "countryDK": "Seychellerne",
     "cityDK": "Denis Island"
  }, {
     "name": "Indira Gandhi International Airport",
     "countryCode": "IN",
     "iata": "DEL",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Delhi"
  }, {
     "name": "Dembidollo Airport",
     "countryCode": "ET",
     "iata": "DEM",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Dembidollo"
  }, {
     "name": "Denver International Airport",
     "countryCode": "US",
     "iata": "DEN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Denver"
  }, {
     "name": "Desroches Airport",
     "countryCode": "SC",
     "iata": "DES",
     "eucustoms": false,
     "countryDK": "Seychellerne",
     "cityDK": "Desroches"
  }, {
     "name": "Coleman A. Young Municipal Airport",
     "countryCode": "US",
     "iata": "DET",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Detroit"
  }, {
     "name": "Al Jafrah Airport",
     "countryCode": "SY",
     "iata": "DEZ",
     "eucustoms": false,
     "countryDK": "Syrien",
     "cityDK": "Deirezzor"
  }, {
     "name": "Defiance Memorial Airport",
     "countryCode": "US",
     "iata": "DFI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Trodsighed"
  }, {
     "name": "Dallas/Fort Worth International Airport",
     "countryCode": "US",
     "iata": "DFW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dallas"
  }, {
     "name": "Mudgee Airport",
     "countryCode": "AU",
     "iata": "DGE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mudgee"
  }, {
     "name": "Douglas Lake Airport",
     "countryCode": "CA",
     "iata": "DGF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Douglas Lake"
  }, {
     "name": "Douglas Municipal Airport",
     "countryCode": "US",
     "iata": "DGL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Douglas"
  }, {
     "name": "Naval Air Field",
     "countryCode": "US",
     "iata": "DGN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dahlgren"
  }, {
     "name": "Guadalupe Victoria Airport",
     "countryCode": "MX",
     "iata": "DGO",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Durango"
  }, {
     "name": "Dargaville Aerodrome",
     "countryCode": "NZ",
     "iata": "DGR",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Dargaville"
  }, {
     "name": "Dumaguete Airport",
     "countryCode": "PH",
     "iata": "DGT",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Dumaguete"
  }, {
     "name": "Dedougou Airport",
     "countryCode": "BF",
     "iata": "DGU",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Dédougou"
  }, {
     "name": "Converse County Airport",
     "countryCode": "US",
     "iata": "DGW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Douglas"
  }, {
     "name": "King Abdulaziz Air Base",
     "countryCode": "SA",
     "iata": "DHA",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Dhahran"
  }, {
     "name": "Durham Downs Airport",
     "countryCode": "AU",
     "iata": "DHD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Durham Downs"
  }, {
     "name": "Al Dhafra Air Base",
     "countryCode": "AE",
     "iata": "DHF",
     "eucustoms": false,
     "countryDK": "Forenede Arabiske Emirater",
     "cityDK": "Abu Dhabi"
  }, {
     "name": "Dhangarhi Airport",
     "countryCode": "NP",
     "iata": "DHI",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Dhangarhi"
  }, {
     "name": "Gaggal Airport",
     "countryCode": "IN",
     "iata": "DHM",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Dharamsala"
  }, {
     "name": "Dothan Regional Airport",
     "countryCode": "US",
     "iata": "DHN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dothan"
  }, {
     "name": "De Kooy Airport",
     "countryCode": "NL",
     "iata": "DHR",
     "eucustoms": false,
     "countryDK": "Holland",
     "cityDK": "Den Helder"
  }, {
     "name": "Dalhart Airport",
     "countryCode": "US",
     "iata": "DHT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dalhart"
  }, {
     "name": "Dibrugarh Airport",
     "countryCode": "IN",
     "iata": "DIB",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Dibrugarh"
  }, {
     "name": "Antsiranana/Arrachart Airport",
     "countryCode": "MG",
     "iata": "DIE",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Antsiranana"
  }, {
     "name": "Longvic Airport",
     "countryCode": "FR",
     "iata": "DIJ",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Dijon"
  }, {
     "name": "Dickinson Regional Airport",
     "countryCode": "US",
     "iata": "DIK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dickinson"
  }, {
     "name": "Comoro Airport",
     "countryCode": "TL",
     "iata": "DIL",
     "eucustoms": false,
     "countryDK": "Østtimor",
     "cityDK": "Dili"
  }, {
     "name": "Dimbokro Airport",
     "countryCode": "CI",
     "iata": "DIM",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Dimbokro"
  }, {
     "name": "Divinopolis Airport",
     "countryCode": "BR",
     "iata": "DIQ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Divinopolis"
  }, {
     "name": "Aba Tenna D Yilma Airport",
     "countryCode": "ET",
     "iata": "DIR",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Dire Dawa"
  }, {
     "name": "Ngot Nzoungou Airport",
     "countryCode": "CG",
     "iata": "DIS",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Dolisie"
  }, {
     "name": "Diyarbakir Airport",
     "countryCode": "TR",
     "iata": "DIY",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Diyarbakir"
  }, {
     "name": "Sultan Thaha Airport",
     "countryCode": "ID",
     "iata": "DJB",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Jambi"
  }, {
     "name": "Melita Airport",
     "countryCode": "TN",
     "iata": "DJE",
     "eucustoms": false,
     "countryDK": "Tunesien",
     "cityDK": "Djerba"
  }, {
     "name": "Tiska Airport",
     "countryCode": "DZ",
     "iata": "DJG",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Djanet"
  }, {
     "name": "Sentani Airport",
     "countryCode": "ID",
     "iata": "DJJ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Jayapura"
  }, {
     "name": "Djambala Airport",
     "countryCode": "CG",
     "iata": "DJM",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Djambala"
  }, {
     "name": "Delta Junction Airport",
     "countryCode": "US",
     "iata": "DJN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Delta Junction"
  }, {
     "name": "Daloa Airport",
     "countryCode": "CI",
     "iata": "DJO",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Daloa"
  }, {
     "name": "Dunk Island Airport",
     "countryCode": "AU",
     "iata": "DKI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Dunk Island"
  }, {
     "name": "Dunkirk Airport",
     "countryCode": "US",
     "iata": "DKK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dunkirk"
  }, {
     "name": "Leopold Sedar Senghor International Airport",
     "countryCode": "SN",
     "iata": "DKR",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Dakar"
  }, {
     "name": "Dikson Airport",
     "countryCode": "RU",
     "iata": "DKS",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Dikson"
  }, {
     "name": "Docker River Airport",
     "countryCode": "AU",
     "iata": "DKV",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Docker River"
  }, {
     "name": "Douala Airport",
     "countryCode": "CM",
     "iata": "DLA",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Douala"
  }, {
     "name": "Dalian Zhoushuizi International Airport",
     "countryCode": "CN",
     "iata": "DLC",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Dalian"
  }, {
     "name": "Dagali Airport",
     "countryCode": "NO",
     "iata": "DLD",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Geilo"
  }, {
     "name": "Dole-Jura Airport",
     "countryCode": "FR",
     "iata": "DLE",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Dole"
  }, {
     "name": "Laughlin Air Force Base",
     "countryCode": "US",
     "iata": "DLF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Del Rio"
  }, {
     "name": "Dillingham Airport",
     "countryCode": "US",
     "iata": "DLG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dillingham"
  }, {
     "name": "Duluth International Airport",
     "countryCode": "US",
     "iata": "DLH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Duluth"
  }, {
     "name": "Lien Khuong Airport",
     "countryCode": "VN",
     "iata": "DLI",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Da Lat"
  }, {
     "name": "Dillon Airport",
     "countryCode": "US",
     "iata": "DLL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dillon"
  }, {
     "name": "Dalaman Airport",
     "countryCode": "TR",
     "iata": "DLM",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Dalaman"
  }, {
     "name": "Dillon Airport",
     "countryCode": "US",
     "iata": "DLN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dillon"
  }, {
     "name": "The Dalles Airport",
     "countryCode": "US",
     "iata": "DLS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "The Dalles"
  }, {
     "name": "Dali Airport",
     "countryCode": "CN",
     "iata": "DLU",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Dali City"
  }, {
     "name": "Delissaville Airport",
     "countryCode": "AU",
     "iata": "DLV",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Delissaville"
  }, {
     "name": "Dillons Bay Airport",
     "countryCode": "VU",
     "iata": "DLY",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Dillons Bay"
  }, {
     "name": "Gurvan Saikhan Airport",
     "countryCode": "MN",
     "iata": "DLZ",
     "eucustoms": false,
     "countryDK": "Mongoliet",
     "cityDK": "Dalanzadgad"
  }, {
     "name": "Davis Monthan Air Force Base",
     "countryCode": "US",
     "iata": "DMA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tucson"
  }, {
     "name": "Jambyl Airport",
     "countryCode": "KZ",
     "iata": "DMB",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Taraz"
  }, {
     "name": "Doomadgee Airport",
     "countryCode": "AU",
     "iata": "DMD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Doomadgee"
  }, {
     "name": "Moscow Domodedovo Airport",
     "countryCode": "RU",
     "iata": "DME",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Moskva"
  }, {
     "name": "Don Mueang International Airport",
     "countryCode": "TH",
     "iata": "DMK",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Bangkok"
  }, {
     "name": "King Fahd International Airport",
     "countryCode": "SA",
     "iata": "DMM",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Dammam"
  }, {
     "name": "Deming Airport",
     "countryCode": "US",
     "iata": "DMN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Deming"
  }, {
     "name": "Sedalia Airport",
     "countryCode": "US",
     "iata": "DMO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sedalia"
  }, {
     "name": "Diamantino Airport",
     "countryCode": "BR",
     "iata": "DMT",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Diamantino"
  }, {
     "name": "Dimapur Airport",
     "countryCode": "IN",
     "iata": "DMU",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Dimapur"
  }, {
     "name": "Kadena Air Force Base",
     "countryCode": "JP",
     "iata": "DNA",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Okinawa"
  }, {
     "name": "Dundee Airport",
     "countryCode": "GB",
     "iata": "DND",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Dundee"
  }, {
     "name": "Dunhuang Airport",
     "countryCode": "CN",
     "iata": "DNH",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Dunhuang"
  }, {
     "name": "Sam Mbakwe International Airport",
     "countryCode": "NG",
     "iata": "QOW",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Imo"
  }, {
     "name": "Dnepropetrovsk International Airport",
     "countryCode": "UA",
     "iata": "DNK",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Dnepropetrovsk"
  }, {
     "name": "Daniel Field",
     "countryCode": "US",
     "iata": "DNL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Augusta"
  }, {
     "name": "Dalton Municipal Airport",
     "countryCode": "US",
     "iata": "DNN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dalton"
  }, {
     "name": "Dianopolis Airport",
     "countryCode": "BR",
     "iata": "DNO",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Dianopolis"
  }, {
     "name": "Dang Airport",
     "countryCode": "NP",
     "iata": "DNP",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Dang"
  }, {
     "name": "Deniliquin Airport",
     "countryCode": "AU",
     "iata": "DNQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Deniliquin"
  }, {
     "name": "Pleurtuit Airport",
     "countryCode": "FR",
     "iata": "DNR",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Dinard"
  }, {
     "name": "Denison Municipal Airport",
     "countryCode": "US",
     "iata": "DNS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Denison"
  }, {
     "name": "Vermilion Regional Airport",
     "countryCode": "US",
     "iata": "DNV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Danville"
  }, {
     "name": "Galegu Airport",
     "countryCode": "SD",
     "iata": "DNX",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Dinder"
  }, {
     "name": "Cardak Airport",
     "countryCode": "TR",
     "iata": "DNZ",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Denizli"
  }, {
     "name": "Rar Gwamar Airport",
     "countryCode": "ID",
     "iata": "DOB",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Dobo"
  }, {
     "name": "Dodoma Airport",
     "countryCode": "TZ",
     "iata": "DOD",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Dodoma"
  }, {
     "name": "Dongola Airport",
     "countryCode": "SD",
     "iata": "DOG",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Dongola"
  }, {
     "name": "Hamad International Airport",
     "countryCode": "QA",
     "iata": "DOH",
     "eucustoms": false,
     "countryDK": "Qatar",
     "cityDK": "Doha"
  }, {
     "name": "Saint Gatien Airport",
     "countryCode": "FR",
     "iata": "DOL",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Deauville"
  }, {
     "name": "Melville Hall Airport",
     "countryCode": "DM",
     "iata": "DOM",
     "eucustoms": false,
     "countryDK": "Dominica",
     "cityDK": "Dominica"
  }, {
     "name": "Dolpa Airport",
     "countryCode": "NP",
     "iata": "DOP",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Dolpa"
  }, {
     "name": "Dori Airport",
     "countryCode": "BF",
     "iata": "DOR",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Dori"
  }, {
     "name": "Dourados Airport",
     "countryCode": "BR",
     "iata": "DOU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Dourados"
  }, {
     "name": "Dover Air Force Base",
     "countryCode": "US",
     "iata": "DOV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dover-Cheswold"
  }, {
     "name": "DuPage Airport",
     "countryCode": "US",
     "iata": "DPA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chicago"
  }, {
     "name": "Pampa Guanaco Airport",
     "countryCode": "CL",
     "iata": "DPB",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Cameron"
  }, {
     "name": "St Aubin Airport",
     "countryCode": "FR",
     "iata": "DPE",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Dieppe"
  }, {
     "name": "Michael Army Air Field",
     "countryCode": "US",
     "iata": "DPG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dugway"
  }, {
     "name": "Dipolog Airport",
     "countryCode": "PH",
     "iata": "DPL",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Dipolog"
  }, {
     "name": "Devonport Airport",
     "countryCode": "AU",
     "iata": "DPO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Devonport"
  }, {
     "name": "Ngurah Rai International Airport",
     "countryCode": "ID",
     "iata": "DPS",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Denpasar"
  }, {
     "name": "Duqm International Airport",
     "countryCode": "OM",
     "iata": "DQM",
     "eucustoms": false,
     "countryDK": "Oman",
     "cityDK": "Duqm"
  }, {
     "name": "Derby Airport",
     "countryCode": "AU",
     "iata": "DRB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Derby"
  }, {
     "name": "Deering Airport",
     "countryCode": "US",
     "iata": "DRG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Deering"
  }, {
     "name": "Beauregard Parish Airport",
     "countryCode": "US",
     "iata": "DRI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "De Ridder"
  }, {
     "name": "Drake Bay Airport",
     "countryCode": "CR",
     "iata": "DRK",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Drake Bay"
  }, {
     "name": "Dirranbandi Airport",
     "countryCode": "AU",
     "iata": "DRN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Dirranbandi"
  }, {
     "name": "Durango-La Plata County Airport",
     "countryCode": "US",
     "iata": "DRO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Durango"
  }, {
     "name": "Durrie Airport",
     "countryCode": "AU",
     "iata": "DRR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Durrie"
  }, {
     "name": "Dresden International Airport",
     "countryCode": "DE",
     "iata": "DRS",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Dresden"
  }, {
     "name": "Del Rio International Airport",
     "countryCode": "US",
     "iata": "DRT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Del Rio"
  }, {
     "name": "Drummond Airport",
     "countryCode": "US",
     "iata": "DRU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Drummond"
  }, {
     "name": "Dharavandhoo AIrport",
     "countryCode": "MV",
     "iata": "DRV",
     "eucustoms": false,
     "countryDK": "Maldiverne",
     "cityDK": "Dharavandhoo Island"
  }, {
     "name": "Darwin International Airport",
     "countryCode": "AU",
     "iata": "DRW",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Darwin"
  }, {
     "name": "Dschang Airport",
     "countryCode": "CM",
     "iata": "DSC",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Dschang"
  }, {
     "name": "La Desirade Airport",
     "countryCode": "GP",
     "iata": "DSD",
     "eucustoms": false,
     "countryDK": "Guadeloupe",
     "cityDK": "La Desirade"
  }, {
     "name": "Kombolcha Airport",
     "countryCode": "ET",
     "iata": "DSE",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Dessie"
  }, {
     "name": "Destin-Fort Walton Beach Airport",
     "countryCode": "US",
     "iata": "DSI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Destin"
  }, {
     "name": "Dera Ismail Khan Airport",
     "countryCode": "PK",
     "iata": "DSK",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Dera Ismail Khan"
  }, {
     "name": "Des Moines International Airport",
     "countryCode": "US",
     "iata": "DSM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Des Moines"
  }, {
     "name": "Dansville Airport",
     "countryCode": "US",
     "iata": "DSV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dansville"
  }, {
     "name": "Dongsha Island Airport",
     "countryCode": "TW",
     "iata": "DSX",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Dongsha Island"
  }, {
     "name": "Delta Airport",
     "countryCode": "US",
     "iata": "DTA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Delta"
  }, {
     "name": "Silangit Airport",
     "countryCode": "ID",
     "iata": "DTB",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Siborong-Borong"
  }, {
     "name": "Camarines Norte Airport",
     "countryCode": "PH",
     "iata": "DTE",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Daet"
  }, {
     "name": "Diamantina Airport",
     "countryCode": "BR",
     "iata": "DTI",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Diamantina"
  }, {
     "name": "Wething Field",
     "countryCode": "US",
     "iata": "DTL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Detroit Lakes"
  }, {
     "name": "Dortmund Airport",
     "countryCode": "DE",
     "iata": "DTM",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Dortmund"
  }, {
     "name": "Shreveport Downtown Airport",
     "countryCode": "US",
     "iata": "DTN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Shreveport"
  }, {
     "name": "Detroit Metropolitan Wayne County Airport",
     "countryCode": "US",
     "iata": "DTW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Detroit"
  }, {
     "name": "Durant Regional Airport - Eaker Field",
     "countryCode": "US",
     "iata": "DUA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Durant"
  }, {
     "name": "Dublin Airport",
     "countryCode": "IE",
     "iata": "DUB",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Dublin"
  }, {
     "name": "Halliburton Field",
     "countryCode": "US",
     "iata": "DUC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Duncan"
  }, {
     "name": "Dunedin International Airport",
     "countryCode": "NZ",
     "iata": "DUD",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Dunedin"
  }, {
     "name": "Bisbee-Douglas International Airport",
     "countryCode": "US",
     "iata": "DUG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Douglas"
  }, {
     "name": "Jefferson County Airport",
     "countryCode": "US",
     "iata": "DUJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dubois"
  }, {
     "name": "Pinang Kampai Airport",
     "countryCode": "ID",
     "iata": "DUM",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Dumai"
  }, {
     "name": "Duncan/Quam Airport",
     "countryCode": "CA",
     "iata": "DUQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Duncan / Quam"
  }, {
     "name": "King Shaka International Airport",
     "countryCode": "ZA",
     "iata": "DUR",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Durban"
  }, {
     "name": "Dusseldorf International Airport",
     "countryCode": "DE",
     "iata": "DUS",
     "eucustoms": true,
     "countryDK": "Tyskland",
     "cityDK": "Düsseldorf"
  }, {
     "name": "Unalaska Airport",
     "countryCode": "US",
     "iata": "DUT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hollandske havn"
  }, {
     "name": "Devils Lake Airport",
     "countryCode": "US",
     "iata": "DVL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Devils Lake"
  }, {
     "name": "Davenport Airport",
     "countryCode": "US",
     "iata": "DVN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Davenport"
  }, {
     "name": "Francisco Bangoy Intl Airport",
     "countryCode": "PH",
     "iata": "DVO",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Davao"
  }, {
     "name": "Davenport Downs Airport",
     "countryCode": "AU",
     "iata": "DVP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Davenport Downs"
  }, {
     "name": "Phoenix Deer Valley Airport",
     "countryCode": "US",
     "iata": "DVT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Phoenix"
  }, {
     "name": "Dwamawa Airport",
     "countryCode": "MW",
     "iata": "DWA",
     "eucustoms": false,
     "countryDK": "Malawi",
     "cityDK": "Dwamawa"
  }, {
     "name": "Soalala Airport",
     "countryCode": "MG",
     "iata": "DWB",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Soalala"
  }, {
     "name": "Dubai World Central - Al Maktoum International Airport",
     "countryCode": "AE",
     "iata": "DWC",
     "eucustoms": false,
     "countryDK": "Forenede Arabiske Emirater",
     "cityDK": "Dubai"
  }, {
     "name": "Dawadmi Airport",
     "countryCode": "SA",
     "iata": "DWD",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Dawadmi"
  }, {
     "name": "David Wayne Hooks Memorial Airport",
     "countryCode": "US",
     "iata": "DWH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Houston"
  }, {
     "name": "Dubai Airport",
     "countryCode": "AE",
     "iata": "DXB",
     "eucustoms": false,
     "countryDK": "Forenede Arabiske Emirater",
     "cityDK": "Dubai"
  }, {
     "name": "Bruce Campbell Field",
     "countryCode": "US",
     "iata": "DXE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Madison"
  }, {
     "name": "Danbury Municipal Airport",
     "countryCode": "US",
     "iata": "DXR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Danbury"
  }, {
     "name": "Dysart Airport",
     "countryCode": "AU",
     "iata": "DYA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Dysart"
  }, {
     "name": "Zhangjiajie Hehua Airport",
     "countryCode": "CN",
     "iata": "DYG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Dayong"
  }, {
     "name": "Doylestown Airport",
     "countryCode": "US",
     "iata": "DYL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Doylestown"
  }, {
     "name": "Anadyr Airport",
     "countryCode": "RU",
     "iata": "DYR",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Anadyr"
  }, {
     "name": "Dyess Air Force Base",
     "countryCode": "US",
     "iata": "DYS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Abilene"
  }, {
     "name": "Dushanbe Airport",
     "countryCode": "TJ",
     "iata": "DYU",
     "eucustoms": false,
     "countryDK": "Tadsjikistan",
     "cityDK": "Dushanbe"
  }, {
     "name": "Dzaoudzi Airport",
     "countryCode": "YT",
     "iata": "DZA",
     "eucustoms": false,
     "countryDK": "Mayotte",
     "cityDK": "Dzaoudzi"
  }, {
     "name": "Zhezhazgan Airport",
     "countryCode": "KZ",
     "iata": "DZN",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Zhezkazgan"
  }, {
     "name": "Durazno Airport",
     "countryCode": "UY",
     "iata": "DZO",
     "eucustoms": false,
     "countryDK": "Uruguay",
     "cityDK": "Durazno"
  }, {
     "name": "Eagle Airport",
     "countryCode": "US",
     "iata": "EAA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Eagle"
  }, {
     "name": "Abbse Airport",
     "countryCode": "YE",
     "iata": "EAB",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Abbse"
  }, {
     "name": "Emae Airport",
     "countryCode": "VU",
     "iata": "EAE",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Emae"
  }, {
     "name": "Nejran Airport",
     "countryCode": "SA",
     "iata": "EAM",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Nejran"
  }, {
     "name": "Phifer Field",
     "countryCode": "US",
     "iata": "EAN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wheatland"
  }, {
     "name": "Kearney Regional Airport",
     "countryCode": "US",
     "iata": "EAR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kearney"
  }, {
     "name": "San Sebastian Airport",
     "countryCode": "ES",
     "iata": "EAS",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "San Sebastian"
  }, {
     "name": "Pangborn Field",
     "countryCode": "US",
     "iata": "EAT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wenatchee"
  }, {
     "name": "Eau Claire Airport",
     "countryCode": "US",
     "iata": "EAU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Eau Claire"
  }, {
     "name": "Marina Di Campo Airport",
     "countryCode": "IT",
     "iata": "EBA",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Elba Island"
  }, {
     "name": "Entebbe International Airport",
     "countryCode": "UG",
     "iata": "EBB",
     "eucustoms": false,
     "countryDK": "Uganda",
     "cityDK": "Entebbe"
  }, {
     "name": "El Obeid Airport",
     "countryCode": "SD",
     "iata": "EBD",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "El Obeid"
  }, {
     "name": "El Bagre Airport",
     "countryCode": "CO",
     "iata": "EBG",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "El Bagre"
  }, {
     "name": "El Bayadh Airport",
     "countryCode": "DZ",
     "iata": "EBH",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "El Bayadh"
  }, {
     "name": "Esbjerg Airport",
     "countryCode": "DK",
     "iata": "EBJ",
     "eucustoms": false,
     "countryDK": "Danmark",
     "cityDK": "Esbjerg"
  }, {
     "name": "Erbil International Airport",
     "countryCode": "IQ",
     "iata": "EBL",
     "eucustoms": false,
     "countryDK": "Irak",
     "cityDK": "Erbil"
  }, {
     "name": "El Borma Airport",
     "countryCode": "TN",
     "iata": "EBM",
     "eucustoms": false,
     "countryDK": "Tunesien",
     "cityDK": "El Borma"
  }, {
     "name": "Webster City Municipal Airport",
     "countryCode": "US",
     "iata": "EBS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Webster City"
  }, {
     "name": "Boutheon Airport",
     "countryCode": "FR",
     "iata": "EBU",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Saint Etienne"
  }, {
     "name": "Ebolowa Airport",
     "countryCode": "CM",
     "iata": "EBW",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Ebolowa"
  }, {
     "name": "Elizabeth City Airport",
     "countryCode": "US",
     "iata": "ECG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Elizabeth City"
  }, {
     "name": "Echuca Airport",
     "countryCode": "AU",
     "iata": "ECH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Echuca"
  }, {
     "name": "Ercan Airport",
     "countryCode": "CY",
     "iata": "ECN",
     "eucustoms": false,
     "countryDK": "Cypern",
     "cityDK": "Ercan"
  }, {
     "name": "Northwest Florida Beaches International Airport",
     "countryCode": "US",
     "iata": "ECP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Panama City"
  }, {
     "name": "Mondell Field",
     "countryCode": "US",
     "iata": "ECS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Newcastle"
  }, {
     "name": "Austin Executive Airport",
     "countryCode": "US",
     "iata": "EDC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Austin"
  }, {
     "name": "Northeastern Regional Airport",
     "countryCode": "US",
     "iata": "EDE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Edenton"
  }, {
     "name": "Elmendorf Air Force Base",
     "countryCode": "US",
     "iata": "EDF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Anchorage"
  }, {
     "name": "Weide Army Air Field",
     "countryCode": "US",
     "iata": "EDG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Edgewood Arsenal"
  }, {
     "name": "Edinburgh Airport",
     "countryCode": "GB",
     "iata": "EDI",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Edinburgh"
  }, {
     "name": "El Dorado Airport",
     "countryCode": "US",
     "iata": "EDK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "El Dorado"
  }, {
     "name": "Eldoret Airport",
     "countryCode": "KE",
     "iata": "EDL",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Eldoret"
  }, {
     "name": "Les Ajoncs Airport",
     "countryCode": "FR",
     "iata": "EDM",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "La Roche"
  }, {
     "name": "Balikesir Koca Seyit Airport",
     "countryCode": "TR",
     "iata": "EDO",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Edremit"
  }, {
     "name": "Zweibrucken Airport",
     "countryCode": "DE",
     "iata": "ZQW",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Zweibrucken"
  }, {
     "name": "Edwards Air Force Base",
     "countryCode": "US",
     "iata": "EDW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Edwards Air Force Base"
  }, {
     "name": "Needles Airport",
     "countryCode": "US",
     "iata": "EED",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Needles"
  }, {
     "name": "Dillant-Hopkins Airport",
     "countryCode": "US",
     "iata": "EEN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Keene"
  }, {
     "name": "Ellington Field",
     "countryCode": "US",
     "iata": "EFD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Houston"
  }, {
     "name": "Newport State Airport",
     "countryCode": "US",
     "iata": "EFK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Newport"
  }, {
     "name": "Kefallinia Airport",
     "countryCode": "GR",
     "iata": "EFL",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Kefallinia"
  }, {
     "name": "Jefferson Municipal Airport",
     "countryCode": "US",
     "iata": "EFW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jefferson"
  }, {
     "name": "Roumanieres Airport",
     "countryCode": "FR",
     "iata": "EGC",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Bergerac"
  }, {
     "name": "Eagle County Airport",
     "countryCode": "US",
     "iata": "EGE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Vail"
  }, {
     "name": "Duke Field",
     "countryCode": "US",
     "iata": "EGI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Crestview"
  }, {
     "name": "Geneina Airport",
     "countryCode": "SD",
     "iata": "EGN",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Geneina"
  }, {
     "name": "Belgorod Airport",
     "countryCode": "RU",
     "iata": "EGO",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Belgorod"
  }, {
     "name": "Anglesey Airport",
     "countryCode": "GB",
     "iata": "VLY",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Dal"
  }, {
     "name": "Egilsstadir Airport",
     "countryCode": "IS",
     "iata": "EGS",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Egilsstadir"
  }, {
     "name": "Eagle River Airport",
     "countryCode": "US",
     "iata": "EGV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Eagle River"
  }, {
     "name": "Egegik Airport",
     "countryCode": "US",
     "iata": "EGX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Egegik"
  }, {
     "name": "Coltishall Ab",
     "countryCode": "GB",
     "iata": "CLF",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Coltishall"
  }, {
     "name": "El Bolson Airport",
     "countryCode": "AR",
     "iata": "EHL",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "El Bolson"
  }, {
     "name": "Cape Newenham Airport",
     "countryCode": "US",
     "iata": "EHM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cape Newenham"
  }, {
     "name": "Eielson Air Force Base",
     "countryCode": "US",
     "iata": "EIL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fairbanks"
  }, {
     "name": "Eindhoven Airport",
     "countryCode": "NL",
     "iata": "EIN",
     "eucustoms": false,
     "countryDK": "Holland",
     "cityDK": "Eindhoven"
  }, {
     "name": "Terrance B. Lettsome International Airport",
     "countryCode": "VG",
     "iata": "EIS",
     "eucustoms": false,
     "countryDK": "De Britiske Jomfruøer",
     "cityDK": "Beef Island"
  }, {
     "name": "Variguies Airport",
     "countryCode": "CO",
     "iata": "EJA",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Barrancabermeja"
  }, {
     "name": "Wedjh Airport",
     "countryCode": "SA",
     "iata": "EJH",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Wedjh"
  }, {
     "name": "Murray Field",
     "countryCode": "US",
     "iata": "EKA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Eureka"
  }, {
     "name": "Elkhart Municipal Airport",
     "countryCode": "US",
     "iata": "EKI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Elkhart"
  }, {
     "name": "Randolph County Airport",
     "countryCode": "US",
     "iata": "EKN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Elkins"
  }, {
     "name": "Elko Airport",
     "countryCode": "US",
     "iata": "EKO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Elko"
  }, {
     "name": "Eskilstuna Airport",
     "countryCode": "SE",
     "iata": "EKT",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Eskilstuna"
  }, {
     "name": "Elizabethtown Regional Airport - Addington Field",
     "countryCode": "US",
     "iata": "EKX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Elizabethtown"
  }, {
     "name": "Eagle Lake Airport",
     "countryCode": "US",
     "iata": "ELA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Eagle Lake"
  }, {
     "name": "San Bernado Airport",
     "countryCode": "CO",
     "iata": "ELB",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "El Banco"
  }, {
     "name": "Elcho Island Airport",
     "countryCode": "AU",
     "iata": "ELC",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Elcho Island"
  }, {
     "name": "South Arkansas Regional Airport",
     "countryCode": "US",
     "iata": "ELD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "El Dorado"
  }, {
     "name": "El Fasher Airport",
     "countryCode": "SD",
     "iata": "ELF",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "El Fasher"
  }, {
     "name": "El Golea Airport",
     "countryCode": "DZ",
     "iata": "ELG",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "El Golea"
  }, {
     "name": "North Eleuthera International Airport",
     "countryCode": "BS",
     "iata": "ELH",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "North Eleuthera"
  }, {
     "name": "Elk City Regional Business Airport",
     "countryCode": "US",
     "iata": "ELK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Elk City"
  }, {
     "name": "Elmira Corning Regional Airport",
     "countryCode": "US",
     "iata": "ELM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Elmira"
  }, {
     "name": "Bowers Field",
     "countryCode": "US",
     "iata": "ELN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ellensburg"
  }, {
     "name": "Eldorado Airport",
     "countryCode": "AR",
     "iata": "ELO",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Eldorado"
  }, {
     "name": "El Paso International Airport",
     "countryCode": "US",
     "iata": "ELP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "El Paso"
  }, {
     "name": "Prince Nayef bin Abdulaziz Regional Airport",
     "countryCode": "SA",
     "iata": "ELQ",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Gassim"
  }, {
     "name": "East London Airport",
     "countryCode": "ZA",
     "iata": "ELS",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "East London"
  }, {
     "name": "Tour Sinai City Airport",
     "countryCode": "EG",
     "iata": "ELT",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Tour Sinai City"
  }, {
     "name": "Guemar Airport",
     "countryCode": "DZ",
     "iata": "ELU",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "El Oued"
  }, {
     "name": "Yelland Field",
     "countryCode": "US",
     "iata": "ELY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ely"
  }, {
     "name": "Wellsville Municipal Airport",
     "countryCode": "US",
     "iata": "ELZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wellsville"
  }, {
     "name": "East Midlands Airport",
     "countryCode": "GB",
     "iata": "EMA",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Leicestershire"
  }, {
     "name": "Emerald Airport",
     "countryCode": "AU",
     "iata": "EMD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "smaragd"
  }, {
     "name": "Emden Airport",
     "countryCode": "DE",
     "iata": "EME",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Emden"
  }, {
     "name": "Empangeni Airport",
     "countryCode": "ZA",
     "iata": "EMG",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Empangeni"
  }, {
     "name": "Emmonak Airport",
     "countryCode": "US",
     "iata": "EMK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Emmonak"
  }, {
     "name": "Emmen Airport",
     "countryCode": "CH",
     "iata": "EML",
     "eucustoms": false,
     "countryDK": "Schweiz",
     "cityDK": "Emmen"
  }, {
     "name": "Kemmerer Airport",
     "countryCode": "US",
     "iata": "EMM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kemmerer"
  }, {
     "name": "Nema Airport",
     "countryCode": "MR",
     "iata": "EMN",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Nema"
  }, {
     "name": "Emporia Airport",
     "countryCode": "US",
     "iata": "EMP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Emporia"
  }, {
     "name": "El Monte Airport",
     "countryCode": "US",
     "iata": "EMT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "El Monte"
  }, {
     "name": "El Maiten Airport",
     "countryCode": "AR",
     "iata": "EMX",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "El Maiten"
  }, {
     "name": "Kenai Municipal Airport",
     "countryCode": "US",
     "iata": "ENA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kenai"
  }, {
     "name": "Essey Airport",
     "countryCode": "FR",
     "iata": "ENC",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Nancy"
  }, {
     "name": "Vance Air Force Base",
     "countryCode": "US",
     "iata": "END",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Enid"
  }, {
     "name": "H. Hasan Aroeboesman Airport",
     "countryCode": "ID",
     "iata": "ENE",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Ende"
  }, {
     "name": "Enontekio Airport",
     "countryCode": "FI",
     "iata": "ENF",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Enontekiö"
  }, {
     "name": "Saint Angelo Airport",
     "countryCode": "GB",
     "iata": "ENK",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Enniskillen"
  }, {
     "name": "Centralia Municipal Airport",
     "countryCode": "US",
     "iata": "ENL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Centralia"
  }, {
     "name": "Nenana Municipal Airport",
     "countryCode": "US",
     "iata": "ENN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Nenana"
  }, {
     "name": "Teniente Amin Ayub Gonzalez Airport",
     "countryCode": "PY",
     "iata": "ENO",
     "eucustoms": false,
     "countryDK": "Paraguay",
     "cityDK": "Encarnacion"
  }, {
     "name": "Twente Airport",
     "countryCode": "NL",
     "iata": "ENS",
     "eucustoms": false,
     "countryDK": "Holland",
     "cityDK": "Enschede"
  }, {
     "name": "Enewetak Island Airport",
     "countryCode": "MH",
     "iata": "ENT",
     "eucustoms": false,
     "countryDK": "Marshalløerne",
     "cityDK": "Enewetak Island"
  }, {
     "name": "Akanu Ibiam International Airport",
     "countryCode": "NG",
     "iata": "ENU",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Enugu"
  }, {
     "name": "Wendover Airport",
     "countryCode": "US",
     "iata": "ENV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wendover"
  }, {
     "name": "Kenosha Regional Airport",
     "countryCode": "US",
     "iata": "ENW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kenosha"
  }, {
     "name": "Enrique Olaya Herrera Airport",
     "countryCode": "CO",
     "iata": "EOH",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Medellin"
  }, {
     "name": "Eday Airport",
     "countryCode": "GB",
     "iata": "EOI",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Eday"
  }, {
     "name": "Keokuk Airport",
     "countryCode": "US",
     "iata": "EOK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Keokuk"
  }, {
     "name": "El Dorado Airporr",
     "countryCode": "VE",
     "iata": "EOR",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "El Dorado"
  }, {
     "name": "Neosho Airport",
     "countryCode": "US",
     "iata": "EOS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Neosho"
  }, {
     "name": "Elorza Airport",
     "countryCode": "VE",
     "iata": "EOZ",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Elorza"
  }, {
     "name": "El Palomar Airport",
     "countryCode": "AR",
     "iata": "EPA",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "El Palomar"
  }, {
     "name": "Browns Airport",
     "countryCode": "US",
     "iata": "EPG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Weeping Water"
  }, {
     "name": "Ephrata Airport",
     "countryCode": "US",
     "iata": "EPH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ephrata"
  }, {
     "name": "Mirecourt Airport",
     "countryCode": "FR",
     "iata": "EPL",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Epinal"
  }, {
     "name": "Warsaw-Modlin Airport",
     "countryCode": "PL",
     "iata": "WMI",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Modlin"
  }, {
     "name": "Esperance Airport",
     "countryCode": "AU",
     "iata": "EPR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Esperance"
  }, {
     "name": "El Portillo Airport",
     "countryCode": "DO",
     "iata": "EPS",
     "eucustoms": false,
     "countryDK": "Dominikanske Republik",
     "cityDK": "El Portillo / Samana"
  }, {
     "name": "Parnu Airport",
     "countryCode": "EE",
     "iata": "EPU",
     "eucustoms": false,
     "countryDK": "Estland",
     "cityDK": "Parnu"
  }, {
     "name": "Esquel Airport",
     "countryCode": "AR",
     "iata": "EQS",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Esquel"
  }, {
     "name": "Erigavo Airport",
     "countryCode": "SO",
     "iata": "ERA",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Erigavo"
  }, {
     "name": "Ernabella Airport",
     "countryCode": "AU",
     "iata": "ERB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ernabella"
  }, {
     "name": "Erzincan Airport",
     "countryCode": "TR",
     "iata": "ERC",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Erzincan"
  }, {
     "name": "Erfurt Airport",
     "countryCode": "DE",
     "iata": "ERF",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Erfurt"
  }, {
     "name": "Erbogachen Airport",
     "countryCode": "RU",
     "iata": "ERG",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Erbogachen"
  }, {
     "name": "Moulay Ali Cherif Airport",
     "countryCode": "MA",
     "iata": "ERH",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Errachidia"
  }, {
     "name": "Erie International Airport",
     "countryCode": "US",
     "iata": "ERI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Erie"
  }, {
     "name": "Comandante Kraemer Airport",
     "countryCode": "BR",
     "iata": "ERM",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Erechim"
  }, {
     "name": "Eirunepe Airport",
     "countryCode": "BR",
     "iata": "ERN",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Eirunepe"
  }, {
     "name": "Elrose Mine Airport",
     "countryCode": "AU",
     "iata": "ERQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Elrose Mine"
  }, {
     "name": "Errol Airport",
     "countryCode": "US",
     "iata": "ERR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Errol"
  }, {
     "name": "Eros Airport",
     "countryCode": "NA",
     "iata": "ERS",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Windhoek"
  }, {
     "name": "Kerrville Airport",
     "countryCode": "US",
     "iata": "ERV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kerrville"
  }, {
     "name": "Erzurum Airport",
     "countryCode": "TR",
     "iata": "ERZ",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Erzurum"
  }, {
     "name": "Esenboga International Airport",
     "countryCode": "TR",
     "iata": "ESB",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Ankara"
  }, {
     "name": "Delta County Airport",
     "countryCode": "US",
     "iata": "ESC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Escanaba"
  }, {
     "name": "Orcas Island Airport",
     "countryCode": "US",
     "iata": "ESD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Eastsound"
  }, {
     "name": "Ensenada Airport",
     "countryCode": "MX",
     "iata": "ESE",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Ensenada"
  }, {
     "name": "Esler Field",
     "countryCode": "US",
     "iata": "ESF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Alexandria"
  }, {
     "name": "Shoreham Airport",
     "countryCode": "GB",
     "iata": "ESH",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Shoreham By Sea"
  }, {
     "name": "Satenas Air Base",
     "countryCode": "SE",
     "iata": "FUP",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Satenas"
  }, {
     "name": "Eskisehir Airport",
     "countryCode": "TR",
     "iata": "ESK",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Eskisehir"
  }, {
     "name": "Elista Airport",
     "countryCode": "RU",
     "iata": "ESL",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Elista"
  }, {
     "name": "Esmeraldas Airport",
     "countryCode": "EC",
     "iata": "ESM",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Esmeraldas"
  }, {
     "name": "Newnam Field",
     "countryCode": "US",
     "iata": "ESN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Easton"
  }, {
     "name": "El Salvador Airport",
     "countryCode": "CL",
     "iata": "ESR",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "El Salvador"
  }, {
     "name": "Essen Airport",
     "countryCode": "DE",
     "iata": "ESS",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Essen"
  }, {
     "name": "Estherville Municipal Airport",
     "countryCode": "US",
     "iata": "EST",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Estherville"
  }, {
     "name": "Essaouira Airport",
     "countryCode": "MA",
     "iata": "ESU",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Essaouira"
  }, {
     "name": "Easton State Airport",
     "countryCode": "US",
     "iata": "ESW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Easton"
  }, {
     "name": "West Bend Airport",
     "countryCode": "US",
     "iata": "ETB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "West Bend"
  }, {
     "name": "Genda Wuha Airport",
     "countryCode": "ET",
     "iata": "ETE",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Genda Wuha"
  }, {
     "name": "Eilat Airport",
     "countryCode": "IL",
     "iata": "ETH",
     "eucustoms": false,
     "countryDK": "Israel",
     "cityDK": "Elat"
  }, {
     "name": "Eastland Municipal Airport",
     "countryCode": "US",
     "iata": "ETN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Eastland"
  }, {
     "name": "Enterprise Municipal Airport",
     "countryCode": "US",
     "iata": "ETS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Enterprise"
  }, {
     "name": "Ingolstadt Manching Airport",
     "countryCode": "DE",
     "iata": "IGS",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Ingolstadt"
  }, {
     "name": "Metz-Nancy-Lorraine Airport",
     "countryCode": "FR",
     "iata": "ETZ",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Metz / Nancy"
  }, {
     "name": "Kaufana Airport",
     "countryCode": "TO",
     "iata": "EUA",
     "eucustoms": false,
     "countryDK": "Tonga",
     "cityDK": "Eua"
  }, {
     "name": "Weedon Field",
     "countryCode": "US",
     "iata": "EUF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Eufaula"
  }, {
     "name": "Mahlon Sweet Field",
     "countryCode": "US",
     "iata": "EUG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Eugene"
  }, {
     "name": "Neumuenster Airport",
     "countryCode": "DE",
     "iata": "EUM",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Neumünster"
  }, {
     "name": "Hassan I Airport",
     "countryCode": "MA",
     "iata": "EUN",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Laayoune"
  }, {
     "name": "Evelio Javier  Airport",
     "countryCode": "PH",
     "iata": "EUQ",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Antik"
  }, {
     "name": "F D Roosevelt Airport",
     "countryCode": "BQ",
     "iata": "EUX",
     "eucustoms": false,
     "countryDK": "Caribien Holland",
     "cityDK": "Saint Eustatius"
  }, {
     "name": "Harstad/Narvik Airport, Evenes",
     "countryCode": "NO",
     "iata": "EVE",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Harstad-Narvik"
  }, {
     "name": "Sveg Airport",
     "countryCode": "SE",
     "iata": "EVG",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Sveg"
  }, {
     "name": "Eveleth Airport",
     "countryCode": "US",
     "iata": "EVM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Eveleth"
  }, {
     "name": "Zvartnots International Airport",
     "countryCode": "AM",
     "iata": "EVN",
     "eucustoms": false,
     "countryDK": "Armenien",
     "cityDK": "Yerevan"
  }, {
     "name": "Evansville Regional Airport",
     "countryCode": "US",
     "iata": "EVV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Evansville"
  }, {
     "name": "Evanston Airport",
     "countryCode": "US",
     "iata": "EVW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Evanston"
  }, {
     "name": "Evreux Airport",
     "countryCode": "FR",
     "iata": "EVX",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Evreux"
  }, {
     "name": "New Bedford Airport",
     "countryCode": "US",
     "iata": "EWB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "New Bedford"
  }, {
     "name": "Newton City-County Airport",
     "countryCode": "US",
     "iata": "EWK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Newton"
  }, {
     "name": "Coastal Carolina Regional Airport",
     "countryCode": "US",
     "iata": "EWN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "New Bern"
  }, {
     "name": "Ewo Airport",
     "countryCode": "CG",
     "iata": "EWO",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Ewo"
  }, {
     "name": "Newark Liberty International Airport",
     "countryCode": "US",
     "iata": "EWR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Newark",
     "OtherSearch": "New York"
  }, {
     "name": "Exeter International Airport",
     "countryCode": "GB",
     "iata": "EXT",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Exeter"
  }, {
     "name": "Beloyarsky Airport",
     "countryCode": "RU",
     "iata": "EYK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Beloyarsky"
  }, {
     "name": "Yelimane Airport",
     "countryCode": "ML",
     "iata": "EYL",
     "eucustoms": false,
     "countryDK": "Mali",
     "cityDK": "Yelimane"
  }, {
     "name": "El Yopal Airport",
     "countryCode": "CO",
     "iata": "EYP",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "El Yopal"
  }, {
     "name": "Elive Springs Airport",
     "countryCode": "KE",
     "iata": "EYS",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Elive Springs"
  }, {
     "name": "Key West International Airport",
     "countryCode": "US",
     "iata": "EYW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Key West"
  }, {
     "name": "Ministro Pistarini Airport",
     "countryCode": "AR",
     "iata": "EZE",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Buenos Aires"
  }, {
     "name": "Elazig Airport",
     "countryCode": "TR",
     "iata": "EZS",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Elazig"
  }, {
     "name": "Beryozovo Airport",
     "countryCode": "RU",
     "iata": "EZV",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Beryozovo"
  }, {
     "name": "Faranah Airport",
     "countryCode": "GN",
     "iata": "FAA",
     "eucustoms": false,
     "countryDK": "Guinea",
     "cityDK": "Faranah"
  }, {
     "name": "Farnborough Airport",
     "countryCode": "GB",
     "iata": "FAB",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Farnborough"
  }, {
     "name": "Faaite Airport",
     "countryCode": "PF",
     "iata": "FAC",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Faaite"
  }, {
     "name": "Vagar Airport",
     "countryCode": "FO",
     "iata": "FAE",
     "eucustoms": false,
     "countryDK": "Færøerne",
     "cityDK": "Færøerne"
  }, {
     "name": "Felker Army Air Field",
     "countryCode": "US",
     "iata": "FAF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Eustis"
  }, {
     "name": "Farah Airport",
     "countryCode": "AF",
     "iata": "FAH",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Farah"
  }, {
     "name": "Fairbanks International Airport",
     "countryCode": "US",
     "iata": "FAI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fairbanks"
  }, {
     "name": "Diego Jimenez Torres Airport",
     "countryCode": "PR",
     "iata": "FAJ",
     "eucustoms": false,
     "countryDK": "Puerto Rico",
     "cityDK": "Fajardo"
  }, {
     "name": "Farmington Regional Airport",
     "countryCode": "US",
     "iata": "FAM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Farmington"
  }, {
     "name": "Lista Airport",
     "countryCode": "NO",
     "iata": "FAN",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Farsund"
  }, {
     "name": "Faro Airport",
     "countryCode": "PT",
     "iata": "FAO",
     "eucustoms": true,
     "countryDK": "Portugal",
     "cityDK": "Faro"
  }, {
     "name": "Hector International Airport",
     "countryCode": "US",
     "iata": "FAR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fargo"
  }, {
     "name": "Fresno Yosemite International Airport",
     "countryCode": "US",
     "iata": "FAT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fresno"
  }, {
     "name": "Fahud Airport",
     "countryCode": "OM",
     "iata": "FAU",
     "eucustoms": false,
     "countryDK": "Oman",
     "cityDK": "Fahud"
  }, {
     "name": "Fakarava Airport",
     "countryCode": "PF",
     "iata": "FAV",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Fakarava"
  }, {
     "name": "Fayetteville Regional Airport",
     "countryCode": "US",
     "iata": "FAY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fayetteville"
  }, {
     "name": "Fonte Boa Airport",
     "countryCode": "BR",
     "iata": "FBA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Fonte Boa"
  }, {
     "name": "Faizabad Airport",
     "countryCode": "AF",
     "iata": "FBD",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Faizabad"
  }, {
     "name": "Francisco Beltrao Airport",
     "countryCode": "BR",
     "iata": "FBE",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Francisco Beltrao"
  }, {
     "name": "Simmons Army Airfield",
     "countryCode": "US",
     "iata": "FBG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Bragg"
  }, {
     "name": "Faribault Municipal Airport",
     "countryCode": "US",
     "iata": "FBL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Faribault"
  }, {
     "name": "Lubumbashi International Airport",
     "countryCode": "CD",
     "iata": "FBM",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Lubumbashi"
  }, {
     "name": "Fort Bridger Airport",
     "countryCode": "US",
     "iata": "FBR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Bridger"
  }, {
     "name": "Fairbury Municipal Airport",
     "countryCode": "US",
     "iata": "FBY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fairbury"
  }, {
     "name": "Glacier Park International Airport",
     "countryCode": "US",
     "iata": "FCA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kalispell"
  }, {
     "name": "Ficksburg Sentra Oes Airport",
     "countryCode": "ZA",
     "iata": "FCB",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Ficksburg"
  }, {
     "name": "Fresno-Chandler Airport",
     "countryCode": "US",
     "iata": "FCH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fresno"
  }, {
     "name": "Flying Cloud Airport",
     "countryCode": "US",
     "iata": "FCM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Minneapolis"
  }, {
     "name": "Nordholz Airport",
     "countryCode": "DE",
     "iata": "FCN",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Cuxhaven"
  }, {
     "name": "Leonardo da Vinci-Fiumicino Airport",
     "countryCode": "IT",
     "iata": "FCO",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Rom",
     "OtherSearch": "Rom"
  }, {
     "name": "Butts Army Air Field",
     "countryCode": "US",
     "iata": "FCS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Colorado Springs"
  }, {
     "name": "Firing Center Army Air Field",
     "countryCode": "US",
     "iata": "FCT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Yakima"
  }, {
     "name": "Forrest City Municipal Airport",
     "countryCode": "US",
     "iata": "FCY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Forrest City"
  }, {
     "name": "Bringeland Airport",
     "countryCode": "NO",
     "iata": "FDE",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Forde"
  }, {
     "name": "Martinique Aime Cesaire International Airport",
     "countryCode": "MQ",
     "iata": "FDF",
     "eucustoms": false,
     "countryDK": "Martinique",
     "cityDK": "Fort De France"
  }, {
     "name": "Friedrichshafen Airport",
     "countryCode": "DE",
     "iata": "FDH",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Friedrichshafen"
  }, {
     "name": "Frederick Municipal Airport",
     "countryCode": "US",
     "iata": "FDK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Frederick"
  }, {
     "name": "Frederick Municipal Airport",
     "countryCode": "US",
     "iata": "FDR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Frederick"
  }, {
     "name": "Bandundu Airport",
     "countryCode": "CD",
     "iata": "FDU",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Bandundu"
  }, {
     "name": "Findlay Airport",
     "countryCode": "US",
     "iata": "FDY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Findlay"
  }, {
     "name": "Sanfebagar Airport",
     "countryCode": "NP",
     "iata": "FEB",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Sanfebagar"
  }, {
     "name": "Joao Durval Carneiro Airport",
     "countryCode": "BR",
     "iata": "FEC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Feira De Santana"
  }, {
     "name": "Feijo Airport",
     "countryCode": "BR",
     "iata": "FEJ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Feijo"
  }, {
     "name": "Ferkessedougou Airport",
     "countryCode": "CI",
     "iata": "FEK",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Ferkessedougou"
  }, {
     "name": "Fuerstenfeldbruck Airport",
     "countryCode": "DE",
     "iata": "FEL",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Fuerstenfeldbruck"
  }, {
     "name": "Fernando De Noronha Airport",
     "countryCode": "BR",
     "iata": "FEN",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Fernando De Noronha"
  }, {
     "name": "Albertus Airport",
     "countryCode": "US",
     "iata": "FEP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Freeport"
  }, {
     "name": "Fremont Municipal Airport",
     "countryCode": "US",
     "iata": "FET",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fremont"
  }, {
     "name": "Fes-Saiss Airport",
     "countryCode": "MA",
     "iata": "FEZ",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Fez"
  }, {
     "name": "First Flight Airport",
     "countryCode": "US",
     "iata": "FFA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kill Devil Hills"
  }, {
     "name": "Fairfield Municipal Airport",
     "countryCode": "US",
     "iata": "FFL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fairfield"
  }, {
     "name": "Fergus Falls Municipal Airport",
     "countryCode": "US",
     "iata": "FFM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fergus Falls"
  }, {
     "name": "Wright-Patterson Air Force Base",
     "countryCode": "US",
     "iata": "FFO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dayton"
  }, {
     "name": "Frankfort Capital City Airport",
     "countryCode": "US",
     "iata": "FFT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Frankfort"
  }, {
     "name": "Futaleufu Airport",
     "countryCode": "CL",
     "iata": "FFU",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Futaleufu"
  }, {
     "name": "Fderik Airport",
     "countryCode": "MR",
     "iata": "FGD",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Fderik"
  }, {
     "name": "Fagali I Airport",
     "countryCode": "WS",
     "iata": "FGI",
     "eucustoms": false,
     "countryDK": "Samoa",
     "cityDK": "Apia"
  }, {
     "name": "Fangatau Airport",
     "countryCode": "PF",
     "iata": "FGU",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Fangatau, Tuamoto Island"
  }, {
     "name": "Fort Huachuca/Sierra Vista Municipal Airport",
     "countryCode": "US",
     "iata": "FHU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sierra Vista"
  }, {
     "name": "Fakahina Airport",
     "countryCode": "PF",
     "iata": "FHZ",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Fakahina"
  }, {
     "name": "Fair Isle Airport",
     "countryCode": "GB",
     "iata": "FIE",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Fair Isle"
  }, {
     "name": "Katourou Airport",
     "countryCode": "GN",
     "iata": "FIG",
     "eucustoms": false,
     "countryDK": "Guinea",
     "cityDK": "Fria"
  }, {
     "name": "N'djili Airport",
     "countryCode": "CD",
     "iata": "FIH",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kinshasa"
  }, {
     "name": "Fitzroy Crossing Airport",
     "countryCode": "AU",
     "iata": "FIZ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Fitzroy Crossing"
  }, {
     "name": "Fujairah International Airport",
     "countryCode": "AE",
     "iata": "FJR",
     "eucustoms": false,
     "countryDK": "Forenede Arabiske Emirater",
     "cityDK": "Al-Fujairah"
  }, {
     "name": "Baden-Airpark",
     "countryCode": "DE",
     "iata": "FKB",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Karlsruhe / Baden Baden"
  }, {
     "name": "Bangoka International Airport",
     "countryCode": "CD",
     "iata": "FKI",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kisangani"
  }, {
     "name": "Fukui Airport",
     "countryCode": "JP",
     "iata": "FKJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Fukui"
  }, {
     "name": "Venango Regional Airport",
     "countryCode": "US",
     "iata": "FKL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Franklin"
  }, {
     "name": "Franklin Municipal Airport",
     "countryCode": "US",
     "iata": "FKN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Franklin"
  }, {
     "name": "Fukushima Airport",
     "countryCode": "JP",
     "iata": "FKS",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Fukushima"
  }, {
     "name": "Capitolio Airport",
     "countryCode": "CO",
     "iata": "FLA",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Florencia"
  }, {
     "name": "Cangapara Airport",
     "countryCode": "BR",
     "iata": "FLB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Floriano"
  }, {
     "name": "Fond Du Lac County Airport",
     "countryCode": "US",
     "iata": "FLD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fond Du Lac"
  }, {
     "name": "Schaferhaus Airport",
     "countryCode": "DE",
     "iata": "FLF",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Flensborg"
  }, {
     "name": "Flagstaff Pulliam Airport",
     "countryCode": "US",
     "iata": "FLG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Flagstaff"
  }, {
     "name": "Fort Lauderdale-Hollywood International Airport",
     "countryCode": "US",
     "iata": "FLL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lauderdalefortet"
  }, {
     "name": "Hercilio Luz International Airport",
     "countryCode": "BR",
     "iata": "FLN",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Florianopolis"
  }, {
     "name": "Florence Airport",
     "countryCode": "US",
     "iata": "FLO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Firenze"
  }, {
     "name": "Flippin Airport",
     "countryCode": "US",
     "iata": "FLP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Flippin"
  }, {
     "name": "Firenze-Peretola Airport",
     "countryCode": "IT",
     "iata": "FLR",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Firenze"
  }, {
     "name": "Flinders Island Airport",
     "countryCode": "AU",
     "iata": "FLS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Flinders Island"
  }, {
     "name": "Sherman Army Air Field",
     "countryCode": "US",
     "iata": "FLV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Leavenworth"
  }, {
     "name": "Santa Cruz Airport",
     "countryCode": "PT",
     "iata": "FLW",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Flores Island (Azorerne)"
  }, {
     "name": "Fallon Municipal Airport",
     "countryCode": "US",
     "iata": "FLX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fallon"
  }, {
     "name": "Ferdinand Lumban Tobing Airport",
     "countryCode": "ID",
     "iata": "FLZ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Sibolga"
  }, {
     "name": "El Pucu Airport",
     "countryCode": "AR",
     "iata": "FMA",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Formosa"
  }, {
     "name": "Otis Air Force Base",
     "countryCode": "US",
     "iata": "FMH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Falmouth"
  }, {
     "name": "Kalemie Airport",
     "countryCode": "CD",
     "iata": "FMI",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kalemie"
  }, {
     "name": "Memmingen Allgau Airport",
     "countryCode": "DE",
     "iata": "FMM",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Memmingen"
  }, {
     "name": "Four Corners Regional Airport",
     "countryCode": "US",
     "iata": "FMN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Farmington"
  }, {
     "name": "Munster Osnabruck International Airport",
     "countryCode": "DE",
     "iata": "FMO",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Münster"
  }, {
     "name": "Fort Madison Municipal Airport",
     "countryCode": "US",
     "iata": "FMS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Madison"
  }, {
     "name": "Page Field",
     "countryCode": "US",
     "iata": "FMY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Myers"
  }, {
     "name": "Lungi International Airport",
     "countryCode": "SL",
     "iata": "FNA",
     "eucustoms": false,
     "countryDK": "Sierra Leone",
     "cityDK": "Freetown"
  }, {
     "name": "Neubrandenburg Airport",
     "countryCode": "DE",
     "iata": "FNB",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Neubrandenburg"
  }, {
     "name": "Madeira Airport",
     "countryCode": "PT",
     "iata": "FNC",
     "eucustoms": true,
     "countryDK": "Portugal",
     "cityDK": "Funchal"
  }, {
     "name": "Fada Ngourma Airport",
     "countryCode": "BF",
     "iata": "FNG",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Fada Ngourma"
  }, {
     "name": "Fincha Airport",
     "countryCode": "ET",
     "iata": "FNH",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Fincha"
  }, {
     "name": "Garons Airport",
     "countryCode": "FR",
     "iata": "FNI",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Nimes"
  }, {
     "name": "Pyongyang Sunan International Airport",
     "countryCode": "KP",
     "iata": "FNJ",
     "eucustoms": false,
     "countryDK": "Nordkorea",
     "cityDK": "Pyongyang"
  }, {
     "name": "Fort Collins/Loveland Municipal Airport",
     "countryCode": "US",
     "iata": "FNL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Collins / Loveland"
  }, {
     "name": "Bishop International Airport",
     "countryCode": "US",
     "iata": "FNT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Flint"
  }, {
     "name": "Changle International Airport",
     "countryCode": "CN",
     "iata": "FOC",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Fuzhou"
  }, {
     "name": "Fort Dodge Airport",
     "countryCode": "US",
     "iata": "FOD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Dodge"
  }, {
     "name": "Forbes Field",
     "countryCode": "US",
     "iata": "FOE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Topeka"
  }, {
     "name": "Gino Lisa Airport",
     "countryCode": "IT",
     "iata": "FOG",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Foggia"
  }, {
     "name": "Francis S. Gabreski Airport",
     "countryCode": "US",
     "iata": "FOK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Westhampton Beach"
  }, {
     "name": "Foumban Airport",
     "countryCode": "CM",
     "iata": "FOM",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Foumban"
  }, {
     "name": "Kornasoren Airfield",
     "countryCode": "ID",
     "iata": "FOO",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Noemfoor"
  }, {
     "name": "Pinto Martins Airport",
     "countryCode": "BR",
     "iata": "FOR",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Fortaleza"
  }, {
     "name": "Forrest Airport",
     "countryCode": "AU",
     "iata": "FOS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Forrest"
  }, {
     "name": "Fougamou Airport",
     "countryCode": "GA",
     "iata": "FOU",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Fougamou"
  }, {
     "name": "Grand Bahama International Airport",
     "countryCode": "BS",
     "iata": "FPO",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Freeport"
  }, {
     "name": "Saint Lucie County Airport",
     "countryCode": "US",
     "iata": "FPR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Pierce"
  }, {
     "name": "Frankfurt Airport",
     "countryCode": "DE",
     "iata": "FRA",
     "eucustoms": true,
     "countryDK": "Tyskland",
     "cityDK": "Frankfurt"
  }, {
     "name": "Forbes Airport",
     "countryCode": "AU",
     "iata": "FRB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Forbes"
  }, {
     "name": "Franca Airport",
     "countryCode": "BR",
     "iata": "FRC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Franca"
  }, {
     "name": "Friday Harbor Airport",
     "countryCode": "US",
     "iata": "FRD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Friday Harbor"
  }, {
     "name": "Republic Airport",
     "countryCode": "US",
     "iata": "FRG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Farmingdale"
  }, {
     "name": "French Lick Municipal Airport",
     "countryCode": "US",
     "iata": "FRH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fransk slikke"
  }, {
     "name": "Marshall Army Air Field",
     "countryCode": "US",
     "iata": "FRI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Riley"
  }, {
     "name": "Fregate Island Airport",
     "countryCode": "SC",
     "iata": "FRK",
     "eucustoms": false,
     "countryDK": "Seychellerne",
     "cityDK": "Fregate Island"
  }, {
     "name": "Luigi Ridolfi Airport",
     "countryCode": "IT",
     "iata": "FRL",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Forli"
  }, {
     "name": "Fairmont Airport",
     "countryCode": "US",
     "iata": "FRM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fairmont"
  }, {
     "name": "Flora Airport",
     "countryCode": "NO",
     "iata": "FRO",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Floro"
  }, {
     "name": "Front Royal-Warren County Airport",
     "countryCode": "US",
     "iata": "FRR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Front Royal"
  }, {
     "name": "Santa Elena Airport",
     "countryCode": "GT",
     "iata": "FRS",
     "eucustoms": false,
     "countryDK": "Guatemala",
     "cityDK": "Flores"
  }, {
     "name": "Manas International Airport",
     "countryCode": "KG",
     "iata": "FRU",
     "eucustoms": false,
     "countryDK": "Kirgisistan",
     "cityDK": "Bishkek"
  }, {
     "name": "Francistown Airport",
     "countryCode": "BW",
     "iata": "FRW",
     "eucustoms": false,
     "countryDK": "Botswana",
     "cityDK": "Francistown"
  }, {
     "name": "Eastern Slopes Regional Airport",
     "countryCode": "US",
     "iata": "FRY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fryeburg"
  }, {
     "name": "Fritzlar Air Base",
     "countryCode": "DE",
     "iata": "FRZ",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Fritzlar"
  }, {
     "name": "Sud Corse Airport",
     "countryCode": "FR",
     "iata": "FSC",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Figari"
  }, {
     "name": "Joe Foss Field",
     "countryCode": "US",
     "iata": "FSD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sioux Falls"
  }, {
     "name": "Post Aaf",
     "countryCode": "US",
     "iata": "FSI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ft Sill"
  }, {
     "name": "Fort Scott Municipal Airport",
     "countryCode": "US",
     "iata": "FSK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Scott"
  }, {
     "name": "Fort Smith Regional Airport",
     "countryCode": "US",
     "iata": "FSM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Smith"
  }, {
     "name": "Saint Pierre Airport",
     "countryCode": "PM",
     "iata": "FSP",
     "eucustoms": false,
     "countryDK": "Saint-Pierre og Miquelon",
     "cityDK": "Saint Pierre"
  }, {
     "name": "Kinloss Airport",
     "countryCode": "GB",
     "iata": "FSS",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Forres"
  }, {
     "name": "Pecos County Airport",
     "countryCode": "US",
     "iata": "FST",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Stockton"
  }, {
     "name": "Fort Sumner Airport",
     "countryCode": "US",
     "iata": "FSU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Sumner"
  }, {
     "name": "Shizuoka Airport",
     "countryCode": "JP",
     "iata": "FSZ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Shizuoka"
  }, {
     "name": "Futuna Airport",
     "countryCode": "VU",
     "iata": "FTA",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Futuna Island"
  }, {
     "name": "Fitiuta Airport",
     "countryCode": "AS",
     "iata": "FTI",
     "eucustoms": false,
     "countryDK": "Amerikansk Samoa",
     "cityDK": "Fitiuta"
  }, {
     "name": "Godman Army Air Field",
     "countryCode": "US",
     "iata": "FTK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Knox"
  }, {
     "name": "Marillac Airport",
     "countryCode": "MG",
     "iata": "FTU",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Fort Dauphin"
  }, {
     "name": "Fort Worth Meacham International Airport",
     "countryCode": "US",
     "iata": "FTW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Worth"
  }, {
     "name": "Owando Airport",
     "countryCode": "CG",
     "iata": "FTX",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Owando"
  }, {
     "name": "Fulton County Airport",
     "countryCode": "US",
     "iata": "FTY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Atlanta"
  }, {
     "name": "Fuerteventura Airport",
     "countryCode": "ES",
     "iata": "FUE",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Puerto del Rosario"
  }, {
     "name": "Fukue Airport",
     "countryCode": "JP",
     "iata": "FUJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Fukue"
  }, {
     "name": "Fukuoka Airport",
     "countryCode": "JP",
     "iata": "FUK",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Fukuoka"
  }, {
     "name": "Fullerton Municipal Airport",
     "countryCode": "US",
     "iata": "FUL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fullerton"
  }, {
     "name": "Funafuti Atol International Airport",
     "countryCode": "TV",
     "iata": "FUN",
     "eucustoms": false,
     "countryDK": "Tuvalu",
     "cityDK": "Funafuti Atol"
  }, {
     "name": "Futuna Island Airport",
     "countryCode": "WF",
     "iata": "FUT",
     "eucustoms": false,
     "countryDK": "Wallis og Futuna",
     "cityDK": "Futuna Island"
  }, {
     "name": "Fuvahmulaku Island Airport",
     "countryCode": "MV",
     "iata": "FVM",
     "eucustoms": false,
     "countryDK": "Maldiverne",
     "cityDK": "Fuvahmulah Island"
  }, {
     "name": "Fort Wayne International Airport",
     "countryCode": "US",
     "iata": "FWA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Wayne"
  }, {
     "name": "Fort Worth Naval Air Station Joint Reserve Base",
     "countryCode": "US",
     "iata": "FWH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Worth"
  }, {
     "name": "Farewell Airport",
     "countryCode": "US",
     "iata": "FWL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Farvel"
  }, {
     "name": "Fort Lauderdale Executive Airport",
     "countryCode": "US",
     "iata": "FXE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lauderdalefortet"
  }, {
     "name": "Cuamba Airport",
     "countryCode": "MZ",
     "iata": "FXO",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Cuamba"
  }, {
     "name": "Forest City Municipal Airport",
     "countryCode": "US",
     "iata": "FXY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Skovby"
  }, {
     "name": "Fayetteville Municipal Airport",
     "countryCode": "US",
     "iata": "FYM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fayetteville"
  }, {
     "name": "Fuyun Koktokay Airport",
     "countryCode": "CN",
     "iata": "FYN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Fuyun"
  }, {
     "name": "Faya Airport",
     "countryCode": "TD",
     "iata": "FYT",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Faya"
  }, {
     "name": "Fort Yukon Airport",
     "countryCode": "US",
     "iata": "FYU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Yukon"
  }, {
     "name": "Drake Field",
     "countryCode": "US",
     "iata": "FYV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fayetteville"
  }, {
     "name": "Filton Airport",
     "countryCode": "GB",
     "iata": "FZO",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Filton"
  }, {
     "name": "Gabbs Airport",
     "countryCode": "US",
     "iata": "GAB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gabbs"
  }, {
     "name": "Gadsden Municipal Airport",
     "countryCode": "US",
     "iata": "GAD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gadsden"
  }, {
     "name": "Gabes - Matmata Airport",
     "countryCode": "TN",
     "iata": "GAE",
     "eucustoms": false,
     "countryDK": "Tunesien",
     "cityDK": "Gabes"
  }, {
     "name": "Gafsa Airport",
     "countryCode": "TN",
     "iata": "GAF",
     "eucustoms": false,
     "countryDK": "Tunesien",
     "cityDK": "Gafsa"
  }, {
     "name": "Gage Airport",
     "countryCode": "US",
     "iata": "GAG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gage"
  }, {
     "name": "Gayndah Airport",
     "countryCode": "AU",
     "iata": "GAH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Gayndah"
  }, {
     "name": "Montgomery County Airpark",
     "countryCode": "US",
     "iata": "GAI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gaithersburg"
  }, {
     "name": "Yamagata Airport",
     "countryCode": "JP",
     "iata": "GAJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Yamagata"
  }, {
     "name": "Edward G. Pitka Sr. Airport",
     "countryCode": "US",
     "iata": "GAL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Galena"
  }, {
     "name": "Gambell Airport",
     "countryCode": "US",
     "iata": "GAM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gambell"
  }, {
     "name": "Gan/Seenu Airport",
     "countryCode": "MV",
     "iata": "GAN",
     "eucustoms": false,
     "countryDK": "Maldiverne",
     "cityDK": "Gan Island"
  }, {
     "name": "Mariana Grajales Airport",
     "countryCode": "CU",
     "iata": "GAO",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Guantanamo"
  }, {
     "name": "Gao Airport",
     "countryCode": "ML",
     "iata": "GAQ",
     "eucustoms": false,
     "countryDK": "Mali",
     "cityDK": "Gao"
  }, {
     "name": "Garissa Airport",
     "countryCode": "KE",
     "iata": "GAS",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Garissa"
  }, {
     "name": "Tallard Airport",
     "countryCode": "FR",
     "iata": "GAT",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Gap"
  }, {
     "name": "Lokpriya Gopinath Bordoloi International Airport",
     "countryCode": "IN",
     "iata": "GAU",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Gauhati"
  }, {
     "name": "Gangaw Airport",
     "countryCode": "MM",
     "iata": "GAW",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Gangaw"
  }, {
     "name": "Gaya Airport",
     "countryCode": "IN",
     "iata": "GAY",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Gaya"
  }, {
     "name": "Gabala International Airport",
     "countryCode": "AZ",
     "iata": "GBB",
     "eucustoms": false,
     "countryDK": "Aserbajdsjan",
     "cityDK": "Gabala"
  }, {
     "name": "Great Bend Airport",
     "countryCode": "US",
     "iata": "GBD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Great Bend"
  }, {
     "name": "Sir Seretse Khama International Airport",
     "countryCode": "BW",
     "iata": "GBE",
     "eucustoms": false,
     "countryDK": "Botswana",
     "cityDK": "Gaborone"
  }, {
     "name": "Galesburg Airport",
     "countryCode": "US",
     "iata": "GBG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Galesburg"
  }, {
     "name": "Galbraith Lake Airport",
     "countryCode": "US",
     "iata": "GBH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Galbraith Lake"
  }, {
     "name": "Les Bases Airport",
     "countryCode": "GP",
     "iata": "GBJ",
     "eucustoms": false,
     "countryDK": "Guadeloupe",
     "cityDK": "Marie Galante"
  }, {
     "name": "Gbangbatok Airport",
     "countryCode": "SL",
     "iata": "GBK",
     "eucustoms": false,
     "countryDK": "Sierra Leone",
     "cityDK": "Gbangbatok"
  }, {
     "name": "Great Barrington Airport",
     "countryCode": "US",
     "iata": "GBR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Great Barrington"
  }, {
     "name": "Gibb River Airport",
     "countryCode": "AU",
     "iata": "GBV",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Gibb River"
  }, {
     "name": "Ginbata Airport",
     "countryCode": "AU",
     "iata": "GBW",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ginbatta"
  }, {
     "name": "Great Barrier Aerodrome",
     "countryCode": "NZ",
     "iata": "GBZ",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Great Barrier Island"
  }, {
     "name": "Campbell County Airport",
     "countryCode": "US",
     "iata": "GCC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gillette"
  }, {
     "name": "Gachsaran Airport",
     "countryCode": "IR",
     "iata": "GCH",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Gachsaran"
  }, {
     "name": "Guernsey Airport",
     "countryCode": "GB",
     "iata": "GCI",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Guernsey"
  }, {
     "name": "Johannesburg-Grand Central Airport",
     "countryCode": "ZA",
     "iata": "GCJ",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Johannesburg"
  }, {
     "name": "Garden City Municipal Airport",
     "countryCode": "US",
     "iata": "GCK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Garden City"
  }, {
     "name": "Owen Roberts International Airport",
     "countryCode": "KY",
     "iata": "GCM",
     "eucustoms": false,
     "countryDK": "Caymanøerne",
     "cityDK": "Grand Cayman Island"
  }, {
     "name": "Grand Canyon National Park Airport",
     "countryCode": "US",
     "iata": "GCN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Grand Canyon"
  }, {
     "name": "Greene County Municipal Airport",
     "countryCode": "US",
     "iata": "GCY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greeneville"
  }, {
     "name": "Donaldson Field",
     "countryCode": "US",
     "iata": "GDC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greenville"
  }, {
     "name": "Gode/Iddidole Airport",
     "countryCode": "ET",
     "iata": "GDE",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Gode ??/ Iddidole"
  }, {
     "name": "Gandajika Airport",
     "countryCode": "CD",
     "iata": "GDJ",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Gandajika"
  }, {
     "name": "Miguel Hidalgo y Costilla International Airport",
     "countryCode": "MX",
     "iata": "GDL",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Guadalajara"
  }, {
     "name": "Gardner Municipal Airport",
     "countryCode": "US",
     "iata": "GDM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gardner"
  }, {
     "name": "Gdansk Lech Walesa Airport",
     "countryCode": "PL",
     "iata": "GDN",
     "eucustoms": true,
     "countryDK": "Polen",
     "cityDK": "Gdansk"
  }, {
     "name": "Vare Maria Airport",
     "countryCode": "VE",
     "iata": "GDO",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Guasdualito"
  }, {
     "name": "Guadalupe Airport",
     "countryCode": "BR",
     "iata": "GDP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Guadalupe"
  }, {
     "name": "Gondar Airport",
     "countryCode": "ET",
     "iata": "GDQ",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Gondar"
  }, {
     "name": "JAGS McCartney International Airport",
     "countryCode": "TC",
     "iata": "GDT",
     "eucustoms": false,
     "countryDK": "Turks- og Caicosøerne",
     "cityDK": "Grand Turk Island"
  }, {
     "name": "Dawson Community Airport",
     "countryCode": "US",
     "iata": "GDV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Glendive"
  }, {
     "name": "Gladwin Airport",
     "countryCode": "US",
     "iata": "GDW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gladwin"
  }, {
     "name": "Magadan Airport",
     "countryCode": "RU",
     "iata": "GDX",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Magadan"
  }, {
     "name": "Noumea Magenta Airport",
     "countryCode": "NC",
     "iata": "GEA",
     "eucustoms": false,
     "countryDK": "Ny Kaledonien",
     "cityDK": "Noumea"
  }, {
     "name": "Sussex County Airport",
     "countryCode": "US",
     "iata": "GED",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Georgetown"
  }, {
     "name": "Spokane International Airport",
     "countryCode": "US",
     "iata": "GEG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Spokane"
  }, {
     "name": "Sepe Tiaraju Airport",
     "countryCode": "BR",
     "iata": "GEL",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Santo Angelo"
  }, {
     "name": "Cheddi Jagan International Airport",
     "countryCode": "GY",
     "iata": "GEO",
     "eucustoms": false,
     "countryDK": "Guyana",
     "cityDK": "Georgetown"
  }, {
     "name": "Rafael Cabrera Airport",
     "countryCode": "CU",
     "iata": "GER",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Nueva Gerona"
  }, {
     "name": "General Santos International Airport",
     "countryCode": "PH",
     "iata": "GES",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "General Santos City"
  }, {
     "name": "Geraldton Airport",
     "countryCode": "AU",
     "iata": "GET",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Geraldton"
  }, {
     "name": "Gallivare Airport",
     "countryCode": "SE",
     "iata": "GEV",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Gallivare"
  }, {
     "name": "South Big Horn County Airport",
     "countryCode": "US",
     "iata": "GEY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greybull"
  }, {
     "name": "Pope Field",
     "countryCode": "US",
     "iata": "GFD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greenfield"
  }, {
     "name": "Griffith Airport",
     "countryCode": "AU",
     "iata": "GFF",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Griffith"
  }, {
     "name": "Grand Forks International Airport",
     "countryCode": "US",
     "iata": "GFK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Grand Forks"
  }, {
     "name": "Floyd Bennett Memorial Airport",
     "countryCode": "US",
     "iata": "GFL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Glens Falls"
  }, {
     "name": "Grafton Airport",
     "countryCode": "AU",
     "iata": "GFN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Grafton"
  }, {
     "name": "Granville Airport",
     "countryCode": "FR",
     "iata": "GFR",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Granville"
  }, {
     "name": "Grootfontein Airport",
     "countryCode": "NA",
     "iata": "GFY",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Grootfontein"
  }, {
     "name": "Gregory Downs Airport",
     "countryCode": "AU",
     "iata": "GGD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Gregory Downs"
  }, {
     "name": "Georgetown Airport",
     "countryCode": "US",
     "iata": "GGE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Georgetown"
  }, {
     "name": "Gregg County Airport",
     "countryCode": "US",
     "iata": "GGG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Longview"
  }, {
     "name": "Guilo Airport",
     "countryCode": "CI",
     "iata": "GGO",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Guilo"
  }, {
     "name": "Gobernador Gregores Airport",
     "countryCode": "AR",
     "iata": "GGS",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Gobernador Gregores"
  }, {
     "name": "Exuma International Airport",
     "countryCode": "BS",
     "iata": "GGT",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "George Town"
  }, {
     "name": "Glasgow International Airport",
     "countryCode": "US",
     "iata": "GGW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Glasgow"
  }, {
     "name": "Noumerate Airport",
     "countryCode": "DZ",
     "iata": "GHA",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Ghardaia"
  }, {
     "name": "Governor's Harbour Airport",
     "countryCode": "BS",
     "iata": "GHB",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Guvernørens havn"
  }, {
     "name": "Great Harbour Airport",
     "countryCode": "BS",
     "iata": "GHC",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Great Harbour"
  }, {
     "name": "Giebelstadt Airport",
     "countryCode": "DE",
     "iata": "GHF",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Giebelstadt"
  }, {
     "name": "Gush Katif Airport",
     "countryCode": "IL",
     "iata": "GHK",
     "eucustoms": false,
     "countryDK": "Israel",
     "cityDK": "Gush Katif"
  }, {
     "name": "Centerville Municipal Airport",
     "countryCode": "US",
     "iata": "GHM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Centreville"
  }, {
     "name": "Melalan Airport",
     "countryCode": "ID",
     "iata": "GHS",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Vest kutai"
  }, {
     "name": "Ghat Airport",
     "countryCode": "LY",
     "iata": "GHT",
     "eucustoms": false,
     "countryDK": "Libyen",
     "cityDK": "Ghat"
  }, {
     "name": "Gualeguaychu Airport",
     "countryCode": "AR",
     "iata": "GHU",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Gualeguaychu"
  }, {
     "name": "North Front Airport",
     "countryCode": "GI",
     "iata": "GIB",
     "eucustoms": false,
     "countryDK": "Gibraltar",
     "cityDK": "Gibraltar"
  }, {
     "name": "Boigu Island Airport",
     "countryCode": "AU",
     "iata": "GIC",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Boigu Island"
  }, {
     "name": "Gitega Airport",
     "countryCode": "BI",
     "iata": "GID",
     "eucustoms": false,
     "countryDK": "Burundi",
     "cityDK": "Gitega"
  }, {
     "name": "Gilbert Field Airport",
     "countryCode": "US",
     "iata": "GIF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Winter Haven"
  }, {
     "name": "Galeao Antonio Carlos Jobim International Airport",
     "countryCode": "BR",
     "iata": "GIG",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Rio de Janeiro"
  }, {
     "name": "Siguiri Airport",
     "countryCode": "GN",
     "iata": "GII",
     "eucustoms": false,
     "countryDK": "Guinea",
     "cityDK": "Siguiri"
  }, {
     "name": "Gilgit Airport",
     "countryCode": "PK",
     "iata": "GIL",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Gilgit"
  }, {
     "name": "Girardot Airport",
     "countryCode": "CO",
     "iata": "GIR",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Girardot"
  }, {
     "name": "Gisborne Airport",
     "countryCode": "NZ",
     "iata": "GIS",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Gisborne"
  }, {
     "name": "Sigiriya Slaf Base",
     "countryCode": "LK",
     "iata": "GIU",
     "eucustoms": false,
     "countryDK": "Sri Lanka",
     "cityDK": "Sigiriya"
  }, {
     "name": "Jazan Regional Airport",
     "countryCode": "SA",
     "iata": "GIZ",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Jazan"
  }, {
     "name": "Guanaja Airport",
     "countryCode": "HN",
     "iata": "GJA",
     "eucustoms": false,
     "countryDK": "Honduras",
     "cityDK": "Guanaja"
  }, {
     "name": "Jijel Ferhat Abbas Airport",
     "countryCode": "DZ",
     "iata": "GJL",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Jijel"
  }, {
     "name": "Guajara-Mirim Airport",
     "countryCode": "BR",
     "iata": "GJM",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Guajara-Mirim"
  }, {
     "name": "Grand Junction Regional Airport",
     "countryCode": "US",
     "iata": "GJT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Grand Junction"
  }, {
     "name": "Goroka Airport",
     "countryCode": "PG",
     "iata": "GKA",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Goroka"
  }, {
     "name": "Geilenkirchen Air Base",
     "countryCode": "DE",
     "iata": "GKE",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Geilenkirchen"
  }, {
     "name": "Gorkha Airport",
     "countryCode": "NP",
     "iata": "GKH",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Gorkha"
  }, {
     "name": "Kooddoo Island Airport",
     "countryCode": "MV",
     "iata": "GKK",
     "eucustoms": false,
     "countryDK": "Maldiverne",
     "cityDK": "Kooddoo Island"
  }, {
     "name": "Gulkana Airport",
     "countryCode": "US",
     "iata": "GKN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gulkana"
  }, {
     "name": "Gatlinburg Airport",
     "countryCode": "US",
     "iata": "GKT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gatlinburg"
  }, {
     "name": "Glasgow International Airport",
     "countryCode": "GB",
     "iata": "GLA",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Glasgow"
  }, {
     "name": "Goodland Municipal Airport",
     "countryCode": "US",
     "iata": "GLD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Goodland"
  }, {
     "name": "Gainesville Municipal Airport",
     "countryCode": "US",
     "iata": "GLE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gainesville"
  }, {
     "name": "Golfito Airport",
     "countryCode": "CR",
     "iata": "GLF",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Golfito"
  }, {
     "name": "Greenville Airport",
     "countryCode": "US",
     "iata": "GLH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greenville"
  }, {
     "name": "Glen Innes Airport",
     "countryCode": "AU",
     "iata": "GLI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Glen Innes"
  }, {
     "name": "Galcaio Airport",
     "countryCode": "SO",
     "iata": "GLK",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Galcaio"
  }, {
     "name": "Gloucestershire Airport",
     "countryCode": "GB",
     "iata": "GLO",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Gloucester"
  }, {
     "name": "Gaylord Regional Airport",
     "countryCode": "US",
     "iata": "GLR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gaylord"
  }, {
     "name": "Scholes Field",
     "countryCode": "US",
     "iata": "GLS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Galveston"
  }, {
     "name": "Gladstone Airport",
     "countryCode": "AU",
     "iata": "GLT",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Gladstone"
  }, {
     "name": "Gelephu Airport",
     "countryCode": "BT",
     "iata": "GLU",
     "eucustoms": false,
     "countryDK": "Bhutan",
     "cityDK": "Gelephu"
  }, {
     "name": "Glasgow Municipal Airport",
     "countryCode": "US",
     "iata": "GLW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Glasgow"
  }, {
     "name": "Gamar Malamo Airport",
     "countryCode": "ID",
     "iata": "GLX",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Galela"
  }, {
     "name": "Gilze-Rijen Air Base",
     "countryCode": "NL",
     "iata": "GLZ",
     "eucustoms": false,
     "countryDK": "Holland",
     "cityDK": "Breda"
  }, {
     "name": "Gemena Airport",
     "countryCode": "CD",
     "iata": "GMA",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Gemena"
  }, {
     "name": "Gambela Airport",
     "countryCode": "ET",
     "iata": "GMB",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Gambela"
  }, {
     "name": "Gomel Airport",
     "countryCode": "BY",
     "iata": "GME",
     "eucustoms": false,
     "countryDK": "Hviderusland",
     "cityDK": "Gomel"
  }, {
     "name": "Greymouth Airport",
     "countryCode": "NZ",
     "iata": "GMN",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Greymouth"
  }, {
     "name": "Gombe Lawanti International Airport",
     "countryCode": "NG",
     "iata": "GMO",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Gombe"
  }, {
     "name": "Gimpo International Airport",
     "countryCode": "KR",
     "iata": "GMP",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Seoul"
  }, {
     "name": "Gambier Island Airport",
     "countryCode": "PF",
     "iata": "GMR",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Gambier Island"
  }, {
     "name": "Guimaraes Airport",
     "countryCode": "BR",
     "iata": "GMS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Guimaraes"
  }, {
     "name": "Greenville Downtown Airport",
     "countryCode": "US",
     "iata": "GMU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greenville"
  }, {
     "name": "La Gomera Airport",
     "countryCode": "ES",
     "iata": "GMZ",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "San Sebastian de la Gomera"
  }, {
     "name": "Grodno Airport",
     "countryCode": "BY",
     "iata": "GNA",
     "eucustoms": false,
     "countryDK": "Hviderusland",
     "cityDK": "Grodno"
  }, {
     "name": "Grenoble-Isere Airport",
     "countryCode": "FR",
     "iata": "GNB",
     "eucustoms": true,
     "countryDK": "Frankrig",
     "cityDK": "Grenoble"
  }, {
     "name": "Maurice Bishop International Airport",
     "countryCode": "GD",
     "iata": "GND",
     "eucustoms": false,
     "countryDK": "Grenada",
     "cityDK": "St. George's"
  }, {
     "name": "Gooding Airport",
     "countryCode": "US",
     "iata": "GNG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gooding"
  }, {
     "name": "Guanambi Airport",
     "countryCode": "BR",
     "iata": "GNM",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Guanambi"
  }, {
     "name": "Ghinnir Airport",
     "countryCode": "ET",
     "iata": "GNN",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Ghinnir"
  }, {
     "name": "General Roca Airport",
     "countryCode": "AR",
     "iata": "GNR",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "General Roca"
  }, {
     "name": "Milan Airport",
     "countryCode": "US",
     "iata": "GNT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bevillinger"
  }, {
     "name": "Gainesville Regional Airport",
     "countryCode": "US",
     "iata": "GNV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gainesville"
  }, {
     "name": "Sanliurfa GAP Airport",
     "countryCode": "TR",
     "iata": "GNY",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Golgen"
  }, {
     "name": "Ghanzi Airport",
     "countryCode": "BW",
     "iata": "GNZ",
     "eucustoms": false,
     "countryDK": "Botswana",
     "cityDK": "Ghanzi"
  }, {
     "name": "Genoa Cristoforo Colombo Airport",
     "countryCode": "IT",
     "iata": "GOA",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Genova"
  }, {
     "name": "Robe Airport",
     "countryCode": "ET",
     "iata": "GOB",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Goba"
  }, {
     "name": "Gobabis Airport",
     "countryCode": "NA",
     "iata": "GOG",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Gobabis"
  }, {
     "name": "Nuuk Airport",
     "countryCode": "GL",
     "iata": "GOH",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Nuuk"
  }, {
     "name": "Dabolim Airport",
     "countryCode": "IN",
     "iata": "GOI",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Goa"
  }, {
     "name": "Nizhny Novgorod International Airport",
     "countryCode": "RU",
     "iata": "GOJ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Nizhniy Novgorod"
  }, {
     "name": "Guthrie Airport",
     "countryCode": "US",
     "iata": "GOK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Guthrie"
  }, {
     "name": "Goma Airport",
     "countryCode": "CD",
     "iata": "GOM",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Goma"
  }, {
     "name": "Groton-New London Airport",
     "countryCode": "US",
     "iata": "GON",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "New London"
  }, {
     "name": "Goondiwindi Airport",
     "countryCode": "AU",
     "iata": "GOO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Goondiwindi"
  }, {
     "name": "Gorakhpur Airport",
     "countryCode": "IN",
     "iata": "GOP",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Gorakhpur"
  }, {
     "name": "Gore Airport",
     "countryCode": "ET",
     "iata": "GOR",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Gore"
  }, {
     "name": "Goteborg Landvetter Airport",
     "countryCode": "SE",
     "iata": "GOT",
     "eucustoms": true,
     "countryDK": "Sverige",
     "cityDK": "Gøteborg"
  }, {
     "name": "Garoua Airport",
     "countryCode": "CM",
     "iata": "GOU",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Garoua"
  }, {
     "name": "Nhulunbuy Airport",
     "countryCode": "AU",
     "iata": "GOV",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Gove"
  }, {
     "name": "Araxos Airport",
     "countryCode": "GR",
     "iata": "GPA",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Patras"
  }, {
     "name": "Tancredo Thomaz Faria Airport",
     "countryCode": "BR",
     "iata": "GPB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Guarapuava"
  }, {
     "name": "Mount Gordon Mine Airport",
     "countryCode": "AU",
     "iata": "GPD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mount Gordon"
  }, {
     "name": "Juan Casiano Airport",
     "countryCode": "CO",
     "iata": "GPI",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Guapi"
  }, {
     "name": "Guapiles Airport",
     "countryCode": "CR",
     "iata": "GPL",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Guapiles"
  }, {
     "name": "Garden Point Airport",
     "countryCode": "AU",
     "iata": "GPN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Have Point"
  }, {
     "name": "General Pico Airport",
     "countryCode": "AR",
     "iata": "GPO",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "General Pico"
  }, {
     "name": "Baltra Airport",
     "countryCode": "EC",
     "iata": "GPS",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Galapagosøerne"
  }, {
     "name": "Gulfport-Biloxi International Airport",
     "countryCode": "US",
     "iata": "GPT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gulfport"
  }, {
     "name": "Grand Rapids - Itsaca County Airport",
     "countryCode": "US",
     "iata": "GPZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Grand Rapids"
  }, {
     "name": "Galion Airport",
     "countryCode": "US",
     "iata": "GQQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Galion"
  }, {
     "name": "Austin Straubel International Airport",
     "countryCode": "US",
     "iata": "GRB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Green Bay"
  }, {
     "name": "Greenwood County Airport",
     "countryCode": "US",
     "iata": "GRD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greenwood"
  }, {
     "name": "Greenville Municipal Airport",
     "countryCode": "US",
     "iata": "GRE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greenville"
  }, {
     "name": "Gray Army Air Field",
     "countryCode": "US",
     "iata": "GRF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tacoma"
  }, {
     "name": "Grand Island Airport",
     "countryCode": "US",
     "iata": "GRI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Grand Island"
  }, {
     "name": "George Airport",
     "countryCode": "ZA",
     "iata": "GRJ",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "George"
  }, {
     "name": "Robert Gray Army Airfield",
     "countryCode": "US",
     "iata": "GRK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Killeen"
  }, {
     "name": "Devils Track Airport",
     "countryCode": "US",
     "iata": "GRM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Grand Marais"
  }, {
     "name": "Gordon Airport",
     "countryCode": "US",
     "iata": "GRN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gordon"
  }, {
     "name": "Girona-Costa Brava Airport",
     "countryCode": "ES",
     "iata": "GRO",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Girona"
  }, {
     "name": "Gurupi Airport",
     "countryCode": "BR",
     "iata": "GRP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Gurupi"
  }, {
     "name": "Eelde Airport",
     "countryCode": "NL",
     "iata": "GRQ",
     "eucustoms": false,
     "countryDK": "Holland",
     "cityDK": "Groningen"
  }, {
     "name": "Gerald R. Ford International Airport",
     "countryCode": "US",
     "iata": "GRR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Grand Rapids"
  }, {
     "name": "Corrado Baccarini Airport",
     "countryCode": "IT",
     "iata": "GRS",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Grosseto"
  }, {
     "name": "Sao Paulo-Guarulhos International Airport",
     "countryCode": "BR",
     "iata": "GRU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Paulo"
  }, {
     "name": "Graciosa Island Airport",
     "countryCode": "PT",
     "iata": "GRW",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Graciosa Island (Azorerne)"
  }, {
     "name": "Granada Airport",
     "countryCode": "ES",
     "iata": "GRX",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Granada"
  }, {
     "name": "Grimsey Airport",
     "countryCode": "IS",
     "iata": "GRY",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Grimsey"
  }, {
     "name": "Graz Airport",
     "countryCode": "AT",
     "iata": "GRZ",
     "eucustoms": false,
     "countryDK": "Østrig",
     "cityDK": "Graz"
  }, {
     "name": "Seymour Johnson Air Force Base",
     "countryCode": "US",
     "iata": "GSB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Goldsboro"
  }, {
     "name": "Goteborg City Airport",
     "countryCode": "SE",
     "iata": "GSE",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Gøteborg"
  }, {
     "name": "Goshen Municipal Airport",
     "countryCode": "US",
     "iata": "GSH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Goshen"
  }, {
     "name": "Puerto San Jose Airport",
     "countryCode": "GT",
     "iata": "GSJ",
     "eucustoms": false,
     "countryDK": "Guatemala",
     "cityDK": "Puerto San Jose"
  }, {
     "name": "Taltheilei Narrows Airport",
     "countryCode": "CA",
     "iata": "GSL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Taltheilei smalter"
  }, {
     "name": "Dayrestan Airport",
     "countryCode": "IR",
     "iata": "GSM",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Qeshm Island"
  }, {
     "name": "Piedmont Triad International Airport",
     "countryCode": "US",
     "iata": "GSO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greensboro / High Point"
  }, {
     "name": "Greenville-Spartanburg International Airport",
     "countryCode": "US",
     "iata": "GSP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greenville"
  }, {
     "name": "Shark Elowainat Airport",
     "countryCode": "EG",
     "iata": "GSQ",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Shark Elowainat"
  }, {
     "name": "Gardo Airport",
     "countryCode": "SO",
     "iata": "GSR",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Gardo"
  }, {
     "name": "Sabi Sabi Airport",
     "countryCode": "ZA",
     "iata": "GSS",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Sabi Sabi"
  }, {
     "name": "Gustavus Airport",
     "countryCode": "US",
     "iata": "GST",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gustavus"
  }, {
     "name": "Gedaref Airport",
     "countryCode": "SD",
     "iata": "GSU",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Gedaref"
  }, {
     "name": "Alyangula Airport",
     "countryCode": "AU",
     "iata": "GTE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Groote Island"
  }, {
     "name": "Great Falls International Airport",
     "countryCode": "US",
     "iata": "GTF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Great Falls"
  }, {
     "name": "Grantsburg Municipal Airport",
     "countryCode": "US",
     "iata": "GTG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Grantsburg"
  }, {
     "name": "Rugen Airport",
     "countryCode": "DE",
     "iata": "GTI",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Dreschvitz"
  }, {
     "name": "Glentanner Airport",
     "countryCode": "NZ",
     "iata": "GTN",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Mount Cook"
  }, {
     "name": "Tolotio Airport",
     "countryCode": "ID",
     "iata": "GTO",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Gorontalo"
  }, {
     "name": "Golden Triangle Regional Airport",
     "countryCode": "US",
     "iata": "GTR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbus"
  }, {
     "name": "Georgetown Airport",
     "countryCode": "AU",
     "iata": "GTT",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Georgetown"
  }, {
     "name": "Holesov Airport",
     "countryCode": "CZ",
     "iata": "GTW",
     "eucustoms": false,
     "countryDK": "Tjekkiet",
     "cityDK": "Zlin"
  }, {
     "name": "La Aurora International Airport",
     "countryCode": "GT",
     "iata": "GUA",
     "eucustoms": false,
     "countryDK": "Guatemala",
     "cityDK": "Guatemala City"
  }, {
     "name": "Guerrero Negro Airport",
     "countryCode": "MX",
     "iata": "GUB",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Guerrero Negro"
  }, {
     "name": "Gunnison Airport",
     "countryCode": "US",
     "iata": "GUC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gunnison"
  }, {
     "name": "Goundam Airport",
     "countryCode": "ML",
     "iata": "GUD",
     "eucustoms": false,
     "countryDK": "Mali",
     "cityDK": "Goundam"
  }, {
     "name": "Jack Edwards Airport",
     "countryCode": "US",
     "iata": "GUF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gulf Shores"
  }, {
     "name": "Gunnedah Airport",
     "countryCode": "AU",
     "iata": "GUH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Gunnedah"
  }, {
     "name": "Guiria Airport",
     "countryCode": "VE",
     "iata": "GUI",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Guiria"
  }, {
     "name": "Guaratingueta Airport",
     "countryCode": "BR",
     "iata": "GUJ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Guaratingueta"
  }, {
     "name": "Goulburn Airport",
     "countryCode": "AU",
     "iata": "GUL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Goulburn"
  }, {
     "name": "A.B. Won Pat International Airport",
     "countryCode": "GU",
     "iata": "GUM",
     "eucustoms": false,
     "countryDK": "Guam",
     "cityDK": "Guam"
  }, {
     "name": "Gallup Municipal Airport",
     "countryCode": "US",
     "iata": "GUP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gallup"
  }, {
     "name": "Guanare Airport",
     "countryCode": "VE",
     "iata": "GUQ",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Guanare"
  }, {
     "name": "Grissom Air Force Base",
     "countryCode": "US",
     "iata": "GUS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Peru"
  }, {
     "name": "Atyrau Airport",
     "countryCode": "KZ",
     "iata": "GUW",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Atyrau"
  }, {
     "name": "Guymon Municipal Airport",
     "countryCode": "US",
     "iata": "GUY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Guymon"
  }, {
     "name": "Geneve Airport",
     "countryCode": "CH",
     "iata": "GVA",
     "eucustoms": false,
     "countryDK": "Schweiz",
     "cityDK": "Geneve"
  }, {
     "name": "Gordonsville Municipal Airport",
     "countryCode": "US",
     "iata": "GVE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gordonsville"
  }, {
     "name": "Lee Gilmer Memorial Airport",
     "countryCode": "US",
     "iata": "GVL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gainesville"
  }, {
     "name": "Governador Valadares Airport",
     "countryCode": "BR",
     "iata": "GVR",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Governador Valadares"
  }, {
     "name": "Majors Field",
     "countryCode": "US",
     "iata": "GVT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greenville"
  }, {
     "name": "Gestrike Airport",
     "countryCode": "SE",
     "iata": "GVX",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Gävle"
  }, {
     "name": "Gwa Airport",
     "countryCode": "MM",
     "iata": "GWA",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Gwa"
  }, {
     "name": "Gwadar Airport",
     "countryCode": "PK",
     "iata": "GWD",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Gwadar"
  }, {
     "name": "Gweru Airport",
     "countryCode": "ZW",
     "iata": "GWE",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Gweru"
  }, {
     "name": "Gwalior Airport",
     "countryCode": "IN",
     "iata": "GWL",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Gwalior"
  }, {
     "name": "Leflore Airport",
     "countryCode": "US",
     "iata": "GWO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greenwood"
  }, {
     "name": "Glenwood Springs Municipal",
     "countryCode": "US",
     "iata": "GWS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Glenwood Springs"
  }, {
     "name": "Westerland - Sylt Airport",
     "countryCode": "DE",
     "iata": "GWT",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Westerland"
  }, {
     "name": "Carnmore Airport",
     "countryCode": "IE",
     "iata": "GWY",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Galway"
  }, {
     "name": "Beringin Airport",
     "countryCode": "ID",
     "iata": "GXA",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Muara Teweh"
  }, {
     "name": "Seiyun Airport",
     "countryCode": "YE",
     "iata": "GXF",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Seiyun"
  }, {
     "name": "Negage Airport",
     "countryCode": "AO",
     "iata": "GXG",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Negage"
  }, {
     "name": "Ten. Vidal Airport",
     "countryCode": "CL",
     "iata": "GXQ",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Coyhaique"
  }, {
     "name": "Greeley-Weld County Airport",
     "countryCode": "US",
     "iata": "GXY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greeley"
  }, {
     "name": "Guayaramerin Airport",
     "countryCode": "BO",
     "iata": "GYA",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Guayaramerin"
  }, {
     "name": "Heydar Aliyev International Airport",
     "countryCode": "AZ",
     "iata": "GYD",
     "eucustoms": false,
     "countryDK": "Aserbajdsjan",
     "cityDK": "Baku"
  }, {
     "name": "Jose Joaquin de Olmedo Airport",
     "countryCode": "EC",
     "iata": "GYE",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Guayaquil"
  }, {
     "name": "Magan Airport",
     "countryCode": "RU",
     "iata": "GYG",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Magan"
  }, {
     "name": "Gisenyi Airport",
     "countryCode": "RW",
     "iata": "GYI",
     "eucustoms": false,
     "countryDK": "Rwanda",
     "cityDK": "Gisenyi"
  }, {
     "name": "Argyle Airport",
     "countryCode": "AU",
     "iata": "GYL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Argyle"
  }, {
     "name": "Gen Jose Maria Yanez International Airport",
     "countryCode": "MX",
     "iata": "GYM",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Guaymas"
  }, {
     "name": "Santa Genoveva Airport",
     "countryCode": "BR",
     "iata": "GYN",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Goiania"
  }, {
     "name": "Gympie Airport",
     "countryCode": "AU",
     "iata": "GYP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Gympie"
  }, {
     "name": "Phoenix Goodyear Airport",
     "countryCode": "US",
     "iata": "GYR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Goodyear"
  }, {
     "name": "Panlong Airport",
     "countryCode": "CN",
     "iata": "GYS",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Guangyuan"
  }, {
     "name": "Guyuan Liupanshan Airport",
     "countryCode": "CN",
     "iata": "GYU",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Guyuan"
  }, {
     "name": "Gary/Chicago International Airport",
     "countryCode": "US",
     "iata": "GYY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gary"
  }, {
     "name": "Yasser Arafat International Airport",
     "countryCode": "PS",
     "iata": "GZA",
     "eucustoms": false,
     "countryDK": "Palæstinensiske territorier",
     "cityDK": "Gaza"
  }, {
     "name": "Nusatupe Airport",
     "countryCode": "SB",
     "iata": "GZO",
     "eucustoms": false,
     "countryDK": "Salomonøerne",
     "cityDK": "Gizo"
  }, {
     "name": "Gazipasa Airport",
     "countryCode": "TR",
     "iata": "GZP",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Gazipasa"
  }, {
     "name": "Oguzeli International Airport",
     "countryCode": "TR",
     "iata": "GZT",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Gaziantep"
  }, {
     "name": "Ghazvin Airport",
     "countryCode": "IR",
     "iata": "GZW",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Ghazvin"
  }, {
     "name": "Hasvik Airport",
     "countryCode": "NO",
     "iata": "HAA",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Hasvik"
  }, {
     "name": "Marion County Airport",
     "countryCode": "US",
     "iata": "HAB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hamilton"
  }, {
     "name": "Hachijo Jima Airport",
     "countryCode": "JP",
     "iata": "HAC",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Hachijo Jima"
  }, {
     "name": "Halmstad Airport",
     "countryCode": "SE",
     "iata": "HAD",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Halmstad"
  }, {
     "name": "Half Moon Airport",
     "countryCode": "US",
     "iata": "HAF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Halvmåne"
  }, {
     "name": "Prince Said Ibrahim Internatonal Airport",
     "countryCode": "KM",
     "iata": "HAH",
     "eucustoms": false,
     "countryDK": "Comorerne",
     "cityDK": "Moroni"
  }, {
     "name": "Dr. Haines Airport",
     "countryCode": "US",
     "iata": "HAI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tre floder"
  }, {
     "name": "Hannover Airport",
     "countryCode": "DE",
     "iata": "HAJ",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Hannover"
  }, {
     "name": "Haikou Meilan International Airport",
     "countryCode": "CN",
     "iata": "HAK",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Haikou"
  }, {
     "name": "Hamburg Airport",
     "countryCode": "DE",
     "iata": "HAM",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Hamborg"
  }, {
     "name": "Noi Bai International Airport",
     "countryCode": "VN",
     "iata": "HAN",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Hanoi"
  }, {
     "name": "Butler County Regional Airport",
     "countryCode": "US",
     "iata": "HAO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hamilton"
  }, {
     "name": "Hanimaadhoo Airport",
     "countryCode": "MV",
     "iata": "HAQ",
     "eucustoms": false,
     "countryDK": "Maldiverne",
     "cityDK": "Hanimaadhoo"
  }, {
     "name": "Harrisburg Capital City Airport",
     "countryCode": "US",
     "iata": "HAR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Harrisburg"
  }, {
     "name": "Hail Airport",
     "countryCode": "SA",
     "iata": "HAS",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Hagl"
  }, {
     "name": "Haugesund Airport",
     "countryCode": "NO",
     "iata": "HAU",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Haugesund"
  }, {
     "name": "Jose Marti International Airport",
     "countryCode": "CU",
     "iata": "HAV",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Havana"
  }, {
     "name": "Haverfordwest Airport",
     "countryCode": "GB",
     "iata": "HAW",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Haverfordwest"
  }, {
     "name": "Hatbox Field",
     "countryCode": "US",
     "iata": "HAX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Muskogee"
  }, {
     "name": "Hobart International Airport",
     "countryCode": "AU",
     "iata": "HBA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Hobart"
  }, {
     "name": "Borg El Arab Airport",
     "countryCode": "EG",
     "iata": "HBE",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Alexandria"
  }, {
     "name": "Bobby L. Chain Municipal Airport",
     "countryCode": "US",
     "iata": "HBG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hattiesburg"
  }, {
     "name": "Hobart Airport",
     "countryCode": "US",
     "iata": "HBR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hobart"
  }, {
     "name": "Hubli Airport",
     "countryCode": "IN",
     "iata": "HBX",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Hubli"
  }, {
     "name": "Eli Airport",
     "countryCode": "SO",
     "iata": "HCM",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Eil"
  }, {
     "name": "Hengchun Airport",
     "countryCode": "TW",
     "iata": "HCN",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Hengchun"
  }, {
     "name": "Halls Creek Airport",
     "countryCode": "AU",
     "iata": "HCQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Halls Creek"
  }, {
     "name": "Holy Cross Airport",
     "countryCode": "US",
     "iata": "HCR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hellige Kors"
  }, {
     "name": "Heidelberg Army Air Field",
     "countryCode": "DE",
     "iata": "HDB",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Heidelberg"
  }, {
     "name": "Hyderabad Airport",
     "countryCode": "PK",
     "iata": "HDD",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Hyderabad"
  }, {
     "name": "Brewster Field",
     "countryCode": "US",
     "iata": "HDE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Holdrege"
  }, {
     "name": "Heringsdorf Airport",
     "countryCode": "DE",
     "iata": "HDF",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Heringsdorf"
  }, {
     "name": "Handan Airport",
     "countryCode": "CN",
     "iata": "HDG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Handan"
  }, {
     "name": "Dillingham Airfield",
     "countryCode": "US",
     "iata": "HDH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oahu"
  }, {
     "name": "Hamadan Airport",
     "countryCode": "IR",
     "iata": "HDM",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Hamadan"
  }, {
     "name": "Yampa Valley Airport",
     "countryCode": "US",
     "iata": "HDN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hayden"
  }, {
     "name": "Hoedspruit Air Force Base",
     "countryCode": "ZA",
     "iata": "HDS",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Hoedspruit"
  }, {
     "name": "Hat Yai International Airport",
     "countryCode": "TH",
     "iata": "HDY",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Hat Yai"
  }, {
     "name": "Herat International Airport",
     "countryCode": "AF",
     "iata": "HEA",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Herat"
  }, {
     "name": "Thompson-Robbins Airport",
     "countryCode": "US",
     "iata": "HEE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Helena"
  }, {
     "name": "Heho Airport",
     "countryCode": "MM",
     "iata": "HEH",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Heho"
  }, {
     "name": "Heide-Buesum Airport",
     "countryCode": "DE",
     "iata": "HEI",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Heide-Buesum"
  }, {
     "name": "Helsinki-Vantaa Airport",
     "countryCode": "FI",
     "iata": "HEL",
     "eucustoms": true,
     "countryDK": "Finland",
     "cityDK": "Helsinki"
  }, {
     "name": "Helsinki-Malmi Airport",
     "countryCode": "FI",
     "iata": "HEM",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Helsinki"
  }, {
     "name": "Heraklion Airport",
     "countryCode": "GR",
     "iata": "HER",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Heraklion"
  }, {
     "name": "State Airport",
     "countryCode": "US",
     "iata": "HES",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hermiston"
  }, {
     "name": "Hohhot Baita International Airport",
     "countryCode": "CN",
     "iata": "HET",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Hohhot"
  }, {
     "name": "Herrera Airport",
     "countryCode": "DO",
     "iata": "HEX",
     "eucustoms": false,
     "countryDK": "Dominikanske Republik",
     "cityDK": "Santo Domingo"
  }, {
     "name": "Hardy-Anders Airport",
     "countryCode": "US",
     "iata": "HEZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Natchez"
  }, {
     "name": "Haifa Airport",
     "countryCode": "IL",
     "iata": "HFA",
     "eucustoms": false,
     "countryDK": "Israel",
     "cityDK": "Haifa"
  }, {
     "name": "Brainard Airport",
     "countryCode": "US",
     "iata": "HFD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hartford"
  }, {
     "name": "Hefei Xinqiao Airport",
     "countryCode": "CN",
     "iata": "HFE",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Hefei"
  }, {
     "name": "Mackall Army Air Field",
     "countryCode": "US",
     "iata": "HFF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hoffman"
  }, {
     "name": "Hornafjordur Airport",
     "countryCode": "IS",
     "iata": "HFN",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Hornafjordur"
  }, {
     "name": "Hagfors Airport",
     "countryCode": "SE",
     "iata": "HFS",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Hagfors"
  }, {
     "name": "Hammerfest Airport",
     "countryCode": "NO",
     "iata": "HFT",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Hammerfest"
  }, {
     "name": "Hargeisa Airport",
     "countryCode": "SO",
     "iata": "HGA",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Hargeisa"
  }, {
     "name": "Hughenden Airport",
     "countryCode": "AU",
     "iata": "HGD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Hughenden"
  }, {
     "name": "Higuerote Airport",
     "countryCode": "VE",
     "iata": "HGE",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Higuerote"
  }, {
     "name": "Hangzhou Xiaoshan International Airport",
     "countryCode": "CN",
     "iata": "HGH",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Hangzhou"
  }, {
     "name": "Helgoland Airport",
     "countryCode": "DE",
     "iata": "HGL",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Helgoland"
  }, {
     "name": "Mae Hong Son Airport",
     "countryCode": "TH",
     "iata": "HGN",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Mae Hong Son"
  }, {
     "name": "Korhogo Airport",
     "countryCode": "CI",
     "iata": "HGO",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Korhogo"
  }, {
     "name": "Wash. County Regional Airport",
     "countryCode": "US",
     "iata": "HGR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hagerstown"
  }, {
     "name": "Hastings Airport",
     "countryCode": "SL",
     "iata": "HGS",
     "eucustoms": false,
     "countryDK": "Sierra Leone",
     "cityDK": "Freetown"
  }, {
     "name": "Mount Hagen Airport",
     "countryCode": "PG",
     "iata": "HGU",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Mount Hagen"
  }, {
     "name": "Hachinohe Air Base",
     "countryCode": "JP",
     "iata": "HHE",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Hachinohe"
  }, {
     "name": "Hilton Head Airport",
     "countryCode": "US",
     "iata": "HHH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hilton Head"
  }, {
     "name": "Wheeler Air Force Base",
     "countryCode": "US",
     "iata": "HHI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wahiawa"
  }, {
     "name": "Frankfurt - Hahn Airport",
     "countryCode": "DE",
     "iata": "HHN",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Hahn"
  }, {
     "name": "Hua Hin Airport",
     "countryCode": "TH",
     "iata": "HHQ",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Hua Hin"
  }, {
     "name": "Hawthorne Municipal Airport",
     "countryCode": "US",
     "iata": "HHR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hawthorne"
  }, {
     "name": "Huai'an Lianshui Airport",
     "countryCode": "CN",
     "iata": "HIA",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Huai'an"
  }, {
     "name": "Chisholm Airport",
     "countryCode": "US",
     "iata": "HIB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hibbing"
  }, {
     "name": "Horn Island Airport",
     "countryCode": "AU",
     "iata": "HID",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Horn Island"
  }, {
     "name": "Mount Washington Regional Airport",
     "countryCode": "US",
     "iata": "HIE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Whitefield"
  }, {
     "name": "Hill Air Force Base",
     "countryCode": "US",
     "iata": "HIF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ogden"
  }, {
     "name": "Lake Havasu City Municipal Airport",
     "countryCode": "US",
     "iata": "HII",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lake Havasu City"
  }, {
     "name": "Hiroshima Airport",
     "countryCode": "JP",
     "iata": "HIJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Hiroshima"
  }, {
     "name": "Sacheon Airport",
     "countryCode": "KR",
     "iata": "HIN",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Jinju"
  }, {
     "name": "Portland Hillsboro Airport",
     "countryCode": "US",
     "iata": "HIO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hillsboro"
  }, {
     "name": "Honiara International Airport",
     "countryCode": "SB",
     "iata": "HIR",
     "eucustoms": false,
     "countryDK": "Salomonøerne",
     "cityDK": "Honiara"
  }, {
     "name": "Hayman Island Airport",
     "countryCode": "AU",
     "iata": "HIS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Hayman Island"
  }, {
     "name": "Hiroshima West Airport",
     "countryCode": "JP",
     "iata": "HIW",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Hiroshima"
  }, {
     "name": "Zhijiang Airport",
     "countryCode": "CN",
     "iata": "HJJ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Huaihua"
  }, {
     "name": "Khajuraho Airport",
     "countryCode": "IN",
     "iata": "HJR",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Khajuraho"
  }, {
     "name": "Blytheville Municipal Airport",
     "countryCode": "US",
     "iata": "HKA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Blytheville"
  }, {
     "name": "Hakodate Airport",
     "countryCode": "JP",
     "iata": "HKD",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Hakodate"
  }, {
     "name": "Hong Kong International Airport",
     "countryCode": "HK",
     "iata": "HKG",
     "eucustoms": false,
     "countryDK": "Hong Kong",
     "cityDK": "Hong Kong"
  }, {
     "name": "Hokitika Airport",
     "countryCode": "NZ",
     "iata": "HKK",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Hokitika"
  }, {
     "name": "Kakamega Airport",
     "countryCode": "KE",
     "iata": "GGM",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Kakamega"
  }, {
     "name": "Hawkins Field",
     "countryCode": "US",
     "iata": "HKS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jackson"
  }, {
     "name": "Phuket International Airport",
     "countryCode": "TH",
     "iata": "HKT",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Phuket"
  }, {
     "name": "Hickory Airport",
     "countryCode": "US",
     "iata": "HKY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hickory"
  }, {
     "name": "Lanseria International Airport",
     "countryCode": "ZA",
     "iata": "HLA",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Lanseria"
  }, {
     "name": "Hillenbrand Airport",
     "countryCode": "US",
     "iata": "HLB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Batesville"
  }, {
     "name": "Hill City Airport",
     "countryCode": "US",
     "iata": "HLC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hill City"
  }, {
     "name": "Hulunbuir Hailar Airport",
     "countryCode": "CN",
     "iata": "HLD",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Hailar"
  }, {
     "name": "Hultsfred Airport",
     "countryCode": "SE",
     "iata": "HLF",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Hultsfred"
  }, {
     "name": "Ohio County Airport",
     "countryCode": "US",
     "iata": "HLG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wheeling"
  }, {
     "name": "Park Township Airport",
     "countryCode": "US",
     "iata": "HLM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Holland"
  }, {
     "name": "Helena Regional Airport",
     "countryCode": "US",
     "iata": "HLN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Helena"
  }, {
     "name": "Halim Perdanakusuma Airport",
     "countryCode": "ID",
     "iata": "HLP",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Jakarta"
  }, {
     "name": "Hood Army Air Field",
     "countryCode": "US",
     "iata": "HLR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Killeen"
  }, {
     "name": "St. Helens Airport",
     "countryCode": "AU",
     "iata": "HLS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Saint Helens"
  }, {
     "name": "Hamilton Airport",
     "countryCode": "AU",
     "iata": "HLT",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Hamilton"
  }, {
     "name": "Houailou Airport",
     "countryCode": "NC",
     "iata": "HLU",
     "eucustoms": false,
     "countryDK": "Ny Kaledonien",
     "cityDK": "Houailou"
  }, {
     "name": "Hluhluwe Airport",
     "countryCode": "ZA",
     "iata": "HLW",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Hluhluwe"
  }, {
     "name": "Hamilton International Airport",
     "countryCode": "NZ",
     "iata": "HLZ",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Hamilton"
  }, {
     "name": "Khanty-Mansiysk Airport",
     "countryCode": "RU",
     "iata": "HMA",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Khanty-Mansiysk"
  }, {
     "name": "Mubarak International Airport",
     "countryCode": "EG",
     "iata": "HMB",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Sohag"
  }, {
     "name": "Oued Irara Airport",
     "countryCode": "DZ",
     "iata": "HME",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Hassi Messaoud"
  }, {
     "name": "Hermannsburg Airport",
     "countryCode": "AU",
     "iata": "HMG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Hermannsburg"
  }, {
     "name": "Holloman Air Force Base",
     "countryCode": "US",
     "iata": "HMN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Alamogordo"
  }, {
     "name": "Gen Pesqueira Garcia Airport",
     "countryCode": "MX",
     "iata": "HMO",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Hermosillo"
  }, {
     "name": "Hamar Airport",
     "countryCode": "NO",
     "iata": "HMR",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Hamar"
  }, {
     "name": "Ryan Field",
     "countryCode": "US",
     "iata": "HMT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hemet"
  }, {
     "name": "Hemavan Airport",
     "countryCode": "SE",
     "iata": "HMV",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Hemavan"
  }, {
     "name": "Hanamaki Airport",
     "countryCode": "JP",
     "iata": "HNA",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Hanamaki"
  }, {
     "name": "Huntingburg Municipal Airport",
     "countryCode": "US",
     "iata": "HNB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Huntingburg"
  }, {
     "name": "Hatteras Airport",
     "countryCode": "US",
     "iata": "HNC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hatteras"
  }, {
     "name": "Haneda Airport",
     "countryCode": "JP",
     "iata": "HND",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Tokyo"
  }, {
     "name": "Hoonah Airport",
     "countryCode": "US",
     "iata": "HNH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hoonah"
  }, {
     "name": "Daniel K. Inouye International Airport",
     "countryCode": "US",
     "iata": "HNL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Honolulu"
  }, {
     "name": "Hana Airport",
     "countryCode": "US",
     "iata": "HNM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hana"
  }, {
     "name": "Haines Municipal Airport",
     "countryCode": "US",
     "iata": "HNS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Haines"
  }, {
     "name": "Hengyang Nanyue Airport",
     "countryCode": "CN",
     "iata": "HNY",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Hengyang"
  }, {
     "name": "Hola Airport",
     "countryCode": "KE",
     "iata": "HOA",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Hej"
  }, {
     "name": "Lea County Airport",
     "countryCode": "US",
     "iata": "HOB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hobbs"
  }, {
     "name": "Hodeidah Airport",
     "countryCode": "YE",
     "iata": "HOD",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Hodeidah"
  }, {
     "name": "Ban Houeisay Airport",
     "countryCode": "LA",
     "iata": "HOE",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Houeisay"
  }, {
     "name": "Al-Ahsa Airport",
     "countryCode": "SA",
     "iata": "HOF",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Hofuf"
  }, {
     "name": "Frank Pais Airport",
     "countryCode": "CU",
     "iata": "HOG",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Holguin"
  }, {
     "name": "Hohenems Airport",
     "countryCode": "AT",
     "iata": "HOH",
     "eucustoms": false,
     "countryDK": "Østrig",
     "cityDK": "Hohenems"
  }, {
     "name": "Hao Island Airport",
     "countryCode": "PF",
     "iata": "HOI",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Hao Island"
  }, {
     "name": "Hooker Creek Airport",
     "countryCode": "AU",
     "iata": "HOK",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Hooker Creek"
  }, {
     "name": "Homer Airport",
     "countryCode": "US",
     "iata": "HOM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Homer"
  }, {
     "name": "Howes Airport",
     "countryCode": "US",
     "iata": "HON",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Huron"
  }, {
     "name": "Campbell Army Airfield",
     "countryCode": "US",
     "iata": "HOP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hopkinsville"
  }, {
     "name": "Hof Airport",
     "countryCode": "DE",
     "iata": "HOQ",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Hof"
  }, {
     "name": "Horta Airport",
     "countryCode": "PT",
     "iata": "HOR",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Horta (Azorerne)"
  }, {
     "name": "Memorial Field",
     "countryCode": "US",
     "iata": "HOT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Varme kilder"
  }, {
     "name": "William P. Hobby Airport",
     "countryCode": "US",
     "iata": "HOU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Houston"
  }, {
     "name": "Hovden Airport",
     "countryCode": "NO",
     "iata": "HOV",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Orsta-Volda"
  }, {
     "name": "Homalin Airport",
     "countryCode": "MM",
     "iata": "HOX",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Homalin"
  }, {
     "name": "Salote Pilolevu Airport",
     "countryCode": "TO",
     "iata": "HPA",
     "eucustoms": false,
     "countryDK": "Tonga",
     "cityDK": "Ha'Apai"
  }, {
     "name": "Hooper Bay Airport",
     "countryCode": "US",
     "iata": "HPB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hooper Bay"
  }, {
     "name": "Cat Bi International Airport",
     "countryCode": "VN",
     "iata": "HPH",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Haiphong"
  }, {
     "name": "Westchester County Airport",
     "countryCode": "US",
     "iata": "HPN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Westchester County"
  }, {
     "name": "Hampton Municipal Airport",
     "countryCode": "US",
     "iata": "HPT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hampton"
  }, {
     "name": "Princeville Airport",
     "countryCode": "US",
     "iata": "HPV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kauai Island"
  }, {
     "name": "Baytown Airport",
     "countryCode": "US",
     "iata": "HPY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Baytown"
  }, {
     "name": "Bowerman Airport",
     "countryCode": "US",
     "iata": "HQM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hoquiam"
  }, {
     "name": "Harbin Taiping International Airport",
     "countryCode": "CN",
     "iata": "HRB",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Harbin"
  }, {
     "name": "RG Mugabe International Airport",
     "countryCode": "ZW",
     "iata": "HRE",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Harare"
  }, {
     "name": "Hurghada International Airport",
     "countryCode": "EG",
     "iata": "HRG",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Hurghada"
  }, {
     "name": "Mattala Rajapaksa International Airport",
     "countryCode": "LK",
     "iata": "HRI",
     "eucustoms": false,
     "countryDK": "Sri Lanka",
     "cityDK": "Hambantota"
  }, {
     "name": "Kharkov Airport",
     "countryCode": "UA",
     "iata": "HRK",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Kharkov"
  }, {
     "name": "Valley International Airport",
     "countryCode": "US",
     "iata": "HRL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Harlingen"
  }, {
     "name": "Boone County Airport",
     "countryCode": "US",
     "iata": "HRO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Harrison"
  }, {
     "name": "Harrismith Airport",
     "countryCode": "ZA",
     "iata": "HRS",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Harrismith"
  }, {
     "name": "Linton-On-Ouse RAF",
     "countryCode": "GB",
     "iata": "HRT",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Linton-on-Ouse"
  }, {
     "name": "Raleigh Airport",
     "countryCode": "US",
     "iata": "HSB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Harrisburg"
  }, {
     "name": "Saga Airport",
     "countryCode": "JP",
     "iata": "HSG",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Saga"
  }, {
     "name": "Henderson Executive Airport",
     "countryCode": "US",
     "iata": "HSH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Las Vegas"
  }, {
     "name": "Hastings Airport",
     "countryCode": "US",
     "iata": "HSI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hastings"
  }, {
     "name": "Huesca-Pirineos Airport",
     "countryCode": "ES",
     "iata": "HSK",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Huesca"
  }, {
     "name": "Huslia Airport",
     "countryCode": "US",
     "iata": "HSL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Huslia"
  }, {
     "name": "Horsham Airport",
     "countryCode": "AU",
     "iata": "HSM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Horsham"
  }, {
     "name": "Rumbek Airport",
     "countryCode": "SS",
     "iata": "RBX",
     "eucustoms": false,
     "countryDK": "Sydsudan",
     "cityDK": "Rumbek"
  }, {
     "name": "Ingalls Field",
     "countryCode": "US",
     "iata": "HSP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Varme kilder"
  }, {
     "name": "Homestead Air Force Base",
     "countryCode": "US",
     "iata": "HST",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Homestead"
  }, {
     "name": "Huntsville International Airport - Carl T. Jones Field",
     "countryCode": "US",
     "iata": "HSV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Huntsville"
  }, {
     "name": "Hsinchu Airport",
     "countryCode": "TW",
     "iata": "HSZ",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Hsinchu"
  }, {
     "name": "Zalingei Airport",
     "countryCode": "SD",
     "iata": "ZLX",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Zalingei"
  }, {
     "name": "Chita Airport",
     "countryCode": "RU",
     "iata": "HTA",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Chita"
  }, {
     "name": "Hatanga Airport",
     "countryCode": "RU",
     "iata": "HTG",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Hatanga"
  }, {
     "name": "Hawthorne Airport",
     "countryCode": "US",
     "iata": "HTH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hawthorne"
  }, {
     "name": "Hamilton Island Airport",
     "countryCode": "AU",
     "iata": "HTI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Hamilton Island"
  }, {
     "name": "Roscommon County Airport",
     "countryCode": "US",
     "iata": "HTL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Houghton Lake"
  }, {
     "name": "Hotan Airport",
     "countryCode": "CN",
     "iata": "HTN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Hotan"
  }, {
     "name": "East Hampton Airport",
     "countryCode": "US",
     "iata": "HTO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "East Hampton"
  }, {
     "name": "Hateruma Airport",
     "countryCode": "JP",
     "iata": "HTR",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Hateruma"
  }, {
     "name": "Tri-State/Milton Airport",
     "countryCode": "US",
     "iata": "HTS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Huntington"
  }, {
     "name": "Hopetown Airport",
     "countryCode": "AU",
     "iata": "HTU",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Hopetown"
  }, {
     "name": "Huntsville Airport",
     "countryCode": "US",
     "iata": "HTV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Huntsville"
  }, {
     "name": "Huntington County Airport",
     "countryCode": "US",
     "iata": "HTW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chesapeake"
  }, {
     "name": "Hatay Airport",
     "countryCode": "TR",
     "iata": "HTY",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Antakya"
  }, {
     "name": "Hato Corozal Airport",
     "countryCode": "CO",
     "iata": "HTZ",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Hato Corozal"
  }, {
     "name": "Redstone Army Air Field",
     "countryCode": "US",
     "iata": "HUA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Huntsville"
  }, {
     "name": "Humera Airport",
     "countryCode": "ET",
     "iata": "HUE",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Humera"
  }, {
     "name": "Hulman Field",
     "countryCode": "US",
     "iata": "HUF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Terre Haute"
  }, {
     "name": "Huahine Airport",
     "countryCode": "PF",
     "iata": "HUH",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Huahine"
  }, {
     "name": "Phu Bai International Airport",
     "countryCode": "VN",
     "iata": "HUI",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Hue"
  }, {
     "name": "Hugo Airport",
     "countryCode": "US",
     "iata": "HUJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hugo"
  }, {
     "name": "Houlton International Airport",
     "countryCode": "US",
     "iata": "HUL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Houlton"
  }, {
     "name": "Houma-Terrebonne Airport",
     "countryCode": "US",
     "iata": "HUM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Houma"
  }, {
     "name": "Hualien Airport",
     "countryCode": "TW",
     "iata": "HUN",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Hualien"
  }, {
     "name": "Houn Airport",
     "countryCode": "LY",
     "iata": "HUQ",
     "eucustoms": false,
     "countryDK": "Libyen",
     "cityDK": "Houn"
  }, {
     "name": "Hutchinson Airport",
     "countryCode": "US",
     "iata": "HUT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hutchinson"
  }, {
     "name": "Huanuco Airport",
     "countryCode": "PE",
     "iata": "HUU",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Huanuco"
  }, {
     "name": "Hudiksvall Airport",
     "countryCode": "SE",
     "iata": "HUV",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Hudiksvall"
  }, {
     "name": "Huatulco Airport",
     "countryCode": "MX",
     "iata": "HUX",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Huatulco"
  }, {
     "name": "Humberside Airport",
     "countryCode": "GB",
     "iata": "HUY",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Humberside"
  }, {
     "name": "Huizhou Airport",
     "countryCode": "CN",
     "iata": "HUZ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Huizhou"
  }, {
     "name": "Analalava Airport",
     "countryCode": "MG",
     "iata": "HVA",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Analalava"
  }, {
     "name": "Hervey Bay Airport",
     "countryCode": "AU",
     "iata": "HVB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Hervey Bay"
  }, {
     "name": "Hanksville Intermediate Airport",
     "countryCode": "US",
     "iata": "HVE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hanksville"
  }, {
     "name": "Valan Airport",
     "countryCode": "NO",
     "iata": "HVG",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Honningsvag"
  }, {
     "name": "New Haven Airport",
     "countryCode": "US",
     "iata": "HVN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "New Haven"
  }, {
     "name": "Havre City County Airport",
     "countryCode": "US",
     "iata": "HVR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Havre"
  }, {
     "name": "Hartsville Municipal Airport",
     "countryCode": "US",
     "iata": "HVS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hartsville"
  }, {
     "name": "Hayward Executive Airport",
     "countryCode": "US",
     "iata": "HWD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hayward"
  }, {
     "name": "Hwange National Park Airport",
     "countryCode": "ZW",
     "iata": "HWN",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Hwange National Park"
  }, {
     "name": "North Perry Airport",
     "countryCode": "US",
     "iata": "HWO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hollywood"
  }, {
     "name": "Hay Airport",
     "countryCode": "AU",
     "iata": "HXX",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Hay"
  }, {
     "name": "Barnstable Municipal Airport",
     "countryCode": "US",
     "iata": "HYA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hyannis"
  }, {
     "name": "Rajiv Gandhi International Airport",
     "countryCode": "IN",
     "iata": "HYD",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Hyderabad"
  }, {
     "name": "Luqiao Airport",
     "countryCode": "CN",
     "iata": "HYN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Taizhou"
  }, {
     "name": "Hayward Municipal Airport",
     "countryCode": "US",
     "iata": "HYR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hayward"
  }, {
     "name": "Hays Municipal Airport",
     "countryCode": "US",
     "iata": "HYS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hays"
  }, {
     "name": "Hyvinkaa Airport",
     "countryCode": "FI",
     "iata": "HYV",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Hyvinkaa"
  }, {
     "name": "Merville/Calonne Airport",
     "countryCode": "FR",
     "iata": "HZB",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Hazebrouck"
  }, {
     "name": "Hanzhong Airport",
     "countryCode": "CN",
     "iata": "HZG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Hanzhong"
  }, {
     "name": "Liping Airport",
     "countryCode": "CN",
     "iata": "HZH",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Liping"
  }, {
     "name": "Husavik Airport",
     "countryCode": "IS",
     "iata": "HZK",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Husavik"
  }, {
     "name": "Hazleton Airport",
     "countryCode": "US",
     "iata": "HZL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hazleton"
  }, {
     "name": "Fort MacKay/Horizon Airport",
     "countryCode": "CA",
     "iata": "HZP",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort MacKay"
  }, {
     "name": "McConnell Air Force Base",
     "countryCode": "US",
     "iata": "IAB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wichita"
  }, {
     "name": "Washington Dulles International Airport",
     "countryCode": "US",
     "iata": "IAD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dulles"
  }, {
     "name": "Niagara Falls International Airport",
     "countryCode": "US",
     "iata": "IAG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Niagara Falls"
  }, {
     "name": "George Bush Intercontinental Airport",
     "countryCode": "US",
     "iata": "IAH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Houston"
  }, {
     "name": "In Amenas Airport",
     "countryCode": "DZ",
     "iata": "IAM",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "I Amenas"
  }, {
     "name": "Bob Baker Memorial Airport",
     "countryCode": "US",
     "iata": "IAN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kiana"
  }, {
     "name": "Sayak Airport",
     "countryCode": "PH",
     "iata": "IAO",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Del Carmin"
  }, {
     "name": "Tunoshna Airport",
     "countryCode": "RU",
     "iata": "IAR",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Yaroslavl"
  }, {
     "name": "Iasi Airport",
     "countryCode": "RO",
     "iata": "IAS",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Iasi"
  }, {
     "name": "Ibadan Airport",
     "countryCode": "NG",
     "iata": "IBA",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Ibadan"
  }, {
     "name": "Ibague Airport",
     "countryCode": "CO",
     "iata": "IBE",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Ibague"
  }, {
     "name": "Iberia Airport",
     "countryCode": "PE",
     "iata": "IBP",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Iberia"
  }, {
     "name": "Ibaraki Airport",
     "countryCode": "JP",
     "iata": "IBR",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Omitami"
  }, {
     "name": "Ibiza Airport",
     "countryCode": "ES",
     "iata": "IBZ",
     "eucustoms": true,
     "countryDK": "Spanien",
     "cityDK": "Ibiza"
  }, {
     "name": "Icabaru Airport",
     "countryCode": "VE",
     "iata": "ICA",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Icabaru"
  }, {
     "name": "Cicia Airport",
     "countryCode": "FJ",
     "iata": "ICI",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Cicia"
  }, {
     "name": "Schenk Field",
     "countryCode": "US",
     "iata": "ICL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Clarinda"
  }, {
     "name": "Incheon International Airport",
     "countryCode": "KR",
     "iata": "ICN",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Seoul"
  }, {
     "name": "Nicaro Airport",
     "countryCode": "CU",
     "iata": "ICR",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Nicaro"
  }, {
     "name": "Wichita Dwight D. Eisenhower National Airport",
     "countryCode": "US",
     "iata": "ICT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wichita"
  }, {
     "name": "Idaho Falls Regional Airport",
     "countryCode": "US",
     "iata": "IDA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Idaho Falls"
  }, {
     "name": "Idre Airport",
     "countryCode": "SE",
     "iata": "IDB",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Idre"
  }, {
     "name": "Idiofa Airport",
     "countryCode": "CD",
     "iata": "IDF",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Idiofa"
  }, {
     "name": "Ida Grove Municipal Airport",
     "countryCode": "US",
     "iata": "IDG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ida Grove"
  }, {
     "name": "Indiana County Airport",
     "countryCode": "US",
     "iata": "IDI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Indiana"
  }, {
     "name": "Indulkana Airport",
     "countryCode": "AU",
     "iata": "IDK",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Indulkana"
  }, {
     "name": "Santa Isabel do Morro Airport",
     "countryCode": "BR",
     "iata": "IDO",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Santa Isabel do Morro"
  }, {
     "name": "Independence Airport",
     "countryCode": "US",
     "iata": "IDP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Independence"
  }, {
     "name": "Devi Ahilya Bai Holkar Airport",
     "countryCode": "IN",
     "iata": "IDR",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Indore"
  }, {
     "name": "Ile 'd' Yeu Airport",
     "countryCode": "FR",
     "iata": "IDY",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Ile 'd' Yeu"
  }, {
     "name": "Zielona Gora-Babimost Airport",
     "countryCode": "PL",
     "iata": "IEG",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Zielona Gora"
  }, {
     "name": "Iejima Airport",
     "countryCode": "JP",
     "iata": "IEJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Iejima"
  }, {
     "name": "Kyiv International Airport",
     "countryCode": "UA",
     "iata": "IEV",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Kiev"
  }, {
     "name": "Iowa Falls Airport",
     "countryCode": "US",
     "iata": "IFA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Iowa Falls"
  }, {
     "name": "Iffley Airport",
     "countryCode": "AU",
     "iata": "IFF",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Iffley"
  }, {
     "name": "Isafjordur Airport",
     "countryCode": "IS",
     "iata": "IFJ",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Isafjordur"
  }, {
     "name": "Innisfail Airport",
     "countryCode": "AU",
     "iata": "IFL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Innisfail"
  }, {
     "name": "Isfahan International Airport",
     "countryCode": "IR",
     "iata": "IFN",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Isfahan"
  }, {
     "name": "Ivano-Frankovsk Airport",
     "countryCode": "UA",
     "iata": "IFO",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Ivano-Frankovsk"
  }, {
     "name": "Laughlin Bullhead International Airport",
     "countryCode": "US",
     "iata": "IFP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bullhead City"
  }, {
     "name": "Inagua Airport",
     "countryCode": "BS",
     "iata": "IGA",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Inagua"
  }, {
     "name": "Igdir Airport",
     "countryCode": "TR",
     "iata": "IGD",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Igdir"
  }, {
     "name": "Ingham Airport",
     "countryCode": "AU",
     "iata": "IGH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ingham"
  }, {
     "name": "Cigli Air Base",
     "countryCode": "TR",
     "iata": "IGL",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Izmir"
  }, {
     "name": "Kingman Airport",
     "countryCode": "US",
     "iata": "IGM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kingman"
  }, {
     "name": "Maria Cristina Airport",
     "countryCode": "PH",
     "iata": "IGN",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Iligan"
  }, {
     "name": "Chigorodo Airport",
     "countryCode": "CO",
     "iata": "IGO",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Chigorodo"
  }, {
     "name": "Cataratas del Iguazu International Airport",
     "countryCode": "AR",
     "iata": "IGR",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Iguazu"
  }, {
     "name": "Cataratas International Airport",
     "countryCode": "BR",
     "iata": "IGU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Iguassu Falls"
  }, {
     "name": "Inhaca Airport",
     "countryCode": "MZ",
     "iata": "IHC",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Inhaca"
  }, {
     "name": "Qishn Airport",
     "countryCode": "YE",
     "iata": "IHN",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Qishn"
  }, {
     "name": "Ihosy Airport",
     "countryCode": "MG",
     "iata": "IHO",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Ihosy"
  }, {
     "name": "Iranshahr Airport",
     "countryCode": "IR",
     "iata": "IHR",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Iranshahr"
  }, {
     "name": "Inishmaan Airport",
     "countryCode": "IE",
     "iata": "IIA",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Inishmaan"
  }, {
     "name": "J. Batista Bos Filho Airport",
     "countryCode": "BR",
     "iata": "IJU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Ijui"
  }, {
     "name": "Jacksonville Municipal Airport",
     "countryCode": "US",
     "iata": "IJX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jacksonville"
  }, {
     "name": "Imam Khomeini International Airport",
     "countryCode": "IR",
     "iata": "IKA",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Teheran"
  }, {
     "name": "Wilkes County Airport",
     "countryCode": "US",
     "iata": "IKB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wilkesboro"
  }, {
     "name": "Ikerasak Heliport",
     "countryCode": "GL",
     "iata": "IKE",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Ikerasak"
  }, {
     "name": "Iki Airport",
     "countryCode": "JP",
     "iata": "IKI",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Iki"
  }, {
     "name": "Greater Kankakee Airport",
     "countryCode": "US",
     "iata": "IKK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kankakee"
  }, {
     "name": "Ikela Airport",
     "countryCode": "CD",
     "iata": "IKL",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Ikela"
  }, {
     "name": "Irkutsk International Airport",
     "countryCode": "RU",
     "iata": "IKT",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Irkutsk"
  }, {
     "name": "Issyk-Kul International Airport",
     "countryCode": "KG",
     "iata": "IKU",
     "eucustoms": false,
     "countryDK": "Kirgisistan",
     "cityDK": "Tamchy"
  }, {
     "name": "Skylark Field",
     "countryCode": "US",
     "iata": "ILE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Killeen"
  }, {
     "name": "Ilford Airport",
     "countryCode": "CA",
     "iata": "ILF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Ilford"
  }, {
     "name": "New Castle Airport",
     "countryCode": "US",
     "iata": "ILG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wilmington"
  }, {
     "name": "Iliamna Airport",
     "countryCode": "US",
     "iata": "ILI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Iliamna"
  }, {
     "name": "Ilaka Airport",
     "countryCode": "MG",
     "iata": "ILK",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Ilaka"
  }, {
     "name": "Willmar Airport",
     "countryCode": "US",
     "iata": "ILL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Willmar"
  }, {
     "name": "Wilmington International Airport",
     "countryCode": "US",
     "iata": "ILM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wilmington"
  }, {
     "name": "Wilmington Airpark",
     "countryCode": "US",
     "iata": "ILN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wilmington"
  }, {
     "name": "Mandurriao Airport",
     "countryCode": "PH",
     "iata": "ILO",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Iloilo"
  }, {
     "name": "Ile Des Pins Airport",
     "countryCode": "NC",
     "iata": "ILP",
     "eucustoms": false,
     "countryDK": "Ny Kaledonien",
     "cityDK": "Ile Des Pins"
  }, {
     "name": "Ilo Airport",
     "countryCode": "PE",
     "iata": "ILQ",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Ilo"
  }, {
     "name": "Ilorin International Airport",
     "countryCode": "NG",
     "iata": "ILR",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Ilorin"
  }, {
     "name": "Kilaguni Airport",
     "countryCode": "KE",
     "iata": "ILU",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Kilaguni"
  }, {
     "name": "Glenegedale Airport",
     "countryCode": "GB",
     "iata": "ILY",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Islay"
  }, {
     "name": "Zilina Airport",
     "countryCode": "SK",
     "iata": "ILZ",
     "eucustoms": false,
     "countryDK": "Slovakiet",
     "cityDK": "Zilina"
  }, {
     "name": "Imbaimadai Airport",
     "countryCode": "GY",
     "iata": "IMB",
     "eucustoms": false,
     "countryDK": "Guyana",
     "cityDK": "Imbaimadai"
  }, {
     "name": "Imphal Municipal Airport",
     "countryCode": "IN",
     "iata": "IMF",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Imphal"
  }, {
     "name": "Simikot Airport",
     "countryCode": "NP",
     "iata": "IMK",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Simikot"
  }, {
     "name": "Imperial Airport",
     "countryCode": "US",
     "iata": "IML",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kejserlig"
  }, {
     "name": "Immokalee Airport",
     "countryCode": "US",
     "iata": "IMM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Immokalee"
  }, {
     "name": "Zemio Airport",
     "countryCode": "CF",
     "iata": "IMO",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "Zemio"
  }, {
     "name": "Imperatriz Airport",
     "countryCode": "BR",
     "iata": "IMP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Imperatriz"
  }, {
     "name": "Ford Airport",
     "countryCode": "US",
     "iata": "IMT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Iron Mountain"
  }, {
     "name": "Yinchuan Hedong International Airport",
     "countryCode": "CN",
     "iata": "INC",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Yinchuan"
  }, {
     "name": "Indianapolis International Airport",
     "countryCode": "US",
     "iata": "IND",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Indianapolis"
  }, {
     "name": "In Guezzam Airport",
     "countryCode": "DZ",
     "iata": "INF",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "I Guezzam"
  }, {
     "name": "Lago Argentino Airport",
     "countryCode": "AR",
     "iata": "ING",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Lago Argentino"
  }, {
     "name": "Inhambane Airport",
     "countryCode": "MZ",
     "iata": "INH",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Inhambane"
  }, {
     "name": "Nis Constantine the Great Airport",
     "countryCode": "RS",
     "iata": "INI",
     "eucustoms": false,
     "countryDK": "Serbien",
     "cityDK": "Nis"
  }, {
     "name": "Injune Airport",
     "countryCode": "AU",
     "iata": "INJ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Injune"
  }, {
     "name": "Wink Airport",
     "countryCode": "US",
     "iata": "INK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wink"
  }, {
     "name": "Falls International Airport",
     "countryCode": "US",
     "iata": "INL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "International Falls"
  }, {
     "name": "Innamincka Airport",
     "countryCode": "AU",
     "iata": "INM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Innamincka"
  }, {
     "name": "Innsbruck Airport",
     "countryCode": "AT",
     "iata": "INN",
     "eucustoms": true,
     "countryDK": "Østrig",
     "cityDK": "Innsbruck"
  }, {
     "name": "Inongo Airport",
     "countryCode": "CD",
     "iata": "INO",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Inongo"
  }, {
     "name": "Inisheer Airport",
     "countryCode": "IE",
     "iata": "INQ",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Inisheer"
  }, {
     "name": "Af Aux Airport",
     "countryCode": "US",
     "iata": "INS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Indian Springs"
  }, {
     "name": "Smith-Reynolds Airport",
     "countryCode": "US",
     "iata": "INT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Winston-Salem"
  }, {
     "name": "Nauru Island International Airport",
     "countryCode": "NR",
     "iata": "INU",
     "eucustoms": false,
     "countryDK": "Nauru",
     "cityDK": "Nauru Island"
  }, {
     "name": "Inverness Airport",
     "countryCode": "GB",
     "iata": "INV",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Inverness"
  }, {
     "name": "Winslow Airport",
     "countryCode": "US",
     "iata": "INW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Winslow"
  }, {
     "name": "In Salah Airport",
     "countryCode": "DZ",
     "iata": "INZ",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "I Salah"
  }, {
     "name": "Ioannina Airport",
     "countryCode": "GR",
     "iata": "IOA",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Ioannina"
  }, {
     "name": "Isle of Man Airport",
     "countryCode": "GB",
     "iata": "IOM",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Isle of Man"
  }, {
     "name": "Impfondo Airport",
     "countryCode": "CG",
     "iata": "ION",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Impfondo"
  }, {
     "name": "Isortoq Heliport",
     "countryCode": "GL",
     "iata": "IOQ",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Isortoq"
  }, {
     "name": "Ilheus/Bahia-Jorge Amado Airport",
     "countryCode": "BR",
     "iata": "IOS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Ilheus"
  }, {
     "name": "Illorsuit Heliport",
     "countryCode": "GL",
     "iata": "IOT",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Illorsuit"
  }, {
     "name": "Iowa City Airport",
     "countryCode": "US",
     "iata": "IOW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Iowa City"
  }, {
     "name": "Ipota Airport",
     "countryCode": "VU",
     "iata": "IPA",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Ipota"
  }, {
     "name": "Mataveri International Airport",
     "countryCode": "CL",
     "iata": "IPC",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Påskeøen"
  }, {
     "name": "Ipiranga Airport",
     "countryCode": "BR",
     "iata": "IPG",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Ipiranga"
  }, {
     "name": "Ipoh Airport",
     "countryCode": "MY",
     "iata": "IPH",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Ipoh"
  }, {
     "name": "San Luis Airport",
     "countryCode": "CO",
     "iata": "IPI",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Ipiales"
  }, {
     "name": "Imperial County Airport",
     "countryCode": "US",
     "iata": "IPL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kejserlig"
  }, {
     "name": "Usiminas Airport",
     "countryCode": "BR",
     "iata": "IPN",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Ipatinga"
  }, {
     "name": "Lycoming County Airport",
     "countryCode": "US",
     "iata": "IPT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Williamsport"
  }, {
     "name": "Qiemo Airport",
     "countryCode": "CN",
     "iata": "IQM",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Qiemo"
  }, {
     "name": "Diego Aracena International Airport",
     "countryCode": "CL",
     "iata": "IQQ",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Iquique"
  }, {
     "name": "C.F. Secada Vignetta International Airport",
     "countryCode": "PE",
     "iata": "IQT",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Iquitos"
  }, {
     "name": "Circle City Airport",
     "countryCode": "US",
     "iata": "IRC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cirkel"
  }, {
     "name": "Ishurdi Airport",
     "countryCode": "BD",
     "iata": "IRD",
     "eucustoms": false,
     "countryDK": "Bangladesh",
     "cityDK": "Ishurdi"
  }, {
     "name": "Irece Airport",
     "countryCode": "BR",
     "iata": "IRE",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Irece"
  }, {
     "name": "Lockhart River Airport",
     "countryCode": "AU",
     "iata": "IRG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Lockhart River"
  }, {
     "name": "Nduli Airport",
     "countryCode": "TZ",
     "iata": "IRI",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Iringa"
  }, {
     "name": "La Rioja Airport",
     "countryCode": "AR",
     "iata": "IRJ",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "La Rioja"
  }, {
     "name": "Kirksville Municipal Airport",
     "countryCode": "US",
     "iata": "IRK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kirksville"
  }, {
     "name": "Igrim Airport",
     "countryCode": "RU",
     "iata": "IRM",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Igrim"
  }, {
     "name": "Birao Airport",
     "countryCode": "CF",
     "iata": "IRO",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "Birao"
  }, {
     "name": "Matari Airport",
     "countryCode": "CD",
     "iata": "IRP",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Isiro"
  }, {
     "name": "Kirsch Municipal",
     "countryCode": "US",
     "iata": "IRS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sturgis"
  }, {
     "name": "Mount Isa Airport",
     "countryCode": "AU",
     "iata": "ISA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mount Isa"
  }, {
     "name": "Islamabad International Airport",
     "countryCode": "PK",
     "iata": "ISB",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Islamabad"
  }, {
     "name": "Isles of Scilly Airport",
     "countryCode": "GB",
     "iata": "ISC",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Isles of Scilly"
  }, {
     "name": "Isparta Suleyman Demirel Airport",
     "countryCode": "TR",
     "iata": "ISE",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Isparta"
  }, {
     "name": "Painushima Ishigaki Airport",
     "countryCode": "JP",
     "iata": "ISG",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Ishigaki"
  }, {
     "name": "Isisford Airport",
     "countryCode": "AU",
     "iata": "ISI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Isisford"
  }, {
     "name": "Isla Mujeres Airport",
     "countryCode": "MX",
     "iata": "ISJ",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Isla Mujeres"
  }, {
     "name": "Istanbul Airport",
     "countryCode": "TR",
     "iata": "ISL",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Istanbul"
  }, {
     "name": "Kissimmee Gateway Airport",
     "countryCode": "US",
     "iata": "ISM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kissimmee"
  }, {
     "name": "Sloulin Field International Airport",
     "countryCode": "US",
     "iata": "ISN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Williston"
  }, {
     "name": "Kinston Regional Jetport",
     "countryCode": "US",
     "iata": "ISO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kinston"
  }, {
     "name": "Long Island MacArthur Airport",
     "countryCode": "US",
     "iata": "ISP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Islip"
  }, {
     "name": "Schoolcraft County Airport",
     "countryCode": "US",
     "iata": "ISQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Manistique"
  }, {
     "name": "Wiscasset Airport",
     "countryCode": "US",
     "iata": "ISS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wiscasset"
  }, {
     "name": "Istanbul Ataturk Airport",
     "countryCode": "TR",
     "iata": "IST",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Istanbul"
  }, {
     "name": "Sulaimaniyah International Airport",
     "countryCode": "IQ",
     "iata": "ISU",
     "eucustoms": false,
     "countryDK": "Irak",
     "cityDK": "Sulaimaniyah"
  }, {
     "name": "South Wood County Airport",
     "countryCode": "US",
     "iata": "ISW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wisconsin Rapids"
  }, {
     "name": "Itacoatiara Airport",
     "countryCode": "BR",
     "iata": "ITA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Itacoatiara"
  }, {
     "name": "Itaituba Airport",
     "countryCode": "BR",
     "iata": "ITB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Itaituba"
  }, {
     "name": "Ithaca Tompkins Regional Airport",
     "countryCode": "US",
     "iata": "ITH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ithaca"
  }, {
     "name": "Itambacuri Airport",
     "countryCode": "BR",
     "iata": "ITI",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Itambacuri"
  }, {
     "name": "Itami Airport",
     "countryCode": "JP",
     "iata": "ITM",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Osaka"
  }, {
     "name": "Itabuna Airport",
     "countryCode": "BR",
     "iata": "ITN",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Itabuna"
  }, {
     "name": "Hilo International Airport",
     "countryCode": "US",
     "iata": "ITO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hilo"
  }, {
     "name": "Itaqui Airport",
     "countryCode": "BR",
     "iata": "ITQ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Itaqui"
  }, {
     "name": "Hanan Airport",
     "countryCode": "NU",
     "iata": "IUE",
     "eucustoms": false,
     "countryDK": "Niue",
     "cityDK": "Niue Island"
  }, {
     "name": "Innarsuit Heliport",
     "countryCode": "GL",
     "iata": "IUI",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Innaarsuit"
  }, {
     "name": "Ambanja Airport",
     "countryCode": "MG",
     "iata": "IVA",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Ambanja"
  }, {
     "name": "Invercargill Airport",
     "countryCode": "NZ",
     "iata": "IVC",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Invercargill"
  }, {
     "name": "Ivalo Airport",
     "countryCode": "FI",
     "iata": "IVL",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Ivalo"
  }, {
     "name": "Inverell Airport",
     "countryCode": "AU",
     "iata": "IVR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Inverell"
  }, {
     "name": "Gogebic County Airport",
     "countryCode": "US",
     "iata": "IWD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ironwood"
  }, {
     "name": "Hagi-Iwami Airport",
     "countryCode": "JP",
     "iata": "IWJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Masuda"
  }, {
     "name": "Iwoto (Iwo Jima) Air Base",
     "countryCode": "JP",
     "iata": "IWO",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Iwoto (Iwo Jima)"
  }, {
     "name": "West Houston Airport",
     "countryCode": "US",
     "iata": "IWS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Houston"
  }, {
     "name": "Agartala Airport",
     "countryCode": "IN",
     "iata": "IXA",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Agartala"
  }, {
     "name": "Bagdogra Airport",
     "countryCode": "IN",
     "iata": "IXB",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Bagdogra"
  }, {
     "name": "Chandigarh Airport",
     "countryCode": "IN",
     "iata": "IXC",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Chandigarh"
  }, {
     "name": "Allahabad Airport",
     "countryCode": "IN",
     "iata": "IXD",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Allahabad"
  }, {
     "name": "Mangalore Airport",
     "countryCode": "IN",
     "iata": "IXE",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Mangalore"
  }, {
     "name": "Belgaum Airport",
     "countryCode": "IN",
     "iata": "IXG",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Belgaum"
  }, {
     "name": "Kailashahar Airport",
     "countryCode": "IN",
     "iata": "IXH",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Kailashahar"
  }, {
     "name": "Lilabari Airport",
     "countryCode": "IN",
     "iata": "IXI",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Lilabari"
  }, {
     "name": "Satwari Airport",
     "countryCode": "IN",
     "iata": "IXJ",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Jammu"
  }, {
     "name": "Keshod Airport",
     "countryCode": "IN",
     "iata": "IXK",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Keshod"
  }, {
     "name": "Leh Airport",
     "countryCode": "IN",
     "iata": "IXL",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Leh"
  }, {
     "name": "Madurai Airport",
     "countryCode": "IN",
     "iata": "IXM",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Madurai"
  }, {
     "name": "Pathankot Airport",
     "countryCode": "IN",
     "iata": "IXP",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Pathankot"
  }, {
     "name": "Kamalpur Airport",
     "countryCode": "IN",
     "iata": "IXQ",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Kamalpur"
  }, {
     "name": "Birsa Munda Airport",
     "countryCode": "IN",
     "iata": "IXR",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Ranchi"
  }, {
     "name": "Kumbhirgram Airport",
     "countryCode": "IN",
     "iata": "IXS",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Silchar"
  }, {
     "name": "Pasighat Airport",
     "countryCode": "IN",
     "iata": "IXT",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Pasighat"
  }, {
     "name": "Chikkalthana Airport",
     "countryCode": "IN",
     "iata": "IXU",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Aurangabad"
  }, {
     "name": "Sonari Airport",
     "countryCode": "IN",
     "iata": "IXW",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Jamshedpur"
  }, {
     "name": "Kandla Airport",
     "countryCode": "IN",
     "iata": "IXY",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Kandla"
  }, {
     "name": "Port Blair Airport",
     "countryCode": "IN",
     "iata": "IXZ",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Port Blair"
  }, {
     "name": "Kern County Airport",
     "countryCode": "US",
     "iata": "IYK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Inyokern"
  }, {
     "name": "Zona da Mata Regional Airport",
     "countryCode": "BR",
     "iata": "IZA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Juiz de Fora"
  }, {
     "name": "Izumo Airport",
     "countryCode": "JP",
     "iata": "IZO",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Izumo"
  }, {
     "name": "Ixtepec Airport",
     "countryCode": "MX",
     "iata": "IZT",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Ixtepec"
  }, {
     "name": "Jalalabad Airport",
     "countryCode": "AF",
     "iata": "JAA",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Jalalabad"
  }, {
     "name": "Jabiru Airport",
     "countryCode": "AU",
     "iata": "JAB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Jabiru"
  }, {
     "name": "Jackson Hole Airport",
     "countryCode": "US",
     "iata": "JAC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jackson"
  }, {
     "name": "Jandakot Airport",
     "countryCode": "AU",
     "iata": "JAD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Jandakot"
  }, {
     "name": "Shumba Airport",
     "countryCode": "PE",
     "iata": "JAE",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Jaen"
  }, {
     "name": "Kankesanturai Airport",
     "countryCode": "LK",
     "iata": "JAF",
     "eucustoms": false,
     "countryDK": "Sri Lanka",
     "cityDK": "Jaffna"
  }, {
     "name": "Jacobabad Airport",
     "countryCode": "PK",
     "iata": "JAG",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Jacobabad"
  }, {
     "name": "Jaipur Airport",
     "countryCode": "IN",
     "iata": "JAI",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Jaipur"
  }, {
     "name": "Jacmel Airport",
     "countryCode": "HT",
     "iata": "JAK",
     "eucustoms": false,
     "countryDK": "Haiti",
     "cityDK": "Jacmel"
  }, {
     "name": "El Lencero Airport",
     "countryCode": "MX",
     "iata": "JAL",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Xalapa"
  }, {
     "name": "Jackson-Evers International Airport",
     "countryCode": "US",
     "iata": "JAN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jackson"
  }, {
     "name": "Jahrom Airport",
     "countryCode": "IR",
     "iata": "JAR",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Jahrom"
  }, {
     "name": "Jasper County-Bell Field",
     "countryCode": "US",
     "iata": "JAS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "jaspis"
  }, {
     "name": "Jauja Airport",
     "countryCode": "PE",
     "iata": "JAU",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Jauja"
  }, {
     "name": "Ilulissat Airport",
     "countryCode": "GL",
     "iata": "JAV",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Ilulissat"
  }, {
     "name": "Jacksonville International Airport",
     "countryCode": "US",
     "iata": "JAX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jacksonville"
  }, {
     "name": "Dr. Joaquin Balaguer International Airport",
     "countryCode": "DO",
     "iata": "JBQ",
     "eucustoms": false,
     "countryDK": "Dominikanske Republik",
     "cityDK": "Santo Domingo"
  }, {
     "name": "Jonesboro Airport",
     "countryCode": "US",
     "iata": "JBR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jonesboro"
  }, {
     "name": "Joacaba Airport",
     "countryCode": "BR",
     "iata": "JCB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Joacaba"
  }, {
     "name": "Julia Creek Airport",
     "countryCode": "AU",
     "iata": "JCK",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Julia Creek"
  }, {
     "name": "Jacobina Airport",
     "countryCode": "BR",
     "iata": "JCM",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Jacobina"
  }, {
     "name": "Jacareacanga Airport",
     "countryCode": "BR",
     "iata": "JCR",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Jacareacanga"
  }, {
     "name": "Kimble County Airport",
     "countryCode": "US",
     "iata": "JCT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Junction"
  }, {
     "name": "Johnson Airport",
     "countryCode": "US",
     "iata": "JCY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Johnson"
  }, {
     "name": "Francisco De Assis Airport",
     "countryCode": "BR",
     "iata": "JDF",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Juiz De Fora"
  }, {
     "name": "Jodhpur Airport",
     "countryCode": "IN",
     "iata": "JDH",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Jodhpur"
  }, {
     "name": "Jordan Airport",
     "countryCode": "US",
     "iata": "JDN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jordan"
  }, {
     "name": "Orlando Bezerra de Menezes Airport",
     "countryCode": "BR",
     "iata": "JDO",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Juazeiro Do Norte"
  }, {
     "name": "Jingdezhen Airport",
     "countryCode": "CN",
     "iata": "JDZ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Jingdezhen"
  }, {
     "name": "King Abdulaziz International Airport",
     "countryCode": "SA",
     "iata": "JED",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Jeddah"
  }, {
     "name": "Jeremie Airport",
     "countryCode": "HT",
     "iata": "JEE",
     "eucustoms": false,
     "countryDK": "Haiti",
     "cityDK": "Jeremie"
  }, {
     "name": "Jefferson City Memorial Airport",
     "countryCode": "US",
     "iata": "JEF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jefferson City"
  }, {
     "name": "Aasiaat Airport",
     "countryCode": "GL",
     "iata": "JEG",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Aasiaat"
  }, {
     "name": "Jeki Airstrip",
     "countryCode": "ZM",
     "iata": "JEK",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Jeki"
  }, {
     "name": "Jequie Airport",
     "countryCode": "BR",
     "iata": "JEQ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Jequie"
  }, {
     "name": "Jersey Airport",
     "countryCode": "GB",
     "iata": "JER",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Jersey"
  }, {
     "name": "John F. Kennedy International Airport",
     "countryCode": "US",
     "iata": "JFK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "New York"
  }, {
     "name": "Paamiut Airport",
     "countryCode": "GL",
     "iata": "JFR",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Paamiut"
  }, {
     "name": "Govardhanpur Airport",
     "countryCode": "IN",
     "iata": "JGA",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Jamnagar"
  }, {
     "name": "Senai Airport",
     "countryCode": "MY",
     "iata": "JHB",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Johor Bharu"
  }, {
     "name": "Kapalua Airport",
     "countryCode": "US",
     "iata": "JHM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kapalua"
  }, {
     "name": "Sisimiut Airport",
     "countryCode": "GL",
     "iata": "JHS",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Sisimiut"
  }, {
     "name": "Jamestown Airport",
     "countryCode": "US",
     "iata": "JHW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jamestown"
  }, {
     "name": "Juina Airport",
     "countryCode": "BR",
     "iata": "JIA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Juina"
  }, {
     "name": "Djibouti-Ambouli International Airport",
     "countryCode": "DJ",
     "iata": "JIB",
     "eucustoms": false,
     "countryDK": "Djibouti",
     "cityDK": "Djibouti"
  }, {
     "name": "Ikaria Airport",
     "countryCode": "GR",
     "iata": "JIK",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Ikaria Island"
  }, {
     "name": "Jimma Airport",
     "countryCode": "ET",
     "iata": "JIM",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Jimma"
  }, {
     "name": "Jinja Airport",
     "countryCode": "UG",
     "iata": "JIN",
     "eucustoms": false,
     "countryDK": "Uganda",
     "cityDK": "Jinja"
  }, {
     "name": "Jiwani Airport",
     "countryCode": "PK",
     "iata": "JIW",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Jiwani"
  }, {
     "name": "Jajao Airport",
     "countryCode": "SB",
     "iata": "JJA",
     "eucustoms": false,
     "countryDK": "Salomonøerne",
     "cityDK": "Santa Isabel Island"
  }, {
     "name": "Humberto Bortoluzzi Regional Airport",
     "countryCode": "BR",
     "iata": "JJG",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Jaguaruna"
  }, {
     "name": "Juanjui Airport",
     "countryCode": "PE",
     "iata": "JJI",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Juanjui"
  }, {
     "name": "Mulika Lodge Airport",
     "countryCode": "KE",
     "iata": "JJM",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Meru"
  }, {
     "name": "Quanzhou Jinjiang International Airport",
     "countryCode": "CN",
     "iata": "JJN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Jinjiang"
  }, {
     "name": "Jonkoping Airport",
     "countryCode": "SE",
     "iata": "JKG",
     "eucustoms": true,
     "countryDK": "Sverige",
     "cityDK": "Jönköping"
  }, {
     "name": "Chios Airport",
     "countryCode": "GR",
     "iata": "JKH",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Chios"
  }, {
     "name": "Kalymnos Island National Airport",
     "countryCode": "GR",
     "iata": "JKL",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Kalymnos"
  }, {
     "name": "Janakpur Airport",
     "countryCode": "NP",
     "iata": "JKR",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Janakpur"
  }, {
     "name": "Landskrona Heliport",
     "countryCode": "SE",
     "iata": "JLD",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Landskrona"
  }, {
     "name": "Joplin Airport",
     "countryCode": "US",
     "iata": "JLN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Joplin"
  }, {
     "name": "Jabalpur Airport",
     "countryCode": "IN",
     "iata": "JLR",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Jabalpur"
  }, {
     "name": "Jales Airport",
     "countryCode": "BR",
     "iata": "JLS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "jales"
  }, {
     "name": "Mikonos Airport",
     "countryCode": "GR",
     "iata": "JMK",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Mikonos"
  }, {
     "name": "Jomsom Airport",
     "countryCode": "NP",
     "iata": "JMO",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Jomsom"
  }, {
     "name": "Jamestown Airport",
     "countryCode": "US",
     "iata": "JMS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jamestown"
  }, {
     "name": "Jiamusi Airport",
     "countryCode": "CN",
     "iata": "JMU",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Jiamusi"
  }, {
     "name": "Januaria Airport",
     "countryCode": "BR",
     "iata": "JNA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Januaria"
  }, {
     "name": "O.R. Tambo International Airport",
     "countryCode": "ZA",
     "iata": "JNB",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Johannesburg"
  }, {
     "name": "Junin Airport",
     "countryCode": "AR",
     "iata": "JNI",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Junin"
  }, {
     "name": "Duqm Jaaluni Airport",
     "countryCode": "OM",
     "iata": "JNJ",
     "eucustoms": false,
     "countryDK": "Oman",
     "cityDK": "Duqm"
  }, {
     "name": "Nanortalik Heliport",
     "countryCode": "GL",
     "iata": "JNN",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Nanortalik"
  }, {
     "name": "Juneau International Airport",
     "countryCode": "US",
     "iata": "JNU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Juneau"
  }, {
     "name": "Naxos Airport",
     "countryCode": "GR",
     "iata": "JNX",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Naxos, Cycladesøerne"
  }, {
     "name": "Joensuu Airport",
     "countryCode": "FI",
     "iata": "JOE",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Joensuu"
  }, {
     "name": "Adisutjipto International Airport",
     "countryCode": "ID",
     "iata": "JOG",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Yogyakarta"
  }, {
     "name": "Lauro Carneiro de Loyola Airport",
     "countryCode": "BR",
     "iata": "JOI",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Joinville"
  }, {
     "name": "Jolo Airport",
     "countryCode": "PH",
     "iata": "JOL",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Jolo"
  }, {
     "name": "Njombe Airport",
     "countryCode": "TZ",
     "iata": "JOM",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Njombe"
  }, {
     "name": "Teniente R. Marsh Martin Airport",
     "countryCode": "AQ",
     "iata": "TNM",
     "eucustoms": false,
     "countryDK": "Antarktis",
     "cityDK": "King George Island"
  }, {
     "name": "Jos Airport",
     "countryCode": "NG",
     "iata": "JOS",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Jos"
  }, {
     "name": "Joliet Municipal Airport",
     "countryCode": "US",
     "iata": "JOT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Joliet"
  }, {
     "name": "Presidente Castro Pinto International Airport",
     "countryCode": "BR",
     "iata": "JPA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Joao Pessoa"
  }, {
     "name": "Ji-Parana Airport",
     "countryCode": "BR",
     "iata": "JPR",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Ji-Parana"
  }, {
     "name": "Jaque Airport",
     "countryCode": "PA",
     "iata": "JQE",
     "eucustoms": false,
     "countryDK": "Panama",
     "cityDK": "Jaque"
  }, {
     "name": "Kalaeloa Airport",
     "countryCode": "US",
     "iata": "JRF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kapolei"
  }, {
     "name": "Rowriah Airport",
     "countryCode": "IN",
     "iata": "JRH",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Jorhat"
  }, {
     "name": "Juruena Airport",
     "countryCode": "BR",
     "iata": "JRN",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Juruena"
  }, {
     "name": "Kilimanjaro International Airport",
     "countryCode": "TZ",
     "iata": "JRO",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Kilimanjaro"
  }, {
     "name": "Jerusalem Airport",
     "countryCode": "IL",
     "iata": "JRS",
     "eucustoms": false,
     "countryDK": "Israel",
     "cityDK": "Jerusalem"
  }, {
     "name": "Sitia Airport",
     "countryCode": "GR",
     "iata": "JSH",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Sitia"
  }, {
     "name": "Skiathos Airport",
     "countryCode": "GR",
     "iata": "JSI",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Skiathos"
  }, {
     "name": "Jose San de Martin Airport",
     "countryCode": "AR",
     "iata": "JSM",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Jose San de Martin"
  }, {
     "name": "Jessore Airport",
     "countryCode": "BD",
     "iata": "JSR",
     "eucustoms": false,
     "countryDK": "Bangladesh",
     "cityDK": "Jessore"
  }, {
     "name": "Cambria County Airport",
     "countryCode": "US",
     "iata": "JST",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Johnstown"
  }, {
     "name": "Maniitsoq Airport",
     "countryCode": "GL",
     "iata": "JSU",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Maniitsoq"
  }, {
     "name": "Syros Island Airport",
     "countryCode": "GR",
     "iata": "JSY",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Syros Island"
  }, {
     "name": "Bauru-Arealva Airport",
     "countryCode": "BR",
     "iata": "JTC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Baura-Arealva"
  }, {
     "name": "Santorini International Airport",
     "countryCode": "GR",
     "iata": "JTR",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Thira"
  }, {
     "name": "Astypalaia Airport",
     "countryCode": "GR",
     "iata": "JTY",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Astypalaia Island"
  }, {
     "name": "Juba International Airport",
     "countryCode": "SS",
     "iata": "JUB",
     "eucustoms": false,
     "countryDK": "Sydsudan",
     "cityDK": "Juba"
  }, {
     "name": "Juist Airport",
     "countryCode": "DE",
     "iata": "JUI",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Juist"
  }, {
     "name": "El Cadillal Airport",
     "countryCode": "AR",
     "iata": "JUJ",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Jujuy"
  }, {
     "name": "Ukkusissat Heliport",
     "countryCode": "GL",
     "iata": "JUK",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Ukkusissat"
  }, {
     "name": "Juliaca Airport",
     "countryCode": "PE",
     "iata": "JUL",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Juliaca"
  }, {
     "name": "Jumla Airport",
     "countryCode": "NP",
     "iata": "JUM",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Jumla"
  }, {
     "name": "Jundah Airport",
     "countryCode": "AU",
     "iata": "JUN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Jundah"
  }, {
     "name": "Nuugaatsiaq Heliport",
     "countryCode": "GL",
     "iata": "JUU",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Nuugaatsiaq"
  }, {
     "name": "Upernavik Airport",
     "countryCode": "GL",
     "iata": "JUV",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Upernavik"
  }, {
     "name": "Ankavandra Airport",
     "countryCode": "MG",
     "iata": "JVA",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Ankavandra"
  }, {
     "name": "Rock County Airport",
     "countryCode": "US",
     "iata": "JVL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Janesville"
  }, {
     "name": "Jwaneng Airport",
     "countryCode": "BW",
     "iata": "JWA",
     "eucustoms": false,
     "countryDK": "Botswana",
     "cityDK": "Jwaneng"
  }, {
     "name": "Zanjan Airport",
     "countryCode": "IR",
     "iata": "JWN",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Zanjan"
  }, {
     "name": "Jixi Airport",
     "countryCode": "CN",
     "iata": "JXA",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Jixi"
  }, {
     "name": "Jackson County Airport",
     "countryCode": "US",
     "iata": "JXN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jackson"
  }, {
     "name": "Jiroft Airport",
     "countryCode": "IR",
     "iata": "JYR",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Jiroft"
  }, {
     "name": "Jyvaskyla Airport",
     "countryCode": "FI",
     "iata": "JYV",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Jyväskylä"
  }, {
     "name": "Kasama Airport",
     "countryCode": "ZM",
     "iata": "KAA",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Kasama"
  }, {
     "name": "Kariba Airport",
     "countryCode": "ZW",
     "iata": "KAB",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Kariba"
  }, {
     "name": "Kameshly Airport",
     "countryCode": "SY",
     "iata": "KAC",
     "eucustoms": false,
     "countryDK": "Syrien",
     "cityDK": "Kameshli"
  }, {
     "name": "Kaduna Airport",
     "countryCode": "NG",
     "iata": "KAD",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Kaduna"
  }, {
     "name": "Gangneung Air Base",
     "countryCode": "KR",
     "iata": "KAG",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Gangneung"
  }, {
     "name": "Kajaani Airport",
     "countryCode": "FI",
     "iata": "KAJ",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Kajaani"
  }, {
     "name": "Mallam Aminu Kano International Airport",
     "countryCode": "NG",
     "iata": "KAN",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Kano"
  }, {
     "name": "Sault Ste Marie Municipal Airport",
     "countryCode": "US",
     "iata": "SSM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sault Ste Marie"
  }, {
     "name": "Kuusamo Airport",
     "countryCode": "FI",
     "iata": "KAO",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Kuusamo"
  }, {
     "name": "Kapanga Airport",
     "countryCode": "CD",
     "iata": "KAP",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kapanga"
  }, {
     "name": "Kamarang Airport",
     "countryCode": "GY",
     "iata": "KAR",
     "eucustoms": false,
     "countryDK": "Guyana",
     "cityDK": "Kamarang"
  }, {
     "name": "Kaitaia Airport",
     "countryCode": "NZ",
     "iata": "KAT",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Kaitaia"
  }, {
     "name": "Kauhava Airport",
     "countryCode": "FI",
     "iata": "KAU",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Kauhava"
  }, {
     "name": "Kavanayen Airport",
     "countryCode": "VE",
     "iata": "KAV",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Kavanayen"
  }, {
     "name": "Kawthaung Airport",
     "countryCode": "MM",
     "iata": "KAW",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Kawthaung"
  }, {
     "name": "Kalbarri Airport",
     "countryCode": "AU",
     "iata": "KAX",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kalbarri"
  }, {
     "name": "Kabala Airport",
     "countryCode": "SL",
     "iata": "KBA",
     "eucustoms": false,
     "countryDK": "Sierra Leone",
     "cityDK": "Kabala"
  }, {
     "name": "Kabalega Falls Airport",
     "countryCode": "UG",
     "iata": "KBG",
     "eucustoms": false,
     "countryDK": "Uganda",
     "cityDK": "Kabalega Falls"
  }, {
     "name": "Kribi Airport",
     "countryCode": "CM",
     "iata": "KBI",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Kribi"
  }, {
     "name": "Kabul International Airport",
     "countryCode": "AF",
     "iata": "KBL",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Kabul"
  }, {
     "name": "Kabinda Airport",
     "countryCode": "CD",
     "iata": "KBN",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kabinda"
  }, {
     "name": "Kabalo Airport",
     "countryCode": "CD",
     "iata": "KBO",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kabalo"
  }, {
     "name": "Boryspil International Airport",
     "countryCode": "UA",
     "iata": "KBP",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Kiev / Kiev"
  }, {
     "name": "Kasungu Airport",
     "countryCode": "MW",
     "iata": "KBQ",
     "eucustoms": false,
     "countryDK": "Malawi",
     "cityDK": "Kasungu"
  }, {
     "name": "Sultan Ismail Petra Airport",
     "countryCode": "MY",
     "iata": "KBR",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Kota Bharu"
  }, {
     "name": "Bo Airport",
     "countryCode": "SL",
     "iata": "KBS",
     "eucustoms": false,
     "countryDK": "Sierra Leone",
     "cityDK": "Bo"
  }, {
     "name": "Gusti Syamsir Alam Airport",
     "countryCode": "ID",
     "iata": "KBU",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Kotabaru"
  }, {
     "name": "Krabi Airport",
     "countryCode": "TH",
     "iata": "KBV",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Krabi"
  }, {
     "name": "Streaky Bay Airport",
     "countryCode": "AU",
     "iata": "KBY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Streaky Bay"
  }, {
     "name": "Kaikoura Airport",
     "countryCode": "NZ",
     "iata": "KBZ",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Kaikoura"
  }, {
     "name": "Quici Airport",
     "countryCode": "CN",
     "iata": "KCA",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Kuqa"
  }, {
     "name": "Collinsville Airport",
     "countryCode": "AU",
     "iata": "KCE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Collinsville"
  }, {
     "name": "Kadanwari Airport",
     "countryCode": "PK",
     "iata": "KCF",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Kadanwari"
  }, {
     "name": "Kuching International Airport",
     "countryCode": "MY",
     "iata": "KCH",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Kuching"
  }, {
     "name": "Kirensk Airport",
     "countryCode": "RU",
     "iata": "KCK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Kirensk"
  }, {
     "name": "Kahramanmaras Airport",
     "countryCode": "TR",
     "iata": "KCM",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Kahramanmaras"
  }, {
     "name": "Cengiz Topel Airport",
     "countryCode": "TR",
     "iata": "KCO",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Izmit"
  }, {
     "name": "Chignik Lake Airport",
     "countryCode": "US",
     "iata": "KCQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chignik"
  }, {
     "name": "Kings Creek Station Airport",
     "countryCode": "AU",
     "iata": "KCS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kings Creek Station"
  }, {
     "name": "Koggala Airport",
     "countryCode": "LK",
     "iata": "KCT",
     "eucustoms": false,
     "countryDK": "Sri Lanka",
     "cityDK": "Koggala"
  }, {
     "name": "Masindi Airport",
     "countryCode": "UG",
     "iata": "KCU",
     "eucustoms": false,
     "countryDK": "Uganda",
     "cityDK": "Masindi"
  }, {
     "name": "Chennault International Airport",
     "countryCode": "US",
     "iata": "CWF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lake Charles"
  }, {
     "name": "Kochi Ryoma Airport",
     "countryCode": "JP",
     "iata": "KCZ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Kochi"
  }, {
     "name": "Kolda Airport",
     "countryCode": "SN",
     "iata": "KDA",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Kolda"
  }, {
     "name": "Kandi Airport",
     "countryCode": "BJ",
     "iata": "KDC",
     "eucustoms": false,
     "countryDK": "Benin",
     "cityDK": "Kandi"
  }, {
     "name": "Khuzdar Airport",
     "countryCode": "PK",
     "iata": "KDD",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Khuzdar"
  }, {
     "name": "Kandahar Airport",
     "countryCode": "AF",
     "iata": "KDH",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Kandahar"
  }, {
     "name": "Haluoleo Airport",
     "countryCode": "ID",
     "iata": "KDI",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Kendari"
  }, {
     "name": "Ndjole Airport",
     "countryCode": "GA",
     "iata": "KDJ",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Ndjole"
  }, {
     "name": "Kardla Airport",
     "countryCode": "EE",
     "iata": "KDL",
     "eucustoms": false,
     "countryDK": "Estland",
     "cityDK": "Kardla"
  }, {
     "name": "Kaadedhdhoo Airport",
     "countryCode": "MV",
     "iata": "KDM",
     "eucustoms": false,
     "countryDK": "Maldiverne",
     "cityDK": "Kaadedhdhoo"
  }, {
     "name": "Ndende Airport",
     "countryCode": "GA",
     "iata": "KDN",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Ndende"
  }, {
     "name": "Kadhdhoo Airport",
     "countryCode": "MV",
     "iata": "KDO",
     "eucustoms": false,
     "countryDK": "Maldiverne",
     "cityDK": "Kadhdhoo"
  }, {
     "name": "Kamphangsaen Airport",
     "countryCode": "TH",
     "iata": "KDT",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Kamphangsaen"
  }, {
     "name": "Skardu Airport",
     "countryCode": "PK",
     "iata": "KDU",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Skardu"
  }, {
     "name": "Kandavu Airport",
     "countryCode": "FJ",
     "iata": "KDV",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Kandavu"
  }, {
     "name": "Kadugli Airport",
     "countryCode": "SD",
     "iata": "KDX",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Kadugli"
  }, {
     "name": "Kasenga Airport",
     "countryCode": "CD",
     "iata": "KEC",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kasenga"
  }, {
     "name": "Kaedi Airport",
     "countryCode": "MR",
     "iata": "KED",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Kaedi"
  }, {
     "name": "Kelle Airport",
     "countryCode": "CG",
     "iata": "KEE",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Kelle"
  }, {
     "name": "Keflavik International Airport",
     "countryCode": "IS",
     "iata": "KEF",
     "eucustoms": true,
     "countryDK": "Island",
     "cityDK": "Reykjavik"
  }, {
     "name": "Kemerovo Airport",
     "countryCode": "RU",
     "iata": "KEJ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Kemerovo"
  }, {
     "name": "Holtenau Airport",
     "countryCode": "DE",
     "iata": "KEL",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Kiel"
  }, {
     "name": "Kemi/Tornio Airport",
     "countryCode": "FI",
     "iata": "KEM",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Kemi / Tornio"
  }, {
     "name": "Kenema Airport",
     "countryCode": "SL",
     "iata": "KEN",
     "eucustoms": false,
     "countryDK": "Sierra Leone",
     "cityDK": "Kenema"
  }, {
     "name": "Odienne Airport",
     "countryCode": "CI",
     "iata": "KEO",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Odienné"
  }, {
     "name": "Nepalganj Airport",
     "countryCode": "NP",
     "iata": "KEP",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Nepalganj"
  }, {
     "name": "Kerman Airport",
     "countryCode": "IR",
     "iata": "KER",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Kerman"
  }, {
     "name": "Kelsey Airport",
     "countryCode": "CA",
     "iata": "KES",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kelsey"
  }, {
     "name": "Keng Tung Airport",
     "countryCode": "MM",
     "iata": "KET",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Keng Tung"
  }, {
     "name": "Keekorok Airport",
     "countryCode": "KE",
     "iata": "KEU",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Maasai Mara"
  }, {
     "name": "Halli Airport",
     "countryCode": "FI",
     "iata": "KEV",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Kuorevesi"
  }, {
     "name": "Keewaywin Airport",
     "countryCode": "CA",
     "iata": "KEW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Keewaywin"
  }, {
     "name": "Kericho Airport",
     "countryCode": "KE",
     "iata": "KEY",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Kericho"
  }, {
     "name": "Kiffa Airport",
     "countryCode": "MR",
     "iata": "KFA",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Kiffa"
  }, {
     "name": "Fortescue Dave Forrest Airport",
     "countryCode": "AU",
     "iata": "KFE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cloudbreak"
  }, {
     "name": "Kalkurung Airport",
     "countryCode": "AU",
     "iata": "KFG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kalkurung"
  }, {
     "name": "Tipton Airport",
     "countryCode": "US",
     "iata": "FME",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Meade"
  }, {
     "name": "Kastamonu Airport",
     "countryCode": "TR",
     "iata": "KFS",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Kastamonu"
  }, {
     "name": "Kananga Airport",
     "countryCode": "CD",
     "iata": "KGA",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kananga"
  }, {
     "name": "Kingscote Airport",
     "countryCode": "AU",
     "iata": "KGC",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kingscote"
  }, {
     "name": "Khrabrovo Airport",
     "countryCode": "RU",
     "iata": "KGD",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Kaliningrad"
  }, {
     "name": "Karaganda Airport",
     "countryCode": "KZ",
     "iata": "KGF",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Karaganda"
  }, {
     "name": "Kedougou Airport",
     "countryCode": "SN",
     "iata": "KGG",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Kedougou"
  }, {
     "name": "Kalgoorlie Airport",
     "countryCode": "AU",
     "iata": "KGI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kalgoorlie"
  }, {
     "name": "Karonga Airport",
     "countryCode": "MW",
     "iata": "KGJ",
     "eucustoms": false,
     "countryDK": "Malawi",
     "cityDK": "Karonga"
  }, {
     "name": "Koliganek Airport",
     "countryCode": "US",
     "iata": "KGK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Koliganek"
  }, {
     "name": "Kigali International Airport",
     "countryCode": "RW",
     "iata": "KGL",
     "eucustoms": false,
     "countryDK": "Rwanda",
     "cityDK": "Kigali"
  }, {
     "name": "Kasongo Lunda Airport",
     "countryCode": "CD",
     "iata": "KGN",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kasongo Lunda"
  }, {
     "name": "Kogalym International Airport",
     "countryCode": "RU",
     "iata": "KGP",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Kogalym"
  }, {
     "name": "Kangersuatsiaq Heliport",
     "countryCode": "GL",
     "iata": "KGQ",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Kangersuatsiaq"
  }, {
     "name": "Kos Airport",
     "countryCode": "GR",
     "iata": "KGS",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Kos",
     "aliases": ["KOS", "Kos Island"]
  }, {
     "name": "Kangding Airport",
     "countryCode": "CN",
     "iata": "KGT",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Kangding"
  }, {
     "name": "Kingaroy Airport",
     "countryCode": "AU",
     "iata": "KGY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kingaroy"
  }, {
     "name": "Khorramabad Airport",
     "countryCode": "IR",
     "iata": "KHD",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Khorramabad"
  }, {
     "name": "Kherson International Airport",
     "countryCode": "UA",
     "iata": "KHE",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Kherson"
  }, {
     "name": "Kashi Airport",
     "countryCode": "CN",
     "iata": "KHG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Kashi"
  }, {
     "name": "Kaohsiung International Airport",
     "countryCode": "TW",
     "iata": "KHH",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Kaohsiung"
  }, {
     "name": "Jinnah International Airport",
     "countryCode": "PK",
     "iata": "KHI",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Karachi"
  }, {
     "name": "Kauhajoki Airport",
     "countryCode": "FI",
     "iata": "KHJ",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Kauhajoki"
  }, {
     "name": "Khark Airport",
     "countryCode": "IR",
     "iata": "KHK",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Khark"
  }, {
     "name": "Khamti Airport",
     "countryCode": "MM",
     "iata": "KHM",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Khamti"
  }, {
     "name": "Nanchang Changbei International Airport",
     "countryCode": "CN",
     "iata": "KHN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Nanchang"
  }, {
     "name": "Kullorsuaq Heliport",
     "countryCode": "GL",
     "iata": "KHQ",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Kullorsuaq"
  }, {
     "name": "Khasab Airport",
     "countryCode": "OM",
     "iata": "KHS",
     "eucustoms": false,
     "countryDK": "Oman",
     "cityDK": "Khasab"
  }, {
     "name": "Khost Airport",
     "countryCode": "AF",
     "iata": "KHT",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Khost"
  }, {
     "name": "Khabarovsk Airport",
     "countryCode": "RU",
     "iata": "KHV",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Khabarovsk"
  }, {
     "name": "Khwai River Lodge Airport",
     "countryCode": "BW",
     "iata": "KHW",
     "eucustoms": false,
     "countryDK": "Botswana",
     "cityDK": "Khwai River Lodge"
  }, {
     "name": "Khoy Airport",
     "countryCode": "IR",
     "iata": "KHY",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Khoy"
  }, {
     "name": "Mesa Del Rey Airport",
     "countryCode": "US",
     "iata": "KIC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "King City"
  }, {
     "name": "Kristianstad Airport",
     "countryCode": "SE",
     "iata": "KID",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Kristianstad"
  }, {
     "name": "Kingfisher Lake Airport",
     "countryCode": "CA",
     "iata": "KIF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kingfisher Lake"
  }, {
     "name": "Kish International Airport",
     "countryCode": "IR",
     "iata": "KIH",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Kish Island"
  }, {
     "name": "Niigata Airport",
     "countryCode": "JP",
     "iata": "KIJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Niigata"
  }, {
     "name": "Kimberley Airport",
     "countryCode": "ZA",
     "iata": "KIM",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Kimberley"
  }, {
     "name": "Norman Manley International Airport",
     "countryCode": "JM",
     "iata": "KIN",
     "eucustoms": false,
     "countryDK": "Jamaica",
     "cityDK": "Kingston"
  }, {
     "name": "Kerry County Airport",
     "countryCode": "IE",
     "iata": "KIR",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Kerry County"
  }, {
     "name": "Kisumu Airport",
     "countryCode": "KE",
     "iata": "KIS",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Kisumu"
  }, {
     "name": "Kithira Airport",
     "countryCode": "GR",
     "iata": "KIT",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Kithira"
  }, {
     "name": "Chisinau International Airport",
     "countryCode": "MD",
     "iata": "KIV",
     "eucustoms": true,
     "countryDK": "Moldova",
     "cityDK": "Chisinau"
  }, {
     "name": "Southdowns Airport",
     "countryCode": "ZM",
     "iata": "KIW",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Kitwe"
  }, {
     "name": "Kansai International Airport",
     "countryCode": "JP",
     "iata": "KIX",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Osaka"
  }, {
     "name": "New Century Aircenter",
     "countryCode": "US",
     "iata": "JCI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kansas City"
  }, {
     "name": "Kilwa Masoko Airport",
     "countryCode": "TZ",
     "iata": "KIY",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Kilwa Masoko"
  }, {
     "name": "Krasnoyarsk Airport",
     "countryCode": "RU",
     "iata": "KJA",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Krasnojarsk"
  }, {
     "name": "Kortrijk Airport",
     "countryCode": "BE",
     "iata": "KJK",
     "eucustoms": false,
     "countryDK": "Belgien",
     "cityDK": "Kortrijk"
  }, {
     "name": "Kerama Airport",
     "countryCode": "JP",
     "iata": "KJP",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Kerama"
  }, {
     "name": "Concord Regional Airport",
     "countryCode": "US",
     "iata": "USA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Concord"
  }, {
     "name": "Koyuk Airport",
     "countryCode": "US",
     "iata": "KKA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Koyuk"
  }, {
     "name": "Khon Kaen Airport",
     "countryCode": "TH",
     "iata": "KKC",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Khon Kaen"
  }, {
     "name": "Kerikeri Airport",
     "countryCode": "NZ",
     "iata": "KKE",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Kerikeri"
  }, {
     "name": "Kongiganak Airport",
     "countryCode": "US",
     "iata": "KKH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kongiganak"
  }, {
     "name": "Kitakyushu Airport",
     "countryCode": "JP",
     "iata": "KKJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Kitakyushu"
  }, {
     "name": "Sa Pran Nak Airport",
     "countryCode": "TH",
     "iata": "KKM",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Lop Buri"
  }, {
     "name": "Kirkenes Airport, Hoeybuktmoen",
     "countryCode": "NO",
     "iata": "KKN",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Kirkenes"
  }, {
     "name": "Kaikohe Airport",
     "countryCode": "NZ",
     "iata": "KKO",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Kaikohe"
  }, {
     "name": "Krasnosel'Kup Airport",
     "countryCode": "RU",
     "iata": "KKQ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Krasnosel'Kup"
  }, {
     "name": "Kashan Airport",
     "countryCode": "IR",
     "iata": "KKS",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Kashan"
  }, {
     "name": "Kikwit Airport",
     "countryCode": "CD",
     "iata": "KKW",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kikwit"
  }, {
     "name": "Kikaiga Shima Airport",
     "countryCode": "JP",
     "iata": "KKX",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Kikaiga Shima"
  }, {
     "name": "Kilkenny Airport",
     "countryCode": "IE",
     "iata": "KKY",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Kilkenny"
  }, {
     "name": "Koh Kong Airport",
     "countryCode": "KH",
     "iata": "KKZ",
     "eucustoms": false,
     "countryDK": "Cambodja",
     "cityDK": "Koh Kong"
  }, {
     "name": "Kalabo Airport",
     "countryCode": "ZM",
     "iata": "KLB",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Kalabo"
  }, {
     "name": "Kaolack Airport",
     "countryCode": "SN",
     "iata": "KLC",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Kaolack"
  }, {
     "name": "Lake City Gateway Airport",
     "countryCode": "US",
     "iata": "LCQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lake City"
  }, {
     "name": "Kolhapur Airport",
     "countryCode": "IN",
     "iata": "KLH",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Kolhapur"
  }, {
     "name": "Kota Koli Airport",
     "countryCode": "CD",
     "iata": "KLI",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kota Koli"
  }, {
     "name": "Kalaleh Airport",
     "countryCode": "IR",
     "iata": "KLM",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Kalaleh"
  }, {
     "name": "Kalibo International Airport",
     "countryCode": "PH",
     "iata": "KLO",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Kalibo"
  }, {
     "name": "Kalmar Oland Airport",
     "countryCode": "SE",
     "iata": "KLR",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Kalmar"
  }, {
     "name": "Longview Airport",
     "countryCode": "US",
     "iata": "KLS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kelso"
  }, {
     "name": "Klagenfurt Airport",
     "countryCode": "AT",
     "iata": "KLU",
     "eucustoms": true,
     "countryDK": "Østrig",
     "cityDK": "Klagenfurt"
  }, {
     "name": "Karlovy Vary Airport",
     "countryCode": "CZ",
     "iata": "KLV",
     "eucustoms": false,
     "countryDK": "Tjekkiet",
     "cityDK": "Karlovy Vary"
  }, {
     "name": "Klawock Airport",
     "countryCode": "US",
     "iata": "KLW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Klawock"
  }, {
     "name": "Kalamata Airport",
     "countryCode": "GR",
     "iata": "KLX",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Kalamata"
  }, {
     "name": "Kalima Airport",
     "countryCode": "CD",
     "iata": "KLY",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kalima"
  }, {
     "name": "Kleinzee Airport",
     "countryCode": "ZA",
     "iata": "KLZ",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Kleinzee"
  }, {
     "name": "King Khaled Military City Airport",
     "countryCode": "SA",
     "iata": "KMC",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "King Khalid Military City"
  }, {
     "name": "Mooreland Municipal",
     "countryCode": "US",
     "iata": "MDF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mooreland"
  }, {
     "name": "Kamembe Airport",
     "countryCode": "RW",
     "iata": "KME",
     "eucustoms": false,
     "countryDK": "Rwanda",
     "cityDK": "Kamembe"
  }, {
     "name": "Kunming Changshui International Airport",
     "countryCode": "CN",
     "iata": "KMG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Kunming"
  }, {
     "name": "Kuruman Airport",
     "countryCode": "ZA",
     "iata": "KMH",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Kuruman"
  }, {
     "name": "Miyazaki Airport",
     "countryCode": "JP",
     "iata": "KMI",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Miyazaki"
  }, {
     "name": "Kumamoto Airport",
     "countryCode": "JP",
     "iata": "KMJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Kumamoto"
  }, {
     "name": "Makabana Airport",
     "countryCode": "CG",
     "iata": "KMK",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Makabana"
  }, {
     "name": "Kamileroi Airport",
     "countryCode": "AU",
     "iata": "KML",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kamileroi"
  }, {
     "name": "Kamina Airport",
     "countryCode": "CD",
     "iata": "KMN",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kamina"
  }, {
     "name": "Manokotak Airport",
     "countryCode": "US",
     "iata": "KMO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Manokotak"
  }, {
     "name": "J.G.H. Van Der Wath Airport",
     "countryCode": "NA",
     "iata": "KMP",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Keetmanshoop"
  }, {
     "name": "Komatsu Airport",
     "countryCode": "JP",
     "iata": "KMQ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Komatsu"
  }, {
     "name": "Kumasi Airport",
     "countryCode": "GH",
     "iata": "KMS",
     "eucustoms": false,
     "countryDK": "Ghana",
     "cityDK": "Kumasi"
  }, {
     "name": "Kismayu Airport",
     "countryCode": "SO",
     "iata": "KMU",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Kismayu"
  }, {
     "name": "King Khalid Air Base",
     "countryCode": "SA",
     "iata": "KMX",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Khamis Mushait"
  }, {
     "name": "Kaoma Airport",
     "countryCode": "ZM",
     "iata": "KMZ",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Kaoma"
  }, {
     "name": "Vina del Mar Airport",
     "countryCode": "CL",
     "iata": "KNA",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Vina del Mar"
  }, {
     "name": "Kanab Airport",
     "countryCode": "US",
     "iata": "KNB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kanab"
  }, {
     "name": "Kindu Airport",
     "countryCode": "CD",
     "iata": "KND",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kindu"
  }, {
     "name": "Kinmen Airport",
     "countryCode": "TW",
     "iata": "KNH",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Kinmen"
  }, {
     "name": "Kindamba Airport",
     "countryCode": "CG",
     "iata": "KNJ",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Kindamba"
  }, {
     "name": "Kaniama Airport",
     "countryCode": "CD",
     "iata": "KNM",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kaniama"
  }, {
     "name": "Kankan Airport",
     "countryCode": "GN",
     "iata": "KNN",
     "eucustoms": false,
     "countryDK": "Guinea",
     "cityDK": "Kankan"
  }, {
     "name": "Kuala Namu International Airport",
     "countryCode": "ID",
     "iata": "KNO",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Kuala Namu"
  }, {
     "name": "Kone Airport",
     "countryCode": "NC",
     "iata": "KNQ",
     "eucustoms": false,
     "countryDK": "Ny Kaledonien",
     "cityDK": "Kone"
  }, {
     "name": "Jam Airport",
     "countryCode": "IR",
     "iata": "KNR",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Kangan"
  }, {
     "name": "King Island Airport",
     "countryCode": "AU",
     "iata": "KNS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "King Island"
  }, {
     "name": "Kennett Municipal Airport",
     "countryCode": "US",
     "iata": "KNT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kennett"
  }, {
     "name": "Kanpur Airport",
     "countryCode": "IN",
     "iata": "KNU",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Kanpur"
  }, {
     "name": "New Stuyahok Airport",
     "countryCode": "US",
     "iata": "KNW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ny Stuyahok"
  }, {
     "name": "Kununurra Airport",
     "countryCode": "AU",
     "iata": "KNX",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kununurra"
  }, {
     "name": "Kenieba Airport",
     "countryCode": "ML",
     "iata": "KNZ",
     "eucustoms": false,
     "countryDK": "Mali",
     "cityDK": "Kenieba"
  }, {
     "name": "Kona International Airport at Keahole",
     "countryCode": "US",
     "iata": "KOA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kailua-Kona"
  }, {
     "name": "Koumac Airport",
     "countryCode": "NC",
     "iata": "KOC",
     "eucustoms": false,
     "countryDK": "Ny Kaledonien",
     "cityDK": "Koumac"
  }, {
     "name": "El Tari Airport",
     "countryCode": "ID",
     "iata": "KOE",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Kupang"
  }, {
     "name": "Komatipoort Airport",
     "countryCode": "ZA",
     "iata": "KOF",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Komatipoort"
  }, {
     "name": "Kirkwall Airport",
     "countryCode": "GB",
     "iata": "KOI",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Kirkwall"
  }, {
     "name": "Kagoshima Airport",
     "countryCode": "JP",
     "iata": "KOJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Kagoshima"
  }, {
     "name": "Kruunupyy Airport",
     "countryCode": "FI",
     "iata": "KOK",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Kokkola / Pietarsaari"
  }, {
     "name": "Komo Airport",
     "countryCode": "PG",
     "iata": "KOM",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Komo"
  }, {
     "name": "Kongolo Airport",
     "countryCode": "CD",
     "iata": "KOO",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kongolo"
  }, {
     "name": "Nakhon Phanom Airport",
     "countryCode": "TH",
     "iata": "KOP",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Nakhon Phanom"
  }, {
     "name": "Sihanouk International Airport",
     "countryCode": "KH",
     "iata": "KOS",
     "eucustoms": false,
     "countryDK": "Cambodja",
     "cityDK": "Sihanoukville",
     "hideFromAutocomplete": true
  }, {
     "name": "Koulamoutou Airport",
     "countryCode": "GA",
     "iata": "KOU",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Koulamoutou"
  }, {
     "name": "Pike County Airport",
     "countryCode": "US",
     "iata": "PVL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pikeville"
  }, {
     "name": "Port Clarence Coast Guard Station",
     "countryCode": "US",
     "iata": "KPC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Port Clarence"
  }, {
     "name": "Kipnuk Sea Plane Base",
     "countryCode": "US",
     "iata": "KPN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kipnuk"
  }, {
     "name": "Ralph Wenz Field",
     "countryCode": "US",
     "iata": "PWY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pinedale"
  }, {
     "name": "Pohang Airport",
     "countryCode": "KR",
     "iata": "KPO",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Pohang"
  }, {
     "name": "Kempsey Airport",
     "countryCode": "AU",
     "iata": "KPS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kempsey"
  }, {
     "name": "Keperveyem Airport",
     "countryCode": "RU",
     "iata": "KPW",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Keperveyem"
  }, {
     "name": "Qurghonteppa International Airport",
     "countryCode": "TJ",
     "iata": "KQT",
     "eucustoms": false,
     "countryDK": "Tadsjikistan",
     "cityDK": "Kurgon-Tyube"
  }, {
     "name": "Kerang Airport",
     "countryCode": "AU",
     "iata": "KRA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kerang"
  }, {
     "name": "Karumba Airport",
     "countryCode": "AU",
     "iata": "KRB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Karumba"
  }, {
     "name": "Kirundo Airport",
     "countryCode": "BI",
     "iata": "KRE",
     "eucustoms": false,
     "countryDK": "Burundi",
     "cityDK": "Kirundo"
  }, {
     "name": "Kramfors Airport",
     "countryCode": "SE",
     "iata": "KRF",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Kramfors"
  }, {
     "name": "Redhill",
     "countryCode": "GB",
     "iata": "KRH",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Redhill"
  }, {
     "name": "J. Paul II International Airport Krakow-Balice",
     "countryCode": "PL",
     "iata": "KRK",
     "eucustoms": true,
     "countryDK": "Polen",
     "cityDK": "Krakow"
  }, {
     "name": "Korla Airport",
     "countryCode": "CN",
     "iata": "KRL",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Korla"
  }, {
     "name": "Karanambo Airport",
     "countryCode": "GY",
     "iata": "KRM",
     "eucustoms": false,
     "countryDK": "Guyana",
     "cityDK": "Karanambo"
  }, {
     "name": "Kiruna Airport",
     "countryCode": "SE",
     "iata": "KRN",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Kiruna"
  }, {
     "name": "Kurgan Airport",
     "countryCode": "RU",
     "iata": "KRO",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Kurgan"
  }, {
     "name": "Midtjyllands Airport",
     "countryCode": "DK",
     "iata": "KRP",
     "eucustoms": false,
     "countryDK": "Danmark",
     "cityDK": "Karup"
  }, {
     "name": "Krasnodar International Airport",
     "countryCode": "RU",
     "iata": "KRR",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Krasnodar"
  }, {
     "name": "Kristiansand Airport",
     "countryCode": "NO",
     "iata": "KRS",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Kristiansand"
  }, {
     "name": "Khartoum International Airport",
     "countryCode": "SD",
     "iata": "KRT",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Khartoum"
  }, {
     "name": "Turkmanbashi Airport",
     "countryCode": "TM",
     "iata": "KRW",
     "eucustoms": false,
     "countryDK": "Turkmenistan",
     "cityDK": "Turkmanbashi"
  }, {
     "name": "Rexburg-Madison County Airport",
     "countryCode": "US",
     "iata": "RXE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rexburg"
  }, {
     "name": "Kosrae Airport",
     "countryCode": "FM",
     "iata": "KSA",
     "eucustoms": false,
     "countryDK": "Mikronesien",
     "cityDK": "Kosrae, Caroline Islands"
  }, {
     "name": "Barca Airport",
     "countryCode": "SK",
     "iata": "KSC",
     "eucustoms": false,
     "countryDK": "Slovakiet",
     "cityDK": "Kosice"
  }, {
     "name": "Karlstad Airport",
     "countryCode": "SE",
     "iata": "KSD",
     "eucustoms": true,
     "countryDK": "Sverige",
     "cityDK": "Karlstad"
  }, {
     "name": "Kasese Airport",
     "countryCode": "UG",
     "iata": "KSE",
     "eucustoms": false,
     "countryDK": "Uganda",
     "cityDK": "Kasese"
  }, {
     "name": "Kassel-Calden Airport",
     "countryCode": "DE",
     "iata": "KSF",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Kassel"
  }, {
     "name": "Kermanshah Airport",
     "countryCode": "IR",
     "iata": "KSH",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Kermanshah"
  }, {
     "name": "Kissidougou Airport",
     "countryCode": "GN",
     "iata": "KSI",
     "eucustoms": false,
     "countryDK": "Guinea",
     "cityDK": "Kissidougou"
  }, {
     "name": "Kasos Island Airport",
     "countryCode": "GR",
     "iata": "KSJ",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Kasos Island"
  }, {
     "name": "Karlskoga Airport",
     "countryCode": "SE",
     "iata": "KSK",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Karlskoga"
  }, {
     "name": "Kassala Airport",
     "countryCode": "SD",
     "iata": "KSL",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Kassala"
  }, {
     "name": "Saint Mary's Airport",
     "countryCode": "US",
     "iata": "KSM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saint Marys"
  }, {
     "name": "Kostanay Airport",
     "countryCode": "KZ",
     "iata": "KSN",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Kostanay"
  }, {
     "name": "Aristoteles Airport",
     "countryCode": "GR",
     "iata": "KSO",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Kastoria"
  }, {
     "name": "Karshi Airport",
     "countryCode": "UZ",
     "iata": "KSQ",
     "eucustoms": false,
     "countryDK": "Usbekistan",
     "cityDK": "Karshi"
  }, {
     "name": "Sikasso Airport",
     "countryCode": "ML",
     "iata": "KSS",
     "eucustoms": false,
     "countryDK": "Mali",
     "cityDK": "Sikasso"
  }, {
     "name": "Kosti Airport",
     "countryCode": "SD",
     "iata": "KST",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Kosti"
  }, {
     "name": "Kristiansund Airport, Kvernberget",
     "countryCode": "NO",
     "iata": "KSU",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Kristiansund"
  }, {
     "name": "Kiryat Shmona Airport",
     "countryCode": "IL",
     "iata": "KSW",
     "eucustoms": false,
     "countryDK": "Israel",
     "cityDK": "Kiryat Shmona"
  }, {
     "name": "Kars Airport",
     "countryCode": "TR",
     "iata": "KSY",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Kars"
  }, {
     "name": "Kotlas Airport",
     "countryCode": "RU",
     "iata": "KSZ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Kotlas"
  }, {
     "name": "Karratha Airport",
     "countryCode": "AU",
     "iata": "KTA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Karratha"
  }, {
     "name": "Kitadaito Airport",
     "countryCode": "JP",
     "iata": "KTD",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Kitadaito"
  }, {
     "name": "Kerteh Airport",
     "countryCode": "MY",
     "iata": "KTE",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Kerteh"
  }, {
     "name": "Ketapang Airport",
     "countryCode": "ID",
     "iata": "KTG",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Ketapang"
  }, {
     "name": "Kichwa Tembo Airport",
     "countryCode": "KE",
     "iata": "KTJ",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Maasai Mara"
  }, {
     "name": "Kitale Airport",
     "countryCode": "KE",
     "iata": "KTL",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Kitale"
  }, {
     "name": "Tribhuvan International Airport",
     "countryCode": "NP",
     "iata": "KTM",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Kathmandu"
  }, {
     "name": "Ketchikan International Airport",
     "countryCode": "US",
     "iata": "KTN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ketchikan"
  }, {
     "name": "Kato Airport",
     "countryCode": "GY",
     "iata": "KTO",
     "eucustoms": false,
     "countryDK": "Guyana",
     "cityDK": "Kato"
  }, {
     "name": "Tinson Airport",
     "countryCode": "JM",
     "iata": "KTP",
     "eucustoms": false,
     "countryDK": "Jamaica",
     "cityDK": "Kingston"
  }, {
     "name": "Kitee Airport",
     "countryCode": "FI",
     "iata": "KTQ",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Kitee"
  }, {
     "name": "RAAF Base Tindal",
     "countryCode": "AU",
     "iata": "KTR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Katherine"
  }, {
     "name": "Kittila Airport",
     "countryCode": "FI",
     "iata": "KTT",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Kittilä"
  }, {
     "name": "Kota Airport",
     "countryCode": "IN",
     "iata": "KTU",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Kota"
  }, {
     "name": "Katowice International Airport",
     "countryCode": "PL",
     "iata": "KTW",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Katowice"
  }, {
     "name": "Koutiala Airport",
     "countryCode": "ML",
     "iata": "KTX",
     "eucustoms": false,
     "countryDK": "Mali",
     "cityDK": "Koutiala"
  }, {
     "name": "Sultan Haji Ahmad Shah Airport",
     "countryCode": "MY",
     "iata": "KUA",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Kuantan"
  }, {
     "name": "Kurumoch International Airport",
     "countryCode": "RU",
     "iata": "KUF",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Samara"
  }, {
     "name": "Kubin Airport",
     "countryCode": "AU",
     "iata": "KUG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kubin Island"
  }, {
     "name": "Kushiro Airport",
     "countryCode": "JP",
     "iata": "KUH",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Kushiro"
  }, {
     "name": "Kuala Lumpur International Airport",
     "countryCode": "MY",
     "iata": "KUL",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Kuala Lumpur"
  }, {
     "name": "Yakushima Airport",
     "countryCode": "JP",
     "iata": "KUM",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Yakushima"
  }, {
     "name": "Kaunas Airport",
     "countryCode": "LT",
     "iata": "KUN",
     "eucustoms": false,
     "countryDK": "Litauen",
     "cityDK": "Kaunas"
  }, {
     "name": "Kuopio Airport",
     "countryCode": "FI",
     "iata": "KUO",
     "eucustoms": true,
     "countryDK": "Finland",
     "cityDK": "Kuopio"
  }, {
     "name": "Kulusuk Airport",
     "countryCode": "GL",
     "iata": "KUS",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Kulusuk"
  }, {
     "name": "Kutaisi International Airport",
     "countryCode": "GE",
     "iata": "KUT",
     "eucustoms": false,
     "countryDK": "Georgien",
     "cityDK": "Kutaisi"
  }, {
     "name": "Bhuntar Airport",
     "countryCode": "IN",
     "iata": "KUU",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Kulu"
  }, {
     "name": "Gunsan Airport",
     "countryCode": "KR",
     "iata": "KUV",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Gunsan"
  }, {
     "name": "Kuummiit Heliport",
     "countryCode": "GL",
     "iata": "KUZ",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Kuummiut"
  }, {
     "name": "Kavala International Airport",
     "countryCode": "GR",
     "iata": "KVA",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Kavala"
  }, {
     "name": "Skovde Airport",
     "countryCode": "SE",
     "iata": "KVB",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Skövde"
  }, {
     "name": "Gyandzha Airport",
     "countryCode": "AZ",
     "iata": "KVD",
     "eucustoms": false,
     "countryDK": "Aserbajdsjan",
     "cityDK": "Gyandzha"
  }, {
     "name": "Kwajalein Airport",
     "countryCode": "MH",
     "iata": "KWA",
     "eucustoms": false,
     "countryDK": "Marshalløerne",
     "cityDK": "Kwajalein"
  }, {
     "name": "Dewadaru Airport",
     "countryCode": "ID",
     "iata": "KWB",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Karimunjawa"
  }, {
     "name": "Guiyang Longdongbao International Airport",
     "countryCode": "CN",
     "iata": "KWE",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Guiyang"
  }, {
     "name": "Krivoy Rog Airport",
     "countryCode": "UA",
     "iata": "KWG",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Krivoy Rog"
  }, {
     "name": "Khwahan Airport",
     "countryCode": "AF",
     "iata": "KWH",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Khwahan"
  }, {
     "name": "Kuwait International Airport",
     "countryCode": "KW",
     "iata": "KWI",
     "eucustoms": false,
     "countryDK": "Kuwait",
     "cityDK": "Kuwait"
  }, {
     "name": "Gwangju Airport",
     "countryCode": "KR",
     "iata": "KWJ",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Gwangju"
  }, {
     "name": "Guilin Liangjiang International Airport",
     "countryCode": "CN",
     "iata": "KWL",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Guilin"
  }, {
     "name": "Kowanyama Airport",
     "countryCode": "AU",
     "iata": "KWM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Kowanyama"
  }, {
     "name": "Kwinhagak Airport",
     "countryCode": "US",
     "iata": "KWN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Quinhagak"
  }, {
     "name": "Kwailibesi Airport",
     "countryCode": "SB",
     "iata": "KWS",
     "eucustoms": false,
     "countryDK": "Salomonøerne",
     "cityDK": "Kwailibesi"
  }, {
     "name": "Kolwezi Airport",
     "countryCode": "CD",
     "iata": "KWZ",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kolwezi"
  }, {
     "name": "Klerksdorp Airport",
     "countryCode": "ZA",
     "iata": "KXE",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Klerksdorp"
  }, {
     "name": "Koro Island Airport",
     "countryCode": "FJ",
     "iata": "KXF",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Koro Island"
  }, {
     "name": "Khurba Airport",
     "countryCode": "RU",
     "iata": "KXK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Komsomolsk Na Amure"
  }, {
     "name": "Konya Airport",
     "countryCode": "TR",
     "iata": "KYA",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Konya"
  }, {
     "name": "Kleyate Airport",
     "countryCode": "LB",
     "iata": "KYE",
     "eucustoms": false,
     "countryDK": "Libanon",
     "cityDK": "Tripoli"
  }, {
     "name": "Karluk Airport",
     "countryCode": "US",
     "iata": "KYK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Karluk"
  }, {
     "name": "Kyaukpyu Airport",
     "countryCode": "MM",
     "iata": "KYP",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Kyaukpyu"
  }, {
     "name": "Kayes Airport",
     "countryCode": "ML",
     "iata": "KYS",
     "eucustoms": false,
     "countryDK": "Mali",
     "cityDK": "Kayes"
  }, {
     "name": "Kyaukhtu Airport",
     "countryCode": "MM",
     "iata": "KYT",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Kyaukhtu"
  }, {
     "name": "Kyzyl Airport",
     "countryCode": "RU",
     "iata": "KYZ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Kyzyl"
  }, {
     "name": "Kitzingen Airport",
     "countryCode": "DE",
     "iata": "KZG",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Kitzingen"
  }, {
     "name": "Philippos Airport",
     "countryCode": "GR",
     "iata": "KZI",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Kozani"
  }, {
     "name": "Kazan International Airport",
     "countryCode": "RU",
     "iata": "KZN",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Kazan"
  }, {
     "name": "Kzyl-Orda Airport",
     "countryCode": "KZ",
     "iata": "KZO",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Kzyl-Orda"
  }, {
     "name": "Zafer Airport",
     "countryCode": "TR",
     "iata": "KZR",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Kutahya"
  }, {
     "name": "Kastellorizo Airport",
     "countryCode": "GR",
     "iata": "KZS",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Kastellórizo"
  }, {
     "name": "Lamar Municipal Airport",
     "countryCode": "US",
     "iata": "LAA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lamar"
  }, {
     "name": "Quatro de Fevereiro Airport",
     "countryCode": "AO",
     "iata": "LAD",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Luanda"
  }, {
     "name": "Nadzab Airport",
     "countryCode": "PG",
     "iata": "LAE",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Lae"
  }, {
     "name": "Purdue University Airport",
     "countryCode": "US",
     "iata": "LAF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lafayette"
  }, {
     "name": "Oesman Sadik Airport",
     "countryCode": "ID",
     "iata": "LAH",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Labuha"
  }, {
     "name": "Servel Airport",
     "countryCode": "FR",
     "iata": "LAI",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Lannion"
  }, {
     "name": "Correia Pinto Airport",
     "countryCode": "BR",
     "iata": "LAJ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Lages"
  }, {
     "name": "Freddie Carmichael Airport",
     "countryCode": "CA",
     "iata": "LAK",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Aklavik"
  }, {
     "name": "Lakeland Municipal Airport",
     "countryCode": "US",
     "iata": "LAL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lakeland"
  }, {
     "name": "Los Alamos Airport",
     "countryCode": "US",
     "iata": "LAM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Los Alamos"
  }, {
     "name": "Lansing Capital Region International Airport",
     "countryCode": "US",
     "iata": "LAN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lansing"
  }, {
     "name": "Laoag Airport",
     "countryCode": "PH",
     "iata": "LAO",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Laoag"
  }, {
     "name": "Leon Airport",
     "countryCode": "MX",
     "iata": "LAP",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "La Paz"
  }, {
     "name": "La Braq Airport",
     "countryCode": "LY",
     "iata": "LAQ",
     "eucustoms": false,
     "countryDK": "Libyen",
     "cityDK": "Beida"
  }, {
     "name": "General Brees Field",
     "countryCode": "US",
     "iata": "LAR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Laramie"
  }, {
     "name": "McCarran International Airport",
     "countryCode": "US",
     "iata": "LAS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Las Vegas"
  }, {
     "name": "Lamu Airport",
     "countryCode": "KE",
     "iata": "LAU",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Lamu"
  }, {
     "name": "Lawton-Fort Sill Regional Airport",
     "countryCode": "US",
     "iata": "LAW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lawton"
  }, {
     "name": "Los Angeles International Airport",
     "countryCode": "US",
     "iata": "LAX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Los Angeles"
  }, {
     "name": "Ladysmith Airport",
     "countryCode": "ZA",
     "iata": "LAY",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Ladysmith"
  }, {
     "name": "Bom Jesus Da Lapa Airport",
     "countryCode": "BR",
     "iata": "LAZ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Bom Jesus Da Lapa"
  }, {
     "name": "Leeds Bradford International Airport",
     "countryCode": "GB",
     "iata": "LBA",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Leeds"
  }, {
     "name": "Lubbock Preston Smith International Airport",
     "countryCode": "US",
     "iata": "LBB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lubbock"
  }, {
     "name": "Luebeck-Blankensee Airport",
     "countryCode": "DE",
     "iata": "LBC",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Hamborg"
  }, {
     "name": "Khujand Airport",
     "countryCode": "TJ",
     "iata": "LBD",
     "eucustoms": false,
     "countryDK": "Tadsjikistan",
     "cityDK": "Khujand"
  }, {
     "name": "Westmoreland County Airport",
     "countryCode": "US",
     "iata": "LBE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Latrobe"
  }, {
     "name": "North Platte Regional Airport (Lee Bird Field)",
     "countryCode": "US",
     "iata": "LBF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "North Platte"
  }, {
     "name": "Le Bourget Airport",
     "countryCode": "FR",
     "iata": "LBG",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Paris"
  }, {
     "name": "Le Sequestre Airport",
     "countryCode": "FR",
     "iata": "LBI",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Albi"
  }, {
     "name": "Komodo Airport",
     "countryCode": "ID",
     "iata": "LBJ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Labuan Bajo"
  }, {
     "name": "Mid-America Regional Airport",
     "countryCode": "US",
     "iata": "LBL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Liberal"
  }, {
     "name": "Lusambo Airport",
     "countryCode": "CD",
     "iata": "LBO",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Lusambo"
  }, {
     "name": "Lambarene Airport",
     "countryCode": "GA",
     "iata": "LBQ",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Lambarene"
  }, {
     "name": "Labrea Airport",
     "countryCode": "BR",
     "iata": "LBR",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Labrea"
  }, {
     "name": "Labasa Airport",
     "countryCode": "FJ",
     "iata": "LBS",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Labasa"
  }, {
     "name": "Lumberton Airport",
     "countryCode": "US",
     "iata": "LBT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lumberton"
  }, {
     "name": "Labuan Airport",
     "countryCode": "MY",
     "iata": "LBU",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Labuan"
  }, {
     "name": "Libreville Airport",
     "countryCode": "GA",
     "iata": "LBV",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Libreville"
  }, {
     "name": "Long Bawan Airport",
     "countryCode": "ID",
     "iata": "LBW",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Long Bawan"
  }, {
     "name": "Lubang Airport",
     "countryCode": "PH",
     "iata": "LBX",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Lubang"
  }, {
     "name": "La Baule-Escoublac Airport",
     "countryCode": "FR",
     "iata": "LBY",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "La Baule Escoublac"
  }, {
     "name": "Larnaca International Airport",
     "countryCode": "CY",
     "iata": "LCA",
     "eucustoms": true,
     "countryDK": "Cypern",
     "cityDK": "Larnaca"
  }, {
     "name": "Galatina Airport",
     "countryCode": "IT",
     "iata": "LCC",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Lecce"
  }, {
     "name": "Louis Trichardt Airport",
     "countryCode": "ZA",
     "iata": "LCD",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Louis Trichardt"
  }, {
     "name": "Goloson International Airport",
     "countryCode": "HN",
     "iata": "LCE",
     "eucustoms": false,
     "countryDK": "Honduras",
     "cityDK": "La Ceiba"
  }, {
     "name": "A Coruna Airport",
     "countryCode": "ES",
     "iata": "LCG",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "La Coruna"
  }, {
     "name": "Lake Charles Regional Airport",
     "countryCode": "US",
     "iata": "LCH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lake Charles"
  }, {
     "name": "Laconia Municipal Airport",
     "countryCode": "US",
     "iata": "LCI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Laconia"
  }, {
     "name": "Lodz Lublinek Airport",
     "countryCode": "PL",
     "iata": "LCJ",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Lodz"
  }, {
     "name": "Rickenbacker International Airport",
     "countryCode": "US",
     "iata": "LCK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbus"
  }, {
     "name": "La Coloma Airport",
     "countryCode": "CU",
     "iata": "LCL",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "La Coloma"
  }, {
     "name": "La Cumbre Airport",
     "countryCode": "AR",
     "iata": "LCM",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "La Cumbre"
  }, {
     "name": "Lague Airport",
     "countryCode": "CG",
     "iata": "LCO",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "lague"
  }, {
     "name": "Lucca Airport",
     "countryCode": "IT",
     "iata": "LCV",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Lucca"
  }, {
     "name": "London City Airport",
     "countryCode": "GB",
     "iata": "LCY",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "London"
  }, {
     "name": "Malda Airport",
     "countryCode": "IN",
     "iata": "LDA",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Malda"
  }, {
     "name": "Londrina Airport",
     "countryCode": "BR",
     "iata": "LDB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Londrina"
  }, {
     "name": "Tarbes Ossun Lourdes Airport",
     "countryCode": "FR",
     "iata": "LDE",
     "eucustoms": true,
     "countryDK": "Frankrig",
     "cityDK": "Lourdes"
  }, {
     "name": "Lord Howe Island Airport",
     "countryCode": "AU",
     "iata": "LDH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Lord Howe Island"
  }, {
     "name": "Kikwetu Airport",
     "countryCode": "TZ",
     "iata": "LDI",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Lindi"
  }, {
     "name": "Linden Airport",
     "countryCode": "US",
     "iata": "LDJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Linden"
  }, {
     "name": "Hovby Airport",
     "countryCode": "SE",
     "iata": "LDK",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Lidköping"
  }, {
     "name": "Mason Co",
     "countryCode": "US",
     "iata": "LDM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ludington"
  }, {
     "name": "Lamidanda Airport",
     "countryCode": "NP",
     "iata": "LDN",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Lamidanda"
  }, {
     "name": "Yichun Shi Airport",
     "countryCode": "CN",
     "iata": "LDS",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Yichun"
  }, {
     "name": "Lahad Datu Airport",
     "countryCode": "MY",
     "iata": "LDU",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Lahad Datu"
  }, {
     "name": "Landivisiau Airport",
     "countryCode": "FR",
     "iata": "LDV",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Landivisiau"
  }, {
     "name": "Saint Laurent du Maroni Airport",
     "countryCode": "GF",
     "iata": "LDX",
     "eucustoms": false,
     "countryDK": "Fransk guyana",
     "cityDK": "Saint Laurent du Maroni"
  }, {
     "name": "City of Derry Airport",
     "countryCode": "GB",
     "iata": "LDY",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Derry"
  }, {
     "name": "Londolozi Airport",
     "countryCode": "ZA",
     "iata": "LDZ",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Londolozi"
  }, {
     "name": "Learmonth Airport",
     "countryCode": "AU",
     "iata": "LEA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Learmonth"
  }, {
     "name": "Lebanon Municipal Airport",
     "countryCode": "US",
     "iata": "LEB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Libanon"
  }, {
     "name": "Villafria Airport",
     "countryCode": "ES",
     "iata": "RGS",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Burgos"
  }, {
     "name": "Coronel Horacio de Mattos Airport",
     "countryCode": "BR",
     "iata": "LEC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Lençóis"
  }, {
     "name": "Pulkovo Airport",
     "countryCode": "RU",
     "iata": "LED",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Sankt Petersborg"
  }, {
     "name": "Lleida-Alguaire Airport",
     "countryCode": "ES",
     "iata": "ILD",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Alguaire"
  }, {
     "name": "Leesburg International Airport",
     "countryCode": "US",
     "iata": "LEE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Leesburg"
  }, {
     "name": "Octeville Airport",
     "countryCode": "FR",
     "iata": "LEH",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Le Havre"
  }, {
     "name": "Almeria Airport",
     "countryCode": "ES",
     "iata": "LEI",
     "eucustoms": true,
     "countryDK": "Spanien",
     "cityDK": "Almeria"
  }, {
     "name": "Leipzig/Halle Airport",
     "countryCode": "DE",
     "iata": "LEJ",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Leipzig / Halle"
  }, {
     "name": "Labe Airport",
     "countryCode": "GN",
     "iata": "LEK",
     "eucustoms": false,
     "countryDK": "Guinea",
     "cityDK": "Labe"
  }, {
     "name": "Lake Evella Airport",
     "countryCode": "AU",
     "iata": "LEL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Lake Evella"
  }, {
     "name": "Lemmon Airport",
     "countryCode": "US",
     "iata": "LEM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lemmon"
  }, {
     "name": "Leon Airport",
     "countryCode": "ES",
     "iata": "LEN",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Leon"
  }, {
     "name": "Leopoldina Airport",
     "countryCode": "BR",
     "iata": "LEP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Leopoldina"
  }, {
     "name": "Lands End Airport",
     "countryCode": "GB",
     "iata": "LEQ",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Lands End"
  }, {
     "name": "Leinster Airport",
     "countryCode": "AU",
     "iata": "LER",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Leinster"
  }, {
     "name": "Gen. A.V. Cobo Airport",
     "countryCode": "CO",
     "iata": "LET",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Leticia"
  }, {
     "name": "Levuka Airfield",
     "countryCode": "FJ",
     "iata": "LEV",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Bureta"
  }, {
     "name": "Auburn Lewiston Municipal Airport",
     "countryCode": "US",
     "iata": "LEW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Auburn"
  }, {
     "name": "Blue Grass Airport",
     "countryCode": "US",
     "iata": "LEX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lexington"
  }, {
     "name": "Lelystad Airport",
     "countryCode": "NL",
     "iata": "LEY",
     "eucustoms": false,
     "countryDK": "Holland",
     "cityDK": "Lelystad"
  }, {
     "name": "La Esperanza Airport",
     "countryCode": "HN",
     "iata": "LEZ",
     "eucustoms": false,
     "countryDK": "Honduras",
     "cityDK": "La Esperanza"
  }, {
     "name": "Albert Bray Airport",
     "countryCode": "FR",
     "iata": "BYF",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Albert"
  }, {
     "name": "Lumbo Airport",
     "countryCode": "MZ",
     "iata": "LFB",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Lumbo"
  }, {
     "name": "Langley Air Force Base",
     "countryCode": "US",
     "iata": "LFI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hampton"
  }, {
     "name": "Lufkin Angelina County Airport",
     "countryCode": "US",
     "iata": "LFK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Nacogdoches"
  }, {
     "name": "Lamerd Airport",
     "countryCode": "IR",
     "iata": "LFM",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Lamerd"
  }, {
     "name": "Triangle North Executive Airport",
     "countryCode": "US",
     "iata": "LFN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Louisburg"
  }, {
     "name": "La Fria Airport",
     "countryCode": "VE",
     "iata": "LFR",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "La Fria"
  }, {
     "name": "Lafayette Regional Airport",
     "countryCode": "US",
     "iata": "LFT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lafayette"
  }, {
     "name": "Lome Airport",
     "countryCode": "TG",
     "iata": "LFW",
     "eucustoms": false,
     "countryDK": "Togo",
     "cityDK": "Lomé"
  }, {
     "name": "LaGuardia Airport",
     "countryCode": "US",
     "iata": "LGA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "New York"
  }, {
     "name": "Long Beach Airport",
     "countryCode": "US",
     "iata": "LGB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lang strand"
  }, {
     "name": "Calloway Airport",
     "countryCode": "US",
     "iata": "LGC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "La Grange"
  }, {
     "name": "La Grande/Union County Airport",
     "countryCode": "US",
     "iata": "LGD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "La Grande"
  }, {
     "name": "Laguna Army Air Field",
     "countryCode": "US",
     "iata": "LGF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Yuma"
  }, {
     "name": "Liege Airport",
     "countryCode": "BE",
     "iata": "LGG",
     "eucustoms": false,
     "countryDK": "Belgien",
     "cityDK": "Liege"
  }, {
     "name": "Leigh Creek Airport",
     "countryCode": "AU",
     "iata": "LGH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Leigh Creek"
  }, {
     "name": "Deadmans Cay Airport",
     "countryCode": "BS",
     "iata": "LGI",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Deadmans Cay"
  }, {
     "name": "Langkawi International Airport",
     "countryCode": "MY",
     "iata": "LGK",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Langkawi"
  }, {
     "name": "Langeoog Airport",
     "countryCode": "DE",
     "iata": "LGO",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Langeoog"
  }, {
     "name": "Legaspi Airport",
     "countryCode": "PH",
     "iata": "LGP",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Legaspi"
  }, {
     "name": "Lago Agrio Airport",
     "countryCode": "EC",
     "iata": "LGQ",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Lago Agrio"
  }, {
     "name": "Cochrane Airport",
     "countryCode": "CL",
     "iata": "LGR",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Cochrane"
  }, {
     "name": "Comodoro D.R. Salomon Airport",
     "countryCode": "AR",
     "iata": "LGS",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Malargue"
  }, {
     "name": "Cache Airport",
     "countryCode": "US",
     "iata": "LGU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Logan"
  }, {
     "name": "London Gatwick Airport",
     "countryCode": "GB",
     "iata": "LGW",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "London"
  }, {
     "name": "Black Forest Airport",
     "countryCode": "DE",
     "iata": "LHA",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Lahr"
  }, {
     "name": "Allama Iqbal International Airport",
     "countryCode": "PK",
     "iata": "LHE",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Lahore"
  }, {
     "name": "Lightning Ridge Airport",
     "countryCode": "AU",
     "iata": "LHG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Lyn Ridge"
  }, {
     "name": "London Heathrow Airport",
     "countryCode": "GB",
     "iata": "LHR",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "London"
  }, {
     "name": "Lianshulu Airport",
     "countryCode": "NA",
     "iata": "LHU",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Caprivi"
  }, {
     "name": "W T Piper Memorial Airport",
     "countryCode": "US",
     "iata": "LHV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lock Haven"
  }, {
     "name": "Lanzhou Zhongchuan International Airport",
     "countryCode": "CN",
     "iata": "LHW",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Lanzhou"
  }, {
     "name": "Limon Municipal Airport",
     "countryCode": "US",
     "iata": "LIC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Limon"
  }, {
     "name": "Valkenburg Airport",
     "countryCode": "NL",
     "iata": "LID",
     "eucustoms": false,
     "countryDK": "Holland",
     "cityDK": "Leiden"
  }, {
     "name": "Libenge Airport",
     "countryCode": "CD",
     "iata": "LIE",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Libenge"
  }, {
     "name": "Lifou Airport",
     "countryCode": "NC",
     "iata": "LIF",
     "eucustoms": false,
     "countryDK": "Ny Kaledonien",
     "cityDK": "Lifou"
  }, {
     "name": "Bellegarde Airport",
     "countryCode": "FR",
     "iata": "LIG",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Limoges"
  }, {
     "name": "Lihue Airport",
     "countryCode": "US",
     "iata": "LIH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kauai Island"
  }, {
     "name": "Lille Airport",
     "countryCode": "FR",
     "iata": "LIL",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Lille"
  }, {
     "name": "Jorge Chavez International Airport",
     "countryCode": "PE",
     "iata": "LIM",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Lima"
  }, {
     "name": "Milano Linate Airport",
     "countryCode": "IT",
     "iata": "LIN",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Milano"
  }, {
     "name": "Limon International Airport",
     "countryCode": "CR",
     "iata": "LIO",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Limon"
  }, {
     "name": "Lins Airport",
     "countryCode": "BR",
     "iata": "LIP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Lins"
  }, {
     "name": "Lisala Airport",
     "countryCode": "CD",
     "iata": "LIQ",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Lisala"
  }, {
     "name": "Liberia Airport",
     "countryCode": "CR",
     "iata": "LIR",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Liberia"
  }, {
     "name": "Salerno Costa d'Amalfi Airport",
     "countryCode": "IT",
     "iata": "QSR",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Salerno"
  }, {
     "name": "Lisbon Portela Airport",
     "countryCode": "PT",
     "iata": "LIS",
     "eucustoms": true,
     "countryDK": "Portugal",
     "cityDK": "Lissabon"
  }, {
     "name": "Bill and Hillary Clinton National Airport",
     "countryCode": "US",
     "iata": "LIT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Little Rock"
  }, {
     "name": "Loikaw Airport",
     "countryCode": "MM",
     "iata": "LIW",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Loikaw"
  }, {
     "name": "Likoma Island Airport",
     "countryCode": "MW",
     "iata": "LIX",
     "eucustoms": false,
     "countryDK": "Malawi",
     "cityDK": "Likoma Island"
  }, {
     "name": "Wright Army Air Field",
     "countryCode": "US",
     "iata": "LIY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hinesville"
  }, {
     "name": "Lodja Airport",
     "countryCode": "CD",
     "iata": "LJA",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Lodja"
  }, {
     "name": "Lijiang Sanyi Airport",
     "countryCode": "CN",
     "iata": "LJG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Lijiang"
  }, {
     "name": "Brazoria County Airport",
     "countryCode": "US",
     "iata": "LJN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lake Jackson"
  }, {
     "name": "Ljubljana Joze Pucnik Airport",
     "countryCode": "SI",
     "iata": "LJU",
     "eucustoms": false,
     "countryDK": "Slovenien",
     "cityDK": "Ljubljana"
  }, {
     "name": "Lakeba Airport",
     "countryCode": "FJ",
     "iata": "LKB",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Lakeba"
  }, {
     "name": "Lokichogio Airport",
     "countryCode": "KE",
     "iata": "LKG",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Lokichogio"
  }, {
     "name": "Banak Airport",
     "countryCode": "NO",
     "iata": "LKL",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Lakselv"
  }, {
     "name": "Leknes Airport",
     "countryCode": "NO",
     "iata": "LKN",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Leknes"
  }, {
     "name": "Chaudhary Charan Singh International Airport",
     "countryCode": "IN",
     "iata": "LKO",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Lucknow"
  }, {
     "name": "Lake Placid Airport",
     "countryCode": "US",
     "iata": "LKP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lake Placid"
  }, {
     "name": "Lake County Airport",
     "countryCode": "US",
     "iata": "LKV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lakeview"
  }, {
     "name": "Lake Manyara Airport",
     "countryCode": "TZ",
     "iata": "LKY",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Lake Manyara"
  }, {
     "name": "Lakenheath RAF",
     "countryCode": "GB",
     "iata": "LKZ",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Brandon"
  }, {
     "name": "Lulea Airport",
     "countryCode": "SE",
     "iata": "LLA",
     "eucustoms": true,
     "countryDK": "Sverige",
     "cityDK": "Luleå"
  }, {
     "name": "Cagayan North International Airport",
     "countryCode": "PH",
     "iata": "LLC",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Lal-lo"
  }, {
     "name": "Malelane Airport",
     "countryCode": "ZA",
     "iata": "LLE",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Malelane"
  }, {
     "name": "Chillagoe Airport",
     "countryCode": "AU",
     "iata": "LLG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Chillagoe"
  }, {
     "name": "Lalibela Airport",
     "countryCode": "ET",
     "iata": "LLI",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Lalibela"
  }, {
     "name": "Lankaran International Airport",
     "countryCode": "AZ",
     "iata": "LLK",
     "eucustoms": false,
     "countryDK": "Aserbajdsjan",
     "cityDK": "Lankaran"
  }, {
     "name": "Alluitsup Paa Heliport",
     "countryCode": "GL",
     "iata": "LLU",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Alluitsup Paa"
  }, {
     "name": "Lilongwe International Airport",
     "countryCode": "MW",
     "iata": "LLW",
     "eucustoms": false,
     "countryDK": "Malawi",
     "cityDK": "Lilongwe"
  }, {
     "name": "Burlington County Airport",
     "countryCode": "US",
     "iata": "LLY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mount Holly"
  }, {
     "name": "Salima Airport",
     "countryCode": "MW",
     "iata": "LMB",
     "eucustoms": false,
     "countryDK": "Malawi",
     "cityDK": "Salima"
  }, {
     "name": "Arnage Airport",
     "countryCode": "FR",
     "iata": "LME",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Le Mans"
  }, {
     "name": "Federal Airport",
     "countryCode": "MX",
     "iata": "LMM",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Los Mochis"
  }, {
     "name": "Limbang Airport",
     "countryCode": "MY",
     "iata": "LMN",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Limbang"
  }, {
     "name": "Lossiemouth Royal Air Force Station",
     "countryCode": "GB",
     "iata": "LMO",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Lossiemouth"
  }, {
     "name": "Lampedusa Airport",
     "countryCode": "IT",
     "iata": "LMP",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Lampedusa"
  }, {
     "name": "Marsa el Brega Airport",
     "countryCode": "LY",
     "iata": "LMQ",
     "eucustoms": false,
     "countryDK": "Libyen",
     "cityDK": "Marsa El Brega"
  }, {
     "name": "Lima Acres Airport",
     "countryCode": "ZA",
     "iata": "LMR",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Lima Acres"
  }, {
     "name": "Winston County Airport",
     "countryCode": "US",
     "iata": "LMS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Louisville"
  }, {
     "name": "Crater Lake Klamath Regional Airport",
     "countryCode": "US",
     "iata": "LMT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Klamath Falls"
  }, {
     "name": "Palm Beach County Airport",
     "countryCode": "US",
     "iata": "LNA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "West Palm Beach"
  }, {
     "name": "Lamen Bay Airport",
     "countryCode": "VU",
     "iata": "LNB",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Lamen Bay"
  }, {
     "name": "Hunt Field",
     "countryCode": "US",
     "iata": "LND",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lander"
  }, {
     "name": "Lonorore Airport",
     "countryCode": "VU",
     "iata": "LNE",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Lonorore"
  }, {
     "name": "Lincoln Airport",
     "countryCode": "US",
     "iata": "LNK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lincoln"
  }, {
     "name": "Lost Nation Airport",
     "countryCode": "US",
     "iata": "LNN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Willoughby"
  }, {
     "name": "Leonora Airport",
     "countryCode": "AU",
     "iata": "LNO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Leonora"
  }, {
     "name": "Wise Airport",
     "countryCode": "US",
     "iata": "LNP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Klog"
  }, {
     "name": "Tri County Regional Airport",
     "countryCode": "US",
     "iata": "LNR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lone Rock"
  }, {
     "name": "Lancaster Airport",
     "countryCode": "US",
     "iata": "LNS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lancaster"
  }, {
     "name": "Kolonel RA Bessing Airport",
     "countryCode": "ID",
     "iata": "LNU",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Malinau"
  }, {
     "name": "Lanai Airport",
     "countryCode": "US",
     "iata": "LNY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lanai"
  }, {
     "name": "Linz Airport",
     "countryCode": "AT",
     "iata": "LNZ",
     "eucustoms": false,
     "countryDK": "Østrig",
     "cityDK": "Linz"
  }, {
     "name": "Lorraine Airport",
     "countryCode": "AU",
     "iata": "LOA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Lorraine"
  }, {
     "name": "Los Andes Airport",
     "countryCode": "CL",
     "iata": "LOB",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Los Andes"
  }, {
     "name": "Longana Airport",
     "countryCode": "VU",
     "iata": "LOD",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Longana"
  }, {
     "name": "Loei Airport",
     "countryCode": "TH",
     "iata": "LOE",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Loei"
  }, {
     "name": "Ciudad de Catamayo Airport",
     "countryCode": "EC",
     "iata": "LOH",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Loja"
  }, {
     "name": "Lodwar Airport",
     "countryCode": "KE",
     "iata": "LOK",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Lodwar"
  }, {
     "name": "Derby Field",
     "countryCode": "US",
     "iata": "LOL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lovelock"
  }, {
     "name": "L'Mekrareg Airport",
     "countryCode": "DZ",
     "iata": "LOO",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Laghouat"
  }, {
     "name": "Lombok International Airport",
     "countryCode": "ID",
     "iata": "LOP",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Praya"
  }, {
     "name": "Murtala Muhammed International Airport",
     "countryCode": "NG",
     "iata": "LOS",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Lagos"
  }, {
     "name": "Lewis University Airport",
     "countryCode": "US",
     "iata": "LOT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Romeoville"
  }, {
     "name": "Bowman Field",
     "countryCode": "US",
     "iata": "LOU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Louisville"
  }, {
     "name": "Venustiano Carranza International Airport",
     "countryCode": "MX",
     "iata": "LOV",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Monclova"
  }, {
     "name": "Louisa Airport",
     "countryCode": "US",
     "iata": "LOW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Louisa"
  }, {
     "name": "Loyangalani Airport",
     "countryCode": "KE",
     "iata": "LOY",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "loyangalani"
  }, {
     "name": "Magee Field",
     "countryCode": "US",
     "iata": "LOZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "London"
  }, {
     "name": "Gran Canaria Airport",
     "countryCode": "ES",
     "iata": "LPA",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Las Palmas"
  }, {
     "name": "Alverca Airport",
     "countryCode": "PT",
     "iata": "AVR",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Alverca"
  }, {
     "name": "El Alto International Airport",
     "countryCode": "BO",
     "iata": "LPB",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "La Paz"
  }, {
     "name": "Beja International Airport",
     "countryCode": "PT",
     "iata": "BYJ",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Beja"
  }, {
     "name": "Lompoc Airport",
     "countryCode": "US",
     "iata": "LPC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lompoc"
  }, {
     "name": "La Pedrera Airport",
     "countryCode": "CO",
     "iata": "LPD",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "La Pedrera"
  }, {
     "name": "La Plata Airport",
     "countryCode": "AR",
     "iata": "LPG",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "La Plata"
  }, {
     "name": "Linkoping City Airport",
     "countryCode": "SE",
     "iata": "LPI",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Linköping"
  }, {
     "name": "Liverpool John Lennon Airport",
     "countryCode": "GB",
     "iata": "LPL",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Liverpool"
  }, {
     "name": "Lamap Airport",
     "countryCode": "VU",
     "iata": "LPM",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Lamap"
  }, {
     "name": "Monte Real Airport",
     "countryCode": "PT",
     "iata": "QLR",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Monte Real"
  }, {
     "name": "Laporte Municipal Airport",
     "countryCode": "US",
     "iata": "LPO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Laporte"
  }, {
     "name": "Lappeenranta Airport",
     "countryCode": "FI",
     "iata": "LPP",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Lappeenranta"
  }, {
     "name": "Luang Prabang International Airport",
     "countryCode": "LA",
     "iata": "LPQ",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Luang Prabang"
  }, {
     "name": "Lampang Airport",
     "countryCode": "TH",
     "iata": "LPT",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Lampang"
  }, {
     "name": "Liepaya Airport",
     "countryCode": "LV",
     "iata": "LPX",
     "eucustoms": false,
     "countryDK": "Letland",
     "cityDK": "Liepaya"
  }, {
     "name": "Loudes Airport",
     "countryCode": "FR",
     "iata": "LPY",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Le Puy"
  }, {
     "name": "Pickens Airport",
     "countryCode": "US",
     "iata": "LQK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pickens"
  }, {
     "name": "Puerto Leguizamo Airport",
     "countryCode": "CO",
     "iata": "LQM",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Puerto Leguizamo"
  }, {
     "name": "Qala i Naw Airport",
     "countryCode": "AF",
     "iata": "LQN",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Qala i Naw"
  }, {
     "name": "Larisa Airport",
     "countryCode": "GR",
     "iata": "LRA",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Larisa"
  }, {
     "name": "Leribe Airport",
     "countryCode": "LS",
     "iata": "LRB",
     "eucustoms": false,
     "countryDK": "Lesotho",
     "cityDK": "Leribe"
  }, {
     "name": "Laredo International Airport",
     "countryCode": "US",
     "iata": "LRD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Laredo"
  }, {
     "name": "Longreach Airport",
     "countryCode": "AU",
     "iata": "LRE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Longreach"
  }, {
     "name": "Little Rock Air Force Base",
     "countryCode": "US",
     "iata": "LRF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jacksonville"
  }, {
     "name": "Laleu Airport",
     "countryCode": "FR",
     "iata": "LRH",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "La Rochelle"
  }, {
     "name": "Lemars Municipal Airport",
     "countryCode": "US",
     "iata": "LRJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lemars"
  }, {
     "name": "Niamtougou Airport",
     "countryCode": "TG",
     "iata": "LRL",
     "eucustoms": false,
     "countryDK": "Togo",
     "cityDK": "Niamtougou"
  }, {
     "name": "La Romana Airport",
     "countryCode": "DO",
     "iata": "LRM",
     "eucustoms": false,
     "countryDK": "Dominikanske Republik",
     "cityDK": "La Romana"
  }, {
     "name": "Lar Airport",
     "countryCode": "IR",
     "iata": "LRR",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Lar"
  }, {
     "name": "Leros Airport",
     "countryCode": "GR",
     "iata": "LRS",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Leros"
  }, {
     "name": "Lann Bihoue Airport",
     "countryCode": "FR",
     "iata": "LRT",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Lorient"
  }, {
     "name": "Las Cruces Municipal Airport",
     "countryCode": "US",
     "iata": "LRU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Las Cruces"
  }, {
     "name": "Lordsburg Airport",
     "countryCode": "US",
     "iata": "LSB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lordsburg"
  }, {
     "name": "La Florida Airport",
     "countryCode": "CL",
     "iata": "LSC",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "La Serena"
  }, {
     "name": "La Crosse Regional Airport",
     "countryCode": "US",
     "iata": "LSE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "La Crosse"
  }, {
     "name": "Lawson Army Air Field - Ft Benning",
     "countryCode": "US",
     "iata": "LSF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbus"
  }, {
     "name": "Lashio Airport",
     "countryCode": "MM",
     "iata": "LSH",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Lashio"
  }, {
     "name": "Sumburgh Airport",
     "countryCode": "GB",
     "iata": "LSI",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Shetlandsøerne"
  }, {
     "name": "Lusk Municipal",
     "countryCode": "US",
     "iata": "LSK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lusk"
  }, {
     "name": "Los Chiles Airport",
     "countryCode": "CR",
     "iata": "LSL",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Los Chiles"
  }, {
     "name": "Los Banos Airport",
     "countryCode": "US",
     "iata": "LSN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Los Banos"
  }, {
     "name": "Josefa Camejo Airport",
     "countryCode": "VE",
     "iata": "LSP",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Las Piedras"
  }, {
     "name": "Los Angeles Airport",
     "countryCode": "CL",
     "iata": "LSQ",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Los Angeles"
  }, {
     "name": "Les Saintes Airport",
     "countryCode": "GP",
     "iata": "LSS",
     "eucustoms": false,
     "countryDK": "Guadeloupe",
     "cityDK": "Terre-de-Haut"
  }, {
     "name": "Launceston Airport",
     "countryCode": "AU",
     "iata": "LST",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Launceston"
  }, {
     "name": "Nellis Air Force Base",
     "countryCode": "US",
     "iata": "LSV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Las Vegas"
  }, {
     "name": "Malikus Saleh Airport",
     "countryCode": "ID",
     "iata": "LSW",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Lhoksumawe"
  }, {
     "name": "Lismore Airport",
     "countryCode": "AU",
     "iata": "LSY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Lismore"
  }, {
     "name": "Losinj Airport",
     "countryCode": "HR",
     "iata": "LSZ",
     "eucustoms": false,
     "countryDK": "Kroatien",
     "cityDK": "Mali Losinj"
  }, {
     "name": "Letaba Airport",
     "countryCode": "ZA",
     "iata": "LTA",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Tzaneen"
  }, {
     "name": "Lai Airport",
     "countryCode": "TD",
     "iata": "LTC",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Lai"
  }, {
     "name": "Ghadames Airport",
     "countryCode": "LY",
     "iata": "LTD",
     "eucustoms": false,
     "countryDK": "Libyen",
     "cityDK": "Ghadames"
  }, {
     "name": "Altai Airport",
     "countryCode": "MN",
     "iata": "LTI",
     "eucustoms": false,
     "countryDK": "Mongoliet",
     "cityDK": "Altai"
  }, {
     "name": "Bassel al-Assad International Airport",
     "countryCode": "SY",
     "iata": "LTK",
     "eucustoms": false,
     "countryDK": "Syrien",
     "cityDK": "Latakia"
  }, {
     "name": "Lastourville Airport",
     "countryCode": "GA",
     "iata": "LTL",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Lastourville"
  }, {
     "name": "Lethem Airport",
     "countryCode": "GY",
     "iata": "LTM",
     "eucustoms": false,
     "countryDK": "Guyana",
     "cityDK": "Lethem"
  }, {
     "name": "London Luton Airport",
     "countryCode": "GB",
     "iata": "LTN",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "London"
  }, {
     "name": "Loreto Airport",
     "countryCode": "MX",
     "iata": "LTO",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Loreto"
  }, {
     "name": "Le Touquet Airport",
     "countryCode": "FR",
     "iata": "LTQ",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Le Touquet"
  }, {
     "name": "Altus Air Force Base",
     "countryCode": "US",
     "iata": "LTS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Altus"
  }, {
     "name": "La Mole Airport",
     "countryCode": "FR",
     "iata": "LTT",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Saint Tropez"
  }, {
     "name": "Cotapaxi International Airport",
     "countryCode": "EC",
     "iata": "LTX",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Latacunga"
  }, {
     "name": "Tenzing-Hillary Airport",
     "countryCode": "NP",
     "iata": "LUA",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Lukla"
  }, {
     "name": "Lumid Pau Airport",
     "countryCode": "GY",
     "iata": "LUB",
     "eucustoms": false,
     "countryDK": "Guyana",
     "cityDK": "Lumid Pau"
  }, {
     "name": "Laucala Island Airport",
     "countryCode": "FJ",
     "iata": "LUC",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Laucala Island"
  }, {
     "name": "Luderitz Airport",
     "countryCode": "NA",
     "iata": "LUD",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Luderitz"
  }, {
     "name": "Luke Air Force Base",
     "countryCode": "US",
     "iata": "LUF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Phoenix"
  }, {
     "name": "Lugano Airport",
     "countryCode": "CH",
     "iata": "LUG",
     "eucustoms": false,
     "countryDK": "Schweiz",
     "cityDK": "Lugano"
  }, {
     "name": "Ludhiana Airport",
     "countryCode": "IN",
     "iata": "LUH",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Ludhiana"
  }, {
     "name": "Lusikisiki Airport",
     "countryCode": "ZA",
     "iata": "LUJ",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Lusikisiki"
  }, {
     "name": "Cincinnati Municipal Airport -  Lunken Field",
     "countryCode": "US",
     "iata": "LUK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cincinnati"
  }, {
     "name": "Hesler-Noble Field",
     "countryCode": "US",
     "iata": "LUL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Laurel"
  }, {
     "name": "Dehong Mangshi Airport",
     "countryCode": "CN",
     "iata": "LUM",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Mangshi"
  }, {
     "name": "Kenneth Kaunda International Airport",
     "countryCode": "ZM",
     "iata": "LUN",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Lusaka"
  }, {
     "name": "Luena Airport",
     "countryCode": "AO",
     "iata": "LUO",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Luena"
  }, {
     "name": "Kalaupapa Airport",
     "countryCode": "US",
     "iata": "LUP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kalaupapa"
  }, {
     "name": "San Luis Airport",
     "countryCode": "AR",
     "iata": "LUQ",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "San Luis"
  }, {
     "name": "Cape Lisburne Airport",
     "countryCode": "US",
     "iata": "LUR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Cape Lisburne"
  }, {
     "name": "Lusanga Airport",
     "countryCode": "CD",
     "iata": "LUS",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Lusanga"
  }, {
     "name": "S. Aminuddin Amir Airport",
     "countryCode": "ID",
     "iata": "LUW",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Luwuk"
  }, {
     "name": "Luxembourg Airport",
     "countryCode": "LU",
     "iata": "LUX",
     "eucustoms": true,
     "countryDK": "Luxembourg",
     "cityDK": "Luxembourg"
  }, {
     "name": "Lublin Airport",
     "countryCode": "PL",
     "iata": "LUZ",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Swidnik"
  }, {
     "name": "Entrammes Airport",
     "countryCode": "FR",
     "iata": "LVA",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Laval"
  }, {
     "name": "Dos Galpoes Airport",
     "countryCode": "BR",
     "iata": "LVB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Livramento"
  }, {
     "name": "Livingstone Airport",
     "countryCode": "ZM",
     "iata": "LVI",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Livingstone"
  }, {
     "name": "Livermore Municipal Airport",
     "countryCode": "US",
     "iata": "LVK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Livermore"
  }, {
     "name": "Lawrenceville Airport",
     "countryCode": "US",
     "iata": "LVL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lawrenceville"
  }, {
     "name": "Mission Field",
     "countryCode": "US",
     "iata": "LVM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Livingston"
  }, {
     "name": "Laverton Airport",
     "countryCode": "AU",
     "iata": "LVO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Laverton"
  }, {
     "name": "Lavan Island Airport",
     "countryCode": "IR",
     "iata": "LVP",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Lavan"
  }, {
     "name": "Las Vegas Airport",
     "countryCode": "US",
     "iata": "LVS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Las Vegas"
  }, {
     "name": "Greenbrier Valley Airport",
     "countryCode": "US",
     "iata": "LWB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lewisburg"
  }, {
     "name": "Lawrence Airport",
     "countryCode": "US",
     "iata": "LWC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lawrence"
  }, {
     "name": "Lawn Hill Airport",
     "countryCode": "AU",
     "iata": "LWH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Lawn Hill"
  }, {
     "name": "Lerwick/Tingwall Airport",
     "countryCode": "GB",
     "iata": "LWK",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Shetlandsøerne"
  }, {
     "name": "Wells Municipal Airport-Harriet Field",
     "countryCode": "US",
     "iata": "LWL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wells"
  }, {
     "name": "Lawrence Municipal Airport",
     "countryCode": "US",
     "iata": "LWM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lawrence"
  }, {
     "name": "Lviv International Airport",
     "countryCode": "UA",
     "iata": "LWO",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Lviv"
  }, {
     "name": "Leeuwarden Air Base",
     "countryCode": "NL",
     "iata": "LWR",
     "eucustoms": false,
     "countryDK": "Holland",
     "cityDK": "Leeuwarden"
  }, {
     "name": "Lewiston-Nez Perce County Regional Airport",
     "countryCode": "US",
     "iata": "LWS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lewiston"
  }, {
     "name": "Lewistown Municipal Airport",
     "countryCode": "US",
     "iata": "LWT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lewistown"
  }, {
     "name": "Lawrenceville Municipal Airport",
     "countryCode": "US",
     "iata": "LWV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lawrenceville"
  }, {
     "name": "Lawas Airport",
     "countryCode": "MY",
     "iata": "LWY",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Lawas"
  }, {
     "name": "Lhasa Gonggar Airport",
     "countryCode": "CN",
     "iata": "LXA",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Lhasa"
  }, {
     "name": "Luang Namtha Airport",
     "countryCode": "LA",
     "iata": "LXG",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Luang Namtha"
  }, {
     "name": "Jim Kelly Field",
     "countryCode": "US",
     "iata": "LXN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lexington"
  }, {
     "name": "Luxor International Airport",
     "countryCode": "EG",
     "iata": "LXR",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Luxor"
  }, {
     "name": "Limnos Airport",
     "countryCode": "GR",
     "iata": "LXS",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Limnos"
  }, {
     "name": "Lukulu Airport",
     "countryCode": "ZM",
     "iata": "LXU",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Lukulu"
  }, {
     "name": "Leadville Airport",
     "countryCode": "US",
     "iata": "LXV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Leadville"
  }, {
     "name": "Luoyang Beijiao Airport",
     "countryCode": "CN",
     "iata": "LYA",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Luoyang"
  }, {
     "name": "Lycksele Airport",
     "countryCode": "SE",
     "iata": "LYC",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Lycksele"
  }, {
     "name": "Lyneham Royal Air Force Station",
     "countryCode": "GB",
     "iata": "LYE",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Lyneham"
  }, {
     "name": "Lianyungang Airport",
     "countryCode": "CN",
     "iata": "LYG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Lianyungang"
  }, {
     "name": "Preston-Glenn Field",
     "countryCode": "US",
     "iata": "LYH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lynchburg"
  }, {
     "name": "Bron Airport",
     "countryCode": "FR",
     "iata": "LYN",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Lyon"
  }, {
     "name": "Rice County Municipal Airport",
     "countryCode": "US",
     "iata": "LYO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lyons"
  }, {
     "name": "Faisalabad Airport",
     "countryCode": "PK",
     "iata": "LYP",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Faisalabad"
  }, {
     "name": "Christmas Island Airport",
     "countryCode": "CX",
     "iata": "XCH",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Juløen"
  }, {
     "name": "Lyon Saint-Exupery International Airport",
     "countryCode": "FR",
     "iata": "LYS",
     "eucustoms": true,
     "countryDK": "Frankrig",
     "cityDK": "Lyon"
  }, {
     "name": "Ely Airport",
     "countryCode": "US",
     "iata": "LYU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ely"
  }, {
     "name": "Lydd International Airport",
     "countryCode": "GB",
     "iata": "LYX",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Lydd"
  }, {
     "name": "Luiza Airport",
     "countryCode": "CD",
     "iata": "LZA",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Luiza"
  }, {
     "name": "Lazaro Cardenas Airport",
     "countryCode": "MX",
     "iata": "LZC",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Lazaro Cardenas"
  }, {
     "name": "Liuzhou Airport",
     "countryCode": "CN",
     "iata": "LZH",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Liuzhou"
  }, {
     "name": "Luozi Airport",
     "countryCode": "CD",
     "iata": "LZI",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Luozi"
  }, {
     "name": "Yunlong Airport",
     "countryCode": "CN",
     "iata": "LZO",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Luzhou"
  }, {
     "name": "Lizard Island Airport",
     "countryCode": "AU",
     "iata": "LZR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Lizard Island"
  }, {
     "name": "Nyingchi Mainling Airport",
     "countryCode": "CN",
     "iata": "LZY",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Nyingchi"
  }, {
     "name": "Chennai Airport",
     "countryCode": "IN",
     "iata": "MAA",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Chennai"
  }, {
     "name": "Maraba Airport",
     "countryCode": "BR",
     "iata": "MAB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Maraba"
  }, {
     "name": "Macon Downtown Airport",
     "countryCode": "US",
     "iata": "MAC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Macon"
  }, {
     "name": "Adolfo Suarez Madrid-Barajas Airport",
     "countryCode": "ES",
     "iata": "MAD",
     "eucustoms": true,
     "countryDK": "Spanien",
     "cityDK": "Madrid"
  }, {
     "name": "Madera Airport",
     "countryCode": "US",
     "iata": "MAE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Madera"
  }, {
     "name": "Midland International Airport",
     "countryCode": "US",
     "iata": "MAF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Midland"
  }, {
     "name": "Madang Airport",
     "countryCode": "PG",
     "iata": "MAG",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Madang"
  }, {
     "name": "Menorca Airport",
     "countryCode": "ES",
     "iata": "MAH",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Menorca"
  }, {
     "name": "Mangochi Airport",
     "countryCode": "MW",
     "iata": "MAI",
     "eucustoms": false,
     "countryDK": "Malawi",
     "cityDK": "Mangochi"
  }, {
     "name": "Amata Kabua International Airport",
     "countryCode": "MH",
     "iata": "MAJ",
     "eucustoms": false,
     "countryDK": "Marshalløerne",
     "cityDK": "Majuro"
  }, {
     "name": "Malakal Airport",
     "countryCode": "SS",
     "iata": "MAK",
     "eucustoms": false,
     "countryDK": "Sydsudan",
     "cityDK": "Malakal"
  }, {
     "name": "Matamoros Airport",
     "countryCode": "MX",
     "iata": "MAM",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Matamoros"
  }, {
     "name": "Manchester Airport",
     "countryCode": "GB",
     "iata": "MAN",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Manchester"
  }, {
     "name": "Eduardo Gomes International Airport",
     "countryCode": "BR",
     "iata": "MAO",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Manaus"
  }, {
     "name": "Mae Sot Airport",
     "countryCode": "TH",
     "iata": "MAQ",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Mae Sot"
  }, {
     "name": "La Chinita Airport",
     "countryCode": "VE",
     "iata": "MAR",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Maracaibo"
  }, {
     "name": "Matadi Airport",
     "countryCode": "CD",
     "iata": "MAT",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Matadi"
  }, {
     "name": "Maupiti Airport",
     "countryCode": "PF",
     "iata": "MAU",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Maupiti"
  }, {
     "name": "Malden Airport",
     "countryCode": "US",
     "iata": "MAW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Malden"
  }, {
     "name": "Matam Airport",
     "countryCode": "SN",
     "iata": "MAX",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Matam"
  }, {
     "name": "Mangrove Cay Airport",
     "countryCode": "BS",
     "iata": "MAY",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Mangrove Cay"
  }, {
     "name": "Eugenio M. De Hostos Airport",
     "countryCode": "PR",
     "iata": "MAZ",
     "eucustoms": false,
     "countryDK": "Puerto Rico",
     "cityDK": "Mayaguez"
  }, {
     "name": "Moi International Airport",
     "countryCode": "KE",
     "iata": "MBA",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Mombasa"
  }, {
     "name": "Marble Bar Airport",
     "countryCode": "AU",
     "iata": "MBB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Marmorbar"
  }, {
     "name": "Mbigou Airport",
     "countryCode": "GA",
     "iata": "MBC",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Mbigou"
  }, {
     "name": "Mmabatho International Airport",
     "countryCode": "ZA",
     "iata": "MBD",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Mmabatho"
  }, {
     "name": "Monbetsu Airport",
     "countryCode": "JP",
     "iata": "MBE",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Monbetsu"
  }, {
     "name": "Mobridge Municipal Airport",
     "countryCode": "US",
     "iata": "MBG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mobridge"
  }, {
     "name": "Maryborough Airport",
     "countryCode": "AU",
     "iata": "MBH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Maryborough"
  }, {
     "name": "Mbeya Airport",
     "countryCode": "TZ",
     "iata": "MBI",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Mbeya"
  }, {
     "name": "Sangster International Airport",
     "countryCode": "JM",
     "iata": "MBJ",
     "eucustoms": false,
     "countryDK": "Jamaica",
     "cityDK": "Montego Bay"
  }, {
     "name": "Blacker Airport",
     "countryCode": "US",
     "iata": "MBL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Manistee"
  }, {
     "name": "Mamburao Airport",
     "countryCode": "PH",
     "iata": "MBO",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Mamburao"
  }, {
     "name": "Moyobamba Airport",
     "countryCode": "PE",
     "iata": "MBP",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Moyobamba"
  }, {
     "name": "Mbarara Airport",
     "countryCode": "UG",
     "iata": "MBQ",
     "eucustoms": false,
     "countryDK": "Uganda",
     "cityDK": "Mbarara"
  }, {
     "name": "MBS International Airport",
     "countryCode": "US",
     "iata": "MBS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saginaw"
  }, {
     "name": "Moises R. Espinosa Airport",
     "countryCode": "PH",
     "iata": "MBT",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Masbate"
  }, {
     "name": "Moorabbin Airport",
     "countryCode": "AU",
     "iata": "MBW",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Moorabbin"
  }, {
     "name": "Maribor Edvard Rusjan Airport",
     "countryCode": "SI",
     "iata": "MBX",
     "eucustoms": false,
     "countryDK": "Slovenien",
     "cityDK": "Maribor"
  }, {
     "name": "Moberly Airport",
     "countryCode": "US",
     "iata": "MBY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Moberly"
  }, {
     "name": "Maues Airport",
     "countryCode": "BR",
     "iata": "MBZ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Maues"
  }, {
     "name": "Macenta Airport",
     "countryCode": "GN",
     "iata": "MCA",
     "eucustoms": false,
     "countryDK": "Guinea",
     "cityDK": "Macenta"
  }, {
     "name": "Pike County Airport",
     "countryCode": "US",
     "iata": "MCB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mc Comb"
  }, {
     "name": "McClellan Air Force Base",
     "countryCode": "US",
     "iata": "MCC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sacramento"
  }, {
     "name": "Mackinac Island Airport",
     "countryCode": "US",
     "iata": "MCD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mackinac Island"
  }, {
     "name": "Merced Municipal Airport",
     "countryCode": "US",
     "iata": "MCE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Merced"
  }, {
     "name": "MacDill Air Force Base",
     "countryCode": "US",
     "iata": "MCF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tampa"
  }, {
     "name": "McGrath Airport",
     "countryCode": "US",
     "iata": "MCG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "McGrath"
  }, {
     "name": "Machala Airport",
     "countryCode": "EC",
     "iata": "MCH",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Machala"
  }, {
     "name": "Kansas City International Airport",
     "countryCode": "US",
     "iata": "MCI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kansas City"
  }, {
     "name": "Jorge Isaacs Airport",
     "countryCode": "CO",
     "iata": "MCJ",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Maicao"
  }, {
     "name": "Mc Cook Airport",
     "countryCode": "US",
     "iata": "MCK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "McCook"
  }, {
     "name": "Mount Mckinley Airport",
     "countryCode": "US",
     "iata": "MCL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mount McKinley"
  }, {
     "name": "Fontvielle Heliport",
     "countryCode": "MC",
     "iata": "MCM",
     "eucustoms": false,
     "countryDK": "Monaco",
     "cityDK": "Monte Carlo"
  }, {
     "name": "Middle Georgia Regional Airport",
     "countryCode": "US",
     "iata": "MCN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Macon"
  }, {
     "name": "Orlando International Airport",
     "countryCode": "US",
     "iata": "MCO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Orlando"
  }, {
     "name": "Macapa International Airport",
     "countryCode": "BR",
     "iata": "MCP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Macapa"
  }, {
     "name": "Monte Caseros Airport",
     "countryCode": "AR",
     "iata": "MCS",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Monte Caseros"
  }, {
     "name": "Muscat International Airport",
     "countryCode": "OM",
     "iata": "MCT",
     "eucustoms": false,
     "countryDK": "Oman",
     "cityDK": "Muscat"
  }, {
     "name": "Gueret (Lepaud) Airport",
     "countryCode": "FR",
     "iata": "MCU",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Montlucon"
  }, {
     "name": "Mcarthur River Airport",
     "countryCode": "AU",
     "iata": "MCV",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mcarthur River"
  }, {
     "name": "Mason City Airport",
     "countryCode": "US",
     "iata": "MCW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mason City"
  }, {
     "name": "Makhachkala Airport",
     "countryCode": "RU",
     "iata": "MCX",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Makhachkala"
  }, {
     "name": "Sunshine Coast Airport",
     "countryCode": "AU",
     "iata": "MCY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Sunshine Coast"
  }, {
     "name": "Maceio-Zumbi dos Palmares International Airport",
     "countryCode": "BR",
     "iata": "MCZ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Maceio"
  }, {
     "name": "Martindale Army Air Field",
     "countryCode": "US",
     "iata": "MDA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Antonio"
  }, {
     "name": "Sam Ratulangi International Airport",
     "countryCode": "ID",
     "iata": "MDC",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Manado"
  }, {
     "name": "Midland Airpark",
     "countryCode": "US",
     "iata": "MDD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Midland"
  }, {
     "name": "Jose Maria Cordova International Airport",
     "countryCode": "CO",
     "iata": "MDE",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Medellin"
  }, {
     "name": "Mudanjiang Airport",
     "countryCode": "CN",
     "iata": "MDG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Mudanjiang"
  }, {
     "name": "Southern Illinois Airport",
     "countryCode": "US",
     "iata": "MDH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Carbondale"
  }, {
     "name": "Mbandaka Airport",
     "countryCode": "CD",
     "iata": "MDK",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Mbandaka"
  }, {
     "name": "Mandalay International Airport",
     "countryCode": "MM",
     "iata": "MDL",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Mandalay"
  }, {
     "name": "Middleton Island Intermediate Airport",
     "countryCode": "US",
     "iata": "MDO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Middleton Island"
  }, {
     "name": "Mar Del Plata Airport",
     "countryCode": "AR",
     "iata": "MDQ",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Mar Del Plata"
  }, {
     "name": "Middle Caicos Airport",
     "countryCode": "TC",
     "iata": "MDS",
     "eucustoms": false,
     "countryDK": "Turks- og Caicosøerne",
     "cityDK": "Mellem Caicos"
  }, {
     "name": "Harrisburg International Airport",
     "countryCode": "US",
     "iata": "MDT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Middletown"
  }, {
     "name": "Chicago Midway International Airport",
     "countryCode": "US",
     "iata": "MDW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chicago"
  }, {
     "name": "Mercedes Airport",
     "countryCode": "AR",
     "iata": "MDX",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Mercedes"
  }, {
     "name": "Mount Pleasant RAF Station",
     "countryCode": "FK",
     "iata": "MPN",
     "eucustoms": false,
     "countryDK": "Falklandsøerne",
     "cityDK": "Mount Pleasant"
  }, {
     "name": "El Plumerillo International Airport",
     "countryCode": "AR",
     "iata": "MDZ",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Mendoza"
  }, {
     "name": "Macae Airport",
     "countryCode": "BR",
     "iata": "MEA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Macaé"
  }, {
     "name": "Essendon Airport",
     "countryCode": "AU",
     "iata": "MEB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Melbourne"
  }, {
     "name": "Manta Airport",
     "countryCode": "EC",
     "iata": "MEC",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Manta"
  }, {
     "name": "Prince Mohammad Bin Abdulaziz International Airport",
     "countryCode": "SA",
     "iata": "MED",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Madinah"
  }, {
     "name": "Mare Airport",
     "countryCode": "NC",
     "iata": "MEE",
     "eucustoms": false,
     "countryDK": "Ny Kaledonien",
     "cityDK": "Hoppe"
  }, {
     "name": "Malanje Airport",
     "countryCode": "AO",
     "iata": "MEG",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Malanje"
  }, {
     "name": "Mehamn Airport",
     "countryCode": "NO",
     "iata": "MEH",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Mehamn"
  }, {
     "name": "Key Field",
     "countryCode": "US",
     "iata": "MEI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "meridian"
  }, {
     "name": "Meadville Airport",
     "countryCode": "US",
     "iata": "MEJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Meadville"
  }, {
     "name": "Melbourne Tullamarine Airport",
     "countryCode": "AU",
     "iata": "MEL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Melbourne"
  }, {
     "name": "Memphis International Airport",
     "countryCode": "US",
     "iata": "MEM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Memphis"
  }, {
     "name": "Brenoux Airport",
     "countryCode": "FR",
     "iata": "MEN",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Mende"
  }, {
     "name": "Dare County Regional Airport",
     "countryCode": "US",
     "iata": "MEO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Manteo"
  }, {
     "name": "Castle Air Force Base",
     "countryCode": "US",
     "iata": "MER",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Merced"
  }, {
     "name": "Soewondo Air Force Base",
     "countryCode": "ID",
     "iata": "MES",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Medan"
  }, {
     "name": "Monte Dourado Airport",
     "countryCode": "BR",
     "iata": "MEU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Monte Dourado"
  }, {
     "name": "Douglas County Airport",
     "countryCode": "US",
     "iata": "MEV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Minden"
  }, {
     "name": "Mweka Airport",
     "countryCode": "CD",
     "iata": "MEW",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Mweka"
  }, {
     "name": "Benito Juarez International Airport",
     "countryCode": "MX",
     "iata": "MEX",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Mexico City"
  }, {
     "name": "Meghauli Airport",
     "countryCode": "NP",
     "iata": "MEY",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Meghauli"
  }, {
     "name": "Mafia Island Airport",
     "countryCode": "TZ",
     "iata": "MFA",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Mafia Island"
  }, {
     "name": "Mafeteng Airport",
     "countryCode": "LS",
     "iata": "MFC",
     "eucustoms": false,
     "countryDK": "Lesotho",
     "cityDK": "Mafeteng"
  }, {
     "name": "Lahm Municipal Airport",
     "countryCode": "US",
     "iata": "MFD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mansfield"
  }, {
     "name": "McAllen International Airport",
     "countryCode": "US",
     "iata": "MFE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "McAllen"
  }, {
     "name": "Moanda Airport",
     "countryCode": "GA",
     "iata": "MFF",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Moanda"
  }, {
     "name": "Muzaffarabad Airport",
     "countryCode": "PK",
     "iata": "MFG",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Muzaffarabad"
  }, {
     "name": "Marshfield Municipal Airport",
     "countryCode": "US",
     "iata": "MFI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marshfield"
  }, {
     "name": "Moala Airport",
     "countryCode": "FJ",
     "iata": "MFJ",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Moala"
  }, {
     "name": "Matsu Beigan Airport",
     "countryCode": "TW",
     "iata": "MFK",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Matsu"
  }, {
     "name": "Macau International Airport",
     "countryCode": "MO",
     "iata": "MFM",
     "eucustoms": false,
     "countryDK": "Macao",
     "cityDK": "Macau"
  }, {
     "name": "Milford Sound Airport",
     "countryCode": "NZ",
     "iata": "MFN",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Milford Sound"
  }, {
     "name": "Manguna Airport",
     "countryCode": "PG",
     "iata": "MFO",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Manguna"
  }, {
     "name": "Maradi Airport",
     "countryCode": "NE",
     "iata": "MFQ",
     "eucustoms": false,
     "countryDK": "Niger",
     "cityDK": "Maradi"
  }, {
     "name": "Rogue Valley International-Medford Airport",
     "countryCode": "US",
     "iata": "MFR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Medford"
  }, {
     "name": "Miraflores Airport",
     "countryCode": "CO",
     "iata": "MFS",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Miraflores"
  }, {
     "name": "Mfuwe Airport",
     "countryCode": "ZM",
     "iata": "MFU",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Mfuwe"
  }, {
     "name": "Accomack County Airport",
     "countryCode": "US",
     "iata": "MFV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Melfa"
  }, {
     "name": "Meribel Airport",
     "countryCode": "FR",
     "iata": "MFX",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Meribel"
  }, {
     "name": "Augusto C Sandino International Airport",
     "countryCode": "NI",
     "iata": "MGA",
     "eucustoms": false,
     "countryDK": "Nicaragua",
     "cityDK": "Managua"
  }, {
     "name": "Mount Gambier Airport",
     "countryCode": "AU",
     "iata": "MGB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mount Gambier"
  }, {
     "name": "Michigan City Airport",
     "countryCode": "US",
     "iata": "MGC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Michigan City"
  }, {
     "name": "Magdalena Airport",
     "countryCode": "BO",
     "iata": "MGD",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Magdalena"
  }, {
     "name": "Dobbins Air Force Base",
     "countryCode": "US",
     "iata": "MGE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marietta"
  }, {
     "name": "Regional De Maringa",
     "countryCode": "BR",
     "iata": "MGF",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Maringa"
  }, {
     "name": "Margate Airport",
     "countryCode": "ZA",
     "iata": "MGH",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Margate"
  }, {
     "name": "Orange County Airport",
     "countryCode": "US",
     "iata": "MGJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Montgomery"
  }, {
     "name": "Mong Ton Airport",
     "countryCode": "MM",
     "iata": "MGK",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Mong Ton"
  }, {
     "name": "Monchengladbach Airport",
     "countryCode": "DE",
     "iata": "MGL",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Düsseldorf"
  }, {
     "name": "Montgomery Regional Airport-Dannelly Field",
     "countryCode": "US",
     "iata": "MGM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Montgomery"
  }, {
     "name": "Baracoa Airport",
     "countryCode": "CO",
     "iata": "MGN",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Magangue"
  }, {
     "name": "Mogadishu International Airport",
     "countryCode": "SO",
     "iata": "MGQ",
     "eucustoms": false,
     "countryDK": "Somalia",
     "cityDK": "Mogadishu"
  }, {
     "name": "Thomasville Airport",
     "countryCode": "US",
     "iata": "MGR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Moultrie"
  }, {
     "name": "Mangaia Island Airport",
     "countryCode": "CK",
     "iata": "MGS",
     "eucustoms": false,
     "countryDK": "Cookøerne",
     "cityDK": "Mangaia Island"
  }, {
     "name": "Milingimbi Airport",
     "countryCode": "AU",
     "iata": "MGT",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Milingimbi"
  }, {
     "name": "Manaung Airport",
     "countryCode": "MM",
     "iata": "MGU",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Manaung"
  }, {
     "name": "Margaret River Station Airport",
     "countryCode": "AU",
     "iata": "MGV",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Margaret River Station"
  }, {
     "name": "Morgantown Airport",
     "countryCode": "US",
     "iata": "MGW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Morgantown"
  }, {
     "name": "Moabi Airport",
     "countryCode": "GA",
     "iata": "MGX",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Moabi"
  }, {
     "name": "Myeik Airport",
     "countryCode": "MM",
     "iata": "MGZ",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Myeik"
  }, {
     "name": "Mahdia Airport",
     "countryCode": "GY",
     "iata": "MHA",
     "eucustoms": false,
     "countryDK": "Guyana",
     "cityDK": "Mahdia"
  }, {
     "name": "Mocopulli Airport",
     "countryCode": "CL",
     "iata": "MHC",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Castro"
  }, {
     "name": "Shahid Hashemi Nejad Airport",
     "countryCode": "IR",
     "iata": "MHD",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Mashad"
  }, {
     "name": "Mitchell Municipal Airport",
     "countryCode": "US",
     "iata": "MHE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mitchell"
  }, {
     "name": "Mannheim Airport",
     "countryCode": "DE",
     "iata": "MHG",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Mannheim"
  }, {
     "name": "Marsh Harbour International Airport",
     "countryCode": "BS",
     "iata": "MHH",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Marsh Harbour"
  }, {
     "name": "Manhattan Municipal Airport",
     "countryCode": "US",
     "iata": "MHK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Manhattan"
  }, {
     "name": "Memorial Municipal Airport",
     "countryCode": "US",
     "iata": "MHL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marshall"
  }, {
     "name": "Minchumina Intermediate Airport",
     "countryCode": "US",
     "iata": "MHM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Minchumina"
  }, {
     "name": "Mullen Airport",
     "countryCode": "US",
     "iata": "MHN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mullen"
  }, {
     "name": "Mount House Airport",
     "countryCode": "AU",
     "iata": "MHO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mount House"
  }, {
     "name": "Minsk International 1 Airport",
     "countryCode": "BY",
     "iata": "MHP",
     "eucustoms": false,
     "countryDK": "Hviderusland",
     "cityDK": "Minsk"
  }, {
     "name": "Ohrid Airport",
     "countryCode": "MK",
     "iata": "OHD",
     "eucustoms": false,
     "countryDK": "Makedonien",
     "cityDK": "Ohrid"
  }, {
     "name": "Mather Airport",
     "countryCode": "US",
     "iata": "MHR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sacramento"
  }, {
     "name": "Manchester Boston Regional Airport",
     "countryCode": "US",
     "iata": "MHT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Manchester"
  }, {
     "name": "Mojave Air and Space Port",
     "countryCode": "US",
     "iata": "MHV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mojave"
  }, {
     "name": "Monteagudo Airport",
     "countryCode": "BO",
     "iata": "MHW",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Monteagudo"
  }, {
     "name": "Manihiki Island Airport",
     "countryCode": "CK",
     "iata": "MHX",
     "eucustoms": false,
     "countryDK": "Cookøerne",
     "cityDK": "Manihiki Island"
  }, {
     "name": "Mildenhall RAF Station",
     "countryCode": "GB",
     "iata": "MHZ",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Mildenhall"
  }, {
     "name": "Miami International Airport",
     "countryCode": "US",
     "iata": "MIA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Miami"
  }, {
     "name": "Minot Air Force Base",
     "countryCode": "US",
     "iata": "MIB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Minot"
  }, {
     "name": "Crystal Airport",
     "countryCode": "US",
     "iata": "MIC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Minneapolis"
  }, {
     "name": "Manuel Crescencio Rejon International Airport",
     "countryCode": "MX",
     "iata": "MID",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Merida"
  }, {
     "name": "Delaware County Regional Airport",
     "countryCode": "US",
     "iata": "MIE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Muncie"
  }, {
     "name": "Mianyang Nanjiao Airport",
     "countryCode": "CN",
     "iata": "MIG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Mian Yang"
  }, {
     "name": "Dr Gastao Vidigal Airport",
     "countryCode": "BR",
     "iata": "MII",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Marilia"
  }, {
     "name": "Mikkeli Airport",
     "countryCode": "FI",
     "iata": "MIK",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Mikkeli"
  }, {
     "name": "Merimbula Airport",
     "countryCode": "AU",
     "iata": "MIM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Merimbula"
  }, {
     "name": "Minnipa Airport",
     "countryCode": "AU",
     "iata": "MIN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Minnipa"
  }, {
     "name": "Miami Airport",
     "countryCode": "US",
     "iata": "MIO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Miami"
  }, {
     "name": "Mitspeh Ramon Airport",
     "countryCode": "IL",
     "iata": "MIP",
     "eucustoms": false,
     "countryDK": "Israel",
     "cityDK": "Mitspeh Ramon"
  }, {
     "name": "Millard Airport",
     "countryCode": "US",
     "iata": "MIQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Omaha"
  }, {
     "name": "Habib Bourguiba International Airport",
     "countryCode": "TN",
     "iata": "MIR",
     "eucustoms": false,
     "countryDK": "Tunesien",
     "cityDK": "Monastir"
  }, {
     "name": "Minter Field",
     "countryCode": "US",
     "iata": "MIT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Shafter"
  }, {
     "name": "Maiduguri International Airport",
     "countryCode": "NG",
     "iata": "MIU",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Maiduguri"
  }, {
     "name": "Millville Municipal Airport",
     "countryCode": "US",
     "iata": "MIV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Millville"
  }, {
     "name": "Marshalltown Municipal Airport",
     "countryCode": "US",
     "iata": "MIW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marshalltown"
  }, {
     "name": "Manja Airport",
     "countryCode": "MG",
     "iata": "MJA",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Manja"
  }, {
     "name": "Man Airport",
     "countryCode": "CI",
     "iata": "MJC",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Mand"
  }, {
     "name": "Mohenjo Daro Airport",
     "countryCode": "PK",
     "iata": "MJD",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Mohenjo Daro"
  }, {
     "name": "Kjaerstad Airport",
     "countryCode": "NO",
     "iata": "MJF",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Mosjøen"
  }, {
     "name": "Mitiga, Tripoli Airport",
     "countryCode": "LY",
     "iata": "MJI",
     "eucustoms": false,
     "countryDK": "Libyen",
     "cityDK": "Mitiga, Tripoli"
  }, {
     "name": "Shark Bay Airport",
     "countryCode": "AU",
     "iata": "MJK",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Monkey Mia"
  }, {
     "name": "Mouila Airport",
     "countryCode": "GA",
     "iata": "MJL",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Mouila"
  }, {
     "name": "Mbuji Mayi Airport",
     "countryCode": "CD",
     "iata": "MJM",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Mbuji Mayi"
  }, {
     "name": "Amborovy Airport",
     "countryCode": "MG",
     "iata": "MJN",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Majunga"
  }, {
     "name": "Manjimup Airport",
     "countryCode": "AU",
     "iata": "MJP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Manjimup"
  }, {
     "name": "Jackson Airport",
     "countryCode": "US",
     "iata": "MJQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jackson"
  }, {
     "name": "Mytilene International Airport",
     "countryCode": "GR",
     "iata": "MJT",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Mytilene"
  }, {
     "name": "Murcia-San Javier Airport",
     "countryCode": "ES",
     "iata": "MJV",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Murcia"
  }, {
     "name": "Mahenye Airfield",
     "countryCode": "ZW",
     "iata": "MJW",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Mahenye"
  }, {
     "name": "Robert J. Miller Air Park",
     "countryCode": "US",
     "iata": "MJX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Toms River"
  }, {
     "name": "Mirnyj Airport",
     "countryCode": "RU",
     "iata": "MJZ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Mirnyj"
  }, {
     "name": "Marianske Lazne Airport",
     "countryCode": "CZ",
     "iata": "MKA",
     "eucustoms": false,
     "countryDK": "Tjekkiet",
     "cityDK": "Marianske Lazne"
  }, {
     "name": "Mekambo Airport",
     "countryCode": "GA",
     "iata": "MKB",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Mekambo"
  }, {
     "name": "Charles B. Wheeler Downtown Airport",
     "countryCode": "US",
     "iata": "MKC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kansas City"
  }, {
     "name": "General Mitchell International Airport",
     "countryCode": "US",
     "iata": "MKE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Milwaukee"
  }, {
     "name": "Muskegon Airport",
     "countryCode": "US",
     "iata": "MKG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Muskegon"
  }, {
     "name": "Mokhotlong Airport",
     "countryCode": "LS",
     "iata": "MKH",
     "eucustoms": false,
     "countryDK": "Lesotho",
     "cityDK": "Mokhotlong"
  }, {
     "name": "M'boki Airport",
     "countryCode": "CF",
     "iata": "MKI",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "M'Boki"
  }, {
     "name": "Makoua Airport",
     "countryCode": "CG",
     "iata": "MKJ",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Makoua"
  }, {
     "name": "Molokai Airport",
     "countryCode": "US",
     "iata": "MKK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Hoolehua"
  }, {
     "name": "Mckellar-Sipes Regional Airport",
     "countryCode": "US",
     "iata": "MKL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jackson"
  }, {
     "name": "Mukah Airport",
     "countryCode": "MY",
     "iata": "MKM",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Mukah"
  }, {
     "name": "Davis Field",
     "countryCode": "US",
     "iata": "MKO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Muskogee"
  }, {
     "name": "Makemo Airport",
     "countryCode": "PF",
     "iata": "MKP",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Makemo"
  }, {
     "name": "Mopah Airport",
     "countryCode": "ID",
     "iata": "MKQ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Merauke"
  }, {
     "name": "Meekatharra Airport",
     "countryCode": "AU",
     "iata": "MKR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Meekatharra"
  }, {
     "name": "Mekane Selam Airport",
     "countryCode": "ET",
     "iata": "MKS",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Mekane Selam"
  }, {
     "name": "Mankato Municipal Airport",
     "countryCode": "US",
     "iata": "MKT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mankato"
  }, {
     "name": "Makokou Airport",
     "countryCode": "GA",
     "iata": "MKU",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Makokou"
  }, {
     "name": "Rendani Airport",
     "countryCode": "ID",
     "iata": "MKW",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Manokwari"
  }, {
     "name": "Mackay Airport",
     "countryCode": "AU",
     "iata": "MKY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mackay"
  }, {
     "name": "Malacca International Airport",
     "countryCode": "MY",
     "iata": "MKZ",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Malacca"
  }, {
     "name": "Malta International Airport",
     "countryCode": "MT",
     "iata": "MLA",
     "eucustoms": true,
     "countryDK": "Malta",
     "cityDK": "Malta"
  }, {
     "name": "Orlando Melbourne International Airport",
     "countryCode": "US",
     "iata": "MLB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Melbourne"
  }, {
     "name": "McAlester Regional Airport",
     "countryCode": "US",
     "iata": "MLC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "McAlester"
  }, {
     "name": "Malad City Airport",
     "countryCode": "US",
     "iata": "MLD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Malad City"
  }, {
     "name": "Velana International Airport",
     "countryCode": "MV",
     "iata": "MLE",
     "eucustoms": false,
     "countryDK": "Maldiverne",
     "cityDK": "Han"
  }, {
     "name": "Milford Airport",
     "countryCode": "US",
     "iata": "MLF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Milford"
  }, {
     "name": "Abdul Rachman Saleh Airport",
     "countryCode": "ID",
     "iata": "MLG",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Malang"
  }, {
     "name": "EuroAirport Basel-Mulhouse-Freiburg",
     "countryCode": "CH",
     "iata": "MLH",
     "eucustoms": false,
     "countryDK": "Schweiz",
     "cityDK": "Mulhouse, Frankrig / Basel"
  }, {
     "name": "Quad City International Airport",
     "countryCode": "US",
     "iata": "MLI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Moline"
  }, {
     "name": "Baldwin County Airport",
     "countryCode": "US",
     "iata": "MLJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Milledgeville"
  }, {
     "name": "Malta",
     "countryCode": "US",
     "iata": "MLK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Malta"
  }, {
     "name": "Marshall Don Hunter Sr. Airport",
     "countryCode": "US",
     "iata": "MLL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marshall"
  }, {
     "name": "Morelia Airport",
     "countryCode": "MX",
     "iata": "MLM",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Morelia"
  }, {
     "name": "Melilla Airport",
     "countryCode": "ES",
     "iata": "MLN",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Melilla"
  }, {
     "name": "Milos Airport",
     "countryCode": "GR",
     "iata": "MLO",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Milos"
  }, {
     "name": "Malabang Airport",
     "countryCode": "PH",
     "iata": "MLP",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Malabang"
  }, {
     "name": "Millicent Airport",
     "countryCode": "AU",
     "iata": "MLR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Millicent"
  }, {
     "name": "Frank Wiley Field",
     "countryCode": "US",
     "iata": "MLS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Miles City"
  }, {
     "name": "Millinocket Municipal Airport",
     "countryCode": "US",
     "iata": "MLT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Millinocket"
  }, {
     "name": "Monroe Regional Airport",
     "countryCode": "US",
     "iata": "MLU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Monroe"
  }, {
     "name": "Spriggs Payne Airport",
     "countryCode": "LR",
     "iata": "MLW",
     "eucustoms": false,
     "countryDK": "Liberia",
     "cityDK": "Monrovia"
  }, {
     "name": "Malatya Airport",
     "countryCode": "TR",
     "iata": "MLX",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Malatya"
  }, {
     "name": "Manley Hot Springs Airport",
     "countryCode": "US",
     "iata": "MLY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Manley Hot Springs"
  }, {
     "name": "Melo Airport",
     "countryCode": "UY",
     "iata": "MLZ",
     "eucustoms": false,
     "countryDK": "Uruguay",
     "cityDK": "Melo"
  }, {
     "name": "Memanbetsu Airport",
     "countryCode": "JP",
     "iata": "MMB",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Memanbetsu"
  }, {
     "name": "Ciudad Mante Airport",
     "countryCode": "MX",
     "iata": "MMC",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Ciudad Mante"
  }, {
     "name": "Celaya",
     "countryCode": "MX",
     "iata": "CYW",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Celaya"
  }, {
     "name": "Maridor Airport",
     "countryCode": "JP",
     "iata": "MMD",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Minami Daito"
  }, {
     "name": "Durham Tees Valley Airport",
     "countryCode": "GB",
     "iata": "MME",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Durham Tees Valley"
  }, {
     "name": "Mamfe Airport",
     "countryCode": "CM",
     "iata": "MMF",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Mamfe"
  }, {
     "name": "Mount Magnet Airport",
     "countryCode": "AU",
     "iata": "MMG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mount Magnet"
  }, {
     "name": "Mammoth Lakes Airport",
     "countryCode": "US",
     "iata": "MMH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mammoth Lakes"
  }, {
     "name": "McMinn County Airport",
     "countryCode": "US",
     "iata": "MMI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Athen"
  }, {
     "name": "Matsumoto Airport",
     "countryCode": "JP",
     "iata": "MMJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Matsumoto"
  }, {
     "name": "Murmansk Airport",
     "countryCode": "RU",
     "iata": "MMK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Murmansk"
  }, {
     "name": "Southwest Minnesota Regional Airport",
     "countryCode": "US",
     "iata": "MML",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marshall"
  }, {
     "name": "Middlemount Airport",
     "countryCode": "AU",
     "iata": "MMM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Middlemount"
  }, {
     "name": "Vila Do Maio Airport",
     "countryCode": "CV",
     "iata": "MMO",
     "eucustoms": false,
     "countryDK": "Kap Verde",
     "cityDK": "Maio"
  }, {
     "name": "San Bernardo Airport",
     "countryCode": "CO",
     "iata": "MMP",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Mompos"
  }, {
     "name": "Mbala Airport",
     "countryCode": "ZM",
     "iata": "MMQ",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Mbala"
  }, {
     "name": "Selfs Airport",
     "countryCode": "US",
     "iata": "MMS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marks"
  }, {
     "name": "McEntire Joint National Guard Base",
     "countryCode": "US",
     "iata": "MMT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbia"
  }, {
     "name": "Morristown Municipal Airport",
     "countryCode": "US",
     "iata": "MMU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Morristown"
  }, {
     "name": "Malmo Airport",
     "countryCode": "SE",
     "iata": "MMX",
     "eucustoms": true,
     "countryDK": "Sverige",
     "cityDK": "Malmø"
  }, {
     "name": "Miyako Airport",
     "countryCode": "JP",
     "iata": "MMY",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Miyako"
  }, {
     "name": "Maimana Airport",
     "countryCode": "AF",
     "iata": "MMZ",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Maimana"
  }, {
     "name": "Moanda Airport",
     "countryCode": "CD",
     "iata": "MNB",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Moanda"
  }, {
     "name": "Nacala Airport",
     "countryCode": "MZ",
     "iata": "MNC",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Nacala"
  }, {
     "name": "Mana Island Airstrip",
     "countryCode": "FJ",
     "iata": "MNF",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Mana Island"
  }, {
     "name": "Maningrida Airport",
     "countryCode": "AU",
     "iata": "MNG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Maningrida"
  }, {
     "name": "Rustaq Airport",
     "countryCode": "OM",
     "iata": "MNH",
     "eucustoms": false,
     "countryDK": "Oman",
     "cityDK": "Al Masnaah"
  }, {
     "name": "Mananjary Airport",
     "countryCode": "MG",
     "iata": "MNJ",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Mananjary"
  }, {
     "name": "Ninoy Aquino International Airport",
     "countryCode": "PH",
     "iata": "MNL",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Manila"
  }, {
     "name": "Menominee-Marinette Twin County Airport",
     "countryCode": "US",
     "iata": "MNM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Menominee"
  }, {
     "name": "Marion Municipal Airport",
     "countryCode": "US",
     "iata": "MNN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marion"
  }, {
     "name": "Manono Airport",
     "countryCode": "CD",
     "iata": "MNO",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Manono"
  }, {
     "name": "Monto Airport",
     "countryCode": "AU",
     "iata": "MNQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Monto"
  }, {
     "name": "Mongu Airport",
     "countryCode": "ZM",
     "iata": "MNR",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Mongu"
  }, {
     "name": "Mansa Airport",
     "countryCode": "ZM",
     "iata": "MNS",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Mansa"
  }, {
     "name": "Mawlamyine Airport",
     "countryCode": "MM",
     "iata": "MNU",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Mawlamyine"
  }, {
     "name": "Manicore Airport",
     "countryCode": "BR",
     "iata": "MNX",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Manicore"
  }, {
     "name": "Mono Airport",
     "countryCode": "SB",
     "iata": "MNY",
     "eucustoms": false,
     "countryDK": "Salomonøerne",
     "cityDK": "Mono"
  }, {
     "name": "Manassas Regional Airport",
     "countryCode": "US",
     "iata": "MNZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Manassas"
  }, {
     "name": "Orestes Acosta Airport",
     "countryCode": "CU",
     "iata": "MOA",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Moa"
  }, {
     "name": "Mobile Regional Airport",
     "countryCode": "US",
     "iata": "MOB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mobil"
  }, {
     "name": "Montes Claros Airport",
     "countryCode": "BR",
     "iata": "MOC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Montes Claros"
  }, {
     "name": "Modesto Municipal Airport",
     "countryCode": "US",
     "iata": "MOD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Modesto"
  }, {
     "name": "Momeik Airport",
     "countryCode": "MM",
     "iata": "MOE",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Momeik"
  }, {
     "name": "Wai Oti Airport",
     "countryCode": "ID",
     "iata": "MOF",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Maumere"
  }, {
     "name": "Mong Hsat Airport",
     "countryCode": "MM",
     "iata": "MOG",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Mong Hsat"
  }, {
     "name": "Molde Airport, Aro",
     "countryCode": "NO",
     "iata": "MOL",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Molde"
  }, {
     "name": "Moudjeria Airport",
     "countryCode": "MR",
     "iata": "MOM",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Moudjeria"
  }, {
     "name": "Mount Cook Airport",
     "countryCode": "NZ",
     "iata": "MON",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Mount Cook"
  }, {
     "name": "Moomba Airport",
     "countryCode": "AU",
     "iata": "MOO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Moomba"
  }, {
     "name": "Mount Pleasant Municipal Airport",
     "countryCode": "US",
     "iata": "MOP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mount Pleasant"
  }, {
     "name": "Morondava Airport",
     "countryCode": "MG",
     "iata": "MOQ",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Morondava"
  }, {
     "name": "Moore-Murrell Airport",
     "countryCode": "US",
     "iata": "MOR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Morristown"
  }, {
     "name": "Minot International Airport",
     "countryCode": "US",
     "iata": "MOT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Minot"
  }, {
     "name": "Moranbah Airport",
     "countryCode": "AU",
     "iata": "MOV",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Moranbah"
  }, {
     "name": "Morris Municipal Airport",
     "countryCode": "US",
     "iata": "MOX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Morris"
  }, {
     "name": "Temae Airport",
     "countryCode": "PF",
     "iata": "MOZ",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Moorea"
  }, {
     "name": "Mpacha Airport",
     "countryCode": "NA",
     "iata": "MPA",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Mpacha"
  }, {
     "name": "Godofredo P. Ramos Airport",
     "countryCode": "PH",
     "iata": "MPH",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Caticlan"
  }, {
     "name": "Petit Jean Park Airport",
     "countryCode": "US",
     "iata": "MPJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Morrilton"
  }, {
     "name": "Mokpo Airport",
     "countryCode": "KR",
     "iata": "MPK",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Mokpo"
  }, {
     "name": "Montpellier Mediterranee Airport",
     "countryCode": "FR",
     "iata": "MPL",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Montpellier"
  }, {
     "name": "Maputo International Airport",
     "countryCode": "MZ",
     "iata": "MPM",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Maputo"
  }, {
     "name": "Skopje International Airport",
     "countryCode": "MK",
     "iata": "SKP",
     "eucustoms": true,
     "countryDK": "Makedonien",
     "cityDK": "Skopje"
  }, {
     "name": "Mount Pocono Airport",
     "countryCode": "US",
     "iata": "MPO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mount Pocono"
  }, {
     "name": "McPherson Airport",
     "countryCode": "US",
     "iata": "MPR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "McPherson"
  }, {
     "name": "Mount Pleasant Airport",
     "countryCode": "US",
     "iata": "MPS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mount Pleasant"
  }, {
     "name": "Edward F. Knapp State Airport",
     "countryCode": "US",
     "iata": "MPV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Berlin"
  }, {
     "name": "Mount Pleasant Municipal Airport",
     "countryCode": "US",
     "iata": "MPZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mount Pleasant"
  }, {
     "name": "Macomb Municipal Airport",
     "countryCode": "US",
     "iata": "MQB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Macomb"
  }, {
     "name": "Miquelon Airport",
     "countryCode": "PM",
     "iata": "MQC",
     "eucustoms": false,
     "countryDK": "Saint-Pierre og Miquelon",
     "cityDK": "Miquelon"
  }, {
     "name": "Maquinchao Airport",
     "countryCode": "AR",
     "iata": "MQD",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Maquinchao"
  }, {
     "name": "Magnitogorsk Airport",
     "countryCode": "RU",
     "iata": "MQF",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Magnitogorsk"
  }, {
     "name": "Moma Airport",
     "countryCode": "RU",
     "iata": "MQJ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Khonu"
  }, {
     "name": "San Matias Airport",
     "countryCode": "BO",
     "iata": "MQK",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "San Matias"
  }, {
     "name": "Mildura Airport",
     "countryCode": "AU",
     "iata": "MQL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mildura"
  }, {
     "name": "Mardin Airport",
     "countryCode": "TR",
     "iata": "MQM",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Mardin"
  }, {
     "name": "Mo i Rana Airport",
     "countryCode": "NO",
     "iata": "MQN",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Mo i Rana"
  }, {
     "name": "Moundou Airport",
     "countryCode": "TD",
     "iata": "MQQ",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Moundou"
  }, {
     "name": "Sawyer International Airport",
     "countryCode": "US",
     "iata": "MQT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marquette"
  }, {
     "name": "Mariquita Airport",
     "countryCode": "CO",
     "iata": "MQU",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Mariquita"
  }, {
     "name": "Telfair-Wheeler Airport",
     "countryCode": "US",
     "iata": "MQW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "McRae"
  }, {
     "name": "Alula Aba Nega Airport",
     "countryCode": "ET",
     "iata": "MQX",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Makale"
  }, {
     "name": "Smyrna Airport",
     "countryCode": "US",
     "iata": "MQY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Smyrna"
  }, {
     "name": "Margaret River Airport",
     "countryCode": "AU",
     "iata": "MQZ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Margaret River"
  }, {
     "name": "Eastern West Virginia Regional Airport",
     "countryCode": "US",
     "iata": "MRB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Martinsburg"
  }, {
     "name": "Maury County Airport",
     "countryCode": "US",
     "iata": "MRC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbia"
  }, {
     "name": "Alberto Carnevalli Airport",
     "countryCode": "VE",
     "iata": "MRD",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Merida"
  }, {
     "name": "Mara Serena Airport",
     "countryCode": "KE",
     "iata": "MRE",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Maasai Mara"
  }, {
     "name": "Marfa Municipal Airport",
     "countryCode": "US",
     "iata": "MRF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marfa"
  }, {
     "name": "Mareeba Airport",
     "countryCode": "AU",
     "iata": "MRG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mareeba"
  }, {
     "name": "Merrill Field",
     "countryCode": "US",
     "iata": "MRI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Anchorage"
  }, {
     "name": "Marco Island Airport",
     "countryCode": "US",
     "iata": "MRK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marco Island"
  }, {
     "name": "Lenoir Airport",
     "countryCode": "US",
     "iata": "MRN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Morganton"
  }, {
     "name": "Masterton Airport",
     "countryCode": "NZ",
     "iata": "MRO",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Masterton"
  }, {
     "name": "Marla Airport",
     "countryCode": "AU",
     "iata": "MRP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Marla"
  }, {
     "name": "Marinduque Airport",
     "countryCode": "PH",
     "iata": "MRQ",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Marinduque"
  }, {
     "name": "Macara Airport",
     "countryCode": "EC",
     "iata": "MRR",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Macara"
  }, {
     "name": "Marseille Provence Airport",
     "countryCode": "FR",
     "iata": "MRS",
     "eucustoms": true,
     "countryDK": "Frankrig",
     "cityDK": "Marseille"
  }, {
     "name": "Sir Seewoosagur Ramgoolam International Airport",
     "countryCode": "MU",
     "iata": "MRU",
     "eucustoms": false,
     "countryDK": "Mauritius",
     "cityDK": "Mauritius"
  }, {
     "name": "Mineralnye Vody Airport",
     "countryCode": "RU",
     "iata": "MRV",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Mineralnye Vody"
  }, {
     "name": "Maribo Airport",
     "countryCode": "DK",
     "iata": "MRW",
     "eucustoms": false,
     "countryDK": "Danmark",
     "cityDK": "Maribo"
  }, {
     "name": "Mahshahr Airport",
     "countryCode": "IR",
     "iata": "MRX",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Bandar Mahshahr"
  }, {
     "name": "Monterey Regional Airport",
     "countryCode": "US",
     "iata": "MRY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Monterey"
  }, {
     "name": "Moree Airport",
     "countryCode": "AU",
     "iata": "MRZ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Moree"
  }, {
     "name": "Muskrat Dam Airport",
     "countryCode": "CA",
     "iata": "MSA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Muskrat Dam"
  }, {
     "name": "Falcon Field",
     "countryCode": "US",
     "iata": "MSC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mesa"
  }, {
     "name": "Manston Airport",
     "countryCode": "GB",
     "iata": "MSE",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Manston"
  }, {
     "name": "Masirah Air Force Base",
     "countryCode": "OM",
     "iata": "MSH",
     "eucustoms": false,
     "countryDK": "Oman",
     "cityDK": "Masirah"
  }, {
     "name": "Misawa Airport",
     "countryCode": "JP",
     "iata": "MSJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Misawa"
  }, {
     "name": "Northwest Alabama Regional Airport",
     "countryCode": "US",
     "iata": "MSL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Muskelskader"
  }, {
     "name": "Masi Manimba Airport",
     "countryCode": "CD",
     "iata": "MSM",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Masi Manimba"
  }, {
     "name": "Dane County Regional Airport",
     "countryCode": "US",
     "iata": "MSN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Madison"
  }, {
     "name": "Missoula International Airport",
     "countryCode": "US",
     "iata": "MSO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Missoula"
  }, {
     "name": "Minneapolis-St. Paul International Airport",
     "countryCode": "US",
     "iata": "MSP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Minneapolis"
  }, {
     "name": "Minsk National Airport",
     "countryCode": "BY",
     "iata": "MSQ",
     "eucustoms": false,
     "countryDK": "Hviderusland",
     "cityDK": "Minsk"
  }, {
     "name": "Mus Airport",
     "countryCode": "TR",
     "iata": "MSR",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Mus"
  }, {
     "name": "Richards Field",
     "countryCode": "US",
     "iata": "MSS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Massena"
  }, {
     "name": "Ilopango Airport",
     "countryCode": "SV",
     "iata": "ILS",
     "eucustoms": false,
     "countryDK": "El Salvador",
     "cityDK": "San Salvador"
  }, {
     "name": "Maastricht Aachen Airport",
     "countryCode": "NL",
     "iata": "MST",
     "eucustoms": false,
     "countryDK": "Holland",
     "cityDK": "Maastricht"
  }, {
     "name": "Moshoeshoe International Airport",
     "countryCode": "LS",
     "iata": "MSU",
     "eucustoms": false,
     "countryDK": "Lesotho",
     "cityDK": "Maseru"
  }, {
     "name": "Sullivan County International Airport",
     "countryCode": "US",
     "iata": "MSV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Monticello"
  }, {
     "name": "Massawa Airport",
     "countryCode": "ER",
     "iata": "MSW",
     "eucustoms": false,
     "countryDK": "Eritrea",
     "cityDK": "Massawa"
  }, {
     "name": "Mossendjo Airport",
     "countryCode": "CG",
     "iata": "MSX",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Mossendjo"
  }, {
     "name": "Louis Armstrong New Orleans International Airport",
     "countryCode": "US",
     "iata": "MSY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "New Orleans"
  }, {
     "name": "Yuri Gagarin Airport",
     "countryCode": "AO",
     "iata": "MSZ",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Namibe"
  }, {
     "name": "Matamata Glider Airport",
     "countryCode": "NZ",
     "iata": "MTA",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Matamata"
  }, {
     "name": "Montelibano Airport",
     "countryCode": "CO",
     "iata": "MTB",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Montelibano"
  }, {
     "name": "Selfridge Air National Guard Base",
     "countryCode": "US",
     "iata": "MTC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mount Clemens"
  }, {
     "name": "Monte Alegre Airport",
     "countryCode": "BR",
     "iata": "MTE",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Monte Alegre"
  }, {
     "name": "Mizan Teferi Airport",
     "countryCode": "ET",
     "iata": "MTF",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Mizan Teferi"
  }, {
     "name": "The Florida Keys Marathon Airport",
     "countryCode": "US",
     "iata": "MTH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marathon"
  }, {
     "name": "Montrose Regional Airport",
     "countryCode": "US",
     "iata": "MTJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Montrose"
  }, {
     "name": "Maitland Airport",
     "countryCode": "AU",
     "iata": "MTL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Maitland"
  }, {
     "name": "Martin State Airport",
     "countryCode": "US",
     "iata": "MTN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Baltimore"
  }, {
     "name": "Coles County Memorial Airport",
     "countryCode": "US",
     "iata": "MTO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mattoon"
  }, {
     "name": "Montauk Airport",
     "countryCode": "US",
     "iata": "MTP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Montauk Point"
  }, {
     "name": "Mitchell Airport",
     "countryCode": "AU",
     "iata": "MTQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mitchell"
  }, {
     "name": "Los Garzones Airport",
     "countryCode": "CO",
     "iata": "MTR",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Monteria"
  }, {
     "name": "Matsapha International Airport",
     "countryCode": "SZ",
     "iata": "MTS",
     "eucustoms": false,
     "countryDK": "Swaziland",
     "cityDK": "Manzini"
  }, {
     "name": "Minatitlan Airport",
     "countryCode": "MX",
     "iata": "MTT",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Minatitlan"
  }, {
     "name": "Mota Lava Airport",
     "countryCode": "VU",
     "iata": "MTV",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Mota Lava"
  }, {
     "name": "Manitowoc Municipal Airport",
     "countryCode": "US",
     "iata": "MTW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Manitowoc"
  }, {
     "name": "Gen Mariano Escobedo Airport",
     "countryCode": "MX",
     "iata": "MTY",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Monterrey"
  }, {
     "name": "Munda Airport",
     "countryCode": "SB",
     "iata": "MUA",
     "eucustoms": false,
     "countryDK": "Salomonøerne",
     "cityDK": "Munda"
  }, {
     "name": "Maun Airport",
     "countryCode": "BW",
     "iata": "MUB",
     "eucustoms": false,
     "countryDK": "Botswana",
     "cityDK": "Maun"
  }, {
     "name": "Franz Josef Strauss Airport",
     "countryCode": "DE",
     "iata": "MUC",
     "eucustoms": true,
     "countryDK": "Tyskland",
     "cityDK": "München"
  }, {
     "name": "Kamuela Airport",
     "countryCode": "US",
     "iata": "MUE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kamuela"
  }, {
     "name": "Mersa Matruh Airport",
     "countryCode": "EG",
     "iata": "MUH",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Mersa Matruh"
  }, {
     "name": "Muir Aaf",
     "countryCode": "US",
     "iata": "MUI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ft Indiantown Gap"
  }, {
     "name": "Mauke Island Airport",
     "countryCode": "CK",
     "iata": "MUK",
     "eucustoms": false,
     "countryDK": "Cookøerne",
     "cityDK": "Mauke Island"
  }, {
     "name": "Spence Airport",
     "countryCode": "US",
     "iata": "MUL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Moultrie"
  }, {
     "name": "Jose Tadeo Monagas International Airport",
     "countryCode": "VE",
     "iata": "MUN",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Maturin"
  }, {
     "name": "Mountain Home Air Force Base",
     "countryCode": "US",
     "iata": "MUO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mountain Home"
  }, {
     "name": "Marudi Airport",
     "countryCode": "MY",
     "iata": "MUR",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Marudi"
  }, {
     "name": "Muscatine Airport",
     "countryCode": "US",
     "iata": "MUT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Muscatine"
  }, {
     "name": "Mount Union Airport",
     "countryCode": "US",
     "iata": "MUU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mount Union"
  }, {
     "name": "Ghriss Airport",
     "countryCode": "DZ",
     "iata": "MUW",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Ghriss"
  }, {
     "name": "Multan Airport",
     "countryCode": "PK",
     "iata": "MUX",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Multan"
  }, {
     "name": "Mouyondzi Airport",
     "countryCode": "CG",
     "iata": "MUY",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Mouyondzi"
  }, {
     "name": "Musoma Airport",
     "countryCode": "TZ",
     "iata": "MUZ",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Musoma"
  }, {
     "name": "M'Vengue El Hadj Omar Bongo Ondimba Intl Airport",
     "countryCode": "GA",
     "iata": "MVB",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Franceville"
  }, {
     "name": "Monroe County Airport",
     "countryCode": "US",
     "iata": "MVC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Monroeville"
  }, {
     "name": "Carrasco International Airport",
     "countryCode": "UY",
     "iata": "MVD",
     "eucustoms": false,
     "countryDK": "Uruguay",
     "cityDK": "Montevideo"
  }, {
     "name": "Montevideo Municipal Airport",
     "countryCode": "US",
     "iata": "MVE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Montevideo"
  }, {
     "name": "Dix-Sept Rosado Airport",
     "countryCode": "BR",
     "iata": "MVF",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Mossoro"
  }, {
     "name": "Morrisville-Stowe Airport",
     "countryCode": "US",
     "iata": "MVL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Stowe"
  }, {
     "name": "Mount Vernon Airport",
     "countryCode": "US",
     "iata": "MVN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mount Vernon"
  }, {
     "name": "Mongo Airport",
     "countryCode": "TD",
     "iata": "MVO",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Mongo"
  }, {
     "name": "Mitu Airport",
     "countryCode": "CO",
     "iata": "MVP",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Mitu"
  }, {
     "name": "Mogilev Airport",
     "countryCode": "BY",
     "iata": "MVQ",
     "eucustoms": false,
     "countryDK": "Hviderusland",
     "cityDK": "Mogilev"
  }, {
     "name": "Salak Airport",
     "countryCode": "CM",
     "iata": "MVR",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Maroua"
  }, {
     "name": "Mataiva Airport",
     "countryCode": "PF",
     "iata": "MVT",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Mataiva"
  }, {
     "name": "Megeve Airport",
     "countryCode": "FR",
     "iata": "MVV",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Megève"
  }, {
     "name": "Skagit Regional Airport",
     "countryCode": "US",
     "iata": "MVW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mount Vernon"
  }, {
     "name": "Minvoul Airport",
     "countryCode": "GA",
     "iata": "MVX",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Minvoul"
  }, {
     "name": "Martha's Vineyard Airport",
     "countryCode": "US",
     "iata": "MVY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marthas Vineyard"
  }, {
     "name": "Masvingo Airport",
     "countryCode": "ZW",
     "iata": "MVZ",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Masvingo"
  }, {
     "name": "Williamson County Airport",
     "countryCode": "US",
     "iata": "MWA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marion"
  }, {
     "name": "Morawa Airport",
     "countryCode": "AU",
     "iata": "MWB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Morawa"
  }, {
     "name": "Lawrence J. Timmerman Airport",
     "countryCode": "US",
     "iata": "MWC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Milwaukee"
  }, {
     "name": "Merowe Airport",
     "countryCode": "SD",
     "iata": "MWE",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Merowe"
  }, {
     "name": "Maewo Airport",
     "countryCode": "VU",
     "iata": "MWF",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Maewo"
  }, {
     "name": "Grant County International Airport",
     "countryCode": "US",
     "iata": "MWH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Moses Lake"
  }, {
     "name": "Tarempa Airport",
     "countryCode": "ID",
     "iata": "MWK",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Matak"
  }, {
     "name": "Mineral Wells Airport",
     "countryCode": "US",
     "iata": "MWL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mineralbrønde"
  }, {
     "name": "Windom Municipal Airport",
     "countryCode": "US",
     "iata": "MWM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Windom"
  }, {
     "name": "Mwadui Airport",
     "countryCode": "TZ",
     "iata": "MWN",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Mwadui"
  }, {
     "name": "Middletown Regional Airport",
     "countryCode": "US",
     "iata": "MWO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Middletown"
  }, {
     "name": "Magwe Airport",
     "countryCode": "MM",
     "iata": "MWQ",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Magwe"
  }, {
     "name": "Muan International Airport",
     "countryCode": "KR",
     "iata": "MWX",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Gwangju"
  }, {
     "name": "Mwanza Airport",
     "countryCode": "TZ",
     "iata": "MWZ",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Mwanza"
  }, {
     "name": "Manila Municipal Airport",
     "countryCode": "US",
     "iata": "MXA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Manila"
  }, {
     "name": "Maxton Airport",
     "countryCode": "US",
     "iata": "MXE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Maxton"
  }, {
     "name": "Maxwell Air Force Base",
     "countryCode": "US",
     "iata": "MXF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Montgomery"
  }, {
     "name": "Mati Airport",
     "countryCode": "PH",
     "iata": "MXI",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Mati"
  }, {
     "name": "Minna Airport",
     "countryCode": "NG",
     "iata": "MXJ",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Minna"
  }, {
     "name": "Mexicali Airport",
     "countryCode": "MX",
     "iata": "MXL",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Mexicali"
  }, {
     "name": "Morombe Airport",
     "countryCode": "MG",
     "iata": "MXM",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Morombe"
  }, {
     "name": "Morlaix Airport",
     "countryCode": "FR",
     "iata": "MXN",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Morlaix"
  }, {
     "name": "Monticello Municipal Airport",
     "countryCode": "US",
     "iata": "MXO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Monticello"
  }, {
     "name": "Milano Malpensa Airport",
     "countryCode": "IT",
     "iata": "MXP",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Milano"
  }, {
     "name": "Maota Savall Island Airport",
     "countryCode": "WS",
     "iata": "MXS",
     "eucustoms": false,
     "countryDK": "Samoa",
     "cityDK": "Maota Savall Island"
  }, {
     "name": "Maintirano Airport",
     "countryCode": "MG",
     "iata": "MXT",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Maintirano"
  }, {
     "name": "Mullewa Airport",
     "countryCode": "AU",
     "iata": "MXU",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mullewa"
  }, {
     "name": "Moron Airport",
     "countryCode": "MN",
     "iata": "MXV",
     "eucustoms": false,
     "countryDK": "Mongoliet",
     "cityDK": "Fjols"
  }, {
     "name": "Mora Airport",
     "countryCode": "SE",
     "iata": "MXX",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Mora"
  }, {
     "name": "Mei Xian Airport",
     "countryCode": "CN",
     "iata": "MXZ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Mei Xian"
  }, {
     "name": "Moruya Airport",
     "countryCode": "AU",
     "iata": "MYA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Moruya"
  }, {
     "name": "Mayoumba Airport",
     "countryCode": "GA",
     "iata": "MYB",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Mayoumba"
  }, {
     "name": "Malindi Airport",
     "countryCode": "KE",
     "iata": "MYD",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Malindi"
  }, {
     "name": "Miyake Jima Airport",
     "countryCode": "JP",
     "iata": "MYE",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Miyake Jima"
  }, {
     "name": "Montgomery Field",
     "countryCode": "US",
     "iata": "MYF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Diego"
  }, {
     "name": "Mayaguana Airport",
     "countryCode": "BS",
     "iata": "MYG",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Mayaguana"
  }, {
     "name": "Matsuyama Airport",
     "countryCode": "JP",
     "iata": "MYJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Matsuyama"
  }, {
     "name": "Mc Call Airport",
     "countryCode": "US",
     "iata": "MYL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mc Call"
  }, {
     "name": "Mareb Airport",
     "countryCode": "YE",
     "iata": "MYN",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Mareb"
  }, {
     "name": "Mary Airport",
     "countryCode": "TM",
     "iata": "MYP",
     "eucustoms": false,
     "countryDK": "Turkmenistan",
     "cityDK": "Mary"
  }, {
     "name": "Mysore Airport",
     "countryCode": "IN",
     "iata": "MYQ",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Mysore"
  }, {
     "name": "Myrtle Beach International Airport",
     "countryCode": "US",
     "iata": "MYR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Myrtle Beach"
  }, {
     "name": "Myitkyina Airport",
     "countryCode": "MM",
     "iata": "MYT",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Myitkyina"
  }, {
     "name": "Ellis Field",
     "countryCode": "US",
     "iata": "MYU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mekoryuk"
  }, {
     "name": "Yuba County Airport",
     "countryCode": "US",
     "iata": "MYV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marysville"
  }, {
     "name": "Mtwara Airport",
     "countryCode": "TZ",
     "iata": "MYW",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Mtwara"
  }, {
     "name": "Miri Airport",
     "countryCode": "MY",
     "iata": "MYY",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Miri"
  }, {
     "name": "Monkey Bay Airport",
     "countryCode": "MW",
     "iata": "MYZ",
     "eucustoms": false,
     "countryDK": "Malawi",
     "cityDK": "Monkey Bay"
  }, {
     "name": "Manuel Prado Airport",
     "countryCode": "PE",
     "iata": "MZA",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Mazamari"
  }, {
     "name": "Mocimboa da Praia Airport",
     "countryCode": "MZ",
     "iata": "MZB",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Mocimboa da Praia"
  }, {
     "name": "Mitzic Airport",
     "countryCode": "GA",
     "iata": "MZC",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Mitzic"
  }, {
     "name": "Penghu Airport",
     "countryCode": "TW",
     "iata": "MZG",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Magong"
  }, {
     "name": "Merzifon Airport",
     "countryCode": "TR",
     "iata": "MZH",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Merzifon"
  }, {
     "name": "Ambodedjo Airport",
     "countryCode": "ML",
     "iata": "MZI",
     "eucustoms": false,
     "countryDK": "Mali",
     "cityDK": "Mopti"
  }, {
     "name": "Pinal Airpark",
     "countryCode": "US",
     "iata": "MZJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marana"
  }, {
     "name": "La Nubia Airport",
     "countryCode": "CO",
     "iata": "MZL",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Manizales"
  }, {
     "name": "Frescaty Airport",
     "countryCode": "FR",
     "iata": "MZM",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Metz"
  }, {
     "name": "Sierra Maestra Airport",
     "countryCode": "CU",
     "iata": "MZO",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Manzanillo"
  }, {
     "name": "Motueka Airport",
     "countryCode": "NZ",
     "iata": "MZP",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Motueka"
  }, {
     "name": "Mkuze Airport",
     "countryCode": "ZA",
     "iata": "MZQ",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Mkuze"
  }, {
     "name": "Mazar-I-Sharif Airport",
     "countryCode": "AF",
     "iata": "MZR",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Mazar-I-Sharif"
  }, {
     "name": "Mazatlan International Airport",
     "countryCode": "MX",
     "iata": "MZT",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Mazatlan"
  }, {
     "name": "Muzaffarpur Airport",
     "countryCode": "IN",
     "iata": "MZU",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Muzaffarpur"
  }, {
     "name": "Mulu Airport",
     "countryCode": "MY",
     "iata": "MZV",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Mulu"
  }, {
     "name": "Mechria Airport",
     "countryCode": "DZ",
     "iata": "MZW",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Mechria"
  }, {
     "name": "Mena Airport",
     "countryCode": "ET",
     "iata": "MZX",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Mena"
  }, {
     "name": "Marion Airport",
     "countryCode": "US",
     "iata": "MZZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Marion"
  }, {
     "name": "Narrabri Airport",
     "countryCode": "AU",
     "iata": "NAA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Narrabri"
  }, {
     "name": "Naracoorte Airport",
     "countryCode": "AU",
     "iata": "NAC",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Naracoorte"
  }, {
     "name": "Natitingou Airport",
     "countryCode": "BJ",
     "iata": "NAE",
     "eucustoms": false,
     "countryDK": "Benin",
     "cityDK": "Natitingou"
  }, {
     "name": "Dr. Babasaheb Ambedkar International Airport",
     "countryCode": "IN",
     "iata": "NAG",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Nagpur"
  }, {
     "name": "Annai Airport",
     "countryCode": "GY",
     "iata": "NAI",
     "eucustoms": false,
     "countryDK": "Guyana",
     "cityDK": "Annai"
  }, {
     "name": "Nakhon Ratchasima Airport",
     "countryCode": "TH",
     "iata": "NAK",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Nakhon Ratchasima"
  }, {
     "name": "Nalchik Airport",
     "countryCode": "RU",
     "iata": "NAL",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Nalchik"
  }, {
     "name": "Nadi International Airport",
     "countryCode": "FJ",
     "iata": "NAN",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Nadi"
  }, {
     "name": "Naples International Airport",
     "countryCode": "IT",
     "iata": "NAP",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Napoli"
  }, {
     "name": "Lynden Pindling International Airport",
     "countryCode": "BS",
     "iata": "NAS",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Nassau"
  }, {
     "name": "Sao Goncalo do Amarante-Governador Aluizio Alves Intl Airport",
     "countryCode": "BR",
     "iata": "NAT",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Natal"
  }, {
     "name": "Napuka Island Airport",
     "countryCode": "PF",
     "iata": "NAU",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Napuka Island"
  }, {
     "name": "Nevsehir Airport",
     "countryCode": "TR",
     "iata": "NAV",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Nevsehir"
  }, {
     "name": "Narathiwat Airport",
     "countryCode": "TH",
     "iata": "NAW",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Narathiwat"
  }, {
     "name": "Begishevo Airport",
     "countryCode": "RU",
     "iata": "NBC",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Naberezhnye Chelny"
  }, {
     "name": "Enfidha - Hammamet International Airport",
     "countryCode": "TN",
     "iata": "NBE",
     "eucustoms": false,
     "countryDK": "Tunesien",
     "cityDK": "Enfidha"
  }, {
     "name": "Naval Air Station/Alvin Callendar",
     "countryCode": "US",
     "iata": "NBG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "New Orleans"
  }, {
     "name": "Jomo Kenyatta International Airport",
     "countryCode": "KE",
     "iata": "NBO",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Nairobi"
  }, {
     "name": "Guantanamo Bay Naval Station",
     "countryCode": "CU",
     "iata": "NBW",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Guantanamo"
  }, {
     "name": "Nabire Airport",
     "countryCode": "ID",
     "iata": "NBX",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Nabire"
  }, {
     "name": "North Caicos Airport",
     "countryCode": "TC",
     "iata": "NCA",
     "eucustoms": false,
     "countryDK": "Turks- og Caicosøerne",
     "cityDK": "North Caicos"
  }, {
     "name": "Cote D'Azur Airport",
     "countryCode": "FR",
     "iata": "NCE",
     "eucustoms": true,
     "countryDK": "Frankrig",
     "cityDK": "Nice"
  }, {
     "name": "Nueva Casas Grandes Airport",
     "countryCode": "MX",
     "iata": "NCG",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Nueva Casas Grandes"
  }, {
     "name": "Nachingwea Airport",
     "countryCode": "TZ",
     "iata": "NCH",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Nachingwea"
  }, {
     "name": "Necocli Airport",
     "countryCode": "CO",
     "iata": "NCI",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Necocli"
  }, {
     "name": "Sunchales Aeroclub Airport",
     "countryCode": "AR",
     "iata": "NCJ",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Sunchales"
  }, {
     "name": "Newcastle International Airport",
     "countryCode": "GB",
     "iata": "NCL",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Newcastle"
  }, {
     "name": "Newcastle Airport",
     "countryCode": "ZA",
     "iata": "NCS",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Newcastle"
  }, {
     "name": "Nukus Airport",
     "countryCode": "UZ",
     "iata": "NCU",
     "eucustoms": false,
     "countryDK": "Usbekistan",
     "cityDK": "Nukus"
  }, {
     "name": "Annecy-Meythet Airport",
     "countryCode": "FR",
     "iata": "NCY",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Annecy"
  }, {
     "name": "Nouadhibou Airport",
     "countryCode": "MR",
     "iata": "NDB",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Nouadhibou"
  }, {
     "name": "Nanded Airport",
     "countryCode": "IN",
     "iata": "NDC",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Nanded"
  }, {
     "name": "Sumbe Airport",
     "countryCode": "AO",
     "iata": "NDD",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Sumbe"
  }, {
     "name": "Mandera Airport",
     "countryCode": "KE",
     "iata": "NDE",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Mandera"
  }, {
     "name": "Ndjamena Airport",
     "countryCode": "TD",
     "iata": "NDJ",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Ndjamena"
  }, {
     "name": "Ndele Airport",
     "countryCode": "CF",
     "iata": "NDL",
     "eucustoms": false,
     "countryDK": "Centralafrikanske Republik",
     "cityDK": "Ndele"
  }, {
     "name": "Mendi Airport",
     "countryCode": "ET",
     "iata": "NDM",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Mendi"
  }, {
     "name": "Nador International Airport",
     "countryCode": "MA",
     "iata": "NDR",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Nador"
  }, {
     "name": "Rundu Airport",
     "countryCode": "NA",
     "iata": "NDU",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Rundu"
  }, {
     "name": "Cuxhaven Airport",
     "countryCode": "DE",
     "iata": "NDZ",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Nordholz-Spieka"
  }, {
     "name": "Necochea Airport",
     "countryCode": "AR",
     "iata": "NEC",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Necochea"
  }, {
     "name": "Negril Airport",
     "countryCode": "JM",
     "iata": "NEG",
     "eucustoms": false,
     "countryDK": "Jamaica",
     "cityDK": "Negril"
  }, {
     "name": "Nejjo Airport",
     "countryCode": "ET",
     "iata": "NEJ",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Nejjo"
  }, {
     "name": "Nekemt Airport",
     "countryCode": "ET",
     "iata": "NEK",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Nekemt"
  }, {
     "name": "Naec Airport",
     "countryCode": "US",
     "iata": "NEL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lakehurst"
  }, {
     "name": "Sam Neua Airport",
     "countryCode": "LA",
     "iata": "NEU",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Sam Neua"
  }, {
     "name": "Norfolk Island Airport",
     "countryCode": "NF",
     "iata": "NLK",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Norfolk Island"
  }, {
     "name": "Lakefront Airport",
     "countryCode": "US",
     "iata": "NEW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "New Orleans"
  }, {
     "name": "Naval Air Station",
     "countryCode": "US",
     "iata": "NFL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fallon"
  }, {
     "name": "Mata'aho Airport",
     "countryCode": "TO",
     "iata": "NFO",
     "eucustoms": false,
     "countryDK": "Tonga",
     "cityDK": "Niuafo'ou"
  }, {
     "name": "Young Airport",
     "countryCode": "AU",
     "iata": "NGA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ung"
  }, {
     "name": "Ningbo Lishe International Airport",
     "countryCode": "CN",
     "iata": "NGB",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Ningbo"
  }, {
     "name": "Auguste George Airport",
     "countryCode": "VG",
     "iata": "NGD",
     "eucustoms": false,
     "countryDK": "De Britiske Jomfruøer",
     "cityDK": "Anegada"
  }, {
     "name": "Ngaoundere Airport",
     "countryCode": "CM",
     "iata": "NGE",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Ngaoundere"
  }, {
     "name": "Ngau Island Airport",
     "countryCode": "FJ",
     "iata": "NGI",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Ngau Island"
  }, {
     "name": "Nogliki Airport",
     "countryCode": "RU",
     "iata": "NGK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Nogliki"
  }, {
     "name": "Ngala Airfield",
     "countryCode": "ZA",
     "iata": "NGL",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Ngala"
  }, {
     "name": "Chubu Centrair International Airport",
     "countryCode": "JP",
     "iata": "NGO",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Nagoya"
  }, {
     "name": "Naval Air Station",
     "countryCode": "US",
     "iata": "NGP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jesu legeme"
  }, {
     "name": "Ngari Gunsa/Ali Kunsha Airport",
     "countryCode": "CN",
     "iata": "NGQ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Shi Quan He"
  }, {
     "name": "Nagasaki Airport",
     "countryCode": "JP",
     "iata": "NGS",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Nagasaki"
  }, {
     "name": "Naval Station Norfolk",
     "countryCode": "US",
     "iata": "NGU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Norfolk"
  }, {
     "name": "Manang Airport",
     "countryCode": "NP",
     "iata": "NGX",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Manang"
  }, {
     "name": "Nha Trang Airport",
     "countryCode": "VN",
     "iata": "NHA",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Nha Trang"
  }, {
     "name": "New Halfa Airport",
     "countryCode": "SD",
     "iata": "NHF",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Ny Halfa"
  }, {
     "name": "Naval Air Station",
     "countryCode": "US",
     "iata": "NHK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Patuxent River"
  }, {
     "name": "Northolt Airport",
     "countryCode": "GB",
     "iata": "NHT",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Northolt"
  }, {
     "name": "Nuku Hiva Airport",
     "countryCode": "PF",
     "iata": "NHV",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Nuku Hiva"
  }, {
     "name": "Brunswick Executive Airport",
     "countryCode": "US",
     "iata": "NHZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Brunswick"
  }, {
     "name": "Nimba Airport",
     "countryCode": "LR",
     "iata": "NIA",
     "eucustoms": false,
     "countryDK": "Liberia",
     "cityDK": "Nimba"
  }, {
     "name": "Nifty Airport",
     "countryCode": "AU",
     "iata": "NIF",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Nifty"
  }, {
     "name": "Niamey Airport",
     "countryCode": "NE",
     "iata": "NIM",
     "eucustoms": false,
     "countryDK": "Niger",
     "cityDK": "Niamey"
  }, {
     "name": "Nioki Airport",
     "countryCode": "CD",
     "iata": "NIO",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "nioki"
  }, {
     "name": "NAS (Towers Field)",
     "countryCode": "US",
     "iata": "NIP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jacksonville"
  }, {
     "name": "Niaqornat Heliport",
     "countryCode": "GL",
     "iata": "NIQ",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Niaqornat"
  }, {
     "name": "Niort Airport",
     "countryCode": "FR",
     "iata": "NIT",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Niort"
  }, {
     "name": "Niau Airport",
     "countryCode": "PF",
     "iata": "NIU",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Fakarava Niau"
  }, {
     "name": "Nioro Airport",
     "countryCode": "ML",
     "iata": "NIX",
     "eucustoms": false,
     "countryDK": "Mali",
     "cityDK": "Nioro"
  }, {
     "name": "Atsugi Naval Air Field",
     "countryCode": "JP",
     "iata": "NJA",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Atsugi"
  }, {
     "name": "Nizhnevartovsk Airport",
     "countryCode": "RU",
     "iata": "NJC",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Nizhnevartovsk"
  }, {
     "name": "Al-Ashraf International Airport",
     "countryCode": "IQ",
     "iata": "NJF",
     "eucustoms": false,
     "countryDK": "Irak",
     "cityDK": "Al-Najaf"
  }, {
     "name": "Navy Air Facility El Centro",
     "countryCode": "US",
     "iata": "NJK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "El Centro"
  }, {
     "name": "Nouakchott International Airport",
     "countryCode": "MR",
     "iata": "NKC",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Nouakchott"
  }, {
     "name": "Nanjing Lukou International Airport",
     "countryCode": "CN",
     "iata": "NKG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Nanjing"
  }, {
     "name": "Nagoya Airport",
     "countryCode": "JP",
     "iata": "NKM",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Nagoya"
  }, {
     "name": "Marine Corps Air Station Miramar",
     "countryCode": "US",
     "iata": "NKX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Diego"
  }, {
     "name": "Nkayi Airport",
     "countryCode": "CG",
     "iata": "NKY",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Nkayi"
  }, {
     "name": "Simon Mwansa Kapwepwe International Airport",
     "countryCode": "ZM",
     "iata": "NLA",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Ndola"
  }, {
     "name": "Naval Air Station/Reeves Field",
     "countryCode": "US",
     "iata": "NLC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lemoore"
  }, {
     "name": "Quetzalcoatl International Airport",
     "countryCode": "MX",
     "iata": "NLD",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Nuevo Laredo"
  }, {
     "name": "Darnley Island Airport",
     "countryCode": "AU",
     "iata": "NLF",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Darnley Island"
  }, {
     "name": "Rota Airport",
     "countryCode": "MP",
     "iata": "ROP",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Rota"
  }, {
     "name": "Nullagine Airport",
     "countryCode": "AU",
     "iata": "NLL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Nullagine"
  }, {
     "name": "N'Dolo Airport",
     "countryCode": "CD",
     "iata": "NLO",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Kinshasa"
  }, {
     "name": "Nelspruit Airport",
     "countryCode": "ZA",
     "iata": "NLP",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Nelspruit"
  }, {
     "name": "Nalati Airport",
     "countryCode": "CN",
     "iata": "NLT",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Xinyuan"
  }, {
     "name": "Nikolaev Airport",
     "countryCode": "UA",
     "iata": "NLV",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Nikolaev"
  }, {
     "name": "Nightmute Airport",
     "countryCode": "US",
     "iata": "NME",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Nightmute"
  }, {
     "name": "Nappamerry Airport",
     "countryCode": "AU",
     "iata": "NMR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Nappamerry"
  }, {
     "name": "Namsang Airport",
     "countryCode": "MM",
     "iata": "NMS",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Namsang"
  }, {
     "name": "Nanning Airport",
     "countryCode": "CN",
     "iata": "NNG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Nanning"
  }, {
     "name": "Namutoni Airport",
     "countryCode": "NA",
     "iata": "NNI",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Namutoni"
  }, {
     "name": "Naryan-Mar Airport",
     "countryCode": "RU",
     "iata": "NNM",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Naryan-Mar"
  }, {
     "name": "Connemara Airport",
     "countryCode": "IE",
     "iata": "NNR",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Spiddal"
  }, {
     "name": "Nan Airport",
     "countryCode": "TH",
     "iata": "NNT",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Nan"
  }, {
     "name": "Nanuque Airport",
     "countryCode": "BR",
     "iata": "NNU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Nanuque"
  }, {
     "name": "Nunukan Airport",
     "countryCode": "ID",
     "iata": "NNX",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Nunukan"
  }, {
     "name": "Nanyang Airport",
     "countryCode": "CN",
     "iata": "NNY",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Nanyang"
  }, {
     "name": "Nowra Airport",
     "countryCode": "AU",
     "iata": "NOA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Nowra"
  }, {
     "name": "Nosara Beach Airport",
     "countryCode": "CR",
     "iata": "NOB",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Nosara Beach"
  }, {
     "name": "Ireland West Airport Knock",
     "countryCode": "IE",
     "iata": "NOC",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Banke"
  }, {
     "name": "Norden Airport",
     "countryCode": "DE",
     "iata": "NOD",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Norden"
  }, {
     "name": "Nogales Airport",
     "countryCode": "MX",
     "iata": "NOG",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Nogales"
  }, {
     "name": "Nova Xavantina Airport",
     "countryCode": "BR",
     "iata": "NOK",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Nova Xavantina"
  }, {
     "name": "Sinop Airport - Turkey",
     "countryCode": "TR",
     "iata": "NOP",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Sinop"
  }, {
     "name": "Nordfjordur Airport",
     "countryCode": "IS",
     "iata": "NOR",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Nordfjordur"
  }, {
     "name": "Fascene Airport",
     "countryCode": "MG",
     "iata": "NOS",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Nossi-be"
  }, {
     "name": "Marin County Airport",
     "countryCode": "US",
     "iata": "NOT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Novato"
  }, {
     "name": "Tontouta Airport",
     "countryCode": "NC",
     "iata": "NOU",
     "eucustoms": false,
     "countryDK": "Ny Kaledonien",
     "cityDK": "Noumea"
  }, {
     "name": "Huambo Airport",
     "countryCode": "AO",
     "iata": "NOV",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Huambo"
  }, {
     "name": "Novokuznetsk Airport",
     "countryCode": "RU",
     "iata": "NOZ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Novokuznetsk"
  }, {
     "name": "Naval Air Station Pensacola",
     "countryCode": "US",
     "iata": "NPA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pensacola"
  }, {
     "name": "Hawkes Bay Airport",
     "countryCode": "NZ",
     "iata": "NPE",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Napier"
  }, {
     "name": "New Plymouth Airport",
     "countryCode": "NZ",
     "iata": "NPL",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "New Plymouth"
  }, {
     "name": "Newport State Airport",
     "countryCode": "US",
     "iata": "NPT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Newport"
  }, {
     "name": "Naval Air Station",
     "countryCode": "US",
     "iata": "NQA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Memphis"
  }, {
     "name": "Naval Air Station",
     "countryCode": "US",
     "iata": "NQI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kingsville"
  }, {
     "name": "Niquelandia Airport",
     "countryCode": "BR",
     "iata": "NQL",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Niquelandia"
  }, {
     "name": "Presidente Peron International Airport",
     "countryCode": "AR",
     "iata": "NQN",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Neuquen"
  }, {
     "name": "Nottingham Airport",
     "countryCode": "GB",
     "iata": "NQT",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Nottingham"
  }, {
     "name": "Nuqui Airport",
     "countryCode": "CO",
     "iata": "NQU",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Nuqui"
  }, {
     "name": "Naval Air Station Key West",
     "countryCode": "US",
     "iata": "NQX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Key West"
  }, {
     "name": "Newquay Cornwall Airport",
     "countryCode": "GB",
     "iata": "NQY",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Newquay"
  }, {
     "name": "Narrandera Airport",
     "countryCode": "AU",
     "iata": "NRA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Narrandera"
  }, {
     "name": "Mayport Naval Station",
     "countryCode": "US",
     "iata": "NRB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mayport"
  }, {
     "name": "Norderney Airport",
     "countryCode": "DE",
     "iata": "NRD",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Norderney"
  }, {
     "name": "Kungsangen Airport",
     "countryCode": "SE",
     "iata": "NRK",
     "eucustoms": true,
     "countryDK": "Sverige",
     "cityDK": "Norrköping"
  }, {
     "name": "North Ronaldsay Airport",
     "countryCode": "GB",
     "iata": "NRL",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "North Ronaldsay"
  }, {
     "name": "Nara Airport",
     "countryCode": "ML",
     "iata": "NRM",
     "eucustoms": false,
     "countryDK": "Mali",
     "cityDK": "Nara"
  }, {
     "name": "Weeze Airport",
     "countryCode": "DE",
     "iata": "NRN",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Düsseldorf"
  }, {
     "name": "Jose Aponte de la Torre Airport",
     "countryCode": "PR",
     "iata": "NRR",
     "eucustoms": false,
     "countryDK": "Puerto Rico",
     "cityDK": "Ceiba"
  }, {
     "name": "NOLF Imperial Beach",
     "countryCode": "US",
     "iata": "NRS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Imperial Beach"
  }, {
     "name": "Narita International Airport",
     "countryCode": "JP",
     "iata": "NRT",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Tokyo"
  }, {
     "name": "Whiting Field Naval Air Station",
     "countryCode": "US",
     "iata": "NSE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Milton"
  }, {
     "name": "Nsimalen Airport",
     "countryCode": "CM",
     "iata": "NSI",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Yaounde"
  }, {
     "name": "Noril'sk Airport",
     "countryCode": "RU",
     "iata": "NSK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Noril'sk"
  }, {
     "name": "Norseman Airport",
     "countryCode": "AU",
     "iata": "NSM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Norseman"
  }, {
     "name": "Nelson Airport",
     "countryCode": "NZ",
     "iata": "NSN",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Nelson"
  }, {
     "name": "Scone Airport",
     "countryCode": "AU",
     "iata": "NSO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Scone"
  }, {
     "name": "Nuussuaq Heliport",
     "countryCode": "GL",
     "iata": "NSQ",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Nuussuaq"
  }, {
     "name": "Nakhon Si Thammarat Airport",
     "countryCode": "TH",
     "iata": "NST",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Nakhon Si Thammarat"
  }, {
     "name": "Sigonella Naval Air Field",
     "countryCode": "IT",
     "iata": "NSY",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Sigonella"
  }, {
     "name": "Notodden Airport",
     "countryCode": "NO",
     "iata": "NTB",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Notodden"
  }, {
     "name": "Naval Base Ventura County",
     "countryCode": "US",
     "iata": "NTD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oxnard"
  }, {
     "name": "Nantes Atlantique Airport",
     "countryCode": "FR",
     "iata": "NTE",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Nantes"
  }, {
     "name": "Newcastle Airport",
     "countryCode": "AU",
     "iata": "NTL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Newcastle"
  }, {
     "name": "Normanton Airport",
     "countryCode": "AU",
     "iata": "NTN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Normanton"
  }, {
     "name": "Agostinho Neto Airport",
     "countryCode": "CV",
     "iata": "NTO",
     "eucustoms": false,
     "countryDK": "Kap Verde",
     "cityDK": "Santo Antao Island"
  }, {
     "name": "Noto Airport",
     "countryCode": "JP",
     "iata": "NTQ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Wajima"
  }, {
     "name": "Del Norte International Airport",
     "countryCode": "MX",
     "iata": "NTR",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Monterrey"
  }, {
     "name": "Kuini Lavenia Airport",
     "countryCode": "TO",
     "iata": "NTT",
     "eucustoms": false,
     "countryDK": "Tonga",
     "cityDK": "Niuatoputapu"
  }, {
     "name": "Naval Air Station",
     "countryCode": "US",
     "iata": "NTU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oceana"
  }, {
     "name": "Pilanesberg International Airport",
     "countryCode": "ZA",
     "iata": "NTY",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Sun City"
  }, {
     "name": "Numbulwar Airport",
     "countryCode": "AU",
     "iata": "NUB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Numbulwar"
  }, {
     "name": "En Nahud Airport",
     "countryCode": "SD",
     "iata": "NUD",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "En Nahud"
  }, {
     "name": "Nuremberg Airport",
     "countryCode": "DE",
     "iata": "NUE",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Nürnberg"
  }, {
     "name": "Nuiqsut Airport",
     "countryCode": "US",
     "iata": "NUI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Nuiqsut"
  }, {
     "name": "Saufley Naval Air Station",
     "countryCode": "US",
     "iata": "NUN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pensacola"
  }, {
     "name": "Moffett Federal Field",
     "countryCode": "US",
     "iata": "NUQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "bjergudsigt"
  }, {
     "name": "Norsup Airport",
     "countryCode": "VU",
     "iata": "NUS",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Norsup"
  }, {
     "name": "Nakuru Airport",
     "countryCode": "KE",
     "iata": "NUU",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Nakuru"
  }, {
     "name": "Ault Field",
     "countryCode": "US",
     "iata": "NUW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Whidbey Island"
  }, {
     "name": "Benito Salas Airport",
     "countryCode": "CO",
     "iata": "NVA",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Neiva"
  }, {
     "name": "Nevada Airport",
     "countryCode": "US",
     "iata": "NVD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Nevada"
  }, {
     "name": "Framnes Airport",
     "countryCode": "NO",
     "iata": "NVK",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Narvik"
  }, {
     "name": "Novo Aripuana Airport",
     "countryCode": "BR",
     "iata": "NVP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Novo Aripuana"
  }, {
     "name": "Nevers Airport",
     "countryCode": "FR",
     "iata": "NVS",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Nevers"
  }, {
     "name": "Navegantes Airport",
     "countryCode": "BR",
     "iata": "NVT",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Navegantes"
  }, {
     "name": "Bandar Es Eslam Airport",
     "countryCode": "KM",
     "iata": "NWA",
     "eucustoms": false,
     "countryDK": "Comorerne",
     "cityDK": "Moheli"
  }, {
     "name": "Norwich International Airport",
     "countryCode": "GB",
     "iata": "NWI",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Norwich"
  }, {
     "name": "Willow Grove Naval Air Station",
     "countryCode": "US",
     "iata": "NXX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Willow Grove"
  }, {
     "name": "Nyagan Airport",
     "countryCode": "RU",
     "iata": "NYA",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Nyagan"
  }, {
     "name": "Nyeri Airport",
     "countryCode": "KE",
     "iata": "NYE",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Nyeri"
  }, {
     "name": "Quantico Naval Air Station",
     "countryCode": "US",
     "iata": "NYG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Quantico"
  }, {
     "name": "Sunyani Airport",
     "countryCode": "GH",
     "iata": "NYI",
     "eucustoms": false,
     "countryDK": "Ghana",
     "cityDK": "Sunyani"
  }, {
     "name": "Nanyuki Airport",
     "countryCode": "KE",
     "iata": "NYK",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Nanyuki"
  }, {
     "name": "Nadym Airport",
     "countryCode": "RU",
     "iata": "NYM",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Nadym"
  }, {
     "name": "Nyngan Airport",
     "countryCode": "AU",
     "iata": "NYN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Nyngan"
  }, {
     "name": "Stockholm Skavsta Airport",
     "countryCode": "SE",
     "iata": "NYO",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Stockholm"
  }, {
     "name": "Nyurba Airport",
     "countryCode": "RU",
     "iata": "NYR",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Nyurba"
  }, {
     "name": "Nay Pyi Taw Airport",
     "countryCode": "MM",
     "iata": "NYT",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Naypyidaw"
  }, {
     "name": "Nyaung U Airport",
     "countryCode": "MM",
     "iata": "NYU",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Nyaung-u"
  }, {
     "name": "Monywa Airport",
     "countryCode": "MM",
     "iata": "NYW",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Monywa"
  }, {
     "name": "Cecil Airport",
     "countryCode": "US",
     "iata": "VQQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Jacksonville"
  }, {
     "name": "Nzerekore Airport",
     "countryCode": "GN",
     "iata": "NZE",
     "eucustoms": false,
     "countryDK": "Guinea",
     "cityDK": "Nzerekore"
  }, {
     "name": "North Island Naval Air Station",
     "countryCode": "US",
     "iata": "NZY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Diego"
  }, {
     "name": "Orange Airport",
     "countryCode": "AU",
     "iata": "OAG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "orange"
  }, {
     "name": "Bagram Airport",
     "countryCode": "AF",
     "iata": "OAI",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Bagram"
  }, {
     "name": "Albert J Ellis Airport",
     "countryCode": "US",
     "iata": "OAJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Richlands"
  }, {
     "name": "Metropolitan Oakland International Airport",
     "countryCode": "US",
     "iata": "OAK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oakland"
  }, {
     "name": "Oamaru Airport",
     "countryCode": "NZ",
     "iata": "OAM",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Oamaru"
  }, {
     "name": "Sharana Air Base",
     "countryCode": "AF",
     "iata": "OAS",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Sharana"
  }, {
     "name": "Xoxocotlan Airport",
     "countryCode": "MX",
     "iata": "OAX",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Oaxaca"
  }, {
     "name": "Camp Bastion",
     "countryCode": "AF",
     "iata": "OAZ",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Lashkar Gah"
  }, {
     "name": "Obock Airport",
     "countryCode": "DJ",
     "iata": "OBC",
     "eucustoms": false,
     "countryDK": "Djibouti",
     "cityDK": "Obock"
  }, {
     "name": "Okeechobee County Airport",
     "countryCode": "US",
     "iata": "OBE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Okeechobee"
  }, {
     "name": "Oberpfaffenhofen Airport",
     "countryCode": "DE",
     "iata": "OBF",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Oberpfaffenhofen"
  }, {
     "name": "Obidos Airport",
     "countryCode": "BR",
     "iata": "OBI",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Obidos"
  }, {
     "name": "Tokachi-Obihiro Airport",
     "countryCode": "JP",
     "iata": "OBO",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Obihiro"
  }, {
     "name": "Vals-Lanas Airport",
     "countryCode": "FR",
     "iata": "OBS",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Aubenas"
  }, {
     "name": "Ittoqqortoormiit Heliport",
     "countryCode": "GL",
     "iata": "OBY",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Ittoqqortoormiit"
  }, {
     "name": "Coca Airport",
     "countryCode": "EC",
     "iata": "OCC",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Coca"
  }, {
     "name": "Ocean City Municipal Airport",
     "countryCode": "US",
     "iata": "OCE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ocean City"
  }, {
     "name": "Ocala International Airport",
     "countryCode": "US",
     "iata": "OCF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ocala"
  }, {
     "name": "A.L. Mangham Jr. Regional Airport",
     "countryCode": "US",
     "iata": "OCH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Nacogdoches"
  }, {
     "name": "Boscobel Airport",
     "countryCode": "JM",
     "iata": "OCJ",
     "eucustoms": false,
     "countryDK": "Jamaica",
     "cityDK": "Ocho Rios"
  }, {
     "name": "Boolgeeda Airport",
     "countryCode": "AU",
     "iata": "OCM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Boolgeeda"
  }, {
     "name": "Oceanside Municipal Airport",
     "countryCode": "US",
     "iata": "OCN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oceanside"
  }, {
     "name": "Aguasclaras Airport",
     "countryCode": "CO",
     "iata": "OCV",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Ocana"
  }, {
     "name": "Warren Field",
     "countryCode": "US",
     "iata": "OCW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Washington"
  }, {
     "name": "Cordoba Airport",
     "countryCode": "ES",
     "iata": "ODB",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Cordoba"
  }, {
     "name": "Oodnadatta Airport",
     "countryCode": "AU",
     "iata": "ODD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Oodnadatta"
  }, {
     "name": "Beldringe Airport",
     "countryCode": "DK",
     "iata": "ODE",
     "eucustoms": false,
     "countryDK": "Danmark",
     "cityDK": "Odense"
  }, {
     "name": "Odiham RAF Station",
     "countryCode": "GB",
     "iata": "ODH",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Odiham"
  }, {
     "name": "Odessa International Airport",
     "countryCode": "UA",
     "iata": "ODS",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Odessa"
  }, {
     "name": "Oudomxai Airport",
     "countryCode": "LA",
     "iata": "ODY",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Muang Xay"
  }, {
     "name": "Oneal Airport",
     "countryCode": "US",
     "iata": "OEA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Vincennes"
  }, {
     "name": "Vincent Fayks Airport",
     "countryCode": "SR",
     "iata": "OEM",
     "eucustoms": false,
     "countryDK": "Surinam",
     "cityDK": "Paloemeu"
  }, {
     "name": "Osceola Municipal Airport",
     "countryCode": "US",
     "iata": "OEO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Osceola"
  }, {
     "name": "Ornskoldsvik Airport",
     "countryCode": "SE",
     "iata": "OER",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Örnsköldsvik"
  }, {
     "name": "San Antonio Oeste Airport",
     "countryCode": "AR",
     "iata": "OES",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "San Antonio Oeste"
  }, {
     "name": "Offutt Air Force Base",
     "countryCode": "US",
     "iata": "OFF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Omaha"
  }, {
     "name": "Ouango Fitini Airport",
     "countryCode": "CI",
     "iata": "OFI",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Ouango Fitini"
  }, {
     "name": "Stefan Field",
     "countryCode": "US",
     "iata": "OFK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Norfolk"
  }, {
     "name": "Ofu Airport",
     "countryCode": "AS",
     "iata": "OFU",
     "eucustoms": false,
     "countryDK": "Amerikansk Samoa",
     "cityDK": "Ofu"
  }, {
     "name": "Searle Field",
     "countryCode": "US",
     "iata": "OGA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ogallala"
  }, {
     "name": "Orangeburg Municipal Airport",
     "countryCode": "US",
     "iata": "OGB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Orangeburg"
  }, {
     "name": "Ogden Municipal Airport",
     "countryCode": "US",
     "iata": "OGD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ogden"
  }, {
     "name": "Kahului Airport",
     "countryCode": "US",
     "iata": "OGG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kahului"
  }, {
     "name": "Ogle Airport",
     "countryCode": "GY",
     "iata": "OGL",
     "eucustoms": false,
     "countryDK": "Guyana",
     "cityDK": "Georgetown"
  }, {
     "name": "Yonaguni Airport",
     "countryCode": "JP",
     "iata": "OGN",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Yonaguni"
  }, {
     "name": "Abengourou Airport",
     "countryCode": "CI",
     "iata": "OGO",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Abengourou"
  }, {
     "name": "Bongor Airport",
     "countryCode": "TD",
     "iata": "OGR",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Bongor"
  }, {
     "name": "Ogdensburg Airport",
     "countryCode": "US",
     "iata": "OGS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ogdensburg"
  }, {
     "name": "Ain Beida Airport",
     "countryCode": "DZ",
     "iata": "OGX",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Ouargla"
  }, {
     "name": "Vladikavkaz Airport",
     "countryCode": "RU",
     "iata": "OGZ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Vladikavkaz"
  }, {
     "name": "Royal Air Force Base",
     "countryCode": "NZ",
     "iata": "OHA",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Ohakea"
  }, {
     "name": "Francisco C. Ada International Airport",
     "countryCode": "MP",
     "iata": "SPN",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Saipan"
  }, {
     "name": "Mohe Airport",
     "countryCode": "CN",
     "iata": "OHE",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Mohe"
  }, {
     "name": "Novostroyka Airport",
     "countryCode": "RU",
     "iata": "OHH",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Okha"
  }, {
     "name": "Okhotsk Airport",
     "countryCode": "RU",
     "iata": "OHO",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Okhotsk"
  }, {
     "name": "Wyk Airport",
     "countryCode": "DE",
     "iata": "OHR",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Wyk"
  }, {
     "name": "Eaton Airport",
     "countryCode": "US",
     "iata": "OIC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Norwich"
  }, {
     "name": "Semnan Airport",
     "countryCode": "IR",
     "iata": "SNX",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Semnan"
  }, {
     "name": "Oshima Airport",
     "countryCode": "JP",
     "iata": "OIM",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Oshima"
  }, {
     "name": "Okushiri Airport",
     "countryCode": "JP",
     "iata": "OIR",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Okushiri"
  }, {
     "name": "Oita Airport",
     "countryCode": "JP",
     "iata": "OIT",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Oita"
  }, {
     "name": "Johnson Executive Airport",
     "countryCode": "US",
     "iata": "OJC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kansas City"
  }, {
     "name": "Naha Airport",
     "countryCode": "JP",
     "iata": "OKA",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Okinawa"
  }, {
     "name": "Will Rogers World Airport",
     "countryCode": "US",
     "iata": "OKC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oklahoma City"
  }, {
     "name": "Okadama Airport",
     "countryCode": "JP",
     "iata": "OKD",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Sapporo"
  }, {
     "name": "Okino Erabu Airport",
     "countryCode": "JP",
     "iata": "OKE",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Wadomari"
  }, {
     "name": "Okaukuejo Airport",
     "countryCode": "NA",
     "iata": "OKF",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Okaukuejo"
  }, {
     "name": "Oki Island Airport",
     "countryCode": "JP",
     "iata": "OKI",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Oki Island"
  }, {
     "name": "Okayama Airport",
     "countryCode": "JP",
     "iata": "OKJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Okayama"
  }, {
     "name": "Kokomo Municipal Airport",
     "countryCode": "US",
     "iata": "OKK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kokomo"
  }, {
     "name": "Gunung Bintang Airport",
     "countryCode": "ID",
     "iata": "OKL",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Oksibil"
  }, {
     "name": "Okmulgee Airport",
     "countryCode": "US",
     "iata": "OKM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Okmulgee"
  }, {
     "name": "Okondja Airport",
     "countryCode": "GA",
     "iata": "OKN",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Okondja"
  }, {
     "name": "Yokota Air Force Base",
     "countryCode": "JP",
     "iata": "OKO",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Tokyo"
  }, {
     "name": "Yorke Island Airport",
     "countryCode": "AU",
     "iata": "OKR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Yorke Island"
  }, {
     "name": "Oshkosh Airport",
     "countryCode": "US",
     "iata": "OKS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oshkosh"
  }, {
     "name": "Mokuti Lodge Airport",
     "countryCode": "NA",
     "iata": "OKU",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Mokuti Lodge"
  }, {
     "name": "Oakey Airport",
     "countryCode": "AU",
     "iata": "OKY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Oakey"
  }, {
     "name": "Orland Airport",
     "countryCode": "NO",
     "iata": "OLA",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Orland"
  }, {
     "name": "Olbia Costa Smeralda Airport",
     "countryCode": "IT",
     "iata": "OLB",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Olbia"
  }, {
     "name": "Old Town Airport",
     "countryCode": "US",
     "iata": "OLD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Gammel by"
  }, {
     "name": "Cattaraugus County Airport",
     "countryCode": "US",
     "iata": "OLE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Olean"
  }, {
     "name": "Wolf Point International Airport",
     "countryCode": "US",
     "iata": "OLF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wolf Point"
  }, {
     "name": "Olympia Regional Airport",
     "countryCode": "US",
     "iata": "OLM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Olympia"
  }, {
     "name": "Olympic Dam Airport",
     "countryCode": "AU",
     "iata": "OLP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Olympic Dam"
  }, {
     "name": "Nogales International Airport",
     "countryCode": "US",
     "iata": "OLS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Nogales"
  }, {
     "name": "Columbus Airport",
     "countryCode": "US",
     "iata": "OLU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbus"
  }, {
     "name": "Olive Branch Airport",
     "countryCode": "US",
     "iata": "OLV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oliven Branch"
  }, {
     "name": "Olkiombo Airport",
     "countryCode": "KE",
     "iata": "OLX",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Maasai Mara"
  }, {
     "name": "Olney Airport",
     "countryCode": "US",
     "iata": "OLY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Olney"
  }, {
     "name": "Olokminsk Airport",
     "countryCode": "RU",
     "iata": "OLZ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Olokminsk"
  }, {
     "name": "Eppley Airfield",
     "countryCode": "US",
     "iata": "OMA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Omaha"
  }, {
     "name": "Omboue Airport",
     "countryCode": "GA",
     "iata": "OMB",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Omboue"
  }, {
     "name": "Ormoc Airport",
     "countryCode": "PH",
     "iata": "OMC",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Ormoc"
  }, {
     "name": "Oranjemund Airport",
     "countryCode": "NA",
     "iata": "OMD",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Oranjemund"
  }, {
     "name": "Nome Airport",
     "countryCode": "US",
     "iata": "OME",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Nej mig"
  }, {
     "name": "Urmia Airport",
     "countryCode": "IR",
     "iata": "OMH",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Nazluy-ye Jonubi"
  }, {
     "name": "Omidiyeh Air Base",
     "countryCode": "IR",
     "iata": "OMI",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Omidiyeh"
  }, {
     "name": "Omak Municipal Airport",
     "countryCode": "US",
     "iata": "OMK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Omak"
  }, {
     "name": "Marmul Airport",
     "countryCode": "OM",
     "iata": "OMM",
     "eucustoms": false,
     "countryDK": "Oman",
     "cityDK": "Marmul"
  }, {
     "name": "Mostar Airport",
     "countryCode": "BA",
     "iata": "OMO",
     "eucustoms": false,
     "countryDK": "Bosnien-Hercegovina",
     "cityDK": "Mostar"
  }, {
     "name": "Oradea Airport",
     "countryCode": "RO",
     "iata": "OMR",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Oradea"
  }, {
     "name": "Omsk Airport",
     "countryCode": "RU",
     "iata": "OMS",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Omsk"
  }, {
     "name": "Winona Municipal Airport",
     "countryCode": "US",
     "iata": "ONA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Winona"
  }, {
     "name": "Ondangwa Airport",
     "countryCode": "NA",
     "iata": "OND",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Ondangwa"
  }, {
     "name": "Mornington Airport",
     "countryCode": "AU",
     "iata": "ONG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mornington"
  }, {
     "name": "Odate Noshiro Airport",
     "countryCode": "JP",
     "iata": "ONJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Odate Noshiro"
  }, {
     "name": "O'Neill Municipal Airport",
     "countryCode": "US",
     "iata": "ONL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "O'Neill"
  }, {
     "name": "Socorro Airport",
     "countryCode": "US",
     "iata": "ONM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Socorro"
  }, {
     "name": "Ontario Airport",
     "countryCode": "US",
     "iata": "ONO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ontario"
  }, {
     "name": "Newport Airport",
     "countryCode": "US",
     "iata": "ONP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Newport"
  }, {
     "name": "Zonguldak Airport",
     "countryCode": "TR",
     "iata": "ONQ",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Zonguldak"
  }, {
     "name": "Monkira Airport",
     "countryCode": "AU",
     "iata": "ONR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Monkira"
  }, {
     "name": "Onslow Airport",
     "countryCode": "AU",
     "iata": "ONS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Onslow"
  }, {
     "name": "Ontario International Airport",
     "countryCode": "US",
     "iata": "ONT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ontario"
  }, {
     "name": "Colon Airport",
     "countryCode": "PA",
     "iata": "ONX",
     "eucustoms": false,
     "countryDK": "Panama",
     "cityDK": "Kolon"
  }, {
     "name": "Olney Airport",
     "countryCode": "US",
     "iata": "ONY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Olney"
  }, {
     "name": "Oskaloosa Municipal Airport",
     "countryCode": "US",
     "iata": "OOA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oskaloosa"
  }, {
     "name": "Gold Coast Airport",
     "countryCode": "AU",
     "iata": "OOL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Coolangatta (Gold Coast)"
  }, {
     "name": "Snowy Mountains Airport",
     "countryCode": "AU",
     "iata": "OOM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Cooma"
  }, {
     "name": "Opa-locka Executive Airport",
     "countryCode": "US",
     "iata": "OPF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Miami"
  }, {
     "name": "Oenpelli Airport",
     "countryCode": "AU",
     "iata": "OPI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Oenpelli"
  }, {
     "name": "St Landry Parish Airport",
     "countryCode": "US",
     "iata": "OPL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Opelousas"
  }, {
     "name": "Porto Airport",
     "countryCode": "PT",
     "iata": "OPO",
     "eucustoms": true,
     "countryDK": "Portugal",
     "cityDK": "Porto"
  }, {
     "name": "Sinop Airport",
     "countryCode": "BR",
     "iata": "OPS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sinop"
  }, {
     "name": "Oran Airport",
     "countryCode": "AR",
     "iata": "ORA",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Oran"
  }, {
     "name": "Orebro-Bofors Airport",
     "countryCode": "SE",
     "iata": "ORB",
     "eucustoms": true,
     "countryDK": "Sverige",
     "cityDK": "Örebro"
  }, {
     "name": "O'Hare International Airport",
     "countryCode": "US",
     "iata": "ORD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chicago"
  }, {
     "name": "Orleans Airport",
     "countryCode": "FR",
     "iata": "ORE",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Orleans"
  }, {
     "name": "Norfolk International Airport",
     "countryCode": "US",
     "iata": "ORF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Norfolk"
  }, {
     "name": "Zorg En Hoop Airport",
     "countryCode": "SR",
     "iata": "ORG",
     "eucustoms": false,
     "countryDK": "Surinam",
     "cityDK": "Paramaribo"
  }, {
     "name": "Worcester Regional Airport",
     "countryCode": "US",
     "iata": "ORH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Worcester"
  }, {
     "name": "Orinduik Airport",
     "countryCode": "GY",
     "iata": "ORJ",
     "eucustoms": false,
     "countryDK": "Guyana",
     "cityDK": "Orinduik"
  }, {
     "name": "Cork Airport",
     "countryCode": "IE",
     "iata": "ORK",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Kork"
  }, {
     "name": "Orlando Executive Airport",
     "countryCode": "US",
     "iata": "ORL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Orlando"
  }, {
     "name": "Northampton Airport",
     "countryCode": "GB",
     "iata": "ORM",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Northampton"
  }, {
     "name": "Es Senia Airport",
     "countryCode": "DZ",
     "iata": "ORN",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Oran"
  }, {
     "name": "Orapa Airport",
     "countryCode": "BW",
     "iata": "ORP",
     "eucustoms": false,
     "countryDK": "Botswana",
     "cityDK": "Orapa"
  }, {
     "name": "Northway Airport",
     "countryCode": "US",
     "iata": "ORT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Northway"
  }, {
     "name": "Juan Mendoza Airport",
     "countryCode": "BO",
     "iata": "ORU",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Oruro"
  }, {
     "name": "Robert (Bob) Curtis Memorial Airport",
     "countryCode": "US",
     "iata": "ORV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Noorvik"
  }, {
     "name": "Ormara Airport",
     "countryCode": "PK",
     "iata": "ORW",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Ormara"
  }, {
     "name": "Oriximina Airport",
     "countryCode": "BR",
     "iata": "ORX",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Oriximina"
  }, {
     "name": "Paris Orly Airport",
     "countryCode": "FR",
     "iata": "ORY",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Paris"
  }, {
     "name": "Wurtsmith Air Force Base",
     "countryCode": "US",
     "iata": "OSC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oscoda"
  }, {
     "name": "Are Ostersund Airport",
     "countryCode": "SE",
     "iata": "OSD",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Östersund"
  }, {
     "name": "Ostafyevo International Airport",
     "countryCode": "RU",
     "iata": "OSF",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Moskva"
  }, {
     "name": "Wittman Regional Airport",
     "countryCode": "US",
     "iata": "OSH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oshkosh"
  }, {
     "name": "Osijek Airport",
     "countryCode": "HR",
     "iata": "OSI",
     "eucustoms": false,
     "countryDK": "Kroatien",
     "cityDK": "Osijek"
  }, {
     "name": "Oskarshamn Airport",
     "countryCode": "SE",
     "iata": "OSK",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Oskarshamn"
  }, {
     "name": "Oslo Airport Gardermoen",
     "countryCode": "NO",
     "iata": "OSL",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Oslo"
  }, {
     "name": "Osan Air Base",
     "countryCode": "KR",
     "iata": "OSN",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Osan"
  }, {
     "name": "Osborne Mine Airport",
     "countryCode": "AU",
     "iata": "OSO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Osborne Mine"
  }, {
     "name": "Redzikowo Airport",
     "countryCode": "PL",
     "iata": "OSP",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Slupsk"
  }, {
     "name": "Mosnov Airport",
     "countryCode": "CZ",
     "iata": "OSR",
     "eucustoms": false,
     "countryDK": "Tjekkiet",
     "cityDK": "Ostrava"
  }, {
     "name": "Osh Airport",
     "countryCode": "KG",
     "iata": "OSS",
     "eucustoms": false,
     "countryDK": "Kirgisistan",
     "cityDK": "Osh"
  }, {
     "name": "Ostend-Bruges International Airport",
     "countryCode": "BE",
     "iata": "OST",
     "eucustoms": false,
     "countryDK": "Belgien",
     "cityDK": "Oostende"
  }, {
     "name": "Ohio State University Airport",
     "countryCode": "US",
     "iata": "OSU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbus"
  }, {
     "name": "Orsk Airport",
     "countryCode": "RU",
     "iata": "OSW",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Orsk"
  }, {
     "name": "Attala County Airport",
     "countryCode": "US",
     "iata": "OSX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kosciusko"
  }, {
     "name": "Namsos Airport",
     "countryCode": "NO",
     "iata": "OSY",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Namsos"
  }, {
     "name": "Bol Airport",
     "countryCode": "TD",
     "iata": "OTC",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Bol"
  }, {
     "name": "Worthington Airport",
     "countryCode": "US",
     "iata": "OTG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Worthington"
  }, {
     "name": "Southwest Oregon Regional Airport",
     "countryCode": "US",
     "iata": "OTH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "North Bend"
  }, {
     "name": "Pitu Airport",
     "countryCode": "ID",
     "iata": "OTI",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Morotai Island"
  }, {
     "name": "Otjiwarongo Airport",
     "countryCode": "NA",
     "iata": "OTJ",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Otjiwarongo"
  }, {
     "name": "Boutilimit Airport",
     "countryCode": "MR",
     "iata": "OTL",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Boutilimit"
  }, {
     "name": "Industrial Airport",
     "countryCode": "US",
     "iata": "OTM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ottumwa"
  }, {
     "name": "Bucharest Henri Coanda International Airport",
     "countryCode": "RO",
     "iata": "OTP",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Bukarest"
  }, {
     "name": "Coto 47 Airport",
     "countryCode": "CR",
     "iata": "OTR",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Coto 47"
  }, {
     "name": "Otu Airport",
     "countryCode": "CO",
     "iata": "OTU",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "otu"
  }, {
     "name": "Ralph Wien Memorial Airport",
     "countryCode": "US",
     "iata": "OTZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Kotzebue"
  }, {
     "name": "Ouagadougou International Airport",
     "countryCode": "BF",
     "iata": "OUA",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Ouagadougou"
  }, {
     "name": "Les Angades Airport",
     "countryCode": "MA",
     "iata": "OUD",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Oujda"
  }, {
     "name": "Ouesso Airport",
     "countryCode": "CG",
     "iata": "OUE",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Ouesso"
  }, {
     "name": "Ouahigouya Airport",
     "countryCode": "BF",
     "iata": "OUG",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Ouahigouya"
  }, {
     "name": "Oudtshoorn Airport",
     "countryCode": "ZA",
     "iata": "OUH",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Oudtshoorn"
  }, {
     "name": "Oulu Airport",
     "countryCode": "FI",
     "iata": "OUL",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Oulu"
  }, {
     "name": "Max Westheimer Airport",
     "countryCode": "US",
     "iata": "OUN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Norman"
  }, {
     "name": "Batouri Airport",
     "countryCode": "CM",
     "iata": "OUR",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Batouri"
  }, {
     "name": "Ourinhos Airport",
     "countryCode": "BR",
     "iata": "OUS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Ourinhos"
  }, {
     "name": "Bousso Airport",
     "countryCode": "TD",
     "iata": "OUT",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Bousso"
  }, {
     "name": "Tazadit Airport",
     "countryCode": "MR",
     "iata": "OUZ",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Zouerate"
  }, {
     "name": "Bekily Airport",
     "countryCode": "MG",
     "iata": "OVA",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Bekily"
  }, {
     "name": "Novosibirsk Tolmachevo Airport",
     "countryCode": "RU",
     "iata": "OVB",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Novosibirsk"
  }, {
     "name": "Asturias Airport",
     "countryCode": "ES",
     "iata": "OVD",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Asturias"
  }, {
     "name": "Oroville Airport",
     "countryCode": "US",
     "iata": "OVE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oroville"
  }, {
     "name": "Sovetsky Airport",
     "countryCode": "RU",
     "iata": "OVS",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Sovetsky"
  }, {
     "name": "Owatonna Airport",
     "countryCode": "US",
     "iata": "OWA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Owatonna"
  }, {
     "name": "Daviess County Airport",
     "countryCode": "US",
     "iata": "OWB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Owensboro"
  }, {
     "name": "Norwood Memorial Airport",
     "countryCode": "US",
     "iata": "OWD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Norwood"
  }, {
     "name": "Central Maine Airport",
     "countryCode": "US",
     "iata": "OWK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Norridgewock"
  }, {
     "name": "Osvaldo Vieira Airport",
     "countryCode": "GW",
     "iata": "OXB",
     "eucustoms": false,
     "countryDK": "Guinea-Bissau",
     "cityDK": "Bissau"
  }, {
     "name": "Waterbury-Oxford Airport",
     "countryCode": "US",
     "iata": "OXC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oxford"
  }, {
     "name": "Miami University Airport",
     "countryCode": "US",
     "iata": "OXD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oxford"
  }, {
     "name": "London Oxford Airport",
     "countryCode": "GB",
     "iata": "OXF",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Oxford"
  }, {
     "name": "Oxnard Airport",
     "countryCode": "US",
     "iata": "OXR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oxnard"
  }, {
     "name": "Morney Airport",
     "countryCode": "AU",
     "iata": "OXY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Morney"
  }, {
     "name": "Goya Airport",
     "countryCode": "AR",
     "iata": "OYA",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Goya"
  }, {
     "name": "Oyem Airport",
     "countryCode": "GA",
     "iata": "OYE",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Oyem"
  }, {
     "name": "Oiapoque Airport",
     "countryCode": "BR",
     "iata": "OYK",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Oiapoque"
  }, {
     "name": "Moyale Airport",
     "countryCode": "KE",
     "iata": "OYL",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Moyale"
  }, {
     "name": "Tres Arroyos Airport",
     "countryCode": "AR",
     "iata": "OYO",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Tres Arroyos"
  }, {
     "name": "St. Georges de L/Oyapock Airport",
     "countryCode": "GF",
     "iata": "OYP",
     "eucustoms": false,
     "countryDK": "Fransk guyana",
     "cityDK": "Saint Georges de L / Oyapock"
  }, {
     "name": "Ozona Airport",
     "countryCode": "US",
     "iata": "OZA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ozona"
  }, {
     "name": "Labo Airport",
     "countryCode": "PH",
     "iata": "OZC",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Ozamiz"
  }, {
     "name": "Zagora Airport",
     "countryCode": "MA",
     "iata": "OZG",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Zagora"
  }, {
     "name": "Zaporozhye Airport",
     "countryCode": "UA",
     "iata": "OZH",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Zaporozhye"
  }, {
     "name": "Moron Air Base",
     "countryCode": "ES",
     "iata": "OZP",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Fjols"
  }, {
     "name": "Cairns Army Air Field",
     "countryCode": "US",
     "iata": "OZR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ozark"
  }, {
     "name": "Ouarzazate Airport",
     "countryCode": "MA",
     "iata": "OZZ",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Ouarzazate"
  }, {
     "name": "Pa-an Airport",
     "countryCode": "MM",
     "iata": "PAA",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Pa-en"
  }, {
     "name": "Bilaspur Airport",
     "countryCode": "IN",
     "iata": "PAB",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Bilaspur"
  }, {
     "name": "Marcos A. Gelabert International Airport",
     "countryCode": "PA",
     "iata": "PAC",
     "eucustoms": false,
     "countryDK": "Panama",
     "cityDK": "Panama City"
  }, {
     "name": "Paderborn Lippstadt Airport",
     "countryCode": "DE",
     "iata": "PAD",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Paderborn"
  }, {
     "name": "Snohomish County Airport",
     "countryCode": "US",
     "iata": "PAE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Everett"
  }, {
     "name": "Pakuba Airport",
     "countryCode": "UG",
     "iata": "PAF",
     "eucustoms": false,
     "countryDK": "Uganda",
     "cityDK": "Pakuba"
  }, {
     "name": "Pagadian Airport",
     "countryCode": "PH",
     "iata": "PAG",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Pagadian"
  }, {
     "name": "Barkley Regional Airport",
     "countryCode": "US",
     "iata": "PAH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Paducah"
  }, {
     "name": "Para Chinar Airport",
     "countryCode": "PK",
     "iata": "PAJ",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Para Chinar"
  }, {
     "name": "Palanquero Airport",
     "countryCode": "CO",
     "iata": "PAL",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Palanquero"
  }, {
     "name": "Tyndall Air Force Base",
     "countryCode": "US",
     "iata": "PAM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Panama City"
  }, {
     "name": "Pattani Airport",
     "countryCode": "TH",
     "iata": "PAN",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Pattani"
  }, {
     "name": "Palo Alto Airport of Santa Clara County",
     "countryCode": "US",
     "iata": "PAO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Palo Alto"
  }, {
     "name": "Toussaint Louverture International Airport",
     "countryCode": "HT",
     "iata": "PAP",
     "eucustoms": false,
     "countryDK": "Haiti",
     "cityDK": "Port Au Prince"
  }, {
     "name": "Palmer Municipal Airport",
     "countryCode": "US",
     "iata": "PAQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Palmer"
  }, {
     "name": "Paris Metropolitan",
     "countryCode": "FR",
     "iata": "PAR",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Paris"
  }, {
     "name": "Paros Airport",
     "countryCode": "GR",
     "iata": "PAS",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Paros"
  }, {
     "name": "Jay Prakash Narayan International Airport",
     "countryCode": "IN",
     "iata": "PAT",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Patna"
  }, {
     "name": "Pauk Airport",
     "countryCode": "MM",
     "iata": "PAU",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Pauk"
  }, {
     "name": "Paulo Afonso Airport",
     "countryCode": "BR",
     "iata": "PAV",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Paulo Afonso"
  }, {
     "name": "Port De Paix Airport",
     "countryCode": "HT",
     "iata": "PAX",
     "eucustoms": false,
     "countryDK": "Haiti",
     "cityDK": "Port De Paix"
  }, {
     "name": "El Tajin National Airport",
     "countryCode": "MX",
     "iata": "PAZ",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Poza Rica"
  }, {
     "name": "Paranaiba Airport",
     "countryCode": "BR",
     "iata": "PBB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Paranaiba"
  }, {
     "name": "Huejotsingo Airport",
     "countryCode": "MX",
     "iata": "PBC",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Puebla"
  }, {
     "name": "Porbandar Airport",
     "countryCode": "IN",
     "iata": "PBD",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Porbandar"
  }, {
     "name": "Puerto Berrio Airport",
     "countryCode": "CO",
     "iata": "PBE",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Puerto Berrio"
  }, {
     "name": "Grider Field",
     "countryCode": "US",
     "iata": "PBF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pine Bluff"
  }, {
     "name": "Plattsburgh International Airport",
     "countryCode": "US",
     "iata": "PBG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Plattsburgh"
  }, {
     "name": "Paro Airport",
     "countryCode": "BT",
     "iata": "PBH",
     "eucustoms": false,
     "countryDK": "Bhutan",
     "cityDK": "Paro"
  }, {
     "name": "Palm Beach International Airport",
     "countryCode": "US",
     "iata": "PBI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "West Palm Beach"
  }, {
     "name": "General Bartolome Salom International Airport",
     "countryCode": "VE",
     "iata": "PBL",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Puerto Cabello"
  }, {
     "name": "Zanderij International Airport",
     "countryCode": "SR",
     "iata": "PBM",
     "eucustoms": false,
     "countryDK": "Surinam",
     "cityDK": "Paramaribo"
  }, {
     "name": "Porto Amboim Airport",
     "countryCode": "AO",
     "iata": "PBN",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Porto Amboim"
  }, {
     "name": "Paraburdoo Airport",
     "countryCode": "AU",
     "iata": "PBO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Paraburdoo"
  }, {
     "name": "Pimenta Bueno Airport",
     "countryCode": "BR",
     "iata": "PBQ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Pimenta Bueno"
  }, {
     "name": "Puerto Barrios Airport",
     "countryCode": "GT",
     "iata": "PBR",
     "eucustoms": false,
     "countryDK": "Guatemala",
     "cityDK": "Puerto Barrios"
  }, {
     "name": "Putao Airport",
     "countryCode": "MM",
     "iata": "PBU",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Putao"
  }, {
     "name": "Porto Dos Gauchos Airport",
     "countryCode": "BR",
     "iata": "PBV",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Porto Dos Gauchos"
  }, {
     "name": "Plettenberg Bay Airport",
     "countryCode": "ZA",
     "iata": "PBZ",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Plettenberg Bay"
  }, {
     "name": "Portage Creek Airport",
     "countryCode": "US",
     "iata": "PCA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Portage Creek"
  }, {
     "name": "Prairie Du Chien Municipal Airport",
     "countryCode": "US",
     "iata": "PCD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Prairie Du Chien"
  }, {
     "name": "Capitan Rolden Airport",
     "countryCode": "PE",
     "iata": "PCL",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Pucallpa"
  }, {
     "name": "Picton Aerodrome",
     "countryCode": "NZ",
     "iata": "PCN",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Picton"
  }, {
     "name": "Principe Airport",
     "countryCode": "ST",
     "iata": "PCP",
     "eucustoms": false,
     "countryDK": "São Tomé og Príncipe",
     "cityDK": "Principe"
  }, {
     "name": "Puerto Carreno Airport",
     "countryCode": "CO",
     "iata": "PCR",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Puerto Carreno"
  }, {
     "name": "Picos Airport",
     "countryCode": "BR",
     "iata": "PCS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Picos"
  }, {
     "name": "Pearl River County Airport",
     "countryCode": "US",
     "iata": "PCU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Picayune"
  }, {
     "name": "Puerto Inirida Airport",
     "countryCode": "CO",
     "iata": "PDA",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Puerto Inirida"
  }, {
     "name": "Ponta De Ouro",
     "countryCode": "MZ",
     "iata": "PDD",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Ponta De Ouro"
  }, {
     "name": "Prado Airport",
     "countryCode": "BR",
     "iata": "PDF",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Prado"
  }, {
     "name": "Minangkabau International Airport",
     "countryCode": "ID",
     "iata": "PDG",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Padang"
  }, {
     "name": "DeKalb Peachtree Airport",
     "countryCode": "US",
     "iata": "PDK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Atlanta"
  }, {
     "name": "Joao Paulo II Airport",
     "countryCode": "PT",
     "iata": "PDL",
     "eucustoms": true,
     "countryDK": "Portugal",
     "cityDK": "Ponta Delgada (Azorerne)"
  }, {
     "name": "Capitan de Corbeta Carlos A. Curbelo International Airport",
     "countryCode": "UY",
     "iata": "PDP",
     "eucustoms": false,
     "countryDK": "Uruguay",
     "cityDK": "Punta Del Este"
  }, {
     "name": "Piedras Negras International Airport",
     "countryCode": "MX",
     "iata": "PDS",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Piedras Negras"
  }, {
     "name": "Eastern Oregon Regional Airport",
     "countryCode": "US",
     "iata": "PDT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pendleton"
  }, {
     "name": "Paysandu Airport",
     "countryCode": "UY",
     "iata": "PDU",
     "eucustoms": false,
     "countryDK": "Uruguay",
     "cityDK": "Paysandu"
  }, {
     "name": "Plovdiv Airport",
     "countryCode": "BG",
     "iata": "PDV",
     "eucustoms": false,
     "countryDK": "Bulgarien",
     "cityDK": "Plovdiv"
  }, {
     "name": "Portland International Airport",
     "countryCode": "US",
     "iata": "PDX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Portland"
  }, {
     "name": "Pardubice Airport",
     "countryCode": "CZ",
     "iata": "PED",
     "eucustoms": false,
     "countryDK": "Tjekkiet",
     "cityDK": "Pardubice"
  }, {
     "name": "Perm International Airport",
     "countryCode": "RU",
     "iata": "PEE",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Perm"
  }, {
     "name": "Sant Egidio Airport",
     "countryCode": "IT",
     "iata": "PEG",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Perugia"
  }, {
     "name": "Pehuajo Airport",
     "countryCode": "AR",
     "iata": "PEH",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Pehuajo"
  }, {
     "name": "Matecana International Airport",
     "countryCode": "CO",
     "iata": "PEI",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Pereira"
  }, {
     "name": "Beijing Capital International Airport",
     "countryCode": "CN",
     "iata": "PEK",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Beijing"
  }, {
     "name": "Puerto Maldonado Airport",
     "countryCode": "PE",
     "iata": "PEM",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Puerto Maldonado"
  }, {
     "name": "Penang International Airport",
     "countryCode": "MY",
     "iata": "PEN",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Penang"
  }, {
     "name": "Pecos Municipal Airport",
     "countryCode": "US",
     "iata": "PEQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pecos City"
  }, {
     "name": "Perth Airport",
     "countryCode": "AU",
     "iata": "PER",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Perth"
  }, {
     "name": "Petrozavodsk Airport",
     "countryCode": "RU",
     "iata": "PES",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Petrozavodsk"
  }, {
     "name": "Federal Airport",
     "countryCode": "BR",
     "iata": "PET",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Pelotas"
  }, {
     "name": "Puerto Lempira Airport",
     "countryCode": "HN",
     "iata": "PEU",
     "eucustoms": false,
     "countryDK": "Honduras",
     "cityDK": "Puerto Lempira"
  }, {
     "name": "Bacha Khan International Airport",
     "countryCode": "PK",
     "iata": "PEW",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Peshawar"
  }, {
     "name": "Pechora Airport",
     "countryCode": "RU",
     "iata": "PEX",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Pechora"
  }, {
     "name": "Passo Fundo Airport",
     "countryCode": "BR",
     "iata": "PFB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Passo Fundo"
  }, {
     "name": "Pacific City State Airport",
     "countryCode": "US",
     "iata": "PFC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pacific City"
  }, {
     "name": "Patrekstjord Airport",
     "countryCode": "IS",
     "iata": "PFJ",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Patrekstjord"
  }, {
     "name": "Paphos International Airport",
     "countryCode": "CY",
     "iata": "PFO",
     "eucustoms": false,
     "countryDK": "Cypern",
     "cityDK": "Paphos"
  }, {
     "name": "Parsabad Moghan Airport",
     "countryCode": "IR",
     "iata": "PFQ",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Parsabad"
  }, {
     "name": "Ilebo Airport",
     "countryCode": "CD",
     "iata": "PFR",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Ilebo"
  }, {
     "name": "Page Airport",
     "countryCode": "US",
     "iata": "PGA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Side"
  }, {
     "name": "Charlotte County Airport",
     "countryCode": "US",
     "iata": "PGD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Punta Gorda"
  }, {
     "name": "Llabanere Airport",
     "countryCode": "FR",
     "iata": "PGF",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Perpignan"
  }, {
     "name": "Pantnagar Airport",
     "countryCode": "IN",
     "iata": "PGH",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Pantnagar"
  }, {
     "name": "Depati Amir Airport",
     "countryCode": "ID",
     "iata": "PGK",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Pangkal Pinang"
  }, {
     "name": "Buli Airport",
     "countryCode": "ID",
     "iata": "PGQ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "buil"
  }, {
     "name": "Kirk Field",
     "countryCode": "US",
     "iata": "PGR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Paragould"
  }, {
     "name": "Ala'Marvdasht Airport",
     "countryCode": "IR",
     "iata": "PGU",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Ala'Marvdasht"
  }, {
     "name": "Pitt-Greenville Airport",
     "countryCode": "US",
     "iata": "PGV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Greenville"
  }, {
     "name": "Perigueux Airport",
     "countryCode": "FR",
     "iata": "PGX",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Perigueux"
  }, {
     "name": "Comte Antonio Amilton Beraldo Airport",
     "countryCode": "BR",
     "iata": "PGZ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Ponta Grossa"
  }, {
     "name": "Parnaiba-Prefeito Dr. Joao Silva Filho International Airport",
     "countryCode": "BR",
     "iata": "PHB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Parnaiba"
  }, {
     "name": "Port Harcourt International Airport",
     "countryCode": "NG",
     "iata": "PHC",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Port Harcourt"
  }, {
     "name": "Harry Clever Field",
     "countryCode": "US",
     "iata": "PHD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "New Philadelphia"
  }, {
     "name": "Port Hedland International Airport",
     "countryCode": "AU",
     "iata": "PHE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Port Hedland"
  }, {
     "name": "Newport News/Williamsburg International Airport",
     "countryCode": "US",
     "iata": "PHF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Newport News"
  }, {
     "name": "Pinheiro Airport",
     "countryCode": "BR",
     "iata": "PHI",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Pinheiro"
  }, {
     "name": "Palm Beach County Glades Airport",
     "countryCode": "US",
     "iata": "PHK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pahokee"
  }, {
     "name": "Philadelphia International Airport",
     "countryCode": "US",
     "iata": "PHL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Philadelphia"
  }, {
     "name": "St Clair County International Airport",
     "countryCode": "US",
     "iata": "PHN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Port Huron"
  }, {
     "name": "Kaneohe Bay Marine Corps Air Station",
     "countryCode": "US",
     "iata": "NGF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mokapu"
  }, {
     "name": "Point Hope Airport",
     "countryCode": "US",
     "iata": "PHO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Point Hope"
  }, {
     "name": "Phillip Airport",
     "countryCode": "US",
     "iata": "PHP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Philip"
  }, {
     "name": "The Monument Airport",
     "countryCode": "AU",
     "iata": "PHQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Fosfat Hill"
  }, {
     "name": "Phitsanulok Airport",
     "countryCode": "TH",
     "iata": "PHS",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Phitsanulok"
  }, {
     "name": "Henry County Airport",
     "countryCode": "US",
     "iata": "PHT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Paris"
  }, {
     "name": "Phalaborwa Airport",
     "countryCode": "ZA",
     "iata": "PHW",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Phalaborwa"
  }, {
     "name": "Phoenix Sky Harbor International Airport",
     "countryCode": "US",
     "iata": "PHX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Phoenix"
  }, {
     "name": "Phetchabun Airport",
     "countryCode": "TH",
     "iata": "PHY",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Phetchabun"
  }, {
     "name": "Peoria International Airport",
     "countryCode": "US",
     "iata": "PIA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Peoria"
  }, {
     "name": "Hattiesburg-Laurel Regional Airport",
     "countryCode": "US",
     "iata": "PIB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Laurel"
  }, {
     "name": "Pine Cay Airport",
     "countryCode": "TC",
     "iata": "PIC",
     "eucustoms": false,
     "countryDK": "Turks- og Caicosøerne",
     "cityDK": "Pine Cay"
  }, {
     "name": "Paradise Island Airport",
     "countryCode": "BS",
     "iata": "PID",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Nassau"
  }, {
     "name": "St. Petersburg-Clearwater International Airport",
     "countryCode": "US",
     "iata": "PIE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sankt Petersborg"
  }, {
     "name": "Pingtung Airport",
     "countryCode": "TW",
     "iata": "PIF",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Pingtung"
  }, {
     "name": "Pocatello Regional Airport",
     "countryCode": "US",
     "iata": "PIH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pocatello"
  }, {
     "name": "Glasgow Prestwick Airport",
     "countryCode": "GB",
     "iata": "PIK",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Glasgow"
  }, {
     "name": "Garden Harris County Airport",
     "countryCode": "US",
     "iata": "PIM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pine Mountain"
  }, {
     "name": "Julio Belem Airport",
     "countryCode": "BR",
     "iata": "PIN",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Parintins"
  }, {
     "name": "Capitan FAP Renan Elias Olivera Airport",
     "countryCode": "PE",
     "iata": "PIO",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Pisco"
  }, {
     "name": "Pierre Regional Airport",
     "countryCode": "US",
     "iata": "PIR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pierre"
  }, {
     "name": "Poitiers-Biard Airport",
     "countryCode": "FR",
     "iata": "PIS",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Poitiers"
  }, {
     "name": "Pittsburgh International Airport",
     "countryCode": "US",
     "iata": "PIT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pittsburgh"
  }, {
     "name": "Cap. FAP Guillermo Concha Iberico International Airport",
     "countryCode": "PE",
     "iata": "PIU",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Piura"
  }, {
     "name": "Pirapora Airport",
     "countryCode": "BR",
     "iata": "PIV",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Pirapora"
  }, {
     "name": "Pikwitonei Airport",
     "countryCode": "CA",
     "iata": "PIW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Pikwitonei"
  }, {
     "name": "Pico Island Airport",
     "countryCode": "PT",
     "iata": "PIX",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Pico Island (Azorerne)"
  }, {
     "name": "Dew Station Airport",
     "countryCode": "US",
     "iata": "PIZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Point Lay"
  }, {
     "name": "Pajala Airport",
     "countryCode": "SE",
     "iata": "PJA",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Pajala"
  }, {
     "name": "Payson Airport",
     "countryCode": "US",
     "iata": "PJB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Payson"
  }, {
     "name": "Panjgur Airport",
     "countryCode": "PK",
     "iata": "PJG",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Panjgur"
  }, {
     "name": "Puerto Jimenez Airport",
     "countryCode": "CR",
     "iata": "PJM",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Puerto Jimenez"
  }, {
     "name": "Wood County Airport",
     "countryCode": "US",
     "iata": "PKB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Parkersburg"
  }, {
     "name": "Petropavlovsk-Kamchatsky Airport",
     "countryCode": "RU",
     "iata": "PKC",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Petropavlovsk-Kamchatsky"
  }, {
     "name": "Park Rapids Municipal Airport-Konshok Field",
     "countryCode": "US",
     "iata": "PKD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Park Rapids"
  }, {
     "name": "Parkes Airport",
     "countryCode": "AU",
     "iata": "PKE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Parkes"
  }, {
     "name": "Park Falls Airport",
     "countryCode": "US",
     "iata": "PKF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Park Falls"
  }, {
     "name": "Pangkor Airport",
     "countryCode": "MY",
     "iata": "PKG",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Pangkor Island"
  }, {
     "name": "Pakokku Airport",
     "countryCode": "MM",
     "iata": "PKK",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Pakokku"
  }, {
     "name": "Iskandar Airport",
     "countryCode": "ID",
     "iata": "PKN",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Pangkalanbun"
  }, {
     "name": "Parakou Airport",
     "countryCode": "BJ",
     "iata": "PKO",
     "eucustoms": false,
     "countryDK": "Benin",
     "cityDK": "Parakou"
  }, {
     "name": "Puka Puka Airport",
     "countryCode": "PF",
     "iata": "PKP",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Puka Puka"
  }, {
     "name": "Pokhara Airport",
     "countryCode": "NP",
     "iata": "PKR",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Pokhara"
  }, {
     "name": "Port Keats Airport",
     "countryCode": "AU",
     "iata": "PKT",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Port Keats"
  }, {
     "name": "Sultan Syarif Kasim II International Airport",
     "countryCode": "ID",
     "iata": "PKU",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Pekanbaru"
  }, {
     "name": "Pskov Airport",
     "countryCode": "RU",
     "iata": "PKV",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Pskov"
  }, {
     "name": "Selebi-Phikwe Airport",
     "countryCode": "BW",
     "iata": "PKW",
     "eucustoms": false,
     "countryDK": "Botswana",
     "cityDK": "Selebi-Phikwe"
  }, {
     "name": "Tjilik Riwut Airport",
     "countryCode": "ID",
     "iata": "PKY",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Palangkaraya"
  }, {
     "name": "Pakse Airport",
     "countryCode": "LA",
     "iata": "PKZ",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Pakse"
  }, {
     "name": "Clinton County Airport",
     "countryCode": "US",
     "iata": "PLB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Plattsburgh"
  }, {
     "name": "Playa Samara Airport",
     "countryCode": "CR",
     "iata": "PLD",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Playa Samara"
  }, {
     "name": "Pala Airport",
     "countryCode": "TD",
     "iata": "PLF",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Pala"
  }, {
     "name": "Plymouth Airport",
     "countryCode": "GB",
     "iata": "PLH",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Plymouth"
  }, {
     "name": "M Graham Clark Airport",
     "countryCode": "US",
     "iata": "PLK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Branson / Point Lookout"
  }, {
     "name": "Ponta Pelada Airport",
     "countryCode": "BR",
     "iata": "PLL",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Ponta Pelada"
  }, {
     "name": "Sultan Mahmud Badaruddin II Airport",
     "countryCode": "ID",
     "iata": "PLM",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Palembang"
  }, {
     "name": "Emmet County Airport",
     "countryCode": "US",
     "iata": "PLN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pellston"
  }, {
     "name": "Port Lincoln Airport",
     "countryCode": "AU",
     "iata": "PLO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Port Lincoln"
  }, {
     "name": "La Palma Airport",
     "countryCode": "PA",
     "iata": "PLP",
     "eucustoms": false,
     "countryDK": "Panama",
     "cityDK": "La Palma"
  }, {
     "name": "Palanga International Airport",
     "countryCode": "LT",
     "iata": "PLQ",
     "eucustoms": false,
     "countryDK": "Litauen",
     "cityDK": "Palanga"
  }, {
     "name": "St. Clair County Airport",
     "countryCode": "US",
     "iata": "PLR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pell City"
  }, {
     "name": "Providenciales International Airport",
     "countryCode": "TC",
     "iata": "PLS",
     "eucustoms": false,
     "countryDK": "Turks- og Caicosøerne",
     "cityDK": "Providenciales"
  }, {
     "name": "Pampulha Airport",
     "countryCode": "BR",
     "iata": "PLU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Belo Horizonte"
  }, {
     "name": "Poltava Airport",
     "countryCode": "UA",
     "iata": "PLV",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Poltava"
  }, {
     "name": "Mutiara Airport",
     "countryCode": "ID",
     "iata": "PLW",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Palu"
  }, {
     "name": "Semipalatinsk Airport",
     "countryCode": "KZ",
     "iata": "PLX",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Semipalatinsk"
  }, {
     "name": "Port Elizabeth International Airport",
     "countryCode": "ZA",
     "iata": "PLZ",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Port Elizabeth"
  }, {
     "name": "Wawi Airport",
     "countryCode": "TZ",
     "iata": "PMA",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Pemba"
  }, {
     "name": "Pembina Intermediate Airport",
     "countryCode": "US",
     "iata": "PMB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pembina"
  }, {
     "name": "El Tepual Airport",
     "countryCode": "CL",
     "iata": "PMC",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Puerto Montt"
  }, {
     "name": "Palmdale Air Force 42 Base",
     "countryCode": "US",
     "iata": "PMD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Palmdale"
  }, {
     "name": "Parma Airport",
     "countryCode": "IT",
     "iata": "PMF",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Parma"
  }, {
     "name": "Ponta Pora International Airport",
     "countryCode": "BR",
     "iata": "PMG",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Ponta Pora"
  }, {
     "name": "Portsmouth Regional Airport",
     "countryCode": "US",
     "iata": "PMH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Portsmouth"
  }, {
     "name": "Palma de Mallorca Airport",
     "countryCode": "ES",
     "iata": "PMI",
     "eucustoms": true,
     "countryDK": "Spanien",
     "cityDK": "Palma Mallorca"
  }, {
     "name": "Palm Island Airport",
     "countryCode": "AU",
     "iata": "PMK",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Palm Island"
  }, {
     "name": "Falcone-Borsellino Airport",
     "countryCode": "IT",
     "iata": "PMO",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Palermo"
  }, {
     "name": "Perito Moreno Airport",
     "countryCode": "AR",
     "iata": "PMQ",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Perito Moreno"
  }, {
     "name": "Palmerston North Airport",
     "countryCode": "NZ",
     "iata": "PMR",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Palmerston North"
  }, {
     "name": "Palmyra Airport",
     "countryCode": "SY",
     "iata": "PMS",
     "eucustoms": false,
     "countryDK": "Syrien",
     "cityDK": "Palmyra"
  }, {
     "name": "Santiago Marino International Airport",
     "countryCode": "VE",
     "iata": "PMV",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Porlamar"
  }, {
     "name": "Palmas Airport",
     "countryCode": "BR",
     "iata": "PMW",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Palmas"
  }, {
     "name": "Palmer Metropolitan Airport",
     "countryCode": "US",
     "iata": "PMX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Palmer"
  }, {
     "name": "El Tehuelche Airport",
     "countryCode": "AR",
     "iata": "PMY",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Puerto Madryn"
  }, {
     "name": "Palmur'Sur Airport",
     "countryCode": "CR",
     "iata": "PMZ",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Palmar"
  }, {
     "name": "Pamplona Airport",
     "countryCode": "ES",
     "iata": "PNA",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Pamplona"
  }, {
     "name": "Porto Nacional Airport",
     "countryCode": "BR",
     "iata": "PNB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Porto Nacional"
  }, {
     "name": "Ponca City Regional Airport",
     "countryCode": "US",
     "iata": "PNC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ponca City"
  }, {
     "name": "Northeast Philadelphia Airport",
     "countryCode": "US",
     "iata": "PNE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Philadelphia"
  }, {
     "name": "Paranagua Municipal Airport",
     "countryCode": "BR",
     "iata": "PNG",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Paranaguá"
  }, {
     "name": "Phnom Penh International Airport",
     "countryCode": "KH",
     "iata": "PNH",
     "eucustoms": false,
     "countryDK": "Cambodja",
     "cityDK": "Phnom Penh"
  }, {
     "name": "Pohnpei Airport",
     "countryCode": "FM",
     "iata": "PNI",
     "eucustoms": false,
     "countryDK": "Mikronesien",
     "cityDK": "Pohnpei, Caroline Islands"
  }, {
     "name": "Supadio International Airport",
     "countryCode": "ID",
     "iata": "PNK",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Pontianak"
  }, {
     "name": "Pantelleria Airport",
     "countryCode": "IT",
     "iata": "PNL",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Pantelleria"
  }, {
     "name": "Princeton Airport",
     "countryCode": "US",
     "iata": "PNN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Princeton"
  }, {
     "name": "Pune Airport",
     "countryCode": "IN",
     "iata": "PNQ",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Pune"
  }, {
     "name": "Pointe Noire Airport",
     "countryCode": "CG",
     "iata": "PNR",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Pointe Noire"
  }, {
     "name": "Pensacola International Airport",
     "countryCode": "US",
     "iata": "PNS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pensacola"
  }, {
     "name": "Teniente J. Gallardo Airport",
     "countryCode": "CL",
     "iata": "PNT",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Puerto Natales"
  }, {
     "name": "Puducherry Airport",
     "countryCode": "IN",
     "iata": "PNY",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Puducherry"
  }, {
     "name": "Petrolina International Airport",
     "countryCode": "BR",
     "iata": "PNZ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Petrolina"
  }, {
     "name": "Salgado Filho International Airport",
     "countryCode": "BR",
     "iata": "POA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Porto Alegre"
  }, {
     "name": "Pope Field",
     "countryCode": "US",
     "iata": "POB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fayetteville"
  }, {
     "name": "Brackett Field",
     "countryCode": "US",
     "iata": "POC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "La Verne"
  }, {
     "name": "Podor Airport",
     "countryCode": "SN",
     "iata": "POD",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Podor"
  }, {
     "name": "Polk Army Air Field",
     "countryCode": "US",
     "iata": "POE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Polk"
  }, {
     "name": "Earl Fields Memorial Airport",
     "countryCode": "US",
     "iata": "POF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Poplar Bluff"
  }, {
     "name": "Port Gentil Airport",
     "countryCode": "GA",
     "iata": "POG",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Port Gentil"
  }, {
     "name": "Pocahontas Municipal Airport",
     "countryCode": "US",
     "iata": "POH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pocahontas"
  }, {
     "name": "Captain Nicolas Rojas Airport",
     "countryCode": "BO",
     "iata": "POI",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Potosi"
  }, {
     "name": "Patos De Minas Airport",
     "countryCode": "BR",
     "iata": "POJ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Patos De Minas"
  }, {
     "name": "Pemba Airport",
     "countryCode": "MZ",
     "iata": "POL",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Pemba"
  }, {
     "name": "Jacksons International Airport",
     "countryCode": "PG",
     "iata": "POM",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Port Moresby"
  }, {
     "name": "Poptun Airport",
     "countryCode": "GT",
     "iata": "PON",
     "eucustoms": false,
     "countryDK": "Guatemala",
     "cityDK": "Poptun"
  }, {
     "name": "Pocos De Caldas Airport",
     "countryCode": "BR",
     "iata": "POO",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Pocos De Caldas"
  }, {
     "name": "La Union Airport",
     "countryCode": "DO",
     "iata": "POP",
     "eucustoms": false,
     "countryDK": "Dominikanske Republik",
     "cityDK": "Puerto Plata"
  }, {
     "name": "Pori Airport",
     "countryCode": "FI",
     "iata": "POR",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Pori"
  }, {
     "name": "Piarco International Airport",
     "countryCode": "TT",
     "iata": "POS",
     "eucustoms": false,
     "countryDK": "Trinidad og Tobago",
     "cityDK": "Port of Spain"
  }, {
     "name": "Ken Jones Airport",
     "countryCode": "JM",
     "iata": "POT",
     "eucustoms": false,
     "countryDK": "Jamaica",
     "cityDK": "Port Antonio"
  }, {
     "name": "Dutchess County Airport",
     "countryCode": "US",
     "iata": "POU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Poughkeepsie"
  }, {
     "name": "Presov Airport",
     "countryCode": "SK",
     "iata": "POV",
     "eucustoms": false,
     "countryDK": "Slovakiet",
     "cityDK": "Presov"
  }, {
     "name": "Portoroz Airport",
     "countryCode": "SI",
     "iata": "POW",
     "eucustoms": false,
     "countryDK": "Slovenien",
     "cityDK": "Portoroz"
  }, {
     "name": "Pontoise - Cormeilles Aerodrome",
     "countryCode": "FR",
     "iata": "POX",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Pontoise"
  }, {
     "name": "Powell/Lovell Airport",
     "countryCode": "US",
     "iata": "POY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Powell / Lovell"
  }, {
     "name": "Poznan Airport",
     "countryCode": "PL",
     "iata": "POZ",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Poznan"
  }, {
     "name": "Perry Lefors Field",
     "countryCode": "US",
     "iata": "PPA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pampa"
  }, {
     "name": "A. De Barros Airport",
     "countryCode": "BR",
     "iata": "PPB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Presidente Prudente"
  }, {
     "name": "Prospect Creek Airport",
     "countryCode": "US",
     "iata": "PPC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Prospect Creek"
  }, {
     "name": "Puerto Penasco Airport",
     "countryCode": "MX",
     "iata": "PPE",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Puerto Penasco"
  }, {
     "name": "Tri-City Airport",
     "countryCode": "US",
     "iata": "PPF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Parsons"
  }, {
     "name": "Pago Pago International Airport",
     "countryCode": "AS",
     "iata": "PPG",
     "eucustoms": false,
     "countryDK": "Amerikansk Samoa",
     "cityDK": "Pago Pago"
  }, {
     "name": "Port Pirie Airport",
     "countryCode": "AU",
     "iata": "PPI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Port Pirie"
  }, {
     "name": "Pompano Beach Airport",
     "countryCode": "US",
     "iata": "PPM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pompano Beach"
  }, {
     "name": "Guillermo Leon Valencia Airport",
     "countryCode": "CO",
     "iata": "PPN",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Popayan"
  }, {
     "name": "Whitsunday Coast Airport",
     "countryCode": "AU",
     "iata": "PPP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Proserpine"
  }, {
     "name": "Paraparaumu Airport",
     "countryCode": "NZ",
     "iata": "PPQ",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Paraparaumu"
  }, {
     "name": "Pasir Pangarayan Airport",
     "countryCode": "ID",
     "iata": "PPR",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Pasir Pangarayan"
  }, {
     "name": "Puerto Princesa International Airport",
     "countryCode": "PH",
     "iata": "PPS",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Puerto Princesa"
  }, {
     "name": "Tahiti Faa'a Airport",
     "countryCode": "PF",
     "iata": "PPT",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Papeete"
  }, {
     "name": "Papun Airport",
     "countryCode": "MM",
     "iata": "PPU",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Papun"
  }, {
     "name": "Papa Westray Airport",
     "countryCode": "GB",
     "iata": "PPW",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Papa Westray"
  }, {
     "name": "Pouso Alegre Airport",
     "countryCode": "BR",
     "iata": "PPY",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Pouso Alegre"
  }, {
     "name": "Phu Quoc International Airport",
     "countryCode": "VN",
     "iata": "PQC",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Phu Quoc"
  }, {
     "name": "Presque Isle Municipal Airport",
     "countryCode": "US",
     "iata": "PQI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Presque Isle"
  }, {
     "name": "Palenque International Airport",
     "countryCode": "MX",
     "iata": "PQM",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Palenque"
  }, {
     "name": "Port Macquarie Airport",
     "countryCode": "AU",
     "iata": "PQQ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Port Macquarie"
  }, {
     "name": "Qeqertaq Heliport",
     "countryCode": "GL",
     "iata": "PQT",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Qeqertaq"
  }, {
     "name": "General Justo Jose de Urquiza Airport",
     "countryCode": "AR",
     "iata": "PRA",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Parana"
  }, {
     "name": "Paso Robles Municipal Airport",
     "countryCode": "US",
     "iata": "PRB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Paso Robles"
  }, {
     "name": "Ernest A. Love Field",
     "countryCode": "US",
     "iata": "PRC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Prescott"
  }, {
     "name": "Vaclav Havel Airport Prague",
     "countryCode": "CZ",
     "iata": "PRG",
     "eucustoms": true,
     "countryDK": "Tjekkiet",
     "cityDK": "Prag"
  }, {
     "name": "Phrae Airport",
     "countryCode": "TH",
     "iata": "PRH",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Phrae"
  }, {
     "name": "Praslin Island Airport",
     "countryCode": "SC",
     "iata": "PRI",
     "eucustoms": false,
     "countryDK": "Seychellerne",
     "cityDK": "Praslin Island"
  }, {
     "name": "Prieska Airport",
     "countryCode": "ZA",
     "iata": "PRK",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Prieska"
  }, {
     "name": "Portimao Airport",
     "countryCode": "PT",
     "iata": "PRM",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Portimao"
  }, {
     "name": "Pristina International Airport",
     "countryCode": "RS",
     "iata": "PRN",
     "eucustoms": true,
     "countryDK": "Serbien",
     "cityDK": "Pristina"
  }, {
     "name": "Perry Municipal Airport",
     "countryCode": "US",
     "iata": "PRO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Perry"
  }, {
     "name": "Propriano Airport",
     "countryCode": "FR",
     "iata": "PRP",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Propriano"
  }, {
     "name": "Pres. Roque Saenz Pena Airport",
     "countryCode": "AR",
     "iata": "PRQ",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Pres. Roque Saenz Pena"
  }, {
     "name": "Prome Airport",
     "countryCode": "MM",
     "iata": "PRU",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Prome"
  }, {
     "name": "Cox Field",
     "countryCode": "US",
     "iata": "PRX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Paris"
  }, {
     "name": "Wonderboom Airport",
     "countryCode": "ZA",
     "iata": "PRY",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Pretoria"
  }, {
     "name": "Pisa International Airport",
     "countryCode": "IT",
     "iata": "PSA",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Pisa"
  }, {
     "name": "Mid-State Airport",
     "countryCode": "US",
     "iata": "PSB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Philipsburg"
  }, {
     "name": "Tri-Cities Airport",
     "countryCode": "US",
     "iata": "PSC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pasco"
  }, {
     "name": "Port Said Airport",
     "countryCode": "EG",
     "iata": "PSD",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Port sagde"
  }, {
     "name": "Mercedita Airport",
     "countryCode": "PR",
     "iata": "PSE",
     "eucustoms": false,
     "countryDK": "Puerto Rico",
     "cityDK": "Ponce"
  }, {
     "name": "Pittsfield Municipal Airport",
     "countryCode": "US",
     "iata": "PSF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pittsfield"
  }, {
     "name": "Petersburg Municipal Airport",
     "countryCode": "US",
     "iata": "PSG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Petersborg"
  }, {
     "name": "St. Peter Airport",
     "countryCode": "DE",
     "iata": "PSH",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Saint peter"
  }, {
     "name": "Pasni Airport",
     "countryCode": "PK",
     "iata": "PSI",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Pasni"
  }, {
     "name": "Kasiguncu Airport",
     "countryCode": "ID",
     "iata": "PSJ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Poso"
  }, {
     "name": "New River Valley Airport",
     "countryCode": "US",
     "iata": "PSK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dublin"
  }, {
     "name": "Perth International Airport",
     "countryCode": "GB",
     "iata": "PSL",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Perth"
  }, {
     "name": "Pease Air Force Base",
     "countryCode": "US",
     "iata": "PSM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Portsmouth"
  }, {
     "name": "Palestine Municipal Airport",
     "countryCode": "US",
     "iata": "PSN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Palæstina"
  }, {
     "name": "Cano Airport",
     "countryCode": "CO",
     "iata": "PSO",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Pasto"
  }, {
     "name": "Palm Springs International Airport",
     "countryCode": "US",
     "iata": "PSP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Palm Springs"
  }, {
     "name": "Abruzzo Airport",
     "countryCode": "IT",
     "iata": "PSR",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Pescara"
  }, {
     "name": "Posadas Airport",
     "countryCode": "AR",
     "iata": "PSS",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Posadas"
  }, {
     "name": "Pangsuma Airport",
     "countryCode": "ID",
     "iata": "PSU",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Putussibau"
  }, {
     "name": "Passos Airport",
     "countryCode": "BR",
     "iata": "PSW",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Passos"
  }, {
     "name": "Palacios Airport",
     "countryCode": "US",
     "iata": "PSX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Palacios"
  }, {
     "name": "Puerto Suarez Airport",
     "countryCode": "BO",
     "iata": "PSZ",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Puerto Suarez"
  }, {
     "name": "Dinwiddie County Airport",
     "countryCode": "US",
     "iata": "PTB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Petersborg"
  }, {
     "name": "Malolo Lailai Island Airport",
     "countryCode": "FJ",
     "iata": "PTF",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Malololailai"
  }, {
     "name": "Polokwane Airport",
     "countryCode": "ZA",
     "iata": "PTG",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Polokwane"
  }, {
     "name": "Port Heiden Airport",
     "countryCode": "US",
     "iata": "PTH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Port Heiden"
  }, {
     "name": "Portland Airport",
     "countryCode": "AU",
     "iata": "PTJ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Portland"
  }, {
     "name": "Oakland County International Airport",
     "countryCode": "US",
     "iata": "PTK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pontiac"
  }, {
     "name": "Palmarito Airport",
     "countryCode": "VE",
     "iata": "PTM",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Palmarito"
  }, {
     "name": "Patterson Municipal Heliport",
     "countryCode": "US",
     "iata": "PTN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Patterson"
  }, {
     "name": "Pato Branco Municipal Airport",
     "countryCode": "BR",
     "iata": "PTO",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Pato Branco"
  }, {
     "name": "Pointe-a-Pitre Le Raizet Airport",
     "countryCode": "GP",
     "iata": "PTP",
     "eucustoms": false,
     "countryDK": "Guadeloupe",
     "cityDK": "Pointe-à-Pitre"
  }, {
     "name": "Porto de Moz Airport",
     "countryCode": "BR",
     "iata": "PTQ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Porto de Moz"
  }, {
     "name": "Pittsburg Municipal Airport",
     "countryCode": "US",
     "iata": "PTS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pittsburg"
  }, {
     "name": "Pratt Airport",
     "countryCode": "US",
     "iata": "PTT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pratt"
  }, {
     "name": "Platinum Airport",
     "countryCode": "US",
     "iata": "PTU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "platin"
  }, {
     "name": "Porterville Airport",
     "countryCode": "US",
     "iata": "PTV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Porterville"
  }, {
     "name": "Heritage Field",
     "countryCode": "US",
     "iata": "PTW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pottstown"
  }, {
     "name": "Pitalito Airport",
     "countryCode": "CO",
     "iata": "PTX",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Pitalito"
  }, {
     "name": "Tocumen International Airport",
     "countryCode": "PA",
     "iata": "PTY",
     "eucustoms": false,
     "countryDK": "Panama",
     "cityDK": "Panama City"
  }, {
     "name": "Pastaza Airport",
     "countryCode": "EC",
     "iata": "PTZ",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Pastaza"
  }, {
     "name": "Pueblo Memorial Airport",
     "countryCode": "US",
     "iata": "PUB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pueblo"
  }, {
     "name": "Carbon County Regional Airport",
     "countryCode": "US",
     "iata": "PUC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pris"
  }, {
     "name": "Puerto Deseado Airport",
     "countryCode": "AR",
     "iata": "PUD",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Puerto Deseado"
  }, {
     "name": "Puerto Obaldia Airport",
     "countryCode": "PA",
     "iata": "PUE",
     "eucustoms": false,
     "countryDK": "Panama",
     "cityDK": "Puerto Obaldia"
  }, {
     "name": "The Pau-Pyrenees International Airport",
     "countryCode": "FR",
     "iata": "PUF",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Pau"
  }, {
     "name": "Port Augusta Airport",
     "countryCode": "AU",
     "iata": "PUG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Port Augusta"
  }, {
     "name": "Punta Cana International Airport",
     "countryCode": "DO",
     "iata": "PUJ",
     "eucustoms": false,
     "countryDK": "Dominikanske Republik",
     "cityDK": "Punta Cana"
  }, {
     "name": "Pukarua Airport",
     "countryCode": "PF",
     "iata": "PUK",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Pukarua, Tuamoto Island"
  }, {
     "name": "Punia Airport",
     "countryCode": "CD",
     "iata": "PUN",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Punia"
  }, {
     "name": "Prudhoe Bay Airport",
     "countryCode": "US",
     "iata": "PUO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Prudhoe Bay"
  }, {
     "name": "Pres Ibanez Airport",
     "countryCode": "CL",
     "iata": "PUQ",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Punta Arenas"
  }, {
     "name": "Gimhae International Airport",
     "countryCode": "KR",
     "iata": "PUS",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Busan"
  }, {
     "name": "Puerto Asis Airport",
     "countryCode": "CO",
     "iata": "PUU",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Puerto Asis"
  }, {
     "name": "Pullman-Moscow Regional Airport",
     "countryCode": "US",
     "iata": "PUW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pullman"
  }, {
     "name": "Pula Airport",
     "countryCode": "HR",
     "iata": "PUY",
     "eucustoms": true,
     "countryDK": "Kroatien",
     "cityDK": "Pula"
  }, {
     "name": "Puerto Cabezas Airport",
     "countryCode": "NI",
     "iata": "PUZ",
     "eucustoms": false,
     "countryDK": "Nicaragua",
     "cityDK": "Puerto Cabezas"
  }, {
     "name": "Providencia Airport",
     "countryCode": "CO",
     "iata": "PVA",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Providencia"
  }, {
     "name": "Provincetown Airport",
     "countryCode": "US",
     "iata": "PVC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Provincetown"
  }, {
     "name": "Theodore Francis Green Memorial State Airport",
     "countryCode": "US",
     "iata": "PVD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Providence"
  }, {
     "name": "Placerville Airport",
     "countryCode": "US",
     "iata": "PVF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Placerville"
  }, {
     "name": "Shanghai Pudong International Airport",
     "countryCode": "CN",
     "iata": "PVG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Shanghai"
  }, {
     "name": "Porto Velho International Airport",
     "countryCode": "BR",
     "iata": "PVH",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Porto Velho"
  }, {
     "name": "Paranavia Airport",
     "countryCode": "BR",
     "iata": "PVI",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Paranavia"
  }, {
     "name": "Aktion Airport",
     "countryCode": "GR",
     "iata": "PVK",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Preveza"
  }, {
     "name": "Portoviejo Airport",
     "countryCode": "EC",
     "iata": "PVO",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Portoviejo"
  }, {
     "name": "Gustavo Diaz Ordaz International Airport",
     "countryCode": "MX",
     "iata": "PVR",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Puerto Vallarta"
  }, {
     "name": "Provideniya Bay Airport",
     "countryCode": "RU",
     "iata": "PVS",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Provideniya"
  }, {
     "name": "Provo Airport",
     "countryCode": "US",
     "iata": "PVU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Provo"
  }, {
     "name": "Hale County Airport",
     "countryCode": "US",
     "iata": "PVW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Plainview"
  }, {
     "name": "Casement Airport",
     "countryCode": "US",
     "iata": "PVZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Painesville"
  }, {
     "name": "Wiley Post Airport",
     "countryCode": "US",
     "iata": "PWA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oklahoma City"
  }, {
     "name": "Sherwood Airport",
     "countryCode": "US",
     "iata": "PWD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Plentywood"
  }, {
     "name": "Chicago Executive Airport",
     "countryCode": "US",
     "iata": "PWK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chicago"
  }, {
     "name": "Portland International Jetport",
     "countryCode": "US",
     "iata": "PWM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Portland"
  }, {
     "name": "Pweto Airport",
     "countryCode": "CD",
     "iata": "PWO",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Pweto"
  }, {
     "name": "Pavlodar Airport",
     "countryCode": "KZ",
     "iata": "PWQ",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Pavlodar"
  }, {
     "name": "Bremerton National Airport",
     "countryCode": "US",
     "iata": "PWT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bremerton"
  }, {
     "name": "Prominent Hill Airport",
     "countryCode": "AU",
     "iata": "PXH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Prominent Hill Mine"
  }, {
     "name": "Puerto Escondido Airport",
     "countryCode": "MX",
     "iata": "PXM",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Puerto Escondido"
  }, {
     "name": "Porto Santo Airport",
     "countryCode": "PT",
     "iata": "PXO",
     "eucustoms": true,
     "countryDK": "Portugal",
     "cityDK": "Porto Santo (Madeira)"
  }, {
     "name": "Pleiku Airport",
     "countryCode": "VN",
     "iata": "PXU",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Pleiku"
  }, {
     "name": "Penrhyn Island Airport",
     "countryCode": "CK",
     "iata": "PYE",
     "eucustoms": false,
     "countryDK": "Cookøerne",
     "cityDK": "Penrhyn Island"
  }, {
     "name": "Pakyong Airport",
     "countryCode": "IN",
     "iata": "PYG",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Pakyong"
  }, {
     "name": "Puerto Ayacucho Airport",
     "countryCode": "VE",
     "iata": "PYH",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Puerto Ayacucho"
  }, {
     "name": "Polyarnyj Airport",
     "countryCode": "RU",
     "iata": "PYJ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Polyarnyj"
  }, {
     "name": "Plymouth Municipal Airport",
     "countryCode": "US",
     "iata": "PYM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Plymouth"
  }, {
     "name": "Andravida Air Base",
     "countryCode": "GR",
     "iata": "PYR",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Pyrgos"
  }, {
     "name": "Pai Airport",
     "countryCode": "TH",
     "iata": "PYY",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Pai"
  }, {
     "name": "Casanare Airport",
     "countryCode": "CO",
     "iata": "PZA",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Paz De Ariporo"
  }, {
     "name": "Pietermaritzburg Airport",
     "countryCode": "ZA",
     "iata": "PZB",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Pietermaritzburg"
  }, {
     "name": "Penzance Heliport",
     "countryCode": "GB",
     "iata": "PZE",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Penzance"
  }, {
     "name": "Zhob Airport",
     "countryCode": "PK",
     "iata": "PZH",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Zhob"
  }, {
     "name": "Pukapuka Island Airport",
     "countryCode": "CK",
     "iata": "PZK",
     "eucustoms": false,
     "countryDK": "Cookøerne",
     "cityDK": "Pukapuka Atoll"
  }, {
     "name": "Zulu Inyala Airport",
     "countryCode": "ZA",
     "iata": "PZL",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Phinda"
  }, {
     "name": "Manuel Carlos Piar Guayana Airport",
     "countryCode": "VE",
     "iata": "PZO",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Puerto Ordaz"
  }, {
     "name": "Port Sudan Airport",
     "countryCode": "SD",
     "iata": "PZU",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Port Sudan"
  }, {
     "name": "Piestany Airport",
     "countryCode": "SK",
     "iata": "PZY",
     "eucustoms": false,
     "countryDK": "Slovakiet",
     "cityDK": "Piestany"
  }, {
     "name": "Castro",
     "countryCode": "BR",
     "iata": "QAC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Castro"
  }, {
     "name": "Barbacena",
     "countryCode": "BR",
     "iata": "QAK",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Barbacena"
  }, {
     "name": "Bella Coola Airport",
     "countryCode": "CA",
     "iata": "QBC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Bella Coola"
  }, {
     "name": "Sobral",
     "countryCode": "BR",
     "iata": "QBX",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sobral"
  }, {
     "name": "Botucatu",
     "countryCode": "BR",
     "iata": "QCJ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Botucatu"
  }, {
     "name": "Canela",
     "countryCode": "BR",
     "iata": "QCN",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Canela"
  }, {
     "name": "Currais Novos",
     "countryCode": "BR",
     "iata": "QCP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Currais Novos"
  }, {
     "name": "Curitibanos",
     "countryCode": "BR",
     "iata": "QCR",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Curitibanos"
  }, {
     "name": "Cachoeira Do Sul",
     "countryCode": "BR",
     "iata": "QDB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Cachoeira Do Sul"
  }, {
     "name": "Dracena",
     "countryCode": "BR",
     "iata": "QDC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Dracena"
  }, {
     "name": "Conselheiro Lafaiete",
     "countryCode": "BR",
     "iata": "QDF",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Conselheiro Lafaiete"
  }, {
     "name": "Dom Pedrito",
     "countryCode": "BR",
     "iata": "QDP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Dom Pedrito"
  }, {
     "name": "Jundiai Airport",
     "countryCode": "BR",
     "iata": "QDV",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Jundiai"
  }, {
     "name": "Eqalugaarsuit Heliport",
     "countryCode": "GL",
     "iata": "QFG",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Eqalugaarsuit"
  }, {
     "name": "Iginniarfik Heliport",
     "countryCode": "GL",
     "iata": "QFI",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Iginniarfik"
  }, {
     "name": "Narsaq Kujalleq Heliport",
     "countryCode": "GL",
     "iata": "QFN",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Narsaq Kujalleq"
  }, {
     "name": "Qassiarsuk Heliport",
     "countryCode": "GL",
     "iata": "QFT",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Qassiarsuk"
  }, {
     "name": "Igaliku Heliport",
     "countryCode": "GL",
     "iata": "QFX",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Igaliku"
  }, {
     "name": "Guaira",
     "countryCode": "BR",
     "iata": "QGA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Guaira"
  }, {
     "name": "Lencois Paulista",
     "countryCode": "BR",
     "iata": "QGC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Lencois Paulista"
  }, {
     "name": "Montenegro",
     "countryCode": "BR",
     "iata": "QGF",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Montenegro"
  }, {
     "name": "Garanhuns",
     "countryCode": "BR",
     "iata": "QGP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Garanhuns"
  }, {
     "name": "Gifu Airport",
     "countryCode": "JP",
     "iata": "QGU",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Gifu"
  }, {
     "name": "Piracicaba",
     "countryCode": "BR",
     "iata": "QHB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Piracicaba"
  }, {
     "name": "Taguatinga",
     "countryCode": "BR",
     "iata": "QHN",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Taguatinga"
  }, {
     "name": "Novo Hamburgo",
     "countryCode": "BR",
     "iata": "QHV",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Novo Hamburgo"
  }, {
     "name": "Mello Viana",
     "countryCode": "BR",
     "iata": "QID",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Tres Coracoes"
  }, {
     "name": "Iguatu",
     "countryCode": "BR",
     "iata": "QIG",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Iguatu"
  }, {
     "name": "Rio Claro",
     "countryCode": "BR",
     "iata": "QIQ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Rio Claro"
  }, {
     "name": "Itapetinga",
     "countryCode": "BR",
     "iata": "QIT",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Itapetinga"
  }, {
     "name": "Kitsissuarsuit Heliport",
     "countryCode": "GL",
     "iata": "QJE",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Kitsissuarsuit"
  }, {
     "name": "Qassimiut Heliport",
     "countryCode": "GL",
     "iata": "QJH",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Qassimiut"
  }, {
     "name": "Lasham Airfield",
     "countryCode": "GB",
     "iata": "QLA",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Lasham"
  }, {
     "name": "Mafra",
     "countryCode": "BR",
     "iata": "QMF",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Mafra"
  }, {
     "name": "Canoas Ab",
     "countryCode": "BR",
     "iata": "QNS",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Porto Alegre"
  }, {
     "name": "Aeroclube Nova Iguacu",
     "countryCode": "BR",
     "iata": "QNV",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Nova Iguacu"
  }, {
     "name": "Mococa",
     "countryCode": "BR",
     "iata": "QOA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Mococa"
  }, {
     "name": "Sao Borja",
     "countryCode": "BR",
     "iata": "QOJ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Borja"
  }, {
     "name": "Saarloq Heliport",
     "countryCode": "GL",
     "iata": "QOQ",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Saarloq"
  }, {
     "name": "Paya Lebar Airport",
     "countryCode": "SG",
     "iata": "QPG",
     "eucustoms": false,
     "countryDK": "Singapore",
     "cityDK": "Singapore"
  }, {
     "name": "Strausberg Airport",
     "countryCode": "DE",
     "iata": "QPK",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Strausberg"
  }, {
     "name": "Randgermiston Airport",
     "countryCode": "ZA",
     "iata": "QRA",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Johannesburg"
  }, {
     "name": "De La Independencia",
     "countryCode": "CL",
     "iata": "QRC",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Rancagua"
  }, {
     "name": "Carazinho",
     "countryCode": "BR",
     "iata": "QRE",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Carazinho"
  }, {
     "name": "Narromine",
     "countryCode": "AU",
     "iata": "QRM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Narromine"
  }, {
     "name": "Queretaro Intercontinental Airport",
     "countryCode": "MX",
     "iata": "QRO",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Queretaro"
  }, {
     "name": "Warren",
     "countryCode": "AU",
     "iata": "QRR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Warren"
  }, {
     "name": "Osubi Airstrip",
     "countryCode": "NG",
     "iata": "QRW",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Warri"
  }, {
     "name": "Ikerasaarsuk Heliport",
     "countryCode": "GL",
     "iata": "QRY",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Ikerasaarsuk"
  }, {
     "name": "Mario Pereira Lopes State Airport",
     "countryCode": "BR",
     "iata": "QSC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Carlos"
  }, {
     "name": "Uetersen Airport",
     "countryCode": "DE",
     "iata": "QSM",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Uetersen"
  }, {
     "name": "Ubari Airport",
     "countryCode": "LY",
     "iata": "QUB",
     "eucustoms": false,
     "countryDK": "Libyen",
     "cityDK": "Ubari"
  }, {
     "name": "Goodwood",
     "countryCode": "GB",
     "iata": "QUG",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Chichester"
  }, {
     "name": "A-306",
     "countryCode": "KR",
     "iata": "QUN",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Chunchon"
  }, {
     "name": "Akwa Ibom Airport",
     "countryCode": "NG",
     "iata": "QUO",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Uyo"
  }, {
     "name": "Saqqaq Heliport",
     "countryCode": "GL",
     "iata": "QUP",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Saqqaq"
  }, {
     "name": "Utsunomiya Aero",
     "countryCode": "JP",
     "iata": "QUT",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Utsunomiya"
  }, {
     "name": "Aappilattoq-Nanortalik Heliport",
     "countryCode": "GL",
     "iata": "QUV",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Aappilattoq"
  }, {
     "name": "Ammassivik Heliport",
     "countryCode": "GL",
     "iata": "QUW",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Ammassivik"
  }, {
     "name": "Uniao Da Vitoria",
     "countryCode": "BR",
     "iata": "QVB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Uniao Da Vitoria"
  }, {
     "name": "Avare-Arandu",
     "countryCode": "BR",
     "iata": "QVP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Avare"
  }, {
     "name": "Caxias",
     "countryCode": "BR",
     "iata": "QXC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Caxias"
  }, {
     "name": "Cachoeiro Do Itapemirim",
     "countryCode": "BR",
     "iata": "QXD",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Cachoeiro Do Itapemirim"
  }, {
     "name": "Tokua Airport",
     "countryCode": "PG",
     "iata": "RAB",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Rabaul"
  }, {
     "name": "Horlick Airport",
     "countryCode": "US",
     "iata": "RAC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Racine"
  }, {
     "name": "Arar Airport",
     "countryCode": "SA",
     "iata": "RAE",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Arar"
  }, {
     "name": "Raglan Airfield",
     "countryCode": "NZ",
     "iata": "RAG",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Raglan"
  }, {
     "name": "Rafha Airport",
     "countryCode": "SA",
     "iata": "RAH",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Rafha"
  }, {
     "name": "Nelson Mandela International Airport",
     "countryCode": "CV",
     "iata": "RAI",
     "eucustoms": false,
     "countryDK": "Kap Verde",
     "cityDK": "Praia"
  }, {
     "name": "Civil Airport",
     "countryCode": "IN",
     "iata": "RAJ",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Rajkot"
  }, {
     "name": "Menara Airport",
     "countryCode": "MA",
     "iata": "RAK",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Marrakech"
  }, {
     "name": "Riverside Municipal Airport",
     "countryCode": "US",
     "iata": "RAL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "flodbred"
  }, {
     "name": "Ramingining Airport",
     "countryCode": "AU",
     "iata": "RAM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ramingining"
  }, {
     "name": "La Spreta Airport",
     "countryCode": "IT",
     "iata": "RAN",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Ravenna"
  }, {
     "name": "Dr. Leite Lopes State Airport",
     "countryCode": "BR",
     "iata": "RAO",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Ribeirao Preto"
  }, {
     "name": "Rapid City Regional Airport",
     "countryCode": "US",
     "iata": "RAP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rapid City"
  }, {
     "name": "Rarotonga Airport",
     "countryCode": "CK",
     "iata": "RAR",
     "eucustoms": false,
     "countryDK": "Cookøerne",
     "cityDK": "Rarotonga"
  }, {
     "name": "Rasht Airport",
     "countryCode": "IR",
     "iata": "RAS",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Rasht"
  }, {
     "name": "Raduzhnyi Airport",
     "countryCode": "RU",
     "iata": "RAT",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Raduzhnyi"
  }, {
     "name": "Cravo Norte Airport",
     "countryCode": "CO",
     "iata": "RAV",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Cravo Norte"
  }, {
     "name": "Rawala Kot Airport",
     "countryCode": "PK",
     "iata": "RAZ",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Rawala Kot"
  }, {
     "name": "Sale Airport",
     "countryCode": "MA",
     "iata": "RBA",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Rabat"
  }, {
     "name": "Borba Airport",
     "countryCode": "BR",
     "iata": "RBB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Borba"
  }, {
     "name": "Robinvale Airport",
     "countryCode": "AU",
     "iata": "RBC",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Robinvale"
  }, {
     "name": "Dallas Executive Airport",
     "countryCode": "US",
     "iata": "RBD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Dallas"
  }, {
     "name": "Ratanakiri Airport",
     "countryCode": "KH",
     "iata": "RBE",
     "eucustoms": false,
     "countryDK": "Cambodja",
     "cityDK": "Ratanakiri"
  }, {
     "name": "Roseburg Regional Airport",
     "countryCode": "US",
     "iata": "RBG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Roseburg"
  }, {
     "name": "Rebun Airport",
     "countryCode": "JP",
     "iata": "RBJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Rebun"
  }, {
     "name": "Red Bluff Municipal Airport",
     "countryCode": "US",
     "iata": "RBL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Red Bluff"
  }, {
     "name": "Wallmuhle Airport",
     "countryCode": "DE",
     "iata": "RBM",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Straubing"
  }, {
     "name": "Robore Airport",
     "countryCode": "BO",
     "iata": "RBO",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Robore"
  }, {
     "name": "Rurrenabaque Airport",
     "countryCode": "BO",
     "iata": "RBQ",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Rurrenabaque"
  }, {
     "name": "Pres. Medici Airport",
     "countryCode": "BR",
     "iata": "RBR",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Rio Branco"
  }, {
     "name": "Orbost Airport",
     "countryCode": "AU",
     "iata": "RBS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Orbost"
  }, {
     "name": "Marsabit Airport",
     "countryCode": "KE",
     "iata": "RBT",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Marsabit"
  }, {
     "name": "Lowcountry Regional Airport",
     "countryCode": "US",
     "iata": "RBW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Walterboro"
  }, {
     "name": "Ruby Airport",
     "countryCode": "US",
     "iata": "RBY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rubin"
  }, {
     "name": "Ellsworth Air Force Base",
     "countryCode": "US",
     "iata": "RCA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rapid City"
  }, {
     "name": "Richards Bay Airport",
     "countryCode": "ZA",
     "iata": "RCB",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Richards Bay"
  }, {
     "name": "Riohacha Airport",
     "countryCode": "CO",
     "iata": "RCH",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Riohacha"
  }, {
     "name": "Coffield Airport",
     "countryCode": "US",
     "iata": "RCK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rockdale"
  }, {
     "name": "Redcliffe Airport",
     "countryCode": "VU",
     "iata": "RCL",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Redcliffe"
  }, {
     "name": "Richmond Airport",
     "countryCode": "AU",
     "iata": "RCM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Richmond"
  }, {
     "name": "Saint Agnant Airport",
     "countryCode": "FR",
     "iata": "RCO",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Rochefort"
  }, {
     "name": "Reconquista Airport",
     "countryCode": "AR",
     "iata": "RCQ",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Reconquista"
  }, {
     "name": "Fulton County Airport",
     "countryCode": "US",
     "iata": "RCR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rochester"
  }, {
     "name": "Rochester Airport",
     "countryCode": "GB",
     "iata": "RCS",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Rochester"
  }, {
     "name": "Nartron Field",
     "countryCode": "US",
     "iata": "RCT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Reed City"
  }, {
     "name": "Las Higueras Airport",
     "countryCode": "AR",
     "iata": "RCU",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Rio Cuarto"
  }, {
     "name": "New Port Nelson Airport",
     "countryCode": "BS",
     "iata": "RCY",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Rum Cay"
  }, {
     "name": "Redencao Airport",
     "countryCode": "BR",
     "iata": "RDC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Redencao"
  }, {
     "name": "Redding Municipal Airport",
     "countryCode": "US",
     "iata": "RDD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Redding"
  }, {
     "name": "Reading Regional Airport",
     "countryCode": "US",
     "iata": "RDG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Reading"
  }, {
     "name": "Roberts Field",
     "countryCode": "US",
     "iata": "RDM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Redmond"
  }, {
     "name": "Radom Airport",
     "countryCode": "PL",
     "iata": "RDO",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Radom"
  }, {
     "name": "Kazi Nazrul Islam Airport",
     "countryCode": "IN",
     "iata": "RDP",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Andal"
  }, {
     "name": "Grand Forks Air Force Base",
     "countryCode": "US",
     "iata": "RDR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Red River"
  }, {
     "name": "Richard Toll Airport",
     "countryCode": "SN",
     "iata": "RDT",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Richard Toll"
  }, {
     "name": "Raleigh-Durham International Airport",
     "countryCode": "US",
     "iata": "RDU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Raleigh / Durham"
  }, {
     "name": "Marcillac Airport",
     "countryCode": "FR",
     "iata": "RDZ",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Rodez"
  }, {
     "name": "Reao Airport",
     "countryCode": "PF",
     "iata": "REA",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Reao, Tuamoto Island"
  }, {
     "name": "Guararapes-Gilberto Freyre International Airport",
     "countryCode": "BR",
     "iata": "REC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Recife"
  }, {
     "name": "Mifflin County Airport",
     "countryCode": "US",
     "iata": "RED",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Reedsville"
  }, {
     "name": "Tito Menniti Airport",
     "countryCode": "IT",
     "iata": "REG",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Reggio Calabria"
  }, {
     "name": "Trelew Airport",
     "countryCode": "AR",
     "iata": "REL",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Trelew"
  }, {
     "name": "Orenburg Airport",
     "countryCode": "RU",
     "iata": "REN",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Orenburg"
  }, {
     "name": "Rome State Airport",
     "countryCode": "US",
     "iata": "REO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rom"
  }, {
     "name": "Siem Reap International Airport",
     "countryCode": "KH",
     "iata": "REP",
     "eucustoms": false,
     "countryDK": "Cambodja",
     "cityDK": "Siem Reap"
  }, {
     "name": "Retalhuleu Airport",
     "countryCode": "GT",
     "iata": "RER",
     "eucustoms": false,
     "countryDK": "Guatemala",
     "cityDK": "Retalhuleu"
  }, {
     "name": "Resistencia Airport",
     "countryCode": "AR",
     "iata": "RES",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Resistencia"
  }, {
     "name": "Rost Airport",
     "countryCode": "NO",
     "iata": "RET",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Rost"
  }, {
     "name": "Reus Airport",
     "countryCode": "ES",
     "iata": "REU",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Reus"
  }, {
     "name": "Gen Lucio Blanco International Airport",
     "countryCode": "MX",
     "iata": "REX",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Reynosa"
  }, {
     "name": "Reyes Airport",
     "countryCode": "BO",
     "iata": "REY",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Reyes"
  }, {
     "name": "Chicago Rockford International Airport",
     "countryCode": "US",
     "iata": "RFD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rockford"
  }, {
     "name": "Rooke Field",
     "countryCode": "US",
     "iata": "RFG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Refugio"
  }, {
     "name": "Raufarhofn Airport",
     "countryCode": "IS",
     "iata": "RFN",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Raufarhofn"
  }, {
     "name": "Raiatea Airport",
     "countryCode": "PF",
     "iata": "RFP",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Raiatea"
  }, {
     "name": "Rio Grande Airport",
     "countryCode": "AR",
     "iata": "RGA",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Rio Grande"
  }, {
     "name": "Rangiroa Airport",
     "countryCode": "PF",
     "iata": "RGI",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Rangiroa"
  }, {
     "name": "Gorno-Altaysk Airport",
     "countryCode": "RU",
     "iata": "RGK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Gorno- Altaysk"
  }, {
     "name": "Rio Gallegos Internacional Airport",
     "countryCode": "AR",
     "iata": "RGL",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Rio Gallegos"
  }, {
     "name": "Yangon International Airport",
     "countryCode": "MM",
     "iata": "RGN",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Yangon"
  }, {
     "name": "Japura Airport",
     "countryCode": "ID",
     "iata": "RGT",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Rengat"
  }, {
     "name": "Reims Airport",
     "countryCode": "FR",
     "iata": "RHE",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Reims"
  }, {
     "name": "Ruhengeri Airport",
     "countryCode": "RW",
     "iata": "RHG",
     "eucustoms": false,
     "countryDK": "Rwanda",
     "cityDK": "Ruhengeri"
  }, {
     "name": "Oneida County Airport",
     "countryCode": "US",
     "iata": "RHI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rhinelander"
  }, {
     "name": "Rhodos Airport",
     "countryCode": "GR",
     "iata": "RHO",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Rhodos"
  }, {
     "name": "Ramechhap Airport",
     "countryCode": "NP",
     "iata": "RHP",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Ramechhap"
  }, {
     "name": "Reid-Hillview Airport",
     "countryCode": "US",
     "iata": "RHV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Jose"
  }, {
     "name": "Santa Maria Airport",
     "countryCode": "BR",
     "iata": "RIA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Santa Maria"
  }, {
     "name": "Gen Buech Airport",
     "countryCode": "BO",
     "iata": "RIB",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Riberalta"
  }, {
     "name": "Richmond International Airport (Byrd Field)",
     "countryCode": "US",
     "iata": "RIC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Richmond"
  }, {
     "name": "Richmond Airport",
     "countryCode": "US",
     "iata": "RID",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Richmond"
  }, {
     "name": "Rice Lake Regional Airport-Carl's Field",
     "countryCode": "US",
     "iata": "RIE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rice Lake"
  }, {
     "name": "Reynolds Airport",
     "countryCode": "US",
     "iata": "RIF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Richfield"
  }, {
     "name": "Rio Grande Airport",
     "countryCode": "BR",
     "iata": "RIG",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Rio Grande"
  }, {
     "name": "Scarlett Martinez International Airport",
     "countryCode": "PA",
     "iata": "RIH",
     "eucustoms": false,
     "countryDK": "Panama",
     "cityDK": "Rio Hato"
  }, {
     "name": "Juan Simons Vela Airport",
     "countryCode": "PE",
     "iata": "RIJ",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Rioja"
  }, {
     "name": "Garfield County Airport",
     "countryCode": "US",
     "iata": "RIL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Riffel"
  }, {
     "name": "Rodriguez De Mendoza Airport",
     "countryCode": "PE",
     "iata": "RIM",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Rodriguez De Mendoza"
  }, {
     "name": "Riverside Flabob Airport",
     "countryCode": "US",
     "iata": "RIR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "flodbred"
  }, {
     "name": "Rishiri Airport",
     "countryCode": "JP",
     "iata": "RIS",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Rishiri"
  }, {
     "name": "March Air Reserve Base",
     "countryCode": "US",
     "iata": "RIV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "flodbred"
  }, {
     "name": "Riverton Airport",
     "countryCode": "US",
     "iata": "RIW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Riverton"
  }, {
     "name": "Riga International Airport",
     "countryCode": "LV",
     "iata": "RIX",
     "eucustoms": false,
     "countryDK": "Letland",
     "cityDK": "Riga"
  }, {
     "name": "Riyan Airport",
     "countryCode": "YE",
     "iata": "RIY",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Riyan"
  }, {
     "name": "Rajahmundry Airport",
     "countryCode": "IN",
     "iata": "RJA",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Rajahmundry"
  }, {
     "name": "Rajbiraj Airport",
     "countryCode": "NP",
     "iata": "RJB",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Rajbiraj"
  }, {
     "name": "Rajshahi Airport",
     "countryCode": "BD",
     "iata": "RJH",
     "eucustoms": false,
     "countryDK": "Bangladesh",
     "cityDK": "Rajshahi"
  }, {
     "name": "Rijeka Airport",
     "countryCode": "HR",
     "iata": "RJK",
     "eucustoms": false,
     "countryDK": "Kroatien",
     "cityDK": "Rijeka"
  }, {
     "name": "Rafsanjan Airport",
     "countryCode": "IR",
     "iata": "RJN",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Rafsanjan"
  }, {
     "name": "Iwakuni Kintaikyo Airport",
     "countryCode": "JP",
     "iata": "IWK",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Iwakuni"
  }, {
     "name": "Aratika-Nord Airport",
     "countryCode": "PF",
     "iata": "RKA",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Aratika"
  }, {
     "name": "Knox County Regional Airport",
     "countryCode": "US",
     "iata": "RKD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rockland"
  }, {
     "name": "Roskilde Airport",
     "countryCode": "DK",
     "iata": "RKE",
     "eucustoms": false,
     "countryDK": "Danmark",
     "cityDK": "København"
  }, {
     "name": "York County Airport-Bryant Field",
     "countryCode": "US",
     "iata": "RKH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rock Hill"
  }, {
     "name": "Aransas County Airport",
     "countryCode": "US",
     "iata": "RKP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rockport"
  }, {
     "name": "Robert S. Kerr Airport",
     "countryCode": "US",
     "iata": "RKR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Poteau"
  }, {
     "name": "Rock Springs-Sweetwater County Airport",
     "countryCode": "US",
     "iata": "RKS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rock Springs"
  }, {
     "name": "Ras Al Khaimah International Airport",
     "countryCode": "AE",
     "iata": "RKT",
     "eucustoms": false,
     "countryDK": "Forenede Arabiske Emirater",
     "cityDK": "Ras al-Khaimah"
  }, {
     "name": "Seosan Airport",
     "countryCode": "KR",
     "iata": "HMY",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Seosan"
  }, {
     "name": "Reykjavik International Airport",
     "countryCode": "IS",
     "iata": "RKV",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Reykjavik"
  }, {
     "name": "Rockwood Municipal Airport",
     "countryCode": "US",
     "iata": "RKW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rockwood"
  }, {
     "name": "Shigatse Peace Airport",
     "countryCode": "CN",
     "iata": "RKZ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Shigatse"
  }, {
     "name": "Rolla Downtown Airport",
     "countryCode": "US",
     "iata": "RLA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rolla"
  }, {
     "name": "Richland Airport",
     "countryCode": "US",
     "iata": "RLD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Richland"
  }, {
     "name": "Laage Airport",
     "countryCode": "DE",
     "iata": "RLG",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Rostock-Laage"
  }, {
     "name": "Valle del Conlara Airport",
     "countryCode": "AR",
     "iata": "RLO",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Santa Rose de Conlara"
  }, {
     "name": "Roma Airport",
     "countryCode": "AU",
     "iata": "RMA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Roma"
  }, {
     "name": "Griffiss International Airport",
     "countryCode": "US",
     "iata": "RME",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rom"
  }, {
     "name": "Marsa Alam International Airport",
     "countryCode": "EG",
     "iata": "RMF",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Marsa Alam"
  }, {
     "name": "Richard B Russell Airport",
     "countryCode": "US",
     "iata": "RMG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rom"
  }, {
     "name": "Miramare Airport",
     "countryCode": "IT",
     "iata": "RMI",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Rimini"
  }, {
     "name": "Renmark Airport",
     "countryCode": "AU",
     "iata": "RMK",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Renmark"
  }, {
     "name": "Ratmalana Airport",
     "countryCode": "LK",
     "iata": "RML",
     "eucustoms": false,
     "countryDK": "Sri Lanka",
     "cityDK": "Colombo"
  }, {
     "name": "Taichung International Airport",
     "countryCode": "TW",
     "iata": "RMQ",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Shalu"
  }, {
     "name": "Ramstein Air Base",
     "countryCode": "DE",
     "iata": "RMS",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Ramstein"
  }, {
     "name": "Rimatara Airport",
     "countryCode": "PF",
     "iata": "RMT",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Rimatara"
  }, {
     "name": "Kallinge Airport",
     "countryCode": "SE",
     "iata": "RNB",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Ronneby"
  }, {
     "name": "Warren County Memorial Airport",
     "countryCode": "US",
     "iata": "RNC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "McMinnville"
  }, {
     "name": "Randolph Air Force Base",
     "countryCode": "US",
     "iata": "RND",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Antonio"
  }, {
     "name": "Renaison Airport",
     "countryCode": "FR",
     "iata": "RNE",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Roanne"
  }, {
     "name": "New Richmond Municipal Airport",
     "countryCode": "US",
     "iata": "RNH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "New Richmond"
  }, {
     "name": "Yoron Airport",
     "countryCode": "JP",
     "iata": "RNJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Yoronjima"
  }, {
     "name": "Qarn Alam Airport",
     "countryCode": "OM",
     "iata": "RNM",
     "eucustoms": false,
     "countryDK": "Oman",
     "cityDK": "Qarn Alam"
  }, {
     "name": "Bornholm Airport",
     "countryCode": "DK",
     "iata": "RNN",
     "eucustoms": true,
     "countryDK": "Danmark",
     "cityDK": "Bornholm"
  }, {
     "name": "Reno/Tahoe International Airport",
     "countryCode": "US",
     "iata": "RNO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Reno"
  }, {
     "name": "Rennes Airport",
     "countryCode": "FR",
     "iata": "RNS",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Rennes"
  }, {
     "name": "Renton Municipal Airport",
     "countryCode": "US",
     "iata": "RNT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Renton"
  }, {
     "name": "Rensselaer Airport",
     "countryCode": "US",
     "iata": "RNZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rensselaer"
  }, {
     "name": "Roanoke-Blacksburg Regional Airport",
     "countryCode": "US",
     "iata": "ROA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Roanoke"
  }, {
     "name": "Roberts International Airport",
     "countryCode": "LR",
     "iata": "ROB",
     "eucustoms": false,
     "countryDK": "Liberia",
     "cityDK": "Monrovia"
  }, {
     "name": "Greater Rochester International Airport",
     "countryCode": "US",
     "iata": "ROC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rochester"
  }, {
     "name": "Robertson Airport",
     "countryCode": "ZA",
     "iata": "ROD",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Robertson"
  }, {
     "name": "Rogers Municipal Airport - Carter Field",
     "countryCode": "US",
     "iata": "ROG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rogers"
  }, {
     "name": "Roi Et Airport",
     "countryCode": "TH",
     "iata": "ROI",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Roi Et"
  }, {
     "name": "Rockhampton Airport",
     "countryCode": "AU",
     "iata": "ROK",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Rockhampton"
  }, {
     "name": "Rondonopolis Airport",
     "countryCode": "BR",
     "iata": "ROO",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Rondonopolis"
  }, {
     "name": "Tinian International Airport",
     "countryCode": "MP",
     "iata": "TIQ",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Tinian"
  }, {
     "name": "Airai Airport",
     "countryCode": "PW",
     "iata": "ROR",
     "eucustoms": false,
     "countryDK": "Palau",
     "cityDK": "Koror"
  }, {
     "name": "Fisherton Airport",
     "countryCode": "AR",
     "iata": "ROS",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Rosario"
  }, {
     "name": "Rotorua International Airport",
     "countryCode": "NZ",
     "iata": "ROT",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Rotorua"
  }, {
     "name": "Platov International Airport",
     "countryCode": "RU",
     "iata": "ROV",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Rostov"
  }, {
     "name": "Roswell International Air Center",
     "countryCode": "US",
     "iata": "ROW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Roswell"
  }, {
     "name": "Roseau Municipal Airport",
     "countryCode": "US",
     "iata": "ROX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Roseau"
  }, {
     "name": "Rio Mayo Airport",
     "countryCode": "AR",
     "iata": "ROY",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Rio Mayo"
  }, {
     "name": "Naval Station Rota",
     "countryCode": "ES",
     "iata": "ROZ",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Rota"
  }, {
     "name": "Ngukurr Airport",
     "countryCode": "AU",
     "iata": "RPM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ngukurr"
  }, {
     "name": "Rosh Pina Airport",
     "countryCode": "IL",
     "iata": "RPN",
     "eucustoms": false,
     "countryDK": "Israel",
     "cityDK": "Rosh Pina"
  }, {
     "name": "Swami Vivekananda Airport",
     "countryCode": "IN",
     "iata": "RPR",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Raipur"
  }, {
     "name": "Roundup Airport",
     "countryCode": "US",
     "iata": "RPX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Runde op"
  }, {
     "name": "Marree Airport",
     "countryCode": "AU",
     "iata": "RRE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Marree"
  }, {
     "name": "Plaine Corail Airport",
     "countryCode": "MU",
     "iata": "RRG",
     "eucustoms": false,
     "countryDK": "Mauritius",
     "cityDK": "Rodrigues Island"
  }, {
     "name": "Rourkela Airport",
     "countryCode": "IN",
     "iata": "RRK",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Rourkela"
  }, {
     "name": "Merrill Municipal Airport",
     "countryCode": "US",
     "iata": "RRL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Merrill"
  }, {
     "name": "Raroia Airport",
     "countryCode": "PF",
     "iata": "RRR",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Raroia"
  }, {
     "name": "Roros Airport",
     "countryCode": "NO",
     "iata": "RRS",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Roros"
  }, {
     "name": "Warroad Airport",
     "countryCode": "US",
     "iata": "RRT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Warroad"
  }, {
     "name": "Santa Rosa Airport",
     "countryCode": "AR",
     "iata": "RSA",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Santa Rosa"
  }, {
     "name": "Roseberth Airport",
     "countryCode": "AU",
     "iata": "RSB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Roseberth"
  }, {
     "name": "South Eleuthera Airport",
     "countryCode": "BS",
     "iata": "RSD",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Rock Sound"
  }, {
     "name": "Abresso Airport",
     "countryCode": "ID",
     "iata": "RSK",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Ransiki"
  }, {
     "name": "Russell Airport",
     "countryCode": "US",
     "iata": "RSL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Russell"
  }, {
     "name": "Ruston Airport",
     "countryCode": "US",
     "iata": "RSN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ruston"
  }, {
     "name": "Damazin Airport",
     "countryCode": "SD",
     "iata": "RSS",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Damazin"
  }, {
     "name": "Rochester International Airport",
     "countryCode": "US",
     "iata": "RST",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rochester"
  }, {
     "name": "Yeosu Airport",
     "countryCode": "KR",
     "iata": "RSU",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Yeosu"
  }, {
     "name": "Southwest Florida International Airport",
     "countryCode": "US",
     "iata": "RSW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Myers"
  }, {
     "name": "Rotuma Island Airport",
     "countryCode": "FJ",
     "iata": "RTA",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Rotuma Island"
  }, {
     "name": "Roatan Airport",
     "countryCode": "HN",
     "iata": "RTB",
     "eucustoms": false,
     "countryDK": "Honduras",
     "cityDK": "Roatan"
  }, {
     "name": "Ratnagiri Airport",
     "countryCode": "IN",
     "iata": "RTC",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Ratnagiri"
  }, {
     "name": "Frans Sales Lega Airport",
     "countryCode": "ID",
     "iata": "RTG",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Ruteng"
  }, {
     "name": "David C. Saudale Airport",
     "countryCode": "ID",
     "iata": "RTI",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Rote Island"
  }, {
     "name": "Rotterdam The Hague Airport",
     "countryCode": "NL",
     "iata": "RTM",
     "eucustoms": false,
     "countryDK": "Holland",
     "cityDK": "Rotterdam"
  }, {
     "name": "Crews Field",
     "countryCode": "US",
     "iata": "RTN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Raton"
  }, {
     "name": "Rutland Plains Airport",
     "countryCode": "AU",
     "iata": "RTP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Rutland Plains"
  }, {
     "name": "Rottnest Island Airport",
     "countryCode": "AU",
     "iata": "RTS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Rottnest Island"
  }, {
     "name": "Saratov Airport",
     "countryCode": "RU",
     "iata": "RTW",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Saratov"
  }, {
     "name": "Arua Airport",
     "countryCode": "UG",
     "iata": "RUA",
     "eucustoms": false,
     "countryDK": "Uganda",
     "cityDK": "Arua"
  }, {
     "name": "Shahrud Airport",
     "countryCode": "IR",
     "iata": "RUD",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Shahrud"
  }, {
     "name": "King Khaled International Airport",
     "countryCode": "SA",
     "iata": "RUH",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Riyadh"
  }, {
     "name": "Ruidoso Municipal Airport",
     "countryCode": "US",
     "iata": "RUI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ruidoso"
  }, {
     "name": "Rukumkot Chaurjahari Airport",
     "countryCode": "NP",
     "iata": "RUK",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Rukumkot"
  }, {
     "name": "Rumjatar Airport",
     "countryCode": "NP",
     "iata": "RUM",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Rumjatar"
  }, {
     "name": "Reunion Roland Garros Airport",
     "countryCode": "RE",
     "iata": "RUN",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Saint Denis de la Reunion"
  }, {
     "name": "Rupsi Airport",
     "countryCode": "IN",
     "iata": "RUP",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Rupsi"
  }, {
     "name": "Rurutu Airport",
     "countryCode": "PF",
     "iata": "RUR",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Rurutu"
  }, {
     "name": "Rutland Airport",
     "countryCode": "US",
     "iata": "RUT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rutland"
  }, {
     "name": "Farafangana Airport",
     "countryCode": "MG",
     "iata": "RVA",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Farafangana"
  }, {
     "name": "Rio Verde Airport",
     "countryCode": "BR",
     "iata": "RVD",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Rio Verde"
  }, {
     "name": "Saravena Airport",
     "countryCode": "CO",
     "iata": "RVE",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Saravena"
  }, {
     "name": "Ryumsjoen Airport",
     "countryCode": "NO",
     "iata": "RVK",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Roervik"
  }, {
     "name": "Rovaniemi Airport",
     "countryCode": "FI",
     "iata": "RVN",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Rovaniemi"
  }, {
     "name": "Reivilo Airport",
     "countryCode": "ZA",
     "iata": "RVO",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Reivilo"
  }, {
     "name": "Richard Lloyd Jones Jr Airport",
     "countryCode": "US",
     "iata": "RVS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tulsa"
  }, {
     "name": "Rivera Airport",
     "countryCode": "UY",
     "iata": "RVY",
     "eucustoms": false,
     "countryDK": "Uruguay",
     "cityDK": "Rivera"
  }, {
     "name": "Redwood Falls Municipal Airport",
     "countryCode": "US",
     "iata": "RWF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Redwood Falls"
  }, {
     "name": "Rocky Mount-Wilson Airport",
     "countryCode": "US",
     "iata": "RWI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rocky Mount / Wilson"
  }, {
     "name": "Rawlins Municipal Airport (Harvey Field)",
     "countryCode": "US",
     "iata": "RWL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Rawlins"
  }, {
     "name": "Rovno Airport",
     "countryCode": "UA",
     "iata": "RWN",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Rovno"
  }, {
     "name": "Roxas City Airport",
     "countryCode": "PH",
     "iata": "RXS",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Roxas City"
  }, {
     "name": "Moss-Rygge Airport",
     "countryCode": "NO",
     "iata": "RYG",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Rygge"
  }, {
     "name": "Rahim Yar Khan Airport",
     "countryCode": "PK",
     "iata": "RYK",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Rahim Yar Khan"
  }, {
     "name": "Royal Airport",
     "countryCode": "ZM",
     "iata": "RYL",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Lower Zambezi National Park"
  }, {
     "name": "Medis Airport",
     "countryCode": "FR",
     "iata": "RYN",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Royan"
  }, {
     "name": "Rio Turbio Airport",
     "countryCode": "AR",
     "iata": "RYO",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Rio Turbio"
  }, {
     "name": "Santa Cruz Airport",
     "countryCode": "AR",
     "iata": "RZA",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Santa Cruz"
  }, {
     "name": "Rzeszow International Airport",
     "countryCode": "PL",
     "iata": "RZE",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Rzeszow"
  }, {
     "name": "Ramsar Airport",
     "countryCode": "IR",
     "iata": "RZR",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Ramsar"
  }, {
     "name": "Sawan Airport",
     "countryCode": "PK",
     "iata": "RZS",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Sawan"
  }, {
     "name": "Halifax County Airport",
     "countryCode": "US",
     "iata": "RZZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Roanoke Rapids"
  }, {
     "name": "Tillamook Airport",
     "countryCode": "US",
     "iata": "OTK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tillamook"
  }, {
     "name": "Shively Field",
     "countryCode": "US",
     "iata": "SAA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saratoga"
  }, {
     "name": "J. Yrausquin Airport",
     "countryCode": "BQ",
     "iata": "SAB",
     "eucustoms": false,
     "countryDK": "Caribien Holland",
     "cityDK": "Saba"
  }, {
     "name": "Sacramento Executive Airport",
     "countryCode": "US",
     "iata": "SAC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sacramento"
  }, {
     "name": "Safford Regional Airport",
     "countryCode": "US",
     "iata": "SAD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Safford"
  }, {
     "name": "Saattut Heliport",
     "countryCode": "GL",
     "iata": "SAE",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Saattut"
  }, {
     "name": "Santa Fe Municipal Airport",
     "countryCode": "US",
     "iata": "SAF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Santa Fe"
  }, {
     "name": "Sana'a International Airport",
     "countryCode": "YE",
     "iata": "SAH",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Sana'a"
  }, {
     "name": "Saudarkrokur Airport",
     "countryCode": "IS",
     "iata": "SAK",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Saudarkrokur"
  }, {
     "name": "El Salvador International Airport",
     "countryCode": "SV",
     "iata": "SAL",
     "eucustoms": false,
     "countryDK": "El Salvador",
     "cityDK": "San Salvador"
  }, {
     "name": "San Diego International Airport",
     "countryCode": "US",
     "iata": "SAN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Diego"
  }, {
     "name": "Ramon Villeda Morales International Airport",
     "countryCode": "HN",
     "iata": "SAP",
     "eucustoms": false,
     "countryDK": "Honduras",
     "cityDK": "San Pedro Sula"
  }, {
     "name": "San Andros Airport",
     "countryCode": "BS",
     "iata": "SAQ",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "San Andros"
  }, {
     "name": "Sparta Community Airport",
     "countryCode": "US",
     "iata": "SAR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sparta"
  }, {
     "name": "Salton City Airport",
     "countryCode": "US",
     "iata": "SAS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Salton City"
  }, {
     "name": "San Antonio International Airport",
     "countryCode": "US",
     "iata": "SAT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Antonio"
  }, {
     "name": "Savannah/Hilton Head Airport",
     "countryCode": "US",
     "iata": "SAV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Savannah"
  }, {
     "name": "Sabiha Gokcen International Airport",
     "countryCode": "TR",
     "iata": "SAW",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Istanbul"
  }, {
     "name": "Ampugnano Airport",
     "countryCode": "IT",
     "iata": "SAY",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Siena"
  }, {
     "name": "Santa Barbara Municipal Airport",
     "countryCode": "US",
     "iata": "SBA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Santa Barbara"
  }, {
     "name": "San Bernadino International Airport",
     "countryCode": "US",
     "iata": "SBD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Bernardino"
  }, {
     "name": "Maimun Saleh Airport",
     "countryCode": "ID",
     "iata": "SBG",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Sabang"
  }, {
     "name": "St. Barthelemy Airport",
     "countryCode": "GP",
     "iata": "SBH",
     "eucustoms": false,
     "countryDK": "Guadeloupe",
     "cityDK": "Saint Barthelemy"
  }, {
     "name": "Sambailo Airport",
     "countryCode": "GN",
     "iata": "SBI",
     "eucustoms": false,
     "countryDK": "Guinea",
     "cityDK": "Koundara"
  }, {
     "name": "Sao Mateus Airport",
     "countryCode": "BR",
     "iata": "SBJ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Mateus"
  }, {
     "name": "Tremuson Airport",
     "countryCode": "FR",
     "iata": "SBK",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Saint Brieuc"
  }, {
     "name": "Sheboygan County Memorial Airport",
     "countryCode": "US",
     "iata": "SBM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sheboygan"
  }, {
     "name": "South Bend Regional",
     "countryCode": "US",
     "iata": "SBN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "South Bend"
  }, {
     "name": "San Luis Obispo County Regional Airport",
     "countryCode": "US",
     "iata": "SBP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Luis Obispo"
  }, {
     "name": "Saibai Island Airport",
     "countryCode": "AU",
     "iata": "SBR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Saibai Island"
  }, {
     "name": "Bob Adams Field",
     "countryCode": "US",
     "iata": "SBS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Steamboat Springs"
  }, {
     "name": "Springbok Airport",
     "countryCode": "ZA",
     "iata": "SBU",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Springbok"
  }, {
     "name": "Sibu Airport",
     "countryCode": "MY",
     "iata": "SBW",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Sibu"
  }, {
     "name": "Shelby Airport",
     "countryCode": "US",
     "iata": "SBX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Shelby"
  }, {
     "name": "Wicomico Regional Airport",
     "countryCode": "US",
     "iata": "SBY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Salisbury-Ocean City"
  }, {
     "name": "Sibiu Airport",
     "countryCode": "RO",
     "iata": "SBZ",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Sibiu"
  }, {
     "name": "Scribner State Airport",
     "countryCode": "US",
     "iata": "SCB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Scribner"
  }, {
     "name": "Prudhoe Bay/Deadhorse Airport",
     "countryCode": "US",
     "iata": "SCC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Prudhoe Bay / Deadhorse"
  }, {
     "name": "University Park Airport",
     "countryCode": "US",
     "iata": "SCE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "State College"
  }, {
     "name": "Scottsdale Airport",
     "countryCode": "US",
     "iata": "SCF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Phoenix"
  }, {
     "name": "Schenectady County Airport",
     "countryCode": "US",
     "iata": "SCH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Schenectady"
  }, {
     "name": "San Cristobal Airport",
     "countryCode": "VE",
     "iata": "SCI",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "San Cristobal"
  }, {
     "name": "Stockton Airport",
     "countryCode": "US",
     "iata": "SCK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Stockton"
  }, {
     "name": "Arturo Merino Benitez Airport",
     "countryCode": "CL",
     "iata": "SCL",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Santiago"
  }, {
     "name": "Ensheim Airport",
     "countryCode": "DE",
     "iata": "SCN",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Saarbrücken"
  }, {
     "name": "Aktau International Airport",
     "countryCode": "KZ",
     "iata": "SCO",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Aktau"
  }, {
     "name": "Santiago de Compostela Airport",
     "countryCode": "ES",
     "iata": "SCQ",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Santiago De Compostela"
  }, {
     "name": "Scatsta Airport",
     "countryCode": "GB",
     "iata": "SCS",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Shetlandsøerne"
  }, {
     "name": "Socotra Airport",
     "countryCode": "YE",
     "iata": "SCT",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Socotra"
  }, {
     "name": "Antonio Maceo Airport",
     "countryCode": "CU",
     "iata": "SCU",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Santiago"
  }, {
     "name": "Suceava Airport",
     "countryCode": "RO",
     "iata": "SCV",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Suceava"
  }, {
     "name": "Syktyvkar Airport",
     "countryCode": "RU",
     "iata": "SCW",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Syktyvkar"
  }, {
     "name": "Salina Cruz Airport",
     "countryCode": "MX",
     "iata": "SCX",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Salina Cruz"
  }, {
     "name": "San Cristobal Airport",
     "countryCode": "EC",
     "iata": "SCY",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "San Cristobal"
  }, {
     "name": "Santa Cruz Island Airport",
     "countryCode": "SB",
     "iata": "SCZ",
     "eucustoms": false,
     "countryDK": "Salomonøerne",
     "cityDK": "Santa Cruz Island"
  }, {
     "name": "Langebaanweg Airport",
     "countryCode": "ZA",
     "iata": "SDB",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Saldanha Bay"
  }, {
     "name": "Lubango Airport",
     "countryCode": "AO",
     "iata": "SDD",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Lubango"
  }, {
     "name": "Santiago Del Estero Airport",
     "countryCode": "AR",
     "iata": "SDE",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Santiago Del Estero"
  }, {
     "name": "Louisville International Airport-Standiford Field",
     "countryCode": "US",
     "iata": "SDF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Louisville"
  }, {
     "name": "Sanandaj Airport",
     "countryCode": "IR",
     "iata": "SDG",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Sanandaj"
  }, {
     "name": "Sendai Airport",
     "countryCode": "JP",
     "iata": "SDJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Sendai"
  }, {
     "name": "Sandakan Airport",
     "countryCode": "MY",
     "iata": "SDK",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Sandakan"
  }, {
     "name": "Sundsvall-Timra Airport",
     "countryCode": "SE",
     "iata": "SDL",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Sundsvall"
  }, {
     "name": "Brown Field Municipal Airport",
     "countryCode": "US",
     "iata": "SDM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Diego"
  }, {
     "name": "Sandane Airport",
     "countryCode": "NO",
     "iata": "SDN",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Sandane"
  }, {
     "name": "Sand Point Municipal Airport",
     "countryCode": "US",
     "iata": "SDP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sand Point"
  }, {
     "name": "Las Americas International Airport",
     "countryCode": "DO",
     "iata": "SDQ",
     "eucustoms": false,
     "countryDK": "Dominikanske Republik",
     "cityDK": "Santo Domingo"
  }, {
     "name": "Santander Airport",
     "countryCode": "ES",
     "iata": "SDR",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Santander"
  }, {
     "name": "Sado Shima Airport",
     "countryCode": "JP",
     "iata": "SDS",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Sado Shima"
  }, {
     "name": "Saidu Sharif Airport",
     "countryCode": "PK",
     "iata": "SDT",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Saidu Sharif"
  }, {
     "name": "Santos Dumont Airport",
     "countryCode": "BR",
     "iata": "SDU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Rio de Janeiro"
  }, {
     "name": "Dov Hoz Airport",
     "countryCode": "IL",
     "iata": "SDV",
     "eucustoms": false,
     "countryDK": "Israel",
     "cityDK": "Tel Aviv-Yafo"
  }, {
     "name": "Sedona Airport",
     "countryCode": "US",
     "iata": "SDX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sedona"
  }, {
     "name": "Richland Municipal Airport",
     "countryCode": "US",
     "iata": "SDY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sidney"
  }, {
     "name": "Seattle-Tacoma International Airport",
     "countryCode": "US",
     "iata": "SEA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Seattle"
  }, {
     "name": "Sebha Airport",
     "countryCode": "LY",
     "iata": "SEB",
     "eucustoms": false,
     "countryDK": "Libyen",
     "cityDK": "Sebha"
  }, {
     "name": "Gillespie Field",
     "countryCode": "US",
     "iata": "SEE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Diego"
  }, {
     "name": "Sebring Air Terminal",
     "countryCode": "US",
     "iata": "SEF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sebring"
  }, {
     "name": "Penn Valley Airport",
     "countryCode": "US",
     "iata": "SEG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Selinsgrove"
  }, {
     "name": "Senhor Do Bonfim Airport",
     "countryCode": "BR",
     "iata": "SEI",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Senhor Do Bonfim"
  }, {
     "name": "Jumandy Airport",
     "countryCode": "EC",
     "iata": "TNW",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Tena"
  }, {
     "name": "Craig Field",
     "countryCode": "US",
     "iata": "SEM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Selma"
  }, {
     "name": "London Southend Airport",
     "countryCode": "GB",
     "iata": "SEN",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Southend"
  }, {
     "name": "Seguela Airport",
     "countryCode": "CI",
     "iata": "SEO",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Seguela"
  }, {
     "name": "Clark Field",
     "countryCode": "US",
     "iata": "SEP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Stephenville"
  }, {
     "name": "Freeman Municipal Airport",
     "countryCode": "US",
     "iata": "SER",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Seymour"
  }, {
     "name": "Coronel Artilleria Victor Larrea Airport",
     "countryCode": "EC",
     "iata": "ETR",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Santa Rosa"
  }, {
     "name": "Seronera Airstrip",
     "countryCode": "TZ",
     "iata": "SEU",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Seronera"
  }, {
     "name": "Selibaby Airport",
     "countryCode": "MR",
     "iata": "SEY",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Selibaby"
  }, {
     "name": "Seychelles International Airport",
     "countryCode": "SC",
     "iata": "SEZ",
     "eucustoms": false,
     "countryDK": "Seychellerne",
     "cityDK": "Mahe Island"
  }, {
     "name": "Sfax El Maou Airport",
     "countryCode": "TN",
     "iata": "SFA",
     "eucustoms": false,
     "countryDK": "Tunesien",
     "cityDK": "Sfax"
  }, {
     "name": "Orlando Sanford International Airport",
     "countryCode": "US",
     "iata": "SFB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Orlando"
  }, {
     "name": "Las Flecheras Airport",
     "countryCode": "VE",
     "iata": "SFD",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "San Fernando de Apure"
  }, {
     "name": "San Fernando Airport",
     "countryCode": "PH",
     "iata": "SFE",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "San Fernando"
  }, {
     "name": "Felts Field",
     "countryCode": "US",
     "iata": "SFF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Spokane"
  }, {
     "name": "Pierrefonds Airport",
     "countryCode": "RE",
     "iata": "ZSE",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Saint Pierre de la Reunion"
  }, {
     "name": "San Felipe International Airport",
     "countryCode": "MX",
     "iata": "SFH",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "San Felipe"
  }, {
     "name": "Safi Airport",
     "countryCode": "MA",
     "iata": "SFI",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Safi"
  }, {
     "name": "Kangerlussuaq Airport",
     "countryCode": "GL",
     "iata": "SFJ",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Kangerlussuaq"
  }, {
     "name": "Soure Airport",
     "countryCode": "BR",
     "iata": "SFK",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Soure"
  }, {
     "name": "Sao Filipe Airport",
     "countryCode": "CV",
     "iata": "SFL",
     "eucustoms": false,
     "countryDK": "Kap Verde",
     "cityDK": "Sao Filipe"
  }, {
     "name": "Seacoast Regional Airport",
     "countryCode": "US",
     "iata": "SFM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sanford"
  }, {
     "name": "Santa Fe Airport",
     "countryCode": "AR",
     "iata": "SFN",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Santa Fe"
  }, {
     "name": "San Francisco International Airport",
     "countryCode": "US",
     "iata": "SFO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Francisco"
  }, {
     "name": "Subic Bay International Airport",
     "countryCode": "PH",
     "iata": "SFS",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Subic Bay"
  }, {
     "name": "Skelleftea Airport",
     "countryCode": "SE",
     "iata": "SFT",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Skelleftea"
  }, {
     "name": "North Central State Airport",
     "countryCode": "US",
     "iata": "SFZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pawtucket"
  }, {
     "name": "Sheghnan Airport",
     "countryCode": "AF",
     "iata": "SGA",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Sheghnan"
  }, {
     "name": "Surgut Airport",
     "countryCode": "RU",
     "iata": "SGC",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Surgut"
  }, {
     "name": "Sonderborg Airport",
     "countryCode": "DK",
     "iata": "SGD",
     "eucustoms": true,
     "countryDK": "Danmark",
     "cityDK": "Sønderborg"
  }, {
     "name": "Siegerland Airport",
     "countryCode": "DE",
     "iata": "SGE",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Siegen"
  }, {
     "name": "Springfield-Branson National Airport",
     "countryCode": "US",
     "iata": "SGF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Springfield"
  }, {
     "name": "Springfield Airport",
     "countryCode": "US",
     "iata": "SGH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Springfield"
  }, {
     "name": "Danilo Atienza Air Base",
     "countryCode": "PH",
     "iata": "SGL",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Manila"
  }, {
     "name": "Tan Son Nhat International Airport",
     "countryCode": "VN",
     "iata": "SGN",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Ho Chi Minh City"
  }, {
     "name": "St. George Airport",
     "countryCode": "AU",
     "iata": "SGO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Saint George"
  }, {
     "name": "Sugar Land Municipal Airport",
     "countryCode": "US",
     "iata": "SGR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Houston"
  }, {
     "name": "Stuttgart Airport",
     "countryCode": "US",
     "iata": "SGT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Stuttgart"
  }, {
     "name": "Saint George Municipal Airport",
     "countryCode": "US",
     "iata": "SGU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saint George"
  }, {
     "name": "Sierra Grande Airport",
     "countryCode": "AR",
     "iata": "SGV",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Sierra Grande"
  }, {
     "name": "Songea Airport",
     "countryCode": "TZ",
     "iata": "SGX",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Songea"
  }, {
     "name": "Skagway Airport",
     "countryCode": "US",
     "iata": "SGY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Skagway"
  }, {
     "name": "Songkhla Airport",
     "countryCode": "TH",
     "iata": "SGZ",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Songkhla"
  }, {
     "name": "Shanghai Hongqiao International Airport",
     "countryCode": "CN",
     "iata": "SHA",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Shanghai"
  }, {
     "name": "Nakashibetsu Airport",
     "countryCode": "JP",
     "iata": "SHB",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Nakashibetsu"
  }, {
     "name": "Shenandoah Valley Airport",
     "countryCode": "US",
     "iata": "SHD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Staunton"
  }, {
     "name": "Shenyang Taoxian International Airport",
     "countryCode": "CN",
     "iata": "SHE",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Shenyang"
  }, {
     "name": "Shishmaref Airport",
     "countryCode": "US",
     "iata": "SHH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Shishmaref"
  }, {
     "name": "Shimojishima Airport",
     "countryCode": "JP",
     "iata": "SHI",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Shimojishima"
  }, {
     "name": "Sharjah International Airport",
     "countryCode": "AE",
     "iata": "SHJ",
     "eucustoms": false,
     "countryDK": "Forenede Arabiske Emirater",
     "cityDK": "Sharjah"
  }, {
     "name": "Sehonghong Airport",
     "countryCode": "LS",
     "iata": "SHK",
     "eucustoms": false,
     "countryDK": "Lesotho",
     "cityDK": "Sehonghong"
  }, {
     "name": "Shillong Airport",
     "countryCode": "IN",
     "iata": "SHL",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Umroi"
  }, {
     "name": "Shirahama Airport",
     "countryCode": "JP",
     "iata": "SHM",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Shirahama"
  }, {
     "name": "Sanderson Field",
     "countryCode": "US",
     "iata": "SHN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Shelton"
  }, {
     "name": "Sheridan Airport",
     "countryCode": "US",
     "iata": "SHR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sheridan"
  }, {
     "name": "Shashi Airport",
     "countryCode": "CN",
     "iata": "SHS",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Shashi"
  }, {
     "name": "Shepparton Airport",
     "countryCode": "AU",
     "iata": "SHT",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Shepparton"
  }, {
     "name": "Shreveport Regional Airport",
     "countryCode": "US",
     "iata": "SHV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Shreveport"
  }, {
     "name": "Sharurah Airport",
     "countryCode": "SA",
     "iata": "SHW",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Sharurah"
  }, {
     "name": "Shinyanga Airport",
     "countryCode": "TZ",
     "iata": "SHY",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Shinyanga"
  }, {
     "name": "Xiguan Airport",
     "countryCode": "CN",
     "iata": "SIA",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Xian"
  }, {
     "name": "Sibiti Airport",
     "countryCode": "CG",
     "iata": "SIB",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Sibiti"
  }, {
     "name": "Amilcar Cabral International Airport",
     "countryCode": "CV",
     "iata": "SID",
     "eucustoms": false,
     "countryDK": "Kap Verde",
     "cityDK": "Sal"
  }, {
     "name": "Sines Airport",
     "countryCode": "PT",
     "iata": "SIE",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Sines"
  }, {
     "name": "Simara Airport",
     "countryCode": "NP",
     "iata": "SIF",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Simara"
  }, {
     "name": "Fernando Luis Ribas Dominicci Airport",
     "countryCode": "PR",
     "iata": "SIG",
     "eucustoms": false,
     "countryDK": "Puerto Rico",
     "cityDK": "San Juan"
  }, {
     "name": "Sidi Ifni Airport",
     "countryCode": "MA",
     "iata": "SII",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Sidi Ifni"
  }, {
     "name": "Siglufjordur Airport",
     "countryCode": "IS",
     "iata": "SIJ",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Siglufjordur"
  }, {
     "name": "Sikeston Memorial Airport",
     "countryCode": "US",
     "iata": "SIK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sikeston"
  }, {
     "name": "Changi International Airport",
     "countryCode": "SG",
     "iata": "SIN",
     "eucustoms": false,
     "countryDK": "Singapore",
     "cityDK": "Singapore"
  }, {
     "name": "Smithton Airport",
     "countryCode": "AU",
     "iata": "SIO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Smithton"
  }, {
     "name": "Simferopol International Airport",
     "countryCode": "UA",
     "iata": "SIP",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Simferopol"
  }, {
     "name": "Dabo Airport",
     "countryCode": "ID",
     "iata": "SIQ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Singkep"
  }, {
     "name": "Sion Airport",
     "countryCode": "CH",
     "iata": "SIR",
     "eucustoms": false,
     "countryDK": "Schweiz",
     "cityDK": "Sion"
  }, {
     "name": "Sishen Airport",
     "countryCode": "ZA",
     "iata": "SIS",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Sishen"
  }, {
     "name": "Sitka Airport",
     "countryCode": "US",
     "iata": "SIT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sitka"
  }, {
     "name": "Sullivan County Airport",
     "countryCode": "US",
     "iata": "SIV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sullivan"
  }, {
     "name": "Siskiyou County Airport",
     "countryCode": "US",
     "iata": "SIY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Montague"
  }, {
     "name": "San Juan Airport",
     "countryCode": "PE",
     "iata": "SJA",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "San Juan"
  }, {
     "name": "San Joaquin Airport",
     "countryCode": "BO",
     "iata": "SJB",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "San Joaquin"
  }, {
     "name": "Norman Y. Mineta San Jose International Airport",
     "countryCode": "US",
     "iata": "SJC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Jose"
  }, {
     "name": "Los Cabos International Airport",
     "countryCode": "MX",
     "iata": "SJD",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "San Jose Cabo"
  }, {
     "name": "San Jose Del Gua Airport",
     "countryCode": "CO",
     "iata": "SJE",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "San Jose Del Gua"
  }, {
     "name": "San Jose Airport",
     "countryCode": "PH",
     "iata": "SJI",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "San Jose"
  }, {
     "name": "Sarajevo International Airport",
     "countryCode": "BA",
     "iata": "SJJ",
     "eucustoms": false,
     "countryDK": "Bosnien-Hercegovina",
     "cityDK": "Sarajevo"
  }, {
     "name": "Professor Urbano Ernesto Stumpf Airport",
     "countryCode": "BR",
     "iata": "SJK",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Jose dos Campos"
  }, {
     "name": "Sao Gabriel Cachoeira Airport",
     "countryCode": "BR",
     "iata": "SJL",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Gabriel Cachoeira"
  }, {
     "name": "Saint Johns Municipal Airport",
     "countryCode": "US",
     "iata": "SJN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saint Johns"
  }, {
     "name": "Juan Santamaria International Airport",
     "countryCode": "CR",
     "iata": "SJO",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "San Jose"
  }, {
     "name": "Sao Jose do Rio Preto Airport",
     "countryCode": "BR",
     "iata": "SJP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Jose Do Rio Preto"
  }, {
     "name": "San Jose de Chiquitos Airport",
     "countryCode": "BO",
     "iata": "SJS",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "San Jose"
  }, {
     "name": "San Angelo Regional Airport",
     "countryCode": "US",
     "iata": "SJT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Angelo"
  }, {
     "name": "Luis Munoz Marin International Airport",
     "countryCode": "PR",
     "iata": "SJU",
     "eucustoms": false,
     "countryDK": "Puerto Rico",
     "cityDK": "San Juan"
  }, {
     "name": "San Javier Airport",
     "countryCode": "BO",
     "iata": "SJV",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "San Javier"
  }, {
     "name": "Shijiazhuang Zhengding International Airport",
     "countryCode": "CN",
     "iata": "SJW",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Shijiazhuang"
  }, {
     "name": "Ilmajoki Airport",
     "countryCode": "FI",
     "iata": "SJY",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Seinajoki"
  }, {
     "name": "Sao Jorge Island Airport",
     "countryCode": "PT",
     "iata": "SJZ",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Sao Jorge Island"
  }, {
     "name": "Fairchild Air Force Base",
     "countryCode": "US",
     "iata": "SKA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Spokane"
  }, {
     "name": "Luis F. Gomez Nino Air Base",
     "countryCode": "CO",
     "iata": "API",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Apiay"
  }, {
     "name": "Esperance Airport",
     "countryCode": "MF",
     "iata": "SFG",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Saint Martin"
  }, {
     "name": "Samarkand Airport",
     "countryCode": "UZ",
     "iata": "SKD",
     "eucustoms": false,
     "countryDK": "Usbekistan",
     "cityDK": "Samarkand"
  }, {
     "name": "Skien Airport",
     "countryCode": "NO",
     "iata": "SKE",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Skien"
  }, {
     "name": "Kelly Field Annex",
     "countryCode": "US",
     "iata": "SKF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Antonio"
  }, {
     "name": "Thessaloniki International Airport",
     "countryCode": "GR",
     "iata": "SKG",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Thessaloniki"
  }, {
     "name": "Surkhet Airport",
     "countryCode": "NP",
     "iata": "SKH",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Surkhet"
  }, {
     "name": "Stokmarknes Skagen Airport",
     "countryCode": "NO",
     "iata": "SKN",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Stokmarknes"
  }, {
     "name": "Sokoto Airport",
     "countryCode": "NG",
     "iata": "SKO",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Sokoto"
  }, {
     "name": "Princess Juliana International Airport",
     "countryCode": "SX",
     "iata": "SXM",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Sint Maarten"
  }, {
     "name": "Shakiso Airport",
     "countryCode": "ET",
     "iata": "SKR",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Shakiso"
  }, {
     "name": "Vojens Airport",
     "countryCode": "DK",
     "iata": "SKS",
     "eucustoms": false,
     "countryDK": "Danmark",
     "cityDK": "Vojens"
  }, {
     "name": "Skiros Airport",
     "countryCode": "GR",
     "iata": "SKU",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Skiros"
  }, {
     "name": "St Catherine International Airport",
     "countryCode": "EG",
     "iata": "SKV",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "St Catherine"
  }, {
     "name": "Skwentna Intermediate Airport",
     "countryCode": "US",
     "iata": "SKW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Skwentna"
  }, {
     "name": "Saransk Airport",
     "countryCode": "RU",
     "iata": "SKX",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Saransk"
  }, {
     "name": "Griffin Sandusky Airport",
     "countryCode": "US",
     "iata": "SKY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sandusky"
  }, {
     "name": "Sukkur Airport",
     "countryCode": "PK",
     "iata": "SKZ",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Sukkur"
  }, {
     "name": "Martin Miguel de Guemes International Airport",
     "countryCode": "AR",
     "iata": "SLA",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Salta"
  }, {
     "name": "Storm Lake Municipal Airport",
     "countryCode": "US",
     "iata": "SLB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Storm Lake"
  }, {
     "name": "Salt Lake City International Airport",
     "countryCode": "US",
     "iata": "SLC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Salt Lake City"
  }, {
     "name": "Sliac Airport",
     "countryCode": "SK",
     "iata": "SLD",
     "eucustoms": false,
     "countryDK": "Slovakiet",
     "cityDK": "Sliac"
  }, {
     "name": "McNary Field",
     "countryCode": "US",
     "iata": "SLE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Salem"
  }, {
     "name": "Smith Field",
     "countryCode": "US",
     "iata": "SLG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Siloam Springs"
  }, {
     "name": "Vanua Lava Airport",
     "countryCode": "VU",
     "iata": "SLH",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Sola"
  }, {
     "name": "Solwezi Airport",
     "countryCode": "ZM",
     "iata": "SLI",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Solwezi"
  }, {
     "name": "Solomon Airport",
     "countryCode": "AU",
     "iata": "SLJ",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Solomon"
  }, {
     "name": "Adirondack Airport",
     "countryCode": "US",
     "iata": "SLK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saranac Lake"
  }, {
     "name": "Salalah International Airport",
     "countryCode": "OM",
     "iata": "SLL",
     "eucustoms": false,
     "countryDK": "Oman",
     "cityDK": "Salalah"
  }, {
     "name": "Salamanca Airport",
     "countryCode": "ES",
     "iata": "SLM",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Salamanca"
  }, {
     "name": "Salina Regional Airport",
     "countryCode": "US",
     "iata": "SLN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Salina"
  }, {
     "name": "Leckrone Airport",
     "countryCode": "US",
     "iata": "SLO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Salem"
  }, {
     "name": "Ponciano Arriaga International Airport",
     "countryCode": "MX",
     "iata": "SLP",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "San Luis Potosi"
  }, {
     "name": "Sleetmute Airport",
     "countryCode": "US",
     "iata": "SLQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sleetmute"
  }, {
     "name": "Sulphur Springs Airport",
     "countryCode": "US",
     "iata": "SLR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sulphur Springs"
  }, {
     "name": "George F. L. Charles Airport",
     "countryCode": "LC",
     "iata": "SLU",
     "eucustoms": false,
     "countryDK": "Saint Lucia",
     "cityDK": "Saint Lucia"
  }, {
     "name": "Shimla Airport",
     "countryCode": "IN",
     "iata": "SLV",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Shimla"
  }, {
     "name": "Plan de Guadalupe International Airport",
     "countryCode": "MX",
     "iata": "SLW",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Saltillo"
  }, {
     "name": "Salekhard Airport",
     "countryCode": "RU",
     "iata": "SLY",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Salekhard"
  }, {
     "name": "Marechal Cunha Machado International Airport",
     "countryCode": "BR",
     "iata": "SLZ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Luiz"
  }, {
     "name": "Vila Do Porto Airport",
     "countryCode": "PT",
     "iata": "SMA",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Santa Maria (Azorerne)"
  }, {
     "name": "Franco Bianco Airport",
     "countryCode": "CL",
     "iata": "SMB",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Cerro Sombrero"
  }, {
     "name": "Smith Field",
     "countryCode": "US",
     "iata": "SMD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Wayne"
  }, {
     "name": "Lake Cumberland Regional Airport",
     "countryCode": "US",
     "iata": "SME",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Somerset"
  }, {
     "name": "Sacramento International Airport",
     "countryCode": "US",
     "iata": "SMF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sacramento"
  }, {
     "name": "Santa Maria Airport",
     "countryCode": "PE",
     "iata": "SMG",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Santa Maria"
  }, {
     "name": "Samos Airport",
     "countryCode": "GR",
     "iata": "SMI",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Samos"
  }, {
     "name": "Stella Maris Airport",
     "countryCode": "BS",
     "iata": "SML",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Stella Maris"
  }, {
     "name": "Lemhi County Airport",
     "countryCode": "US",
     "iata": "SMN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Laks"
  }, {
     "name": "Santa Monica Municipal Airport",
     "countryCode": "US",
     "iata": "SMO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Santa Monica"
  }, {
     "name": "H. Asan Airport",
     "countryCode": "ID",
     "iata": "SMQ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Sampit"
  }, {
     "name": "Simon Bolivar International Airport",
     "countryCode": "CO",
     "iata": "SMR",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Santa Marta"
  }, {
     "name": "Sainte Marie Airport",
     "countryCode": "MG",
     "iata": "SMS",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Sainte Marie"
  }, {
     "name": "Sorriso Airport",
     "countryCode": "BR",
     "iata": "SMT",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sorriso"
  }, {
     "name": "Sheep Mountain Airport",
     "countryCode": "US",
     "iata": "SMU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sheep Mountain"
  }, {
     "name": "Samedan Airport",
     "countryCode": "CH",
     "iata": "SMV",
     "eucustoms": false,
     "countryDK": "Schweiz",
     "cityDK": "Saint Moritz"
  }, {
     "name": "Santa Maria Public Airport",
     "countryCode": "US",
     "iata": "SMX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Santa Maria"
  }, {
     "name": "Simenti Airport",
     "countryCode": "SN",
     "iata": "SMY",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Simenti"
  }, {
     "name": "John Wayne Airport",
     "countryCode": "US",
     "iata": "SNA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Santa Ana"
  }, {
     "name": "Snake Bay Airport",
     "countryCode": "AU",
     "iata": "SNB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Snake Bay"
  }, {
     "name": "General Ulpiano Paez Airport",
     "countryCode": "EC",
     "iata": "SNC",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Salinas"
  }, {
     "name": "Preguica Airport",
     "countryCode": "CV",
     "iata": "SNE",
     "eucustoms": false,
     "countryDK": "Kap Verde",
     "cityDK": "Sao Nicolau"
  }, {
     "name": "San Felipe Airport",
     "countryCode": "VE",
     "iata": "SNF",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "San Felipe"
  }, {
     "name": "Cap. Juan Cochamanidis Airport",
     "countryCode": "BO",
     "iata": "SNG",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "San Ignacio De Velasco"
  }, {
     "name": "Stanthorpe Airport",
     "countryCode": "AU",
     "iata": "SNH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Stanthorpe"
  }, {
     "name": "Santa Magalhaes Airport",
     "countryCode": "BR",
     "iata": "SET",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Serra Talhada"
  }, {
     "name": "R. E. Murray Airport",
     "countryCode": "LR",
     "iata": "SNI",
     "eucustoms": false,
     "countryDK": "Liberia",
     "cityDK": "Sinoe"
  }, {
     "name": "San Julian Air Base",
     "countryCode": "CU",
     "iata": "SNJ",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "San Julian"
  }, {
     "name": "Sao Joao Del Rei Airport",
     "countryCode": "BR",
     "iata": "JDR",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Joao Del Rei"
  }, {
     "name": "Winston Field",
     "countryCode": "US",
     "iata": "SNK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Snyder"
  }, {
     "name": "Shawnee Municipal Airport",
     "countryCode": "US",
     "iata": "SNL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Shawnee"
  }, {
     "name": "San Ignacio De Moxos Airport",
     "countryCode": "BO",
     "iata": "SNM",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "San Ignacio De Moxos"
  }, {
     "name": "Shannon Airport",
     "countryCode": "IE",
     "iata": "SNN",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Shannon"
  }, {
     "name": "Sakon Nakhon Airport",
     "countryCode": "TH",
     "iata": "SNO",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Sakon Nakhon"
  }, {
     "name": "Saint Paul Island Airport",
     "countryCode": "US",
     "iata": "SNP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saint Paul Island"
  }, {
     "name": "Montoir Airport",
     "countryCode": "FR",
     "iata": "SNR",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Saint Nazaire"
  }, {
     "name": "Salinas Municipal Airport",
     "countryCode": "US",
     "iata": "SNS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Salinas"
  }, {
     "name": "Santa Clara Airport",
     "countryCode": "CU",
     "iata": "SNU",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Santa Clara"
  }, {
     "name": "Santa Elena Airport",
     "countryCode": "VE",
     "iata": "SNV",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Santa Elena"
  }, {
     "name": "Thandwe Airport",
     "countryCode": "MM",
     "iata": "SNW",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Thandwe"
  }, {
     "name": "Sidney Municipal Airport",
     "countryCode": "US",
     "iata": "SNY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sidney"
  }, {
     "name": "Sarmellek/Balaton Airport",
     "countryCode": "HU",
     "iata": "SOB",
     "eucustoms": false,
     "countryDK": "Ungarn",
     "cityDK": "Sarmellek"
  }, {
     "name": "Adi Sumarmo International Airport",
     "countryCode": "ID",
     "iata": "SOC",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Surakarta"
  }, {
     "name": "Sorocaba Airport",
     "countryCode": "BR",
     "iata": "SOD",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sorocaba"
  }, {
     "name": "Souanke Airport",
     "countryCode": "CG",
     "iata": "SOE",
     "eucustoms": false,
     "countryDK": "Republikken Congo",
     "cityDK": "Souanke"
  }, {
     "name": "Sofia Airport",
     "countryCode": "BG",
     "iata": "SOF",
     "eucustoms": false,
     "countryDK": "Bulgarien",
     "cityDK": "Sofia"
  }, {
     "name": "Sogndal Airport",
     "countryCode": "NO",
     "iata": "SOG",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Sogndal"
  }, {
     "name": "South Molle Island Airport",
     "countryCode": "AU",
     "iata": "SOI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "South Molle Island"
  }, {
     "name": "Sorkjosen Airport",
     "countryCode": "NO",
     "iata": "SOJ",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Sørkjosen"
  }, {
     "name": "Semongkong Airport",
     "countryCode": "LS",
     "iata": "SOK",
     "eucustoms": false,
     "countryDK": "Lesotho",
     "cityDK": "Semongkong"
  }, {
     "name": "San Tome Airport",
     "countryCode": "VE",
     "iata": "SOM",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "San Tome"
  }, {
     "name": "Santo Pekoa International Airport",
     "countryCode": "VU",
     "iata": "SON",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Espiritu Santo"
  }, {
     "name": "Soderhamn Airport",
     "countryCode": "SE",
     "iata": "SOO",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Söderhamn"
  }, {
     "name": "Moore County Airport",
     "countryCode": "US",
     "iata": "SOP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sydlige Pines"
  }, {
     "name": "Sorong Airport",
     "countryCode": "ID",
     "iata": "SOQ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Sorong"
  }, {
     "name": "Sodankyla Airport",
     "countryCode": "FI",
     "iata": "SOT",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Sodankyla"
  }, {
     "name": "Southampton Airport",
     "countryCode": "GB",
     "iata": "SOU",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Southampton"
  }, {
     "name": "Seldovia Airport",
     "countryCode": "US",
     "iata": "SOV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Seldovia"
  }, {
     "name": "Show Low Airport",
     "countryCode": "US",
     "iata": "SOW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Vis lavt"
  }, {
     "name": "Sogamoso Airport",
     "countryCode": "CO",
     "iata": "SOX",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Sogamoso"
  }, {
     "name": "Stronsay Airport",
     "countryCode": "GB",
     "iata": "SOY",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Stronsay"
  }, {
     "name": "Solenzara Airport",
     "countryCode": "FR",
     "iata": "SOZ",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Solenzara"
  }, {
     "name": "Spartanburg Downtown Memorial Airport",
     "countryCode": "US",
     "iata": "SPA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Spartanburg"
  }, {
     "name": "La Palma Airport",
     "countryCode": "ES",
     "iata": "SPC",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Santa Cruz De La Palma"
  }, {
     "name": "Saidpur Airport",
     "countryCode": "BD",
     "iata": "SPD",
     "eucustoms": false,
     "countryDK": "Bangladesh",
     "cityDK": "Saidpur"
  }, {
     "name": "Black Hills Airport",
     "countryCode": "US",
     "iata": "SPF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Spearfish"
  }, {
     "name": "St Pete-Albert Whitted Airport",
     "countryCode": "US",
     "iata": "SPG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sankt Petersborg"
  }, {
     "name": "Sopu Airport",
     "countryCode": "PG",
     "iata": "SPH",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Sopu"
  }, {
     "name": "Capital Airport",
     "countryCode": "US",
     "iata": "SPI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Springfield"
  }, {
     "name": "Sparta Airport",
     "countryCode": "GR",
     "iata": "SPJ",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Sparta"
  }, {
     "name": "Spangdahlem Air Base",
     "countryCode": "DE",
     "iata": "SPM",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Spangdahlem"
  }, {
     "name": "Newcastle Airport",
     "countryCode": "KN",
     "iata": "NEV",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Nevis"
  }, {
     "name": "Menongue Airport",
     "countryCode": "AO",
     "iata": "SPP",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Menongue"
  }, {
     "name": "Wichita Falls Municipal Airport/Sheppard Air Force Base",
     "countryCode": "US",
     "iata": "SPS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wichita Falls"
  }, {
     "name": "Split Airport",
     "countryCode": "HR",
     "iata": "SPU",
     "eucustoms": true,
     "countryDK": "Kroatien",
     "cityDK": "Dele"
  }, {
     "name": "Spencer Municipal Airport",
     "countryCode": "US",
     "iata": "SPW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Spencer"
  }, {
     "name": "San Pedro Airport",
     "countryCode": "CI",
     "iata": "SPY",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "San Pedro"
  }, {
     "name": "Springdale Municipal Airport",
     "countryCode": "US",
     "iata": "SPZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Springdale"
  }, {
     "name": "Maria Reiche Neuman Airport",
     "countryCode": "PE",
     "iata": "NZC",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Nazca"
  }, {
     "name": "Santa Ynez Airport",
     "countryCode": "US",
     "iata": "SQA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Santa Ynez"
  }, {
     "name": "Southern Cross Airport",
     "countryCode": "AU",
     "iata": "SQC",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Sydkorset"
  }, {
     "name": "Sanqingshan Airport",
     "countryCode": "CN",
     "iata": "SQD",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Shangrao"
  }, {
     "name": "Susilo Airport",
     "countryCode": "ID",
     "iata": "SQG",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Sintang"
  }, {
     "name": "Whiteside County Airport",
     "countryCode": "US",
     "iata": "SQI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sterling"
  }, {
     "name": "San Carlos Airport",
     "countryCode": "US",
     "iata": "SQL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Carlos"
  }, {
     "name": "Emalamo Sanana Airport",
     "countryCode": "ID",
     "iata": "SQN",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Sanana"
  }, {
     "name": "Gunnarn Airport",
     "countryCode": "SE",
     "iata": "SQO",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Storuman"
  }, {
     "name": "Siauliai International Airport",
     "countryCode": "LT",
     "iata": "SQQ",
     "eucustoms": false,
     "countryDK": "Litauen",
     "cityDK": "Siauliai"
  }, {
     "name": "Skive Airport",
     "countryCode": "DK",
     "iata": "SQW",
     "eucustoms": false,
     "countryDK": "Danmark",
     "cityDK": "Skive"
  }, {
     "name": "Sao Miguel Do Oeste Airport",
     "countryCode": "BR",
     "iata": "SQX",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Miguel Do Oeste"
  }, {
     "name": "Sao Lourenco Do Sul Airport",
     "countryCode": "BR",
     "iata": "SQY",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Lourenco Do Sul"
  }, {
     "name": "Santa Rosa Airport",
     "countryCode": "BR",
     "iata": "SRA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Santa Rosa"
  }, {
     "name": "Searcy Airport",
     "countryCode": "US",
     "iata": "SRC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Searcy"
  }, {
     "name": "San Ramon Airport",
     "countryCode": "BO",
     "iata": "SRD",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "San Ramon"
  }, {
     "name": "Juana Azurduy de Padilla International Airport",
     "countryCode": "BO",
     "iata": "SRE",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Sucre"
  }, {
     "name": "Achmad Yani International Airport",
     "countryCode": "ID",
     "iata": "SRG",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Semarang"
  }, {
     "name": "Sarh Airport",
     "countryCode": "TD",
     "iata": "SRH",
     "eucustoms": false,
     "countryDK": "Tchad",
     "cityDK": "Sarh"
  }, {
     "name": "Temindung Airport",
     "countryCode": "ID",
     "iata": "SRI",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Samarinda"
  }, {
     "name": "Capitan G Q Guardia Airport",
     "countryCode": "BO",
     "iata": "SRJ",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "San Borja"
  }, {
     "name": "Siorapaluk Heliport",
     "countryCode": "GL",
     "iata": "SRK",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Siorapaluk"
  }, {
     "name": "Strahan Airport",
     "countryCode": "AU",
     "iata": "SRN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Strahan"
  }, {
     "name": "Stord Airport",
     "countryCode": "NO",
     "iata": "SRP",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Stord"
  }, {
     "name": "Sarasota Bradenton International Airport",
     "countryCode": "US",
     "iata": "SRQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sarasota"
  }, {
     "name": "Soroti Airport",
     "countryCode": "UG",
     "iata": "SRT",
     "eucustoms": false,
     "countryDK": "Uganda",
     "cityDK": "Soroti"
  }, {
     "name": "Rowan County Airport",
     "countryCode": "US",
     "iata": "SRW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Salisbury"
  }, {
     "name": "Dashte Naz Airport",
     "countryCode": "IR",
     "iata": "SRY",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Sary"
  }, {
     "name": "El Trompillo Airport",
     "countryCode": "BO",
     "iata": "SRZ",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Santa Cruz"
  }, {
     "name": "Deputado Luis Eduardo Magalhaes International Airport",
     "countryCode": "BR",
     "iata": "SSA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Salvador"
  }, {
     "name": "Robert L. Bradshaw International Airport",
     "countryCode": "KN",
     "iata": "SKB",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Saint Kitts"
  }, {
     "name": "Shaw Air Force Base",
     "countryCode": "US",
     "iata": "SSC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sumter"
  }, {
     "name": "San Felipe Airport",
     "countryCode": "CO",
     "iata": "SSD",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "San Felipe"
  }, {
     "name": "Sholapur Airport",
     "countryCode": "IN",
     "iata": "SSE",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Sholapur"
  }, {
     "name": "Stinson Municipal Airport",
     "countryCode": "US",
     "iata": "SSF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "San Antonio"
  }, {
     "name": "Malabo Airport",
     "countryCode": "GQ",
     "iata": "SSG",
     "eucustoms": false,
     "countryDK": "Ækvatorialguinea",
     "cityDK": "Malabo"
  }, {
     "name": "Sharm El Sheikh Airport",
     "countryCode": "EG",
     "iata": "SSH",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Sharm el Sheikh"
  }, {
     "name": "McKinnon St. Simons Island Airport",
     "countryCode": "US",
     "iata": "SSI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Brunswick"
  }, {
     "name": "Stokka Airport",
     "countryCode": "NO",
     "iata": "SSJ",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Sandnessjøen"
  }, {
     "name": "Seoul Air Base",
     "countryCode": "KR",
     "iata": "SSN",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Seoul"
  }, {
     "name": "Sao Lourenzo Airport",
     "countryCode": "BR",
     "iata": "SSO",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Lourenzo"
  }, {
     "name": "La Sarre Airport",
     "countryCode": "CA",
     "iata": "SSQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "La Sarre"
  }, {
     "name": "Sara Airport",
     "countryCode": "VU",
     "iata": "SSR",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Arongbwaratu"
  }, {
     "name": "Santa Teresita Airport",
     "countryCode": "AR",
     "iata": "SST",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Santa Teresita"
  }, {
     "name": "Tres Lagoas Airport",
     "countryCode": "BR",
     "iata": "TJL",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Tres Lagoas"
  }, {
     "name": "M'Banza Congo Airport",
     "countryCode": "AO",
     "iata": "SSY",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "M'Banza Congo"
  }, {
     "name": "Base Aerea de Santos Airport",
     "countryCode": "BR",
     "iata": "SSZ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Santos"
  }, {
     "name": "Stauning Airport",
     "countryCode": "DK",
     "iata": "STA",
     "eucustoms": false,
     "countryDK": "Danmark",
     "cityDK": "Stauning"
  }, {
     "name": "L Delicias Airport",
     "countryCode": "VE",
     "iata": "STB",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Santa Barbara Ed"
  }, {
     "name": "St. Cloud Municipal Airport",
     "countryCode": "US",
     "iata": "STC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saint Cloud"
  }, {
     "name": "Mayo Guerrero Airport",
     "countryCode": "VE",
     "iata": "STD",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Santo Domingo"
  }, {
     "name": "Stevens Point Municipal Airport",
     "countryCode": "US",
     "iata": "STE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Stevens Point"
  }, {
     "name": "Cibao International Airport",
     "countryCode": "DO",
     "iata": "STI",
     "eucustoms": false,
     "countryDK": "Dominikanske Republik",
     "cityDK": "Santiago"
  }, {
     "name": "Rosecrans Memorial Airport",
     "countryCode": "US",
     "iata": "STJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saint Joseph"
  }, {
     "name": "Sterling Municipal Airport",
     "countryCode": "US",
     "iata": "STK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sterling"
  }, {
     "name": "Lambert-St. Louis International Airport",
     "countryCode": "US",
     "iata": "STL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saint Louis"
  }, {
     "name": "Maestro Wilson Fonseca Airport",
     "countryCode": "BR",
     "iata": "STM",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Santarem"
  }, {
     "name": "Stansted Airport",
     "countryCode": "GB",
     "iata": "STN",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "London"
  }, {
     "name": "St. Paul Downtown Airport",
     "countryCode": "US",
     "iata": "STP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saint Paul"
  }, {
     "name": "St. Marys Airport",
     "countryCode": "US",
     "iata": "STQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sainte Marys"
  }, {
     "name": "Stuttgart Airport",
     "countryCode": "DE",
     "iata": "STR",
     "eucustoms": true,
     "countryDK": "Tyskland",
     "cityDK": "Stuttgart"
  }, {
     "name": "Sonoma County Airport",
     "countryCode": "US",
     "iata": "STS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Santa Rosa"
  }, {
     "name": "Svalbard Airport",
     "countryCode": "SJ",
     "iata": "LYR",
     "eucustoms": false,
     "countryDK": "Svalbard",
     "cityDK": "Longyearbyen"
  }, {
     "name": "Stavropol Airport",
     "countryCode": "RU",
     "iata": "STW",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Stavropol"
  }, {
     "name": "Christiansted Harbor Seaplane Base",
     "countryCode": "VI",
     "iata": "SSB",
     "eucustoms": false,
     "countryDK": "Amerikanske Jomfruøer",
     "cityDK": "Saint Croix"
  }, {
     "name": "Salto Airport",
     "countryCode": "UY",
     "iata": "STY",
     "eucustoms": false,
     "countryDK": "Uruguay",
     "cityDK": "Salto"
  }, {
     "name": "Confresa Airport",
     "countryCode": "BR",
     "iata": "STZ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Santa Teresinha"
  }, {
     "name": "Witham Field",
     "countryCode": "US",
     "iata": "SUA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Stuart"
  }, {
     "name": "Juanda International Airport",
     "countryCode": "ID",
     "iata": "SUB",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Surabaya"
  }, {
     "name": "Stroud Airport",
     "countryCode": "US",
     "iata": "SUD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Stroud"
  }, {
     "name": "Door County Airport",
     "countryCode": "US",
     "iata": "SUE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sturgeon Bay"
  }, {
     "name": "Lamezia Terme International Airport",
     "countryCode": "IT",
     "iata": "SUF",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Lamezia-Terme"
  }, {
     "name": "Surigao Airport",
     "countryCode": "PH",
     "iata": "SUG",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Surigao"
  }, {
     "name": "Babusheri Airport",
     "countryCode": "GE",
     "iata": "SUI",
     "eucustoms": false,
     "countryDK": "Georgien",
     "cityDK": "Sukhumi"
  }, {
     "name": "Satu Mare International Airport",
     "countryCode": "RO",
     "iata": "SUJ",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Satu Mare"
  }, {
     "name": "Sui Airport",
     "countryCode": "PK",
     "iata": "SUL",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Sui"
  }, {
     "name": "Sumter Municipal Airport",
     "countryCode": "US",
     "iata": "SUM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sumter"
  }, {
     "name": "Friedman Memorial Airport",
     "countryCode": "US",
     "iata": "SUN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sun Valley"
  }, {
     "name": "Sucua Airport",
     "countryCode": "EC",
     "iata": "SUQ",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Sucua"
  }, {
     "name": "Summer Beaver Airport",
     "countryCode": "CA",
     "iata": "SUR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Summer Beaver"
  }, {
     "name": "Spirit of St. Louis Airport",
     "countryCode": "US",
     "iata": "SUS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saint Louis"
  }, {
     "name": "Sumbawanga Airport",
     "countryCode": "TZ",
     "iata": "SUT",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Sumbawanga"
  }, {
     "name": "Travis Air Force Base",
     "countryCode": "US",
     "iata": "SUU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fairfield"
  }, {
     "name": "Nausori Airport",
     "countryCode": "FJ",
     "iata": "SUV",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Suva"
  }, {
     "name": "Richard I Bong Airport",
     "countryCode": "US",
     "iata": "SUW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Overlegen"
  }, {
     "name": "Sioux Gateway Airport",
     "countryCode": "US",
     "iata": "SUX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sioux City"
  }, {
     "name": "Suntar Airport",
     "countryCode": "RU",
     "iata": "SUY",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "suntar"
  }, {
     "name": "Savoonga Airport",
     "countryCode": "US",
     "iata": "SVA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Savoonga"
  }, {
     "name": "Sambava Airport",
     "countryCode": "MG",
     "iata": "SVB",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Sambava"
  }, {
     "name": "Grant County Airport",
     "countryCode": "US",
     "iata": "SVC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Silver City"
  }, {
     "name": "Argyle International Airport",
     "countryCode": "VC",
     "iata": "SVD",
     "eucustoms": false,
     "countryDK": "Saint Vincent og Grenadinerne",
     "cityDK": "Saint Vincent"
  }, {
     "name": "Susanville Airport",
     "countryCode": "US",
     "iata": "SVE",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Susanville"
  }, {
     "name": "Stavanger Airport Sola",
     "countryCode": "NO",
     "iata": "SVG",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Stavanger"
  }, {
     "name": "Statesville Municipal Airport",
     "countryCode": "US",
     "iata": "SVH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Statesville"
  }, {
     "name": "Eduardo Falla Solano Airport",
     "countryCode": "CO",
     "iata": "SVI",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "San Vicente del Caguan"
  }, {
     "name": "Helle Airport",
     "countryCode": "NO",
     "iata": "SVJ",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Svolvaer"
  }, {
     "name": "Savonlinna Airport",
     "countryCode": "FI",
     "iata": "SVL",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Savonlinna"
  }, {
     "name": "Hunter Air Force Base",
     "countryCode": "US",
     "iata": "SVN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Savannah"
  }, {
     "name": "Sheremetyevo International Airport",
     "countryCode": "RU",
     "iata": "SVO",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Moskva"
  }, {
     "name": "Kuito Airport",
     "countryCode": "AO",
     "iata": "SVP",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Kuito"
  }, {
     "name": "Seville Airport",
     "countryCode": "ES",
     "iata": "SVQ",
     "eucustoms": true,
     "countryDK": "Spanien",
     "cityDK": "Sevilla"
  }, {
     "name": "Savissivik Heliport",
     "countryCode": "GL",
     "iata": "SVR",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Savissivik"
  }, {
     "name": "Savusavu Airport",
     "countryCode": "FJ",
     "iata": "SVU",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Savusavu"
  }, {
     "name": "Sparrevohn Air Force Station",
     "countryCode": "US",
     "iata": "SVW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sparrevohn"
  }, {
     "name": "Koltsovo International Airport",
     "countryCode": "RU",
     "iata": "SVX",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Jekaterinburg"
  }, {
     "name": "Juan Vicente Gomez International Airport",
     "countryCode": "VE",
     "iata": "SVZ",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "San Antonio del Tachira"
  }, {
     "name": "Jieyang Chaoshan Airport",
     "countryCode": "CN",
     "iata": "SWA",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Jieyang"
  }, {
     "name": "Stawell Airport",
     "countryCode": "AU",
     "iata": "SWC",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Stawell"
  }, {
     "name": "Seward Airport",
     "countryCode": "US",
     "iata": "SWD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Seward"
  }, {
     "name": "Stewart International Airport",
     "countryCode": "US",
     "iata": "SWF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Newburgh"
  }, {
     "name": "Swan Hill Airport",
     "countryCode": "AU",
     "iata": "SWH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Swan Hill"
  }, {
     "name": "Humaita Airport",
     "countryCode": "BR",
     "iata": "HUW",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Humaita"
  }, {
     "name": "South West Bay Airport",
     "countryCode": "VU",
     "iata": "SWJ",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "South West Bay"
  }, {
     "name": "Searcy Field",
     "countryCode": "US",
     "iata": "SWO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Stillwater"
  }, {
     "name": "Swakopmund Airport",
     "countryCode": "NA",
     "iata": "SWP",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Swakopmund"
  }, {
     "name": "Sultan Muhammad Kaharuddin III Airport",
     "countryCode": "ID",
     "iata": "SWQ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Sumbawa Besar"
  }, {
     "name": "Swansea Airport",
     "countryCode": "GB",
     "iata": "SWS",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Swansea"
  }, {
     "name": "Strezhevoy Airport",
     "countryCode": "RU",
     "iata": "SWT",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Strezhevoy"
  }, {
     "name": "Suwon Air Base",
     "countryCode": "KR",
     "iata": "SWU",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Suwon"
  }, {
     "name": "Avenger Field",
     "countryCode": "US",
     "iata": "SWW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sweetwater"
  }, {
     "name": "Shakawe Airport",
     "countryCode": "BW",
     "iata": "SWX",
     "eucustoms": false,
     "countryDK": "Botswana",
     "cityDK": "Shakawe"
  }, {
     "name": "Strasbourg Airport",
     "countryCode": "FR",
     "iata": "SXB",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Strasbourg"
  }, {
     "name": "Sale Airport",
     "countryCode": "AU",
     "iata": "SXE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Salg"
  }, {
     "name": "Schonefeld Airport",
     "countryCode": "DE",
     "iata": "SXF",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Berlin"
  }, {
     "name": "Senanga Airport",
     "countryCode": "ZM",
     "iata": "SXG",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Senanga"
  }, {
     "name": "Sirri Island Airport",
     "countryCode": "IR",
     "iata": "SXI",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Sirri Island"
  }, {
     "name": "Saumlaki Olilit Airport",
     "countryCode": "ID",
     "iata": "SXK",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Saumlaki"
  }, {
     "name": "Collooney Airport",
     "countryCode": "IE",
     "iata": "SXL",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Sligo"
  }, {
     "name": "Cyril E. King Airport",
     "countryCode": "VI",
     "iata": "STT",
     "eucustoms": false,
     "countryDK": "Amerikanske Jomfruøer",
     "cityDK": "Saint Thomas"
  }, {
     "name": "Sao Felix Do Araguaia Airport",
     "countryCode": "BR",
     "iata": "SXO",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Felix Do Araguaia"
  }, {
     "name": "Soldotna Airport",
     "countryCode": "US",
     "iata": "SXQ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Soldotna"
  }, {
     "name": "Srinagar International Airport",
     "countryCode": "IN",
     "iata": "SXR",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Srinagar"
  }, {
     "name": "Soddu Airport",
     "countryCode": "ET",
     "iata": "SXU",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Soddu"
  }, {
     "name": "Salem Airport",
     "countryCode": "IN",
     "iata": "SXV",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Salem"
  }, {
     "name": "Sao Felix Do Xingu Airport",
     "countryCode": "BR",
     "iata": "SXX",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Sao Felix Do Xingu"
  }, {
     "name": "Siirt Airport",
     "countryCode": "TR",
     "iata": "SXZ",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Siirt"
  }, {
     "name": "Shemya Air Force Base",
     "countryCode": "US",
     "iata": "SYA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Shemya"
  }, {
     "name": "Shiringayoc O Hda Mejia",
     "countryCode": "PE",
     "iata": "SYC",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Leon Velarde"
  }, {
     "name": "Sydney (Kingsford Smith) Airport",
     "countryCode": "AU",
     "iata": "SYD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Sydney"
  }, {
     "name": "Sadah Airport",
     "countryCode": "YE",
     "iata": "SYE",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Sadah"
  }, {
     "name": "Shelbyville Municipal Airport-Bomar Field",
     "countryCode": "US",
     "iata": "SYI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Shelbyville"
  }, {
     "name": "Sirjan Airport",
     "countryCode": "IR",
     "iata": "SYJ",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Sirjan"
  }, {
     "name": "Stykkisholmur Airport",
     "countryCode": "IS",
     "iata": "SYK",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Stykkisholmur"
  }, {
     "name": "Pu'er Simao Airport",
     "countryCode": "CN",
     "iata": "SYM",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Pu'er"
  }, {
     "name": "Carleton Airport",
     "countryCode": "US",
     "iata": "SYN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Stanton"
  }, {
     "name": "Shonai Airport",
     "countryCode": "JP",
     "iata": "SYO",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Shonai"
  }, {
     "name": "Hancock International Airport",
     "countryCode": "US",
     "iata": "SYR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Syracuse"
  }, {
     "name": "Sylvester Airport",
     "countryCode": "US",
     "iata": "SYV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sylvester"
  }, {
     "name": "Sanya Phoenix International Airport",
     "countryCode": "CN",
     "iata": "SYX",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Sanya"
  }, {
     "name": "Stornoway Airport",
     "countryCode": "GB",
     "iata": "SYY",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Stornoway, Outer Stat Hebrides"
  }, {
     "name": "Shiraz International Airport",
     "countryCode": "IR",
     "iata": "SYZ",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Shiraz"
  }, {
     "name": "Soyo Airport",
     "countryCode": "AO",
     "iata": "SZA",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Soyo"
  }, {
     "name": "Sultan Abdul Aziz Shah Airport",
     "countryCode": "MY",
     "iata": "SZB",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Kuala Lumpur"
  }, {
     "name": "Sheffield City Airport",
     "countryCode": "GB",
     "iata": "SZD",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Sheffield"
  }, {
     "name": "Samsun-Carsamba Airport",
     "countryCode": "TR",
     "iata": "SZF",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Samsun"
  }, {
     "name": "W. A. Mozart Salzburg Airport",
     "countryCode": "AT",
     "iata": "SZG",
     "eucustoms": true,
     "countryDK": "Østrig",
     "cityDK": "Salzburg"
  }, {
     "name": "Siguanea Airport",
     "countryCode": "CU",
     "iata": "SZJ",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Siguanea"
  }, {
     "name": "Skukuza Airport",
     "countryCode": "ZA",
     "iata": "SZK",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Skukuza"
  }, {
     "name": "Whiteman Air Force Base",
     "countryCode": "US",
     "iata": "SZL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Warrensburg"
  }, {
     "name": "Santa Paula Airport",
     "countryCode": "US",
     "iata": "SZP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Santa Paula"
  }, {
     "name": "San Cristobal de las Casas Airport",
     "countryCode": "MX",
     "iata": "SZT",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "San Cristobal de las Casas"
  }, {
     "name": "Parchim Airport",
     "countryCode": "DE",
     "iata": "SZW",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Schwerin"
  }, {
     "name": "Shenzhen Bao'an International Airport",
     "countryCode": "CN",
     "iata": "SZX",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Shenzhen"
  }, {
     "name": "Mazury Airport",
     "countryCode": "PL",
     "iata": "SZY",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Szymany"
  }, {
     "name": "Goleniow Airport",
     "countryCode": "PL",
     "iata": "SZZ",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Szczecin"
  }, {
     "name": "A.N.R. Robinson International Airport",
     "countryCode": "TT",
     "iata": "TAB",
     "eucustoms": false,
     "countryDK": "Trinidad og Tobago",
     "cityDK": "Tobago"
  }, {
     "name": "D. Z. Romualdez Airport",
     "countryCode": "PH",
     "iata": "TAC",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Tacloban"
  }, {
     "name": "Perry Stokes Municipal Airport",
     "countryCode": "US",
     "iata": "TAD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Trinidad"
  }, {
     "name": "Daegu International Airport",
     "countryCode": "KR",
     "iata": "TAE",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Daegu"
  }, {
     "name": "Tafaraoui Airport",
     "countryCode": "DZ",
     "iata": "TAF",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Oran"
  }, {
     "name": "Tagbilaran Airport",
     "countryCode": "PH",
     "iata": "TAG",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Tagbilaran"
  }, {
     "name": "Al Janad Airport",
     "countryCode": "YE",
     "iata": "TAI",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Taiz"
  }, {
     "name": "Takamatsu Airport",
     "countryCode": "JP",
     "iata": "TAK",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Takamatsu"
  }, {
     "name": "Ralph M Calhoun Airport",
     "countryCode": "US",
     "iata": "TAL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tanana"
  }, {
     "name": "Tampico International Airport",
     "countryCode": "MX",
     "iata": "TAM",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Tampico"
  }, {
     "name": "Qingdao Liuting International Airport",
     "countryCode": "CN",
     "iata": "TAO",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Qingdao"
  }, {
     "name": "Tapachula International Airport",
     "countryCode": "MX",
     "iata": "TAP",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Tapachula"
  }, {
     "name": "Taranto-Grottaglie Airport",
     "countryCode": "IT",
     "iata": "TAR",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Taranto"
  }, {
     "name": "Tashkent International Airport",
     "countryCode": "UZ",
     "iata": "TAS",
     "eucustoms": false,
     "countryDK": "Usbekistan",
     "cityDK": "Tashkent"
  }, {
     "name": "Poprad/Tatry Airport",
     "countryCode": "SK",
     "iata": "TAT",
     "eucustoms": false,
     "countryDK": "Slovakiet",
     "cityDK": "Poprad / Tatry"
  }, {
     "name": "Tacuarembo Airport",
     "countryCode": "UY",
     "iata": "TAW",
     "eucustoms": false,
     "countryDK": "Uruguay",
     "cityDK": "Tacuarembo"
  }, {
     "name": "Tartu Airport",
     "countryCode": "EE",
     "iata": "TAY",
     "eucustoms": false,
     "countryDK": "Estland",
     "cityDK": "Tartu"
  }, {
     "name": "Dashoguz Airport",
     "countryCode": "TM",
     "iata": "TAZ",
     "eucustoms": false,
     "countryDK": "Turkmenistan",
     "cityDK": "Dashoguz"
  }, {
     "name": "Tugdan Airport",
     "countryCode": "PH",
     "iata": "TBH",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Barangay Tugdan"
  }, {
     "name": "New Bight Airport",
     "countryCode": "BS",
     "iata": "TBI",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Cat Island"
  }, {
     "name": "Tabarka-Ain Draham Airport",
     "countryCode": "TN",
     "iata": "TBJ",
     "eucustoms": false,
     "countryDK": "Tunesien",
     "cityDK": "Tabarka"
  }, {
     "name": "Timber Creek Airport",
     "countryCode": "AU",
     "iata": "TBK",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Timber Creek"
  }, {
     "name": "Waynesville-St. Robert Regional Airport",
     "countryCode": "US",
     "iata": "TBN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Leonard Wood"
  }, {
     "name": "Tabora Airport",
     "countryCode": "TZ",
     "iata": "TBO",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Tabora"
  }, {
     "name": "Capitan FAP Pedro Canga Rodriguez Airport",
     "countryCode": "PE",
     "iata": "TBP",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Tumbes"
  }, {
     "name": "Statesboro-Bulloch County Airport",
     "countryCode": "US",
     "iata": "TBR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Statesboro"
  }, {
     "name": "Tbilisi International Airport",
     "countryCode": "GE",
     "iata": "TBS",
     "eucustoms": false,
     "countryDK": "Georgien",
     "cityDK": "Tbilisi"
  }, {
     "name": "Tabatinga International Airport",
     "countryCode": "BR",
     "iata": "TBT",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Tabatinga"
  }, {
     "name": "Fua'amotu International Airport",
     "countryCode": "TO",
     "iata": "TBU",
     "eucustoms": false,
     "countryDK": "Tonga",
     "cityDK": "Nuku'alofa"
  }, {
     "name": "Tsabong Airport",
     "countryCode": "BW",
     "iata": "TBY",
     "eucustoms": false,
     "countryDK": "Botswana",
     "cityDK": "Tshabong"
  }, {
     "name": "Tabriz Airport",
     "countryCode": "IR",
     "iata": "TBZ",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Tabriz"
  }, {
     "name": "Tennant Creek Airport",
     "countryCode": "AU",
     "iata": "TCA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Tennant Creek"
  }, {
     "name": "Treasure Cay Airport",
     "countryCode": "BS",
     "iata": "TCB",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Treasure Cay"
  }, {
     "name": "Tucumcari Airport",
     "countryCode": "US",
     "iata": "TCC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tucumcari"
  }, {
     "name": "Tulcea Airport",
     "countryCode": "RO",
     "iata": "TCE",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Tulcea"
  }, {
     "name": "Tacheng Airport",
     "countryCode": "CN",
     "iata": "TCG",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Tacheng"
  }, {
     "name": "Tchibanga Airport",
     "countryCode": "GA",
     "iata": "TCH",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Tchibanga"
  }, {
     "name": "Tuscaloosa Regional Airport",
     "countryCode": "US",
     "iata": "TCL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tuscaloosa"
  }, {
     "name": "McChord Field",
     "countryCode": "US",
     "iata": "TCM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tacoma"
  }, {
     "name": "Tehuacan Airport",
     "countryCode": "MX",
     "iata": "TCN",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Tehuacán"
  }, {
     "name": "La Florida Airport",
     "countryCode": "CO",
     "iata": "TCO",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Tumaco"
  }, {
     "name": "Taba International Airport",
     "countryCode": "EG",
     "iata": "TCP",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "Taba"
  }, {
     "name": "Tacna Airport",
     "countryCode": "PE",
     "iata": "TCQ",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Tacna"
  }, {
     "name": "Truth Or Consequences Municipal Airport",
     "countryCode": "US",
     "iata": "TCS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sandhed eller konsekvenser"
  }, {
     "name": "Tocumwal Airport",
     "countryCode": "AU",
     "iata": "TCW",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Tocumwal"
  }, {
     "name": "Tabas Airport",
     "countryCode": "IR",
     "iata": "TCX",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Tabas"
  }, {
     "name": "Tengchong Tuofeng Airport",
     "countryCode": "CN",
     "iata": "TCZ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Tengchong"
  }, {
     "name": "Trinidad Airport",
     "countryCode": "CO",
     "iata": "TDA",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Trinidad"
  }, {
     "name": "Teniente Jorge Henrich Arauz Airport",
     "countryCode": "BO",
     "iata": "TDD",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Trinidad"
  }, {
     "name": "Tandag Airport",
     "countryCode": "PH",
     "iata": "TDG",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Tandag"
  }, {
     "name": "Tadjoura Airport",
     "countryCode": "DJ",
     "iata": "TDJ",
     "eucustoms": false,
     "countryDK": "Djibouti",
     "cityDK": "Tadjoura"
  }, {
     "name": "Taldykorgan Airport",
     "countryCode": "KZ",
     "iata": "TDK",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Taldykorgan"
  }, {
     "name": "Tandil Airport",
     "countryCode": "AR",
     "iata": "TDL",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Tandil"
  }, {
     "name": "Winlock Airport",
     "countryCode": "US",
     "iata": "TDO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Toledo"
  }, {
     "name": "Theodore Airport",
     "countryCode": "AU",
     "iata": "TDR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Theodore"
  }, {
     "name": "Tanandava Airport",
     "countryCode": "MG",
     "iata": "TDV",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Tanandava"
  }, {
     "name": "Tradewind Airport",
     "countryCode": "US",
     "iata": "TDW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Amarillo"
  }, {
     "name": "Toledo Executive Airport",
     "countryCode": "US",
     "iata": "TDZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Toledo"
  }, {
     "name": "Tela Airport",
     "countryCode": "HN",
     "iata": "TEA",
     "eucustoms": false,
     "countryDK": "Honduras",
     "cityDK": "Tela"
  }, {
     "name": "Teterboro Airport",
     "countryCode": "US",
     "iata": "TEB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Teterboro"
  }, {
     "name": "Telemaco Borba Airport",
     "countryCode": "BR",
     "iata": "TEC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Telemaco Borba"
  }, {
     "name": "Thisted Airport",
     "countryCode": "DK",
     "iata": "TED",
     "eucustoms": false,
     "countryDK": "Danmark",
     "cityDK": "Thisted"
  }, {
     "name": "Cheikh Larbi Tebessi Airport",
     "countryCode": "DZ",
     "iata": "TEE",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Tebessa"
  }, {
     "name": "Telfer Airport",
     "countryCode": "AU",
     "iata": "TEF",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Telfer"
  }, {
     "name": "Tenkodogo Airport",
     "countryCode": "BF",
     "iata": "TEG",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Tenkodogo"
  }, {
     "name": "Temora Airport",
     "countryCode": "AU",
     "iata": "TEM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Temora"
  }, {
     "name": "Corlu Airport",
     "countryCode": "TR",
     "iata": "TEQ",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Tekirdag"
  }, {
     "name": "Lajes Field",
     "countryCode": "PT",
     "iata": "TER",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Terceira"
  }, {
     "name": "Tessenei Airport",
     "countryCode": "ER",
     "iata": "TES",
     "eucustoms": false,
     "countryDK": "Eritrea",
     "cityDK": "Tessenei"
  }, {
     "name": "Matundo Airport",
     "countryCode": "MZ",
     "iata": "TET",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Tete"
  }, {
     "name": "Manapouri Airport",
     "countryCode": "NZ",
     "iata": "TEU",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Te Anau"
  }, {
     "name": "Telluride Regional Airport",
     "countryCode": "US",
     "iata": "TEX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Telluride"
  }, {
     "name": "Thingeyri Airport",
     "countryCode": "IS",
     "iata": "TEY",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Thingeyri"
  }, {
     "name": "Tefe Airport",
     "countryCode": "BR",
     "iata": "TFF",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Tefe"
  }, {
     "name": "Tenerife North Airport",
     "countryCode": "ES",
     "iata": "TFN",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Tenerife"
  }, {
     "name": "Tenerife South Airport",
     "countryCode": "ES",
     "iata": "TFS",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Tenerife"
  }, {
     "name": "Tengah Airport",
     "countryCode": "SG",
     "iata": "TGA",
     "eucustoms": false,
     "countryDK": "Singapore",
     "cityDK": "Singapore"
  }, {
     "name": "Tanjung Manis Airport",
     "countryCode": "MY",
     "iata": "TGC",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Sarikei"
  }, {
     "name": "Podgorica Airport",
     "countryCode": "ME",
     "iata": "TGD",
     "eucustoms": false,
     "countryDK": "Montenegro",
     "cityDK": "Podgorica"
  }, {
     "name": "Sultan Mahmud Airport",
     "countryCode": "MY",
     "iata": "TGG",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Kuala Terengganu"
  }, {
     "name": "Tongoa Airport",
     "countryCode": "VU",
     "iata": "TGH",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Tongoa"
  }, {
     "name": "Tingo Maria Airport",
     "countryCode": "PE",
     "iata": "TGI",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Tingo Maria"
  }, {
     "name": "Tiga Airport",
     "countryCode": "NC",
     "iata": "TGJ",
     "eucustoms": false,
     "countryDK": "Ny Kaledonien",
     "cityDK": "Tiga"
  }, {
     "name": "Taganrog Yuzhny Airport",
     "countryCode": "RU",
     "iata": "TGK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Taganrog"
  }, {
     "name": "Transilvania Airport",
     "countryCode": "RO",
     "iata": "TGM",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Targu-Mures"
  }, {
     "name": "Tongliao Airport",
     "countryCode": "CN",
     "iata": "TGO",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Tongliao"
  }, {
     "name": "Podkamennaya Tunguska Airport",
     "countryCode": "RU",
     "iata": "TGP",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Bor"
  }, {
     "name": "Touggourt Airport",
     "countryCode": "DZ",
     "iata": "TGR",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Touggourt"
  }, {
     "name": "Tanga Airport",
     "countryCode": "TZ",
     "iata": "TGT",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Tanga"
  }, {
     "name": "Toncontin Airport",
     "countryCode": "HN",
     "iata": "TGU",
     "eucustoms": false,
     "countryDK": "Honduras",
     "cityDK": "Tegucigalpa"
  }, {
     "name": "Angel Albino Corzo International Airport",
     "countryCode": "MX",
     "iata": "TGZ",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Tuxtla Gutierrez"
  }, {
     "name": "Northern Airport",
     "countryCode": "US",
     "iata": "THA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tullahoma"
  }, {
     "name": "Tchien Airport",
     "countryCode": "LR",
     "iata": "THC",
     "eucustoms": false,
     "countryDK": "Liberia",
     "cityDK": "Tchien"
  }, {
     "name": "Teresina Airport",
     "countryCode": "BR",
     "iata": "THE",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Teresina"
  }, {
     "name": "Thangool Airport",
     "countryCode": "AU",
     "iata": "THG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Thangool"
  }, {
     "name": "Tichitt Airport",
     "countryCode": "MR",
     "iata": "THI",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Tichitt"
  }, {
     "name": "Thakhek Airport",
     "countryCode": "LA",
     "iata": "THK",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Thakhek"
  }, {
     "name": "Tachilek Airport",
     "countryCode": "MM",
     "iata": "THL",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Tachilek"
  }, {
     "name": "Trollhattan Airport",
     "countryCode": "SE",
     "iata": "THN",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Trollhättan"
  }, {
     "name": "Thorshofn Airport",
     "countryCode": "IS",
     "iata": "THO",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Thorshofn"
  }, {
     "name": "Hot Springs Airport",
     "countryCode": "US",
     "iata": "THP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Thermopolis"
  }, {
     "name": "Mehrabad International Airport",
     "countryCode": "IR",
     "iata": "THR",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Teheran"
  }, {
     "name": "Sukhothai Airport",
     "countryCode": "TH",
     "iata": "THS",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Sukhothai"
  }, {
     "name": "Tamchakett Airport",
     "countryCode": "MR",
     "iata": "THT",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Tamchakett"
  }, {
     "name": "Thule Air Base",
     "countryCode": "GL",
     "iata": "THU",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Pituffik"
  }, {
     "name": "York Airport",
     "countryCode": "US",
     "iata": "THV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "York"
  }, {
     "name": "Turukhansk Airport",
     "countryCode": "RU",
     "iata": "THX",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Turukhansk"
  }, {
     "name": "Tahoua Airport",
     "countryCode": "NE",
     "iata": "THZ",
     "eucustoms": false,
     "countryDK": "Niger",
     "cityDK": "Tahoua"
  }, {
     "name": "Tirana International Airport",
     "countryCode": "AL",
     "iata": "TIA",
     "eucustoms": false,
     "countryDK": "Albanien",
     "cityDK": "Tirana"
  }, {
     "name": "Tibu Airport",
     "countryCode": "CO",
     "iata": "TIB",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Tibu"
  }, {
     "name": "Bouchekif Airport",
     "countryCode": "DZ",
     "iata": "TID",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Tiaret"
  }, {
     "name": "Tippi Airport",
     "countryCode": "ET",
     "iata": "TIE",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "Tippi"
  }, {
     "name": "Taif Airport",
     "countryCode": "SA",
     "iata": "TIF",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Taif"
  }, {
     "name": "Tikehau Atoll Airport",
     "countryCode": "PF",
     "iata": "TIH",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Tikehau Atoll"
  }, {
     "name": "Tereen Airport",
     "countryCode": "AF",
     "iata": "TII",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Tarin Kot"
  }, {
     "name": "Tijuana Airport",
     "countryCode": "MX",
     "iata": "TIJ",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Tijuana"
  }, {
     "name": "Tinker Air Force Base",
     "countryCode": "US",
     "iata": "TIK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oklahoma City"
  }, {
     "name": "Timika Airport",
     "countryCode": "ID",
     "iata": "TIM",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Tembagapura"
  }, {
     "name": "Tindouf Airport",
     "countryCode": "DZ",
     "iata": "TIN",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Tindouf"
  }, {
     "name": "Tripoli International Airport",
     "countryCode": "LY",
     "iata": "TIP",
     "eucustoms": false,
     "countryDK": "Libyen",
     "cityDK": "Tripoli"
  }, {
     "name": "Henry E. Rohlsen Airport",
     "countryCode": "VI",
     "iata": "STX",
     "eucustoms": false,
     "countryDK": "Amerikanske Jomfruøer",
     "cityDK": "Saint Croix"
  }, {
     "name": "Tirupati Airport",
     "countryCode": "IN",
     "iata": "TIR",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Tirupati"
  }, {
     "name": "Thursday Island Airport",
     "countryCode": "AU",
     "iata": "TIS",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Torsdag ø"
  }, {
     "name": "Timaru Airport",
     "countryCode": "NZ",
     "iata": "TIU",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Timaru"
  }, {
     "name": "Tivat Airport",
     "countryCode": "ME",
     "iata": "TIV",
     "eucustoms": false,
     "countryDK": "Montenegro",
     "cityDK": "Tivat"
  }, {
     "name": "Tacoma Narrows Airport",
     "countryCode": "US",
     "iata": "TIW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tacoma"
  }, {
     "name": "Space Center Executive Airport",
     "countryCode": "US",
     "iata": "TIX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Titusville"
  }, {
     "name": "Tidjikja Airport",
     "countryCode": "MR",
     "iata": "TIY",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Tidjikdja"
  }, {
     "name": "Capitan Oriel Lea Plaza Airport",
     "countryCode": "BO",
     "iata": "TJA",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Tarija"
  }, {
     "name": "Warukin Airport",
     "countryCode": "ID",
     "iata": "TJG",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Tanjung"
  }, {
     "name": "Tajima Airport",
     "countryCode": "JP",
     "iata": "TJH",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Toyooka"
  }, {
     "name": "Tokat Airport",
     "countryCode": "TR",
     "iata": "TJK",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Tokat"
  }, {
     "name": "Roshchino International Airport",
     "countryCode": "RU",
     "iata": "TJM",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Tyumen"
  }, {
     "name": "Takume Airport",
     "countryCode": "PF",
     "iata": "TJN",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Takume"
  }, {
     "name": "Bulutumbang Airport",
     "countryCode": "ID",
     "iata": "TJQ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Tanjung Pandan"
  }, {
     "name": "Tanjung Harapan Airport",
     "countryCode": "ID",
     "iata": "TJS",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Tanjung Selor"
  }, {
     "name": "Kulyab Airport",
     "countryCode": "TJ",
     "iata": "TJU",
     "eucustoms": false,
     "countryDK": "Tadsjikistan",
     "cityDK": "Kulyab"
  }, {
     "name": "Talkeetna Airport",
     "countryCode": "US",
     "iata": "TKA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Talkeetna"
  }, {
     "name": "Tiko Airport",
     "countryCode": "CM",
     "iata": "TKC",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Tiko"
  }, {
     "name": "Takoradi Airport",
     "countryCode": "GH",
     "iata": "TKD",
     "eucustoms": false,
     "countryDK": "Ghana",
     "cityDK": "Takoradi"
  }, {
     "name": "Truckee Tahoe Airport",
     "countryCode": "US",
     "iata": "TKF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Truckee"
  }, {
     "name": "Radin Inten II Airport",
     "countryCode": "ID",
     "iata": "TKG",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Bandar Lampung"
  }, {
     "name": "Takhli Airport",
     "countryCode": "TH",
     "iata": "TKH",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Takhli"
  }, {
     "name": "Tok Airport",
     "countryCode": "US",
     "iata": "TKJ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tok"
  }, {
     "name": "Chuuk International Airport",
     "countryCode": "FM",
     "iata": "TKK",
     "eucustoms": false,
     "countryDK": "Mikronesien",
     "cityDK": "Truk, Caroline Islands"
  }, {
     "name": "Tokunoshima Airport",
     "countryCode": "JP",
     "iata": "TKN",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Tokunoshima"
  }, {
     "name": "Takapoto Airport",
     "countryCode": "PF",
     "iata": "TKP",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Takapoto"
  }, {
     "name": "Kigoma Airport",
     "countryCode": "TZ",
     "iata": "TKQ",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Kigoma"
  }, {
     "name": "Tokushima Awaodori Airport",
     "countryCode": "JP",
     "iata": "TKS",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Tokushima"
  }, {
     "name": "Tak Airport",
     "countryCode": "TH",
     "iata": "TKT",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Tak"
  }, {
     "name": "Turku Airport",
     "countryCode": "FI",
     "iata": "TKU",
     "eucustoms": true,
     "countryDK": "Finland",
     "cityDK": "Turku"
  }, {
     "name": "Takaroa Airport",
     "countryCode": "PF",
     "iata": "TKX",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Takaroa"
  }, {
     "name": "Tokoroa Airfield",
     "countryCode": "NZ",
     "iata": "TKZ",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Tokoroa"
  }, {
     "name": "Toluca International Airport",
     "countryCode": "MX",
     "iata": "TLC",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Toluca"
  }, {
     "name": "Limpopo Valley Airfield",
     "countryCode": "BW",
     "iata": "TLD",
     "eucustoms": false,
     "countryDK": "Botswana",
     "cityDK": "Tuli Block"
  }, {
     "name": "Toliara Airport",
     "countryCode": "MG",
     "iata": "TLE",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Toliara"
  }, {
     "name": "Tallahassee International Airport",
     "countryCode": "US",
     "iata": "TLH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tallahassee"
  }, {
     "name": "Sultan Bantilan Airport",
     "countryCode": "ID",
     "iata": "TLI",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Toli Toli"
  }, {
     "name": "Tallinn Airport",
     "countryCode": "EE",
     "iata": "TLL",
     "eucustoms": false,
     "countryDK": "Estland",
     "cityDK": "Tallinn"
  }, {
     "name": "Zenata Airport",
     "countryCode": "DZ",
     "iata": "TLM",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Tlemcen"
  }, {
     "name": "Hyeres Airport",
     "countryCode": "FR",
     "iata": "TLN",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Toulon"
  }, {
     "name": "Turpan Jiaohe Airport",
     "countryCode": "CN",
     "iata": "TLQ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Turpan"
  }, {
     "name": "Mefford Field",
     "countryCode": "US",
     "iata": "TLR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tulare"
  }, {
     "name": "Toulouse-Blagnac Airport",
     "countryCode": "FR",
     "iata": "TLS",
     "eucustoms": true,
     "countryDK": "Frankrig",
     "cityDK": "Toulouse"
  }, {
     "name": "Golfo de Morrosquillo Airport",
     "countryCode": "CO",
     "iata": "TLU",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Tolu"
  }, {
     "name": "Ben Gurion International Airport",
     "countryCode": "IL",
     "iata": "TLV",
     "eucustoms": false,
     "countryDK": "Israel",
     "cityDK": "Tel Aviv-Yafo"
  }, {
     "name": "Talca Airport",
     "countryCode": "CL",
     "iata": "TLX",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Talca"
  }, {
     "name": "Plastun Airport",
     "countryCode": "RU",
     "iata": "TLY",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Plastun"
  }, {
     "name": "Henry Tift Myers Airport",
     "countryCode": "US",
     "iata": "TMA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tifton"
  }, {
     "name": "Kendall-Tamiami Executive Airport",
     "countryCode": "US",
     "iata": "TMB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Miami"
  }, {
     "name": "Timbedra Airport",
     "countryCode": "MR",
     "iata": "TMD",
     "eucustoms": false,
     "countryDK": "Mauretanien",
     "cityDK": "Timbedra"
  }, {
     "name": "Gabriel Vargas Santos Airport",
     "countryCode": "CO",
     "iata": "TME",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Tame"
  }, {
     "name": "Tumling Tar Airport",
     "countryCode": "NP",
     "iata": "TMI",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Tumling Tar"
  }, {
     "name": "Termez Airport",
     "countryCode": "UZ",
     "iata": "TMJ",
     "eucustoms": false,
     "countryDK": "Usbekistan",
     "cityDK": "Termez"
  }, {
     "name": "Tamale Airport",
     "countryCode": "GH",
     "iata": "TML",
     "eucustoms": false,
     "countryDK": "Ghana",
     "cityDK": "Tamale"
  }, {
     "name": "Tamatave Airport",
     "countryCode": "MG",
     "iata": "TMM",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Tamatave"
  }, {
     "name": "Tumeremo Airport",
     "countryCode": "VE",
     "iata": "TMO",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Tumeremo"
  }, {
     "name": "Tampere-Pirkkala Airport",
     "countryCode": "FI",
     "iata": "TMP",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Tampere"
  }, {
     "name": "Aguenar Airport",
     "countryCode": "DZ",
     "iata": "TMR",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Tamanrasset"
  }, {
     "name": "Sao Tome Island Airport",
     "countryCode": "ST",
     "iata": "TMS",
     "eucustoms": false,
     "countryDK": "São Tomé og Príncipe",
     "cityDK": "Sao Tome Island"
  }, {
     "name": "Trombetas Airport",
     "countryCode": "BR",
     "iata": "TMT",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Trombetas"
  }, {
     "name": "Tambor Airport",
     "countryCode": "CR",
     "iata": "TMU",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Tambor"
  }, {
     "name": "Tamworth Airport",
     "countryCode": "AU",
     "iata": "TMW",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Tamworth"
  }, {
     "name": "Timimoun Airport",
     "countryCode": "DZ",
     "iata": "TMX",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Timimoun"
  }, {
     "name": "Thames Aerodrome",
     "countryCode": "NZ",
     "iata": "TMZ",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Thames"
  }, {
     "name": "Jinan Yaoqiang International Airport",
     "countryCode": "CN",
     "iata": "TNA",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Jinan"
  }, {
     "name": "Tin City Air Force Station",
     "countryCode": "US",
     "iata": "TNC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tin City"
  }, {
     "name": "New Tanegashima Airport",
     "countryCode": "JP",
     "iata": "TNE",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Nakatane"
  }, {
     "name": "Toussus-le-Noble Airport",
     "countryCode": "FR",
     "iata": "TNF",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Toussus-le-Noble"
  }, {
     "name": "Tangier Ibn Battouta Airport",
     "countryCode": "MA",
     "iata": "TNG",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Tanger"
  }, {
     "name": "Satna Airport",
     "countryCode": "IN",
     "iata": "TNI",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Satna"
  }, {
     "name": "Raja Haji Fisabilillah Airport",
     "countryCode": "ID",
     "iata": "TNJ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Tanjung Pinang"
  }, {
     "name": "Wake Island Airport",
     "countryCode": "UM",
     "iata": "AWK",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Wake Island"
  }, {
     "name": "Tainan Airport",
     "countryCode": "TW",
     "iata": "TNN",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Tainan"
  }, {
     "name": "Twentynine Palms Airport",
     "countryCode": "US",
     "iata": "TNP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Twentynine Palms"
  }, {
     "name": "Antananarivo Ivato International Airport",
     "countryCode": "MG",
     "iata": "TNR",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Antananarivo"
  }, {
     "name": "Cantung Airport",
     "countryCode": "CA",
     "iata": "TNS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Wolfram"
  }, {
     "name": "Dade Collier Training and Transition Airport",
     "countryCode": "US",
     "iata": "TNT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Miami"
  }, {
     "name": "Newton Municipal Airport",
     "countryCode": "US",
     "iata": "TNU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Newton"
  }, {
     "name": "Stung Treng Airport",
     "countryCode": "KH",
     "iata": "TNX",
     "eucustoms": false,
     "countryDK": "Cambodja",
     "cityDK": "Stung Treng"
  }, {
     "name": "Zamperini Field",
     "countryCode": "US",
     "iata": "TOA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Torrance"
  }, {
     "name": "R.G. LeTourneau Field",
     "countryCode": "US",
     "iata": "TOC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Toccoa"
  }, {
     "name": "Tioman Airport",
     "countryCode": "MY",
     "iata": "TOD",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Tioman"
  }, {
     "name": "Tozeur Nefta International Airport",
     "countryCode": "TN",
     "iata": "TOE",
     "eucustoms": false,
     "countryDK": "Tunesien",
     "cityDK": "Tozeur"
  }, {
     "name": "Tomsk Bogashevo Airport",
     "countryCode": "RU",
     "iata": "TOF",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Tomsk"
  }, {
     "name": "Togiak Village Airport",
     "countryCode": "US",
     "iata": "TOG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Togiak Village"
  }, {
     "name": "Troy Municipal Airport",
     "countryCode": "US",
     "iata": "TOI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Troy"
  }, {
     "name": "Torrejon Air Force Base",
     "countryCode": "ES",
     "iata": "TOJ",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Madrid"
  }, {
     "name": "Toledo Express Airport",
     "countryCode": "US",
     "iata": "TOL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Toledo"
  }, {
     "name": "Tombouctou Airport",
     "countryCode": "ML",
     "iata": "TOM",
     "eucustoms": false,
     "countryDK": "Mali",
     "cityDK": "Tombouctou"
  }, {
     "name": "San Vito Airport",
     "countryCode": "CR",
     "iata": "TOO",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "San Vito"
  }, {
     "name": "Philip Billard Municipal Airport",
     "countryCode": "US",
     "iata": "TOP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Topeka"
  }, {
     "name": "Barriles Airport",
     "countryCode": "CL",
     "iata": "TOQ",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Tocopilla"
  }, {
     "name": "Torrington Municipal Airport",
     "countryCode": "US",
     "iata": "TOR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Torrington"
  }, {
     "name": "Tromso/Langnes Airport",
     "countryCode": "NO",
     "iata": "TOS",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Tromsø"
  }, {
     "name": "Touho Airport",
     "countryCode": "NC",
     "iata": "TOU",
     "eucustoms": false,
     "countryDK": "Ny Kaledonien",
     "cityDK": "Touho"
  }, {
     "name": "Luis dal Canalle Filho Airport",
     "countryCode": "BR",
     "iata": "TOW",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Toledo"
  }, {
     "name": "Toyama Airport",
     "countryCode": "JP",
     "iata": "TOY",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Toyama"
  }, {
     "name": "Mahana Airport",
     "countryCode": "CI",
     "iata": "TOZ",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Touba"
  }, {
     "name": "Tampa International Airport",
     "countryCode": "US",
     "iata": "TPA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tampa"
  }, {
     "name": "Tarapoa Airport",
     "countryCode": "EC",
     "iata": "TPC",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Tarapoa"
  }, {
     "name": "Taiwan Taoyuan International Airport",
     "countryCode": "TW",
     "iata": "TPE",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Taipei"
  }, {
     "name": "Peter O. Knight Airport",
     "countryCode": "US",
     "iata": "TPF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tampa"
  }, {
     "name": "Taiping Airport",
     "countryCode": "MY",
     "iata": "TPG",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Taiping"
  }, {
     "name": "Tonopah Airport",
     "countryCode": "US",
     "iata": "TPH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tonopah"
  }, {
     "name": "Draughon-Miller Airport",
     "countryCode": "US",
     "iata": "TPL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tempel"
  }, {
     "name": "Tiputini Airport",
     "countryCode": "EC",
     "iata": "TPN",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Tiputini"
  }, {
     "name": "Cad. FAP Guillermo del Castillo Paredes Airport",
     "countryCode": "PE",
     "iata": "TPP",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Tarapoto"
  }, {
     "name": "Amado Nervo Airport",
     "countryCode": "MX",
     "iata": "TPQ",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Tepic"
  }, {
     "name": "Tom Price Airport",
     "countryCode": "AU",
     "iata": "TPR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Tom Price"
  }, {
     "name": "Trapani-Birgi Airport",
     "countryCode": "IT",
     "iata": "TPS",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Trapani"
  }, {
     "name": "Tasiusaq Heliport (Upernavik)",
     "countryCode": "GL",
     "iata": "TQA",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Tasiusaq"
  }, {
     "name": "Tiniteqilaaq Heliport",
     "countryCode": "GL",
     "iata": "TQI",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Tiniteqilaaq"
  }, {
     "name": "Tarko-Sale Airport",
     "countryCode": "RU",
     "iata": "TQL",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Tarko-Sale"
  }, {
     "name": "Tres Esquinas Airport",
     "countryCode": "CO",
     "iata": "TQS",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Tres Esquinas"
  }, {
     "name": "Tarama Airport",
     "countryCode": "JP",
     "iata": "TRA",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Taramajima"
  }, {
     "name": "Gonzalo Airport",
     "countryCode": "CO",
     "iata": "TRB",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Turbo"
  }, {
     "name": "Francisco Sarabia International Airport",
     "countryCode": "MX",
     "iata": "TRC",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Torreon"
  }, {
     "name": "Trondheim Airport Vaernes",
     "countryCode": "NO",
     "iata": "TRD",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Trondheim"
  }, {
     "name": "Tiree Airport",
     "countryCode": "GB",
     "iata": "TRE",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Tiree, Indre Hebrider"
  }, {
     "name": "Torp Sandefjord Airport",
     "countryCode": "NO",
     "iata": "TRF",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Sandefjord"
  }, {
     "name": "Tauranga City Airport",
     "countryCode": "NZ",
     "iata": "TRG",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Tauranga"
  }, {
     "name": "Tri-Cities Regional Airport",
     "countryCode": "US",
     "iata": "TRI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bristol, VA / Johnson City / Kingsport"
  }, {
     "name": "Juwata International Airport",
     "countryCode": "ID",
     "iata": "TRK",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Tarakan"
  }, {
     "name": "Terrell Municipal Airport",
     "countryCode": "US",
     "iata": "TRL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Terrell"
  }, {
     "name": "Jacqueline Cochran Regional Airport",
     "countryCode": "US",
     "iata": "TRM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Termisk"
  }, {
     "name": "Turin Airport",
     "countryCode": "IT",
     "iata": "TRN",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Torino"
  }, {
     "name": "Taree Airport",
     "countryCode": "AU",
     "iata": "TRO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Taree"
  }, {
     "name": "Tarauaca Airport",
     "countryCode": "BR",
     "iata": "TRQ",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Tarauaca"
  }, {
     "name": "China Bay Airport",
     "countryCode": "LK",
     "iata": "TRR",
     "eucustoms": false,
     "countryDK": "Sri Lanka",
     "cityDK": "Trincomalee"
  }, {
     "name": "Trieste - Friuli Venezia Giulia Airport",
     "countryCode": "IT",
     "iata": "TRS",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Trieste"
  }, {
     "name": "Trujillo Airport",
     "countryCode": "PE",
     "iata": "TRU",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Trujillo"
  }, {
     "name": "Trivandrum International Airport",
     "countryCode": "IN",
     "iata": "TRV",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Thiruvananthapuram"
  }, {
     "name": "Bonriki Airport",
     "countryCode": "KI",
     "iata": "TRW",
     "eucustoms": false,
     "countryDK": "Kiribati",
     "cityDK": "Tarawa"
  }, {
     "name": "Trenton Memorial Airport",
     "countryCode": "US",
     "iata": "TRX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Trenton"
  }, {
     "name": "Tororo Airport",
     "countryCode": "UG",
     "iata": "TRY",
     "eucustoms": false,
     "countryDK": "Uganda",
     "cityDK": "Tororo"
  }, {
     "name": "Tiruchirapalli International Airport",
     "countryCode": "IN",
     "iata": "TRZ",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Tiruchirappalli"
  }, {
     "name": "Taipei Songshan Airport",
     "countryCode": "TW",
     "iata": "TSA",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Taipei"
  }, {
     "name": "Tsumeb Airport",
     "countryCode": "NA",
     "iata": "TSB",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Tsumeb"
  }, {
     "name": "Taisha Airport",
     "countryCode": "EC",
     "iata": "TSC",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Taisha"
  }, {
     "name": "Astana Nursultan Nazarbayev Airport",
     "countryCode": "KZ",
     "iata": "TSE",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Astana"
  }, {
     "name": "Treviso Airport",
     "countryCode": "IT",
     "iata": "TSF",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Venedig"
  }, {
     "name": "Tshikapa Airport",
     "countryCode": "CD",
     "iata": "TSH",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Tshikapa"
  }, {
     "name": "Tsushima Airport",
     "countryCode": "JP",
     "iata": "TSJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Tsushima"
  }, {
     "name": "Tamuin Airport",
     "countryCode": "MX",
     "iata": "TSL",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Tamuin"
  }, {
     "name": "Taos Airport",
     "countryCode": "US",
     "iata": "TSM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Taos"
  }, {
     "name": "Tianjin Binhai International Airport",
     "countryCode": "CN",
     "iata": "TSN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Tianjin"
  }, {
     "name": "Tresco Airport",
     "countryCode": "GB",
     "iata": "TSO",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Isles of Scilly"
  }, {
     "name": "Kern County Airport",
     "countryCode": "US",
     "iata": "TSP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tehachapi"
  }, {
     "name": "Timisoara Traian Vuia International Airport",
     "countryCode": "RO",
     "iata": "TSR",
     "eucustoms": false,
     "countryDK": "Rumænien",
     "cityDK": "Timisoara"
  }, {
     "name": "Trang Airport",
     "countryCode": "TH",
     "iata": "TST",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Trang"
  }, {
     "name": "Townsville Airport",
     "countryCode": "AU",
     "iata": "TSV",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Townsville"
  }, {
     "name": "Tan Tan Airport",
     "countryCode": "MA",
     "iata": "TTA",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Tan Tan"
  }, {
     "name": "Arbatax Airport",
     "countryCode": "IT",
     "iata": "TTB",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Tortoli"
  }, {
     "name": "Taltal Airport",
     "countryCode": "CL",
     "iata": "TTC",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Taltal"
  }, {
     "name": "Troutdale Airport",
     "countryCode": "US",
     "iata": "TTD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Troutdale"
  }, {
     "name": "Babullah Airport",
     "countryCode": "ID",
     "iata": "TTE",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Ternate"
  }, {
     "name": "Tartagal Airport",
     "countryCode": "AR",
     "iata": "TTG",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Tartagal"
  }, {
     "name": "Thumrait Air Base",
     "countryCode": "OM",
     "iata": "TTH",
     "eucustoms": false,
     "countryDK": "Oman",
     "cityDK": "Thumrait"
  }, {
     "name": "Tottori Airport",
     "countryCode": "JP",
     "iata": "TTJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Tottori"
  }, {
     "name": "Trenton-Mercer Airport",
     "countryCode": "US",
     "iata": "TTN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Trenton"
  }, {
     "name": "Britton Municipal Airport",
     "countryCode": "US",
     "iata": "TTO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Britton"
  }, {
     "name": "Tsaratanana Airport",
     "countryCode": "MG",
     "iata": "TTS",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Tsaratanana"
  }, {
     "name": "Taitung Airport",
     "countryCode": "TW",
     "iata": "TTT",
     "eucustoms": false,
     "countryDK": "Republikken Kina Taiwan",
     "cityDK": "Taitung City"
  }, {
     "name": "Sania Ramel Airport",
     "countryCode": "MA",
     "iata": "TTU",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Tetouan"
  }, {
     "name": "Tulcan Airport",
     "countryCode": "EC",
     "iata": "TUA",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Tulcan"
  }, {
     "name": "Tubuai Island Airport",
     "countryCode": "PF",
     "iata": "TUB",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Tubuai Island"
  }, {
     "name": "Teniente Benjamin Matienzo Airport",
     "countryCode": "AR",
     "iata": "TUC",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Tucuman"
  }, {
     "name": "Tambacounda Airport",
     "countryCode": "SN",
     "iata": "TUD",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Tambacounda"
  }, {
     "name": "Val de Loire Airport",
     "countryCode": "FR",
     "iata": "TUF",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "ture"
  }, {
     "name": "Tuguegarao Airport",
     "countryCode": "PH",
     "iata": "TUG",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Tuguegarao"
  }, {
     "name": "Turaif Airport",
     "countryCode": "SA",
     "iata": "TUI",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Turaif"
  }, {
     "name": "Turbat Airport",
     "countryCode": "PK",
     "iata": "TUK",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Turbat"
  }, {
     "name": "Tulsa International Airport",
     "countryCode": "US",
     "iata": "TUL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tulsa"
  }, {
     "name": "Tumut Airport",
     "countryCode": "AU",
     "iata": "TUM",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Tumut"
  }, {
     "name": "Tunis-Carthage International Airport",
     "countryCode": "TN",
     "iata": "TUN",
     "eucustoms": false,
     "countryDK": "Tunesien",
     "cityDK": "Tunis"
  }, {
     "name": "Taupo Airport",
     "countryCode": "NZ",
     "iata": "TUO",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Taupo"
  }, {
     "name": "Tupelo Regional Airport",
     "countryCode": "US",
     "iata": "TUP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tupelo"
  }, {
     "name": "Tougan Airport",
     "countryCode": "BF",
     "iata": "TUQ",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Tougan"
  }, {
     "name": "Tucurui Airport",
     "countryCode": "BR",
     "iata": "TUR",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Tucurui"
  }, {
     "name": "Tucson International Airport",
     "countryCode": "US",
     "iata": "TUS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tucson"
  }, {
     "name": "Tabuk Regional Airport",
     "countryCode": "SA",
     "iata": "TUU",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Tabuk"
  }, {
     "name": "San Rafael Airport",
     "countryCode": "VE",
     "iata": "TUV",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Tucupita"
  }, {
     "name": "Tumbler Ridge Airport",
     "countryCode": "CA",
     "iata": "TUX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Tumbler Ridge"
  }, {
     "name": "Morafenobe Airport",
     "countryCode": "MG",
     "iata": "TVA",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Morafenobe"
  }, {
     "name": "Cherry Capital Airport",
     "countryCode": "US",
     "iata": "TVC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Traverse City"
  }, {
     "name": "Thief River Falls Regional Airport",
     "countryCode": "US",
     "iata": "TVF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Thief River Falls"
  }, {
     "name": "Thomasville Regional Airport",
     "countryCode": "US",
     "iata": "TVI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Thomasville"
  }, {
     "name": "Lake Tahoe Airport",
     "countryCode": "US",
     "iata": "TVL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "South Lake Tahoe"
  }, {
     "name": "Tangshan Sannuhe Airport",
     "countryCode": "CN",
     "iata": "TVS",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Tangshan"
  }, {
     "name": "Matei Airport",
     "countryCode": "FJ",
     "iata": "TVU",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Taveuni"
  }, {
     "name": "Dawe Airport",
     "countryCode": "MM",
     "iata": "TVY",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Dawe"
  }, {
     "name": "Toowoomba Airport",
     "countryCode": "AU",
     "iata": "TWB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Toowoomba"
  }, {
     "name": "Magic Valley Regional Airport",
     "countryCode": "US",
     "iata": "TWF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Twin Falls"
  }, {
     "name": "Sanga Sanga Airport",
     "countryCode": "PH",
     "iata": "TWT",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Bongao"
  }, {
     "name": "Tawau Airport",
     "countryCode": "MY",
     "iata": "TWU",
     "eucustoms": false,
     "countryDK": "Malaysia",
     "cityDK": "Tawau"
  }, {
     "name": "Teixeira de Freitas Airport",
     "countryCode": "BR",
     "iata": "TXF",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Teixeira de Freitas"
  }, {
     "name": "Texarkana Regional Airport - Webb Field",
     "countryCode": "US",
     "iata": "TXK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Texarkana"
  }, {
     "name": "Huangshan Tunxi International Airport",
     "countryCode": "CN",
     "iata": "TXN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Tunxi"
  }, {
     "name": "Tabou Airport",
     "countryCode": "CI",
     "iata": "TXU",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Tabou"
  }, {
     "name": "Tibooburra Airport",
     "countryCode": "AU",
     "iata": "TYB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Tibooburra"
  }, {
     "name": "Torsby Airport",
     "countryCode": "SE",
     "iata": "TYF",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Torsby"
  }, {
     "name": "Captain FAP Victor Montes Arias Airport",
     "countryCode": "PE",
     "iata": "TYL",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Talara"
  }, {
     "name": "Staniel Cay Airport",
     "countryCode": "BS",
     "iata": "TYM",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Staniel Cay"
  }, {
     "name": "Taiyuan Wusu International Airport",
     "countryCode": "CN",
     "iata": "TYN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Taiyuan"
  }, {
     "name": "Tyler Pounds Regional Airport",
     "countryCode": "US",
     "iata": "TYR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tyler"
  }, {
     "name": "McGhee Tyson Airport",
     "countryCode": "US",
     "iata": "TYS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Knoxville"
  }, {
     "name": "Treinta-y-Tres Airport",
     "countryCode": "UY",
     "iata": "TYT",
     "eucustoms": false,
     "countryDK": "Uruguay",
     "cityDK": "Treinta-y-Tres"
  }, {
     "name": "Taylor Airport",
     "countryCode": "US",
     "iata": "TYZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Taylor"
  }, {
     "name": "Tuzla International Airport",
     "countryCode": "BA",
     "iata": "TZL",
     "eucustoms": false,
     "countryDK": "Bosnien-Hercegovina",
     "cityDK": "Tuzla"
  }, {
     "name": "South Andros Airport",
     "countryCode": "BS",
     "iata": "TZN",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "Congo Town"
  }, {
     "name": "Trabzon Airport",
     "countryCode": "TR",
     "iata": "TZX",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Trabzon"
  }, {
     "name": "Incirlik Air Base",
     "countryCode": "TR",
     "iata": "UAB",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Adana"
  }, {
     "name": "Ua Huka Airport",
     "countryCode": "PF",
     "iata": "UAH",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Ua Huka"
  }, {
     "name": "Narsarsuaq Airport",
     "countryCode": "GL",
     "iata": "UAK",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Narsarsuaq"
  }, {
     "name": "Anderson Air Force Base",
     "countryCode": "GU",
     "iata": "UAM",
     "eucustoms": false,
     "countryDK": "Guam",
     "cityDK": "Guam"
  }, {
     "name": "Ua Pou Airport",
     "countryCode": "PF",
     "iata": "UAP",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Ua Pou, Marquesas Island"
  }, {
     "name": "San Juan Airport",
     "countryCode": "AR",
     "iata": "UAQ",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "San Juan"
  }, {
     "name": "Samburu Airport",
     "countryCode": "KE",
     "iata": "UAS",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Samburu"
  }, {
     "name": "Uberaba Airport",
     "countryCode": "BR",
     "iata": "UBA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Uberaba"
  }, {
     "name": "Mabuiag Island Airport",
     "countryCode": "AU",
     "iata": "UBB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mabuiag Island"
  }, {
     "name": "Yamaguchi Ube Airport",
     "countryCode": "JP",
     "iata": "UBJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Ube"
  }, {
     "name": "Ulaanbaatar International Airport",
     "countryCode": "MN",
     "iata": "UBN",
     "eucustoms": false,
     "countryDK": "Mongoliet",
     "cityDK": "Ulaanbaatar"
  }, {
     "name": "Ubon Ratchathani International Airport",
     "countryCode": "TH",
     "iata": "UBP",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Ubon Ratchathani"
  }, {
     "name": "Lowndes County Airport",
     "countryCode": "US",
     "iata": "UBS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Columbus"
  }, {
     "name": "Ubatuba Airport",
     "countryCode": "BR",
     "iata": "UBT",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Ubatuba"
  }, {
     "name": "Oneida County Airport",
     "countryCode": "US",
     "iata": "UCA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Utica"
  }, {
     "name": "Buchanan Airport",
     "countryCode": "LR",
     "iata": "UCN",
     "eucustoms": false,
     "countryDK": "Liberia",
     "cityDK": "Buchanan"
  }, {
     "name": "Ukhta Airport",
     "countryCode": "RU",
     "iata": "UCT",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Ukhta"
  }, {
     "name": "Everett-Stewart Airport",
     "countryCode": "US",
     "iata": "UCY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Union City"
  }, {
     "name": "Bermuda Dunes Airport",
     "countryCode": "US",
     "iata": "UDD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Palm Springs"
  }, {
     "name": "Uberlandia-Ten. Cel. Av. Cesar Bombonato Airport",
     "countryCode": "BR",
     "iata": "UDI",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Uberlandia"
  }, {
     "name": "Uzhhorod International Airport",
     "countryCode": "UA",
     "iata": "UDJ",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Uzhgorod"
  }, {
     "name": "Udine Airfield",
     "countryCode": "IT",
     "iata": "UDN",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Udine"
  }, {
     "name": "Maharana Pratap Airport",
     "countryCode": "IN",
     "iata": "UDR",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Udaipur"
  }, {
     "name": "Quelimane Airport",
     "countryCode": "MZ",
     "iata": "UEL",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Quelimane"
  }, {
     "name": "Kume-jima Airport",
     "countryCode": "JP",
     "iata": "UEO",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Kume-jima"
  }, {
     "name": "Waukesha County Airport",
     "countryCode": "US",
     "iata": "UES",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Waukesha"
  }, {
     "name": "Quetta Airport",
     "countryCode": "PK",
     "iata": "UET",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Quetta"
  }, {
     "name": "Ufa International Airport",
     "countryCode": "RU",
     "iata": "UFA",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Ufa"
  }, {
     "name": "Bulgan Airport",
     "countryCode": "MN",
     "iata": "UGA",
     "eucustoms": false,
     "countryDK": "Mongoliet",
     "cityDK": "Bulgan"
  }, {
     "name": "Urgench Airport",
     "countryCode": "UZ",
     "iata": "UGC",
     "eucustoms": false,
     "countryDK": "Usbekistan",
     "cityDK": "Urgench"
  }, {
     "name": "Waukegan National Airport",
     "countryCode": "US",
     "iata": "UGN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Waukegan"
  }, {
     "name": "Uige Airport",
     "countryCode": "AO",
     "iata": "UGO",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Uige"
  }, {
     "name": "Kunovice Airport",
     "countryCode": "CZ",
     "iata": "UHE",
     "eucustoms": false,
     "countryDK": "Tjekkiet",
     "cityDK": "Uherske Hradiste"
  }, {
     "name": "Shakhtyorsk Airport",
     "countryCode": "RU",
     "iata": "EKS",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Shakhtyorsk"
  }, {
     "name": "El Carano Airport",
     "countryCode": "CO",
     "iata": "UIB",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Quibdo"
  }, {
     "name": "Phu Cat Airport",
     "countryCode": "VN",
     "iata": "UIH",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Qui Nhon"
  }, {
     "name": "Utila Airport",
     "countryCode": "HN",
     "iata": "UII",
     "eucustoms": false,
     "countryDK": "Honduras",
     "cityDK": "Utila"
  }, {
     "name": "Quillayute State Airport",
     "countryCode": "US",
     "iata": "UIL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Quillayute"
  }, {
     "name": "Quincy Municipal Airport",
     "countryCode": "US",
     "iata": "UIN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Quincy"
  }, {
     "name": "Mariscal Sucre International Airport",
     "countryCode": "EC",
     "iata": "UIO",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Quito"
  }, {
     "name": "Pluguffan Airport",
     "countryCode": "FR",
     "iata": "UIP",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Quimper"
  }, {
     "name": "Quirindi Airport",
     "countryCode": "AU",
     "iata": "UIR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Quirindi"
  }, {
     "name": "Berz-Macomb Airport",
     "countryCode": "US",
     "iata": "UIZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Utica"
  }, {
     "name": "Kobe Airport",
     "countryCode": "JP",
     "iata": "UKB",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Kobe"
  }, {
     "name": "Ust-Kuyga Airport",
     "countryCode": "RU",
     "iata": "UKG",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Ust-Kuyga"
  }, {
     "name": "Mukhaizna Airport",
     "countryCode": "OM",
     "iata": "UKH",
     "eucustoms": false,
     "countryDK": "Oman",
     "cityDK": "Mukhaizna Oil Field"
  }, {
     "name": "Ukiah Municipal Airport",
     "countryCode": "US",
     "iata": "UKI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ukiah"
  }, {
     "name": "Mukeiras Airport",
     "countryCode": "YE",
     "iata": "UKR",
     "eucustoms": false,
     "countryDK": "Yemen",
     "cityDK": "Mukeiras"
  }, {
     "name": "Upper Bucks Airport",
     "countryCode": "US",
     "iata": "UKT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Quakertown"
  }, {
     "name": "San Julian Airport",
     "countryCode": "AR",
     "iata": "ULA",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "San Julian"
  }, {
     "name": "Ulei Airport",
     "countryCode": "VU",
     "iata": "ULB",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Ulei"
  }, {
     "name": "Los Cerrillos Airport",
     "countryCode": "CL",
     "iata": "ULC",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Santiago"
  }, {
     "name": "Prince Mangosuthu Buthelezi Airport",
     "countryCode": "ZA",
     "iata": "ULD",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Ulundi"
  }, {
     "name": "Sule Airport",
     "countryCode": "PG",
     "iata": "ULE",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Sule"
  }, {
     "name": "Prince Abdul Majeed bin Abdulaziz Airport",
     "countryCode": "SA",
     "iata": "ULH",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Al Ula"
  }, {
     "name": "Ulithi Airport",
     "countryCode": "FM",
     "iata": "ULI",
     "eucustoms": false,
     "countryDK": "Mikronesien",
     "cityDK": "Ulithi Caroline Islands"
  }, {
     "name": "Lensk Airport",
     "countryCode": "RU",
     "iata": "ULK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Lensk"
  }, {
     "name": "New Ulm Airport",
     "countryCode": "US",
     "iata": "ULM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Ny Ulm"
  }, {
     "name": "Chinggis Khaan International Airport",
     "countryCode": "MN",
     "iata": "ULN",
     "eucustoms": false,
     "countryDK": "Mongoliet",
     "cityDK": "Ulaanbaatar"
  }, {
     "name": "Quilpie Airport",
     "countryCode": "AU",
     "iata": "ULP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Quilpie"
  }, {
     "name": "Farfan Airport",
     "countryCode": "CO",
     "iata": "ULQ",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Tulua"
  }, {
     "name": "Gulu Airport",
     "countryCode": "UG",
     "iata": "ULU",
     "eucustoms": false,
     "countryDK": "Uganda",
     "cityDK": "Gulu"
  }, {
     "name": "Ulyanovsk Baratayevka Airport",
     "countryCode": "RU",
     "iata": "ULV",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Ulyanovsk"
  }, {
     "name": "Ulusaba Airport",
     "countryCode": "ZA",
     "iata": "ULX",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Ulusaba"
  }, {
     "name": "Ulyanovsk Vostochny Airport",
     "countryCode": "RU",
     "iata": "ULY",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Ulyanovsk"
  }, {
     "name": "Uummannaq Heliport",
     "countryCode": "GL",
     "iata": "UMD",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Uummannaq"
  }, {
     "name": "Umea Airport",
     "countryCode": "SE",
     "iata": "UME",
     "eucustoms": true,
     "countryDK": "Sverige",
     "cityDK": "Umeå"
  }, {
     "name": "Quincemil Airport",
     "countryCode": "PE",
     "iata": "UMI",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Quincemil"
  }, {
     "name": "Woomera Airport",
     "countryCode": "AU",
     "iata": "UMR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Woomera"
  }, {
     "name": "Umiat Airport",
     "countryCode": "US",
     "iata": "UMT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Umiat"
  }, {
     "name": "Ernesto Geisel Airport",
     "countryCode": "BR",
     "iata": "UMU",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Umuarama"
  }, {
     "name": "Kunduz Airport",
     "countryCode": "AF",
     "iata": "UND",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Kunduz"
  }, {
     "name": "Qachas Airport",
     "countryCode": "LS",
     "iata": "UNE",
     "eucustoms": false,
     "countryDK": "Lesotho",
     "cityDK": "Qachas"
  }, {
     "name": "Union Island Airport",
     "countryCode": "VC",
     "iata": "UNI",
     "eucustoms": false,
     "countryDK": "Saint Vincent og Grenadinerne",
     "cityDK": "Union Island"
  }, {
     "name": "Unalakleet Airport",
     "countryCode": "US",
     "iata": "UNK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Unalakleet"
  }, {
     "name": "Ranong Airport",
     "countryCode": "TH",
     "iata": "UNN",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Ranong"
  }, {
     "name": "Unst Airport",
     "countryCode": "GB",
     "iata": "UNT",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Baltasound"
  }, {
     "name": "Dodge County Airport",
     "countryCode": "US",
     "iata": "UNU",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Juneau"
  }, {
     "name": "Pogogul Airport",
     "countryCode": "ID",
     "iata": "UOL",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Buol"
  }, {
     "name": "Franklin County Airport",
     "countryCode": "US",
     "iata": "UOS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Sewanee"
  }, {
     "name": "University-Oxford Airport",
     "countryCode": "US",
     "iata": "UOX",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Oxford"
  }, {
     "name": "Playa Baracoa Airport",
     "countryCode": "CU",
     "iata": "UPB",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Havana"
  }, {
     "name": "Sultan Hasanuddin International Airport",
     "countryCode": "ID",
     "iata": "UPG",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Ujung Pandang"
  }, {
     "name": "Upernavik Kujalleq Heliport",
     "countryCode": "GL",
     "iata": "UPK",
     "eucustoms": false,
     "countryDK": "Grønland",
     "cityDK": "Upernavik Kujalleq"
  }, {
     "name": "Licenciado y General Ignacio Lopez Rayon Airport",
     "countryCode": "MX",
     "iata": "UPN",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Uruapan"
  }, {
     "name": "Upolu Point Airport",
     "countryCode": "US",
     "iata": "UPP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Upolu Point"
  }, {
     "name": "Upavon Airport",
     "countryCode": "GB",
     "iata": "UPV",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Upavon"
  }, {
     "name": "Uralsk Airport",
     "countryCode": "KZ",
     "iata": "URA",
     "eucustoms": false,
     "countryDK": "Kasakhstan",
     "cityDK": "Uralsk"
  }, {
     "name": "Ernesto Pochler Airport",
     "countryCode": "BR",
     "iata": "URB",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Urubupunga"
  }, {
     "name": "Urumqi Diwopu International Airport",
     "countryCode": "CN",
     "iata": "URC",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Urumqi"
  }, {
     "name": "Burg Feuerstein Airport",
     "countryCode": "DE",
     "iata": "URD",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Burg Feuerstein"
  }, {
     "name": "Kuressaare Airport",
     "countryCode": "EE",
     "iata": "URE",
     "eucustoms": false,
     "countryDK": "Estland",
     "cityDK": "Kuressaare"
  }, {
     "name": "Ruben Berta Airport",
     "countryCode": "BR",
     "iata": "URG",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Uruguaiana"
  }, {
     "name": "Uriman Airport",
     "countryCode": "VE",
     "iata": "URM",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Uriman"
  }, {
     "name": "Boos Airport",
     "countryCode": "FR",
     "iata": "URO",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Rouen"
  }, {
     "name": "Urrao Airport",
     "countryCode": "CO",
     "iata": "URR",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Urrao"
  }, {
     "name": "Kursk Vostochny Airport",
     "countryCode": "RU",
     "iata": "URS",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Kursk"
  }, {
     "name": "Surat Thani Airport",
     "countryCode": "TH",
     "iata": "URT",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Surat Thani"
  }, {
     "name": "Gurayat Airport",
     "countryCode": "SA",
     "iata": "URY",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Gurayat"
  }, {
     "name": "Malvinas Argentinas International Airport",
     "countryCode": "AR",
     "iata": "USH",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Ushuaia"
  }, {
     "name": "Usinsk Airport",
     "countryCode": "RU",
     "iata": "USK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Usinsk"
  }, {
     "name": "Koh Samui Airport",
     "countryCode": "TH",
     "iata": "USM",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Koh Samui"
  }, {
     "name": "Ulsan Airport",
     "countryCode": "KR",
     "iata": "USN",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Ulsan"
  }, {
     "name": "Usak Airport",
     "countryCode": "TR",
     "iata": "USQ",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Usak"
  }, {
     "name": "St. Augustine Airport",
     "countryCode": "US",
     "iata": "UST",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Saint Augustine"
  }, {
     "name": "Busuanga Airport",
     "countryCode": "PH",
     "iata": "USU",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Busuanga"
  }, {
     "name": "Mutare Airport",
     "countryCode": "ZW",
     "iata": "UTA",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Mutare"
  }, {
     "name": "Muttaburra Airport",
     "countryCode": "AU",
     "iata": "UTB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Muttaburra"
  }, {
     "name": "Soesterberg Airport",
     "countryCode": "NL",
     "iata": "UTC",
     "eucustoms": false,
     "countryDK": "Holland",
     "cityDK": "Utrecht"
  }, {
     "name": "Udon Thani International Airport",
     "countryCode": "TH",
     "iata": "UTH",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Udon Thani"
  }, {
     "name": "Utti Airport",
     "countryCode": "FI",
     "iata": "UTI",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Kouvola"
  }, {
     "name": "Tunica Municipal Airport",
     "countryCode": "US",
     "iata": "UTM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tunica"
  }, {
     "name": "Upington Airport",
     "countryCode": "ZA",
     "iata": "UTN",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Upington"
  }, {
     "name": "Utapao Airport",
     "countryCode": "TH",
     "iata": "UTP",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Utapao"
  }, {
     "name": "Uttaradit Airport",
     "countryCode": "TH",
     "iata": "UTR",
     "eucustoms": false,
     "countryDK": "Thailand",
     "cityDK": "Uttaradit"
  }, {
     "name": "Ust-Tsilma Airport",
     "countryCode": "RU",
     "iata": "UTS",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Ust-Tsilma"
  }, {
     "name": "Umtata Airport",
     "countryCode": "ZA",
     "iata": "UTT",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Umtata"
  }, {
     "name": "Queenstown Airport",
     "countryCode": "ZA",
     "iata": "UTW",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Queenstown"
  }, {
     "name": "Bugulma Airport",
     "countryCode": "RU",
     "iata": "UUA",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Bugulma"
  }, {
     "name": "Ulan-Ude Airport",
     "countryCode": "RU",
     "iata": "UUD",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Ulan-Ude"
  }, {
     "name": "Baruun-Urt Airport",
     "countryCode": "MN",
     "iata": "UUN",
     "eucustoms": false,
     "countryDK": "Mongoliet",
     "cityDK": "Baruun-Urt"
  }, {
     "name": "Yuzhno-Sakhalinsk Airport",
     "countryCode": "RU",
     "iata": "UUS",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Yuzhno-Sakhalinsk"
  }, {
     "name": "Garner Field",
     "countryCode": "US",
     "iata": "UVA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Uvalde"
  }, {
     "name": "Ouvea Airport",
     "countryCode": "NC",
     "iata": "UVE",
     "eucustoms": false,
     "countryDK": "Ny Kaledonien",
     "cityDK": "Ouvea"
  }, {
     "name": "Hewanorra Airport",
     "countryCode": "LC",
     "iata": "UVF",
     "eucustoms": false,
     "countryDK": "Saint Lucia",
     "cityDK": "Saint Lucia"
  }, {
     "name": "Kharga Airport",
     "countryCode": "EG",
     "iata": "UVL",
     "eucustoms": false,
     "countryDK": "Egypten",
     "cityDK": "New Valley"
  }, {
     "name": "Nyala Airport",
     "countryCode": "SD",
     "iata": "UYL",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Nyala"
  }, {
     "name": "Uyuni Airport",
     "countryCode": "BO",
     "iata": "UYU",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Uyuni"
  }, {
     "name": "Ponikve Airport",
     "countryCode": "RS",
     "iata": "UZC",
     "eucustoms": false,
     "countryDK": "Serbien",
     "cityDK": "Uzice"
  }, {
     "name": "Curuzu Cuatia Airport",
     "countryCode": "AR",
     "iata": "UZU",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Curuzu Cuatia"
  }, {
     "name": "Vaasa Airport",
     "countryCode": "FI",
     "iata": "VAA",
     "eucustoms": true,
     "countryDK": "Finland",
     "cityDK": "Vaasa"
  }, {
     "name": "Varrelbusch Airport",
     "countryCode": "DE",
     "iata": "VAC",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Varrelbusch"
  }, {
     "name": "Moody Air Force Base",
     "countryCode": "US",
     "iata": "VAD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Valdosta"
  }, {
     "name": "Chabeuil Airport",
     "countryCode": "FR",
     "iata": "VAF",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Valence"
  }, {
     "name": "Major-Brigadeiro Trompowsky Airport",
     "countryCode": "BR",
     "iata": "VAG",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Varginha"
  }, {
     "name": "Vallegrande Airport",
     "countryCode": "BO",
     "iata": "VAH",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Vallegrande"
  }, {
     "name": "Maamigili Island Airport",
     "countryCode": "MV",
     "iata": "VAM",
     "eucustoms": false,
     "countryDK": "Maldiverne",
     "cityDK": "Maamigili Island"
  }, {
     "name": "Van Ferit Melen Airport",
     "countryCode": "TR",
     "iata": "VAN",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Van"
  }, {
     "name": "Ozar Airport",
     "countryCode": "IN",
     "iata": "ISK",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Ozar"
  }, {
     "name": "Varna Airport",
     "countryCode": "BG",
     "iata": "VAR",
     "eucustoms": true,
     "countryDK": "Bulgarien",
     "cityDK": "Varna"
  }, {
     "name": "Sivas Airport",
     "countryCode": "TR",
     "iata": "VAS",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Sivas"
  }, {
     "name": "Vatomandry Airport",
     "countryCode": "MG",
     "iata": "VAT",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Vatomandry"
  }, {
     "name": "Vava'u International Airport",
     "countryCode": "TO",
     "iata": "VAV",
     "eucustoms": false,
     "countryDK": "Tonga",
     "cityDK": "Vava'u"
  }, {
     "name": "Vardoe Airport",
     "countryCode": "NO",
     "iata": "VAW",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Vardoe"
  }, {
     "name": "Ann Airport",
     "countryCode": "MM",
     "iata": "VBA",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Ann"
  }, {
     "name": "Mandalay Chan Mya Thazi Airport",
     "countryCode": "MM",
     "iata": "VBC",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Mandalay"
  }, {
     "name": "Vandenburg Air Force Base",
     "countryCode": "US",
     "iata": "VBG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lompoc"
  }, {
     "name": "Bokpyin Airport",
     "countryCode": "MM",
     "iata": "VBP",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Bokpyin"
  }, {
     "name": "Montichiari Airport",
     "countryCode": "IT",
     "iata": "VBS",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Brescia"
  }, {
     "name": "Vanua Balavu Airport",
     "countryCode": "FJ",
     "iata": "VBV",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Vanuabalavu"
  }, {
     "name": "Visby Airport",
     "countryCode": "SE",
     "iata": "VBY",
     "eucustoms": true,
     "countryDK": "Sverige",
     "cityDK": "Visby"
  }, {
     "name": "Victoria River Downs Airport",
     "countryCode": "AU",
     "iata": "VCD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Victoria River Downs"
  }, {
     "name": "Venice Marco Polo Airport",
     "countryCode": "IT",
     "iata": "VCE",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Venedig"
  }, {
     "name": "Vichadero Airport",
     "countryCode": "UY",
     "iata": "VCH",
     "eucustoms": false,
     "countryDK": "Uruguay",
     "cityDK": "Vichadero"
  }, {
     "name": "Viracopos Airport",
     "countryCode": "BR",
     "iata": "VCP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Campinas"
  }, {
     "name": "Carora Airport",
     "countryCode": "VE",
     "iata": "VCR",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Carora"
  }, {
     "name": "County-Foster Airport",
     "countryCode": "US",
     "iata": "VCT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Victoria"
  }, {
     "name": "Southern California Logistics Airport",
     "countryCode": "US",
     "iata": "VCV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Victorville"
  }, {
     "name": "Ovda Airport",
     "countryCode": "IL",
     "iata": "VDA",
     "eucustoms": false,
     "countryDK": "Israel",
     "cityDK": "Ovda"
  }, {
     "name": "Leirin Airport",
     "countryCode": "NO",
     "iata": "VDB",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Fagernes"
  }, {
     "name": "Vitoria Da Conquista Airport",
     "countryCode": "BR",
     "iata": "VDC",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Vitoria Da Conquista"
  }, {
     "name": "Hierro Airport",
     "countryCode": "ES",
     "iata": "VDE",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Valverde"
  }, {
     "name": "Tampa Executive Airport",
     "countryCode": "US",
     "iata": "VDF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tampa"
  }, {
     "name": "Vidalia Municipal Airport",
     "countryCode": "US",
     "iata": "VDI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Vidalia"
  }, {
     "name": "Gobernador Edgardo Castello Airport",
     "countryCode": "AR",
     "iata": "VDM",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Viedma"
  }, {
     "name": "Valle de la Pascua Airport",
     "countryCode": "VE",
     "iata": "VDP",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Valle de la Pascua"
  }, {
     "name": "Villa Dolores Airport",
     "countryCode": "AR",
     "iata": "VDR",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Villa Dolores"
  }, {
     "name": "Vadso Airport",
     "countryCode": "NO",
     "iata": "VDS",
     "eucustoms": false,
     "countryDK": "Norge",
     "cityDK": "Vadsø"
  }, {
     "name": "Jindal Airport",
     "countryCode": "IN",
     "iata": "VDY",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Vijaynagar"
  }, {
     "name": "Pioneer Field",
     "countryCode": "US",
     "iata": "VDZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Valdez"
  }, {
     "name": "Vernal Regional Airport",
     "countryCode": "US",
     "iata": "VEL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Vernal"
  }, {
     "name": "Veracruz International Airport",
     "countryCode": "MX",
     "iata": "VER",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Veracruz"
  }, {
     "name": "Vestmannaeyjar Airport",
     "countryCode": "IS",
     "iata": "VEY",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Vestmannaeyjar"
  }, {
     "name": "Victoria Falls Airport",
     "countryCode": "ZW",
     "iata": "VFA",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Victoria Falls"
  }, {
     "name": "Vijayawada Airport",
     "countryCode": "IN",
     "iata": "VGA",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Vijayawada"
  }, {
     "name": "Vigo Airport",
     "countryCode": "ES",
     "iata": "VGO",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Vigo"
  }, {
     "name": "North Las Vegas Airport",
     "countryCode": "US",
     "iata": "VGT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Las Vegas"
  }, {
     "name": "Villa Garzon Airport",
     "countryCode": "CO",
     "iata": "VGZ",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Villa Garzon"
  }, {
     "name": "Saurimo Airport",
     "countryCode": "AO",
     "iata": "VHC",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Saurimo"
  }, {
     "name": "Vilhelmina Airport",
     "countryCode": "SE",
     "iata": "VHM",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Vilhelmina"
  }, {
     "name": "Culberson County Airport",
     "countryCode": "US",
     "iata": "VHN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Van Horn"
  }, {
     "name": "Charmeil Airport",
     "countryCode": "FR",
     "iata": "VHY",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Vichy"
  }, {
     "name": "Vahitahi Airport",
     "countryCode": "PF",
     "iata": "VHZ",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Vahitahi"
  }, {
     "name": "Videira Airport",
     "countryCode": "BR",
     "iata": "VIA",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Videira"
  }, {
     "name": "Vicenza Airport",
     "countryCode": "IT",
     "iata": "VIC",
     "eucustoms": false,
     "countryDK": "Italien",
     "cityDK": "Vicenza"
  }, {
     "name": "Vienna International Airport",
     "countryCode": "AT",
     "iata": "VIE",
     "eucustoms": true,
     "countryDK": "Østrig",
     "cityDK": "Wien"
  }, {
     "name": "El Vigia Airport",
     "countryCode": "VE",
     "iata": "VIG",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "El Vigia"
  }, {
     "name": "Vinh Airport",
     "countryCode": "VN",
     "iata": "VII",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Vinh City"
  }, {
     "name": "Virgin Gorda Airport",
     "countryCode": "VG",
     "iata": "VIJ",
     "eucustoms": false,
     "countryDK": "De Britiske Jomfruøer",
     "cityDK": "Virgin Gorda"
  }, {
     "name": "Dakhla Airport",
     "countryCode": "MA",
     "iata": "VIL",
     "eucustoms": false,
     "countryDK": "Marokko",
     "cityDK": "Dakhla"
  }, {
     "name": "Havryshivka Vinnytsia International Airport",
     "countryCode": "UA",
     "iata": "VIN",
     "eucustoms": false,
     "countryDK": "Ukraine",
     "cityDK": "Vinnytsia"
  }, {
     "name": "Virginia Airport",
     "countryCode": "ZA",
     "iata": "VIR",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Durban"
  }, {
     "name": "Visalia Municipal Airport",
     "countryCode": "US",
     "iata": "VIS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Visalia"
  }, {
     "name": "Vitoria Airport",
     "countryCode": "ES",
     "iata": "VIT",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Vitoria"
  }, {
     "name": "Eurico de Aguiar Salles Airport",
     "countryCode": "BR",
     "iata": "VIX",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Vitoria"
  }, {
     "name": "Virginia Highlands Airport",
     "countryCode": "US",
     "iata": "VJI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Abingdon"
  }, {
     "name": "Rach Gia Airport",
     "countryCode": "VN",
     "iata": "VKG",
     "eucustoms": false,
     "countryDK": "Vietnam",
     "cityDK": "Rach Gia"
  }, {
     "name": "Vnukovo Airport",
     "countryCode": "RU",
     "iata": "VKO",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Moskva"
  }, {
     "name": "Vicksburg Airport",
     "countryCode": "US",
     "iata": "VKS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Vicksburg"
  }, {
     "name": "Vorkuta Airport",
     "countryCode": "RU",
     "iata": "VKT",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Vorkuta"
  }, {
     "name": "Vandalia Airport",
     "countryCode": "US",
     "iata": "VLA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Vandalia"
  }, {
     "name": "Valencia Airport",
     "countryCode": "ES",
     "iata": "VLC",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Valencia"
  }, {
     "name": "Valdosta Regional Airport",
     "countryCode": "US",
     "iata": "VLD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Valdosta"
  }, {
     "name": "Villa Gesell Airport",
     "countryCode": "AR",
     "iata": "VLG",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Villa Gesell"
  }, {
     "name": "Bauerfield Airport",
     "countryCode": "VU",
     "iata": "VLI",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Port Vila"
  }, {
     "name": "Valladolid Airport",
     "countryCode": "ES",
     "iata": "VLL",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Valladolid"
  }, {
     "name": "Villamontes Airport",
     "countryCode": "BO",
     "iata": "VLM",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Villamontes"
  }, {
     "name": "Arturo Michelena International Airport",
     "countryCode": "VE",
     "iata": "VLN",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Valencia"
  }, {
     "name": "Vila Rica Municipal Airport",
     "countryCode": "BR",
     "iata": "VLP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Vila Rica"
  }, {
     "name": "Vallenar Airport",
     "countryCode": "CL",
     "iata": "VLR",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Vallenar"
  }, {
     "name": "Valesdir Airport",
     "countryCode": "VU",
     "iata": "VLS",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Valesdir"
  }, {
     "name": "Colonel Antonio Nicolas Briceno Airport",
     "countryCode": "VE",
     "iata": "VLV",
     "eucustoms": false,
     "countryDK": "Venezuela",
     "cityDK": "Valera"
  }, {
     "name": "Villa Reynolds Airport",
     "countryCode": "AR",
     "iata": "VME",
     "eucustoms": false,
     "countryDK": "Argentina",
     "cityDK": "Villa Mercedes"
  }, {
     "name": "Saravane Airport",
     "countryCode": "LA",
     "iata": "VNA",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Saravane"
  }, {
     "name": "Venice Municipal Airport",
     "countryCode": "US",
     "iata": "VNC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Venedig"
  }, {
     "name": "Vangaindrano Airport",
     "countryCode": "MG",
     "iata": "VND",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Vangaindrano"
  }, {
     "name": "Meucon Airport",
     "countryCode": "FR",
     "iata": "VNE",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Vannes"
  }, {
     "name": "Vilnius International Airport",
     "countryCode": "LT",
     "iata": "VNO",
     "eucustoms": true,
     "countryDK": "Litauen",
     "cityDK": "Vilnius"
  }, {
     "name": "Lal Bahadur Shastri International Airport",
     "countryCode": "IN",
     "iata": "VNS",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Varanasi"
  }, {
     "name": "Vilanculos Airport",
     "countryCode": "MZ",
     "iata": "VNX",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Vilanculos"
  }, {
     "name": "Van Nuys Airport",
     "countryCode": "US",
     "iata": "VNY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Los Angeles"
  }, {
     "name": "Volgograd International Airport",
     "countryCode": "RU",
     "iata": "VOG",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Volgograd"
  }, {
     "name": "Vohemar Airport",
     "countryCode": "MG",
     "iata": "VOH",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Vohemar"
  }, {
     "name": "Volk Field",
     "countryCode": "US",
     "iata": "VOK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Camp Douglas"
  }, {
     "name": "Nea Anchialos Airport",
     "countryCode": "GR",
     "iata": "VOL",
     "eucustoms": false,
     "countryDK": "Grækenland",
     "cityDK": "Volos"
  }, {
     "name": "Votuporanga Airport",
     "countryCode": "BR",
     "iata": "VOT",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Votuporanga"
  }, {
     "name": "Voronezh Airport",
     "countryCode": "RU",
     "iata": "VOZ",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Voronezh"
  }, {
     "name": "Ongiva Airport",
     "countryCode": "AO",
     "iata": "VPE",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Ongiva"
  }, {
     "name": "Vopnafjordur Airport",
     "countryCode": "IS",
     "iata": "VPN",
     "eucustoms": false,
     "countryDK": "Island",
     "cityDK": "Vopnafjordur"
  }, {
     "name": "Destin Fort Walton Beach Airport",
     "countryCode": "US",
     "iata": "VPS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Fort Walton Beach"
  }, {
     "name": "Chimoio Airport",
     "countryCode": "MZ",
     "iata": "VPY",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Chimoio"
  }, {
     "name": "Porter County Regional Airport",
     "countryCode": "US",
     "iata": "VPZ",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Valparaiso"
  }, {
     "name": "Bathpalathang Airport",
     "countryCode": "BT",
     "iata": "BUT",
     "eucustoms": false,
     "countryDK": "Bhutan",
     "cityDK": "Jakar"
  }, {
     "name": "Antonio Rivera Rodriguez Airport",
     "countryCode": "PR",
     "iata": "VQS",
     "eucustoms": false,
     "countryDK": "Puerto Rico",
     "cityDK": "Vieques"
  }, {
     "name": "Juan Gualberto Gomez Airport",
     "countryCode": "CU",
     "iata": "VRA",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Varadero"
  }, {
     "name": "Vero Beach Municipal Airport",
     "countryCode": "US",
     "iata": "VRB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Vero Beach"
  }, {
     "name": "Virac Airport",
     "countryCode": "PH",
     "iata": "VRC",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Virac"
  }, {
     "name": "Vredendal Airport",
     "countryCode": "ZA",
     "iata": "VRE",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Vredendal"
  }, {
     "name": "Varkaus Airport",
     "countryCode": "FI",
     "iata": "VRK",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Varkaus"
  }, {
     "name": "Vila Real Airport",
     "countryCode": "PT",
     "iata": "VRL",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Vila Real"
  }, {
     "name": "Verona Villafranca Airport",
     "countryCode": "IT",
     "iata": "VRN",
     "eucustoms": true,
     "countryDK": "Italien",
     "cityDK": "Verona"
  }, {
     "name": "Vryburg Airport",
     "countryCode": "ZA",
     "iata": "VRU",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Vryburg"
  }, {
     "name": "Carlos Rovirosa Perez International Airport",
     "countryCode": "MX",
     "iata": "VSA",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Villahermosa"
  }, {
     "name": "Viseu Airport",
     "countryCode": "PT",
     "iata": "VSE",
     "eucustoms": false,
     "countryDK": "Portugal",
     "cityDK": "Viseu"
  }, {
     "name": "Hartness State Airport",
     "countryCode": "US",
     "iata": "VSF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Springfield"
  }, {
     "name": "Vasteras/Hasslo Airport",
     "countryCode": "SE",
     "iata": "VST",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Stockholm"
  }, {
     "name": "Vitebsk Airport",
     "countryCode": "BY",
     "iata": "VTB",
     "eucustoms": false,
     "countryDK": "Hviderusland",
     "cityDK": "Vitebsk"
  }, {
     "name": "Wattay International Airport",
     "countryCode": "LA",
     "iata": "VTE",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Vientiane"
  }, {
     "name": "Vittel Airport",
     "countryCode": "FR",
     "iata": "VTL",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Vittel"
  }, {
     "name": "Nevatim Air Force Base",
     "countryCode": "IL",
     "iata": "VTM",
     "eucustoms": false,
     "countryDK": "Israel",
     "cityDK": "Nevatim"
  }, {
     "name": "Miller Field",
     "countryCode": "US",
     "iata": "VTN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Valentine"
  }, {
     "name": "Hermanos Ameijeiras Airport",
     "countryCode": "CU",
     "iata": "VTU",
     "eucustoms": false,
     "countryDK": "Cuba",
     "cityDK": "Las Tunas"
  }, {
     "name": "Vishakhapatnam Airport",
     "countryCode": "IN",
     "iata": "VTZ",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Vishakhapatnam"
  }, {
     "name": "Valledupar Airport",
     "countryCode": "CO",
     "iata": "VUP",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Valledupar"
  }, {
     "name": "Mahanoro Airport",
     "countryCode": "MG",
     "iata": "VVB",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Mahanoro"
  }, {
     "name": "Vanguardia Airport",
     "countryCode": "CO",
     "iata": "VVC",
     "eucustoms": false,
     "countryDK": "Colombia",
     "cityDK": "Villavicencio"
  }, {
     "name": "Viru Viru International Airport",
     "countryCode": "BO",
     "iata": "VVI",
     "eucustoms": false,
     "countryDK": "Bolivia",
     "cityDK": "Santa Cruz"
  }, {
     "name": "Vastervik Airport",
     "countryCode": "SE",
     "iata": "VVK",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Vastervik"
  }, {
     "name": "Malvinas Airport",
     "countryCode": "PE",
     "iata": "VVN",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Malvinas"
  }, {
     "name": "Vladivostok International Airport",
     "countryCode": "RU",
     "iata": "VVO",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Vladivostok"
  }, {
     "name": "Illizi Airport",
     "countryCode": "DZ",
     "iata": "VVZ",
     "eucustoms": false,
     "countryDK": "Algeriet",
     "cityDK": "Illizi"
  }, {
     "name": "Lichinga Airport",
     "countryCode": "MZ",
     "iata": "VXC",
     "eucustoms": false,
     "countryDK": "Mozambique",
     "cityDK": "Lichinga"
  }, {
     "name": "Cesaria Evora International Airport",
     "countryCode": "CV",
     "iata": "VXE",
     "eucustoms": false,
     "countryDK": "Kap Verde",
     "cityDK": "Sao Vicente"
  }, {
     "name": "Vaxjo Airport",
     "countryCode": "SE",
     "iata": "VXO",
     "eucustoms": false,
     "countryDK": "Sverige",
     "cityDK": "Växjö"
  }, {
     "name": "Vryheid Airport",
     "countryCode": "ZA",
     "iata": "VYD",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Vryheid"
  }, {
     "name": "Illinois Valley Regional Airport",
     "countryCode": "US",
     "iata": "VYS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Peru"
  }, {
     "name": "Waca Airport",
     "countryCode": "ET",
     "iata": "WAC",
     "eucustoms": false,
     "countryDK": "Etiopien",
     "cityDK": "WACA"
  }, {
     "name": "Wadi Ad Dawasir Airport",
     "countryCode": "SA",
     "iata": "WAE",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Wadi Ad Dawasir"
  }, {
     "name": "Wanganui Airport",
     "countryCode": "NZ",
     "iata": "WAG",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Wanganui"
  }, {
     "name": "Wahpeton Airport",
     "countryCode": "US",
     "iata": "WAH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wahpeton"
  }, {
     "name": "Ambalabe Airport",
     "countryCode": "MG",
     "iata": "WAI",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Antsohihy"
  }, {
     "name": "Ankazoabo Airport",
     "countryCode": "MG",
     "iata": "WAK",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Ankazoabo"
  }, {
     "name": "Wallops Flight Facility",
     "countryCode": "US",
     "iata": "WAL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chincoteague"
  }, {
     "name": "Ambatondrazaka Airport",
     "countryCode": "MG",
     "iata": "WAM",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Ambatondrazaka"
  }, {
     "name": "Antsalova Airport",
     "countryCode": "MG",
     "iata": "WAQ",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Antsalova"
  }, {
     "name": "Waterford Airport",
     "countryCode": "IE",
     "iata": "WAT",
     "eucustoms": false,
     "countryDK": "Irland",
     "cityDK": "Waterford"
  }, {
     "name": "Kalkgurung Airport",
     "countryCode": "AU",
     "iata": "WAV",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Wave Hill"
  }, {
     "name": "Frederic Chopin Airport",
     "countryCode": "PL",
     "iata": "WAW",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Warszawa"
  }, {
     "name": "Green County Airport",
     "countryCode": "US",
     "iata": "WAY",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Waynesburg"
  }, {
     "name": "Befandriana Airport",
     "countryCode": "MG",
     "iata": "WBD",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Befandriana"
  }, {
     "name": "Schleswig Airport",
     "countryCode": "DE",
     "iata": "WBG",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Schleswig"
  }, {
     "name": "Wapenamanda Airport",
     "countryCode": "PG",
     "iata": "WBM",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Wapenamanda"
  }, {
     "name": "Beroroha Airport",
     "countryCode": "MG",
     "iata": "WBO",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Beroroha"
  }, {
     "name": "Big Rapids Airport",
     "countryCode": "US",
     "iata": "WBR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Big Rapids"
  }, {
     "name": "Wyoming Valle Airport",
     "countryCode": "US",
     "iata": "WBW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wilkes-Barre"
  }, {
     "name": "Nuevo Chaiten Airport",
     "countryCode": "CL",
     "iata": "WCH",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Chaiten"
  }, {
     "name": "Chandalar Airport",
     "countryCode": "US",
     "iata": "WCR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Chandalar"
  }, {
     "name": "Enid Woodring Municipal Airport",
     "countryCode": "US",
     "iata": "WDG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Enid"
  }, {
     "name": "Hosea Kutako International Airport",
     "countryCode": "NA",
     "iata": "WDH",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Windhoek"
  }, {
     "name": "Wondai Airport",
     "countryCode": "AU",
     "iata": "WDI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Wondai"
  }, {
     "name": "Winder Airport",
     "countryCode": "US",
     "iata": "WDR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Winder"
  }, {
     "name": "Shiyan Wudangshan Airport",
     "countryCode": "CN",
     "iata": "WDS",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Shiyan"
  }, {
     "name": "Parker County Airport",
     "countryCode": "US",
     "iata": "WEA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Weatherford"
  }, {
     "name": "Weipa Airport",
     "countryCode": "AU",
     "iata": "WEI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Weipa"
  }, {
     "name": "Welkom Airport",
     "countryCode": "ZA",
     "iata": "WEL",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Welkom"
  }, {
     "name": "Wee Waa Airport",
     "countryCode": "AU",
     "iata": "WEW",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Wee Waa"
  }, {
     "name": "Manchester Woodford Airport",
     "countryCode": "GB",
     "iata": "WFD",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Woodford"
  }, {
     "name": "Fianarantsoa Airport",
     "countryCode": "MG",
     "iata": "WFI",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Fianarantsoa"
  }, {
     "name": "Frenchville Airport",
     "countryCode": "US",
     "iata": "WFK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Frenchville"
  }, {
     "name": "Wagga Wagga Airport",
     "countryCode": "AU",
     "iata": "WGA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Wagga Wagga"
  }, {
     "name": "Warangal Airport",
     "countryCode": "IN",
     "iata": "WGC",
     "eucustoms": false,
     "countryDK": "Indien",
     "cityDK": "Warangal"
  }, {
     "name": "Walgett Airport",
     "countryCode": "AU",
     "iata": "WGE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Walgett"
  }, {
     "name": "Winchester Regional Airport",
     "countryCode": "US",
     "iata": "WGO",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Winchester"
  }, {
     "name": "Umbu Mehang Kunda Airport",
     "countryCode": "ID",
     "iata": "WGP",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Waingapu"
  }, {
     "name": "Wangaratta Airport",
     "countryCode": "AU",
     "iata": "WGT",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Wangaratta"
  }, {
     "name": "Wadi Halfa Airport",
     "countryCode": "SD",
     "iata": "WHF",
     "eucustoms": false,
     "countryDK": "Sudan",
     "cityDK": "Wadi Halfa"
  }, {
     "name": "Whakatane Airport",
     "countryCode": "NZ",
     "iata": "WHK",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Whakatane"
  }, {
     "name": "Whiteman Airport",
     "countryCode": "US",
     "iata": "WHP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Los Angeles"
  }, {
     "name": "Whalsay Airport",
     "countryCode": "GB",
     "iata": "WHS",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Whalsay"
  }, {
     "name": "Wick Airport",
     "countryCode": "GB",
     "iata": "WIC",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Wick"
  }, {
     "name": "Wiesbaden Army Airfield",
     "countryCode": "DE",
     "iata": "WIE",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Wiesbaden"
  }, {
     "name": "Wilson Airport",
     "countryCode": "KE",
     "iata": "WIL",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Nairobi"
  }, {
     "name": "Winton Airport",
     "countryCode": "AU",
     "iata": "WIN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Winton"
  }, {
     "name": "Wilcannia Airport",
     "countryCode": "AU",
     "iata": "WIO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Wilcannia"
  }, {
     "name": "Silampari Airport",
     "countryCode": "ID",
     "iata": "LLJ",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Lubuk Linggau"
  }, {
     "name": "Wairoa Airport",
     "countryCode": "NZ",
     "iata": "WIR",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Wairoa"
  }, {
     "name": "Witu Airport",
     "countryCode": "PG",
     "iata": "WIU",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Witu"
  }, {
     "name": "General William J Fox Airfield",
     "countryCode": "US",
     "iata": "WJF",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Lancaster"
  }, {
     "name": "Wajir Airport",
     "countryCode": "KE",
     "iata": "WJR",
     "eucustoms": false,
     "countryDK": "Kenya",
     "cityDK": "Wajir"
  }, {
     "name": "Wonju Airport",
     "countryCode": "KR",
     "iata": "WJU",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Wonju"
  }, {
     "name": "Wanaka Airport",
     "countryCode": "NZ",
     "iata": "WKA",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Wanaka"
  }, {
     "name": "Warracknabeal Airport",
     "countryCode": "AU",
     "iata": "WKB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Warracknabeal"
  }, {
     "name": "Waterkloof Air Force Base",
     "countryCode": "ZA",
     "iata": "WKF",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Waterkloof"
  }, {
     "name": "Hwange Airport",
     "countryCode": "ZW",
     "iata": "WKI",
     "eucustoms": false,
     "countryDK": "Zimbabwe",
     "cityDK": "Hwange"
  }, {
     "name": "Hokkaido Airport",
     "countryCode": "JP",
     "iata": "WKJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Wakkanai"
  }, {
     "name": "Strother Field",
     "countryCode": "US",
     "iata": "WLD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Winfield"
  }, {
     "name": "Wellington International Airport",
     "countryCode": "NZ",
     "iata": "WLG",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Wellington"
  }, {
     "name": "Walaha Airport",
     "countryCode": "VU",
     "iata": "WLH",
     "eucustoms": false,
     "countryDK": "Vanuatu",
     "cityDK": "Walaha"
  }, {
     "name": "Selawik Airport",
     "countryCode": "US",
     "iata": "WLK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Selawik"
  }, {
     "name": "Wallis Island Airport",
     "countryCode": "WF",
     "iata": "WLS",
     "eucustoms": false,
     "countryDK": "Wallis og Futuna",
     "cityDK": "Wallis Island"
  }, {
     "name": "Glenn County Airport",
     "countryCode": "US",
     "iata": "WLW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Willows"
  }, {
     "name": "Mandritsara Airport",
     "countryCode": "MG",
     "iata": "WMA",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Mandritsara"
  }, {
     "name": "Warrnambool Airport",
     "countryCode": "AU",
     "iata": "WMB",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Warrnambool"
  }, {
     "name": "Winnemucca Municipal Airport",
     "countryCode": "US",
     "iata": "WMC",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Winnemucca"
  }, {
     "name": "Mandabe Airport",
     "countryCode": "MG",
     "iata": "WMD",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Mandabe"
  }, {
     "name": "Mount Keith Airport",
     "countryCode": "AU",
     "iata": "WME",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mount Keith"
  }, {
     "name": "Mountain Home Airport",
     "countryCode": "US",
     "iata": "WMH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Mountain Home"
  }, {
     "name": "Malaimbandy Airport",
     "countryCode": "MG",
     "iata": "WML",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Malaimbandy"
  }, {
     "name": "Maroantsetra Airport",
     "countryCode": "MG",
     "iata": "WMN",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Maroantsetra"
  }, {
     "name": "Mananara Nord Airport",
     "countryCode": "MG",
     "iata": "WMR",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Mananara"
  }, {
     "name": "Wamena Airport",
     "countryCode": "ID",
     "iata": "WMX",
     "eucustoms": false,
     "countryDK": "Indonesien",
     "cityDK": "Wamena"
  }, {
     "name": "Wenshan Puzhehei Airport",
     "countryCode": "CN",
     "iata": "WNH",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Wenshan"
  }, {
     "name": "Wunnummin Lake Airport",
     "countryCode": "CA",
     "iata": "WNN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Wunnummin Lake"
  }, {
     "name": "Naga Airport",
     "countryCode": "PH",
     "iata": "WNP",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Naga"
  }, {
     "name": "Windorah Airport",
     "countryCode": "AU",
     "iata": "WNR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Windorah"
  }, {
     "name": "Nawabshah Airport",
     "countryCode": "PK",
     "iata": "WNS",
     "eucustoms": false,
     "countryDK": "Pakistan",
     "cityDK": "Nawabshah"
  }, {
     "name": "Wenzhou Longwan International Airport",
     "countryCode": "CN",
     "iata": "WNZ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Wenzhou"
  }, {
     "name": "Woensdrecht Air Base",
     "countryCode": "NL",
     "iata": "WOE",
     "eucustoms": false,
     "countryDK": "Holland",
     "cityDK": "Woensdrecht Ab"
  }, {
     "name": "Illawara Airport",
     "countryCode": "AU",
     "iata": "WOL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Wollongong"
  }, {
     "name": "Willow Airport",
     "countryCode": "US",
     "iata": "WOW",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Willow"
  }, {
     "name": "Puerto Aisen Airport",
     "countryCode": "CL",
     "iata": "WPA",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Puerto Aisen"
  }, {
     "name": "Port Berge Airport",
     "countryCode": "MG",
     "iata": "WPB",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Port Berge"
  }, {
     "name": "Pincher Creek Airport",
     "countryCode": "CA",
     "iata": "WPC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Pincher Creek"
  }, {
     "name": "Captain F. Martinez Airport",
     "countryCode": "CL",
     "iata": "WPR",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Porvenir"
  }, {
     "name": "Guardiamarina Zanartu Airport",
     "countryCode": "CL",
     "iata": "WPU",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Puerto Williams"
  }, {
     "name": "Robins Air Force Base",
     "countryCode": "US",
     "iata": "WRB",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Macon"
  }, {
     "name": "Whangarei Airport",
     "countryCode": "NZ",
     "iata": "WRE",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Whangarei"
  }, {
     "name": "Wrangell Airport",
     "countryCode": "US",
     "iata": "WRG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wrangell"
  }, {
     "name": "McGuire Air Force Base",
     "countryCode": "US",
     "iata": "WRI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Trenton"
  }, {
     "name": "Worland Airport",
     "countryCode": "US",
     "iata": "WRL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Worland"
  }, {
     "name": "Windarling Airport",
     "countryCode": "AU",
     "iata": "WRN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Windarling"
  }, {
     "name": "Wroclaw Airport",
     "countryCode": "PL",
     "iata": "WRO",
     "eucustoms": false,
     "countryDK": "Polen",
     "cityDK": "Wroclaw"
  }, {
     "name": "Westray Airport",
     "countryCode": "GB",
     "iata": "WRY",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Westray"
  }, {
     "name": "Weerawila Airport",
     "countryCode": "LK",
     "iata": "WRZ",
     "eucustoms": false,
     "countryDK": "Sri Lanka",
     "cityDK": "Weerawila"
  }, {
     "name": "County Airport",
     "countryCode": "US",
     "iata": "WSG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Washington"
  }, {
     "name": "Brookhaven Airport",
     "countryCode": "US",
     "iata": "WSH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Shirley"
  }, {
     "name": "Westerly State Airport",
     "countryCode": "US",
     "iata": "WST",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Westerly"
  }, {
     "name": "Westport Airport",
     "countryCode": "NZ",
     "iata": "WSZ",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Westport"
  }, {
     "name": "Tambohorano Airport",
     "countryCode": "MG",
     "iata": "WTA",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Tambohorano"
  }, {
     "name": "Noatak Airport",
     "countryCode": "US",
     "iata": "WTK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Noatak"
  }, {
     "name": "Waddington RAF Station",
     "countryCode": "GB",
     "iata": "WTN",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Waddington"
  }, {
     "name": "Wotho Airport",
     "countryCode": "MH",
     "iata": "WTO",
     "eucustoms": false,
     "countryDK": "Marshalløerne",
     "cityDK": "Wotho"
  }, {
     "name": "Tsiroanomandidy Airport",
     "countryCode": "MG",
     "iata": "WTS",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Tsiroanomandidy"
  }, {
     "name": "Wudinna Airport",
     "countryCode": "AU",
     "iata": "WUD",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Wudinna"
  }, {
     "name": "Wuhan Tianhe International Airport",
     "countryCode": "CN",
     "iata": "WUH",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Wuhan"
  }, {
     "name": "Wiluna Airport",
     "countryCode": "AU",
     "iata": "WUN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Wiluna"
  }, {
     "name": "Wau Airport",
     "countryCode": "SS",
     "iata": "WUU",
     "eucustoms": false,
     "countryDK": "Sydsudan",
     "cityDK": "Wau"
  }, {
     "name": "Sunan Shuofang International Airport",
     "countryCode": "CN",
     "iata": "WUX",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Wuxi"
  }, {
     "name": "Rooikop Airport",
     "countryCode": "NA",
     "iata": "WVB",
     "eucustoms": false,
     "countryDK": "Namibia",
     "cityDK": "Walvis Bay"
  }, {
     "name": "Watsonville Municipal Airport",
     "countryCode": "US",
     "iata": "WVI",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Watsonville"
  }, {
     "name": "Manakara Airport",
     "countryCode": "MG",
     "iata": "WVK",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Manakara"
  }, {
     "name": "Waterville Robert LaFleur Airport",
     "countryCode": "US",
     "iata": "WVL",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Waterville"
  }, {
     "name": "Mariensiel Airport",
     "countryCode": "DE",
     "iata": "WVN",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Wilhelmshaven"
  }, {
     "name": "Wasilla Airport",
     "countryCode": "US",
     "iata": "WWA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wasilla"
  }, {
     "name": "Cape May County Airport",
     "countryCode": "US",
     "iata": "WWD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Wildwood"
  }, {
     "name": "Woodie Woodie Airport",
     "countryCode": "AU",
     "iata": "WWI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Woodie Woodie Mine"
  }, {
     "name": "Boram Airport",
     "countryCode": "PG",
     "iata": "WWK",
     "eucustoms": false,
     "countryDK": "Papua Ny Guinea",
     "cityDK": "Wewak"
  }, {
     "name": "West Woodward Airport",
     "countryCode": "US",
     "iata": "WWR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Woodward"
  }, {
     "name": "Newtok Airport",
     "countryCode": "US",
     "iata": "WWT",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Newtok"
  }, {
     "name": "West Wyalong Airport",
     "countryCode": "AU",
     "iata": "WWY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "West Wyalong"
  }, {
     "name": "Wuqiao Airport",
     "countryCode": "CN",
     "iata": "WXN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Wanxian"
  }, {
     "name": "Whyalla Airport",
     "countryCode": "AU",
     "iata": "WYA",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Whyalla"
  }, {
     "name": "Yengema Airport",
     "countryCode": "SL",
     "iata": "WYE",
     "eucustoms": false,
     "countryDK": "Sierra Leone",
     "cityDK": "Yengema"
  }, {
     "name": "Wyndham Airport",
     "countryCode": "AU",
     "iata": "WYN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Wyndham"
  }, {
     "name": "Yellowstone Airport",
     "countryCode": "US",
     "iata": "WYS",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "West Yellowstone"
  }, {
     "name": "Chapeco Airport",
     "countryCode": "BR",
     "iata": "XAP",
     "eucustoms": false,
     "countryDK": "Brasilien",
     "cityDK": "Chapeco"
  }, {
     "name": "Aribinda Airport",
     "countryCode": "BF",
     "iata": "XAR",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Aribinda"
  }, {
     "name": "Saul Airport",
     "countryCode": "GF",
     "iata": "XAU",
     "eucustoms": false,
     "countryDK": "Fransk guyana",
     "cityDK": "Saul"
  }, {
     "name": "Bearskin Lake Airport",
     "countryCode": "CA",
     "iata": "XBE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Bearskin Lake"
  }, {
     "name": "Bogande Airport",
     "countryCode": "BF",
     "iata": "XBG",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Bogande"
  }, {
     "name": "Birjand Airport",
     "countryCode": "IR",
     "iata": "XBJ",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Birjand"
  }, {
     "name": "Brockville Airport",
     "countryCode": "CA",
     "iata": "XBR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Brockville"
  }, {
     "name": "Josephstaal Airport",
     "countryCode": "UM",
     "iata": "JON",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Johnston Island"
  }, {
     "name": "Cluff Lake Airport",
     "countryCode": "CA",
     "iata": "XCL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Cluff Lake"
  }, {
     "name": "Chatham Airport",
     "countryCode": "CA",
     "iata": "XCM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Chatham"
  }, {
     "name": "Chalons Vatry Airport",
     "countryCode": "FR",
     "iata": "XCR",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Châlons-en-Champagne"
  }, {
     "name": "Diebougou Airport",
     "countryCode": "BF",
     "iata": "XDE",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Diebougou"
  }, {
     "name": "Djibo Airport",
     "countryCode": "BF",
     "iata": "XDJ",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Djibo"
  }, {
     "name": "Xiangyang Airport",
     "countryCode": "CN",
     "iata": "XFN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Xiangyang"
  }, {
     "name": "Hamburg Finkenwerder Airport",
     "countryCode": "DE",
     "iata": "XFW",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Finkenwerder"
  }, {
     "name": "Amilcar Cabral Airport",
     "countryCode": "BF",
     "iata": "XGA",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Gaoua"
  }, {
     "name": "Gorum-Gorum Airport",
     "countryCode": "BF",
     "iata": "XGG",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Gorom-Gorom"
  }, {
     "name": "Xangongo Airport",
     "countryCode": "AO",
     "iata": "XGN",
     "eucustoms": false,
     "countryDK": "Angola",
     "cityDK": "Xangongo"
  }, {
     "name": "Kangiqsualujjuaq Airport",
     "countryCode": "CA",
     "iata": "XGR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kangiqsualujjuaq"
  }, {
     "name": "Xichang Airport",
     "countryCode": "CN",
     "iata": "XIC",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Xichang"
  }, {
     "name": "Xilinhot Airport",
     "countryCode": "CN",
     "iata": "XIL",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Xilinhot"
  }, {
     "name": "Xianyang International Airport",
     "countryCode": "CN",
     "iata": "XIY",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Xian"
  }, {
     "name": "Al Udeid Air Base",
     "countryCode": "QA",
     "iata": "XJD",
     "eucustoms": false,
     "countryDK": "Qatar",
     "cityDK": "Doha"
  }, {
     "name": "Kantchari Airport",
     "countryCode": "BF",
     "iata": "XKA",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Kantchari"
  }, {
     "name": "Xieng Khouang Airport",
     "countryCode": "LA",
     "iata": "XKH",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Xieng Khouang"
  }, {
     "name": "Kasabonika Airport",
     "countryCode": "CA",
     "iata": "XKS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kasabonika"
  }, {
     "name": "Lac Brochet Airport",
     "countryCode": "CA",
     "iata": "XLB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Lac Brochet"
  }, {
     "name": "St. Louis Airport",
     "countryCode": "SN",
     "iata": "XLS",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Saint Louis"
  }, {
     "name": "Lemwerder Airport",
     "countryCode": "DE",
     "iata": "XLW",
     "eucustoms": false,
     "countryDK": "Tyskland",
     "cityDK": "Lemwerder"
  }, {
     "name": "Mallacoota Airport",
     "countryCode": "AU",
     "iata": "XMC",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Mallacoota"
  }, {
     "name": "Madison Airport",
     "countryCode": "US",
     "iata": "XMD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Madison"
  }, {
     "name": "Mahendranagar Airport",
     "countryCode": "NP",
     "iata": "XMG",
     "eucustoms": false,
     "countryDK": "Nepal",
     "cityDK": "Mahendranagar"
  }, {
     "name": "Manihi Airport",
     "countryCode": "PF",
     "iata": "XMH",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Manihi"
  }, {
     "name": "Masasi Airport",
     "countryCode": "TZ",
     "iata": "XMI",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Masasi"
  }, {
     "name": "Xiamen Gaoqi International Airport",
     "countryCode": "CN",
     "iata": "XMN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Xiamen"
  }, {
     "name": "Macmillan Pass Airport",
     "countryCode": "CA",
     "iata": "XMP",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Macmillan Pass"
  }, {
     "name": "Macas Airport",
     "countryCode": "EC",
     "iata": "XMS",
     "eucustoms": false,
     "countryDK": "Ecuador",
     "cityDK": "Macas"
  }, {
     "name": "Yam Island Airport",
     "countryCode": "AU",
     "iata": "XMY",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Yam Island"
  }, {
     "name": "Northwest Arkansas Regional Airport",
     "countryCode": "US",
     "iata": "XNA",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Bentonville"
  }, {
     "name": "Ali Air Base",
     "countryCode": "IQ",
     "iata": "XNH",
     "eucustoms": false,
     "countryDK": "Irak",
     "cityDK": "Nasiriyah"
  }, {
     "name": "Xining Caojiabao Airport",
     "countryCode": "CN",
     "iata": "XNN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Xining"
  }, {
     "name": "Nouna Airport",
     "countryCode": "BF",
     "iata": "XNU",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Nouna"
  }, {
     "name": "Pama Airport",
     "countryCode": "BF",
     "iata": "XPA",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Pama"
  }, {
     "name": "Pukatawagan Airport",
     "countryCode": "CA",
     "iata": "XPK",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Pukatawagan"
  }, {
     "name": "Poplar River Airport",
     "countryCode": "CA",
     "iata": "XPP",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Poplar River"
  }, {
     "name": "Pine Ridge Airport",
     "countryCode": "US",
     "iata": "XPR",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Pine Ridge"
  }, {
     "name": "Balad Airbase",
     "countryCode": "IQ",
     "iata": "XQC",
     "eucustoms": false,
     "countryDK": "Irak",
     "cityDK": "Balad"
  }, {
     "name": "La Managua Airport",
     "countryCode": "CR",
     "iata": "XQP",
     "eucustoms": false,
     "countryDK": "Costa Rica",
     "cityDK": "Quepos"
  }, {
     "name": "Richmond Air Force Base",
     "countryCode": "AU",
     "iata": "XRH",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Richmond"
  }, {
     "name": "Ross River Airport",
     "countryCode": "CA",
     "iata": "XRR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Ross River"
  }, {
     "name": "Jerez Airport",
     "countryCode": "ES",
     "iata": "XRY",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Jerez De La Frontera"
  }, {
     "name": "Yas Island Airport",
     "countryCode": "AE",
     "iata": "XSB",
     "eucustoms": false,
     "countryDK": "Forenede Arabiske Emirater",
     "cityDK": "Sir Bani Yas Island"
  }, {
     "name": "South Caicos International Airport",
     "countryCode": "TC",
     "iata": "XSC",
     "eucustoms": false,
     "countryDK": "Turks- og Caicosøerne",
     "cityDK": "Sydlige Caicos"
  }, {
     "name": "Tonopah Test Range Airport",
     "countryCode": "US",
     "iata": "XSD",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Tonopah"
  }, {
     "name": "Sebba Airport",
     "countryCode": "BF",
     "iata": "XSE",
     "eucustoms": false,
     "countryDK": "Burkina Faso",
     "cityDK": "Sebba"
  }, {
     "name": "South Indian Lake Airport",
     "countryCode": "CA",
     "iata": "XSI",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "South Indian Lake"
  }, {
     "name": "Seletar Airport",
     "countryCode": "SG",
     "iata": "XSP",
     "eucustoms": false,
     "countryDK": "Singapore",
     "cityDK": "Singapore"
  }, {
     "name": "Thargomindah Airport",
     "countryCode": "AU",
     "iata": "XTG",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Thargomindah"
  }, {
     "name": "Tadoule Lake Airport",
     "countryCode": "CA",
     "iata": "XTL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Tadoule Lake"
  }, {
     "name": "Taroom Airport",
     "countryCode": "AU",
     "iata": "XTO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Taroom"
  }, {
     "name": "Tara Airport",
     "countryCode": "AU",
     "iata": "XTR",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Tara"
  }, {
     "name": "Ye Airport",
     "countryCode": "MM",
     "iata": "XYE",
     "eucustoms": false,
     "countryDK": "Burma",
     "cityDK": "Ye"
  }, {
     "name": "Anahim Lake Airport",
     "countryCode": "CA",
     "iata": "YAA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Anahim Lake"
  }, {
     "name": "Cat Lake Airport",
     "countryCode": "CA",
     "iata": "YAC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Cat Lake"
  }, {
     "name": "Fort Frances Municipal Airport",
     "countryCode": "CA",
     "iata": "YAG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort Frances"
  }, {
     "name": "La Grande-4 Airport",
     "countryCode": "CA",
     "iata": "YAH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "La Grande-4"
  }, {
     "name": "Chillan Airport",
     "countryCode": "CL",
     "iata": "YAI",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Chillan"
  }, {
     "name": "Yakutat Airport",
     "countryCode": "US",
     "iata": "YAK",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Yakutat"
  }, {
     "name": "Alert Bay Airport",
     "countryCode": "CA",
     "iata": "YAL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Alert Bay"
  }, {
     "name": "Sault Ste. Marie Airport",
     "countryCode": "CA",
     "iata": "YAM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sault Ste. Marie"
  }, {
     "name": "Yangambi Airport",
     "countryCode": "CD",
     "iata": "YAN",
     "eucustoms": false,
     "countryDK": "Demokratiske Republik Congo",
     "cityDK": "Yangambi"
  }, {
     "name": "West Angelas Airport",
     "countryCode": "AU",
     "iata": "WLP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "West Angelas"
  }, {
     "name": "Yaounde Ville Airport",
     "countryCode": "CM",
     "iata": "YAO",
     "eucustoms": false,
     "countryDK": "Cameroun",
     "cityDK": "Yaounde"
  }, {
     "name": "Yap International Airport",
     "countryCode": "FM",
     "iata": "YAP",
     "eucustoms": false,
     "countryDK": "Mikronesien",
     "cityDK": "Yap, Caroline Islands"
  }, {
     "name": "La Grande-3 Airport",
     "countryCode": "CA",
     "iata": "YAR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "La Grande-3"
  }, {
     "name": "Yasawa Island Airport",
     "countryCode": "FJ",
     "iata": "YAS",
     "eucustoms": false,
     "countryDK": "Fiji",
     "cityDK": "Yasawa Island"
  }, {
     "name": "Attawapiskat Airport",
     "countryCode": "CA",
     "iata": "YAT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Attawapiskat"
  }, {
     "name": "Shearwater Airport",
     "countryCode": "CA",
     "iata": "YAW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Halifax"
  }, {
     "name": "Wapekeka Airport",
     "countryCode": "CA",
     "iata": "YAX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Angling Lake"
  }, {
     "name": "St. Anthony Airport",
     "countryCode": "CA",
     "iata": "YAY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Saint Anthony"
  }, {
     "name": "Tofino Long Beach Airport",
     "countryCode": "CA",
     "iata": "YAZ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Tofino"
  }, {
     "name": "Kugaaruk Airport",
     "countryCode": "CA",
     "iata": "YBB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Pelly Bay"
  }, {
     "name": "Baie-Comeau Airport",
     "countryCode": "CA",
     "iata": "YBC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Baie Comeau"
  }, {
     "name": "Uranium City Airport",
     "countryCode": "CA",
     "iata": "YBE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Uranby"
  }, {
     "name": "Saguenay-Bagotville Airport",
     "countryCode": "CA",
     "iata": "YBG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "La Baie"
  }, {
     "name": "Bull Harbour Seaplane Base",
     "countryCode": "CA",
     "iata": "YBH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Bull Harbor"
  }, {
     "name": "Black Tickle Airport",
     "countryCode": "CA",
     "iata": "YBI",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Black Tickle"
  }, {
     "name": "Baker Lake Airport",
     "countryCode": "CA",
     "iata": "YBK",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Baker Lake"
  }, {
     "name": "Campbell River Airport",
     "countryCode": "CA",
     "iata": "YBL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Campbell River"
  }, {
     "name": "Bronson Creek Airport",
     "countryCode": "CA",
     "iata": "YBM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Bronson Creek"
  }, {
     "name": "Yibin Caiba Airport",
     "countryCode": "CN",
     "iata": "YBP",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Yibin"
  }, {
     "name": "Brandon Municipal Airport",
     "countryCode": "CA",
     "iata": "YBR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Brandon"
  }, {
     "name": "Brochet Airport",
     "countryCode": "CA",
     "iata": "YBT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Brochet"
  }, {
     "name": "Berens River Airport",
     "countryCode": "CA",
     "iata": "YBV",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Berens River"
  }, {
     "name": "Blanc Sablon Airport",
     "countryCode": "CA",
     "iata": "YBX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Blanc Sablon"
  }, {
     "name": "Bonnyville Airport",
     "countryCode": "CA",
     "iata": "YBY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Bonnyville"
  }, {
     "name": "Courtenay Airport",
     "countryCode": "CA",
     "iata": "YCA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Courtenay"
  }, {
     "name": "Cambridge Bay Airport",
     "countryCode": "CA",
     "iata": "YCB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Cambridge Bay"
  }, {
     "name": "Cornwall Regional Airport",
     "countryCode": "CA",
     "iata": "YCC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Cornwall"
  }, {
     "name": "Nanaimo Airport",
     "countryCode": "CA",
     "iata": "YCD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Nanaimo"
  }, {
     "name": "Centralia Airport",
     "countryCode": "CA",
     "iata": "YCE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Centralia"
  }, {
     "name": "Castlegar Airport",
     "countryCode": "CA",
     "iata": "YCG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Castlegar"
  }, {
     "name": "Miramichi Airport",
     "countryCode": "CA",
     "iata": "YCH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Miramichi"
  }, {
     "name": "RAAF Base Curtin",
     "countryCode": "AU",
     "iata": "DCN",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Curtin"
  }, {
     "name": "Colville Lake Airport",
     "countryCode": "CA",
     "iata": "YCK",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Colville Lake"
  }, {
     "name": "Charlo Airport",
     "countryCode": "CA",
     "iata": "YCL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Charlo"
  }, {
     "name": "St. Catharines Airport",
     "countryCode": "CA",
     "iata": "YCM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Saint Catharines"
  }, {
     "name": "Cochrane Airport",
     "countryCode": "CA",
     "iata": "YCN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Cochrane"
  }, {
     "name": "Kugluktuk Airport",
     "countryCode": "CA",
     "iata": "YCO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kugluktuk / Coppermine"
  }, {
     "name": "Chetwynd Airport",
     "countryCode": "CA",
     "iata": "YCQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Chetwynd"
  }, {
     "name": "Charlie Sinclair Memorial Airport",
     "countryCode": "CA",
     "iata": "YCR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Cross Lake"
  }, {
     "name": "Chesterfield Inlet Airport",
     "countryCode": "CA",
     "iata": "YCS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Chesterfield Inlet"
  }, {
     "name": "Coronation Airport",
     "countryCode": "CA",
     "iata": "YCT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kroning"
  }, {
     "name": "Yuncheng Airport",
     "countryCode": "CN",
     "iata": "YCU",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Yuncheng"
  }, {
     "name": "Chilliwack Airport",
     "countryCode": "CA",
     "iata": "YCW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Chilliwack"
  }, {
     "name": "Clyde River Airport",
     "countryCode": "CA",
     "iata": "YCY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Clyde River"
  }, {
     "name": "Fairmount Springs Airport",
     "countryCode": "CA",
     "iata": "YCZ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fairmount Springs"
  }, {
     "name": "Dawson City Airport",
     "countryCode": "CA",
     "iata": "YDA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Dawson City"
  }, {
     "name": "Burwash Landings Airport",
     "countryCode": "CA",
     "iata": "YDB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Burwash Landings"
  }, {
     "name": "Industrial Airport",
     "countryCode": "CA",
     "iata": "YDC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Drayton Valley"
  }, {
     "name": "Deer Lake Regional Airport",
     "countryCode": "CA",
     "iata": "YDF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Hjorte sø"
  }, {
     "name": "Annapolis Regional Airport",
     "countryCode": "CA",
     "iata": "YDG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Digby"
  }, {
     "name": "Davis Inlet Airport",
     "countryCode": "CA",
     "iata": "YDI",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Davis Inlet"
  }, {
     "name": "Hatchet Lake Airport",
     "countryCode": "CA",
     "iata": "YDJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Hatchet Lake"
  }, {
     "name": "Dease Lake Airport",
     "countryCode": "CA",
     "iata": "YDL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Dease Lake"
  }, {
     "name": "Lt. W.G. (Billy) Barker Airport",
     "countryCode": "CA",
     "iata": "YDN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Dauphin"
  }, {
     "name": "St. Felicien Airport",
     "countryCode": "CA",
     "iata": "YDO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Dolbeau"
  }, {
     "name": "Nain Airport",
     "countryCode": "CA",
     "iata": "YDP",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Nain"
  }, {
     "name": "Dawson Creek Airport",
     "countryCode": "CA",
     "iata": "YDQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Dawson Creek"
  }, {
     "name": "Boundary Bay Airport",
     "countryCode": "CA",
     "iata": "YDT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Vancouver"
  }, {
     "name": "Kasba Lake Airport",
     "countryCode": "CA",
     "iata": "YDU",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kasba Lake"
  }, {
     "name": "Bloodvein Airport",
     "countryCode": "CA",
     "iata": "YDV",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Bloodvein"
  }, {
     "name": "Yecheon Airport",
     "countryCode": "KR",
     "iata": "YEC",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Yecheon"
  }, {
     "name": "Edmonton International Airport",
     "countryCode": "CA",
     "iata": "YEG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Edmonton"
  }, {
     "name": "Yenisehir Airport",
     "countryCode": "TR",
     "iata": "YEI",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Bursa"
  }, {
     "name": "Arviat Airport",
     "countryCode": "CA",
     "iata": "YEK",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Arviat"
  }, {
     "name": "Elliot Lake Municipal Airport",
     "countryCode": "CA",
     "iata": "YEL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Elliot Lake"
  }, {
     "name": "Manitoulin East Municipal Airport",
     "countryCode": "CA",
     "iata": "YEM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Manitowaning"
  }, {
     "name": "Estevan Regional Airport",
     "countryCode": "CA",
     "iata": "YEN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Estevan"
  }, {
     "name": "Yeovilton Airport",
     "countryCode": "GB",
     "iata": "YEO",
     "eucustoms": false,
     "countryDK": "Storbritannien",
     "cityDK": "Yeovilton"
  }, {
     "name": "Fort Severn Airport",
     "countryCode": "CA",
     "iata": "YER",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort Severn"
  }, {
     "name": "Edson Airport",
     "countryCode": "CA",
     "iata": "YET",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Edson"
  }, {
     "name": "Eureka Airport",
     "countryCode": "CA",
     "iata": "YEU",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Eureka"
  }, {
     "name": "Inuvik Mike Zubko Airport",
     "countryCode": "CA",
     "iata": "YEV",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Inuvik"
  }, {
     "name": "Amos/Magny Airport",
     "countryCode": "CA",
     "iata": "YEY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Amos"
  }, {
     "name": "Fort Albany Airport",
     "countryCode": "CA",
     "iata": "YFA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort Albany"
  }, {
     "name": "Iqaluit Airport",
     "countryCode": "CA",
     "iata": "YFB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Iqaluit"
  }, {
     "name": "Fredericton International Airport",
     "countryCode": "CA",
     "iata": "YFC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fredericton"
  }, {
     "name": "Fort Hope Airport",
     "countryCode": "CA",
     "iata": "YFH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort Hope"
  }, {
     "name": "Wekweeti Airport",
     "countryCode": "CA",
     "iata": "YFJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Snare Lake"
  }, {
     "name": "Flin Flon Airport",
     "countryCode": "CA",
     "iata": "YFO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Flin Flon"
  }, {
     "name": "Fort Resolution Airport",
     "countryCode": "CA",
     "iata": "YFR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort Resolution"
  }, {
     "name": "Fort Simpson Airport",
     "countryCode": "CA",
     "iata": "YFS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort Simpson"
  }, {
     "name": "Fox Harbour Airport",
     "countryCode": "CA",
     "iata": "YFX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fox Harbor"
  }, {
     "name": "Gillies Bay Airport",
     "countryCode": "CA",
     "iata": "YGB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Gillies Bay"
  }, {
     "name": "Grande Cache Airport",
     "countryCode": "CA",
     "iata": "YGC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Grande Cache"
  }, {
     "name": "Fort Good Hope Airport",
     "countryCode": "CA",
     "iata": "YGH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort Good Hope"
  }, {
     "name": "Miho Airport",
     "countryCode": "JP",
     "iata": "YGJ",
     "eucustoms": false,
     "countryDK": "Japan",
     "cityDK": "Yonago"
  }, {
     "name": "Kingston/Norman Rogers Airport",
     "countryCode": "CA",
     "iata": "YGK",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kingston"
  }, {
     "name": "La Grande Airport",
     "countryCode": "CA",
     "iata": "YGL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "La Grande"
  }, {
     "name": "Gimli Industrial Park Airport",
     "countryCode": "CA",
     "iata": "YGM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Gimli"
  }, {
     "name": "Gods Lake Narrows Airport",
     "countryCode": "CA",
     "iata": "YGO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Gods Lake Narrows"
  }, {
     "name": "Michel-Pouliot Gaspe Airport",
     "countryCode": "CA",
     "iata": "YGP",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Gaspe"
  }, {
     "name": "Greenstone Regional Airport",
     "countryCode": "CA",
     "iata": "YGQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Geraldton"
  }, {
     "name": "Iles De La Madeleine Airport",
     "countryCode": "CA",
     "iata": "YGR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Iles De La Madeleine"
  }, {
     "name": "Igloolik Airport",
     "countryCode": "CA",
     "iata": "YGT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Igloolik"
  }, {
     "name": "Havre St. Pierre Airport",
     "countryCode": "CA",
     "iata": "YGV",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Havre St. Pierre"
  }, {
     "name": "Kuujjuarapik Airport",
     "countryCode": "CA",
     "iata": "YGW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kuujjuarapik"
  }, {
     "name": "Gillam Airport",
     "countryCode": "CA",
     "iata": "YGX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Gillam"
  }, {
     "name": "Grise Fiord Airport",
     "countryCode": "CA",
     "iata": "YGZ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Grise Fiord"
  }, {
     "name": "Port Hope Simpson Airport",
     "countryCode": "CA",
     "iata": "YHA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Port Hope Simpson"
  }, {
     "name": "Hudson Bay Airport",
     "countryCode": "CA",
     "iata": "YHB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Hudson Bay"
  }, {
     "name": "Dryden Regional Airport",
     "countryCode": "CA",
     "iata": "YHD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Dryden"
  }, {
     "name": "Hope Airport",
     "countryCode": "CA",
     "iata": "YHE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Hope"
  }, {
     "name": "Rene Fontaine Municipal Airport",
     "countryCode": "CA",
     "iata": "YHF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Hearst"
  }, {
     "name": "Charlottetown Airport",
     "countryCode": "CA",
     "iata": "YHG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Charlottetown"
  }, {
     "name": "Ulukhaktok Airport",
     "countryCode": "CA",
     "iata": "YHI",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Ulukhaktok"
  }, {
     "name": "Gjoa Haven Airport",
     "countryCode": "CA",
     "iata": "YHK",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Gjoa Haven"
  }, {
     "name": "John C. Munro Hamilton Airport",
     "countryCode": "CA",
     "iata": "YHM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Hamilton"
  }, {
     "name": "Hornepayne Municipal Airport",
     "countryCode": "CA",
     "iata": "YHN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Hornepayne"
  }, {
     "name": "Hopedale Airport",
     "countryCode": "CA",
     "iata": "YHO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Hopedale"
  }, {
     "name": "Chevery Airport",
     "countryCode": "CA",
     "iata": "YHR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Chevery"
  }, {
     "name": "Sechelt Airport",
     "countryCode": "CA",
     "iata": "YHS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sechelt"
  }, {
     "name": "Haines Junction Airport",
     "countryCode": "CA",
     "iata": "YHT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Haines Junction"
  }, {
     "name": "St. Hubert Airport",
     "countryCode": "CA",
     "iata": "YHU",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Montreal"
  }, {
     "name": "Merlyn Carter Airport",
     "countryCode": "CA",
     "iata": "YHY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Hay River"
  }, {
     "name": "Halifax Stanfield International Airport",
     "countryCode": "CA",
     "iata": "YHZ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Halifax"
  }, {
     "name": "Atikokan Airport",
     "countryCode": "CA",
     "iata": "YIB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Atikokan"
  }, {
     "name": "Arxan Yiershi Airport",
     "countryCode": "CN",
     "iata": "YIE",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Arxan"
  }, {
     "name": "Pakuashipi Airport",
     "countryCode": "CA",
     "iata": "YIF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Pakuashipi"
  }, {
     "name": "Ivujivik Airport",
     "countryCode": "CA",
     "iata": "YIK",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Ivujivik"
  }, {
     "name": "Yining Airport",
     "countryCode": "CN",
     "iata": "YIN",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Yining"
  }, {
     "name": "Pond Inlet Airport",
     "countryCode": "CA",
     "iata": "YIO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Pond Inlet"
  }, {
     "name": "Willow Run Airport",
     "countryCode": "US",
     "iata": "YIP",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Detroit"
  }, {
     "name": "Island Lake Airport",
     "countryCode": "CA",
     "iata": "YIV",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Island Lake"
  }, {
     "name": "Jasper Airport",
     "countryCode": "CA",
     "iata": "YJA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "jaspis"
  }, {
     "name": "Fort Liard Airport",
     "countryCode": "CA",
     "iata": "YJF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort Liard"
  }, {
     "name": "Saint Jean Airport",
     "countryCode": "CA",
     "iata": "YJN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Saint Jean"
  }, {
     "name": "Stephenville Airport",
     "countryCode": "CA",
     "iata": "YJT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Stephenville"
  }, {
     "name": "Kamloops Airport",
     "countryCode": "CA",
     "iata": "YKA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kamloops"
  }, {
     "name": "Collins Bay Airport",
     "countryCode": "CA",
     "iata": "YKC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Collins Bay"
  }, {
     "name": "Kincardine Airport",
     "countryCode": "CA",
     "iata": "YKD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kincardine"
  }, {
     "name": "Knee Lake Airport",
     "countryCode": "CA",
     "iata": "YKE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Knee Lake"
  }, {
     "name": "Region of Waterloo International Airport",
     "countryCode": "CA",
     "iata": "YKF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kitchener"
  }, {
     "name": "Kangirsuk Airport",
     "countryCode": "CA",
     "iata": "YKG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kangirsuk"
  }, {
     "name": "Key Lake Airport",
     "countryCode": "CA",
     "iata": "YKJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Key Lake"
  }, {
     "name": "Schefferville Airport",
     "countryCode": "CA",
     "iata": "YKL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Schefferville"
  }, {
     "name": "Yakima Air Terminal",
     "countryCode": "US",
     "iata": "YKM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Yakima"
  }, {
     "name": "Chan Gurney Airport",
     "countryCode": "US",
     "iata": "YKN",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Yankton"
  }, {
     "name": "Hakkari Yuksekova Selahaddin Eyyubi Airport",
     "countryCode": "TR",
     "iata": "YKO",
     "eucustoms": false,
     "countryDK": "Tyrkiet",
     "cityDK": "Yuksekova"
  }, {
     "name": "Waskaganish Airport",
     "countryCode": "CA",
     "iata": "YKQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Waskaganish"
  }, {
     "name": "Yakutsk Airport",
     "countryCode": "RU",
     "iata": "YKS",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Yakutsk"
  }, {
     "name": "Kirkland Lake Airport",
     "countryCode": "CA",
     "iata": "YKX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kirkland Lake"
  }, {
     "name": "Kindersley Regional Airport",
     "countryCode": "CA",
     "iata": "YKY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kindersley"
  }, {
     "name": "Buttonville Municipal Airport",
     "countryCode": "CA",
     "iata": "YKZ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Toronto"
  }, {
     "name": "Lac Biche Airport",
     "countryCode": "CA",
     "iata": "YLB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Lac Biche"
  }, {
     "name": "Kimmirut Airport",
     "countryCode": "CA",
     "iata": "YLC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kimmirut / Lake Harbour"
  }, {
     "name": "Chapleau Airport",
     "countryCode": "CA",
     "iata": "YLD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Chapleau"
  }, {
     "name": "Whati Airport",
     "countryCode": "CA",
     "iata": "YLE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Whati / Lac La Martre"
  }, {
     "name": "Lansdowne House Airport",
     "countryCode": "CA",
     "iata": "YLH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Lansdowne House"
  }, {
     "name": "Ylivieska Airport",
     "countryCode": "FI",
     "iata": "YLI",
     "eucustoms": false,
     "countryDK": "Finland",
     "cityDK": "Ylivieska"
  }, {
     "name": "Meadow Lake Airport",
     "countryCode": "CA",
     "iata": "YLJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Meadow Lake"
  }, {
     "name": "Lloydminster Airport",
     "countryCode": "CA",
     "iata": "YLL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Lloydminster"
  }, {
     "name": "Ballera Airport",
     "countryCode": "AU",
     "iata": "BBL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ballera"
  }, {
     "name": "La Tuque Airport",
     "countryCode": "CA",
     "iata": "YLQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "La Tuque"
  }, {
     "name": "Leaf Rapids Airport",
     "countryCode": "CA",
     "iata": "YLR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Leaf Rapids"
  }, {
     "name": "Lebel-Sur-Quevillon Airport",
     "countryCode": "CA",
     "iata": "YLS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Lebel-Sur-Quevillon"
  }, {
     "name": "Alert Airport",
     "countryCode": "CA",
     "iata": "YLT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Alert"
  }, {
     "name": "Kelowna International Airport",
     "countryCode": "CA",
     "iata": "YLW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kelowna"
  }, {
     "name": "Langley Regional Airport",
     "countryCode": "CA",
     "iata": "YLY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Langley"
  }, {
     "name": "Mayo Airport",
     "countryCode": "CA",
     "iata": "YMA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Mayo"
  }, {
     "name": "Merritt Airport",
     "countryCode": "CA",
     "iata": "YMB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Merritt"
  }, {
     "name": "Matane Airport",
     "countryCode": "CA",
     "iata": "YME",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Matane"
  }, {
     "name": "Manitouwadge Airport",
     "countryCode": "CA",
     "iata": "YMG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Manitouwadge"
  }, {
     "name": "Mary's Harbour Airport",
     "countryCode": "CA",
     "iata": "YMH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Mary's Harbour"
  }, {
     "name": "C.M. McEwen Airport",
     "countryCode": "CA",
     "iata": "YMJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Moose Jaw"
  }, {
     "name": "Mys Kamennyy Airport",
     "countryCode": "RU",
     "iata": "YMK",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Mys Kamennyy"
  }, {
     "name": "Charlevoix Airport",
     "countryCode": "CA",
     "iata": "YML",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Murray Bay"
  }, {
     "name": "Fort McMurray International Airport",
     "countryCode": "CA",
     "iata": "YMM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort McMurray"
  }, {
     "name": "Murrin Murrin Airport",
     "countryCode": "AU",
     "iata": "WUI",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Murrin Murrin"
  }, {
     "name": "Makkovik Airport",
     "countryCode": "CA",
     "iata": "YMN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Makkovik"
  }, {
     "name": "Moosonee Airport",
     "countryCode": "CA",
     "iata": "YMO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Moosonee"
  }, {
     "name": "Yurimaguas Airport",
     "countryCode": "PE",
     "iata": "YMS",
     "eucustoms": false,
     "countryDK": "Peru",
     "cityDK": "Yurimaguas"
  }, {
     "name": "Chibougamau Airport",
     "countryCode": "CA",
     "iata": "YMT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Chibougamau"
  }, {
     "name": "Maniwaki Airport",
     "countryCode": "CA",
     "iata": "YMW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Maniwaki"
  }, {
     "name": "Mirabel International Airport",
     "countryCode": "CA",
     "iata": "YMX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Montreal"
  }, {
     "name": "Natashquan Airport",
     "countryCode": "CA",
     "iata": "YNA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Natashquan"
  }, {
     "name": "Yanbu Airport",
     "countryCode": "SA",
     "iata": "YNB",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Yanbu"
  }, {
     "name": "Wemindji Airport",
     "countryCode": "CA",
     "iata": "YNC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Wemindji"
  }, {
     "name": "Gatineau Airport",
     "countryCode": "CA",
     "iata": "YND",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Gatineau"
  }, {
     "name": "Norway House Airport",
     "countryCode": "CA",
     "iata": "YNE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Norway House"
  }, {
     "name": "Youngstown-Warren Regional Airport",
     "countryCode": "US",
     "iata": "YNG",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Youngstown"
  }, {
     "name": "Hudson's Hope Airport",
     "countryCode": "CA",
     "iata": "YNH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Hudson's Hope"
  }, {
     "name": "Yanji Chaoyangchuan Airport",
     "countryCode": "CN",
     "iata": "YNJ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Yanji"
  }, {
     "name": "Points North Landing Airport",
     "countryCode": "CA",
     "iata": "YNL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Point North Landing"
  }, {
     "name": "Matagami Airport",
     "countryCode": "CA",
     "iata": "YNM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Matagami"
  }, {
     "name": "Nemiscau Airport",
     "countryCode": "CA",
     "iata": "YNS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Nemiscau"
  }, {
     "name": "Yantai Laishan International Airport",
     "countryCode": "CN",
     "iata": "YNT",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Yantai"
  }, {
     "name": "Yangyang Airport",
     "countryCode": "KR",
     "iata": "YNY",
     "eucustoms": false,
     "countryDK": "Sydkorea",
     "cityDK": "Yangyang"
  }, {
     "name": "Yancheng Nanyang International Airport",
     "countryCode": "CN",
     "iata": "YNZ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Yancheng"
  }, {
     "name": "Ekati Airport",
     "countryCode": "CA",
     "iata": "YOA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Ekati"
  }, {
     "name": "Old Crow Airport",
     "countryCode": "CA",
     "iata": "YOC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Old Crow"
  }, {
     "name": "R.W. McNair Airport",
     "countryCode": "CA",
     "iata": "YOD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Cold Lake"
  }, {
     "name": "Ogoki Airport",
     "countryCode": "CA",
     "iata": "YOG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Ogoki"
  }, {
     "name": "Oxford House Airport",
     "countryCode": "CA",
     "iata": "YOH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Oxford House"
  }, {
     "name": "High Level Airport",
     "countryCode": "CA",
     "iata": "YOJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "High Level"
  }, {
     "name": "Yola Airport",
     "countryCode": "NG",
     "iata": "YOL",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Yola"
  }, {
     "name": "Yongphulla Airport",
     "countryCode": "BT",
     "iata": "YON",
     "eucustoms": false,
     "countryDK": "Bhutan",
     "cityDK": "Trashigang"
  }, {
     "name": "Oshawa Municipal Airport",
     "countryCode": "CA",
     "iata": "YOO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Oshawa"
  }, {
     "name": "Rainbow Lake Airport",
     "countryCode": "CA",
     "iata": "YOP",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Rainbow Lake"
  }, {
     "name": "Billy Bishop Regional Airport",
     "countryCode": "CA",
     "iata": "YOS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Owen Sound"
  }, {
     "name": "Ottawa/Macdonald-Cartier International Airport",
     "countryCode": "CA",
     "iata": "YOW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Ottawa"
  }, {
     "name": "Glass Field",
     "countryCode": "CA",
     "iata": "YPA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Prins Albert"
  }, {
     "name": "Nora A. Ruben Airport",
     "countryCode": "CA",
     "iata": "YPC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Paulatuk"
  }, {
     "name": "Parry Sound Airport",
     "countryCode": "CA",
     "iata": "YPD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Parry Sound"
  }, {
     "name": "Peace River Airport",
     "countryCode": "CA",
     "iata": "YPE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Peace River"
  }, {
     "name": "Esquimalt Airport",
     "countryCode": "CA",
     "iata": "YPF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Esquimalt"
  }, {
     "name": "Southport Airport",
     "countryCode": "CA",
     "iata": "YPG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Portage La Prarie"
  }, {
     "name": "Inukjuak Airport",
     "countryCode": "CA",
     "iata": "YPH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Inukjuak"
  }, {
     "name": "Aupaluk Airport",
     "countryCode": "CA",
     "iata": "YPJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Aupaluk"
  }, {
     "name": "Pickle Lake Airport",
     "countryCode": "CA",
     "iata": "YPL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Pickle Lake"
  }, {
     "name": "Pikangikum Airport",
     "countryCode": "CA",
     "iata": "YPM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Pikangikum"
  }, {
     "name": "Port-Menier Airport",
     "countryCode": "CA",
     "iata": "YPN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Port-Menier"
  }, {
     "name": "Peawanuk Airport",
     "countryCode": "CA",
     "iata": "YPO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Peawanuk"
  }, {
     "name": "Peterborough Airport",
     "countryCode": "CA",
     "iata": "YPQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Peterborough"
  }, {
     "name": "Digby Island Airport",
     "countryCode": "CA",
     "iata": "YPR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Prins rupert"
  }, {
     "name": "Port Hawkesbury Airport",
     "countryCode": "CA",
     "iata": "YPS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Port Hawkesbury"
  }, {
     "name": "Powell River Airport",
     "countryCode": "CA",
     "iata": "YPW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Powell River"
  }, {
     "name": "Puvirnituq Airport",
     "countryCode": "CA",
     "iata": "YPX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Povungnituk"
  }, {
     "name": "Fort Chipewyan Airport",
     "countryCode": "CA",
     "iata": "YPY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort Chipewyan"
  }, {
     "name": "Burns Lake Airport",
     "countryCode": "CA",
     "iata": "YPZ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Burns Lake"
  }, {
     "name": "Muskoka Airport",
     "countryCode": "CA",
     "iata": "YQA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Muskoka"
  }, {
     "name": "Quebec City Jean Lesage International Airport",
     "countryCode": "CA",
     "iata": "YQB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Quebec"
  }, {
     "name": "Quaqtaq Airport",
     "countryCode": "CA",
     "iata": "YQC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Quaqtaq"
  }, {
     "name": "The Pas Airport",
     "countryCode": "CA",
     "iata": "YQD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "The Pas"
  }, {
     "name": "Red Deer Regional Airport",
     "countryCode": "CA",
     "iata": "YQF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Red Deer"
  }, {
     "name": "Windsor International Airport",
     "countryCode": "CA",
     "iata": "YQG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Windsor"
  }, {
     "name": "Watson Lake Airport",
     "countryCode": "CA",
     "iata": "YQH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Watson Lake"
  }, {
     "name": "Yarmouth Airport",
     "countryCode": "CA",
     "iata": "YQI",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Yarmouth"
  }, {
     "name": "Kenora Airport",
     "countryCode": "CA",
     "iata": "YQK",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kenora"
  }, {
     "name": "Lethbridge Airport",
     "countryCode": "CA",
     "iata": "YQL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Lethbridge"
  }, {
     "name": "Greater Moncton International Airport",
     "countryCode": "CA",
     "iata": "YQM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Moncton"
  }, {
     "name": "Nakina Airport",
     "countryCode": "CA",
     "iata": "YQN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Nakina"
  }, {
     "name": "Comox Airport",
     "countryCode": "CA",
     "iata": "YQQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Comox"
  }, {
     "name": "Regina International Airport",
     "countryCode": "CA",
     "iata": "YQR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "regina"
  }, {
     "name": "Pembroke Area Municipal Airport",
     "countryCode": "CA",
     "iata": "YQS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Saint Thomas"
  }, {
     "name": "Thunder Bay International Airport",
     "countryCode": "CA",
     "iata": "YQT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Thunder Bay"
  }, {
     "name": "Grande Prairie Airport",
     "countryCode": "CA",
     "iata": "YQU",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Grande Prairie"
  }, {
     "name": "Yorkton Municipal Airport",
     "countryCode": "CA",
     "iata": "YQV",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Yorkton"
  }, {
     "name": "Cameron McIntosh Airport",
     "countryCode": "CA",
     "iata": "YQW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "North Battleford"
  }, {
     "name": "Gander International Airport",
     "countryCode": "CA",
     "iata": "YQX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Gander"
  }, {
     "name": "Sydney Airport",
     "countryCode": "CA",
     "iata": "YQY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sydney"
  }, {
     "name": "Quesnel Airport",
     "countryCode": "CA",
     "iata": "YQZ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Quesnel"
  }, {
     "name": "Null",
     "countryCode": "CA",
     "iata": "YR6",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Campbell River"
  }, {
     "name": "Gameti Rae Lakes Airport",
     "countryCode": "CA",
     "iata": "YRA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Rae Lakes"
  }, {
     "name": "Resolute Bay Airport",
     "countryCode": "CA",
     "iata": "YRB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Resolute"
  }, {
     "name": "Cartwright Airport",
     "countryCode": "CA",
     "iata": "YRF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Cartwright"
  }, {
     "name": "Rigolet Airport",
     "countryCode": "CA",
     "iata": "YRG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Rigolet"
  }, {
     "name": "Riviere-du-Loup Airport",
     "countryCode": "CA",
     "iata": "YRI",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Riviere-du-Loup"
  }, {
     "name": "Roberval Airport",
     "countryCode": "CA",
     "iata": "YRJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Roberval"
  }, {
     "name": "Red Lake Airport",
     "countryCode": "CA",
     "iata": "YRL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Red Lake"
  }, {
     "name": "Rocky Mountain House Airport",
     "countryCode": "CA",
     "iata": "YRM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Rocky Mountain House"
  }, {
     "name": "Rockcliffe Airport",
     "countryCode": "CA",
     "iata": "YRO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Ottawa"
  }, {
     "name": "Trois-Rivieres Airport",
     "countryCode": "CA",
     "iata": "YRQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Trois-Rivieres"
  }, {
     "name": "Red Sucker Lake Airport",
     "countryCode": "CA",
     "iata": "YRS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Red Sucker Lake"
  }, {
     "name": "Rankin Inlet Airport",
     "countryCode": "CA",
     "iata": "YRT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Rankin Inlet"
  }, {
     "name": "Revelstoke Airport",
     "countryCode": "CA",
     "iata": "YRV",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Revelstoke"
  }, {
     "name": "Sudbury Airport",
     "countryCode": "CA",
     "iata": "YSB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sudbury"
  }, {
     "name": "Sherbrooke Airport",
     "countryCode": "CA",
     "iata": "YSC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sherbrooke"
  }, {
     "name": "Suffield CFB Heliport",
     "countryCode": "CA",
     "iata": "YSD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Suffield"
  }, {
     "name": "Squamish Airport",
     "countryCode": "CA",
     "iata": "YSE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Squamish"
  }, {
     "name": "Stony Rapids Airport",
     "countryCode": "CA",
     "iata": "YSF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Stony Rapids"
  }, {
     "name": "Montague Airport",
     "countryCode": "CA",
     "iata": "YSH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Smith Falls"
  }, {
     "name": "Saint John Airport",
     "countryCode": "CA",
     "iata": "YSJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Saint John"
  }, {
     "name": "Sanikiluaq Airport",
     "countryCode": "CA",
     "iata": "YSK",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sanikiluaq"
  }, {
     "name": "St Leonard Airport",
     "countryCode": "CA",
     "iata": "YSL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "St Leonard"
  }, {
     "name": "Fort Smith Airport",
     "countryCode": "CA",
     "iata": "YSM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort Smith"
  }, {
     "name": "Salmon Arm Airport",
     "countryCode": "CA",
     "iata": "YSN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Laksarm"
  }, {
     "name": "Postville Airport",
     "countryCode": "CA",
     "iata": "YSO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Postville"
  }, {
     "name": "Marathon Airport",
     "countryCode": "CA",
     "iata": "YSP",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Marathon"
  }, {
     "name": "Nanisivik Airport",
     "countryCode": "CA",
     "iata": "YSR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Nanisivik"
  }, {
     "name": "St. Theresa Point Airport",
     "countryCode": "CA",
     "iata": "YST",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "St. Theresa Point"
  }, {
     "name": "Summerside Airport",
     "countryCode": "CA",
     "iata": "YSU",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Summerside"
  }, {
     "name": "Sachs Harbour Airport",
     "countryCode": "CA",
     "iata": "YSY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sachs Harbour"
  }, {
     "name": "Pembroke And Area Airport",
     "countryCode": "CA",
     "iata": "YTA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Pembroke"
  }, {
     "name": "Thicket Portage Airport",
     "countryCode": "CA",
     "iata": "YTD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Thicket Portage"
  }, {
     "name": "Cape Dorset Airport",
     "countryCode": "CA",
     "iata": "YTE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Cape Dorset"
  }, {
     "name": "Trepell Airport",
     "countryCode": "AU",
     "iata": "TQP",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Trepell"
  }, {
     "name": "Alma Airport",
     "countryCode": "CA",
     "iata": "YTF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Alma"
  }, {
     "name": "Thompson Airport",
     "countryCode": "CA",
     "iata": "YTH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Thompson"
  }, {
     "name": "Terrace Bay Airport",
     "countryCode": "CA",
     "iata": "YTJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Terrace Bay"
  }, {
     "name": "Big Trout Airport",
     "countryCode": "CA",
     "iata": "YTL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Big Trout"
  }, {
     "name": "Mont-Tremblant International Airport",
     "countryCode": "CA",
     "iata": "YTM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "La Macaza"
  }, {
     "name": "Tasiujuaq Airport",
     "countryCode": "CA",
     "iata": "YTQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Tasiujuaq"
  }, {
     "name": "Trenton Airport",
     "countryCode": "CA",
     "iata": "YTR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Trenton"
  }, {
     "name": "Timmins Victor M. Power Airport",
     "countryCode": "CA",
     "iata": "YTS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Timmins"
  }, {
     "name": "Tisdale Airport",
     "countryCode": "CA",
     "iata": "YTT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Tisdale"
  }, {
     "name": "Telegraph Creek Airport",
     "countryCode": "CA",
     "iata": "YTX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Telegraph Creek"
  }, {
     "name": "Yangzhou Taizhou Airport",
     "countryCode": "CN",
     "iata": "YTY",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Yangzhou"
  }, {
     "name": "Billy Bishop Toronto City Airport",
     "countryCode": "CA",
     "iata": "YTZ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Toronto"
  }, {
     "name": "James Gruben Airport",
     "countryCode": "CA",
     "iata": "YUB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Tuktoyaktuk"
  }, {
     "name": "Umiujaq Airport",
     "countryCode": "CA",
     "iata": "YUD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Umiujaq"
  }, {
     "name": "Yuendumu Airport",
     "countryCode": "AU",
     "iata": "YUE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Yuendumu"
  }, {
     "name": "Montreal-Pierre Elliott Trudeau International Airport",
     "countryCode": "CA",
     "iata": "YUL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Montreal"
  }, {
     "name": "Yuma International Airport",
     "countryCode": "US",
     "iata": "YUM",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Yuma"
  }, {
     "name": "Yushu Batang Airport",
     "countryCode": "CN",
     "iata": "YUS",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Yushu"
  }, {
     "name": "Repulse Bay Airport",
     "countryCode": "CA",
     "iata": "YUT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Repulse Bay"
  }, {
     "name": "Hall Beach Airport",
     "countryCode": "CA",
     "iata": "YUX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Hall Beach"
  }, {
     "name": "Rouyn-Noranda Airport",
     "countryCode": "CA",
     "iata": "YUY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Rouyn"
  }, {
     "name": "Bonaventure Airport",
     "countryCode": "CA",
     "iata": "YVB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Bonaventure"
  }, {
     "name": "Barber Field",
     "countryCode": "CA",
     "iata": "YVC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "La Ronge"
  }, {
     "name": "Vernon Airport",
     "countryCode": "CA",
     "iata": "YVE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Vernon"
  }, {
     "name": "Vermilion Airport",
     "countryCode": "CA",
     "iata": "YVG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Vermilion"
  }, {
     "name": "Qikiqtarjuaq Airport",
     "countryCode": "CA",
     "iata": "YVM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Qikiqtarkuaq"
  }, {
     "name": "Val-d'Or Airport",
     "countryCode": "CA",
     "iata": "YVO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Val D'Or"
  }, {
     "name": "Kuujjuaq Airport",
     "countryCode": "CA",
     "iata": "YVP",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kuujjuaq"
  }, {
     "name": "Norman Wells Airport",
     "countryCode": "CA",
     "iata": "YVQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Norman Wells"
  }, {
     "name": "Vancouver International Airport",
     "countryCode": "CA",
     "iata": "YVR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Vancouver"
  }, {
     "name": "Buffalo Narrows Airport",
     "countryCode": "CA",
     "iata": "YVT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Buffalo Narrows"
  }, {
     "name": "Wiarton Airport",
     "countryCode": "CA",
     "iata": "YVV",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Wiarton"
  }, {
     "name": "Deer Lake Airport",
     "countryCode": "CA",
     "iata": "YVZ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Deer Lake"
  }, {
     "name": "Petawawa Airport",
     "countryCode": "CA",
     "iata": "YWA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Petawawa"
  }, {
     "name": "Kangiqsujuaq Airport",
     "countryCode": "CA",
     "iata": "YWB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kangiqsujuaq"
  }, {
     "name": "Winnipeg James Armstrong Richardson International Airport",
     "countryCode": "CA",
     "iata": "YWG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Winnipeg"
  }, {
     "name": "Deline Airport",
     "countryCode": "CA",
     "iata": "YWJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Deline"
  }, {
     "name": "Wabush Airport",
     "countryCode": "CA",
     "iata": "YWK",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Wabush"
  }, {
     "name": "Williams Lake Airport",
     "countryCode": "CA",
     "iata": "YWL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Williams Lake"
  }, {
     "name": "Williams Harbour Airport",
     "countryCode": "CA",
     "iata": "YWM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Williams Harbor"
  }, {
     "name": "Lupin Airport",
     "countryCode": "CA",
     "iata": "YWO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Lupin"
  }, {
     "name": "Webequie Airport",
     "countryCode": "CA",
     "iata": "YWP",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Webequie"
  }, {
     "name": "White River Sea Plane Base",
     "countryCode": "CA",
     "iata": "YWR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "White River"
  }, {
     "name": "Wrigley Airport",
     "countryCode": "CA",
     "iata": "YWY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Wrigley"
  }, {
     "name": "Canadian Rockies International Airport",
     "countryCode": "CA",
     "iata": "YXC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Cranbrook"
  }, {
     "name": "Edmonton City Centre Airport",
     "countryCode": "CA",
     "iata": "YXD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Edmonton"
  }, {
     "name": "Saskatoon International Airport",
     "countryCode": "CA",
     "iata": "YXE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Saskatoon"
  }, {
     "name": "Medicine Hat Regional Airport",
     "countryCode": "CA",
     "iata": "YXH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Medicine Hat"
  }, {
     "name": "North Peace Regional Airport",
     "countryCode": "CA",
     "iata": "YXJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort St. John"
  }, {
     "name": "Rimouski Airport",
     "countryCode": "CA",
     "iata": "YXK",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Rimouski"
  }, {
     "name": "Sioux Lookout Airport",
     "countryCode": "CA",
     "iata": "YXL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sioux Lookout"
  }, {
     "name": "Whale Cove Airport",
     "countryCode": "CA",
     "iata": "YXN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Whale Cove"
  }, {
     "name": "Pangnirtung Airport",
     "countryCode": "CA",
     "iata": "YXP",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Pangnirtung"
  }, {
     "name": "Beaver Creek Airport",
     "countryCode": "CA",
     "iata": "YXQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Beaver Creek"
  }, {
     "name": "Earlton Airport",
     "countryCode": "CA",
     "iata": "YXR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Earlton"
  }, {
     "name": "Prince George Airport",
     "countryCode": "CA",
     "iata": "YXS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Prince George"
  }, {
     "name": "Northwest Regional Airport",
     "countryCode": "CA",
     "iata": "YXT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Terrasse"
  }, {
     "name": "London International Airport",
     "countryCode": "CA",
     "iata": "YXU",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "London"
  }, {
     "name": "Abbotsford Airport",
     "countryCode": "CA",
     "iata": "YXX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Abbotsford"
  }, {
     "name": "Whitehorse Airport",
     "countryCode": "CA",
     "iata": "YXY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Hvide hest"
  }, {
     "name": "Wawa Airport",
     "countryCode": "CA",
     "iata": "YXZ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Wawa"
  }, {
     "name": "Jack Garland Airport",
     "countryCode": "CA",
     "iata": "YYB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "North Bay"
  }, {
     "name": "Calgary International Airport",
     "countryCode": "CA",
     "iata": "YYC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Calgary"
  }, {
     "name": "Smithers Airport",
     "countryCode": "CA",
     "iata": "YYD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Smithers"
  }, {
     "name": "Northern Rockies Regional Airport",
     "countryCode": "CA",
     "iata": "YYE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort Nelson"
  }, {
     "name": "Penticton Airport",
     "countryCode": "CA",
     "iata": "YYF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Penticton"
  }, {
     "name": "Charlottetown Airport",
     "countryCode": "CA",
     "iata": "YYG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Charlottetown"
  }, {
     "name": "Taloyoak Airport",
     "countryCode": "CA",
     "iata": "YYH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Taloyoak"
  }, {
     "name": "Victoria International Airport",
     "countryCode": "CA",
     "iata": "YYJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Victoria"
  }, {
     "name": "Lynn Lake Airport",
     "countryCode": "CA",
     "iata": "YYL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Lynn Lake"
  }, {
     "name": "Cowley Airport",
     "countryCode": "CA",
     "iata": "YYM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Cowley"
  }, {
     "name": "Swift Current Airport",
     "countryCode": "CA",
     "iata": "YYN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Swift Current"
  }, {
     "name": "Churchill Airport",
     "countryCode": "CA",
     "iata": "YYQ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Churchill"
  }, {
     "name": "Goose Bay Airport",
     "countryCode": "CA",
     "iata": "YYR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Goose Bay"
  }, {
     "name": "St. John's International Airport",
     "countryCode": "CA",
     "iata": "YYT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "St. Johns"
  }, {
     "name": "Kapuskasing Airport",
     "countryCode": "CA",
     "iata": "YYU",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kapuskasing"
  }, {
     "name": "Armstrong Airport",
     "countryCode": "CA",
     "iata": "YYW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Armstrong"
  }, {
     "name": "Mont Joli Airport",
     "countryCode": "CA",
     "iata": "YYY",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Mont Joli"
  }, {
     "name": "Pearson International Airport",
     "countryCode": "CA",
     "iata": "YYZ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Toronto"
  }, {
     "name": "Manitoulin Airport",
     "countryCode": "CA",
     "iata": "YZE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Gore Bay"
  }, {
     "name": "Yellowknife Airport",
     "countryCode": "CA",
     "iata": "YZF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Yellowknife"
  }, {
     "name": "Salluit Airport",
     "countryCode": "CA",
     "iata": "YZG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Salluit"
  }, {
     "name": "Slave Lake Airport",
     "countryCode": "CA",
     "iata": "YZH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Slave Lake"
  }, {
     "name": "Sandspit Airport",
     "countryCode": "CA",
     "iata": "YZP",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sandspit"
  }, {
     "name": "Sarnia Airport",
     "countryCode": "CA",
     "iata": "YZR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sarnia"
  }, {
     "name": "Coral Harbour Airport",
     "countryCode": "CA",
     "iata": "YZS",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Coral Harbour"
  }, {
     "name": "Port Hardy Airport",
     "countryCode": "CA",
     "iata": "YZT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Port Hardy"
  }, {
     "name": "Whitecourt Airport",
     "countryCode": "CA",
     "iata": "YZU",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Whitecourt"
  }, {
     "name": "Sept-Iles Airport",
     "countryCode": "CA",
     "iata": "YZV",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sept-Iles"
  }, {
     "name": "Teslin Airport",
     "countryCode": "CA",
     "iata": "YZW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Teslin"
  }, {
     "name": "Greenwood Airport",
     "countryCode": "CA",
     "iata": "YZX",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Greenwood"
  }, {
     "name": "Trail Airport",
     "countryCode": "CA",
     "iata": "YZZ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sti"
  }, {
     "name": "York Landing Airport",
     "countryCode": "CA",
     "iata": "ZAC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "York Landing"
  }, {
     "name": "Zadar Airport",
     "countryCode": "HR",
     "iata": "ZAD",
     "eucustoms": true,
     "countryDK": "Kroatien",
     "cityDK": "Zadar"
  }, {
     "name": "Franjo Tudman Airport",
     "countryCode": "HR",
     "iata": "ZAG",
     "eucustoms": false,
     "countryDK": "Kroatien",
     "cityDK": "Zagreb"
  }, {
     "name": "Zahedan Airport",
     "countryCode": "IR",
     "iata": "ZAH",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Zahedan"
  }, {
     "name": "Zaranj Airport",
     "countryCode": "AF",
     "iata": "ZAJ",
     "eucustoms": false,
     "countryDK": "Afghanistan",
     "cityDK": "Zaranj"
  }, {
     "name": "Pichoy Airport",
     "countryCode": "CL",
     "iata": "ZAL",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Valdivia"
  }, {
     "name": "Zamboanga International Airport",
     "countryCode": "PH",
     "iata": "ZAM",
     "eucustoms": false,
     "countryDK": "Filippinerne",
     "cityDK": "Zamboanga"
  }, {
     "name": "Laberandie Airport",
     "countryCode": "FR",
     "iata": "ZAO",
     "eucustoms": false,
     "countryDK": "Frankrig",
     "cityDK": "Cahors"
  }, {
     "name": "Zaria Airport",
     "countryCode": "NG",
     "iata": "ZAR",
     "eucustoms": false,
     "countryDK": "Nigeria",
     "cityDK": "Zaria"
  }, {
     "name": "Zhaotong Airport",
     "countryCode": "CN",
     "iata": "ZAT",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Zhaotong"
  }, {
     "name": "Zaragoza Airport",
     "countryCode": "ES",
     "iata": "ZAZ",
     "eucustoms": false,
     "countryDK": "Spanien",
     "cityDK": "Zaragoza"
  }, {
     "name": "Bathurst Airport",
     "countryCode": "CA",
     "iata": "ZBF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Bathurst"
  }, {
     "name": "Roland-Desourdy Airport",
     "countryCode": "CA",
     "iata": "ZBM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Bromont"
  }, {
     "name": "Bowen Airport",
     "countryCode": "AU",
     "iata": "ZBO",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Bowen"
  }, {
     "name": "Konarak Airport",
     "countryCode": "IR",
     "iata": "ZBR",
     "eucustoms": false,
     "countryDK": "Iran",
     "cityDK": "Chah Bahar"
  }, {
     "name": "Sayaboury Airport",
     "countryCode": "LA",
     "iata": "ZBY",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Sayaboury"
  }, {
     "name": "La Calera Airport",
     "countryCode": "MX",
     "iata": "ZCL",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Zacatecas"
  }, {
     "name": "Temuco Airport",
     "countryCode": "CL",
     "iata": "ZCO",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Temuco"
  }, {
     "name": "Delma Island Airport",
     "countryCode": "AE",
     "iata": "ZDY",
     "eucustoms": false,
     "countryDK": "Forenede Arabiske Emirater",
     "cityDK": "Delma Island"
  }, {
     "name": "Secunda Airport",
     "countryCode": "ZA",
     "iata": "ZEC",
     "eucustoms": false,
     "countryDK": "Sydafrika",
     "cityDK": "Secunda"
  }, {
     "name": "Campbell Island Airport",
     "countryCode": "CA",
     "iata": "ZEL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Bella Bella"
  }, {
     "name": "East Main Airport",
     "countryCode": "CA",
     "iata": "ZEM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "East Main"
  }, {
     "name": "Faro Airport",
     "countryCode": "CA",
     "iata": "ZFA",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Faro"
  }, {
     "name": "Fond Du Lac Airport",
     "countryCode": "CA",
     "iata": "ZFD",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fond Du Lac"
  }, {
     "name": "Fort Mcpherson Airport",
     "countryCode": "CA",
     "iata": "ZFM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fort McPherson"
  }, {
     "name": "Tulita Airport",
     "countryCode": "CA",
     "iata": "ZFN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Tulita / Fort Norman"
  }, {
     "name": "Fairview Airport",
     "countryCode": "CA",
     "iata": "ZFW",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Fairview"
  }, {
     "name": "Grand Forks Airport",
     "countryCode": "CA",
     "iata": "ZGF",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Grand Forks"
  }, {
     "name": "Gods River Airport",
     "countryCode": "CA",
     "iata": "ZGI",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Gods River"
  }, {
     "name": "South Galway Airport",
     "countryCode": "AU",
     "iata": "ZGL",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "South Galway"
  }, {
     "name": "Ngoma Airport",
     "countryCode": "ZM",
     "iata": "ZGM",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Ngoma"
  }, {
     "name": "Little Grand Rapids Airport",
     "countryCode": "CA",
     "iata": "ZGR",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Lille Grand Rapids"
  }, {
     "name": "Zhanjiang Airport",
     "countryCode": "CN",
     "iata": "ZHA",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Zhanjiang"
  }, {
     "name": "Shamshernagar Airport",
     "countryCode": "BD",
     "iata": "ZHM",
     "eucustoms": false,
     "countryDK": "Bangladesh",
     "cityDK": "Shamshernagar"
  }, {
     "name": "High Prairie Airport",
     "countryCode": "CA",
     "iata": "ZHP",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "High Prairie"
  }, {
     "name": "Xiangshan Airport",
     "countryCode": "CN",
     "iata": "ZHY",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Zhongwei"
  }, {
     "name": "Zhukovsky International Airport",
     "countryCode": "RU",
     "iata": "ZIA",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Zhukovsky"
  }, {
     "name": "Victoria Airport",
     "countryCode": "CL",
     "iata": "ZIC",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Victoria"
  }, {
     "name": "Ziguinchor Airport",
     "countryCode": "SN",
     "iata": "ZIG",
     "eucustoms": false,
     "countryDK": "Senegal",
     "cityDK": "Ziguinchor"
  }, {
     "name": "Ixtapa/Zihuatanejo Internacional Airport",
     "countryCode": "MX",
     "iata": "ZIH",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Ixtapa / Zihuatanejo"
  }, {
     "name": "Zhigansk Airport",
     "countryCode": "RU",
     "iata": "ZIX",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Zhigansk"
  }, {
     "name": "Jenpeg Airport",
     "countryCode": "CA",
     "iata": "ZJG",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Jenpeg"
  }, {
     "name": "Swan River Airport",
     "countryCode": "CA",
     "iata": "ZJN",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Swan River"
  }, {
     "name": "Kasaba Bay Airport",
     "countryCode": "ZM",
     "iata": "ZKB",
     "eucustoms": false,
     "countryDK": "Zambia",
     "cityDK": "Kasaba Bay"
  }, {
     "name": "Kashechewan Airport",
     "countryCode": "CA",
     "iata": "ZKE",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Kaschechewan"
  }, {
     "name": "Sette Cama Airport",
     "countryCode": "GA",
     "iata": "ZKM",
     "eucustoms": false,
     "countryDK": "Gabon",
     "cityDK": "Sette Cama"
  }, {
     "name": "Zyryanka Airport",
     "countryCode": "RU",
     "iata": "ZKP",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Zyryanka"
  }, {
     "name": "Manzanillo Airport",
     "countryCode": "MX",
     "iata": "ZLO",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Manzanillo"
  }, {
     "name": "Bulgan Airport, Khovd",
     "countryCode": "MN",
     "iata": "HBU",
     "eucustoms": false,
     "countryDK": "Mongoliet",
     "cityDK": "Bulgan"
  }, {
     "name": "South Cariboo Regional Airport",
     "countryCode": "CA",
     "iata": "ZMH",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "108 Mile Ranch"
  }, {
     "name": "Zamora Airport",
     "countryCode": "MX",
     "iata": "ZMM",
     "eucustoms": false,
     "countryDK": "Mexico",
     "cityDK": "Zamora"
  }, {
     "name": "Masset Airport",
     "countryCode": "CA",
     "iata": "ZMT",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Masset"
  }, {
     "name": "Zinder Airport",
     "countryCode": "NE",
     "iata": "ZND",
     "eucustoms": false,
     "countryDK": "Niger",
     "cityDK": "Zinder"
  }, {
     "name": "Newman Airport",
     "countryCode": "AU",
     "iata": "ZNE",
     "eucustoms": false,
     "countryDK": "Australien",
     "cityDK": "Ny mand"
  }, {
     "name": "Zanzibar International Airport",
     "countryCode": "TZ",
     "iata": "ZNZ",
     "eucustoms": false,
     "countryDK": "Tanzania",
     "cityDK": "Zanzibar"
  }, {
     "name": "Canal Bajo Airport",
     "countryCode": "CL",
     "iata": "ZOS",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Osorno"
  }, {
     "name": "Sachigo Lake Airport",
     "countryCode": "CA",
     "iata": "ZPB",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sachigo Lake"
  }, {
     "name": "Pucon Airport",
     "countryCode": "CL",
     "iata": "ZPC",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Pucon"
  }, {
     "name": "Zephyrhills Airport",
     "countryCode": "US",
     "iata": "ZPH",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Zephyrhills"
  }, {
     "name": "Pine House Airport",
     "countryCode": "CA",
     "iata": "ZPO",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Pine House"
  }, {
     "name": "Queenstown Airport",
     "countryCode": "NZ",
     "iata": "ZQN",
     "eucustoms": false,
     "countryDK": "New Zealand",
     "cityDK": "Queenstown"
  }, {
     "name": "Zhangjiakou Ningyuan Airport",
     "countryCode": "CN",
     "iata": "ZQZ",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Zhangjiakou"
  }, {
     "name": "Zurich Airport",
     "countryCode": "CH",
     "iata": "ZRH",
     "eucustoms": false,
     "countryDK": "Schweiz",
     "cityDK": "Zürich"
  }, {
     "name": "Weagamow Airport",
     "countryCode": "CA",
     "iata": "ZRJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Round Lake"
  }, {
     "name": "San Salvador Airport",
     "countryCode": "BS",
     "iata": "ZSA",
     "eucustoms": false,
     "countryDK": "Bahamas",
     "cityDK": "San Salvador"
  }, {
     "name": "Henderson Field",
     "countryCode": "UM",
     "iata": "MDY",
     "eucustoms": false,
     "countryDK": "",
     "cityDK": "Sand Island"
  }, {
     "name": "Sandy Lake Airport",
     "countryCode": "CA",
     "iata": "ZSJ",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Sandy Lake"
  }, {
     "name": "Sassandra Airport",
     "countryCode": "CI",
     "iata": "ZSS",
     "eucustoms": false,
     "countryDK": "Elfenbenskysten",
     "cityDK": "Sassandra"
  }, {
     "name": "Stewart Airport",
     "countryCode": "CA",
     "iata": "ZST",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Stewart"
  }, {
     "name": "Tureira Airport",
     "countryCode": "PF",
     "iata": "ZTA",
     "eucustoms": false,
     "countryDK": "Fransk polynesien",
     "cityDK": "Tureira"
  }, {
     "name": "Zakinthos Airport",
     "countryCode": "GR",
     "iata": "ZTH",
     "eucustoms": true,
     "countryDK": "Grækenland",
     "cityDK": "Zakinthos"
  }, {
     "name": "Shamattawa Airport",
     "countryCode": "CA",
     "iata": "ZTM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Shamattawa"
  }, {
     "name": "Zaqatala Airport",
     "countryCode": "AZ",
     "iata": "ZTU",
     "eucustoms": false,
     "countryDK": "Aserbajdsjan",
     "cityDK": "Zaqatala"
  }, {
     "name": "Ignace Municipal Airport",
     "countryCode": "CA",
     "iata": "ZUC",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Ignace"
  }, {
     "name": "Ancud Airport",
     "countryCode": "CL",
     "iata": "ZUD",
     "eucustoms": false,
     "countryDK": "Chile",
     "cityDK": "Ancud"
  }, {
     "name": "Zhuhai Jinwan Airport",
     "countryCode": "CN",
     "iata": "ZUH",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Zhuhai"
  }, {
     "name": "Zilfi Airport",
     "countryCode": "SA",
     "iata": "ZUL",
     "eucustoms": false,
     "countryDK": "Saudi-Arabien",
     "cityDK": "Zilfi"
  }, {
     "name": "Churchill Falls Airport",
     "countryCode": "CA",
     "iata": "ZUM",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Churchill Falls"
  }, {
     "name": "Miandrivazo Airport",
     "countryCode": "MG",
     "iata": "ZVA",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Miandrivazo"
  }, {
     "name": "Savannakhet Airport",
     "countryCode": "LA",
     "iata": "ZVK",
     "eucustoms": false,
     "countryDK": "Laos",
     "cityDK": "Savannakhet"
  }, {
     "name": "Andapa Airport",
     "countryCode": "MG",
     "iata": "ZWA",
     "eucustoms": false,
     "countryDK": "Madagaskar",
     "cityDK": "Andapa"
  }, {
     "name": "Wollaston Lake Airport",
     "countryCode": "CA",
     "iata": "ZWL",
     "eucustoms": false,
     "countryDK": "Canada",
     "cityDK": "Wollaston Lake"
  }, {
     "name": "Zunyi Xinzhou Airport",
     "countryCode": "CN",
     "iata": "ZYI",
     "eucustoms": false,
     "countryDK": "Kina",
     "cityDK": "Zunyi"
  }, {
     "name": "Osmani International Airport",
     "countryCode": "BD",
     "iata": "ZYL",
     "eucustoms": false,
     "countryDK": "Bangladesh",
     "cityDK": "Sylhet"
  }, {
     "name": "Zonalnoye Airport",
     "countryCode": "RU",
     "iata": "ZZO",
     "eucustoms": false,
     "countryDK": "Rusland",
     "cityDK": "Tymovskoye"
  }, {
     "name": "Mzuzu Airport",
     "countryCode": "MW",
     "iata": "ZZU",
     "eucustoms": false,
     "countryDK": "Malawi",
     "cityDK": "Mzuzu"
  }, {
     "name": "Zanesville Municipal Airport",
     "countryCode": "US",
     "iata": "ZZV",
     "eucustoms": false,
     "countryDK": "USA",
     "cityDK": "Zanesville"
  }];
}
